webpackJsonp([213534597649335],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isRequiredForA11y;
	function isRequiredForA11y(validator) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.shape({
	  x: _propTypes2.default.object,
	  y: _propTypes2.default.object
	})]);

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AccessibleFakeButton = __webpack_require__(70);
	
	var _AccessibleFakeButton2 = _interopRequireDefault(_AccessibleFakeButton);
	
	var _injectInk = __webpack_require__(167);
	
	var _injectInk2 = _interopRequireDefault(_injectInk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _injectInk2.default)(_AccessibleFakeButton2.default);

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _HorizontalAnchors = __webpack_require__(117);
	
	var _HorizontalAnchors2 = _interopRequireDefault(_HorizontalAnchors);
	
	var _VerticalAnchors = __webpack_require__(119);
	
	var _VerticalAnchors2 = _interopRequireDefault(_VerticalAnchors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _propTypes2.default.shape({
	  x: _propTypes2.default.oneOf([_HorizontalAnchors2.default.LEFT, _HorizontalAnchors2.default.INNER_LEFT, _HorizontalAnchors2.default.CENTER, _HorizontalAnchors2.default.RIGHT, _HorizontalAnchors2.default.INNER_RIGHT]).isRequired,
	  y: _propTypes2.default.oneOf([_VerticalAnchors2.default.TOP, _VerticalAnchors2.default.CENTER, _VerticalAnchors2.default.OVERLAP, _VerticalAnchors2.default.BOTTOM]).isRequired
	});

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isReact16 = typeof _reactDom.createPortal === 'function';
	
	/**
	 * Creates a "Portal" for the children to be rendered in. Basically it will render the
	 * children only when the `visible` prop is `true`. When it is visible, a new `component`
	 * will be rendered as the first child in the body with the children inside.
	 *
	 * Unlike all the other components, `style` will not be applied for the `Portal`.
	 */
	
	var Portal = function (_PureComponent) {
	  _inherits(Portal, _PureComponent);
	
	  function Portal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Portal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this._container = null, _this._portal = null, _this._applyStyles = function (props) {
	      if (props.className) {
	        _this._container.className = props.className;
	      }
	    }, _this._renderPortal = function (props) {
	      if (!_this._container) {
	        _this._container = document.createElement(props.component);
	
	        _this._applyStyles(props);
	        var node = props.renderNode || document.body;
	        if (props.lastChild) {
	          node.appendChild(_this._container);
	        } else {
	          node.insertBefore(_this._container, node.firstChild);
	        }
	      } else {
	        _this._applyStyles(props);
	      }
	
	      if (!isReact16) {
	        _this._portal = (0, _reactDom.unstable_renderSubtreeIntoContainer)(_this, props.children, _this._container);
	      }
	    }, _this._removePortal = function () {
	      if (_this.props.onClose) {
	        _this.props.onClose();
	      }
	
	      if (_this._container) {
	        if (!isReact16) {
	          (0, _reactDom.unmountComponentAtNode)(_this._container);
	        }
	
	        (_this.props.renderNode || document.body).removeChild(_this._container);
	      }
	
	      _this._portal = null;
	      _this._container = null;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Portal.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.visible) {
	      this._renderPortal(this.props);
	
	      if (isReact16) {
	        // Need to update after the renderPortal created the DOM element.
	        this.forceUpdate();
	      }
	    }
	  };
	
	  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var visible = nextProps.visible,
	        onOpen = nextProps.onOpen;
	
	    if (this.props.visible === visible) {
	      if (visible && !isReact16) {
	        // Need to just re-render the subtree
	        this._renderPortal(nextProps);
	      }
	
	      return;
	    }
	
	    if (visible) {
	      if (onOpen) {
	        onOpen();
	      }
	
	      this._renderPortal(nextProps);
	    } else {
	      this._removePortal();
	    }
	  };
	
	  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.props.visible && this.props.onClose) {
	      this.props.onClose();
	    }
	    this._removePortal();
	  };
	
	  Portal.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.component,
	        className = _props.className,
	        children = _props.children,
	        visible = _props.visible;
	
	    // When doing server side rendering, actually render the component as a direct child of its parent.
	    // Once it has been rendered and working client side, it will be removed correctly.
	
	    if (typeof window === 'undefined' && visible) {
	      return _react2.default.createElement(
	        Component,
	        { className: className },
	        children
	      );
	    } else if (isReact16 && visible && this._container && typeof window !== 'undefined') {
	      return (0, _reactDom.createPortal)(children, this._container);
	    }
	
	    return null;
	  };
	
	  return Portal;
	}(_react.PureComponent);
	
	Portal.propTypes = {
	  /**
	   * An optional className to apply to the newly created `component` when visible.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Boolean if the children are visible.
	   */
	  visible: _propTypes2.default.bool.isRequired,
	
	  /**
	   * The children to render when visible.
	   */
	  children: _propTypes2.default.element,
	
	  /**
	   * The component to render as. This should be a valid DOM element.
	   */
	  component: _propTypes2.default.string.isRequired,
	
	  /**
	   * An optional function to call when the portal is opened.
	   */
	  onOpen: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the portal is closed
	   */
	  onClose: _propTypes2.default.func,
	
	  /**
	   * An optional DOM Node to render the portal into. The default is to render as
	   * the first child in the `body`.
	   */
	  renderNode: _propTypes2.default.object,
	
	  /**
	   * Boolean if the portal should render the children as the last child of the `renderNode`
	   * or `body` instead of the first.
	   */
	  lastChild: _propTypes2.default.bool
	};
	Portal.defaultProps = {
	  component: 'span'
	};
	exports.default = Portal;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _resizeObserverPolyfill = __webpack_require__(264);
	
	var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `ResizeObserver` component is a component hook for the
	 * [ResizeObserver](http://rawgit.com/WICG/ResizeObserver/master/index.html)
	 * using the [resize-observer-polyfill](https://github.com/que-etc/resize-observer-polyfill)
	 * for browsers that don't support it yet.
	 *
	 * This component displays an empty `span` with `aria-hidden` to allow access to the DOM. By
	 * default it will attempt to watch changes on its parent component, but it can be configured
	 * to watch any element by using the `target` prop.
	 */
	var ResizeObserver = function (_PureComponent) {
	  _inherits(ResizeObserver, _PureComponent);
	
	  function ResizeObserver() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ResizeObserver);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this._container = null, _this._target = null, _this._observer = null, _this._height = null, _this._width = null, _this._scrollHeight = null, _this._scrollWidth = null, _this._measure = function (entries) {
	      if (!_this._observer || !_this._target) {
	        return;
	      }
	
	      for (var _iterator = entries, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var entry = _ref;
	
	        if (!entry) {
	          return;
	        }
	
	        var _entry$contentRect = entry.contentRect,
	            height = _entry$contentRect.height,
	            width = _entry$contentRect.width;
	        var _entry$target = entry.target,
	            scrollHeight = _entry$target.scrollHeight,
	            scrollWidth = _entry$target.scrollWidth;
	
	        if (_this._isHeightChange(height, scrollHeight) || _this._isWidthChange(width, scrollWidth)) {
	          _this._height = height;
	          _this._width = width;
	          _this._scrollHeight = scrollHeight;
	          _this._scrollWidth = scrollWidth;
	          _this.props.onResize({ height: height, width: width, scrollHeight: scrollHeight, scrollWidth: scrollWidth, el: entry.target });
	        }
	      }
	    }, _this._isHeightChange = function (height, scrollHeight) {
	      return _this.props.watchHeight && (height !== _this._height || scrollHeight !== _this._scrollHeight);
	    }, _this._isWidthChange = function (width, scrollWidth) {
	      return _this.props.watchWidth && (width !== _this._width || scrollWidth !== _this._scrollWidth);
	    }, _this._handleRef = function (container) {
	      if (container) {
	        _this._container = container;
	        _this._target = _this._getTarget(container, _this.props.target);
	        _this._observer = new _resizeObserverPolyfill2.default(_this._measure);
	
	        if (_this._target) {
	          _this._observer.observe(_this._target);
	        }
	      } else {
	        if (_this._observer) {
	          _this._observer.disconnect();
	        }
	
	        _this._container = null;
	        _this._target = null;
	        _this._observer = null;
	        _this._height = null;
	        _this._width = null;
	        _this._scrollHeight = null;
	        _this._scrollWidth = null;
	      }
	
	      if (_this.props.elRef) {
	        _this.props.elRef(_this._target);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ResizeObserver.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var target = this.props.target;
	
	    var nextTarget = nextProps.target;
	    if (target === nextTarget) {
	      return;
	    } else if (nextTarget) {
	      if (this._target) {
	        this._observer.unobserve(this._target);
	      }
	      this._target = this._getTarget(this._container, nextTarget);
	      this._observer.observe(this._target);
	    }
	  };
	
	  ResizeObserver.prototype._getTarget = function _getTarget(container, target) {
	    if (target === null || target && typeof target !== 'string') {
	      return target;
	    }
	
	    var t = null;
	    if (target) {
	      t = document.getElementById(target) || document.querySelector(target);
	    } else {
	      t = container.parentNode;
	    }
	
	    if (!t) {
	      throw new Error('An HTMLDOMNode is required as the `ResizeObserver`\'s watch target but none were provided/found. ' + ('Please update the target prop to find a valid node since the provided target is invalid. `' + target + '`.'));
	    }
	
	    return t;
	  };
	
	  ResizeObserver.prototype.render = function render() {
	    var Component = this.props.component;
	
	    return _react2.default.createElement(Component, { ref: this._handleRef, 'aria-hidden': true });
	  };
	
	  return ResizeObserver;
	}(_react.PureComponent);
	
	ResizeObserver.propTypes = {
	  /**
	   * Boolean if the height should be watched for the resize target.
	   */
	  watchHeight: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the width should be watched for the resize target.
	   */
	  watchWidth: _propTypes2.default.bool,
	
	  /**
	   * An optional target that should be used for detecting resize events. This can either
	   * be a HTMLDOMNode or a string to use with `document.getElementById` or `document.querySelector`.
	   *
	   * If this prop is not provided and not null, it will default to the parent node of this component.
	   * If the provided `target={null}`, the observer will not begin until the `target` is `undefined` or
	   * it has been correctly passed a target string or object.
	   */
	  target: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	
	  /**
	   * The component to be rendered as. This should normally just be the default `span`, but there are cases
	   * where the component should be switched to something else for valid html.
	   */
	  component: _propTypes2.default.string,
	
	  /**
	   * A function to call when the height or width has been changed and that attribute is being watched.
	   * The callback will include the current height, width, scrollHeight and scrollWidth of the target.
	   *
	   * ```js
	   * onResize({
	   *   height: nextHeight,
	   *   width: nextWidth,
	   *   scrollHeight: nextScrollHeight,
	   *   scrollWidth: nextScrollWidth,
	   *   el: resizeTarget,
	   * });
	   * ```
	   */
	  onResize: _propTypes2.default.func.isRequired,
	
	  /**
	   * An optional ref callback that will include the `target` or the parent node of the resize observer. Just
	   * like other refs, this will provide null when it unmounts.
	   *
	   * This is really only helpful if you'd like the DOM node for a parent Component without needing to use
	   * `ReactDOM.findDOMNode(this)`.
	   */
	  elRef: _propTypes2.default.func
	};
	ResizeObserver.defaultProps = {
	  watchHeight: false,
	  watchWidth: false,
	  component: 'span'
	};
	exports.default = ResizeObserver;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Positions = __webpack_require__(118);
	
	var _Positions2 = _interopRequireDefault(_Positions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _propTypes2.default.oneOfType([_propTypes2.default.oneOf([_Positions2.default.TOP_LEFT, _Positions2.default.TOP_RIGHT, _Positions2.default.BOTTOM_LEFT, _Positions2.default.BOTTOM_RIGHT, _Positions2.default.BELOW]), _propTypes2.default.string]);

/***/ }),
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(134);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _CSSTransitionGroupChild = __webpack_require__(133);
	
	var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);
	
	var _PropTypes = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  transitionName: _PropTypes.nameShape.isRequired,
	
	  transitionAppear: _propTypes2.default.bool,
	  transitionEnter: _propTypes2.default.bool,
	  transitionLeave: _propTypes2.default.bool,
	  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
	  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
	  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
	};
	
	var defaultProps = {
	  transitionAppear: false,
	  transitionEnter: true,
	  transitionLeave: true
	};
	
	var CSSTransitionGroup = function (_React$Component) {
	  _inherits(CSSTransitionGroup, _React$Component);
	
	  function CSSTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
	      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
	        name: _this.props.transitionName,
	        appear: _this.props.transitionAppear,
	        enter: _this.props.transitionEnter,
	        leave: _this.props.transitionLeave,
	        appearTimeout: _this.props.transitionAppearTimeout,
	        enterTimeout: _this.props.transitionEnterTimeout,
	        leaveTimeout: _this.props.transitionLeaveTimeout
	      }, child);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // We need to provide this childFactory so that
	  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	  // leave while it is leaving.
	
	
	  CSSTransitionGroup.prototype.render = function render() {
	    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
	  };
	
	  return CSSTransitionGroup;
	}(_react2.default.Component);
	
	CSSTransitionGroup.displayName = 'CSSTransitionGroup';
	
	
	CSSTransitionGroup.propTypes =  false ? propTypes : {};
	CSSTransitionGroup.defaultProps = defaultProps;
	
	exports.default = CSSTransitionGroup;
	module.exports = exports['default'];

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(7);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(5);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _getField = __webpack_require__(8);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _fixedToShape = __webpack_require__(19);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _Subheaders = __webpack_require__(243);
	
	var _Subheaders2 = _interopRequireDefault(_Subheaders);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Lists present multiple line items vertically as a single continuous element.
	 */
	var List = function (_PureComponent) {
	  _inherits(List, _PureComponent);
	
	  function List() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, List);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  List.prototype.getChildContext = function getChildContext() {
	    var _context = this.context,
	        listLevel = _context.listLevel,
	        context = _objectWithoutProperties(_context, ['listLevel']);
	
	    var cascadingFixedTo = (0, _getField2.default)(this.state, this.context, 'cascadingFixedTo');
	    return _extends({}, context, {
	      cascadingFixedTo: cascadingFixedTo,
	      listLevel: typeof listLevel === 'undefined' ? 1 : listLevel + 1
	    });
	  };
	
	  List.prototype.componentDidMount = function componentDidMount() {
	    if (this.context.cascadingMenu) {
	      var list = (0, _reactDom.findDOMNode)(this);
	      if (list.offsetHeight < list.scrollHeight) {
	        var cascadingFixedTo = { y: (0, _reactDom.findDOMNode)(this) };
	        this.setState({ cascadingFixedTo: cascadingFixedTo }); // eslint-disable-line react/no-did-mount-set-state
	      }
	    }
	  };
	
	  List.prototype.render = function render() {
	    var _cn;
	
	    var _props = this.props,
	        className = _props.className,
	        ordered = _props.ordered,
	        children = _props.children,
	        subheader = _props.subheader,
	        inline = _props.inline,
	        primarySubheader = _props.primarySubheader,
	        props = _objectWithoutProperties(_props, ['className', 'ordered', 'children', 'subheader', 'inline', 'primarySubheader']);
	
	    var _context2 = this.context,
	        cascadingMenu = _context2.cascadingMenu,
	        cascadingZDepth = _context2.cascadingZDepth,
	        listLevel = _context2.listLevel;
	
	
	    var subheaderEl = void 0;
	    if (subheader) {
	      subheaderEl = _react2.default.createElement(_Subheaders2.default, { key: 'subheader', primaryText: subheader, primary: primarySubheader });
	    }
	
	    var Component = ordered ? 'ol' : 'ul';
	    return _react2.default.createElement(
	      Component,
	      _extends({}, props, {
	        className: (0, _classnames2.default)('md-list', (_cn = {
	          'md-list--inline': inline,
	          'md-list--menu-cascading': cascadingMenu
	        }, _cn['md-paper md-paper--' + cascadingZDepth] = cascadingZDepth && cascadingMenu && listLevel > 0, _cn['md-list--nested-' + listLevel] = listLevel && !cascadingMenu, _cn), className)
	      }),
	      subheaderEl,
	      children
	    );
	  };
	
	  return List;
	}(_react.PureComponent);
	
	List.propTypes = {
	  /**
	   * An optional style to apply to the list.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the list.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Boolean if this should be an ordered list (`<ol>`) component. Otherwise, it will
	   * be rendered as `<ul>`.
	   */
	  ordered: _propTypes2.default.bool,
	
	  /**
	   * This *should* be a list of `ListItem`, `ListItemControl`, `Divider`, or
	   * `Subheader`.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * Boolean if the list should appear horizontally instead of vertically.
	   */
	  inline: _propTypes2.default.bool,
	  subheader: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `Subheader` component as a child instead'),
	  primarySubheader: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use the `Subheader` component as a child instead')
	};
	List.childContextTypes = {
	  listLevel: _propTypes2.default.number,
	  cascadingMenu: _propTypes2.default.bool,
	  cascadingFixedTo: _fixedToShape2.default,
	  cascadingZDepth: _propTypes2.default.number
	};
	List.contextTypes = {
	  listLevel: _propTypes2.default.number,
	  cascadingMenu: _propTypes2.default.bool,
	  cascadingFixedTo: _fixedToShape2.default,
	  cascadingZDepth: _propTypes2.default.number
	};
	exports.default = List;

/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(7);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(5);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _isRequiredForA11y = __webpack_require__(16);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _CSSTransitionGroupTick = __webpack_require__(29);
	
	var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);
	
	var _getField = __webpack_require__(8);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _handleKeyboardAccessibility = __webpack_require__(57);
	
	var _handleKeyboardAccessibility2 = _interopRequireDefault(_handleKeyboardAccessibility);
	
	var _anchorShape = __webpack_require__(28);
	
	var _anchorShape2 = _interopRequireDefault(_anchorShape);
	
	var _fixedToShape = __webpack_require__(19);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _positionShape = __webpack_require__(36);
	
	var _positionShape2 = _interopRequireDefault(_positionShape);
	
	var _Layover = __webpack_require__(84);
	
	var _Layover2 = _interopRequireDefault(_Layover);
	
	var _List = __webpack_require__(41);
	
	var _List2 = _interopRequireDefault(_List);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `Menu` controlled component is used to display a list of children in the `List`
	 * component once the `visible` prop is true.
	 */
	var Menu = function (_PureComponent) {
	  _inherits(Menu, _PureComponent);
	
	  function Menu() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Menu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this._handleClose = function (e) {
	      var _this$props = _this.props,
	          close = _this$props.close,
	          onClose = _this$props.onClose;
	
	      if (close || onClose) {
	        (close || onClose)(e);
	      }
	    }, _this._handleClick = function (e) {
	      if (_this.props.onClick) {
	        _this.props.onClick(e);
	      }
	
	      var node = e.target;
	      while (_this._container && _this._container.contains(node)) {
	        if (_this._isIgnoreTarget(node)) {
	          return;
	        } else if (_this._isCloseTarget(node)) {
	          e.persist();
	          // set a timeout so item click events still trigger, and then close
	          _this._timeout = setTimeout(function () {
	            _this._timeout = null;
	            _this._handleClose(e);
	          }, _CSSTransitionGroupTick2.default);
	
	          return;
	        }
	
	        node = node.parentNode;
	      }
	    }, _this._handleKeyDown = function (e) {
	      if (_this.props.onKeyDown) {
	        _this.props.onKeyDown(e);
	      }
	
	      (0, _handleKeyboardAccessibility2.default)(e, _this._handleClick, true, true);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Menu.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        cascading = _props.cascading,
	        id = _props.id,
	        fixedTo = _props.fixedTo,
	        cascadingAnchor = _props.cascadingAnchor;
	
	    var listLevel = this.context.listLevel || 0;
	    var cascadingMenu = typeof cascading !== 'undefined' ? cascading : this.context.cascadingMenu;
	    var cascadingZDepth = (0, _getField2.default)(this.context, this.props, 'cascadingZDepth');
	    var cascadingFixedTo = typeof fixedTo !== 'undefined' ? fixedTo : this.context.cascadingFixedTo;
	
	    return {
	      listLevel: listLevel,
	      cascadingId: id + '-level-' + (listLevel + 1),
	      cascadingMenu: cascadingMenu,
	      cascadingAnchor: cascadingAnchor,
	      cascadingZDepth: cascadingZDepth,
	      cascadingFixedTo: cascadingFixedTo
	    };
	  };
	
	  Menu.prototype.componentDidMount = function componentDidMount() {
	    this._container = (0, _reactDom.findDOMNode)(this);
	  };
	
	  Menu.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this._timeout) {
	      clearTimeout(this._timeout);
	    }
	  };
	
	  /**
	   * Checks if a provided event target or HTML Element is considered a menu click target.
	   * This normally is just a ListItem.
	   */
	  Menu.prototype._isCloseTarget = function _isCloseTarget(target) {
	    return target.classList.contains('md-list-item') && !target.classList.contains('md-list-item--nested-container');
	  };
	
	  /**
	   * Checks if a provided event target or HTML Element is something that should shortcut/break
	   * out of the click event loop because it **should not** close menus when clicked.
	   */
	
	
	  Menu.prototype._isIgnoreTarget = function _isIgnoreTarget(target) {
	    return target.getAttribute('disabled') !== null || target.classList.contains('md-list-control');
	  };
	
	  Menu.prototype.render = function render() {
	    var _cn;
	
	    var _props2 = this.props,
	        id = _props2.id,
	        className = _props2.className,
	        listStyle = _props2.listStyle,
	        listClassName = _props2.listClassName,
	        visible = _props2.visible,
	        children = _props2.children,
	        listProps = _props2.listProps,
	        listZDepth = _props2.listZDepth,
	        listInline = _props2.listInline,
	        listHeightRestricted = _props2.listHeightRestricted,
	        cascading = _props2.cascading,
	        sameWidth = _props2.sameWidth,
	        simplified = _props2.simplified,
	        contained = _props2.contained,
	        isOpen = _props2.isOpen,
	        propFixedTo = _props2.fixedTo,
	        propListId = _props2.listId,
	        cascadingAnchor = _props2.cascadingAnchor,
	        cascadingZDepth = _props2.cascadingZDepth,
	        onClose = _props2.onClose,
	        propPosition = _props2.position,
	        close = _props2.close,
	        autoclose = _props2.autoclose,
	        limitHeight = _props2.limitHeight,
	        expanderIconChildren = _props2.expanderIconChildren,
	        expanderIconClassName = _props2.expanderIconClassName,
	        props = _objectWithoutProperties(_props2, ['id', 'className', 'listStyle', 'listClassName', 'visible', 'children', 'listProps', 'listZDepth', 'listInline', 'listHeightRestricted', 'cascading', 'sameWidth', 'simplified', 'contained', 'isOpen', 'fixedTo', 'listId', 'cascadingAnchor', 'cascadingZDepth', 'onClose', 'position', 'close', 'autoclose', 'limitHeight', 'expanderIconChildren', 'expanderIconClassName']);
	
	    var _props3 = this.props,
	        listId = _props3.listId,
	        position = _props3.position;
	
	    if (!listId) {
	      listId = id + '-list';
	    }
	
	    // can't have a simplified menu for cascading and context menus
	    var simple = !cascading && !props.onContextMenu && position !== 'context' && simplified;
	    if (position === 'context') {
	      position = Menu.Positions.BELOW;
	    }
	
	    var below = position === Menu.Positions.BELOW;
	    var fixedTo = typeof propFixedTo !== 'undefined' ? propFixedTo : this.context.cascadingFixedTo;
	    var listVisible = typeof isOpen !== 'undefined' ? isOpen : visible;
	    return _react2.default.createElement(
	      _Layover2.default,
	      _extends({}, props, {
	        id: id,
	        className: (0, _classnames2.default)('md-menu-container', {
	          'md-menu-container--menu-below': simplified && below
	        }, className),
	        simplified: simple,
	        sameWidth: contained || sameWidth,
	        fixedTo: fixedTo,
	        onClick: this._handleClick,
	        onKeyDown: this._handleKeyDown,
	        onClose: this._handleClose,
	        animationPosition: position,
	        visible: listVisible,
	        'aria-haspopup': true,
	        'aria-expanded': listVisible,
	        'aria-owns': listId
	      }),
	      _react2.default.createElement(
	        _List2.default,
	        _extends({}, listProps, {
	          id: listId,
	          key: 'menu-list',
	          style: listStyle,
	          className: (0, _classnames2.default)('md-list--menu', (_cn = {
	            'md-list--menu-restricted': listHeightRestricted,
	            'md-list--menu-contained': simplified && (sameWidth || contained)
	          }, _cn['md-list--menu-' + position] = simplified, _cn['md-paper md-paper--' + listZDepth] = listZDepth, _cn), listClassName),
	          inline: listInline
	        }),
	        children
	      )
	    );
	  };
	
	  return Menu;
	}(_react.PureComponent);
	
	Menu.HorizontalAnchors = _Layover2.default.HorizontalAnchors;
	Menu.VerticalAnchors = _Layover2.default.VerticalAnchors;
	Menu.Positions = {
	  // Can't do ...Layover.Positions since it triggers the get for CONTEXT
	  TOP_LEFT: _Layover2.default.Positions.TOP_LEFT,
	  TOP_RIGHT: _Layover2.default.Positions.TOP_RIGHT,
	  BOTTOM_LEFT: _Layover2.default.Positions.BOTTOM_LEFT,
	  BOTTOM_RIGHT: _Layover2.default.Positions.BOTTOM_RIGHT,
	  BELOW: _Layover2.default.Positions.BELOW,
	  _warned: false,
	  get CONTEXT() {
	    if (!this._warned) {
	      /* eslint-disable no-console */
	      console.error('The `Menu.Positions.CONTEXT` position has been deprecated and will be removed ' + 'in the next major release. To make the `Menu` behave as a context menu, provide ' + 'the `onContextMenu` prop instead.');
	      /* eslint-enable no-console */
	    }
	
	    this._warned = true;
	    return 'context';
	  }
	};
	Menu.propTypes = {
	  /**
	   * An id to provide to the menu's container. This is required for accessibility as it generates
	   * the `aria-` attributes for dynamic content.
	   *
	   * @see {@link #listId}
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * An optional id to provide to the menu's list. If this prop is omitted, the list's id will be
	   * `\`${id}-list\``
	   */
	  listId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply to the main container for the menu.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional class name to apply to the main container for the menu.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the list once the menu has opened.
	   */
	  listStyle: _propTypes2.default.object,
	
	  /**
	   * An optional class name to apply to the list once the menu has opened.
	   */
	  listClassName: _propTypes2.default.string,
	
	  /**
	   * The component to render the main container as.
	   *
	   * @see {@link Helpers/Layover#component}
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	
	  /**
	   * This is how the menu's `List` gets anchored to the `toggle` element.
	   *
	   * @see {@link Helpers/Layover#anchor}
	   */
	  anchor: _anchorShape2.default,
	
	  /**
	   * This is the optional anchor to use when the `position` is set to `Menu.Positions.BELOW`.
	   * Set this to `null` to use the default `anchor` prop.
	   *
	   * @see {@link Helpers/Layover#belowAnchor}
	   */
	  belowAnchor: _anchorShape2.default,
	
	  /**
	   * This is the animation position for the list that appears.
	   *
	   * @see {@link Helpers/Layover#animationPosition}
	   */
	  position: _positionShape2.default,
	
	  /**
	   * This is the component/element that should toggle the menu open.
	   *
	   * @see {@link Helpers/Layover#toggle}
	   */
	  toggle: _propTypes2.default.node,
	
	  /**
	   * This is how the menu's list will be "fixed" to the `toggle` component.
	   *
	   * @see {@link Helpers/Layover#fixedTo}
	   */
	  fixedTo: _fixedToShape2.default,
	
	  /**
	   * Any additional props that should be applied to the list in the menu. This is really used
	   * when additional `aria-` tags need to be applied.
	   */
	  listProps: _propTypes2.default.object,
	
	  /**
	   * Boolean if the menu's list should appear horizontally instead of vertically.
	   */
	  listInline: _propTypes2.default.bool,
	
	  /**
	   * The list's z-depth for applying box shadow. This should be a number from 0 to 5.
	   */
	  listZDepth: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the list should have its height restricted to the `$md-menu-mobile-max-height`/
	   * `$md-menu-desktop-max-height` values.
	   *
	   * @see [md-menu-mobile-max-height](/components/menus?tab=2#variable-md-menu-mobile-max-height)
	   * @see [md-menu-desktop-max-height](/components/menus?tab=2#variable-md-menu-desktop-max-height)
	   */
	  listHeightRestricted: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu's list is visible.
	   */
	  visible: _propTypes2.default.bool.isRequired,
	
	  /**
	   * Any children to render in the menu's list. This _should_ normally be `ListItem`, or
	   * `ListItemControl`.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * An optional function to call when en element in the menu has been clicked.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when a key is pressed anywhere in the menu.
	   */
	  onKeyDown: _propTypes2.default.func,
	
	  /**
	   * A function to call to close the menu. This is used for closing on outside clicks,
	   * closing when a list item has been clicked, or the user presses escape.
	   */
	  onClose: _propTypes2.default.func.isRequired,
	
	  /**
	   * Boolean if the menu should be cascading. This means that the menu will pop the additional
	   * `nestedItems` on any `ListItem` to be appear either to the right or left of the visible list.
	   */
	  cascading: _propTypes2.default.bool,
	
	  /**
	   * This is how the cascading lists get anchored to the list item.
	   *
	   * @see {@link Helpers/Layover#anchor}
	   */
	  cascadingAnchor: _Layover2.default.propTypes.anchor,
	
	  /**
	   * This is the z-depth the list should gain for a cascading menu. This only gets applied on
	   * items that are more than 1 level deep.
	   */
	  cascadingZDepth: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the `md-full-width` class name should get applied to the menu's container.
	   */
	  fullWidth: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu should be displayed as a block instead of as an inline block.
	   *
	   * @see {@link #fullWidth}
	   */
	  block: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#centered}
	   */
	  centered: _Layover2.default.propTypes.centered,
	
	  /**
	   * @see {@link Helpers/Layover#sameWidth}
	   */
	  sameWidth: _Layover2.default.propTypes.sameWidth,
	
	  /**
	   * If you would like the menu to interact as a context menu, provide this prop.
	   *
	   * @see {@link Helpers/Layover#onContextMenu}
	   */
	  onContextMenu: _Layover2.default.propTypes.onContextMenu,
	
	  /**
	   * Boolean if the default behavior of the context menu should be prevented when using the
	   * `onContextMenu` prop.
	   *
	   * @see {@link Helpers/Layover#preventContextMenu}
	   */
	  preventContextMenu: _Layover2.default.propTypes.preventContextMenu,
	
	  /**
	   * @see {@link Helpers/Layover#xThreshold}
	   */
	  xThreshold: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#yThreshold}
	   */
	  yThreshold: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#closeOnOutsideClick}
	   */
	  closeOnOutsideClick: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#toggleQuery}
	   */
	  toggleQuery: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.string]),
	
	  /**
	   * An optional transition name to use for the list appearing/disappearing.
	   *
	   * @see {@link Helpers/Layover#transitionName}
	   */
	  transitionName: _propTypes2.default.string,
	
	  /**
	   * @see {@link Helpers/Layover#transitionEnterTimeout}
	   */
	  transitionEnterTimeout: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#transitionLeaveTimeout}
	   */
	  transitionLeaveTimeout: _propTypes2.default.number,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the `fixedTo` element scrolls.
	   *
	   * @see {@link Helpers/Layover#repositionOnScroll}
	   */
	  repositionOnScroll: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the window resizes.
	   *
	   * @see {@link Helpers/Layover#repositionOnResize}
	   */
	  repositionOnResize: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#simplified}
	   */
	  simplified: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#minLeft}
	   */
	  minLeft: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * @see {@link Helpers/Layover#minRight}
	   */
	  minRight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * @see {@link Helpers/Layover#minBottom}
	   */
	  minBottom: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * @see {@link Helpers/Layover#fillViewportWidth}
	   */
	  fillViewportWidth: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#fillViewportHeight}
	   */
	  fillViewportHeight: _propTypes2.default.bool,
	
	  isOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `visible` instead'),
	  close: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `onClose` instead'),
	  autoclose: (0, _deprecated2.default)(_propTypes2.default.bool, 'The menus will always autoclose as according to the specs'),
	  contained: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `sameWidth` instead'),
	  limitHeight: (0, _deprecated2.default)(_propTypes2.default.bool, 'The menus will always be limited in height as according to the specs'),
	  expanderIconClassName: (0, _deprecated2.default)(_propTypes2.default.node, 'The expander for cascading menus will now just be a simple rotate of the existing `ListItem` ' + 'expander icon'),
	  expanderIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'The expander for cascading menus will now just be a simple rotate of the existing `ListItem` ' + 'expander icon')
	};
	Menu.defaultProps = {
	  anchor: {
	    x: _Layover2.default.HorizontalAnchors.INNER_RIGHT,
	    y: _Layover2.default.VerticalAnchors.OVERLAP
	  },
	  cascadingAnchor: {
	    x: _Layover2.default.HorizontalAnchors.RIGHT,
	    y: _Layover2.default.VerticalAnchors.OVERLAP
	  },
	  position: _Layover2.default.Positions.TOP_RIGHT,
	  fixedTo: typeof window !== 'undefined' ? window : {},
	  listZDepth: 2,
	  listHeightRestricted: true,
	  cascadingZDepth: 3,
	  repositionOnScroll: true,
	  repositionOnResize: false,
	  simplified: true
	};
	Menu.contextTypes = {
	  listLevel: _propTypes2.default.number,
	  cascadingId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  cascadingMenu: _propTypes2.default.bool,
	  cascadingAnchor: _anchorShape2.default,
	  cascadingZDepth: _propTypes2.default.number
	};
	Menu.childContextTypes = {
	  listLevel: _propTypes2.default.number,
	  cascadingId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  cascadingMenu: _propTypes2.default.bool,
	  cascadingFixedTo: _fixedToShape2.default,
	  cascadingAnchor: _anchorShape2.default,
	  cascadingZDepth: _propTypes2.default.number
	};
	exports.default = Menu;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = handleKeyboardAccessibility;
	
	var _keyCodes = __webpack_require__(14);
	
	var _closest = __webpack_require__(252);
	
	var _closest2 = _interopRequireDefault(_closest);
	
	var _isFormPartRole = __webpack_require__(255);
	
	var _isFormPartRole2 = _interopRequireDefault(_isFormPartRole);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A utility function for adding keyboard accessibility to elements that are not a natively
	 * clickable (div, span, etc). When the space or enter key is pressed while focusing the
	 * element, different flows will happen.
	 *
	 * - space - The click event will be triggered and the default page scrolling behavior of the
	 *      spacebar will be prevented
	 * - enter - If the element has a form role ('checkbox' or 'radio'), the click event will not
	 *      be triggered. Instead, it will find out if the element is inside a form. If it is, it
	 *      will emulate the default behavior of attempting to submit the form. If the element does
	 *      not have a form role, the click event will be triggered.
	 *
	 * @param {Event} e - the keydown event
	 * @param {function} onClick - the on click event to be triggered if space or enter was pressed
	 * @param {boolean=true} listenToEnter - boolean if the enter key should be used to trigger the
	 *      the click event. Even if this is true, the click event will not be triggered if the role
	 *      is for a form role.
	 * @param {boolean=true} listenToSpace - boolean if the space key should be used to trigger the
	 *      click event.
	 * @return {Boolean} true if the enter or space keys were pressed while their listener is also active.
	 */
	function handleKeyboardAccessibility(e, onClick) {
	  var listenToEnter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  var listenToSpace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	  var key = e.which || e.keyCode;
	  var space = listenToSpace && key === _keyCodes.SPACE;
	  var enter = key === _keyCodes.ENTER;
	
	  var tagName = e.target.tagName;
	  // it is valid to press space in text fields, contenteditable, and buttons
	
	  if (space && !tagName.match(/input|textarea|button/i) && e.target.getAttribute('contenteditable') !== 'true') {
	    // Stop page scrolling
	    e.preventDefault();
	  }
	
	  if (enter && (0, _isFormPartRole2.default)(e.target)) {
	    var form = (0, _closest2.default)(e.target, 'form');
	    var submit = form ? form.querySelector('*[type="submit"]') : null;
	    if (submit) {
	      submit.click();
	    }
	
	    return true;
	  }
	
	  if (enter && listenToEnter || space) {
	    onClick(e);
	
	    return true;
	  }
	
	  return false;
	} /** @module utils/EventUtils/handleKeyboardAccessibility */

/***/ }),
/* 58 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isValidDate;
	/**
	 * Checks if a variable provided is defined and a correctly formatted date.
	 *
	 * Examples:
	 * - isValidDate(null) -> false
	 * - isValidDate('') -> false
	 * - isValidDate(new Date('23--33')) - false (malformed date)
	 * - isValidDate(new Date()) -> true
	 *
	 * @param d - Any value that should be checked if it is a valid date
	 * @return {boolean} true if it is a valid date.
	 */
	function isValidDate(d) {
	  // just checking if getTime is a function is ridiculously quicker than instanceof Date
	  // and _seems_ safe enough
	  return !!d && typeof d.getTime === 'function' && d.getTime() === d.getTime();
	}

/***/ }),
/* 59 */,
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.nameShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  leaveActive: _propTypes2.default.string,
	  appear: _propTypes2.default.string,
	  appearActive: _propTypes2.default.string
	})]);

/***/ }),
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The divider component will pass all other props such as style or
	 * event listeners on to the component.
	 */
	var Divider = function (_PureComponent) {
	  _inherits(Divider, _PureComponent);
	
	  function Divider() {
	    _classCallCheck(this, Divider);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  Divider.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        inset = _props.inset,
	        vertical = _props.vertical,
	        props = _objectWithoutProperties(_props, ['className', 'inset', 'vertical']);
	
	    var Component = vertical ? 'div' : 'hr';
	
	    return _react2.default.createElement(Component, _extends({}, props, {
	      className: (0, _classnames2.default)('md-divider', {
	        'md-divider--vertical': vertical,
	        'md-divider--inset': inset
	      }, className)
	    }));
	  };
	
	  return Divider;
	}(_react.PureComponent);
	
	Divider.propTypes = {
	  /*
	   * An optional style to apply to the divider.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the divider.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Boolean if this divider should be inset relative to it's container
	   * component. This means that if it is in a `List` with `Avatar`, it
	   * will start the divider  to the left of the main text in the list.
	   */
	  inset: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the divider should be vertical instead of horizontal.
	   */
	  vertical: _propTypes2.default.bool
	};
	exports.default = Divider;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(7);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keyCodes = __webpack_require__(14);
	
	var _handleKeyboardAccessibility = __webpack_require__(57);
	
	var _handleKeyboardAccessibility2 = _interopRequireDefault(_handleKeyboardAccessibility);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `AccessibleFakeButton` is a generic component that can be used to render
	 * a `div` or any other non `button` components as a button. This should not be
	 * used often.
	 *
	 * The `AccessibleFakeButton` allows the user to tab focus the element, use the
	 * space or enter key to trigger the `onClick` event, and toggles the `aria-pressed`
	 * attribute.
	 */
	var AccessibleFakeButton = function (_PureComponent) {
	  _inherits(AccessibleFakeButton, _PureComponent);
	
	  function AccessibleFakeButton() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AccessibleFakeButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = { pressed: false, tabFocused: false }, _this.focus = function () {
	      if (_this._node) {
	        _this._node.focus();
	      }
	    }, _this.blur = function () {
	      if (_this._node) {
	        _this._node.blur();
	      }
	    }, _this._setNode = function (node) {
	      if (node) {
	        _this._node = (0, _reactDom.findDOMNode)(node);
	      }
	    }, _this._handleClick = function (e) {
	      if (_this.props.disabled) {
	        return;
	      }
	
	      if (_this.props.onClick) {
	        _this.props.onClick(e);
	      }
	
	      _this._node.focus();
	      _this.setState({ pressed: !_this.state.pressed });
	    }, _this._handleKeyDown = function (e) {
	      var _this$props = _this.props,
	          disabled = _this$props.disabled,
	          onKeyDown = _this$props.onKeyDown,
	          listenToEnter = _this$props.listenToEnter,
	          listenToSpace = _this$props.listenToSpace;
	
	      if (disabled) {
	        return;
	      }
	
	      if (onKeyDown) {
	        onKeyDown(e);
	      }
	
	      (0, _handleKeyboardAccessibility2.default)(e, _this._handleClick, listenToEnter, listenToSpace);
	    }, _this._handleKeyUp = function (e) {
	      var _this$props2 = _this.props,
	          onKeyUp = _this$props2.onKeyUp,
	          onTabFocus = _this$props2.onTabFocus;
	
	      if (onKeyUp) {
	        onKeyUp(e);
	      }
	
	      if ((e.which || e.keyCode) === _keyCodes.TAB) {
	        if (onTabFocus) {
	          onTabFocus(e);
	        }
	
	        _this.setState({ tabFocused: true });
	      }
	    }, _this._handleBlur = function (e) {
	      if (_this.props.onBlur) {
	        _this.props.onBlur(e);
	      }
	
	      if (_this.state.tabFocused) {
	        _this.setState({ tabFocused: false });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  /**
	   * Focuses the button.
	   */
	
	
	  /**
	   * Blurs the button.
	   */
	
	
	  AccessibleFakeButton.prototype.render = function render() {
	    var _cn;
	
	    var _props = this.props,
	        Component = _props.component,
	        children = _props.children,
	        className = _props.className,
	        tabbedClassName = _props.tabbedClassName,
	        disabled = _props.disabled,
	        tabIndex = _props.tabIndex,
	        ink = _props.ink,
	        noFocusOutline = _props.noFocusOutline,
	        onBlur = _props.onBlur,
	        onClick = _props.onClick,
	        onKeyUp = _props.onKeyUp,
	        onKeyDown = _props.onKeyDown,
	        onTabFocus = _props.onTabFocus,
	        listenToEnter = _props.listenToEnter,
	        listenToSpace = _props.listenToSpace,
	        props = _objectWithoutProperties(_props, ['component', 'children', 'className', 'tabbedClassName', 'disabled', 'tabIndex', 'ink', 'noFocusOutline', 'onBlur', 'onClick', 'onKeyUp', 'onKeyDown', 'onTabFocus', 'listenToEnter', 'listenToSpace']);
	
	    var childElements = children;
	    if (ink) {
	      childElements = _react.Children.toArray(children);
	      childElements.unshift(ink);
	    }
	
	    return _react2.default.createElement(
	      Component,
	      _extends({}, props, {
	        ref: this._setNode,
	        className: (0, _classnames2.default)('md-fake-btn', (_cn = {
	          'md-pointer--hover': !disabled,
	          'md-fake-btn--no-outline': noFocusOutline
	        }, _cn[tabbedClassName] = tabbedClassName && this.state.tabFocused, _cn), className),
	        disabled: disabled,
	        tabIndex: disabled ? null : tabIndex,
	        onBlur: this._handleBlur,
	        onClick: this._handleClick,
	        onKeyUp: this._handleKeyUp,
	        onKeyDown: this._handleKeyDown,
	        'aria-pressed': this.state.pressed
	      }),
	      childElements
	    );
	  };
	
	  return AccessibleFakeButton;
	}(_react.PureComponent);
	
	AccessibleFakeButton.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional function to call only when the button has been focused with the tab key.
	   */
	  tabbedClassName: _propTypes2.default.string,
	
	  /**
	   * Any children to display in the Accessible Fake Button.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * An optional onClick function to call when the user clicks the
	   * button or presses space || enter.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional onKeyDown function to call.
	   */
	  onKeyDown: _propTypes2.default.func,
	
	  /**
	   * An optional onBlur function to call.
	   */
	  onBlur: _propTypes2.default.func,
	
	  /**
	   * An optional onKeyUp function to call.
	   */
	  onKeyUp: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the element is focused with the tab key.
	   */
	  onTabFocus: _propTypes2.default.func,
	
	  /**
	   * The component to render the Fake button as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * Boolean if the default outline should be removed the when the fake button has been focused.
	   *
	   * @see {@link #tabbedClassName}
	   */
	  noFocusOutline: _propTypes2.default.bool,
	
	  /**
	   * The tab index to use for the Fake button so it is keyboard focusable.
	   */
	  tabIndex: _propTypes2.default.number,
	
	  /**
	   * Boolean if the Button is disabled. This will prevent tab focus.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * The role for the accessible fake button. It is recommended to keep it
	   * the default of `button` unless you are rendering it as an `a` tag.
	   */
	  role: _propTypes2.default.string,
	
	  /**
	   * The ink when coming from the AccessibleFakeInkedButton
	   * @access private
	   */
	  ink: _propTypes2.default.node,
	
	  /**
	   * Boolean if the spacebar should be used to trigger the click event. This _should_ be `true`
	   * is almost all cases.
	   */
	  listenToSpace: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the enter key should be used to trigger the click event. This _should_ be `true`
	   * in most cases. By default, the param will be ignored if the `role` attribute is for a `checkbox`
	   * or `radio`. When it is a checkbox or radio, it will attempt to submit the form on the enter
	   * keypress instead like the native elements.
	   */
	  listenToEnter: _propTypes2.default.bool
	};
	AccessibleFakeButton.defaultProps = {
	  component: 'div',
	  tabIndex: 0,
	  role: 'button',
	  noFocusOutline: true,
	  listenToEnter: true,
	  listenToSpace: true
	};
	exports.default = AccessibleFakeButton;

/***/ }),
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(5);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _themeColors = __webpack_require__(11);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _getCollapserStyles = __webpack_require__(129);
	
	var _getCollapserStyles2 = _interopRequireDefault(_getCollapserStyles);
	
	var _getField = __webpack_require__(8);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _injectTooltip = __webpack_require__(173);
	
	var _injectTooltip2 = _interopRequireDefault(_injectTooltip);
	
	var _FontIcon = __webpack_require__(12);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _getDeprecatedIcon = __webpack_require__(21);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _IconSeparator = __webpack_require__(83);
	
	var _IconSeparator2 = _interopRequireDefault(_IconSeparator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CELL_SCOPE = {
	  header: {
	    scope: 'col'
	  },
	  noop: {}
	};
	
	/**
	 * A column in a table. This is either the `th` or `td` component.
	 */
	
	var TableColumn = function (_PureComponent) {
	  _inherits(TableColumn, _PureComponent);
	
	  function TableColumn() {
	    _classCallCheck(this, TableColumn);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  TableColumn.prototype.render = function render() {
	    var _cn;
	
	    var _props = this.props,
	        className = _props.className,
	        fixedStyle = _props.fixedStyle,
	        fixedClassName = _props.fixedClassName,
	        numeric = _props.numeric,
	        header = _props.header,
	        children = _props.children,
	        sorted = _props.sorted,
	        sortIcon = _props.sortIcon,
	        tooltip = _props.tooltip,
	        selectColumnHeader = _props.selectColumnHeader,
	        adjusted = _props.adjusted,
	        grow = _props.grow,
	        sortIconBefore = _props.sortIconBefore,
	        propPlain = _props.plain,
	        propScope = _props.scope,
	        cellIndex = _props.cellIndex,
	        sortIconChildren = _props.sortIconChildren,
	        sortIconClassName = _props.sortIconClassName,
	        props = _objectWithoutProperties(_props, ['className', 'fixedStyle', 'fixedClassName', 'numeric', 'header', 'children', 'sorted', 'sortIcon', 'tooltip', 'selectColumnHeader', 'adjusted', 'grow', 'sortIconBefore', 'plain', 'scope', 'cellIndex', 'sortIconChildren', 'sortIconClassName']);
	
	    var sortable = typeof sorted === 'boolean';
	    var plain = (0, _getField2.default)(this.props, this.context, 'plain');
	    var Component = header ? 'th' : 'td';
	    var scope = (0, _getField2.default)(this.props, CELL_SCOPE[header ? 'header' : 'noop'], 'scope');
	
	    var displayedChildren = children;
	    var ariaSort = void 0;
	    if (sortable) {
	      ariaSort = sorted ? 'ascending' : 'descending';
	      var icon = _react2.default.Children.only((0, _getDeprecatedIcon2.default)(sortIconClassName, sortIconChildren, sortIcon));
	      displayedChildren = _react2.default.createElement(
	        _IconSeparator2.default,
	        { label: children, iconBefore: sortIconBefore },
	        _react2.default.cloneElement(icon, { className: (0, _getCollapserStyles2.default)({ flipped: !sorted }, icon.props.className) })
	      );
	    }
	
	    var fixedHeader = header && this.context.fixedHeader;
	    var fixedFooter = this.context.footer && this.context.fixedFooter;
	    var fixed = fixedHeader || fixedFooter;
	    var baseClassNames = (0, _themeColors2.default)({ text: !header, hint: header }, {
	      'md-table-column--relative': tooltip,
	      'md-table-column--select-field': selectColumnHeader
	    });
	
	    var mergedClassNames = (0, _classnames2.default)((_cn = {
	      'md-table-column--header': header,
	      'md-table-column--data': !header && !plain,
	      'md-table-column--plain': !header && plain,
	      'md-table-column--adjusted': adjusted && !grow && !selectColumnHeader,
	      'md-table-column--grow': grow,
	      'md-table-column--sortable md-pointer--hover': sortable
	    }, _cn[baseClassNames] = !fixed, _cn), className);
	
	    if (fixed) {
	      displayedChildren = _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('md-table-column__fixed', {
	            'md-table-column__fixed--header': fixedHeader,
	            'md-table-column__fixed--footer': fixedFooter
	          })
	        },
	        _react2.default.createElement(
	          'div',
	          {
	            style: fixedStyle,
	            className: (0, _classnames2.default)(baseClassNames, mergedClassNames, 'md-table-column__fixed--flex', {
	              'md-table-column__fixed--flex-right': numeric
	            }, fixedClassName)
	          },
	          tooltip,
	          displayedChildren
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      Component,
	      _extends({
	        'aria-sort': ariaSort
	      }, props, {
	        scope: scope,
	        className: (0, _classnames2.default)('md-table-column', {
	          'md-table-column--fixed': fixed,
	          'md-text-left': !numeric && !fixed,
	          'md-text-right': numeric && !fixed
	        }, mergedClassNames)
	      }),
	      !fixedHeader && !fixedFooter && tooltip,
	      displayedChildren
	    );
	  };
	
	  return TableColumn;
	}(_react.PureComponent);
	
	TableColumn.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * The optional className for the table column
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the surrounding div when the DataTable has been
	   * set to include a fixed header or a fixed footer.
	   */
	  fixedStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the surrounding div when the DataTable has been
	   * set to include a fixed header or a fixed footer.
	   */
	  fixedClassName: _propTypes2.default.string,
	
	  /**
	   * The children to display in the column.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * Boolean if the column is currently sorted. If this prop is not `undefined`,
	   * it will add the sort icon unto this column. You will also need to use the
	   * `onClick` function to toggle the `sorted` prop as well as handling the sorting
	   * of data.
	   *
	   * This value should really only be set in the `TableHeader` component.
	   */
	  sorted: _propTypes2.default.bool,
	
	  /**
	   * The icon to show when a column is sortable.
	   */
	  sortIcon: _propTypes2.default.element,
	
	  /**
	   * Boolean if the sortIcon should appear before the text in the column.
	   */
	  sortIconBefore: _propTypes2.default.bool,
	
	  /**
	   * A boolean if the column has numeric data. It will right-align the data.
	   */
	  numeric: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the table column should gain the `.md-data-table--adjusted` class name. By default,
	   * every column will gain this class name unless it is an `EditDialogColumn`, a `SelectFieldColumn`,
	   * or the `grow` prop is enabled.
	   */
	  adjusted: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the column should expand to fill any remaining width in the container. There should
	   * really only be one column with the `grow` prop enabled. In addition, it should really only be
	   * applied to one of the columns in the TableHeader.
	   */
	  grow: _propTypes2.default.bool,
	
	  /**
	   * Boolean if this column is the `th` for a column of `SelectFieldColumn`. This will apply
	   * additional styling to the column to position with the select field.
	   */
	  selectColumnHeader: _propTypes2.default.bool,
	
	  /**
	   * Boolean if this is a `th` component. This value **should** be set
	   * automatically for you if it is in the `TableHeader` component.
	   */
	  header: _propTypes2.default.bool.isRequired,
	
	  /**
	   * The optional tooltip to render on hover.
	   */
	  tooltipLabel: _propTypes2.default.node,
	
	  /**
	   * An optional delay to apply to the tooltip before it appears.
	   */
	  tooltipDelay: _propTypes2.default.number,
	
	  /**
	   * The position of the tooltip.
	   */
	  tooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The injected tooltip.
	   * @access private
	   */
	  tooltip: _propTypes2.default.node,
	
	  /**
	   * Boolean if the `TableColumn` should gain the `plain` styles. This means that the text
	   * in the column can wrap and there is no height limit enforced with some additional padding.
	   */
	  plain: _propTypes2.default.bool,
	
	  /**
	   * An optional scope to apply to the table column. If omitted, the scope will be set to
	   * `'col'` if inside of the `TableHeader` component. This is really only needed for
	   * header columns.
	   */
	  scope: _propTypes2.default.oneOf(['row', 'col']),
	
	  /**
	   * This is injected by the `TableRow` component to help with generating ids
	   * @access private
	   */
	  cellIndex: _propTypes2.default.number,
	  sortIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `sortIcon` prop instead'),
	  sortIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `sortIcon` prop instead')
	};
	TableColumn.defaultProps = {
	  header: false,
	  adjusted: true,
	  sortIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'arrow_upward'
	  ),
	  sortIconBefore: true
	};
	TableColumn.contextTypes = {
	  plain: _propTypes2.default.bool,
	  footer: _propTypes2.default.bool,
	  fixedHeader: _propTypes2.default.bool,
	  fixedFooter: _propTypes2.default.bool
	};
	exports.default = (0, _injectTooltip2.default)(TableColumn);

/***/ }),
/* 83 */,
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(7);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CSSTransitionGroup = __webpack_require__(38);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _handleWindowClickListeners = __webpack_require__(90);
	
	var _handleWindowClickListeners2 = _interopRequireDefault(_handleWindowClickListeners);
	
	var _getSelectedTextPosition = __webpack_require__(248);
	
	var _getSelectedTextPosition2 = _interopRequireDefault(_getSelectedTextPosition);
	
	var _getScroll = __webpack_require__(247);
	
	var _getScroll2 = _interopRequireDefault(_getScroll);
	
	var _viewport = __webpack_require__(174);
	
	var _viewport2 = _interopRequireDefault(_viewport);
	
	var _isOutOfBounds = __webpack_require__(249);
	
	var _isOutOfBounds2 = _interopRequireDefault(_isOutOfBounds);
	
	var _anchorShape = __webpack_require__(28);
	
	var _anchorShape2 = _interopRequireDefault(_anchorShape);
	
	var _fixedToShape = __webpack_require__(19);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _positionShape = __webpack_require__(36);
	
	var _positionShape2 = _interopRequireDefault(_positionShape);
	
	var _HorizontalAnchors = __webpack_require__(117);
	
	var _HorizontalAnchors2 = _interopRequireDefault(_HorizontalAnchors);
	
	var _VerticalAnchors = __webpack_require__(119);
	
	var _VerticalAnchors2 = _interopRequireDefault(_VerticalAnchors);
	
	var _Positions = __webpack_require__(118);
	
	var _Positions2 = _interopRequireDefault(_Positions);
	
	var _ResizeObserver = __webpack_require__(35);
	
	var _ResizeObserver2 = _interopRequireDefault(_ResizeObserver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The Layover component is used to keep a component fixed to another component
	 * while the page is scrolling or a container is scrolling. When the fixed component
	 * is considered out of view, it will be closed.
	 *
	 * > NOTE: Don't look at source code. Plz.
	 */
	var Layover = function (_PureComponent) {
	  _inherits(Layover, _PureComponent);
	
	  function Layover(props) {
	    _classCallCheck(this, Layover);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this));
	
	    _initialiseProps.call(_this);
	
	    var child = _react2.default.Children.only(props.children);
	    _this.state = {
	      below: false,
	      right: false,
	      styles: child.props.style
	    };
	
	    _this._lastXFix = null;
	    _this._lastYFix = null;
	    _this._initialX = null;
	    _this._initialY = null;
	    _this._initialTop = null;
	    _this._initialLeft = null;
	    _this._child = null;
	    _this._toggle = null;
	    return _this;
	  }
	
	  Layover.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    if (false) {
	      window.addEventListener('load', function () {
	        _this2._setContainer(_this2._container);
	      });
	    }
	
	    var _props = this.props,
	        visible = _props.visible,
	        fixedTo = _props.fixedTo,
	        sameWidth = _props.sameWidth,
	        centered = _props.centered,
	        simplified = _props.simplified;
	
	    var anchor = this._getAnchor(this.props);
	    if (visible) {
	      (0, _handleWindowClickListeners2.default)(this._handleOutsideClick, true);
	
	      // Don't worry about any of the other logic for a "simple" layover
	      if (simplified) {
	        return;
	      }
	
	      var rect = this._contextRect || this._toggle.getBoundingClientRect();
	      if (this._dialog) {
	        this._manageFixedToListener(this._dialog, true);
	      } else if (!this._inFixed) {
	        this._manageFixedToListener(fixedTo, true);
	      }
	
	      this._init(fixedTo, anchor, sameWidth, centered, rect);
	    }
	  };
	
	  Layover.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var fixedTo = nextProps.fixedTo,
	        visible = nextProps.visible,
	        children = nextProps.children,
	        sameWidth = nextProps.sameWidth,
	        centered = nextProps.centered,
	        simplified = nextProps.simplified;
	
	    if (simplified) {
	      if (this.props.simplified !== simplified) {
	        this._reset();
	      }
	      return;
	    }
	
	    var anchor = this._getAnchor(nextProps);
	    var visibileDiff = visible !== this.props.visible;
	    var childStyle = _react2.default.Children.only(children).props.style;
	
	    if (visibileDiff) {
	      if (!visible) {
	        this._reset();
	      } else {
	        // Initialize the layover logic
	        var rect = this._contextRect || this._toggle.getBoundingClientRect();
	        if (this._dialog) {
	          this._manageFixedToListener(this._dialog, true);
	        } else if (!this._inFixed) {
	          this._manageFixedToListener(fixedTo, true);
	        }
	
	        this._init(fixedTo, anchor, sameWidth, centered, rect);
	      }
	    } else if (fixedTo !== this.props.fixedTo && visible) {
	      // swap the fixedTo listeners
	      this._manageFixedToListener(this.props.fixedTo, false);
	      this._manageFixedToListener(fixedTo, true);
	    } else if (childStyle !== _react2.default.Children.only(this.props.children).props.style) {
	      // Re-merge styles... This is only required if all the others fail since all the other
	      // logic always merges styles with the children styles
	      this.setState({ styles: _extends({}, this.state.styles, childStyle) });
	    }
	  };
	
	  Layover.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var _this3 = this;
	
	    var _props2 = this.props,
	        visible = _props2.visible,
	        closeOnOutsideClick = _props2.closeOnOutsideClick;
	
	    var enabled = visible && closeOnOutsideClick;
	    var prevEnabled = prevProps.visible && prevProps.closeOnOutsideClick;
	    if (enabled !== prevEnabled) {
	      if (this._clickTimeout) {
	        clearTimeout(this._clickTimeout);
	        this._clickTimeout = null;
	      }
	
	      // This is really an arbitrary timeout time, but firefox needs to have a timeout
	      // so the context menu doesn't close automatically due to an "outside click" being
	      // triggered
	      this._clickTimeout = setTimeout(function () {
	        _this3._clickTimeout = null;
	        (0, _handleWindowClickListeners2.default)(_this3._handleOutsideClick, enabled);
	      }, enabled ? 300 : 0);
	    }
	  };
	
	  Layover.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this._clickTimeout) {
	      clearTimeout(this._clickTimeout);
	      this._clickTimeout = null;
	    }
	    (0, _handleWindowClickListeners2.default)(this._handleOutsideClick, false);
	
	    if (!this.props.simplified) {
	      this._manageFixedToListener(this.props.fixedTo, false);
	      this._manageWindowResizeListener(false);
	    }
	  };
	
	  Layover.prototype._getAnchor = function _getAnchor(_ref) {
	    var anchor = _ref.anchor,
	        belowAnchor = _ref.belowAnchor,
	        animationPosition = _ref.animationPosition;
	
	    return animationPosition === Layover.Positions.BELOW && belowAnchor || anchor;
	  };
	
	  /**
	   * Whew. Ok. So since the fixedTo prop can either be two elements or a single item,
	   * this utility function is used to add/remove the scrolling event listeners for
	   * this prop.
	   *
	   * When the fixedTo prop has a horizontal and/or vertical attribute, the `window`
	   * will be the fallback option. If both the horizontal and vertical attributes are
	   * defined, the `window` still needs to have a scroll listener to make sure it
	   * doesn't go off screen.
	   */
	
	
	  /**
	   * This is just a simple utility function to merge the existing state styles,
	   * any new styles, and the children's styles (with most precedence).
	   */
	
	
	  /**
	   * This initializes the popover with the default styles, and the initial bookkeeping
	   * variables to update while it is open.
	   */
	
	
	  /**
	   * Attempts to fix the child by setting it's location ONLY for the entire
	   * page viewport. I didn't bother attempting to fix it for additional fixedTo
	   * stuff.
	   */
	
	
	  /**
	   * When the child is initially mounted, it will update the styles for centering
	   * the element (if enabled) and then attempt to fix any viewport issues.
	   */
	
	
	  /**
	   * This is the meat of the stuff. Do lots of viewport / container checks to make sure
	   * the element should still be visible. If it is still visible, it will update its
	   * x and y position for the new scroll position.
	   */
	
	
	  /**
	   * Attempts to fix a viewport problem by swapping the positioning. This only does
	   * vertical switching right now.
	   *
	   * @param {Object} vp - The result of the viewport function
	   * @return {boolean} true if the fix was able to be done and successful.
	   */
	
	
	  Layover.prototype.render = function render() {
	    var _props3 = this.props,
	        className = _props3.className,
	        block = _props3.block,
	        toggle = _props3.toggle,
	        visible = _props3.visible,
	        children = _props3.children,
	        fullWidth = _props3.fullWidth,
	        animationPosition = _props3.animationPosition,
	        simplified = _props3.simplified,
	        fillViewportWidth = _props3.fillViewportWidth,
	        fillViewportHeight = _props3.fillViewportHeight,
	        anchor = _props3.anchor,
	        belowAnchor = _props3.belowAnchor,
	        onClose = _props3.onClose,
	        repositionOnScroll = _props3.repositionOnScroll,
	        repositionOnResize = _props3.repositionOnResize,
	        sameWidth = _props3.sameWidth,
	        centered = _props3.centered,
	        fixedTo = _props3.fixedTo,
	        toggleQuery = _props3.toggleQuery,
	        yThreshold = _props3.yThreshold,
	        xThreshold = _props3.xThreshold,
	        onContextMenu = _props3.onContextMenu,
	        preventContextMenu = _props3.preventContextMenu,
	        closeOnOutsideClick = _props3.closeOnOutsideClick,
	        minLeft = _props3.minLeft,
	        minRight = _props3.minRight,
	        minBottom = _props3.minBottom,
	        props = _objectWithoutProperties(_props3, ['className', 'block', 'toggle', 'visible', 'children', 'fullWidth', 'animationPosition', 'simplified', 'fillViewportWidth', 'fillViewportHeight', 'anchor', 'belowAnchor', 'onClose', 'repositionOnScroll', 'repositionOnResize', 'sameWidth', 'centered', 'fixedTo', 'toggleQuery', 'yThreshold', 'xThreshold', 'onContextMenu', 'preventContextMenu', 'closeOnOutsideClick', 'minLeft', 'minRight', 'minBottom']);
	
	    var child = void 0;
	    var childId = void 0;
	    if (visible) {
	      child = _react2.default.Children.only(children);
	      if (child.props.id) {
	        childId = child.props.id;
	      } else if (props.id) {
	        childId = props.id + '-layover';
	      }
	
	      child = _react2.default.cloneElement(children, {
	        ref: this._fixateChild,
	        id: childId,
	        style: simplified ? child.props.style : this.state.styles,
	        className: (0, _classnames2.default)('md-layover-child md-layover-child--' + animationPosition, {
	          'md-layover-child--simplified': simplified
	        }, child.props.className)
	      });
	    }
	
	    var observer = null;
	    if (!simplified && !fillViewportWidth && !fillViewportHeight) {
	      observer = _react2.default.createElement(_ResizeObserver2.default, {
	        watchWidth: !fillViewportWidth,
	        watchHeight: !fillViewportHeight,
	        target: this._child,
	        onResize: this._handleResize
	      });
	    }
	
	    return _react2.default.createElement(
	      _CSSTransitionGroup2.default,
	      _extends({}, props, {
	        className: (0, _classnames2.default)('md-layover', {
	          'md-layover--simplified': simplified,
	          'md-inline-block': !block && !fullWidth,
	          'md-full-width': fullWidth
	        }, className),
	        ref: this._setContainer,
	        'aria-haspopup': true,
	        'aria-owns': childId,
	        'aria-expanded': visible,
	        transitionEnter: props.transitionEnterTimeout !== 0,
	        transitionLeave: props.transitionLeaveTimeout !== 0,
	        onContextMenu: this._handleContextMenu
	      }),
	      observer,
	      toggle,
	      child
	    );
	  };
	
	  return Layover;
	}(_react.PureComponent);
	
	Layover.HorizontalAnchors = _HorizontalAnchors2.default;
	Layover.VerticalAnchors = _VerticalAnchors2.default;
	Layover.Positions = _Positions2.default;
	Layover.propTypes = {
	  /**
	   * A id to give the layover itself. This is generally recommended for accessibility. If the
	   * child does not have an id, the child will automatically be updated to be `${id}-layover`.
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply to the layover.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the layover.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Boolean if the layover's child is currently visible.
	   */
	  visible: _propTypes2.default.bool.isRequired,
	
	  /**
	   * This should either be a single element or two elements that the layover recalculates
	   * its fixed position when scrolling for horizontal and vertical.
	   *
	   * When it is a single element, it will recalculate for both horizontal and vertical
	   * scrolling. Otherwise, you can specify the element for horizontal scrolling and a
	   * separate element for vertical scrolling. If one is omitted, it will default to `window`.
	   *
	   * If the component is no longer considered to be in view after scrolling, the `onClose`
	   * prop will be called.
	   */
	  fixedTo: _fixedToShape2.default.isRequired,
	
	  /**
	   * The renderable item that causes the Layover to become visible. This _should_
	   * most likely be an `element` or `arrayOf(element)`, but anything is allowed.
	   */
	  toggle: _propTypes2.default.node,
	
	  /**
	   * Since the `toggle` prop can be anything, I need a way to be able to find an
	   * element to base all the calculations on. This can either be a string that
	   * gets passed to `layover.querySelector`, a DOM Element, or a function that
	   * returns a DOM Element.
	   */
	  toggleQuery: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.string]).isRequired,
	
	  /**
	   * A single child that should be fixed to the toggle element.
	   */
	  children: _propTypes2.default.element.isRequired,
	
	  /**
	   * Boolean if the Layover should be displayed as a block instead of as an inline block.
	   */
	  block: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `children` should be centered horizontally and vertically while keeping
	   * its height in mind as well. This is *only* valid if both the x and y `anchor` targets
	   * are `CENTER`.
	   */
	  centered: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the layover should gain the `md-full-width` class name.
	   */
	  fullWidth: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the width of the children should be updated automatically to be the width
	   * of the toggle element.
	   */
	  sameWidth: _propTypes2.default.bool,
	
	  /**
	   * The minimum value the `left` style can be for the child component. This is really just used
	   * to make sure it doesn't scroll off the left of the page. It can also be used to make
	   * full screen layovers on devices when when the `fillViewportWidth` prop is enabled.
	   *
	   * This can either be a number of pixels or a string for percentages. If this value is a string
	   * **it will always be used over the calculated values** so it is preferred to use a number.
	   *
	   * @see {@link #minRight}
	   * @see {@link #fillViewportWidth}
	   */
	  minLeft: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	
	  /**
	   * The minimum value the `right` style can be for the child component. This is really just used
	   * to make sure it doesn't scroll off the right of the page when the `fillViewportWidth` prop is
	   * enabled.
	   *
	   * This can either be a number of pixels or a string for percentages. If this value is a string
	   * **it will always be used over the calculated values** so it is preferred to use a number.
	   *
	   * @see {@link #minLeft}
	   * @see {@link #fillViewportWidth}
	   */
	  minRight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	
	  /**
	   * The minimum value that can be used for the `bottom` prop when the `fillViewportHeight` prop is enabled.
	   * It is generally recommended to keep this value at `0` to keep it stretched to the bottom of the viewport
	   * or setting it to a small positive number to add some padding.
	   *
	   * This can either be a number of pixels or a string for percentages. If this value is a string
	   * **it will always be used over the calculated values** so it is preferred to use a number.
	   *
	   * @see {@link #fillViewportHeight}
	   */
	  minBottom: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the layover should make the child fill the entire viewport's width. This will just
	   * style the child element with:
	   *
	   * ```js
	   * childStyle = {
	   *   left: this.props.minLeft,
	   *   right: this.props.minRight,
	   * };
	   * ```
	   *
	   * If you add any additional constraints such as `width` or `max-width`, it will not span the entire viewport's
	   * width. This prop should generally really only be used on mobile devices. Using this prop along with
	   * `fillViewportHeight` for Autocompletes can create great Android mobile searches. See the `fillViewportHeight`
	   * for more information about why it is *only Android*.
	   *
	   * @see {@link #minLeft}
	   * @see {@link #minRight}
	   * @see {@link #fillViewportHeight}
	   */
	  fillViewportWidth: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the layover should fill the height of the viewport from the current calculated `top`. This will just
	   * style the child element with:
	   *
	   * ```js
	   * childStyle = {
	   *   top: currentCalculatedTop,
	   *   bottom: this.props.minBottom,
	   *   maxHeight: 'none',
	   * };
	   * ```
	   *
	   * This is *super* nice on Android devices since it will allow you to create nice toolbar search autocompletes
	   * in your app and the list of items will grow until it reaches the soft keyboard. It isn't as nice on iOS since
	   * iOS does not subtract the soft keyboard from the viewport's size so the list will still extend to the bottom
	   * of the page.
	   *
	   * @see {@link #minBottom}
	   * @see {@link #fillViewportWidth}
	   */
	  fillViewportHeight: _propTypes2.default.bool,
	
	  /**
	   * A function used to hide the visibility of the children when the children are no longer
	   * visible or an element outside of the layover is clicked.
	   */
	  onClose: _propTypes2.default.func.isRequired,
	
	  /**
	   * The component to render the Layover as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	  /**
	   * The transition name to use for the children appearing/disappearing.
	   */
	  transitionName: _propTypes2.default.string.isRequired,
	
	  /**
	   * The transition duration for the enter animation. The animation can be disabled by setting
	   * this value to 0.
	   */
	  transitionEnterTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * The transition duration for the leave animation. The animation can be disabled by setting
	   * this value to 0.
	   */
	  transitionLeaveTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * This is a threshold that is used to calculate if the `children` is still in
	   * view by applying this multiplier to the `children`'s width.
	   */
	  xThreshold: _propTypes2.default.number.isRequired,
	
	  /**
	   * This is a threshold that is used to calculate if the `children` is still in
	   * view by applying this multiplier to the `toggle`'s height.
	   */
	  yThreshold: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the `children` should be hidden when an element outside
	   * of the `Layout` component has been clicked.
	   */
	  closeOnOutsideClick: _propTypes2.default.bool.isRequired,
	
	  /**
	   * This is how the children get "anchored" to the `toggle` element and how the
	   * auto-fix attempts will be made. Right now, the auto fixes will only be handled
	   * on viewport boundaries instead of `fixedTo` boundaries. It was too hard for
	   * first attempt.
	   *
	   * The general behavior will be that an equal-opposite of an anchor will be chosen
	   * when that direction is out of viewport. So for example, the children are out
	   * of viewport for the right of the screen, and the `anchor.x` value is
	   * `Layover.HorizontalPositions.RIGHT`, the children will be swapped to be the `LEFT`
	   * of the `toggle` component now.
	   *
	   * So a full list:
	   * - `LEFT` / `RIGHT`
	   * - `INNER_LEFT` / `INNER_RIGHT`
	   * - `TOP` / `BOTTOM`
	   *
	   * The `CENTER` and `OVERLAP` positions can not be automatically adjusted.
	   *
	   * > To be safe, you should use the enum values for the `x` and `y` values.
	   * @see {@link #VerticalAnchors}
	   * @see {@link #HorizontalAnchors}
	   */
	  anchor: _anchorShape2.default.isRequired,
	
	  /**
	   * This is how the children get "anchored" when the `animationPositions` is set to `Layover.Positions.BELOW`.
	   * Set this to `null` to continue using the base `anchor` prop instead of switching to this anchor.
	   *
	   * @see {@link #anchor}
	   */
	  belowAnchor: _anchorShape2.default,
	
	  /**
	   * This is the position that the children should animate from. It directly ties into
	   * the `$md-layover-child-positions` Sass variable.
	   */
	  animationPosition: _positionShape2.default.isRequired,
	
	  /**
	   * If you would like the layover to interact as a context menu, provide this prop. It will
	   * make the children appear relative to the context menu origin automatically.
	   *
	   * @see {@link #preventContextMenu}
	   */
	  onContextMenu: _propTypes2.default.func,
	
	  /**
	   * Boolean if the default behavior of the context menu should be prevented when using the
	   * `onContextMenu` prop.
	   *
	   * @see {@link #onContextMenu}
	   */
	  preventContextMenu: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the layover should attempt to automatically adjust the position of the element to
	   * keep it within the viewport. If this value is set to `false`, the `onClose` prop will be called
	   * instead.
	   */
	  repositionOnScroll: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the layover should attempt to automatically adjust the position of the element to
	   * keep it within the viewport. If this value is set to `false`, the `onClose` prop will be called
	   * instead.
	   */
	  repositionOnResize: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the layover should become "simplified". This basically disables all the logic for
	   * keeping the child within the viewport and allows you to manage all the positioning via CSS.
	   *
	   * When this is enabled, it updates the `Layover` to have `position: relative` while the child will
	   * have `position: absolute` which will allow for simple `top`, `right`, `bottom`, and/or `left` CSS
	   * to position as wanted.
	   *
	   * This is really only helpful in cases where the layover can't calculate things correctly due to
	   * being in fixed containers somewhere in the page or some other weird stuff. Hopefully this won't
	   * really need to be used much.
	   */
	  simplified: _propTypes2.default.bool
	};
	Layover.defaultProps = {
	  anchor: {
	    x: Layover.HorizontalAnchors.INNER_LEFT,
	    y: Layover.VerticalAnchors.OVERLAP
	  },
	  belowAnchor: {
	    x: Layover.HorizontalAnchors.CENTER,
	    y: Layover.VerticalAnchors.BOTTOM
	  },
	  animationPosition: Layover.Positions.BELOW,
	  repositionOnScroll: true,
	  repositionOnResize: false,
	  component: 'div',
	  fixedTo: typeof window !== 'undefined' ? window : {},
	  toggleQuery: '.md-text-field-container,button,*[role="button"],*[role="listbox"]',
	  transitionName: 'md-layover',
	  transitionEnterTimeout: 200,
	  transitionLeaveTimeout: 200,
	  yThreshold: 0.38,
	  xThreshold: 0.38,
	  closeOnOutsideClick: true,
	  preventContextMenu: true,
	  simplified: false,
	  minLeft: 0,
	  minRight: 0,
	  minBottom: 0,
	  fillViewportWidth: false,
	  fillViewportHeight: false
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this._isCenteredDialog = function () {
	    return _this4._dialog && _this4._dialog.classList.contains('md-dialog--centered');
	  };
	
	  this._createStyles = function (anchor, centered, child, rect) {
	    var x = anchor.x,
	        y = anchor.y;
	    var offsetWidth = child.offsetWidth,
	        offsetHeight = child.offsetHeight;
	
	
	    var left = void 0;
	    var top = void 0;
	    if (x === _HorizontalAnchors2.default.CENTER) {
	      left = rect.left + rect.width / 2 - offsetWidth / 2;
	    } else if (x === _HorizontalAnchors2.default.INNER_RIGHT) {
	      left = rect.right - offsetWidth;
	    } else if (x === _HorizontalAnchors2.default.LEFT) {
	      left = rect.left - offsetWidth;
	    } else if (x === _HorizontalAnchors2.default.RIGHT) {
	      left = rect.right;
	    }
	
	    if (centered && x === _HorizontalAnchors2.default.CENTER && y === _VerticalAnchors2.default.CENTER) {
	      top = rect.top - offsetHeight / 2 + rect.height / 2;
	    } else if (y === _VerticalAnchors2.default.TOP) {
	      top = rect.top - offsetHeight;
	    } else if (y === _VerticalAnchors2.default.CENTER) {
	      top = rect.top + rect.height / 2;
	    } else if (y === _VerticalAnchors2.default.BOTTOM) {
	      top = rect.bottom;
	    }
	
	    if (_this4._isCenteredDialog()) {
	      var dialogRect = _this4._dialog.getBoundingClientRect();
	      left -= dialogRect.left;
	      top -= dialogRect.top;
	    }
	
	    var style = {};
	    if (top) {
	      style.top = top;
	    }
	
	    if (left) {
	      style.left = left;
	    }
	
	    return style;
	  };
	
	  this._manageFixedToListener = function (fixedTo, add) {
	    var listener = (add ? 'add' : 'remove') + 'EventListener';
	    if (fixedTo !== window && (fixedTo.x || fixedTo.y)) {
	      var x = fixedTo.x,
	          y = fixedTo.y;
	
	      if (x) {
	        x[listener]('scroll', _this4._handleScroll);
	      } else {
	        window[listener]('scroll', _this4._handleScroll);
	      }
	
	      if (y) {
	        y[listener]('scroll', _this4._handleScroll);
	      } else if (!x) {
	        // Only add the window event listener once
	        window[listener]('scroll', _this4._handleScroll);
	      }
	
	      if (y && y !== window && x && x !== window) {
	        window[listener]('scroll', _this4._handleScroll);
	      }
	    } else {
	      fixedTo[listener]('scroll', _this4._handleScroll);
	
	      if (fixedTo !== window) {
	        window[listener]('scroll', _this4._handleScroll);
	      }
	    }
	  };
	
	  this._manageWindowResizeListener = function (enabled) {
	    if (_this4._windowResizeTimeout) {
	      clearTimeout(_this4._windowResizeTimeout);
	      _this4._windowResizeTimeout = null;
	    }
	
	    if (enabled) {
	      // add a 2 second delay before watching resize events since Android soft keyboards trigger a resize event.
	      _this4._windowResizeTimeout = setTimeout(function () {
	        _this4._windowResizeTimeout = null;
	        window.addEventListener('resize', _this4._handleWindowResize);
	      }, 2000);
	    } else {
	      window.removeEventListener('resize', _this4._handleWindowResize);
	    }
	  };
	
	  this._mergeStyles = function (style) {
	    var _props4 = _this4.props,
	        minLeft = _props4.minLeft,
	        minRight = _props4.minRight,
	        minBottom = _props4.minBottom,
	        fillViewportWidth = _props4.fillViewportWidth,
	        fillViewportHeight = _props4.fillViewportHeight;
	
	    if (fillViewportWidth) {
	      style.left = minLeft;
	      style.right = minRight;
	    } else {
	      if (style.left) {
	        style.left = Math.max(minLeft, style.left);
	      }
	
	      if (style.right) {
	        style.right = Math.max(minRight, style.right);
	      }
	    }
	
	    if (fillViewportHeight) {
	      style.bottom = minBottom;
	      style.maxHeight = 'none';
	    } else {
	      // These styles are only created when filling the viewport height, so clear
	      // them out again
	      style.bottom = null;
	      style.maxHeight = null;
	    }
	
	    return _extends({}, _this4.state.styles, style, _react2.default.Children.only(_this4.props.children).props.style);
	  };
	
	  this._init = function (fixedTo, anchor, sameWidth, centered, rect) {
	    if (_this4._child) {
	      // The init function can be called again if the user quickly toggles the layover. If that
	      // is the case, we want the styles that were set after the _positionChild _attemptFix.
	      return;
	    }
	
	    var height = rect.height,
	        width = rect.width;
	    var top = rect.top,
	        left = rect.left,
	        right = rect.right;
	
	    var x = void 0;
	    var y = void 0;
	    if (_this4._dialog) {
	      var scroll = (0, _getScroll2.default)(_this4._dialog);
	      x = scroll.x;
	      y = scroll.y;
	
	      if (_this4._isCenteredDialog()) {
	        var dialogRect = _this4._dialog.getBoundingClientRect();
	        left -= dialogRect.left;
	        top -= dialogRect.top;
	        right -= dialogRect.right;
	      }
	    } else if (fixedTo !== window && (fixedTo.y || fixedTo.x)) {
	      x = (0, _getScroll2.default)(fixedTo.x || window).x;
	      y = (0, _getScroll2.default)(fixedTo.y || window).y;
	    } else {
	      var _scroll = (0, _getScroll2.default)(fixedTo);
	      x = _scroll.x;
	      y = _scroll.y;
	    }
	
	    _this4._initialX = x;
	    _this4._initialY = y;
	    _this4._initialLeft = left;
	    _this4._initialTop = top;
	
	    if (anchor.x === _HorizontalAnchors2.default.INNER_RIGHT) {
	      _this4._initialLeft = left + width;
	    } else if (anchor.x === _HorizontalAnchors2.default.RIGHT) {
	      _this4._initialLeft = right;
	    }
	
	    if (!centered) {
	      _this4._lastYFix = anchor.y === _VerticalAnchors2.default.TOP ? 'bottom' : 'top';
	    } else {
	      // Centered is not fixable
	      _this4._lastYFix = null;
	    }
	    if (anchor.x === _HorizontalAnchors2.default.LEFT || anchor.x === _HorizontalAnchors2.default.INNER_LEFT) {
	      _this4._lastXFix = 'right';
	    } else if (anchor.x === _HorizontalAnchors2.default.RIGHT || anchor.x === _HorizontalAnchors2.default.INNER_RIGHT) {
	      _this4._lastXFix = 'left';
	    } else {
	      // Can't fix others
	      _this4._lastXFix = null;
	    }
	
	    if (anchor.y === _VerticalAnchors2.default.BOTTOM) {
	      _this4._initialTop = top + height;
	    }
	
	    if (fixedTo !== window && !fixedTo.y && !fixedTo.x) {
	      var _scroll2 = (0, _getScroll2.default)(window);
	      _this4._initialWinX = _scroll2.x;
	      _this4._initialWinY = _scroll2.y;
	    }
	
	    var styles = _this4._mergeStyles({
	      left: _this4._initialLeft,
	      top: _this4._initialTop,
	      transformOrigin: undefined,
	      width: sameWidth ? width : undefined
	    });
	
	    _this4.setState({ styles: styles });
	  };
	
	  this._reset = function () {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this4.props,
	        fixedTo = _ref2.fixedTo;
	
	    // Reset all the bookkeeping variables for a fresh start on re-visible
	    _this4._lastXFix = null;
	    _this4._lastYFix = null;
	    _this4._initialX = null;
	    _this4._initialY = null;
	    _this4._initialTop = null;
	    _this4._initialLeft = null;
	
	    if (!_this4._inFixed) {
	      if (_this4._dialog) {
	        _this4._manageFixedToListener(_this4._dialog, false);
	      }
	
	      _this4._manageFixedToListener(fixedTo, false);
	    }
	  };
	
	  this._setContainer = function (container) {
	    _this4._container = (0, _reactDom.findDOMNode)(container);
	    _this4._toggle = null;
	    if (!_this4._container) {
	      return;
	    }
	
	    var _props5 = _this4.props,
	        toggleQuery = _props5.toggleQuery,
	        onContextMenu = _props5.onContextMenu;
	
	    if (typeof toggleQuery === 'function') {
	      _this4._toggle = toggleQuery();
	    } else if (typeof toggleQuery === 'string') {
	      _this4._toggle = _this4._container.querySelector(toggleQuery);
	    } else {
	      _this4._toggle = toggleQuery;
	    }
	
	    if (!_this4._toggle && !onContextMenu && ("production") !== 'production') {
	      var error = new Error('Unable to find a toggle component with the provided `toggleQuery` and `toggle` element. \n' + ('`toggleQuery`: `' + toggleQuery + '`'));
	      error.toggleQuery = toggleQuery;
	      error.toggle = _this4.props.toggle;
	
	      throw error;
	    }
	
	    var node = _this4._container;
	    while (node) {
	      var fixed = window.getComputedStyle(node).position === 'fixed';
	      if (fixed && node.className.match(/md-dialog--(full-page|centered)/)) {
	        _this4._dialog = node;
	        return;
	      } else if (fixed && !node.classList.contains('md-layover-child')) {
	        _this4._inFixed = true;
	        return;
	      }
	
	      node = node.offsetParent;
	    }
	  };
	
	  this._initialFix = function () {
	    // Need to make a clone that disables any transitions to calculate positioning stuff
	    var clone = _this4._child.cloneNode(true);
	    clone.style.webkitTransform = 'none';
	    clone.style.transfrom = 'none';
	    clone.style.webkitTransition = 'none';
	    clone.style.transition = 'none';
	
	    _this4._child.parentNode.appendChild(clone);
	    var vp = (0, _viewport2.default)(clone);
	    var childHeight = clone.offsetHeight,
	        childWidth = clone.offsetWidth;
	
	    _this4._child.parentNode.removeChild(clone);
	
	    if (vp === true || !_this4._toggle || !_this4._child) {
	      return;
	    }
	
	    var _getAnchor2 = _this4._getAnchor(_this4.props),
	        x = _getAnchor2.x,
	        y = _getAnchor2.y;
	
	    var toggleHeight = void 0;
	    var toggleWidth = void 0;
	    if (_this4._contextRect) {
	      toggleHeight = _this4._contextRect.height;
	      toggleWidth = _this4._contextRect.width;
	    } else {
	      toggleHeight = _this4._toggle.offsetHeight;
	      toggleWidth = _this4._toggle.offsetWidth;
	    }
	
	    var addToTop = 0;
	    var addToLeft = 0;
	
	    // Android devices will never get this far because they consider the keyboard as part
	    // of the viewport, iOS will and cause it to be a giant negative number. *sigh*
	    // Prevent any additional vertical positioning for iOS
	    if (!_this4.props.fillViewportHeight && (!vp.top || !vp.bottom)) {
	      var multiplier = vp.top ? -1 : 1;
	      if (!vp.bottom && y === _VerticalAnchors2.default.OVERLAP) {
	        addToTop += toggleHeight;
	      } else if (y === _VerticalAnchors2.default.TOP || y === _VerticalAnchors2.default.BOTTOM) {
	        addToTop += multiplier * toggleHeight;
	      }
	
	      addToTop += multiplier * childHeight;
	
	      _this4._lastYFix = vp.top ? 'bottom' : 'top';
	    }
	
	    if (!_this4.props.fillViewportWidth && x !== _HorizontalAnchors2.default.CENTER && (!vp.left || !vp.right)) {
	      if (!vp.left && x === _HorizontalAnchors2.default.LEFT) {
	        addToLeft += toggleWidth + childWidth;
	        _this4._lastXFix = 'left';
	      } else if (!vp.left && x === _HorizontalAnchors2.default.INNER_LEFT) {
	        addToLeft += toggleWidth;
	        _this4._lastXFix = 'left';
	      } else if (!vp.right && x === _HorizontalAnchors2.default.RIGHT) {
	        addToLeft -= toggleWidth + childWidth;
	        _this4._lastXFix = 'right';
	      } else if (!vp.right && x === _HorizontalAnchors2.default.INNER_RIGHT) {
	        addToLeft -= toggleWidth;
	        _this4._lastXFix = 'right';
	      }
	    }
	
	    if (addToTop !== 0 || addToLeft !== 0) {
	      _this4._initialTop += addToTop;
	      _this4._initialLeft += addToLeft;
	
	      _this4.setState({ styles: _this4._mergeStyles({ top: _this4._initialTop, left: _this4._initialLeft }) });
	    }
	  };
	
	  this._fixateChild = function (child) {
	    _this4._child = (0, _reactDom.findDOMNode)(child);
	
	    if (_this4._child !== null) {
	      _this4._childComponent = _react2.default.Children.only(_this4.props.children);
	
	      // If child also has a ref callback, simulate the same thing
	      if (typeof _this4._childComponent.ref === 'function') {
	        _this4._childComponent.ref(child);
	      }
	
	      if (_this4.props.simplified || !_this4._child || !_this4._toggle && !_this4._contextRect) {
	        return;
	      }
	
	      if (_this4._dialog && _this4._dialog.classList.contains('md-dialog--centered')) {
	        return;
	      }
	
	      _this4._manageWindowResizeListener(true);
	      _this4._positionChild();
	    } else if (_this4._childComponent && typeof _this4._childComponent.ref === 'function') {
	      _this4._childComponent.ref(child);
	    }
	  };
	
	  this._positionChild = function () {
	    var centered = _this4.props.centered;
	
	    var anchor = _this4._getAnchor(_this4.props);
	    var rect = _this4._contextRect || _this4._toggle.getBoundingClientRect();
	    _this4._height = rect.height;
	    _this4._width = rect.width;
	    var styles = _this4._createStyles(anchor, centered, _this4._child, rect);
	    if (styles.top || styles.left) {
	      _this4._initialLeft = styles.left || _this4._initialLeft;
	      _this4._initialTop = styles.top || _this4._initialTop;
	      _this4.setState({ styles: _this4._mergeStyles(styles) }, _this4._initialFix);
	    } else {
	      _this4._initialFix();
	    }
	  };
	
	  this._handleResize = function () {
	    if (_this4.props.visible) {
	      _this4._positionChild();
	    }
	  };
	
	  this._handleScroll = function (e) {
	    if (!_this4.props.repositionOnScroll) {
	      _this4._manageFixedToListener(_this4.props.fixedTo, false);
	      _this4.props.onClose(e);
	    }
	
	    if (!_this4._ticking) {
	      requestAnimationFrame(function () {
	        return _this4._handleTick(e);
	      });
	    }
	
	    _this4._ticking = true;
	  };
	
	  this._handleTick = function (e) {
	    var _props6 = _this4.props,
	        fixedTo = _props6.fixedTo,
	        xThreshold = _props6.xThreshold,
	        yThreshold = _props6.yThreshold;
	
	    var vp = (0, _viewport2.default)(_this4._child);
	    if (vp !== true && vp.left && vp.right) {
	      var fixed = !_this4._contextRect && _this4._attemptFix(vp);
	      if (!fixed) {
	        _this4.props.onClose(e);
	        _this4._ticking = false;
	      }
	
	      return;
	    } else if ((0, _isOutOfBounds2.default)(fixedTo, _this4._child, _this4._toggle, yThreshold, xThreshold)) {
	      _this4.props.onClose(e);
	      _this4._ticking = false;
	      return;
	    }
	
	    var x = void 0;
	    var y = void 0;
	    if (_this4._dialog) {
	      var scroll = (0, _getScroll2.default)(_this4._dialog);
	      x = scroll.x;
	      y = scroll.y;
	    } else if (fixedTo !== window && (fixedTo.x || fixedTo.y)) {
	      x = (0, _getScroll2.default)(fixedTo.x || window).x;
	      y = (0, _getScroll2.default)(fixedTo.y || window).y;
	    } else {
	      var _scroll3 = (0, _getScroll2.default)(fixedTo);
	      x = _scroll3.x;
	      y = _scroll3.y;
	    }
	
	    var winX = void 0;
	    var winY = void 0;
	    // When using the additional fixedTo stuff, need to also keep track of the entire
	    // window's scrolling..
	    if (fixedTo !== window && !fixedTo.x && !fixedTo.y) {
	      var _scroll4 = (0, _getScroll2.default)(window);
	      winX = _scroll4.x;
	      winY = _scroll4.y;
	    }
	
	    var styles = _this4.state.styles;
	    var left = styles.left,
	        top = styles.top;
	
	    if (_this4._initialX !== x) {
	      left = _this4._initialX - x + _this4._initialLeft;
	    }
	
	    if (winX && _this4._initialWinX !== winX) {
	      left = _this4._initialWinX - winX + _this4._initialX;
	    }
	
	    if (_this4._initialY !== y) {
	      top = _this4._initialY - y + _this4._initialTop;
	    }
	
	    if (winY && _this4._initialWinY !== winY) {
	      top = _this4._initialWinY - winY + _this4._initialTop + (_this4._initialY - y);
	    }
	
	    if (styles.top !== top || styles.left !== left) {
	      _this4.setState({ styles: _this4._mergeStyles({ left: left, top: top }) }, function () {
	        _this4._ticking = false;
	      });
	    } else {
	      _this4._ticking = false;
	    }
	  };
	
	  this._handleOutsideClick = function (e) {
	    if (_this4._contextRect && _this4._child && !_this4._child.contains(e.target) || _this4._container && !_this4._container.contains(e.target)) {
	      _this4.props.onClose(e);
	    }
	  };
	
	  this._handleWindowResize = function (e) {
	    var _props7 = _this4.props,
	        onClose = _props7.onClose,
	        repositionOnResize = _props7.repositionOnResize;
	
	    if (repositionOnResize) {
	      _this4._handleResize();
	    } else {
	      onClose(e);
	      _this4._manageWindowResizeListener(false);
	    }
	  };
	
	  this._attemptFix = function (vp) {
	    var _getAnchor3 = _this4._getAnchor(_this4.props),
	        x = _getAnchor3.x,
	        y = _getAnchor3.y;
	
	    var centered = x === _HorizontalAnchors2.default.CENTER && y === _VerticalAnchors2.default.CENTER && _this4.props.centered;
	    if (centered || _this4._lastYFix === 'top' && !vp.top || _this4._lastYFix === 'bottom' && !vp.bottom) {
	      return false;
	    }
	
	    var toggleTop = _this4._toggle.getBoundingClientRect().top;
	    var toggleHeight = _this4._toggle.offsetHeight;
	    var childHeight = _this4._child.offsetHeight;
	
	    // Can;t fix if the child can't fit on the page based on the toggle's position
	
	    if (toggleTop + toggleHeight + childHeight > window.innerHeight) {
	      return false;
	    }
	
	    var _child$getBoundingCli = _this4._child.getBoundingClientRect(),
	        top = _child$getBoundingCli.top;
	
	    var newTop = _this4._initialTop;
	    var addToTop = childHeight * (vp.top ? -1 : 1);
	    if (y === _VerticalAnchors2.default.OVERLAP) {
	      addToTop += (vp.top ? 1 : -1) * toggleHeight;
	    } else if (y === _VerticalAnchors2.default.TOP || y === _VerticalAnchors2.default.BOTTOM) {
	      addToTop += (_this4._lastYFix === 'top' ? -1 : 1) * toggleHeight;
	    }
	
	    if (addToTop !== 0) {
	      newTop = top + addToTop;
	      _this4._lastYFix = vp.top ? 'bottom' : 'top';
	    }
	
	    if (newTop !== _this4._initialTop) {
	      _this4._initialTop = newTop;
	      var fixedTo = _this4.props.fixedTo;
	
	      var scrollEl = fixedTo;
	      if (fixedTo !== window && (fixedTo.y || fixedTo.x)) {
	        scrollEl = fixedTo.y || window;
	      }
	
	      _this4._initialY = (0, _getScroll2.default)(scrollEl).y;
	
	      _this4.setState({ styles: _this4._mergeStyles({ top: _this4._initialTop }) }, function () {
	        _this4._ticking = false;
	      });
	      return true;
	    }
	
	    return false;
	  };
	
	  this._handleContextMenu = function (e) {
	    var anchor = _this4._getAnchor(_this4.props);
	    var _props8 = _this4.props,
	        onContextMenu = _props8.onContextMenu,
	        preventContextMenu = _props8.preventContextMenu,
	        fixedTo = _props8.fixedTo,
	        sameWidth = _props8.sameWidth,
	        centered = _props8.centered,
	        visible = _props8.visible;
	
	    if (!onContextMenu) {
	      return;
	    }
	
	    _this4._contextRect = (0, _getSelectedTextPosition2.default)(e);
	    if (preventContextMenu && (!_this4._child || !_this4._child.contains(e.target))) {
	      e.preventDefault();
	    }
	
	    onContextMenu(e);
	    if (visible) {
	      _this4._init(fixedTo, anchor, sameWidth, centered, _this4._contextRect);
	    }
	  };
	};
	
	exports.default = Layover;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(7);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(5);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _themeColors = __webpack_require__(11);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _getCollapserStyles = __webpack_require__(129);
	
	var _getCollapserStyles2 = _interopRequireDefault(_getCollapserStyles);
	
	var _getField = __webpack_require__(8);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _controlled = __webpack_require__(15);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _keyCodes = __webpack_require__(14);
	
	var _anchorShape = __webpack_require__(28);
	
	var _anchorShape2 = _interopRequireDefault(_anchorShape);
	
	var _fixedToShape = __webpack_require__(19);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _AccessibleFakeInkedButton = __webpack_require__(24);
	
	var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	var _Collapse = __webpack_require__(55);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _FontIcon = __webpack_require__(12);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _getDeprecatedIcon = __webpack_require__(21);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _TileAddon = __webpack_require__(86);
	
	var _TileAddon2 = _interopRequireDefault(_TileAddon);
	
	var _ListItemText = __webpack_require__(168);
	
	var _ListItemText2 = _interopRequireDefault(_ListItemText);
	
	var _List = __webpack_require__(41);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Menu = __webpack_require__(56);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `ListItem` component is used for rendering a `li` tag with text and optional
	 * icons/avatars.
	 */
	var ListItem = function (_PureComponent) {
	  _inherits(ListItem, _PureComponent);
	
	  function ListItem(props) {
	    _classCallCheck(this, ListItem);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = { active: false };
	
	    if (typeof props.isOpen === 'undefined' && typeof props.visible === 'undefined') {
	      var defined = function defined(v) {
	        return typeof v !== 'undefined';
	      };
	      var _this$props = _this.props,
	          initiallyOpen = _this$props.initiallyOpen,
	          defaultOpen = _this$props.defaultOpen,
	          defaultVisible = _this$props.defaultVisible;
	
	      var visible = defined(initiallyOpen) ? initiallyOpen : defaultVisible;
	      visible = defined(defaultOpen) ? defaultOpen : visible;
	      visible = !!visible;
	
	      _this.state.visible = visible;
	    }
	    return _this;
	  }
	
	  ListItem.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.state.active) {
	      window.removeEventListener('click', this._handleOutsideClick);
	    }
	
	    if (this._touchTimeout) {
	      clearTimeout(this._touchTimeout);
	    }
	  };
	
	  /**
	   * A utility function to focus the `AccessibleFakeInkedButton` in the `ListItem` and also
	   * inject an ink to indicate focus.
	   */
	
	
	  /**
	   * A utility function to blur the `AccessibleFakeInkedButton` in the `ListItem`.
	   */
	
	
	  ListItem.prototype.render = function render() {
	    var _cn;
	
	    var _props = this.props,
	        style = _props.style,
	        className = _props.className,
	        tileStyle = _props.tileStyle,
	        tileClassName = _props.tileClassName,
	        contentStyle = _props.contentStyle,
	        contentClassName = _props.contentClassName,
	        leftNodeStyle = _props.leftNodeStyle,
	        leftNodeClassName = _props.leftNodeClassName,
	        rightNodeStyle = _props.rightNodeStyle,
	        rightNodeClassName = _props.rightNodeClassName,
	        primaryTextStyle = _props.primaryTextStyle,
	        primaryTextClassName = _props.primaryTextClassName,
	        secondaryTextStyle = _props.secondaryTextStyle,
	        secondaryTextClassName = _props.secondaryTextClassName,
	        nestedListStyle = _props.nestedListStyle,
	        nestedListClassName = _props.nestedListClassName,
	        nestedListHeightRestricted = _props.nestedListHeightRestricted,
	        disabled = _props.disabled,
	        leftIcon = _props.leftIcon,
	        leftAvatar = _props.leftAvatar,
	        inset = _props.inset,
	        rightIcon = _props.rightIcon,
	        rightAvatar = _props.rightAvatar,
	        primaryText = _props.primaryText,
	        secondaryText = _props.secondaryText,
	        threeLines = _props.threeLines,
	        children = _props.children,
	        nestedItems = _props.nestedItems,
	        prependNested = _props.prependNested,
	        active = _props.active,
	        activeClassName = _props.activeClassName,
	        activeBoxStyle = _props.activeBoxStyle,
	        activeBoxClassName = _props.activeBoxClassName,
	        animateNestedItems = _props.animateNestedItems,
	        expanderIcon = _props.expanderIcon,
	        expanderLeft = _props.expanderLeft,
	        component = _props.component,
	        ItemComponent = _props.itemComponent,
	        itemProps = _props.itemProps,
	        tileProps = _props.tileProps,
	        passPropsToItem = _props.passPropsToItem,
	        ariaSize = _props['aria-setsize'],
	        ariaPos = _props['aria-posinset'],
	        isOpen = _props.isOpen,
	        expanderIconChildren = _props.expanderIconChildren,
	        expanderIconClassName = _props.expanderIconClassName,
	        propVisible = _props.visible,
	        defaultVisible = _props.defaultVisible,
	        itemRef = _props.itemRef,
	        defaultOpen = _props.defaultOpen,
	        initiallyOpen = _props.initiallyOpen,
	        props = _objectWithoutProperties(_props, ['style', 'className', 'tileStyle', 'tileClassName', 'contentStyle', 'contentClassName', 'leftNodeStyle', 'leftNodeClassName', 'rightNodeStyle', 'rightNodeClassName', 'primaryTextStyle', 'primaryTextClassName', 'secondaryTextStyle', 'secondaryTextClassName', 'nestedListStyle', 'nestedListClassName', 'nestedListHeightRestricted', 'disabled', 'leftIcon', 'leftAvatar', 'inset', 'rightIcon', 'rightAvatar', 'primaryText', 'secondaryText', 'threeLines', 'children', 'nestedItems', 'prependNested', 'active', 'activeClassName', 'activeBoxStyle', 'activeBoxClassName', 'animateNestedItems', 'expanderIcon', 'expanderLeft', 'component', 'itemComponent', 'itemProps', 'tileProps', 'passPropsToItem', 'aria-setsize', 'aria-posinset', 'isOpen', 'expanderIconChildren', 'expanderIconClassName', 'visible', 'defaultVisible', 'itemRef', 'defaultOpen', 'initiallyOpen']);
	
	    var _context = this.context,
	        cascadingId = _context.cascadingId,
	        cascadingMenu = _context.cascadingMenu,
	        cascadingAnchor = _context.cascadingAnchor,
	        cascadingFixedTo = _context.cascadingFixedTo;
	
	    var visible = (0, _getField2.default)(this.props, this.state, 'visible');
	    if (typeof isOpen !== 'undefined') {
	      visible = isOpen;
	    }
	
	    var leftNode = _react2.default.createElement(_TileAddon2.default, {
	      key: 'left-addon',
	      style: leftNodeStyle,
	      className: leftNodeClassName,
	      active: active,
	      activeClassName: activeClassName,
	      icon: leftIcon,
	      avatar: leftAvatar
	    });
	
	    var rightNode = _react2.default.createElement(_TileAddon2.default, {
	      key: 'right-addon',
	      style: rightNodeStyle,
	      className: rightNodeClassName,
	      active: active,
	      activeClassName: activeClassName,
	      icon: rightIcon,
	      avatar: rightAvatar
	    });
	
	    var nestedList = void 0;
	    if (nestedItems) {
	      if (!cascadingMenu) {
	        nestedList = _react2.default.createElement(
	          _Collapse2.default,
	          { collapsed: !visible, animate: animateNestedItems },
	          _react2.default.createElement(
	            _List2.default,
	            { style: nestedListStyle, className: nestedListClassName },
	            nestedItems
	          )
	        );
	      }
	
	      var icon = _react2.default.Children.only((0, _getDeprecatedIcon2.default)(expanderIconClassName, expanderIconChildren, expanderIcon));
	      var collapser = _react2.default.createElement(_TileAddon2.default, {
	        key: 'expander-addon',
	        icon: _react2.default.cloneElement(icon, {
	          className: (0, _getCollapserStyles2.default)({ flipped: visible }, icon.props.className)
	        }),
	        avatar: null
	      });
	
	      if (expanderLeft) {
	        if (!leftIcon && !leftAvatar) {
	          leftNode = collapser;
	        }
	      } else if (!rightIcon && !rightAvatar) {
	        rightNode = collapser;
	      }
	    }
	
	    var icond = !!leftIcon || !!rightIcon || !!nestedItems;
	    var avatard = !!leftAvatar || !!rightAvatar;
	
	    var tile = _react2.default.createElement(
	      _AccessibleFakeInkedButton2.default,
	      _extends({}, tileProps, passPropsToItem ? undefined : props, {
	        component: component,
	        __SUPER_SECRET_REF__: this._setTile,
	        key: 'tile',
	        onClick: this._handleClick,
	        onMouseOver: this._handleMouseOver,
	        onMouseLeave: this._handleMouseLeave,
	        onTouchStart: this._handleTouchStart,
	        onTouchEnd: this._handleTouchEnd,
	        onKeyDown: this._handleKeyDown,
	        onKeyUp: this._handleKeyUp,
	        disabled: disabled,
	        style: tileStyle,
	        className: (0, _classnames2.default)('md-list-tile', {
	          'md-list-tile--active': this.state.active && !this._touched,
	          'md-list-tile--icon': !secondaryText && icond && !avatard,
	          'md-list-tile--avatar': !secondaryText && avatard,
	          'md-list-tile--two-lines': secondaryText && !threeLines,
	          'md-list-tile--three-lines': secondaryText && threeLines,
	          'md-list-item--inset': inset && !leftIcon && !leftAvatar
	        }, (0, _themeColors2.default)({ disabled: disabled, text: true }), tileClassName),
	        'aria-expanded': nestedList && !cascadingMenu ? visible : null
	      }),
	      leftNode,
	      _react2.default.createElement(_ListItemText2.default, {
	        active: active,
	        activeClassName: activeClassName,
	        disabled: disabled,
	        primaryText: primaryText,
	        secondaryText: secondaryText,
	        threeLines: threeLines,
	        style: contentStyle,
	        className: (0, _classnames2.default)({
	          'md-tile-content--left-icon': leftIcon || expanderLeft && nestedItems,
	          'md-tile-content--left-avatar': leftAvatar,
	          'md-tile-content--right-padding': rightIcon || rightAvatar
	        }, contentClassName),
	        primaryTextStyle: primaryTextStyle,
	        primaryTextClassName: primaryTextClassName,
	        secondaryTextStyle: secondaryTextStyle,
	        secondaryTextClassName: secondaryTextClassName
	      }),
	      rightNode,
	      children
	    );
	
	    var sharedProps = _extends({}, itemProps, passPropsToItem ? props : undefined, {
	      style: Object.assign({}, style, active ? activeBoxStyle : null),
	      className: (0, _classnames2.default)('md-list-item', (_cn = {
	        'md-list-item--nested-container': nestedItems
	      }, _cn[activeBoxClassName] = activeBoxClassName && active, _cn), className),
	      'aria-setsize': ariaSize,
	      'aria-posinset': ariaPos,
	      ref: this._setContainer
	    });
	    if (cascadingMenu && nestedItems) {
	      return _react2.default.createElement(
	        _Menu2.default,
	        _extends({
	          id: cascadingId,
	          visible: visible,
	          onClose: this._handleClick,
	          toggle: tile,
	          block: true,
	          simplified: false,
	          anchor: cascadingAnchor,
	          belowAnchor: null,
	          position: _Menu2.default.Positions.BELOW,
	          component: ItemComponent,
	          listStyle: nestedListStyle,
	          listClassName: nestedListClassName,
	          listHeightRestricted: nestedListHeightRestricted
	        }, sharedProps, {
	          fixedTo: cascadingFixedTo
	        }),
	        nestedItems
	      );
	    }
	
	    return _react2.default.createElement(
	      ItemComponent,
	      sharedProps,
	      prependNested ? nestedList : null,
	      tile,
	      prependNested ? null : nestedList
	    );
	  };
	
	  return ListItem;
	}(_react.PureComponent);
	
	ListItem.propTypes = {
	  /**
	   * An optional style to apply to the `li` tag.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `li` tag.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the `.md-list-tile`.
	   *
	   * @see {@link #component}
	   */
	  tileStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `.md-list-tile`.
	   *
	   * @see {@link #component}
	   */
	  tileClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the div that surrounds the `primaryText` and `secondaryText`
	   * nodes.
	   */
	  contentStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the div that surrounds the `primaryText` and `secondaryText`
	   * nodes.
	   */
	  contentClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the element that is rendered before content node.
	   */
	  leftNodeStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the element that is rendered before content node.
	   */
	  leftNodeClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the element that is rendered after content node.
	   */
	  rightNodeStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the element that is rendered after content node.
	   */
	  rightNodeClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the div surrounding the `primaryText`.
	   */
	  primaryTextStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the div surrounding the `primaryText`.
	   */
	  primaryTextClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the div surrounding the `secondaryText`.
	   */
	  secondaryTextStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the div surrounding the `secondaryText`.
	   */
	  secondaryTextClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the nested `List` that gets created when using `nestedItems`.
	   */
	  nestedListStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the nested `List` that gets created when using `nestedItems`.
	   */
	  nestedListClassName: _propTypes2.default.string,
	
	  /**
	   * Boolean if the nested `List` in a cascading menu should be restricted.
	   */
	  nestedListHeightRestricted: _propTypes2.default.bool,
	
	  /**
	   * Any additional children to display in the `.md-list-tile`. If you use this prop,
	   * you will most likely need to override the `height` for the `.md-list-tile--icon`,
	   * `.md-list-tile--avatar`, `.md-list-tile--two-lines`, and/or `.md-list-tile--three-lines`
	   * to get it to display correctly unless the children are positioned `absolute`.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * Boolean if the `ListItem` is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional tab index for the `.md-list-tile`. If omitted, it will default to the
	   * `AccessibleFakeButton`'s `tabIndex` default prop value.
	   */
	  tabIndex: _propTypes2.default.number,
	
	  /**
	   * The primary text to display. This will only be rendered as a single line. Any overflown
	   * text will be converted to ellipsis.
	   */
	  primaryText: _propTypes2.default.node.isRequired,
	
	  /**
	   * An optional secondary text to display below the `primaryText`. This can be an additional
	   * one or two lines. Like the `primaryText`, and overflown text will be converted to ellipsis.
	   *
	   * You must set the `threeLines` prop to `true` if you want this to be displayed as two lines.
	   */
	  secondaryText: _propTypes2.default.node,
	
	  /**
	   * An optional `FontIcon` to display to the left of the text.
	   */
	  leftIcon: _propTypes2.default.node,
	
	  /**
	   * An optional `Avatar` to display to the left of the text. If you have a mixed `List` of
	   * `FontIcon` and `Avatar`, it is recommended to set the `iconSized` prop on the `Avatar` to
	   * `true` so that the `Avatar` will be scaled down to the `FontIcon` size.
	   */
	  leftAvatar: _propTypes2.default.node,
	
	  /**
	   * An optional `FontIcon` to display to the right of the text.
	   */
	  rightIcon: _propTypes2.default.node,
	
	  /**
	   * An optional `Avatar` to display to the right of the text. If you have a mixed `List` of
	   * `FontIcon` and `Avatar`, it is recommended to set the `iconSized` prop on the `Avatar` to
	   * `true` so that the `Avatar` will be scaled down to the `FontIcon` size.
	   */
	  rightAvatar: _propTypes2.default.node,
	
	  /**
	   * Boolean if the list item should be inset as if there is a `leftIcon` or a `leftAvatar`.
	   * This is used for some lists where only a parent contains the icon.
	   */
	  inset: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `secondaryText` should span two lines instead of one. This will include
	   * three lines of text in total when including the `primaryText`.
	   */
	  threeLines: _propTypes2.default.bool,
	
	  /**
	   * The component to render the `.md-list-tile` as. This is mostly useful if you
	   * want to use the `ListItem` for navigation and working with the `react-router`'s `Link`
	   * component.
	   *
	   * This prop is **not** the top-most element of the `ListItem` component. To change the
	   * top-most element, see the `itemComponent` prop.
	   *
	   * @see {@link #itemComponent}
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	  /**
	   * The component to render the top-most element of the `ListItem` component. This is the
	   * `.md-list-item` and defaults to the `<li>` element.
	   *
	   * @see {@link #component}
	   * @see {@link #itemProps}
	   */
	  itemComponent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	  /**
	   * An optional ref callback to get reference to the top-most element of the `ListItem` component.
	   * Just like other refs, this will provide null when it unmounts.
	   */
	  itemRef: _propTypes2.default.func,
	
	  /**
	   * An optional list of `ListItem`, `ListItemControl`, `Divider`, or `Subheader` components
	   * to render in a nested list. This will inject an expander icon to the right of the text
	   * in the `.md-list-tile` that rotates 180 degrees when open.
	   *
	   * The nested items will be visible once the user clicks on the `ListItem`.
	   *
	   * @see {@link #visible}
	   */
	  nestedItems: _propTypes2.default.arrayOf(_propTypes2.default.node),
	
	  /**
	   * An optional parameter determining whether `nestedItems` should be placed before or after `ListItemText`
	   */
	  prependNested: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `nestedItems` are visible by default.
	   */
	  defaultVisible: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `nestedItems` are visible. This will make the `nestedItems` controlled
	   * and require the `onClick` function to be defined.
	   *
	   * @see {@link #defaultVisible}
	   */
	  visible: (0, _controlled2.default)(_propTypes2.default.bool, 'onClick', 'defaultVisible'),
	
	  /**
	   * An icon to use for the expander icon when there are nested items.
	   */
	  expanderIcon: _propTypes2.default.element,
	
	  /**
	   * Boolean if the expander icon should appear as the left icon instead of the right.
	   */
	  expanderLeft: _propTypes2.default.bool,
	
	  /**
	   * An optional function to call when the `.md-list-tile` is clicked. This is required if the
	   * `visible` prop is defined.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `.md-list-tile` triggers the `mouseover` event.
	   */
	  onMouseOver: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `.md-list-tile` triggers the `mouseleave` event.
	   */
	  onMouseLeave: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `.md-list-tile` triggers the `touchstart` event.
	   */
	  onTouchStart: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `.md-list-tile` triggers the `touchend` event.
	   */
	  onTouchEnd: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `.md-list-tile` triggers the `keydown` event.
	   */
	  onKeyDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `.md-list-tile` triggers the `keyup` event.
	   */
	  onKeyUp: _propTypes2.default.func,
	
	  /**
	   * Boolean if the `ListItem` is currently active. This will apply the `activeClassName` prop
	   * to the `leftIcon`, `rightIcon`, and the `primaryText`.
	   */
	  active: _propTypes2.default.bool,
	
	  /**
	   * The className to apply to the `leftIcon`, `rightIcon`, and `primaryText` when the `active`
	   * prop is `true`.
	   */
	  activeClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the top-most element of the `ListItem` component (`.md-list-item`)
	   * when the `active` prop is `true`.
	   */
	  activeBoxStyle: _propTypes2.default.object,
	
	  /**
	   * The className to apply to the top-most element of the `ListItem` component (`.md-list-item`)
	   * when the `active` prop is `true`.
	   */
	  activeBoxClassName: _propTypes2.default.string,
	
	  /**
	   * Boolean if the nested items should animate when they appear or disappear.
	   */
	  animateNestedItems: _propTypes2.default.bool,
	
	  /**
	   * Defines the number of items in the list. This is only required when all items in the
	   * list are not present in the DOM.
	   *
	   * @see https://www.w3.org/TR/wai-aria/states_and_properties#aria-setsize
	   */
	  'aria-setsize': _propTypes2.default.number,
	
	  /**
	   * Defines the items position in the list. This is only required when all items in the list
	   * are not present in the DOM. The custom validation just requires this prop if the `aria-setsize`
	   * prop is defined as a helpful reminder.
	   *
	   * @see https://www.w3.org/TR/wai-aria/states_and_properties#aria-posinset
	   */
	  'aria-posinset': function ariaPosinset(props, propName) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    var validator = _propTypes2.default.number;
	    if (typeof props['aria-setsize'] !== 'undefined') {
	      validator = validator.isRequired;
	    }
	
	    return validator.apply(undefined, [props, propName].concat(args));
	  },
	
	  /**
	   * Any additional props you would like to supply to the surrounding `<li>` tag for the `ListItem`.
	   * By default, all props will be provided to the inner `AccessibleFakeButton`. If the `passPropsToItem`
	   * prop is enabled, the remaining props will be provided to the `<li>` tag instead and this prop
	   * is probably useless.
	   */
	  itemProps: _propTypes2.default.object,
	
	  /**
	   * Any additional props you would like to add to the inner `AccessibleFakeButton`. By default, all the
	   * remaining props will be provided to the `AccessibleFakeButton`, so this prop is probably useless.
	   * Enabling the `passPropsToItem` prop will change the default behavior so that the remaining props
	   * are provided to the surrounding `<li>` node instead and this prop becomes useful.
	   */
	  tileProps: _propTypes2.default.object,
	
	  /**
	   * All the remaining props should be passed to the surrounding `<li>` node instead of the `AccessibleFakeButton`.
	   *
	   * > NOTE: This will most likely become the default in the next *major* release. Migration warnings will be added
	   * if that is the case.
	   */
	  passPropsToItem: _propTypes2.default.bool,
	  expanderIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `expanderIcon` instead'),
	  expanderIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `expanderIcon` instead'),
	  initiallyOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `defaultVisible` instead'),
	  defaultOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `defaultVisible` instead'),
	  isOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `visible` instead')
	};
	ListItem.defaultProps = {
	  animateNestedItems: true,
	  activeClassName: 'md-text--theme-primary',
	  component: 'div',
	  itemComponent: 'li',
	  expanderIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'keyboard_arrow_down'
	  )
	};
	ListItem.contextTypes = {
	  cascadingId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  cascadingMenu: _propTypes2.default.bool,
	  cascadingAnchor: _anchorShape2.default,
	  cascadingFixedTo: _fixedToShape2.default
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.focus = function () {
	    if (_this2._tile) {
	      _this2._tile.focus();
	    }
	  };
	
	  this.blur = function () {
	    if (_this2._tile) {
	      _this2._tile.blur();
	    }
	  };
	
	  this._setTile = function (tile) {
	    if (tile) {
	      _this2._tile = tile;
	      _this2._tileNode = (0, _reactDom.findDOMNode)(tile);
	    }
	  };
	
	  this._setContainer = function (container) {
	    var itemRef = _this2.props.itemRef;
	
	    if (container) {
	      _this2._container = (0, _reactDom.findDOMNode)(container);
	    }
	    if (itemRef) {
	      itemRef(container ? _this2._container : null);
	    }
	  };
	
	  this._handleOutsideClick = function (e) {
	    if (_this2._container && !_this2._container.contains(e.target)) {
	      window.removeEventListener('click', _this2._handleOutsideClick);
	      _this2.setState({ active: false });
	    }
	  };
	
	  this._handleClick = function (e) {
	    if (_this2.props.onClick) {
	      _this2.props.onClick(e);
	    }
	
	    if (typeof _this2.state.visible !== 'undefined') {
	      _this2.setState({ visible: !_this2.state.visible });
	    }
	  };
	
	  this._handleMouseOver = function (e) {
	    if (_this2.props.onMouseOver) {
	      _this2.props.onMouseOver(e);
	    }
	
	    if (!_this2.props.disabled) {
	      _this2.setState({ active: true });
	    }
	  };
	
	  this._handleMouseLeave = function (e) {
	    if (_this2.props.onMouseLeave) {
	      _this2.props.onMouseLeave(e);
	    }
	
	    if (!_this2.props.disabled) {
	      _this2.setState({ active: false });
	    }
	  };
	
	  this._handleTouchStart = function (e) {
	    if (_this2.props.onTouchStart) {
	      _this2.props.onTouchStart(e);
	    }
	
	    _this2._touched = true;
	
	    _this2.setState({ active: true, touchedAt: Date.now() });
	  };
	
	  this._handleTouchEnd = function (e) {
	    if (_this2.props.onTouchEnd) {
	      _this2.props.onTouchEnd(e);
	    }
	
	    var time = Date.now() - _this2.state.touchedAt;
	    _this2._touchTimeout = setTimeout(function () {
	      _this2._touchTimeout = null;
	
	      _this2.setState({ active: false });
	    }, time > 450 ? 0 : 450 - time);
	  };
	
	  this._handleKeyUp = function (e) {
	    if (_this2.props.onKeyUp) {
	      _this2.props.onKeyUp(e);
	    }
	
	    if ((e.which || e.keyCode) === _keyCodes.TAB) {
	      window.addEventListener('click', _this2._handleOutsideClick);
	      _this2.setState({ active: true });
	    }
	  };
	
	  this._handleKeyDown = function (e) {
	    if (_this2.props.onKeyDown) {
	      _this2.props.onKeyDown(e);
	    }
	
	    if ((e.which || e.keyCode) === _keyCodes.TAB) {
	      window.removeEventListener('click', _this2._handleOutsideClick);
	      _this2.setState({ active: false });
	    }
	  };
	};
	
	exports.default = ListItem;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `TileAddon` component is used to render either a `FontIcon` or an `Avatar`
	 * next to the `ListTileText` for a `ListItem`.
	 */
	var TileAddon = function (_PureComponent) {
	  _inherits(TileAddon, _PureComponent);
	
	  function TileAddon() {
	    _classCallCheck(this, TileAddon);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  TileAddon.prototype.render = function render() {
	    var _cn;
	
	    var _props = this.props,
	        icon = _props.icon,
	        avatar = _props.avatar,
	        active = _props.active,
	        activeClassName = _props.activeClassName,
	        style = _props.style,
	        className = _props.className;
	
	    if (!icon && !avatar) {
	      return null;
	    }
	
	    var avatarIcon = false;
	    if (avatar) {
	      var avatarChild = _react2.default.Children.only(avatar);
	      if (avatarChild.props.iconSized) {
	        avatarIcon = true;
	      }
	    }
	    return _react2.default.createElement(
	      'div',
	      {
	        style: style,
	        className: (0, _classnames2.default)('md-tile-addon', (_cn = {
	          'md-tile-addon--icon': icon || avatarIcon,
	          'md-tile-addon--avatar': avatar && !avatarIcon
	        }, _cn[activeClassName] = active, _cn), className)
	      },
	      icon || avatar
	    );
	  };
	
	  return TileAddon;
	}(_react.PureComponent);
	
	TileAddon.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  active: _propTypes2.default.bool,
	  activeClassName: _propTypes2.default.string,
	  icon: _propTypes2.default.node,
	  avatar: _propTypes2.default.node
	};
	exports.default = TileAddon;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(5);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _isRequiredForA11y = __webpack_require__(16);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _keyCodes = __webpack_require__(14);
	
	var _getField = __webpack_require__(8);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _themeColors = __webpack_require__(11);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _oneRequiredForA11y = __webpack_require__(175);
	
	var _oneRequiredForA11y2 = _interopRequireDefault(_oneRequiredForA11y);
	
	var _capitalizeFirst = __webpack_require__(931);
	
	var _capitalizeFirst2 = _interopRequireDefault(_capitalizeFirst);
	
	var _AccessibleFakeInkedButton = __webpack_require__(24);
	
	var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	var _FontIcon = __webpack_require__(12);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _SwitchTrack = __webpack_require__(897);
	
	var _SwitchTrack2 = _interopRequireDefault(_SwitchTrack);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Prevents a second warning from appearing when using the deprecated or a11y required
	 * props by using the `__superSecretProp`.... So secret!
	 */
	function preventDouble(validator) {
	  return function validate(props, propName) {
	    for (var _len = arguments.length, others = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      others[_key - 2] = arguments[_key];
	    }
	
	    var err = validator.apply(undefined, [props, propName].concat(others));
	    if (err && props.__superSecreteProp) {
	      err = null;
	    }
	
	    return err;
	  };
	}
	
	/**
	 * The `SelectionControl` component is used to render any of the `Radio`, `Checkbox`, or `Switch`
	 * selection control type. This component might eventually replace all three since they use this
	 * anyways. I am not sure yet though.
	 */
	
	var SelectionControl = function (_PureComponent) {
	  _inherits(SelectionControl, _PureComponent);
	
	  function SelectionControl(props) {
	    _classCallCheck(this, SelectionControl);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));
	
	    _this._setInput = function (input) {
	      _this._input = input;
	    };
	
	    _this._setControl = function (control) {
	      _this._control = control;
	    };
	
	    _this._setContainer = function (container) {
	      _this._container = container;
	    };
	
	    _this._getIcon = function () {
	      var _this$props = _this.props,
	          checkedIcon = _this$props.checkedIcon,
	          uncheckedIcon = _this$props.uncheckedIcon,
	          type = _this$props.type;
	
	      var checked = (0, _getField2.default)(_this.props, _this.state, 'checked');
	      if (checkedIcon || uncheckedIcon) {
	        return checked ? checkedIcon : uncheckedIcon;
	      }
	
	      var prefix = (checked ? '' : 'un') + 'checked' + (0, _capitalizeFirst2.default)(type) + 'Icon';
	      var iconClassName = _this.props[prefix + 'ClassName'];
	      var children = _this.props[prefix + 'Children'];
	
	      if (iconClassName || children) {
	        return _react2.default.createElement(
	          _FontIcon2.default,
	          { iconClassName: iconClassName, inherit: true },
	          children
	        );
	      }
	
	      var icon = _this.props[prefix];
	      return icon ? _react2.default.cloneElement(icon, { inherit: true }) : null;
	    };
	
	    _this._handleKeyDown = function (e) {
	      if (_this.props.onKeyDown) {
	        _this.props.onKeyDown(e);
	      }
	
	      var key = e.which || e.keyCode;
	      if (key === _keyCodes.SPACE) {
	        _this._input.click();
	      }
	    };
	
	    _this._handleChange = function (e) {
	      var _this$props2 = _this.props,
	          type = _this$props2.type,
	          onChange = _this$props2.onChange;
	
	      var checked = !(0, _getField2.default)(_this.props, _this.state, 'checked');
	      if (onChange) {
	        onChange(type === 'radio' ? e.target.value : checked, e);
	      }
	
	      if (typeof _this.props.checked === 'undefined') {
	        _this.setState({ checked: checked });
	      }
	    };
	
	    _this.state = {};
	    if (typeof props.checked === 'undefined') {
	      _this.state.checked = !!props.defaultChecked;
	    }
	    return _this;
	  }
	
	  /**
	   * Gets the current checked value from the selection control. This is used when you have
	   * an uncontrolled selection control and simply need the checked state from a ref callback.
	   *
	   * @return {boolean} the checked state for the selection control.\
	   */
	
	
	  SelectionControl.prototype.render = function render() {
	    var _props = this.props,
	        id = _props.id,
	        style = _props.style,
	        className = _props.className,
	        inline = _props.inline,
	        type = _props.type,
	        name = _props.name,
	        value = _props.value,
	        disabled = _props.disabled,
	        labelBefore = _props.labelBefore,
	        tabIndex = _props.tabIndex,
	        inkDisabled = _props.inkDisabled,
	        disabledInteractions = _props.disabledInteractions,
	        ariaLabel = _props['aria-label'],
	        ariaLabelledBy = _props['aria-labelledby'],
	        ariaDescribedBy = _props['aria-describedby'],
	        propLabel = _props.label,
	        propChildren = _props.checked,
	        onChange = _props.onChange,
	        tooltip = _props.tooltip,
	        checkedCheckboxIcon = _props.checkedCheckboxIcon,
	        uncheckedCheckboxIcon = _props.uncheckedCheckboxIcon,
	        checkedRadioIcon = _props.checkedRadioIcon,
	        uncheckedRadioIcon = _props.uncheckedRadioIcon,
	        __superSecreteProp = _props.__superSecreteProp,
	        checkedIcon = _props.checkedIcon,
	        uncheckedIcon = _props.uncheckedIcon,
	        checkedRadioIconChildren = _props.checkedRadioIconChildren,
	        checkedRadioIconClassName = _props.checkedRadioIconClassName,
	        uncheckedRadioIconChildren = _props.uncheckedRadioIconChildren,
	        uncheckedRadioIconClassName = _props.uncheckedRadioIconClassName,
	        checkedCheckboxIconChildren = _props.checkedCheckboxIconChildren,
	        checkedCheckboxIconClassName = _props.checkedCheckboxIconClassName,
	        uncheckedCheckboxIconChildren = _props.uncheckedCheckboxIconChildren,
	        uncheckedCheckboxIconClassName = _props.uncheckedCheckboxIconClassName,
	        props = _objectWithoutProperties(_props, ['id', 'style', 'className', 'inline', 'type', 'name', 'value', 'disabled', 'labelBefore', 'tabIndex', 'inkDisabled', 'disabledInteractions', 'aria-label', 'aria-labelledby', 'aria-describedby', 'label', 'checked', 'onChange', 'tooltip', 'checkedCheckboxIcon', 'uncheckedCheckboxIcon', 'checkedRadioIcon', 'uncheckedRadioIcon', '__superSecreteProp', 'checkedIcon', 'uncheckedIcon', 'checkedRadioIconChildren', 'checkedRadioIconClassName', 'uncheckedRadioIconChildren', 'uncheckedRadioIconClassName', 'checkedCheckboxIconChildren', 'checkedCheckboxIconClassName', 'uncheckedCheckboxIconChildren', 'uncheckedCheckboxIconClassName']);
	
	    var checked = (0, _getField2.default)(this.props, this.state, 'checked');
	    var isSwitch = type === 'switch';
	    var label = this.props.label && _react2.default.createElement(
	      'span',
	      { id: id + '-label' },
	      this.props.label
	    );
	
	    var control = void 0;
	    if (isSwitch) {
	      control = _react2.default.createElement(_SwitchTrack2.default, { disabled: disabled, checked: checked });
	    } else {
	      control = _react2.default.createElement(
	        _AccessibleFakeInkedButton2.default,
	        {
	          inkDisabled: inkDisabled,
	          disabledInteractions: disabledInteractions,
	          role: type,
	          className: (0, _classnames2.default)('md-selection-control-toggle md-btn md-btn--icon', (0, _themeColors2.default)({
	            disabled: disabled,
	            hint: !checked,
	            secondary: checked
	          })),
	          'aria-checked': checked,
	          'aria-label': ariaLabel,
	          'aria-labelledby': ariaLabelledBy || id + '-label',
	          'aria-describedby': ariaDescribedBy,
	          tabIndex: tabIndex,
	          disabled: disabled
	        },
	        tooltip,
	        this._getIcon()
	      );
	    }
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, props, {
	        style: style,
	        className: (0, _classnames2.default)('md-selection-control-container', {
	          'md-selection-control-container--inline': inline,
	          'md-switch-container': isSwitch
	        }, className),
	        onKeyDown: this._handleKeyDown
	      }),
	      _react2.default.createElement('input', {
	        ref: this._setInput,
	        id: id,
	        type: isSwitch ? 'checkbox' : type,
	        checked: checked,
	        onChange: this._handleChange,
	        disabled: disabled,
	        className: 'md-selection-control-input',
	        name: name,
	        value: value,
	        'aria-hidden': true
	      }),
	      _react2.default.createElement(
	        'label',
	        {
	          htmlFor: id,
	          className: (0, _classnames2.default)('md-selection-control-label', {
	            'md-pointer--hover': !disabled
	          }, (0, _themeColors2.default)({ disabled: disabled, text: !disabled }))
	        },
	        labelBefore && label,
	        control,
	        !labelBefore && label
	      )
	    );
	  };
	
	  _createClass(SelectionControl, [{
	    key: 'checked',
	    get: function get() {
	      return (0, _getField2.default)(this.props, this.state, 'checked');
	    }
	  }]);
	
	  return SelectionControl;
	}(_react.PureComponent);
	
	SelectionControl.propTypes = {
	  /**
	   * An id to use with the selection control. This is used for accessibility and so that the label
	   * triggers the selection control toggle.
	   */
	  id: preventDouble((0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]))),
	
	  /**
	   * An optional label to apply to the checkbox when there is no visible label.
	   */
	  'aria-label': (0, _oneRequiredForA11y2.default)(_propTypes2.default.string, 'label', 'aria-labelledby'),
	
	  /**
	   * An optional id that points to a label for the selection control when there is no visible label.
	   */
	  'aria-labelledby': _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id of an element that describes this selection control.
	   * In the case of a fieldset, this should be the id of the fieldset legend which ensures
	   * screen readers provides additional context about the selection control
	   */
	  'aria-describedby': _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the selection control's container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the selection control's container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The type of selection control to render.
	   */
	  type: _propTypes2.default.oneOf(['checkbox', 'radio', 'switch']).isRequired,
	
	  /**
	   * A label to display with the selection control. This is required for accessibility and triggering
	   * the toggle.
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * Boolean if the label should appear before the checkbox/radio icon or switch.
	   */
	  labelBefore: _propTypes2.default.bool,
	
	  /**
	   * A name to use for the `SelectionControl`. This is required for accessibility. If the `type`
	   * is a `checkbox` and it is part of a group, it is recommended to make this a string ending
	   * in `[]` so that the value can be found from `document.querySelector('input[name="someName[]"]').value`.
	   */
	  name: preventDouble((0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]))),
	
	  /**
	   * Boolean if the `Radio` is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * A function to call when the `SelectionControl` triggers the `change` event. The `onChange`
	   * callback will either include:
	   * - the currently changed radio's value
	   * - the next checked state for the `Switch` or `Checkbox`.
	   *
	   * as the first parameter followed by the change event.
	   *
	   * ```js
	   * // Radio
	   * onChange(changeEvent.target.value, changeEvent);
	   *
	   * // Checkbox or Switch
	   * onChange(changeEvent.target.checked, changeEvent);
	   * ```
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `keydown` event is triggered.
	   */
	  onKeyDown: _propTypes2.default.func,
	
	  /**
	   * The value for the `SelectionControl`. It is not required for `Checkbox` and `Switch`,
	   * but it is recommended.
	   */
	  value: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * A boolean if the `SelectionControl` is currently checked. This _really_ makes the `onChange`
	   * prop required, but since there are cases you might want to have the `onChange` listener on a
	   * `fieldset` or something above the component, it is never set to `required`. It will however
	   * prevent updates if there is no change listener.
	   */
	  checked: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `Checkbox` or `Switch` are checked by default. This prop is invalid for a
	   * `Radio`.
	   */
	  defaultChecked: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `SelectionControl` should be displayed inline instead of a block.
	   */
	  inline: _propTypes2.default.bool,
	
	  /**
	   * The icon to use for a checked `checkbox` selection control.
	   */
	  checkedCheckboxIcon: _propTypes2.default.element,
	
	  /**
	   * The icon to use for an unchecked `checkbox` selection control.
	   */
	  uncheckedCheckboxIcon: _propTypes2.default.element,
	
	  /**
	   * The icon to use for a checked `radio` selection control.
	   */
	  checkedRadioIcon: _propTypes2.default.element,
	
	  /**
	   * The icon to use for an unchecked `radio` selection control.
	   */
	  uncheckedRadioIcon: _propTypes2.default.element,
	
	  /**
	   * An optional tooltip to render with the control. This is only used if you inject the
	   * tooltip manually yourself.
	   *
	   * `const TooltippedSelectionControl = injectTooltip(SelectionControl);`
	   */
	  tooltip: _propTypes2.default.node,
	
	  /**
	   * Boolean if the ink should be disabled for radios or checkboxes.
	   *
	   * @see {@link Inks#inkDisabled}
	   */
	  inkDisabled: _propTypes2.default.bool,
	
	  /**
	   * An optional list of ink interactions that should be disabled.
	   *
	   * @see {@link Inks#disabledInteractions}
	   */
	  disabledInteractions: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['keyboard', 'touch', 'mouse'])),
	
	  /**
	   * An optional tab index to apply to the selection control.
	   */
	  tabIndex: _propTypes2.default.number,
	
	  checkedIcon: preventDouble((0, _deprecated2.default)(_propTypes2.default.node, 'Use the `checkedCheckboxIconChildren` and `checkedCheckboxIconClassName`  or the ' + '`checkedRadioIconChildren` and `checkedRadioIconClassName` props instead')),
	  uncheckedIcon: preventDouble((0, _deprecated2.default)(_propTypes2.default.node, 'Use the `uncheckedCheckboxIconChildren` and `uncheckedCheckboxIconClassName`  or the ' + '`uncheckedRadioIconChildren` and `uncheckedRadioIconClassName` props instead')),
	  checkedCheckboxIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `checkedCheckboxIcon` prop instead'),
	  checkedCheckboxIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `checkedCheckboxIcon` prop instead'),
	  uncheckedCheckboxIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `uncheckedCheckboxIcon` prop instead'),
	  uncheckedCheckboxIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `uncheckedCheckboxIcon` prop instead'),
	  checkedRadioIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `checkedRadioIcon` prop instead'),
	  checkedRadioIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `checkedRadioIcon` prop instead'),
	  uncheckedRadioIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `uncheckedRadioIcon` prop instead'),
	  uncheckedRadioIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `uncheckedRadioIcon` prop instead'),
	
	  /* maybe removed once upgrade again? */
	  __superSecreteProp: _propTypes2.default.bool
	};
	SelectionControl.defaultProps = {
	  checkedCheckboxIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'check_box'
	  ),
	  uncheckedCheckboxIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'check_box_outline_blank'
	  ),
	  checkedRadioIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'radio_button_checked'
	  ),
	  uncheckedRadioIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'radio_button_unchecked'
	  )
	};
	exports.default = SelectionControl;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(11);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `Subheader` component is generally used inside of lists or menus.
	 */
	var Subheader = function (_PureComponent) {
	  _inherits(Subheader, _PureComponent);
	
	  function Subheader() {
	    _classCallCheck(this, Subheader);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  Subheader.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.component,
	        inset = _props.inset,
	        primary = _props.primary,
	        primaryText = _props.primaryText,
	        className = _props.className,
	        children = _props.children,
	        props = _objectWithoutProperties(_props, ['component', 'inset', 'primary', 'primaryText', 'className', 'children']);
	
	    return _react2.default.createElement(
	      Component,
	      _extends({}, props, {
	        className: (0, _classnames2.default)('md-subheader', {
	          'md-list-item--inset': inset
	        }, (0, _themeColors2.default)({ primary: primary, hint: !primary }), className)
	      }),
	      primaryText,
	      children
	    );
	  };
	
	  return Subheader;
	}(_react.PureComponent);
	
	Subheader.propTypes = {
	  /**
	   * An optional style to apply to the subheader.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the subheader.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Boolean if the subheader should be styled with the primary color.
	   */
	  primary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the subheader is inset in the list. This will add additional
	   * spacing to align the subheader.
	   */
	  inset: _propTypes2.default.bool,
	
	  /**
	   * The primary text to use in the subheader.
	   */
	  primaryText: _propTypes2.default.node.isRequired,
	
	  /**
	   * Any optional children to display after the `primaryText`. This prop is
	   * not recommended.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * The component to render the Subheader as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired
	};
	Subheader.defaultProps = {
	  component: 'li'
	};
	exports.default = Subheader;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(5);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _isRequiredForA11y = __webpack_require__(16);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _isValued = __webpack_require__(176);
	
	var _isValued2 = _interopRequireDefault(_isValued);
	
	var _getField = __webpack_require__(8);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _getTextWidth = __webpack_require__(128);
	
	var _getTextWidth2 = _interopRequireDefault(_getTextWidth);
	
	var _controlled = __webpack_require__(15);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _invalidIf = __webpack_require__(43);
	
	var _invalidIf2 = _interopRequireDefault(_invalidIf);
	
	var _minNumber = __webpack_require__(928);
	
	var _minNumber2 = _interopRequireDefault(_minNumber);
	
	var _addSuffix = __webpack_require__(352);
	
	var _addSuffix2 = _interopRequireDefault(_addSuffix);
	
	var _FontIcon = __webpack_require__(12);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _getDeprecatedIcon = __webpack_require__(21);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _FloatingLabel = __webpack_require__(342);
	
	var _FloatingLabel2 = _interopRequireDefault(_FloatingLabel);
	
	var _TextFieldMessage = __webpack_require__(344);
	
	var _TextFieldMessage2 = _interopRequireDefault(_TextFieldMessage);
	
	var _PasswordButton = __webpack_require__(913);
	
	var _PasswordButton2 = _interopRequireDefault(_PasswordButton);
	
	var _InputField = __webpack_require__(911);
	
	var _InputField2 = _interopRequireDefault(_InputField);
	
	var _TextFieldDivider = __webpack_require__(343);
	
	var _TextFieldDivider2 = _interopRequireDefault(_TextFieldDivider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_TEXT_FIELD_SIZE = 180;
	
	var WILL_RECEIVE_KEYS = ['style', 'value', 'resize'];
	var DID_UPDATE_KEYS = ['leftIcon', 'rightIcon', 'passwordIcon', 'inlineIndicator'];
	
	/**
	 * The `TextField` component can either be a single line `input` field or a multiline
	 * `textarea` field. `FontIcon`s, messages, and password indicators can also be added
	 * to this field.
	 *
	 * The optional mouse and touch events will be added to the entire container while the
	 * text specific events will be added to the `input` or `textarea` tags.
	 */
	
	var TextField = function (_PureComponent) {
	  _inherits(TextField, _PureComponent);
	
	  function TextField(props) {
	    _classCallCheck(this, TextField);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var currentLength = _this._getLength(typeof props.value !== 'undefined' ? props.value : props.defaultValue);
	
	    _this._canvas = null;
	    var width = null;
	    if (typeof props.resize !== 'undefined') {
	      width = typeof props.resize.min === 'number' ? props.resize.min : DEFAULT_TEXT_FIELD_SIZE;
	    }
	
	    _this.state = {
	      active: false,
	      error: props.maxLength ? props.maxLength < currentLength : false,
	      floating: (0, _isValued2.default)(props.defaultValue) || (0, _isValued2.default)(props.value),
	      passwordVisible: props.passwordInitiallyVisible,
	      currentLength: currentLength,
	      styles: width ? _extends({ width: width }, props.style) : props.style
	    };
	    return _this;
	  }
	
	  TextField.prototype.componentDidMount = function componentDidMount() {
	    var _props = this.props,
	        value = _props.value,
	        defaultValue = _props.defaultValue,
	        resize = _props.resize,
	        style = _props.style;
	
	    var v = typeof value !== 'undefined' ? value : defaultValue;
	    /* eslint-disable react/no-did-mount-set-state */
	    if (resize) {
	      // always want to set width on mount
	      this.setState({ styles: _extends({ width: this._calcWidth(v, this.props) }, style) });
	    }
	  };
	
	  TextField.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    var value = nextProps.value,
	        resize = nextProps.resize,
	        style = nextProps.style;
	
	    var nextState = {};
	    if (value !== this.props.value) {
	      nextState.error = this._isErrored(nextProps);
	      nextState.floating = this._focus || (0, _isValued2.default)(value);
	      nextState.currentLength = this._getLength(value);
	    }
	
	    if (WILL_RECEIVE_KEYS.some(function (key) {
	      return _this2.props[key] !== nextProps[key];
	    })) {
	      if (!resize) {
	        nextState.styles = style;
	      } else {
	        var width = this._calcWidth(value, nextProps);
	        nextState.styles = _extends({ width: width }, style);
	      }
	    }
	
	    this.setState(nextState);
	  };
	
	  TextField.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var _this3 = this;
	
	    var _props2 = this.props,
	        resize = _props2.resize,
	        value = _props2.value,
	        style = _props2.style;
	
	    if (resize && DID_UPDATE_KEYS.some(function (key) {
	      return _this3.props[key] !== prevProps[key];
	    })) {
	      var width = this._calcWidth(value, this.props);
	      this.setState({ styles: _extends({ width: width }, style) }); // eslint-disable-line react/no-did-update-set-state
	    }
	  };
	
	  /**
	   * A helper function for getting the specific `input` field or the `textarea` in the `TextField`.
	   * This is accessible if you use `refs`.
	   *
	   * Example:
	   *
	   * ```js
	   * <TextField ref={field => this._field = field;} label="Hello" />;
	   *
	   * this._field.getField(); // `input` node
	   * ```
	   */
	
	
	  /**
	   * A helper function for focusing the `input` field or the `textarea` in the `TextField`.
	   * This is accessibile if you use `refs`.
	   * Example:
	   *
	   * ```js
	   * <TextField ref={field => this._field = field;} label="Hello" />;
	   *
	   * this._field.focus();
	   * ```
	   */
	
	
	  /**
	   * A helper function for blurring the `input` field or the `textarea` in the `TextField`.
	   * This is accessible if you use `refs`.
	   * Example:
	   *
	   * ```js
	   * <TextField ref={field => this._field = field;} label="Hello" />;
	   *
	   * this._field.blur();
	   * ```
	   */
	  TextField.prototype.blur = function blur() {
	    this._field.blur();
	  };
	
	  TextField.prototype._cloneIcon = function _cloneIcon(icon, active, error, disabled, stateful, block, dir) {
	    if (!icon) {
	      return icon;
	    }
	
	    try {
	      var iconEl = _react.Children.only(icon);
	      return (0, _react.cloneElement)(iconEl, {
	        key: iconEl.key || 'icon-' + dir,
	        disabled: stateful ? disabled : undefined,
	        primary: stateful ? !error && active : undefined,
	        error: stateful ? error : undefined,
	        className: (0, _classnames2.default)('md-text-field-icon', {
	          'md-text-field-icon--positioned': !block
	        }, iconEl.props.className)
	      });
	    } catch (e) {
	      return icon;
	    }
	  };
	
	  /**
	   * A small utility function for calculating an inline-icon's width keeping the SVG Icons
	   * in mind and any margin that gets applied for spacing.
	   */
	
	
	  TextField.prototype.render = function render() {
	    var _state = this.state,
	        currentLength = _state.currentLength,
	        passwordVisible = _state.passwordVisible,
	        styles = _state.styles;
	
	    var _props3 = this.props,
	        id = _props3.id,
	        type = _props3.type,
	        className = _props3.className,
	        inputStyle = _props3.inputStyle,
	        inputClassName = _props3.inputClassName,
	        block = _props3.block,
	        fullWidth = _props3.fullWidth,
	        required = _props3.required,
	        customSize = _props3.customSize,
	        maxLength = _props3.maxLength,
	        errorText = _props3.errorText,
	        helpText = _props3.helpText,
	        helpOnFocus = _props3.helpOnFocus,
	        disabled = _props3.disabled,
	        leftIconStateful = _props3.leftIconStateful,
	        rightIconStateful = _props3.rightIconStateful,
	        lineDirection = _props3.lineDirection,
	        paddedBlock = _props3.paddedBlock,
	        onDoubleClick = _props3.onDoubleClick,
	        onTouchStart = _props3.onTouchStart,
	        onTouchMove = _props3.onTouchMove,
	        onTouchCancel = _props3.onTouchCancel,
	        onTouchEnd = _props3.onTouchEnd,
	        onMouseDown = _props3.onMouseDown,
	        onMouseUp = _props3.onMouseUp,
	        onMouseOver = _props3.onMouseOver,
	        onMouseLeave = _props3.onMouseLeave,
	        ink = _props3.ink,
	        inlineIndicator = _props3.inlineIndicator,
	        toolbar = _props3.toolbar,
	        propPasswordIcon = _props3.passwordIcon,
	        icon = _props3.icon,
	        passwordIconChildren = _props3.passwordIconChildren,
	        passwordIconClassName = _props3.passwordIconClassName,
	        style = _props3.style,
	        propLabel = _props3.label,
	        propPlaceholder = _props3.placeholder,
	        propError = _props3.error,
	        propActive = _props3.active,
	        propFloating = _props3.floating,
	        propLeftIcon = _props3.leftIcon,
	        propRightIcon = _props3.rightIcon,
	        onClick = _props3.onClick,
	        onChange = _props3.onChange,
	        onBlur = _props3.onBlur,
	        onFocus = _props3.onFocus,
	        resize = _props3.resize,
	        adjustMinWidth = _props3.adjustMinWidth,
	        propFloatingLabel = _props3.floatingLabel,
	        props = _objectWithoutProperties(_props3, ['id', 'type', 'className', 'inputStyle', 'inputClassName', 'block', 'fullWidth', 'required', 'customSize', 'maxLength', 'errorText', 'helpText', 'helpOnFocus', 'disabled', 'leftIconStateful', 'rightIconStateful', 'lineDirection', 'paddedBlock', 'onDoubleClick', 'onTouchStart', 'onTouchMove', 'onTouchCancel', 'onTouchEnd', 'onMouseDown', 'onMouseUp', 'onMouseOver', 'onMouseLeave', 'ink', 'inlineIndicator', 'toolbar', 'passwordIcon', 'icon', 'passwordIconChildren', 'passwordIconClassName', 'style', 'label', 'placeholder', 'error', 'active', 'floating', 'leftIcon', 'rightIcon', 'onClick', 'onChange', 'onBlur', 'onFocus', 'resize', 'adjustMinWidth', 'floatingLabel']);
	
	    var _props4 = this.props,
	        label = _props4.label,
	        placeholder = _props4.placeholder,
	        error = _props4.error,
	        active = _props4.active,
	        floating = _props4.floating,
	        leftIcon = _props4.leftIcon,
	        rightIcon = _props4.rightIcon;
	
	    active = active || this.state.active;
	    error = error || this.state.error;
	    floating = floating || this.state.floating;
	
	    if (required) {
	      if (label) {
	        label = (0, _addSuffix2.default)(label, '*');
	      }
	
	      if (placeholder && !label) {
	        placeholder = (0, _addSuffix2.default)(placeholder, '*');
	      }
	    }
	
	    if (label && !floating) {
	      placeholder = null;
	    }
	
	    leftIcon = this._cloneIcon(icon || leftIcon, active, error, disabled, leftIconStateful, block, 'left');
	    var passwordIcon = (0, _getDeprecatedIcon2.default)(passwordIconClassName, passwordIconChildren, propPasswordIcon);
	    if (passwordIcon !== null && type === 'password' && !disabled) {
	      rightIcon = _react2.default.createElement(_PasswordButton2.default, {
	        key: 'password-btn',
	        onClick: this._togglePasswordField,
	        active: active,
	        passwordVisible: passwordVisible,
	        icon: passwordIcon,
	        block: block,
	        floating: !!label
	      });
	    } else if (inlineIndicator) {
	      var el = _react.Children.only(inlineIndicator);
	      rightIcon = (0, _react.cloneElement)(inlineIndicator, {
	        key: 'icon-right',
	        className: (0, _classnames2.default)('md-text-field-inline-indicator', {
	          'md-text-field-inline-indicator--floating': label,
	          'md-text-field-inline-indicator--block': block
	        }, el.props.className)
	      });
	    } else {
	      rightIcon = this._cloneIcon(rightIcon, active, error, disabled, rightIconStateful, block, 'right');
	    }
	    var rightIconed = !!rightIcon && type !== 'password' && !inlineIndicator;
	
	    var floatingLabel = _react2.default.createElement(_FloatingLabel2.default, {
	      key: 'label',
	      label: label,
	      htmlFor: id,
	      active: active,
	      error: error,
	      floating: floating,
	      customSize: customSize,
	      disabled: disabled,
	      iconOffset: !!leftIcon
	    });
	
	    var message = _react2.default.createElement(_TextFieldMessage2.default, {
	      key: 'message',
	      active: active,
	      error: error,
	      errorText: errorText,
	      helpText: helpText,
	      helpOnFocus: helpOnFocus,
	      block: block,
	      maxLength: maxLength,
	      leftIcon: !!leftIcon,
	      rightIcon: !!rightIcon,
	      currentLength: currentLength
	    });
	
	    var field = _react2.default.createElement(_InputField2.default, _extends({}, props, {
	      required: required,
	      key: 'field',
	      ref: this._setField,
	      id: id,
	      type: type,
	      label: label,
	      style: inputStyle,
	      className: (0, _classnames2.default)({ 'md-text-field--toolbar': toolbar }, inputClassName),
	      disabled: disabled,
	      customSize: customSize,
	      fullWidth: fullWidth,
	      passwordVisible: passwordVisible,
	      placeholder: placeholder,
	      block: block,
	      onFocus: this._handleFocus,
	      onBlur: this._handleBlur,
	      onChange: this._handleChange,
	      inlineIndicator: !!inlineIndicator
	    }));
	
	    var divider = void 0;
	    if (!block) {
	      divider = _react2.default.createElement(_TextFieldDivider2.default, {
	        key: 'text-divider',
	        active: active,
	        error: error,
	        lineDirection: lineDirection
	      });
	    }
	
	    var children = void 0;
	    if (leftIcon || rightIconed) {
	      children = _react2.default.createElement(
	        'div',
	        { key: 'icon-divider', className: 'md-text-field-icon-container' },
	        leftIcon,
	        _react2.default.createElement(
	          'div',
	          {
	            key: 'divider-container',
	            className: (0, _classnames2.default)('md-text-field-divider-container', {
	              'md-text-field-divider-container--grow': fullWidth
	            })
	          },
	          field,
	          divider
	        ),
	        rightIcon
	      );
	    } else {
	      children = [leftIcon, field, divider, rightIcon];
	    }
	
	    children = [floatingLabel, children, message];
	
	    var multiline = typeof props.rows !== 'undefined';
	    return _react2.default.createElement(
	      'div',
	      {
	        style: styles,
	        className: (0, _classnames2.default)('md-text-field-container', {
	          'md-inline-block': !fullWidth && !block,
	          'md-full-width': block || fullWidth,
	          'md-text-field-container--disabled': disabled,
	          'md-text-field-container--input': !multiline,
	          'md-text-field-container--input-block': block && !multiline,
	          'md-text-field-container--multiline': multiline,
	          'md-text-field-container--multiline-block': multiline && block,
	          'md-text-field-container--padded-block': block && paddedBlock
	        }, className),
	        onClick: this._handleContainerClick,
	        onDoubleClick: onDoubleClick,
	        onMouseOver: onMouseOver,
	        onMouseLeave: onMouseLeave,
	        onMouseDown: onMouseDown,
	        onMouseUp: onMouseUp,
	        onTouchStart: onTouchStart,
	        onTouchEnd: onTouchEnd,
	        onTouchCancel: onTouchCancel,
	        onTouchMove: onTouchMove,
	        ref: this._setContainer
	      },
	      ink,
	      children
	    );
	  };
	
	  _createClass(TextField, [{
	    key: 'value',
	
	
	    /**
	     * Gets the current value from the text field. This is used when you have an uncontrolled
	     * text field and simply need the value from a ref callback.
	     *
	     * @return {String} the text field's value
	     */
	    get: function get() {
	      return this.getField().value;
	    }
	  }]);
	
	  return TextField;
	}(_react.PureComponent);
	
	TextField.propTypes = {
	  /**
	   * The id for a text field. This is required when using the `label` prop for accessibility,
	   * but normally a good idea to include one anyways.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * An optional style to apply to the text field's container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the text field's container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the `input` or `textarea` tag.
	   */
	  inputStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `input` or `textarea` tag.
	   */
	  inputClassName: _propTypes2.default.string,
	
	  /**
	   * An optional value to apply to the text field. This will make the component
	   * controlled and require the `onChange` prop.
	   */
	  value: (0, _controlled2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]), 'onChange'),
	
	  /**
	   * An optional default value for the text field.
	   */
	  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	
	  /**
	   * Boolean if the text field should be displayed as a `block`. This is equivalent to
	   * the `full width` text field in the Material Design specs. This view will disable
	   * floating labels and remove the text divider from the component.
	   */
	  block: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `block` text field should include padding to the left and right of
	   * the text field.
	   */
	  paddedBlock: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the text field is currently disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional label to display with the text field. This will convert the text field
	   * into a floating label text field. You can make it single line by only using the
	   * `placeholder` prop.
	   */
	  label: (0, _invalidIf2.default)(_propTypes2.default.node, 'block'),
	
	  /**
	   * An optional placeholder text to display in the text field. If there is no `label` prop,
	   * the text field will be displayed as a single line text field. If there is a `label` prop,
	   * this will only be visible when there is no value and the user focused the text field.
	   */
	  placeholder: _propTypes2.default.string,
	
	  /**
	   * The type for the text field. This is one of the most import props for mobile accessibility
	   * as it will update the keyboard for the text type. This does not get applied on multiline
	   * text fields.
	   */
	  type: _propTypes2.default.oneOf(['text', 'number', 'email', 'search', 'tel', 'url', 'password']).isRequired,
	
	  /**
	   * An optional function to call when the text field's container triggers the `click` event.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field's container triggers the `doubleclick`
	   * event.
	   */
	  onDoubleClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field's container triggers the `touchstart`
	   * event.
	   */
	  onTouchStart: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field's container triggers the `touchmove`
	   * event.
	   */
	  onTouchMove: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field's container triggers the `touchcancel`
	   * event.
	   */
	  onTouchCancel: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field's container triggers the `touchend`
	   * event.
	   */
	  onTouchEnd: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field's container triggers the `mousedown`
	   * event.
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field's container triggers the `mouseup`
	   * event.
	   */
	  onMouseUp: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field's container triggers the `mouseover`
	   * event.
	   */
	  onMouseOver: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field's container triggers the `mouseleave`
	   * event.
	   */
	  onMouseLeave: _propTypes2.default.func,
	
	  /**
	   * An optional onChange function to call. If the `value` prop is defined, this is
	   * required.
	   *
	   * When the value changes in the text field, this will be called with the new text
	   * field's value and the change event.
	   *
	   * ```js
	   * onChange(e.target.value, e);
	   * ```
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field is blurred.
	   */
	  onBlur: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field is focused.
	   */
	  onFocus: _propTypes2.default.func,
	
	  /**
	   * An optional boolean if the `active` state of the text field can be externally
	   * modified as well. The text field is usually considered active when it gains focus.
	   *
	   * If this prop is set, it will check both the active prop and the active state to
	   * determine if one is true.
	   */
	  active: _propTypes2.default.bool,
	
	  /**
	   * An optional boolean if the `error` state of the text field can be externally
	   * modified as well. The text field is usually considered errored when it is required
	   * and there is no value or the current length of the text field's value is greater
	   * than the `maxLength` prop.
	   *
	   * If this prop is set, it will check both the error prop and the error state to
	   * determine if one is true.
	   */
	  error: _propTypes2.default.bool,
	
	  /**
	   * An optional boolean if the `floating` state of the text field's floating label can be
	   * externally modified as well. The floating state is true when the text field gains focus
	   * or there is a value in the text field.
	   *
	   * If this prop is set, it will check both the floating prop and the floating state to
	   * determine if one is true.
	   */
	  floating: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the text field is required. If the user blurs the text field while there is
	   * no value and it is required, the `error` state will be set to true.
	   */
	  required: _propTypes2.default.bool,
	
	  /**
	   * The direction that the underline should appear from.
	   */
	  lineDirection: _propTypes2.default.oneOf(['left', 'center', 'right']).isRequired,
	
	  /**
	   * An optional icon to place to the left of the text field.
	   */
	  leftIcon: _propTypes2.default.element,
	
	  /**
	   * Boolean if the left icon should be stateful. This means that the icon will
	   * gain the active or error colors with the text field.
	   */
	  leftIconStateful: _propTypes2.default.bool,
	
	  /**
	   * An optional icon to place to the right of the text field.
	   */
	  rightIcon: _propTypes2.default.element,
	
	  /**
	   * Boolean if the right icon should be stateful. This means that the icon will
	   * gain the active or error colors with the text field.
	   */
	  rightIconStateful: _propTypes2.default.bool,
	
	  /**
	   * The icon to use for a password text field.
	   */
	  passwordIcon: _propTypes2.default.element,
	
	  /**
	   * Boolean if the password is initially visible.
	   */
	  passwordInitiallyVisible: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the text field should be displayed as full width.
	   */
	  fullWidth: _propTypes2.default.bool,
	
	  /**
	   * The number of rows for the `multiline` text field. This value must be greater than
	   * or equal to 1. When this value is set, the text field will be converted to a multiline
	   * field.
	   */
	  rows: (0, _minNumber2.default)(1, false),
	
	  /**
	   * The maximum number of rows for a `multiline` text field. If this value is
	   * `undefined`, `0`, or a number less than `0`, the multiline text field will
	   * infinitely expand.
	   */
	  maxRows: _propTypes2.default.number,
	
	  /**
	   * An optional custom size to apply to the text field. This is used along with
	   * the `$md-text-field-custom-sizes` variable. It basically applies a className of
	   * `md-text-field--NAME`.
	   */
	  customSize: _propTypes2.default.string,
	
	  /**
	   * An optional error text to display below the text field. This will only appear when
	   * the text field has the `error` state through the `error` prop, the current length
	   * of the text field's value is greater than the `maxLength` prop, or the field is
	   * required and the user blurs the text field with no value.
	   */
	  errorText: _propTypes2.default.node,
	
	  /**
	   * An optional help text to display below the text field. This will always be visible
	   * unless the `helpOnFocus` prop is set to true. Otherwise it will appear on focus.
	   */
	  helpText: _propTypes2.default.node,
	
	  /**
	   * Boolean if the help text should display on focus only.
	   */
	  helpOnFocus: _propTypes2.default.bool,
	
	  /**
	   * An optional max length for the text field. This will insert a counter underneath the
	   * text field that appears on focus.
	   */
	  maxLength: _propTypes2.default.number,
	
	  /**
	   * The ink when there is an injectInk above the text field. Used from the SelectField.
	   *
	   * @access private
	   */
	  ink: _propTypes2.default.node,
	
	  /**
	   * An optional element to display inside of the `TextField` to the farthest right. This will
	   * position the indicator absolutely and add some additional padding to the `TextField`.
	   */
	  inlineIndicator: _propTypes2.default.element,
	
	  /**
	   * This prop allows the text field to resize its width to stay between the min and max sizes provided. By
	   * default, the field will expand and collapse based on the amount of text provided. The collapsing can
	   * be disabled by providing `disableShrink` to the configuration object.
	   *
	   * If the `min` prop is not provided, it will default to `180` which is about the same size as a default
	   * text field.
	   */
	  resize: _propTypes2.default.shape({
	    min: _propTypes2.default.number,
	    max: _propTypes2.default.number.isRequired,
	    disableShrink: _propTypes2.default.bool
	  }),
	
	  /**
	   * Boolean if the TextField is in a toolbar and acting as a title. This will apply additional styles to the
	   * text field to make it look like the toolbar's title.
	   */
	  toolbar: _propTypes2.default.bool,
	
	  passwordIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `passwordIcon` prop instead'),
	  passwordIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `passwordIcon` prop instead'),
	  icon: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `leftIcon` or `rightIcon` prop instead'),
	  floatingLabel: (0, _deprecated2.default)(_propTypes2.default.bool, 'The `label` prop is now always floating. To create a non-floating text field, only use the `placeholder` prop'),
	  adjustMinWidth: (0, _deprecated2.default)(_propTypes2.default.bool, 'Manually add a min width style instead')
	};
	TextField.defaultProps = {
	  type: 'text',
	  lineDirection: 'left',
	  passwordIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'remove_red_eye'
	  ),
	  leftIconStateful: true,
	  rightIconStateful: true,
	  fullWidth: true
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this.getField = function () {
	    return _this4._field.getField();
	  };
	
	  this.focus = function () {
	    _this4._field.focus();
	  };
	
	  this._getLength = function (v) {
	    if ((0, _isValued2.default)(v)) {
	      return String(v).length;
	    }
	
	    return 0;
	  };
	
	  this._setContainer = function (div) {
	    _this4._container = div;
	  };
	
	  this._setField = function (field) {
	    if (field !== null) {
	      _this4._field = field;
	    }
	  };
	
	  this._calcIconWidth = function (icon) {
	    var style = window.getComputedStyle(icon);
	
	    return icon.getBoundingClientRect().width + parseInt(style.marginLeft, 10);
	  };
	
	  this._calcWidth = function (value) {
	    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this4.props;
	
	    var text = value;
	    // if it is a password, use the bullet unicode instead
	    if (props.type === 'password') {
	      text = Array.from(Array(value.length)).reduce(function (s) {
	        return s + '\u2022';
	      }, '');
	    }
	
	    var field = _this4._field && _this4._field.getField();
	    if (!(0, _isValued2.default)(text) && field) {
	      text = field.value;
	    }
	
	    var min = (0, _getField2.default)(props.resize, { min: DEFAULT_TEXT_FIELD_SIZE }, 'min');
	    var width = (0, _getTextWidth2.default)(text, field);
	    if (width === null || !field) {
	      // some error happened, don't do other logic
	      return width || min;
	    }
	
	    var max = props.resize.max;
	
	
	    if (_this4._container) {
	      var indicator = _this4._container.querySelector('.md-text-field-inline-indicator');
	      if (indicator) {
	        width += indicator.getBoundingClientRect().width;
	      }
	
	      var iconContainer = _this4._container.querySelector('.md-text-field-icon-container');
	      if (iconContainer) {
	        // There is conditionally an icon before and after the text field, or only an icon before/after
	        var _iconContainer$childr = iconContainer.children,
	            first = _iconContainer$childr[0],
	            second = _iconContainer$childr[1],
	            third = _iconContainer$childr[2];
	
	        if (first.classList.contains('md-icon')) {
	          width += first.getBoundingClientRect().width;
	          width += parseInt(window.getComputedStyle(second).marginLeft, 10);
	
	          if (third) {
	            width += _this4._calcIconWidth(third);
	          }
	        } else if (second) {
	          width += _this4._calcIconWidth(second);
	        }
	      }
	    }
	
	    return Math.ceil(Math.min(max, Math.max(min, width)));
	  };
	
	  this._isErrored = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this4.props,
	        value = _ref.value,
	        maxLength = _ref.maxLength,
	        required = _ref.required;
	
	    var error = _this4.state.error;
	
	    var currentLength = _this4._getLength(value);
	    if (required && error) {
	      error = !(0, _isValued2.default)(value);
	    }
	
	    if (maxLength) {
	      error = error || currentLength > maxLength;
	    }
	
	    return error;
	  };
	
	  this._handleContainerClick = function (e) {
	    if (_this4.props.onClick) {
	      _this4.props.onClick(e);
	    }
	
	    if (!_this4.props.disabled) {
	      _this4.focus();
	    }
	  };
	
	  this._handleBlur = function (e) {
	    _this4._focus = false;
	    var _props5 = _this4.props,
	        required = _props5.required,
	        maxLength = _props5.maxLength,
	        onBlur = _props5.onBlur;
	
	    if (onBlur) {
	      onBlur(e);
	    }
	
	    var value = e.target.value;
	
	    var state = {
	      active: false,
	      error: required && !(0, _isValued2.default)(value) || maxLength && String(value).length > maxLength
	    };
	
	    if (!_this4.props.block) {
	      state.floating = (0, _isValued2.default)(value);
	    }
	
	    _this4.setState(state);
	  };
	
	  this._handleFocus = function (e) {
	    _this4._focus = true;
	    var _props6 = _this4.props,
	        onFocus = _props6.onFocus,
	        block = _props6.block;
	
	    if (onFocus) {
	      onFocus(e);
	    }
	
	    var state = { active: true };
	    if (!block) {
	      state.floating = true;
	    }
	
	    _this4.setState(state);
	  };
	
	  this._handleChange = function (e) {
	    var _props7 = _this4.props,
	        onChange = _props7.onChange,
	        maxLength = _props7.maxLength,
	        required = _props7.required,
	        resize = _props7.resize;
	    var value = e.target.value;
	
	    if (onChange) {
	      onChange(e.target.value, e);
	    }
	
	    var currentLength = value.length;
	    var state = void 0;
	    if (typeof maxLength !== 'undefined') {
	      state = { currentLength: currentLength, error: currentLength > maxLength };
	    } else if (required && _this4.state.error) {
	      state = { error: !currentLength };
	    }
	
	    if (typeof _this4.props.value === 'undefined' && resize) {
	      var width = _this4._calcWidth(value);
	      if (!resize.disableShrink || !_this4.state.styles || width > _this4.state.styles.width) {
	        state = state || {};
	        state.styles = _extends({}, _this4.state.styles, { width: width });
	      }
	    }
	
	    if (state) {
	      _this4.setState(state);
	    }
	  };
	
	  this._togglePasswordField = function () {
	    _this4.setState({ passwordVisible: !_this4.state.passwordVisible }, _this4.focus);
	  };
	};
	
	exports.default = TextField;

/***/ }),
/* 90 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = handleWindowClickListeners;
	/** @module utils/EventUtils/handleWindowClickListeners */
	var mobileSafari = void 0;
	
	/**
	 * Since mobile safari doesn't delegate click events to the window (it only does touch events),
	 * this utility function will hack a fix to allow the delegation by updaging the body's cursor
	 * to be a pointer.
	 *
	 * Hopefully this can be removed one day....
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile
	 * @param {function} cb - the callback function to use for a window click event.
	 * @param {boolean} enabled - boolean if the click event is enabled.
	 */
	function handleWindowClickListeners(cb) {
	  var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  if (typeof mobileSafari === 'undefined' && typeof window !== 'undefined') {
	    var ua = window.navigator.userAgent;
	    var iOS = ua.match(/iP(ad|hone)/i);
	    var webkit = ua.match(/WebKit/i);
	    mobileSafari = iOS && webkit && !ua.match(/CriOS/i);
	
	    if (mobileSafari) {
	      document.body.style.cursor = 'pointer';
	    }
	  }
	
	  var listener = window[(enabled ? 'add' : 'remove') + 'EventListener'];
	  listener('click', cb);
	}

/***/ }),
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */
/***/ (function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	}
	
	module.exports = _interopRequireDefault;

/***/ }),
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/** @module Drawers/DrawerTypes */
	
	/**
	 * An enum for all the different type of drawers.
	 *
	 * @readonly
	 * @enum {string}
	 */
	var DrawerTypes = {
	  // Permanent drawers
	  /**
	   * This is the default drawer type. It will always be on the screen and takes
	   * up the entire height. This is very helpful for main navigation on desktops
	   * when you do not need an expandable workspace.
	   */
	  FULL_HEIGHT: 'full-height',
	
	  /**
	   * This drawer type will always be on the screen, but it will appear under the
	   * main toolbar.
	   */
	  CLIPPED: 'clipped',
	
	  /**
	   * This drawer type will always be on the screen, but it will appear under the
	   * main toolbar and have a transparent background. This is useful if you want
	   * a persistent drawer on desktop screens, but do not want the main focus to be
	   * the drawer.
	   */
	  FLOATING: 'floating',
	
	  // Persistent drawers
	  /**
	   * A persistent drawer changes between being hidden and being fixed on the page like
	   * a permanent drawer. When it is visible, it will take up the same amount of room
	   * as a permanent drawer, and will not go away until closed.
	   *
	   * This drawer type is helpful when you need to have a dynamic workspace size.
	   */
	  PERSISTENT: 'persistent',
	
	  /**
	   * This is a modification of the persistent drawer. It will behave as the persistent drawer
	   * but it will always have a "mini" drawer visible. This is helpful when you want to have
	   * a dynamic workspace size and keep certain actions available at all times.
	   */
	  PERSISTENT_MINI: 'persistent-mini',
	
	  // Temporary
	  /**
	   * A temporary drawer will not be visible by default. When it is visible, it will overlay
	   * the page to get the main focus on the drawer. When the user touches the overlay or
	   * one of the navigation items, the drawer will be closed. The overlay can be disabled on
	   * desktop and tablets.
	   */
	  TEMPORARY: 'temporary',
	
	  /**
	   * This is a modification of the temporary drawer. It will behave like a temporary drawer,
	   * but it will always have a "mini" drawer visible. Just like the `PERSISTENT_MINI` drawer
	   * type, this is useful when certain actions should be available at all times but additional
	   * actions are available when the drawer is visible.
	   */
	  TEMPORARY_MINI: 'temporary-mini'
	};
	
	exports.default = DrawerTypes;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.isTemporary = isTemporary;
	exports.isPersistent = isPersistent;
	exports.isPermanent = isPermanent;
	exports.isMini = isMini;
	
	var _DrawerTypes = __webpack_require__(115);
	
	var _DrawerTypes2 = _interopRequireDefault(_DrawerTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FULL_HEIGHT = _DrawerTypes2.default.FULL_HEIGHT,
	    CLIPPED = _DrawerTypes2.default.CLIPPED,
	    FLOATING = _DrawerTypes2.default.FLOATING,
	    PERSISTENT = _DrawerTypes2.default.PERSISTENT,
	    PERSISTENT_MINI = _DrawerTypes2.default.PERSISTENT_MINI,
	    TEMPORARY = _DrawerTypes2.default.TEMPORARY,
	    TEMPORARY_MINI = _DrawerTypes2.default.TEMPORARY_MINI;
	function isTemporary(type) {
	  return [TEMPORARY, TEMPORARY_MINI].indexOf(type) !== -1;
	}
	
	function isPersistent(type) {
	  return [PERSISTENT, PERSISTENT_MINI].indexOf(type) !== -1;
	}
	
	function isPermanent(type) {
	  return [FULL_HEIGHT, CLIPPED, FLOATING].indexOf(type) !== -1;
	}
	
	function isMini(type) {
	  return [PERSISTENT_MINI, TEMPORARY_MINI].indexOf(type) !== -1;
	}

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/** @module Helpers/HorizontalAnchors */
	
	/**
	 * An enum for all the different types of horizontal anchors on a layover.
	 *
	 * @readonly
	 * @enum {string}
	 */
	var HorizontalAnchors = {
	  /**
	   * Positions the layover to the outside left on the toggle component
	   * so that it does not overlap.
	   */
	  LEFT: 'left',
	
	  /**
	   * Positions the layover to the inner left of the toggle component so
	   * that it will overlap.
	   */
	  INNER_LEFT: 'inner left',
	
	  /**
	   * Positions the layover so that it overlaps the toggle component
	   * by positioning itself in the cetner of the toggle component's width.
	   */
	  CENTER: 'center',
	
	  /**
	   * Positions the layover to the outside right on the toggle component
	   * so that it does not overlap.
	   */
	  RIGHT: 'right',
	
	  /**
	   * Positions the layover to the outside right on the toggle component
	   * so that it will overlap.
	   */
	  INNER_RIGHT: 'inner right'
	};
	
	exports.default = HorizontalAnchors;

/***/ }),
/* 118 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/** @module Helpers/Positions */
	
	/**
	 * An enum for all the animation positions for a layover appearing.
	 *
	 * @readonly
	 * @enum {string}
	 */
	var Positions = {
	  /**
	   * The layover will appear by transitioning from the top left and expand
	   * down right.
	   */
	  TOP_LEFT: 'tl',
	
	  /**
	   * The layover will appear by transitioning from the top right and expand
	   * down left.
	   */
	  TOP_RIGHT: 'tr',
	
	  /**
	   * The layover will appear by transitioning from the bottom left and expand
	   * top right.
	   */
	  BOTTOM_LEFT: 'bl',
	
	  /**
	   * The layover will appear by transitioning from the bottom right and expand
	   * top left.
	   */
	  BOTTOM_RIGHT: 'br',
	
	  /**
	   * The layover will appear by just transitioning downwards from the bottom
	   * of the toggle component.
	   */
	  BELOW: 'below'
	};
	
	exports.default = Positions;

/***/ }),
/* 119 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/** @module Helpers/VerticalAnchors */
	
	/**
	 * An enum for all the different types of horizontal anchors on a layover.
	 *
	 * @readonly
	 * @enum {string}
	 */
	var VerticalAnchors = {
	  /**
	   * Positions the layover to be placed over the toggle component so that
	   * it will never overlay the toggle component.
	   */
	  TOP: 'top',
	
	  /**
	   * Positions the layover so that it will be centered over the toggle component
	   * based on the layover's height.
	   */
	  CENTER: 'center',
	
	  /**
	   * Positions the layover so that it will overlap the toggle component by
	   * fixing to the top of the toggle.
	   */
	  OVERLAP: 'overlap',
	
	  /**
	   * Positions the layover to be placed below the toggle component so that
	   * it will never overlay the toggle component.
	   */
	  BOTTOM: 'bottom'
	};
	
	exports.default = VerticalAnchors;

/***/ }),
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isInvalidAnimate;
	var gcc = 'getComposedComponent';
	
	/**
	 * Just checks if the fab is actually a ref to the FAB Button.
	 */
	function isInvalidAnimate(fab) {
	  return typeof fab[gcc] !== 'function' || typeof fab[gcc]()[gcc] !== 'function' || typeof fab[gcc]()[gcc]()._animateForSnackbar !== 'function';
	}

/***/ }),
/* 125 */,
/* 126 */,
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getScreenSize;
	/** @module utils/Positioning/getScreenSize */
	
	/**
	 * A utility function to get the height or width of the of the browser with
	 * a fallback for older browsers.
	 *
	 * @param {String} position - the position to get the screen size for
	 * @return {number} the screen size for the provided position.
	 */
	function getScreenSize(position) {
	  if (position !== 'Height' && position !== 'Width' && ("production") !== 'production') {
	    throw new Error('The \'getScreenSize\' function requires either a position of \'Height\' or \'Width\' ' + ('but received `' + position + '`'));
	  }
	
	  return window['inner' + position] || document.documentElement['client' + position];
	}

/***/ }),
/* 128 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getTextWidth;
	/** @module utils/Positioning/getTextWidth */
	
	var cachedCanvas = void 0;
	
	/**
	 * A utility function to measure the width (in px) of any text. It will require a canvas
	 * and an element to use to determine the current fonts to apply since different fonts will
	 * have different widths.
	 *
	 * This isn't fully accurate since some browsers handle the calculations a bit differently so
	 * they are off by a 0-3px
	 *
	 * @param {String} text - The text to measure the width
	 * @param {HTMLElement} el - The element to use to determine the current font for the text.
	 * @param {HTMLElement=} canvas - An optional canvas to use for doing the calculations. If this
	 *    is omitted, it will just use the locally created canvas to do the calculations.
	 * @return {number} this will either return null if there is a problem calculating the width or
	 *    the length (in px) of the text.
	 */
	function getTextWidth(text, el, canvas) {
	  if (!el) {
	    return null;
	  }
	
	  if (!canvas) {
	    if (!cachedCanvas) {
	      cachedCanvas = document.createElement('canvas');
	    }
	
	    canvas = cachedCanvas;
	  }
	
	  var context = canvas.getContext('2d');
	  if (!context) {
	    // context doesn't exist in testing without complicated mocks
	    return null;
	  }
	
	  var styles = window.getComputedStyle(el);
	  var font = styles.font;
	  // Some browsers do not actually supply the font style since they are on an older version of CSSProperties,
	  // so the font string needs to be made manually.
	  if (!font) {
	    // font-style font-variant font-weight font-size/line-height font-family
	    var sizing = styles.fontSize + ' / ' + styles.lineHeight + ' ' + styles.fontFamily;
	    font = styles.fontStyle + ' ' + styles.fontVariant + ' ' + styles.fontWeight + ' ' + sizing;
	  }
	
	  context.font = font;
	  return context.measureText(text).width;
	}

/***/ }),
/* 129 */,
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = mapToListParts;
	
	var _react = __webpack_require__(1);
	
	var _Divider = __webpack_require__(69);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _Subheader = __webpack_require__(88);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	var _ListItem = __webpack_require__(85);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /** @module utils/mapToListParts */
	
	/**
	 * A utility function to convert any "item" into a valid React element that is used
	 * within the `List` component.
	 *
	 * Use cases:
	 * - is a valid React element -> item returned unmodified
	 * - `number` or `string` -> `ListItem` with the item as the `primaryText`
	 * - an `object` with a key `divider: true` -> a `Divider` component with the remaining
	 *    keys applied as props.
	 * - an `object` with a key `subheader: true` -> a `Subheader` component with the remianing
	 *    keys applied as props. This one technically requires the `primaryText` key to be defined.
	 * - an `object` -> all keys passed into the `ListItem` component.
	 *
	 * Examples:
	 * ```js
	 * mapToListParts('Hello') == <ListItem primaryText="Hello" />
	 * mapToListParts(100)     == <ListItem primaryText={100} />
	 * mapToListParts({ primaryText: 'Item' }) == <ListItem primaryText="Item" />
	 * mapToListParts({ divider: true }) == <Divider />
	 * mapToListParts({ subheader: true, primaryText: 'Subheader' }) == <Subheader primaryText="Subheader" />
	 * ```
	 *
	 * @param {string|number|Object} item - the item to convert
	 * @param {number|string=} index - the current index in the array (if used in an array)
	 * @return {Object} a React element
	 */
	function mapToListParts(item, index) {
	  if (typeof item === 'string' || typeof item === 'number') {
	    return (0, _react.createElement)(_ListItem2.default, { key: item, primaryText: item });
	  } else if ((0, _react.isValidElement)(item)) {
	    return item;
	  }
	
	  var divider = item.divider,
	      subheader = item.subheader,
	      nestedItems = item.nestedItems,
	      remainingProps = _objectWithoutProperties(item, ['divider', 'subheader', 'nestedItems']);
	
	  var component = void 0;
	  if (divider) {
	    component = _Divider2.default;
	  } else if (subheader) {
	    component = _Subheader2.default;
	  } else {
	    component = _ListItem2.default;
	  }
	
	  var props = _extends({}, remainingProps, { key: item.key || index });
	  if (nestedItems) {
	    props.nestedItems = nestedItems.map(mapToListParts);
	  }
	
	  return (0, _react.createElement)(component, props);
	}

/***/ }),
/* 131 */,
/* 132 */,
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _addClass = __webpack_require__(207);
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__(208);
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _requestAnimationFrame = __webpack_require__(153);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _properties = __webpack_require__(151);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(7);
	
	var _PropTypes = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var events = [];
	if (_properties.transitionEnd) events.push(_properties.transitionEnd);
	if (_properties.animationEnd) events.push(_properties.animationEnd);
	
	function addEndListener(node, listener) {
	  if (events.length) {
	    events.forEach(function (e) {
	      return node.addEventListener(e, listener, false);
	    });
	  } else {
	    setTimeout(listener, 0);
	  }
	
	  return function () {
	    if (!events.length) return;
	    events.forEach(function (e) {
	      return node.removeEventListener(e, listener, false);
	    });
	  };
	}
	
	var propTypes = {
	  children: _propTypes2.default.node,
	  name: _PropTypes.nameShape.isRequired,
	
	  // Once we require timeouts to be specified, we can remove the
	  // boolean flags (appear etc.) and just accept a number
	  // or a bool for the timeout flags (appearTimeout etc.)
	  appear: _propTypes2.default.bool,
	  enter: _propTypes2.default.bool,
	  leave: _propTypes2.default.bool,
	  appearTimeout: _propTypes2.default.number,
	  enterTimeout: _propTypes2.default.number,
	  leaveTimeout: _propTypes2.default.number
	};
	
	var CSSTransitionGroupChild = function (_React$Component) {
	  _inherits(CSSTransitionGroupChild, _React$Component);
	
	  function CSSTransitionGroupChild() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroupChild);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
	      if (_this.props.appear) {
	        _this.transition('appear', done, _this.props.appearTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillEnter = function (done) {
	      if (_this.props.enter) {
	        _this.transition('enter', done, _this.props.enterTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillLeave = function (done) {
	      if (_this.props.leave) {
	        _this.transition('leave', done, _this.props.leaveTimeout);
	      } else {
	        done();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
	    this.classNameAndNodeQueue = [];
	    this.transitionTimeouts = [];
	  };
	
	  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounted = true;
	
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	
	    this.classNameAndNodeQueue.length = 0;
	  };
	
	  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
	    var node = (0, _reactDom.findDOMNode)(this);
	
	    if (!node) {
	      if (finishCallback) {
	        finishCallback();
	      }
	      return;
	    }
	
	    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
	    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
	    var timer = null;
	    var removeListeners = void 0;
	
	    (0, _addClass2.default)(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClassAndNode(activeClassName, node);
	
	    // Clean-up the animation after the specified delay
	    var finish = function finish(e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      clearTimeout(timer);
	      if (removeListeners) removeListeners();
	
	      (0, _removeClass2.default)(node, className);
	      (0, _removeClass2.default)(node, activeClassName);
	
	      if (removeListeners) removeListeners();
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    if (timeout) {
	      timer = setTimeout(finish, timeout);
	      this.transitionTimeouts.push(timer);
	    } else if (_properties.transitionEnd) {
	      removeListeners = addEndListener(node, finish);
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
	    var _this2 = this;
	
	    this.classNameAndNodeQueue.push({
	      className: className,
	      node: node
	    });
	
	    if (!this.rafHandle) {
	      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
	        return _this2.flushClassNameAndNodeQueue();
	      });
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
	    if (!this.unmounted) {
	      this.classNameAndNodeQueue.forEach(function (obj) {
	        // This is for to force a repaint,
	        // which is necessary in order to transition styles when adding a class name.
	        /* eslint-disable no-unused-expressions */
	        obj.node.scrollTop;
	        /* eslint-enable no-unused-expressions */
	        (0, _addClass2.default)(obj.node, obj.className);
	      });
	    }
	    this.classNameAndNodeQueue.length = 0;
	    this.rafHandle = null;
	  };
	
	  CSSTransitionGroupChild.prototype.render = function render() {
	    var props = _extends({}, this.props);
	    delete props.name;
	    delete props.appear;
	    delete props.enter;
	    delete props.leave;
	    delete props.appearTimeout;
	    delete props.enterTimeout;
	    delete props.leaveTimeout;
	    delete props.children;
	    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
	  };
	
	  return CSSTransitionGroupChild;
	}(_react2.default.Component);
	
	CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';
	
	
	CSSTransitionGroupChild.propTypes =  false ? propTypes : {};
	
	exports.default = CSSTransitionGroupChild;
	module.exports = exports['default'];

/***/ }),
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(5);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _CardExpander = __webpack_require__(231);
	
	var _CardExpander2 = _interopRequireDefault(_CardExpander);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `CardActions` component is used for adding actions on your card.
	 * The actions should be `FlatButton`s or `IconButton`s.
	 *
	 * This component can act as a `CardExpander`.
	 */
	var CardActions = function (_Component) {
	  _inherits(CardActions, _Component);
	
	  function CardActions() {
	    _classCallCheck(this, CardActions);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  CardActions.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        isExpander = _props.isExpander,
	        expander = _props.expander,
	        centered = _props.centered,
	        stacked = _props.stacked,
	        props = _objectWithoutProperties(_props, ['className', 'children', 'isExpander', 'expander', 'centered', 'stacked']);
	
	    return _react2.default.createElement(
	      'section',
	      _extends({}, props, {
	        className: (0, _classnames2.default)('md-dialog-footer--card', {
	          'md-dialog-footer--inline': !stacked,
	          'md-dialog-footer--stacked': stacked,
	          'md-dialog-footer--card-centered': centered
	        }, className)
	      }),
	      children,
	      isExpander || expander && _react2.default.createElement(_CardExpander2.default, null)
	    );
	  };
	
	  return CardActions;
	}(_react.Component);
	
	CardActions.propTypes = {
	  /**
	   * Boolean if this component should act as an expander and inject the
	   * `CardExpander`.
	   */
	  expander: _propTypes2.default.bool,
	
	  /**
	   * An optional className to apply to the actions container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An actions to display.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * Boolean if the actions should be centered.
	   */
	  centered: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the actions should be stacked.
	   */
	  stacked: _propTypes2.default.bool,
	
	  isExpander: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `expander` instead')
	};
	exports.default = CardActions;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  checkedIcon: _propTypes2.default.element,
	  uncheckedIcon: _propTypes2.default.element,
	  indeterminateIcon: _propTypes2.default.element,
	  indeterminate: _propTypes2.default.bool,
	  plain: _propTypes2.default.bool,
	  selectableRows: _propTypes2.default.bool.isRequired,
	  allSelected: _propTypes2.default.bool.isRequired,
	  selectedRows: _propTypes2.default.arrayOf(_propTypes2.default.bool).isRequired,
	  createCheckbox: _propTypes2.default.func.isRequired,
	  removeCheckbox: _propTypes2.default.func.isRequired,
	  toggleSelectedRow: _propTypes2.default.func.isRequired,
	  baseId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  baseName: _propTypes2.default.string,
	  checkboxHeaderLabel: _propTypes2.default.string.isRequired,
	  checkboxLabelTemplate: _propTypes2.default.string.isRequired,
	  fixedHeader: _propTypes2.default.bool.isRequired,
	  fixedFooter: _propTypes2.default.bool.isRequired
	};

/***/ }),
/* 164 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = findTable;
	/**
	 * Attempts fo find the base table component from an element in the table.
	 * This will either be the wrapper for responsive data tables, or the table element.
	 *
	 * @param {Object} el - The element to traverse from
	 * @param {Object} the table or null.
	 */
	function findTable(el) {
	  var table = void 0;
	  var node = el;
	  while (node && node.parentNode) {
	    if (node.classList) {
	      if (node.classList.contains('md-data-table')) {
	        table = node;
	      } else if (node.classList.contains('md-data-table--responsive')) {
	        return node;
	      } else if (node.classList.contains('md-data-table__scroll-wrapper')) {
	        // fixed-wrapper then responsive
	        return node.parentNode.parentNode;
	      } else if (table) {
	        return table;
	      }
	    }
	
	    node = node.parentNode;
	  }
	
	  return null;
	}

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FOOTER_PADDING = 8;
	
	var DialogFooter = function (_PureComponent) {
	  _inherits(DialogFooter, _PureComponent);
	
	  function DialogFooter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DialogFooter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = { stacked: false }, _this._setContainer = function (container) {
	      if (container !== null) {
	        _this._container = container;
	        var maxWidth = (_this._container.offsetWidth - FOOTER_PADDING * 3) / 2;
	
	        var stacked = false;
	        Array.prototype.slice.call(_this._container.querySelectorAll('.md-btn')).some(function (_ref) {
	          var offsetWidth = _ref.offsetWidth;
	
	          stacked = offsetWidth > maxWidth;
	          return stacked;
	        });
	
	        _this.setState({ stacked: stacked });
	      }
	    }, _this._generateActions = function () {
	      var actions = _this.props.actions;
	
	      if (!actions) {
	        return null;
	      } else if (Array.isArray(actions)) {
	        return actions.map(_this._toElement);
	      }
	
	      return _this._toElement(actions);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  DialogFooter.prototype._toElement = function _toElement(action, index) {
	    if ((0, _react.isValidElement)(action)) {
	      var button = _react.Children.only(action);
	
	      return (0, _react.cloneElement)(action, {
	        key: button.key || index,
	        className: (0, _classnames2.default)('md-btn--dialog', button.props.className)
	      });
	    }
	
	    // Both label and children are valid for dialog actions
	
	    var label = action.label,
	        children = action.children,
	        remaining = _objectWithoutProperties(action, ['label', 'children']);
	
	    return _react2.default.createElement(
	      _Button2.default,
	      _extends({
	        key: index,
	        flat: true
	      }, remaining, {
	        className: (0, _classnames2.default)('md-btn--dialog', action.className)
	      }),
	      label || children
	    );
	  };
	
	  DialogFooter.prototype.render = function render() {
	    var _props = this.props,
	        actions = _props.actions,
	        className = _props.className,
	        children = _props.children,
	        propStacked = _props.stacked,
	        props = _objectWithoutProperties(_props, ['actions', 'className', 'children', 'stacked']);
	
	    if (!children && (!actions || Array.isArray(actions) && !actions.length)) {
	      return null;
	    }
	
	    var stacked = this.props.stacked;
	
	    var stackedDefined = typeof propStacked !== 'undefined';
	    if (!stackedDefined) {
	      stacked = this.state.stacked;
	    }
	
	    return _react2.default.createElement(
	      'footer',
	      _extends({}, props, {
	        className: (0, _classnames2.default)('md-dialog-footer', {
	          'md-dialog-footer--inline': !stacked,
	          'md-dialog-footer--stacked': stacked
	        }, className),
	        ref: !stackedDefined ? this._setContainer : null
	      }),
	      this._generateActions(),
	      children
	    );
	  };
	
	  return DialogFooter;
	}(_react.PureComponent);
	
	DialogFooter.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  actions: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.object, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.object]))]),
	  stacked: _propTypes2.default.bool
	};
	exports.default = DialogFooter;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(7);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(5);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _media = __webpack_require__(245);
	
	var _CSSTransitionGroupTick = __webpack_require__(29);
	
	var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);
	
	var _getField = __webpack_require__(8);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _mapToListParts = __webpack_require__(130);
	
	var _mapToListParts2 = _interopRequireDefault(_mapToListParts);
	
	var _controlled = __webpack_require__(15);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _Paper = __webpack_require__(37);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _Portal = __webpack_require__(34);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _List = __webpack_require__(41);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Overlay = __webpack_require__(236);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _isType = __webpack_require__(116);
	
	var _DrawerTypes = __webpack_require__(115);
	
	var _DrawerTypes2 = _interopRequireDefault(_DrawerTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var oneOfDrawerTypes = _propTypes2.default.oneOf([_DrawerTypes2.default.FULL_HEIGHT, _DrawerTypes2.default.CLIPPED, _DrawerTypes2.default.FLOATING, _DrawerTypes2.default.PERSISTENT, _DrawerTypes2.default.PERSISTENT_MINI, _DrawerTypes2.default.TEMPORARY, _DrawerTypes2.default.TEMPORARY_MINI]);
	
	/**
	 * The `Drawer` component is used for having a sliding panel of content or navigation
	 * that appears from the side of a screen.
	 *
	 * If the `Drawer` uses any of the `_MINI` drawer types, you will need to also create another
	 * `Drawer` that is not `_MINI`. Transitioning the `width` on mobile devices is very sluggish,
	 * and it isn't much more work to create another drawer.
	 */
	
	var Drawer = function (_PureComponent) {
	  _inherits(Drawer, _PureComponent);
	
	  /**
	   * Determines the current media and returns an object containing matches for `mobile`, `tablet`, `desktop`,
	   * and the current drawer type. This expects a `props` object of the drawer.
	   *
	   * If this is used server side, it will default to only matching mobile.
	   *
	   * @param {Object=} props - The current drawer's prop shape to extract the mobile, tablet,
	   *    and desktop type/min widths. This defaults to the drawer's default props.
	   * @return {Object} an object containing the media matches and the current type to use for the drawer.
	   */
	  Drawer.getCurrentMedia = function getCurrentMedia() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Drawer.defaultProps;
	    var mobileMinWidth = props.mobileMinWidth,
	        tabletMinWidth = props.tabletMinWidth,
	        desktopMinWidth = props.desktopMinWidth,
	        mobileType = props.mobileType,
	        tabletType = props.tabletType,
	        desktopType = props.desktopType,
	        constantType = props.constantType;
	
	    if (typeof window === 'undefined') {
	      var _type = constantType && props.type ? props.type : mobileType;
	      return { mobile: true, tablet: false, desktop: false, type: _type };
	    }
	
	    var mobile = Drawer.matchesMedia(mobileMinWidth, tabletMinWidth - 1);
	    var tablet = Drawer.matchesMedia(tabletMinWidth, desktopMinWidth);
	    var desktop = Drawer.matchesMedia(desktopMinWidth);
	
	    var type = void 0;
	    if (constantType && props.type && (0, _isType.isTemporary)(props.type)) {
	      type = props.type;
	    } else if (desktop) {
	      type = desktopType;
	    } else if (tablet) {
	      type = tabletType;
	    } else {
	      type = mobileType;
	    }
	
	    return { type: type, mobile: mobile, tablet: tablet, desktop: desktop };
	  };
	
	  /**
	   * Simply does a `window.matchMedia(query)` where the query gets defined as a min width
	   * and optional max width.
	   *
	   * @param {number} min - The min width for the media query.
	   * @param {number=} max - An optional max width to include for the media query.
	   * @return {boolean} true if the media matches.
	   */
	
	
	  Drawer.matchesMedia = function matchesMedia(min, max) {
	    var media = 'screen and (min-width: ' + min + 'px)';
	    if (max) {
	      media += ' and (max-width: ' + max + 'px)';
	    }
	
	    return window.matchMedia(media).matches;
	  };
	
	  function Drawer(props) {
	    _classCallCheck(this, Drawer);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var defaultVisible = props.defaultVisible,
	        defaultMedia = props.defaultMedia,
	        overlay = props.overlay;
	
	
	    _this.state = {
	      mobile: defaultMedia === 'mobile',
	      tablet: defaultMedia === 'tablet',
	      desktop: defaultMedia === 'desktop',
	      animating: false,
	      overlayActive: false,
	      drawerActive: false
	    };
	
	    if (typeof props.type === 'undefined') {
	      _this.state.type = props[defaultMedia + 'Type'];
	    }
	
	    var type = (0, _getField2.default)(props, _this.state, 'type');
	    _this._initialFix = true;
	
	    if (typeof props.visible === 'undefined') {
	      var _visible = (0, _isType.isPermanent)(type) || (0, _isType.isMini)(type);
	      if (!_visible && typeof defaultVisible !== 'undefined') {
	        _visible = defaultVisible;
	      }
	
	      _this.state.visible = _visible;
	    }
	
	    var visible = (0, _getField2.default)(props, _this.state, 'visible');
	
	    _this.state.overlayActive = (typeof overlay !== 'undefined' ? overlay : (0, _isType.isTemporary)(type) && !_this.state.desktop) && visible;
	    _this.state.drawerActive = visible;
	    return _this;
	  }
	
	  Drawer.prototype.componentWillMount = function componentWillMount() {
	    if (typeof window !== 'undefined') {
	      this._updateType(this.props);
	    }
	  };
	
	  Drawer.prototype.componentDidMount = function componentDidMount() {
	    if (!(0, _isType.isMini)((0, _getField2.default)(this.props, this.state, 'type'))) {
	      window.addEventListener('resize', this._updateMedia);
	    }
	  };
	
	  Drawer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _props = this.props,
	        mobileMinWidth = _props.mobileMinWidth,
	        mobileType = _props.mobileType,
	        tabletMinWidth = _props.tabletMinWidth,
	        tabletType = _props.tabletType,
	        desktopMinWidth = _props.desktopMinWidth,
	        desktopType = _props.desktopType;
	
	
	    if (nextProps.mobileMinWidth !== mobileMinWidth || nextProps.mobileType !== mobileType || nextProps.tabletMinWidth !== tabletMinWidth || nextProps.tabletType !== tabletType || nextProps.desktopMinWidth !== desktopMinWidth || nextProps.desktopType !== desktopType) {
	      this._updateType(nextProps);
	    }
	
	    var visible = nextProps.visible,
	        transitionDuration = nextProps.transitionDuration,
	        overlay = nextProps.overlay;
	
	    if (this.props.visible === nextProps.visible) {
	      return;
	    }
	
	    var type = (0, _getField2.default)(nextProps, this.state, 'type');
	    this._animate(visible, type, transitionDuration, overlay, this.state.desktop);
	  };
	
	  Drawer.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this._timeout) {
	      clearTimeout(this._timeout);
	    }
	
	    if (this._closeTimeout) {
	      clearTimeout(this._closeTimeout);
	    }
	
	    window.removeEventListener('resize', this._updateMedia);
	  };
	
	  Drawer.prototype.render = function render() {
	    var _cn;
	
	    var _state = this.state,
	        overlayActive = _state.overlayActive,
	        drawerActive = _state.drawerActive,
	        animating = _state.animating;
	
	    var _props2 = this.props,
	        id = _props2.id,
	        style = _props2.style,
	        className = _props2.className,
	        navStyle = _props2.navStyle,
	        navClassName = _props2.navClassName,
	        component = _props2.component,
	        navItems = _props2.navItems,
	        header = _props2.header,
	        children = _props2.children,
	        inline = _props2.inline,
	        position = _props2.position,
	        overlay = _props2.overlay,
	        clickableDesktopOverlay = _props2.clickableDesktopOverlay,
	        lastChild = _props2.lastChild,
	        portal = _props2.portal,
	        overlayStyle = _props2.overlayStyle,
	        overlayClassName = _props2.overlayClassName,
	        propType = _props2.type,
	        propVisible = _props2.visible,
	        propRenderNode = _props2.renderNode,
	        propNavItemsId = _props2.navItemsId,
	        propZDepth = _props2.zDepth,
	        constantType = _props2.constantType,
	        defaultVisible = _props2.defaultVisible,
	        defaultMedia = _props2.defaultMedia,
	        mobileType = _props2.mobileType,
	        mobileMinWidth = _props2.mobileMinWidth,
	        tabletType = _props2.tabletType,
	        tabletMinWidth = _props2.tabletMinWidth,
	        desktopType = _props2.desktopType,
	        desktopMinWidth = _props2.desktopMinWidth,
	        transitionDuration = _props2.transitionDuration,
	        onMediaTypeChange = _props2.onMediaTypeChange,
	        onVisibilityChange = _props2.onVisibilityChange,
	        autoclose = _props2.autoclose,
	        autocloseAfterInk = _props2.autocloseAfterInk,
	        onVisibilityToggle = _props2.onVisibilityToggle,
	        closeOnNavItemClick = _props2.closeOnNavItemClick,
	        props = _objectWithoutProperties(_props2, ['id', 'style', 'className', 'navStyle', 'navClassName', 'component', 'navItems', 'header', 'children', 'inline', 'position', 'overlay', 'clickableDesktopOverlay', 'lastChild', 'portal', 'overlayStyle', 'overlayClassName', 'type', 'visible', 'renderNode', 'navItemsId', 'zDepth', 'constantType', 'defaultVisible', 'defaultMedia', 'mobileType', 'mobileMinWidth', 'tabletType', 'tabletMinWidth', 'desktopType', 'desktopMinWidth', 'transitionDuration', 'onMediaTypeChange', 'onVisibilityChange', 'autoclose', 'autocloseAfterInk', 'onVisibilityToggle', 'closeOnNavItemClick']);
	
	    var _props3 = this.props,
	        navItemsId = _props3.navItemsId,
	        zDepth = _props3.zDepth;
	
	    if (!navItemsId && id) {
	      navItemsId = id + '-nav-items';
	    }
	
	    var desktop = this.state.desktop;
	
	    var renderNode = (0, _getField2.default)(this.props, this.context, 'renderNode');
	    var type = (0, _getField2.default)(this.props, this.state, 'type');
	    var visible = (0, _getField2.default)(this.props, this.state, 'visible');
	    var mini = (0, _isType.isMini)(type);
	    var temporary = (0, _isType.isTemporary)(type);
	    var floating = _DrawerTypes2.default.FLOATING === type;
	    var permanent = (0, _isType.isPermanent)(type);
	
	    var Component = void 0;
	    if (component) {
	      Component = component;
	    } else if (navItems) {
	      Component = 'nav';
	    } else {
	      Component = 'aside';
	    }
	
	    var navigation = void 0;
	    if (navItems) {
	      navigation = _react2.default.createElement(
	        _List2.default,
	        {
	          ref: this._setNavigation,
	          key: 'navigation',
	          id: navItemsId,
	          style: navStyle,
	          className: (0, _classnames2.default)('md-list--drawer', {
	            'md-toolbar-relative': mini && !visible,
	            'md-background': floating
	          }, navClassName),
	          onClick: this._handleNavClick
	        },
	        navItems.map(_mapToListParts2.default)
	      );
	    }
	
	    if (typeof zDepth === 'undefined') {
	      zDepth = 1;
	      if (floating || inline) {
	        zDepth = 0;
	      } else if (!mini && temporary) {
	        zDepth = 5;
	      }
	    }
	
	    var overlayVisible = overlay;
	    if (typeof overlayVisible !== 'boolean') {
	      overlayVisible = temporary && !mini && (!desktop || clickableDesktopOverlay) && (animating || visible);
	    }
	
	    var drawer = _react2.default.createElement(
	      _Paper2.default,
	      _extends({}, props, {
	        id: id,
	        key: 'drawer',
	        component: Component,
	        zDepth: zDepth,
	        raiseOnHover: false,
	        style: style,
	        className: (0, _classnames2.default)('md-drawer', (_cn = {}, _cn['md-drawer--' + position] = !inline, _cn['md-drawer--fixed'] = !inline, _cn['md-drawer--inline'] = inline, _cn['md-drawer--active'] = mini || drawerActive, _cn['md-drawer--mini'] = mini, _cn['md-transition--deceleration'] = !mini && !permanent && visible, _cn['md-transition--acceleration'] = !mini && !permanent && !visible, _cn['md-background'] = inline || floating, _cn['md-background--card'] = !floating && !inline, _cn), className)
	      }),
	      header,
	      navigation,
	      children,
	      _react2.default.createElement(_Overlay2.default, {
	        style: overlayStyle,
	        className: overlayClassName,
	        active: overlayActive,
	        onClick: this._closeDrawer,
	        visible: overlayVisible,
	        renderNode: renderNode
	      })
	    );
	
	    if (inline || permanent) {
	      return drawer;
	    } else if (!portal) {
	      return mini || animating || visible ? drawer : null;
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      { visible: animating || visible, renderNode: renderNode, lastChild: lastChild },
	      drawer
	    );
	  };
	
	  return Drawer;
	}(_react.PureComponent);
	
	Drawer.DrawerTypes = _DrawerTypes2.default;
	Drawer.propTypes = {
	  /**
	   * An optional id to provide to the drawer. This is generally a good idea to provide if
	   * there are any `navItems` defined.
	   *
	   * @see {@link #navItemsId}
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to provide to the navItems list. If this is omitted and the `id` prop is
	   * defined, it will be defaulted to `${id}-nav-items`.
	   */
	  navItemsId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the `List` surrounding the `navItems`.
	   */
	  navStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `List` surrounding the `navItems`.
	   */
	  navClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the overlay.
	   */
	  overlayStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the overlay.
	   */
	  overlayClassName: _propTypes2.default.string,
	
	  /**
	   * An optional component to render the drawer in. When this prop is undefined, the drawer
	   * will be rendered as a `nav` if the `navItems` prop is defined, otherwise an `aside`.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	
	  /**
	   * An optional list of navigation items to display in the drawer. This list can either contain
	   * a valid child component for a `List` or an object used to create a `Divider`, `Subheader`,
	   * or `ListItem`.
	   *
	   * - To create a divider in the list, set a `divider` key to `true`. Any other keys will be
	   * passed to the `Divider` component.
	   * - To create a subheader in the list, set the `subheader` key to `true`. Any other keys will
	   * be passed to the `Subheader` component.
	   * - To create a list item, just create an object with any normal `ListItem` props.
	   */
	  navItems: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.shape({
	    divider: _propTypes2.default.bool,
	    subheader: _propTypes2.default.bool,
	    primaryText: _propTypes2.default.node
	  })])),
	
	  /**
	   * Boolean if a temporary drawer should close when a nav item is clicked.
	   */
	  autoclose: _propTypes2.default.bool,
	
	  /**
	   * An optional header to display. This _should_ normally be a toolbar.
	   */
	  header: _propTypes2.default.node,
	
	  /**
	   * Any additional children to display after the `header` and `navItems`.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * The drawer type to use when the current device matches the mobile
	   * media query.
	   */
	  mobileType: _propTypes2.default.oneOf([Drawer.DrawerTypes.TEMPORARY, Drawer.DrawerTypes.TEMPORARY_MINI]).isRequired,
	
	  /**
	   * The min-width to use for the mobile media query.
	   */
	  mobileMinWidth: _propTypes2.default.number.isRequired,
	
	  /**
	   * The drawer type to use when the current device matches the tablet
	   * media query.
	   */
	  tabletType: oneOfDrawerTypes.isRequired,
	
	  /**
	   * The min-width to use for the tablet media query.
	   */
	  tabletMinWidth: _propTypes2.default.number.isRequired,
	
	  /**
	   * The drawer type to use when the current device matches the desktop media
	   * query.
	   */
	  desktopType: oneOfDrawerTypes.isRequired,
	
	  /**
	   * The min-width for a desktop screen.
	   */
	  desktopMinWidth: _propTypes2.default.number.isRequired,
	
	  /**
	   * An optional type to enforce across all media sizes. Since `mobile` devices are
	   * included, you are required to manually specify when the `type` should be `temporary`.
	   *
	   * When the `type` is not one of the `temporary` types, the `onMediaTypeChange` prop
	   * must be provided.
	   */
	  type: function type(props, propName, component) {
	    for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      others[_key - 3] = arguments[_key];
	    }
	
	    var type = props[propName];
	    if ((0, _isType.isTemporary)(type)) {
	      return oneOfDrawerTypes.apply(undefined, [props, propName, component].concat(others));
	    }
	
	    var err = oneOfDrawerTypes.apply(undefined, [props, propName, component].concat(others));
	    if (!err && typeof type !== 'undefined' && !(0, _isType.isMini)(type) && typeof props.onMediaTypeChange === 'undefined') {
	      err = new Error('You provided a `' + propName + '` prop to the ' + component + ' without the `onMediaTypeChange` ' + ('handler. The `onMediaTypeChange` prop must be specified when the `' + propName + '` is not ') + 'one of the `temporary` types.');
	    }
	
	    return err;
	  },
	
	  /**
	   * An optional function to call when the drawer's type changes when the screen resizes.
	   * The callback will include the new `type` that should be used for the screen size,
	   * and an object containing the media matches for `mobile`, `tablet`, and `desktop`.
	   *
	   * ```js
	   * this.props.onMediaTypeChange(Drawer.DrawerTypes.TEMPORARY, {
	   *   mobile: true,
	   *   tablet: false,
	   *   desktop: false,
	   * });
	   * ```
	   */
	  onMediaTypeChange: _propTypes2.default.func,
	
	  /**
	   * The default drawer type to display on initial render. The drawer will automatically
	   * adjust itself to the correct media once it has mounted. This prop is really only useful
	   * for server side rendering.
	   */
	  defaultMedia: _propTypes2.default.oneOf(['mobile', 'tablet', 'desktop']).isRequired,
	
	  /**
	   * Boolean if there should be a visible overlay when the drawer is visible. The default behavior
	   * is to only include a visible overlay when the `type` is `TEMPORARY` or `TEMPORARY_MINI` and
	   * the device is not a desktop.
	   *
	   * Definining this variable as `true` or `false` will override any default behavior. This means that
	   * if this is enabled for a full-height drawer, an overlay will still be created.
	   */
	  overlay: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the Portal's functionality of rendering in a separate react tree should be applied
	   * to the drawer. The overlay that appears for temporary type drawers will still appear in the
	   * separate subtree.
	   *
	   * @see {@link Helpers/Portal}
	   */
	  portal: _propTypes2.default.bool,
	
	  /**
	   * An optional DOM Node to render the drawer into. The default is to render as
	   * the first child in the `body`.
	   *
	   * > This prop will not be used when the drawer is of the permanent type or `inline` is specified
	   * since the `Portal` component will not be used.
	   */
	  renderNode: _propTypes2.default.object,
	
	  /**
	   * Boolean if the drawer should be rendered as the last child instead of the first child
	   * in the `renderNode` or `body`.
	   *
	   * > This prop will not be used when the drawer is of the permanent type or `inline` is specified
	   * since the `Portal` component will not be used.
	   */
	  lastChild: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the drawer is visible by default. If this is omitted, the drawer will be visible
	   * if the current drawer type is NOT `Drawer.DrawerTypes.TEMPORARY` or `Drawer.DrawerTypes.TEMPORARY_MINI`.
	   *
	   * This basically means that if you are using the default configuration, a mobile device's drawer
	   * will be hidden while tablets and desktops will be visible.
	   */
	  defaultVisible: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the drawer is visible. This will force the component to define the `onVisibilityChange`
	   * prop as well as manually updating the drawer's visibility.
	   */
	  visible: (0, _controlled2.default)(_propTypes2.default.bool, 'onVisibilityChange', 'defaultVisible'),
	
	  /**
	   * An optional function to call when the visibility of the drawer is changed. The function will
	   * be called with the new visibility state.
	   *
	   * ```js
	   * onVisibilityChange(!currentlyVisible);
	   * ```
	   */
	  onVisibilityChange: _propTypes2.default.func,
	
	  /**
	   * The drawer's position on the page when it is not `inline`. When the drawer's position is `left`,
	   * the width will be `calc(100vw - 56px)` on mobile devices and `$md-drawer-desktop-width` on desktops.
	   *
	   * When the position is `right`, the width will be `100vw` for mobile devices and scaling to the drawer's
	   * children width on desktops.
	   */
	  position: _propTypes2.default.oneOf(['left', 'right']).isRequired,
	
	  /**
	   * Boolean if the drawer should be displayed inline instead of fixed to the page. When this prop
	   * is enabled, the `position` prop will not be used.
	   */
	  inline: _propTypes2.default.bool,
	
	  /**
	   * The `$md-drawer-transition-time` value from sass.
	   */
	  transitionDuration: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the temporary drawer's overlay should be created on desktop screens. This is really used so that
	   * the drawer will close when a user clicks anywhere on the page except in the drawer.
	   */
	  clickableDesktopOverlay: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `autoclose` feature should wait for the ink transition to finish before automatically
	   * closing the drawer. This will add a `300ms` delay. If this is `false`, there will only be a `17ms` delay.
	   *
	   * > The delay is required so that any event listeners will still be correctly invoked when an item is clicked.
	   */
	  autocloseAfterInk: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `type` prop should be constant across all media sizes. This is only valid if the `type` is
	   * one of the temporary types.
	   *
	   * This will basically mean that when attempting to do a media adjustment, it will use the `type` prop instead of
	   * `mobileType`, `tabletType`, and `desktopType` to determine the next drawer type.
	   */
	  constantType: _propTypes2.default.bool.isRequired,
	
	  /**
	   * An optional zDepth to apply to the drawer. If this is omitted, the value will be set as follows:
	   * - floating || inline = 1
	   * - temporary = 5
	   * - all others = 1
	   *
	   * @see {@link Papers/Paper#zDepth}
	   */
	  zDepth: _propTypes2.default.number,
	
	  closeOnNavItemClick: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `autoclose` instead'),
	  onVisibilityToggle: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `onVisibilityChange` instead')
	};
	Drawer.defaultProps = {
	  defaultMedia: 'mobile',
	  mobileType: Drawer.DrawerTypes.TEMPORARY,
	  mobileMinWidth: _media.MOBILE_MIN_WIDTH,
	  tabletType: Drawer.DrawerTypes.PERSISTENT,
	  tabletMinWidth: _media.TABLET_MIN_WIDTH,
	  desktopType: Drawer.DrawerTypes.FULL_HEIGHT,
	  desktopMinWidth: _media.DESKTOP_MIN_WIDTH,
	  position: 'left',
	  transitionDuration: 300,
	  autoclose: true,
	  clickableDesktopOverlay: true,
	  constantType: true
	};
	Drawer.contextTypes = {
	  renderNode: _propTypes2.default.object
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._updateType = function (props) {
	    var onMediaTypeChange = props.onMediaTypeChange,
	        overlay = props.overlay,
	        transitionDuration = props.transitionDuration;
	
	
	    var onVisibilityChange = props.onVisibilityToggle || props.onVisibilityChange;
	
	    var state = Drawer.getCurrentMedia(props);
	    var diffType = (0, _getField2.default)(props, _this2.state, 'type') !== state.type;
	    var diffMedia = state.mobile !== _this2.state.mobile || state.tablet !== _this2.state.tablet || state.desktop !== _this2.state.desktop;
	
	    if (onMediaTypeChange && (diffType || diffMedia)) {
	      onMediaTypeChange(state.type, { mobile: state.mobile, tablet: state.tablet, desktop: state.desktop });
	    }
	
	    if (diffType) {
	      var visible = (0, _isType.isPermanent)(state.type);
	      if (_this2._initialFix) {
	        if (props.defaultVisible) {
	          visible = props.defaultVisible;
	        } else if (props.visible) {
	          visible = props.visible;
	        }
	      }
	
	      var prevVisible = (0, _getField2.default)(props, _this2.state, 'visible');
	      if (onVisibilityChange && visible !== prevVisible) {
	        onVisibilityChange(visible);
	      }
	
	      if (typeof props.visible === 'undefined') {
	        state.visible = visible;
	        _this2._animate(visible, state.type, transitionDuration, overlay, state.desktop);
	      }
	    } else if (_this2._initialFix && diffMedia) {
	      state.overlayActive = (typeof overlay !== 'undefined' ? overlay : (0, _isType.isTemporary)(state.type) && !state.desktop) && (0, _getField2.default)(props, _this2.state, 'visible');
	    }
	
	    if (typeof props.type !== 'undefined') {
	      var _state2 = state,
	          type = _state2.type,
	          realState = _objectWithoutProperties(_state2, ['type']); // eslint-disable-line no-unused-vars
	
	
	      state = realState;
	    }
	
	    _this2._initialFix = false;
	    _this2.setState(state);
	  };
	
	  this._updateMedia = function () {
	    _this2._updateType(_this2.props);
	  };
	
	  this._animate = function (visible, type, timeout, overlay, desktop) {
	    if (_this2._timeout) {
	      clearTimeout(_this2._timeout);
	    }
	
	    if (visible) {
	      _this2._timeout = setTimeout(function () {
	        _this2._timeout = null;
	
	        _this2.setState({
	          overlayActive: overlay || (0, _isType.isTemporary)(type) && !desktop,
	          drawerActive: true,
	          animating: true
	        });
	      }, _CSSTransitionGroupTick2.default);
	    } else {
	      _this2._timeout = setTimeout(function () {
	        _this2._timeout = null;
	
	        _this2.setState({ animating: false });
	      }, timeout);
	      _this2.setState({ animating: true, overlayActive: false, drawerActive: false });
	    }
	  };
	
	  this._setNavigation = function (navigation) {
	    _this2._navigation = (0, _reactDom.findDOMNode)(navigation);
	  };
	
	  this._handleNavClick = function (e) {
	    var _props4 = _this2.props,
	        closeOnNavItemClick = _props4.closeOnNavItemClick,
	        autoclose = _props4.autoclose,
	        autocloseAfterInk = _props4.autocloseAfterInk;
	
	    var enabled = typeof closeOnNavItemClick !== 'undefined' ? closeOnNavItemClick : autoclose;
	    if (!enabled || !(0, _isType.isTemporary)((0, _getField2.default)(_this2.props, _this2.state, 'type'))) {
	      return;
	    }
	
	    var target = e.target;
	
	    while (target && _this2._navigation.contains(target)) {
	      if (target.classList.contains('md-list-tile')) {
	        // Clicked a nav item that has a nested list
	        if (target.getAttribute('aria-expanded') !== null) {
	          return;
	        }
	
	        _this2._closeTimeout = setTimeout(function () {
	          _this2._closeTimeout = null;
	
	          _this2._closeDrawer(e);
	        }, autocloseAfterInk ? 300 : _CSSTransitionGroupTick2.default);
	        return;
	      }
	
	      target = target.parentNode;
	    }
	  };
	
	  this._closeDrawer = function () {
	    var _props5 = _this2.props,
	        onVisibilityChange = _props5.onVisibilityChange,
	        onVisibilityToggle = _props5.onVisibilityToggle,
	        transitionDuration = _props5.transitionDuration,
	        overlay = _props5.overlay;
	
	    var callback = onVisibilityToggle || onVisibilityChange;
	    if (callback) {
	      callback(false);
	    }
	
	    if (typeof _this2.props.visible === 'undefined') {
	      _this2.setState({ visible: false });
	      _this2._animate(false, (0, _getField2.default)(_this2.props, _this2.state, 'type'), transitionDuration, overlay, _this2.state.desktop);
	    }
	  };
	};
	
	exports.default = Drawer;

/***/ }),
/* 167 */,
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(11);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `ListItemText` component is used to render the `primaryText` and an optional
	 * `secondaryText` for a `ListItem`.
	 */
	var ListItemText = function (_PureComponent) {
	  _inherits(ListItemText, _PureComponent);
	
	  function ListItemText() {
	    _classCallCheck(this, ListItemText);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  ListItemText.prototype.render = function render() {
	    var _cn;
	
	    var _props = this.props,
	        active = _props.active,
	        activeClassName = _props.activeClassName,
	        disabled = _props.disabled,
	        primaryText = _props.primaryText,
	        primaryTextStyle = _props.primaryTextStyle,
	        primaryTextClassName = _props.primaryTextClassName,
	        secondaryText = _props.secondaryText,
	        secondaryTextStyle = _props.secondaryTextStyle,
	        secondaryTextClassName = _props.secondaryTextClassName,
	        className = _props.className,
	        threeLines = _props.threeLines,
	        props = _objectWithoutProperties(_props, ['active', 'activeClassName', 'disabled', 'primaryText', 'primaryTextStyle', 'primaryTextClassName', 'secondaryText', 'secondaryTextStyle', 'secondaryTextClassName', 'className', 'threeLines']);
	
	    var secondaryTextNode = void 0;
	    if (secondaryText) {
	      secondaryTextNode = _react2.default.createElement(
	        'div',
	        {
	          style: secondaryTextStyle,
	          className: (0, _classnames2.default)('md-tile-text--secondary', {
	            'md-tile-text--three-lines': threeLines
	          }, (0, _themeColors2.default)({ disabled: disabled, hint: !disabled }), secondaryTextClassName)
	        },
	        secondaryText
	      );
	    }
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, props, { className: (0, _classnames2.default)('md-tile-content', className) }),
	      _react2.default.createElement(
	        'div',
	        {
	          style: primaryTextStyle,
	          className: (0, _classnames2.default)('md-tile-text--primary', (_cn = {}, _cn[activeClassName] = !disabled && active, _cn), (0, _themeColors2.default)({ disabled: disabled, text: !active }), primaryTextClassName)
	        },
	        primaryText
	      ),
	      secondaryTextNode
	    );
	  };
	
	  return ListItemText;
	}(_react.PureComponent);
	
	ListItemText.propTypes = {
	  active: _propTypes2.default.bool,
	  activeClassName: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  primaryText: _propTypes2.default.node.isRequired,
	  primaryTextStyle: _propTypes2.default.object,
	  primaryTextClassName: _propTypes2.default.string,
	  secondaryText: _propTypes2.default.node,
	  secondaryTextStyle: _propTypes2.default.object,
	  secondaryTextClassName: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  threeLines: _propTypes2.default.bool
	};
	exports.default = ListItemText;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A button used to close the persistent navigation drawer. The button will
	 * be generated based on the `NavigationDrawer`'s `contextTypes`.
	 *
	 * This component is really only used if you are using a `persistent` drawer and you
	 * manually created the `drawerHeader` for the `NavigationDrawer`.
	 */
	var CloseButton = function (_PureComponent) {
	  _inherits(CloseButton, _PureComponent);
	
	  function CloseButton() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CloseButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this._handleClick = function (e) {
	      if (_this.props.onClick) {
	        _this.props.onClick(e);
	      }
	
	      if (_this.context.onCloseClick) {
	        _this.context.onCloseClick(e);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CloseButton.prototype.render = function render() {
	    var closeIcon = this.context.closeIcon;
	
	
	    return _react2.default.createElement(_Button2.default, _extends({}, this.props, {
	      icon: true,
	      key: 'close',
	      onClick: this._handleClick,
	      iconEl: closeIcon
	    }));
	  };
	
	  return CloseButton;
	}(_react.PureComponent);
	
	CloseButton.propTypes = {
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional additional function to call when the `click` event is triggered.
	   */
	  onClick: _propTypes2.default.func
	};
	CloseButton.contextTypes = {
	  closeIcon: _propTypes2.default.element,
	  onCloseClick: _propTypes2.default.func
	};
	exports.default = CloseButton;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This is an accessibility only component that should be used in the `NavigationDrawer`
	 * component. It allows keyboard users to quickly jump to the main content.
	 *
	 * This component relies on the `contextTypes` of the `NavigationDrawer` to work. If this is going
	 * to be used outside of that component, you will need to specify an `id` and `label` contextType
	 * to pass to this component.
	 */
	var JumpToContentLink = function (_PureComponent) {
	  _inherits(JumpToContentLink, _PureComponent);
	
	  function JumpToContentLink() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, JumpToContentLink);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this._handleClick = function (e) {
	      if (_this.props.onClick) {
	        _this.props.onClick(e);
	      }
	
	      document.getElementById(_this.context.id).focus();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  JumpToContentLink.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = _objectWithoutProperties(_props, ['className']);
	
	    var _context = this.context,
	        id = _context.id,
	        label = _context.label;
	
	    return _react2.default.createElement(
	      'a',
	      _extends({}, props, {
	        id: 'jump-to-' + id,
	        href: '#' + id,
	        onClick: this._handleClick,
	        className: (0, _classnames2.default)('md-content-jump', className)
	      }),
	      label
	    );
	  };
	
	  return JumpToContentLink;
	}(_react.PureComponent);
	
	JumpToContentLink.propTypes = {
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional function to call when the linked is clicked.
	   */
	  onClick: _propTypes2.default.func
	};
	JumpToContentLink.contextTypes = {
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	  label: _propTypes2.default.node.isRequired
	};
	exports.default = JumpToContentLink;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _isInvalidAnimate = __webpack_require__(124);
	
	var _isInvalidAnimate2 = _interopRequireDefault(_isInvalidAnimate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Snackbar = function (_PureComponent) {
	  _inherits(Snackbar, _PureComponent);
	
	  function Snackbar() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Snackbar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this._handleClick = function (e) {
	      var _this$props = _this.props,
	          onDismiss = _this$props.onDismiss,
	          action = _this$props.toast.action,
	          leaveTimeout = _this$props.leaveTimeout,
	          multiline = _this$props.multiline;
	
	      if (typeof action.onClick === 'function') {
	        action.onClick(e);
	      }
	
	      if (_this._fab) {
	        _this._fab._animateForSnackbar(multiline, leaveTimeout);
	      }
	
	      onDismiss();
	    }, _this._clearTimeout = function () {
	      if (_this._timeout) {
	        clearTimeout(_this._timeout);
	        _this._timeout = null;
	      }
	    }, _this._handleAutohide = function () {
	      var _this$props2 = _this.props,
	          autohide = _this$props2.autohide,
	          autohideTimeout = _this$props2.autohideTimeout,
	          onDismiss = _this$props2.onDismiss,
	          multiline = _this$props2.multiline,
	          leaveTimeout = _this$props2.leaveTimeout;
	
	      if (!autohide) {
	        return;
	      }
	
	      window.addEventListener('blur', _this._handleWindowBlur);
	      _this._eventType = 'blur';
	      _this._timeout = setTimeout(function () {
	        _this._timeout = null;
	        _this._eventType = null;
	
	        window.removeEventListener('blur', _this._handleWindowBlur);
	
	        if (_this._fab) {
	          _this._fab._animateForSnackbar(multiline, leaveTimeout);
	        }
	
	        onDismiss();
	      }, autohideTimeout || _this.state.toast);
	    }, _this._handleWindowBlur = function () {
	      _this._clearTimeout();
	      window.removeEventListener('blur', _this._handleWindowBlur);
	      window.addEventListener('focus', _this._handleWindowFocus);
	      _this._eventType = 'focus';
	    }, _this._handleWindowFocus = function () {
	      window.removeEventListener('focus', _this._handleWindowFocus);
	      _this._eventType = null;
	      _this._handleAutohide();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Snackbar.prototype.componentWillMount = function componentWillMount() {
	    var _props = this.props,
	        fab = _props.fab,
	        multiline = _props.multiline,
	        onAppear = _props.toast.onAppear;
	
	    if (onAppear) {
	      onAppear();
	    }
	
	    if (!fab || (0, _isInvalidAnimate2.default)(fab)) {
	      return;
	    }
	
	    this._fab = fab.getComposedComponent().getComposedComponent();
	    this._fab._animateForSnackbar(multiline);
	  };
	
	  Snackbar.prototype.componentDidMount = function componentDidMount() {
	    this._handleAutohide();
	  };
	
	  Snackbar.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._clearTimeout();
	
	    if (this._eventType === 'focus') {
	      window.removeEventListener('focus', this._handleWindowFocus);
	    } else if (this._eventType === 'blur') {
	      window.removeEventListener('blur', this._handleWindowBlur);
	    }
	  };
	
	  Snackbar.prototype.render = function render() {
	    var _props2 = this.props,
	        className = _props2.className,
	        toast = _props2.toast,
	        multiline = _props2.multiline,
	        propId = _props2.id,
	        fab = _props2.fab,
	        autohide = _props2.autohide,
	        autohideTimeout = _props2.autohideTimeout,
	        leaveTimeout = _props2.leaveTimeout,
	        onDismiss = _props2.onDismiss,
	        props = _objectWithoutProperties(_props2, ['className', 'toast', 'multiline', 'id', 'fab', 'autohide', 'autohideTimeout', 'leaveTimeout', 'onDismiss']);
	
	    var text = toast.text,
	        action = toast.action;
	    var id = this.props.id;
	
	
	    var Component = 'p';
	    if (action) {
	      Component = 'section';
	      text = _react2.default.createElement(
	        'p',
	        { className: 'md-snackbar--toast md-snackbar--action' },
	        text
	      );
	
	      var btnProps = {
	        flat: true,
	        onClick: this._handleClick,
	        children: action,
	        secondary: true,
	        className: 'md-btn--snackbar'
	      };
	
	      if (typeof action !== 'string') {
	        btnProps = Object.assign(btnProps, action, {
	          className: (0, _classnames2.default)(btnProps.className, action.className),
	          onClick: this._handleClick
	        });
	      }
	
	      action = _react2.default.createElement(_Button2.default, btnProps);
	    }
	
	    if (!id) {
	      id = 'snackbar-alert' + (action ? '-dialog' : '');
	    }
	
	    var role = 'alert' + (action ? 'dialog' : '');
	    return _react2.default.createElement(
	      Component,
	      _extends({}, props, {
	        id: id,
	        role: role,
	        className: (0, _classnames2.default)('md-snackbar', {
	          'md-snackbar--multiline': multiline,
	          'md-snackbar--toast': !action
	        }, className)
	      }),
	      text,
	      action
	    );
	  };
	
	  return Snackbar;
	}(_react.PureComponent);
	
	Snackbar.propTypes = {
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  onDismiss: _propTypes2.default.func.isRequired,
	  toast: _propTypes2.default.shape({
	    text: _propTypes2.default.node.isRequired,
	    action: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.shape({
	      label: _propTypes2.default.node,
	      children: _propTypes2.default.node,
	      onClick: _propTypes2.default.func
	    })]),
	    onAppear: _propTypes2.default.func
	  }).isRequired,
	  multiline: _propTypes2.default.bool,
	  autohide: _propTypes2.default.bool,
	  autohideTimeout: _propTypes2.default.number,
	  fab: _propTypes2.default.object,
	  leaveTimeout: _propTypes2.default.number.isRequired
	};
	exports.default = Snackbar;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(5);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _invalidIf = __webpack_require__(43);
	
	var _invalidIf2 = _interopRequireDefault(_invalidIf);
	
	var _between = __webpack_require__(91);
	
	var _between2 = _interopRequireDefault(_between);
	
	var _Paper = __webpack_require__(37);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _ToolbarTitle = __webpack_require__(244);
	
	var _ToolbarTitle2 = _interopRequireDefault(_ToolbarTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Toolbar = function (_PureComponent) {
	  _inherits(Toolbar, _PureComponent);
	
	  function Toolbar() {
	    _classCallCheck(this, Toolbar);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  Toolbar.prototype.render = function render() {
	    var _props = this.props,
	        style = _props.style,
	        className = _props.className,
	        component = _props.component,
	        titleStyle = _props.titleStyle,
	        titleClassName = _props.titleClassName,
	        prominentTitle = _props.prominentTitle,
	        themed = _props.themed,
	        singleColor = _props.singleColor,
	        actions = _props.actions,
	        fixed = _props.fixed,
	        children = _props.children,
	        inset = _props.inset,
	        titleId = _props.titleId,
	        propNav = _props.nav,
	        propTitle = _props.title,
	        propTitleMenu = _props.titleMenu,
	        propZDepth = _props.zDepth,
	        propColored = _props.colored,
	        propProminent = _props.prominent,
	        containerStyle = _props.containerStyle,
	        containerClassName = _props.containerClassName,
	        actionLeft = _props.actionLeft,
	        actionsRight = _props.actionsRight,
	        primary = _props.primary,
	        secondary = _props.secondary,
	        props = _objectWithoutProperties(_props, ['style', 'className', 'component', 'titleStyle', 'titleClassName', 'prominentTitle', 'themed', 'singleColor', 'actions', 'fixed', 'children', 'inset', 'titleId', 'nav', 'title', 'titleMenu', 'zDepth', 'colored', 'prominent', 'containerStyle', 'containerClassName', 'actionLeft', 'actionsRight', 'primary', 'secondary']);
	
	    var _props2 = this.props,
	        colored = _props2.colored,
	        title = _props2.title,
	        titleMenu = _props2.titleMenu,
	        nav = _props2.nav,
	        prominent = _props2.prominent,
	        zDepth = _props2.zDepth;
	
	
	    colored = colored || primary || secondary;
	    prominent = prominent || prominentTitle;
	
	    title = _react2.default.createElement(_ToolbarTitle2.default, {
	      key: 'title',
	      style: titleStyle,
	      className: titleClassName,
	      prominent: prominentTitle,
	      offset: prominentTitle,
	      id: typeof titleId === 'undefined' && props.id ? props.id + '-title' : titleId,
	      title: title
	    });
	
	    if (nav || actionLeft) {
	      var navEl = _react.Children.only(nav || actionLeft);
	      nav = (0, _react.cloneElement)(nav, {
	        className: (0, _classnames2.default)('md-btn--toolbar md-toolbar--action-left', navEl.props.className)
	      });
	    }
	
	    var rightActions = void 0;
	    if (actions || actionsRight) {
	      rightActions = _react.Children.map(_react.Children.toArray(actions || actionsRight), function (action) {
	        return (0, _react.cloneElement)(action, {
	          className: (0, _classnames2.default)('md-btn--toolbar', action.props.className)
	        });
	      });
	
	      rightActions = _react2.default.createElement(
	        'div',
	        { key: 'actions', className: 'md-cell--right md-toolbar--action-right' },
	        rightActions
	      );
	    }
	
	    if (titleMenu) {
	      titleMenu = _react.Children.only(titleMenu);
	      titleMenu = (0, _react.cloneElement)(titleMenu, {
	        className: (0, _classnames2.default)('md-title md-title--toolbar md-select-field--toolbar', {
	          'md-title--toolbar-offset': prominentTitle,
	          'md-title--toolbar-prominent': prominentTitle
	        }, titleMenu.props.className),
	        position: titleMenu.props.position || 'tl',
	        toolbar: true
	      });
	    }
	
	    if (typeof zDepth !== 'number') {
	      zDepth = fixed ? 2 : 0;
	    }
	
	    return _react2.default.createElement(
	      _Paper2.default,
	      _extends({}, props, {
	        component: component,
	        zDepth: zDepth,
	        style: style,
	        className: (0, _classnames2.default)('md-toolbar', {
	          'md-background--primary': colored,
	          'md-toolbar--themed': themed,
	          'md-toolbar--text-white': singleColor && colored,
	          'md-toolbar--prominent': prominent,
	          'md-toolbar--fixed': fixed,
	          'md-toolbar--inset': inset
	        }, className)
	      }),
	      nav,
	      title,
	      titleMenu,
	      children,
	      rightActions
	    );
	  };
	
	  return Toolbar;
	}(_react.PureComponent);
	
	Toolbar.propTypes = {
	  /**
	   * An optional id to provide to the toolbar. If this is specified and the `titleId` is not, the title
	   * will gain an id of `${id}-title`. This will not be applied to the `titleMenu`.
	   *
	   * @see {@link #titleId}
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply to the toolbar.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the toolbar,
	   */
	  className: _propTypes2.default.string,
	
	  /*
	   * An optional style to apply to the `h2` surrounding the `title` prop.
	   */
	  titleStyle: _propTypes2.default.object,
	
	  /*
	   * An optional className to apply to the `h2` surrounding the `title` prop.
	   */
	  titleClassName: _propTypes2.default.string,
	
	  /**
	   * Boolean if the toolbar should more prominent. This will double the height of the toolbar.
	   */
	  prominent: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the toolbar's title should be more prominent. This will move the title to the
	   * second line of the toolbar. This only works when the `prominent` prop is true as well.
	   */
	  prominentTitle: _propTypes2.default.bool,
	
	  /**
	   * The current title of the page to show in the toolbar. It is invalid to specify both a
	   * `title` and a `titleMenu`. Only one should be given.
	   */
	  title: (0, _invalidIf2.default)(_propTypes2.default.node, 'titleMenu'),
	
	  /**
	   * An optional id to give the main title in the toolbar. This will not be applied to the
	   * `titleMenu`.
	   */
	  titleId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional title menu to display instead of the title. This should be a `SelectField` component.
	   * It is cloned with some additional props, so if the `SelectField` is separated into a separate
	   * component, the following props must be passed to get the correct styling: `className`, `block`,
	   * `paddedBlock`, `position`.
	   */
	  titleMenu: _propTypes2.default.element,
	
	  /**
	   * This prop is used for rendering an optional navigation button to the left of the `title`
	   * or the `titleMenu` component. This needs to be an icon `Button` because some additional props
	   * are cloned into it.
	   */
	  nav: _propTypes2.default.element,
	
	  /**
	   * Any additional actions to display to the right of the title. This should be a list or a single
	   * `Button` to display. The buttons get cloned with an additional className for toolbar styling.
	   */
	  actions: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)]),
	
	  /**
	   * Any children to display in the toolbar. This will be displayed between the optional title and
	   * actions.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * Boolean if the toolbar should be fixed to the top of the page. This will add some additional box shadow.
	   */
	  fixed: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the nav, actions, and title should share the same color. For a `colored` or dark `themed`
	   * toolbar, they will all be colored white. For a transparent or light `themed` toolbar, the colors will
	   * be the `rgba(0, 0, 0, .87)`. Setting this to false will only style the title to the specific color
	   * stated above.
	   */
	  singleColor: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the toolbar should be colored based off the current theme. This will either style the background
	   * to be fairly white, or fairly black. You can not specify both `themed` and `colored`.
	   */
	  themed: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the toolbar should be colored with the `$md-primary-color`.
	   */
	  colored: (0, _invalidIf2.default)(_propTypes2.default.bool, 'themed'),
	
	  /**
	   * The component to render the toolbar as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * Boolean if the toolbar is inset in the page. This will just add some margin around
	   * it.
	   */
	  inset: _propTypes2.default.bool,
	
	  /**
	   * An optional zDepth to enforce for the toolbar. This should be a number between 0 and 5.
	   * If this is omitted, the toolbar will gain a zDepth of 2 when `fixed`.
	   */
	  zDepth: (0, _between2.default)(_propTypes2.default.number, 0, 5),
	  containerStyle: (0, _deprecated2.default)(_propTypes2.default.object, 'The `container` no longer exists in the `Toolbar`. Use the `style` prop instead'),
	  containerClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'The `container` no longer exists in the `Toolbar`. Use the `className` prop instead'),
	  primary: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use the `colored` prop instead'),
	  secondary: (0, _deprecated2.default)(_propTypes2.default.bool, 'Toolbars can no longer be themed to the secondary color. Use the `colored` prop instead'),
	  actionLeft: (0, _deprecated2.default)(_propTypes2.default.element, 'Use the `nav` prop instead'),
	  actionsRight: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `menu` prop and/or the `actions` prop instead')
	};
	Toolbar.defaultProps = {
	  singleColor: true,
	  component: 'header'
	};
	exports.default = Toolbar;

/***/ }),
/* 173 */,
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = viewport;
	
	var _getScreenSize = __webpack_require__(127);
	
	var _getScreenSize2 = _interopRequireDefault(_getScreenSize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Determines if an element is still in the viewport. If it is,
	 * it will return a `true` boolean. If it is not, it will return
	 * an object containing booleans for top, right, bottom, and left
	 * where a `false` value will mean it is out of the viewport for that
	 * position.
	 *
	 * @param {Object} el - The element to test.
	 * @return {boolean|Object} the results.
	 */
	function viewport(el) {
	  if (!el) {
	    return {};
	  }
	
	  var rect = el.getBoundingClientRect();
	  var top = rect.top >= 0;
	  var right = rect.right <= (0, _getScreenSize2.default)('Width');
	  var bottom = rect.bottom <= (0, _getScreenSize2.default)('Height');
	  var left = rect.left >= 0;
	
	  return top && right && bottom && left || { top: top, right: right, bottom: bottom, left: left };
	} /** @module utils/Positioning/viewport */

/***/ }),
/* 175 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = oneRequiredForA11y;
	/** @module utils/PropTypes/oneRequiredForA11y */
	
	/**
	 * This validator checks that either the current prop is defined and valid or that one of the
	 * other given prop names are defined. If it fails it returns an error for a11y.
	 *
	 * @param {function} validator - The React PropTypes validator to use for the given prop.
	 * @param {String[]} otherPropNames - Any other prop names to validate against.
	 * @return {Error} an error or null
	 */
	function oneRequiredForA11y(validator) {
	  for (var _len = arguments.length, otherPropNames = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    otherPropNames[_key - 1] = arguments[_key];
	  }
	
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	    var allPropNames = [propFullNameSafe].concat(otherPropNames);
	
	    for (var _len2 = arguments.length, args = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
	      args[_key2 - 5] = arguments[_key2];
	    }
	
	    var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	    if (!err && !allPropNames.filter(function (pn) {
	      return typeof props[pn] !== 'undefined';
	    }).length) {
	      err = new Error('One of the following props are required to make ' + componentNameSafe + ' accessible ' + ('for users of assistive technologies such as screen readers. `' + allPropNames.join('`, `') + '`.'));
	    }
	
	    return err;
	  };
	}

/***/ }),
/* 176 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isValued;
	/** @module utils/isValied */
	
	/**
	 * A really simple utility function to check if an input's value is considered "valued".
	 *
	 * @param {string|number} v - the value to check
	 * @return {boolean} true if the value is a number or a non-empty string.
	 */
	function isValued(v) {
	  return v === 0 || !!v;
	}

/***/ }),
/* 177 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = omit;
	/** @module utils/omit */
	
	/**
	 * This should hopefully be very similar to lodash's omit function. It will
	 * take an object and return a new object without any of the given keys.
	 *
	 * @param {Object} obj - The object to omit keys from.
	 * @param {Array.<String>} keys - a list of keys to remove.
	 */
	function omit(obj, keys) {
	  if (!obj) {
	    return {};
	  } else if (!keys || !keys.length) {
	    return obj;
	  }
	
	  return Object.keys(obj).filter(function (key) {
	    return keys.indexOf(key) === -1;
	  }).reduce(function (newProps, key) {
	    newProps[key] = obj[key];
	
	    return newProps;
	  }, {});
	}

/***/ }),
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _contextTypes = __webpack_require__(163);
	
	var _contextTypes2 = _interopRequireDefault(_contextTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _extends({}, _contextTypes2.default, { header: _propTypes2.default.bool });

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withTableFixes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(7);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _getField = __webpack_require__(8);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _fixedToShape = __webpack_require__(19);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _findTable = __webpack_require__(164);
	
	var _findTable2 = _interopRequireDefault(_findTable);
	
	var _findFixedTo = __webpack_require__(334);
	
	var _findFixedTo2 = _interopRequireDefault(_findFixedTo);
	
	var _getDisplayName = __webpack_require__(250);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This is a utility HOC to fix the components that use the `Menu` component behind the scenes. This will
	 * correctly add the `id` and `fixedTo` props if they are omitted from the child component's props.
	 *
	 * If the id prop is omitted, it will default to the `${rowId}-${cellIndex}-${suffix}` and when the
	 * `fixedTo` prop is omitted, it will automatically set it to the responsive table wrapper so that
	 * it will stay in viewport as expected.
	 *
	 * This component also attempts to find the `cellIndex` prop if it is not correctly cloned into the
	 * component.
	 *
	 * @param {function|Class} ComposedComponent - the component to compose with the tooltip functionality.
	 * @param {String} suffix - the id suffix to apply.
	 * @return {Class} the ComposedComponent with some fixes applied.
	 */
	function withTableFixes(ComposedComponent, suffix) {
	  var _class, _temp2;
	
	  return _temp2 = _class = function (_PureComponent) {
	    _inherits(TableFixesComponent, _PureComponent);
	
	    function TableFixesComponent() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, TableFixesComponent);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = { cellIndex: undefined }, _this._fixedTo = null, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    TableFixesComponent.prototype.componentDidMount = function componentDidMount() {
	      var _props = this.props,
	          cellIndex = _props.cellIndex,
	          fixedTo = _props.fixedTo,
	          id = _props.id;
	
	      var isIndexed = !!id || cellIndex === 0 || !!cellIndex;
	      var isFixed = fixedTo === null || !!fixedTo;
	      if (isIndexed && isFixed) {
	        // all is good
	        return;
	      }
	
	      var column = (0, _reactDom.findDOMNode)(this);
	      var table = (0, _findTable2.default)(column);
	      this._fixedTo = (0, _findFixedTo2.default)(table);
	
	      // If a developer creates their own component to wrap the component that uses a menu, the cellIndex prop
	      // might not be defined if they don't pass ...props
	      if (!isIndexed) {
	        var columns = [].slice.call(column.parentNode.querySelectorAll('th,td'));
	        this.setState({ cellIndex: columns.indexOf(column) }); // eslint-disable-line react/no-did-mount-set-state
	      } else if (this._fixedTo) {
	        // need to apply the _fixedTo for the select field
	        this.forceUpdate();
	      }
	    };
	
	    TableFixesComponent.prototype.render = function render() {
	      var rowId = this.context.rowId;
	
	      var _props2 = this.props,
	          propid = _props2.id,
	          propFixedTo = _props2.fixedTo,
	          propCellIndex = _props2.cellIndex,
	          props = _objectWithoutProperties(_props2, ['id', 'fixedTo', 'cellIndex']);
	
	      var id = this.props.id;
	
	      var fixedTo = this._fixedTo === null || propFixedTo ? propFixedTo : this._fixedTo;
	      var cellIndex = (0, _getField2.default)(this.props, this.state, 'cellIndex');
	      if (!id) {
	        id = rowId + '-' + cellIndex + '-' + suffix;
	      }
	
	      return _react2.default.createElement(ComposedComponent, _extends({}, props, { id: id, fixedTo: fixedTo }));
	    };
	
	    return TableFixesComponent;
	  }(_react.PureComponent), _class.Positions = ComposedComponent.Positions, _class.HorizontalAnchors = ComposedComponent.HorizontalAnchors, _class.VerticalAnchors = ComposedComponent.VerticalAnchors, _class.displayName = (0, _getDisplayName2.default)(ComposedComponent, 'TableFixes'), _class.propTypes = {
	    id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    cellIndex: _propTypes2.default.number,
	    fixedTo: _fixedToShape2.default
	  }, _class.contextTypes = {
	    rowId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	  }, _temp2;
	}

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(7);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _isRequiredForA11y = __webpack_require__(16);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _oneRequiredForA11y = __webpack_require__(175);
	
	var _oneRequiredForA11y2 = _interopRequireDefault(_oneRequiredForA11y);
	
	var _FocusContainer = __webpack_require__(338);
	
	var _FocusContainer2 = _interopRequireDefault(_FocusContainer);
	
	var _ResizeObserver = __webpack_require__(35);
	
	var _ResizeObserver2 = _interopRequireDefault(_ResizeObserver);
	
	var _Paper = __webpack_require__(37);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _DialogTitle = __webpack_require__(860);
	
	var _DialogTitle2 = _interopRequireDefault(_DialogTitle);
	
	var _DialogFooter = __webpack_require__(165);
	
	var _DialogFooter2 = _interopRequireDefault(_DialogFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DIFF_KEYS = ['style', 'height', 'width', 'contentStyle'];
	
	/**
	 * The `Dialog` is just a static component for creating dialogs. Dialogs
	 * seemed like they could be used outside of the `DialogContainer` component,
	 * so it was exposed as well. In *most* cases, you will still want to use
	 * the `DialogContainer` component.
	 */
	
	var Dialog = function (_PureComponent) {
	  _inherits(Dialog, _PureComponent);
	
	  function Dialog(props) {
	    _classCallCheck(this, Dialog);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this));
	
	    _initialiseProps.call(_this);
	
	    var height = props.height,
	        width = props.width;
	
	    var styles = props.style;
	    if (height || width) {
	      styles = styles || {};
	      styles = _extends({ height: height, width: width }, styles);
	    }
	
	    _this.state = {
	      styles: styles,
	      contentStyles: props.contentStyle,
	      contentPadded: false
	    };
	    return _this;
	  }
	
	  Dialog.prototype.getChildContext = function getChildContext() {
	    return { renderNode: this._renderNode };
	  };
	
	  Dialog.prototype.componentWillMount = function componentWillMount() {
	    var _props = this.props,
	        pageX = _props.pageX,
	        pageY = _props.pageY;
	
	    if (!pageX || !pageY) {
	      return;
	    }
	
	    this.setState({ styles: this._getStyles(this.props) });
	  };
	
	  Dialog.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.onOpen) {
	      this.props.onOpen();
	    }
	  };
	
	  Dialog.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    if (DIFF_KEYS.some(function (key) {
	      return nextProps[key] !== _this2.props[key];
	    })) {
	      this.setState({
	        styles: this._getStyles(nextProps),
	        contentStyles: _extends({}, this.state.contentStyles, nextProps.contentStyle)
	      });
	    }
	  };
	
	  Dialog.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.props.onLeave) {
	      this.props.onLeave();
	    }
	  };
	
	  Dialog.prototype.render = function render() {
	    var _state = this.state,
	        contentPadded = _state.contentPadded,
	        styles = _state.styles,
	        contentStyles = _state.contentStyles;
	
	    var _props2 = this.props,
	        id = _props2.id,
	        className = _props2.className,
	        titleStyle = _props2.titleStyle,
	        titleClassName = _props2.titleClassName,
	        footerStyle = _props2.footerStyle,
	        footerClassName = _props2.footerClassName,
	        contentClassName = _props2.contentClassName,
	        title = _props2.title,
	        Content = _props2.contentComponent,
	        contentProps = _props2.contentProps,
	        actions = _props2.actions,
	        children = _props2.children,
	        fullPage = _props2.fullPage,
	        centered = _props2.centered,
	        autopadContent = _props2.autopadContent,
	        paddedContent = _props2.paddedContent,
	        autosizeContent = _props2.autosizeContent,
	        stackedActions = _props2.stackedActions,
	        style = _props2.style,
	        contentStyle = _props2.contentStyle,
	        pageX = _props2.pageX,
	        pageY = _props2.pageY,
	        containerX = _props2.containerX,
	        containerY = _props2.containerY,
	        onOpen = _props2.onOpen,
	        onLeave = _props2.onLeave,
	        height = _props2.height,
	        width = _props2.width,
	        props = _objectWithoutProperties(_props2, ['id', 'className', 'titleStyle', 'titleClassName', 'footerStyle', 'footerClassName', 'contentClassName', 'title', 'contentComponent', 'contentProps', 'actions', 'children', 'fullPage', 'centered', 'autopadContent', 'paddedContent', 'autosizeContent', 'stackedActions', 'style', 'contentStyle', 'pageX', 'pageY', 'containerX', 'containerY', 'onOpen', 'onLeave', 'height', 'width']);
	
	    var labelledBy = this.props['aria-labelledby'];
	
	    var titleId = id + '-title';
	    if (!labelledBy && title) {
	      labelledBy = titleId;
	    }
	
	    var padDefined = typeof paddedContent !== 'undefined';
	    var dialogChildren = fullPage ? children : [_react2.default.createElement(
	      _DialogTitle2.default,
	      {
	        key: 'title',
	        id: titleId,
	        style: titleStyle,
	        className: titleClassName
	      },
	      title
	    ), _react2.default.createElement(
	      Content,
	      _extends({
	        ref: !padDefined && autopadContent ? this._setContent : null,
	        key: 'content'
	      }, contentProps, {
	        style: contentStyles,
	        className: (0, _classnames2.default)('md-dialog-content', {
	          'md-dialog-content--padded': padDefined ? paddedContent : contentPadded
	        }, contentClassName)
	      }),
	      autosizeContent ? _react2.default.createElement(_ResizeObserver2.default, { watchHeight: true, watchWidth: true, onResize: this._handleContentResize }) : null,
	      children
	    ), _react2.default.createElement(_DialogFooter2.default, {
	      key: 'footer',
	      style: footerStyle,
	      className: footerClassName,
	      actions: actions,
	      stacked: stackedActions
	    })];
	
	    return _react2.default.createElement(
	      _Paper2.default,
	      _extends({}, props, {
	        id: id,
	        component: _FocusContainer2.default,
	        ref: this._setRenderNode,
	        style: styles,
	        className: (0, _classnames2.default)('md-dialog', {
	          'md-dialog--full-page': fullPage,
	          'md-dialog--centered': centered
	        }, className),
	        role: 'dialog',
	        'aria-labelledby': labelledBy
	      }),
	      dialogChildren
	    );
	  };
	
	  return Dialog;
	}(_react.PureComponent);
	
	Dialog.propTypes = {
	  /**
	   * @see {@link Dialogs/DialogContainer#id}
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * @see {@link Dialogs/DialogContainer#aria-describedby}
	   */
	  'aria-describedby': (0, _oneRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]), 'title', 'aria-labelledby', 'aria-label'),
	
	  /**
	   * @see {@link Dialogs/DialogContainer#aria-labelledby}
	   */
	  'aria-labelledby': _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * @see {@link Dialogs/DialogContainer#aria-label}
	   */
	  'aria-label': _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the dialog.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the dialog.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional styke to apply to the title.
	   */
	  titleStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the title.
	   */
	  titleClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the footer. This is used when the `actions`
	   * prop is defined.
	   */
	  footerStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the footer. This is used when the `actions`
	   * prop is defined.
	   */
	  footerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the dialog's content.
	   */
	  contentStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the dialog's content.
	   */
	  contentClassName: _propTypes2.default.string,
	
	  /**
	   * The component to render the content as. This is helpful if you would like to use
	   * the CSSTransitionGroup. This really just saves a tiny bit of markup.
	   *
	   * ```js
	   * <Dialog
	   *   contentComponent={CSSTransitionGroup}
	   *   contentProps={{
	   *     transitionName: 'md-cross-fade',
	   *     transitionLeave: false,
	   *     transitionEnterTimeout: 150,
	   *   }}
	   * >
	   *   {dynamicContent}
	   * </Dialog>
	   * ```
	   */
	  contentComponent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	  /**
	   * Any additional props to pass to the content component.
	   */
	  contentProps: _propTypes2.default.object,
	
	  /**
	   * An optional title to display in the dialog.
	   */
	  title: _propTypes2.default.node,
	
	  /**
	   * Any children to display in the content of the dialog.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * A single action or a list of actions to display in the dialog. This can either be a list
	   * of `FlatButton` props or `<Button flat {...props} />` elements.
	   */
	  actions: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.object, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.object]))]),
	
	  /**
	   * @see {@link Helpers/FocusContainer#additionalFocusKeys}
	   */
	  additionalFocusKeys: _FocusContainer2.default.propTypes.additionalFocusKeys,
	
	  /**
	   * @see {@link Helpers/FocusContainer#initialFocus}
	   */
	  initialFocus: _FocusContainer2.default.propTypes.initialFocus,
	
	  /**
	   * @see {@link Helpers/FocusContainer#focusOnMount}
	   */
	  focusOnMount: _FocusContainer2.default.propTypes.focusOnMount,
	
	  /**
	   * @see {@link Helpers/FocusContainer#containFocus}
	   */
	  containFocus: _FocusContainer2.default.propTypes.containFocus,
	
	  /**
	   * An optional x coordinate on the page that caused a full page dialog
	   * to be created. This is really just used for a `transformOrigin` style.
	   */
	  pageX: _propTypes2.default.number,
	
	  /**
	   * An optional y coordinate on the page that caused a full page dialog
	   * to be created. This is really just used for a `transformOrigin` style.
	   */
	  pageY: _propTypes2.default.number,
	
	  /**
	   * An optional x scroll position of the container holding the dialog. This
	   * is really just used for a `transformOrigin` style on full page dialogs.
	   */
	  containerX: _propTypes2.default.number,
	
	  /**
	   * An optional y scroll position of the container holding the dialog. This
	   * is really just used for a `transformOrigin` style on full page dialogs.
	   */
	  containerY: _propTypes2.default.number,
	
	  /**
	   * Boolean if the dialog should be rendered as a full page dialog.
	   */
	  fullPage: _propTypes2.default.bool,
	
	  /**
	   * The zDepth to use for the dialog.
	   */
	  zDepth: _propTypes2.default.number.isRequired,
	
	  /**
	   * An optional function to call when the dialog has been opened. This is
	   * really just used for the `DialogContainer`.
	   */
	  onOpen: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the dialog has been closed. This is
	   * really just used for the `DialogContainer`.
	   */
	  onLeave: _propTypes2.default.func,
	
	  /**
	   * Boolean if the dialog should be centered in the page.
	   */
	  centered: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the content should be padded. This will take precedence
	   * over the `autopadContent` prop. So if this is defined, that value
	   * will be used instead of any thing that was was calculated in this
	   * component.
	   *
	   * @see {@link #autopadContent}
	   */
	  paddedContent: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the dialog should automatically try to determine if the content
	   * should be padded. It will be padded if the dialog does not contain a `List`.
	   */
	  autopadContent: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the dialog content's size should automatically be resized to overflow
	   * correctly when there is a lot of content. This will calculate and apply some `maxHeight`
	   * to the `contentStyle`.
	   */
	  autosizeContent: _propTypes2.default.bool,
	
	  /**
	   * An optional height to apply to the dialog. This is used if it is easier to just apply height/width
	   * with for specific dialogs instead of in CSS.
	   *
	   * **This prop should not be used if the `fullPage` prop is enabled.**
	   *
	   * @see {@link #fullPage}
	   * @see {@link #width}
	   */
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional width to apply to the dialog. This is used if it is easier to just apply height/width
	   * with for specific dialogs instead of in CSS.
	   *
	   * **This prop should not be used if the `fullPage` prop is enabled.**
	   *
	   * @see {@link #fullPage}
	   * @see {@link #height}
	   */
	  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * Boolean if the actions should be stacked on top of each other. If this value is `undefined`, it will
	   * automatically attempt to guess if the items should be stacked.
	   */
	  stackedActions: _propTypes2.default.bool
	};
	Dialog.defaultProps = {
	  autopadContent: true,
	  autosizeContent: true,
	  contentComponent: 'section',
	  zDepth: 5
	};
	Dialog.childContextTypes = {
	  renderNode: _propTypes2.default.object
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this._getStyles = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this3.props,
	        pageX = _ref.pageX,
	        containerX = _ref.containerX,
	        pageY = _ref.pageY,
	        containerY = _ref.containerY,
	        height = _ref.height,
	        width = _ref.width,
	        style = _ref.style;
	
	    return _extends({
	      height: typeof height !== 'undefined' ? height : null,
	      width: typeof width !== 'undefined' ? width : null,
	      transformOrigin: pageX || pageY ? pageX - containerX + 'px ' + (pageY - containerY) + 'px' : null
	    }, style);
	  };
	
	  this._setRenderNode = function (dialog) {
	    _this3._renderNode = (0, _reactDom.findDOMNode)(dialog);
	  };
	
	  this._setContent = function (content) {
	    if (content !== null) {
	      _this3._content = (0, _reactDom.findDOMNode)(content);
	      var contentPadded = _this3._content.querySelectorAll('.md-list').length === 0;
	
	      _this3.setState({ contentPadded: contentPadded });
	    }
	  };
	
	  this._handleContentResize = function (_ref2) {
	    var scrollHeight = _ref2.scrollHeight,
	        content = _ref2.el;
	
	    var maxHeight = content.style.maxHeight;
	    var dialog = content.parentNode;
	    content.style.maxHeight = 'none';
	    var title = _this3.props.title ? dialog.querySelector('.md-title--dialog') : null;
	    var footer = _this3.props.actions ? dialog.querySelector('.md-dialog-footer') : null;
	
	    var totalHeight = dialog.offsetHeight - (title ? title.offsetHeight : 0) - (footer ? footer.offsetHeight : 0);
	    content.style.maxHeight = maxHeight;
	    var equalHeight = totalHeight === scrollHeight;
	    if (equalHeight) {
	      var currentHeight = _this3.state.contentStyles && _this3.state.contentStyles.maxHeight || null;
	      if (currentHeight && currentHeight !== scrollHeight) {
	        _this3.setState({ contentStyles: _this3.props.contentStyle });
	      }
	    } else {
	      _this3.setState({ contentStyles: _extends({ maxHeight: totalHeight }, _this3.props.contentStyle) });
	    }
	  };
	};
	
	exports.default = Dialog;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(7);
	
	var _CSSTransitionGroup = __webpack_require__(38);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(5);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _isRequiredForA11y = __webpack_require__(16);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _keyCodes = __webpack_require__(14);
	
	var _CSSTransitionGroupTick = __webpack_require__(29);
	
	var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);
	
	var _getField = __webpack_require__(8);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _toggleScroll = __webpack_require__(944);
	
	var _toggleScroll2 = _interopRequireDefault(_toggleScroll);
	
	var _oneRequiredForA11y = __webpack_require__(175);
	
	var _oneRequiredForA11y2 = _interopRequireDefault(_oneRequiredForA11y);
	
	var _Dialog = __webpack_require__(234);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Portal = __webpack_require__(34);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `DialogContainer` component is used for dynamically creating the `Dialog` with
	 * transitions.
	 */
	var DialogContainer = function (_PureComponent) {
	  _inherits(DialogContainer, _PureComponent);
	
	  function DialogContainer(props) {
	    _classCallCheck(this, DialogContainer);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var visible = typeof props.isOpen !== 'undefined' ? props.isOpen : props.visible;
	    var dialogVisible = visible && !props.defaultVisibleTransitionable;
	
	    _this.state = {
	      active: visible && !props.fullPage,
	      portalVisible: visible,
	      dialogVisible: dialogVisible
	    };
	    return _this;
	  }
	  /* eslint-disable max-len */
	
	
	  DialogContainer.prototype.componentDidMount = function componentDidMount() {
	    if (!this.props.isOpen && !this.props.visible) {
	      return;
	    }
	
	    this._mountDialog(this.props);
	  };
	
	  DialogContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var visible = typeof nextProps.isOpen !== 'undefined' ? nextProps.isOpen : nextProps.visible;
	    if (this.props.isOpen === visible || this.props.visible === visible) {
	      return;
	    }
	
	    var el = (0, _getField2.default)(this.props, this.context, 'renderNode') || window;
	    var pageX = el.scrollX,
	        pageY = el.scrollY;
	
	    if (typeof el.scrollTop !== 'undefined' && typeof el.scrollLeft !== 'undefined') {
	      pageX = el.scrollLeft;
	      pageY = el.scrollTop;
	    } else if (typeof el.scrollY !== 'undefined' && typeof el.scrollX !== 'undefined') {
	      pageX = el.scrollX;
	      pageY = el.scrollY;
	    }
	
	    this._pageX = pageX;
	    this._pageY = pageY;
	
	    if (this._inTimeout) {
	      clearTimeout(this._inTimeout);
	      this._inTimeout = null;
	    }
	
	    if (visible) {
	      this._activeElement = document.activeElement;
	      this._mountPortal(nextProps);
	    } else {
	      this.setState({ dialogVisible: false, active: false });
	    }
	  };
	
	  DialogContainer.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var _props = this.props,
	        visible = _props.visible,
	        closeOnEsc = _props.closeOnEsc,
	        modal = _props.modal;
	
	    var escapable = !modal && closeOnEsc;
	    var prevEscapable = !prevProps.modal && prevProps.closeOnEsc;
	
	    // Only going to support visible here since it was not implemented before.
	    if (visible === prevProps.visible && escapable === prevEscapable) {
	      return;
	    }
	
	    var add = false;
	    var remove = false;
	
	    if (escapable !== prevEscapable) {
	      add = visible && escapable;
	      remove = !visible || prevEscapable && !escapable;
	    } else if (escapable) {
	      add = visible;
	      remove = !visible;
	    }
	
	    if (add) {
	      window.addEventListener('keydown', this._handleEscClose);
	    } else if (remove) {
	      window.removeEventListener('keydown', this._handleEscClose);
	    }
	  };
	
	  DialogContainer.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.props.isOpen || this.props.visible) {
	      (0, _toggleScroll2.default)(false);
	    }
	
	    if (this.props.visible && this.props.closeOnEsc && !this.props.modal) {
	      window.removeEventListener('keydown', this._handleEscClose);
	    }
	
	    if (this._inTimeout) {
	      clearTimeout(this._inTimeout);
	    }
	  };
	
	  DialogContainer.prototype.render = function render() {
	    var _state = this.state,
	        active = _state.active,
	        dialogVisible = _state.dialogVisible,
	        portalVisible = _state.portalVisible;
	
	    var _props2 = this.props,
	        style = _props2.style,
	        className = _props2.className,
	        dialogStyle = _props2.dialogStyle,
	        dialogClassName = _props2.dialogClassName,
	        modal = _props2.modal,
	        fullPage = _props2.fullPage,
	        component = _props2.component,
	        transitionEnterTimeout = _props2.transitionEnterTimeout,
	        transitionLeaveTimeout = _props2.transitionLeaveTimeout,
	        lastChild = _props2.lastChild,
	        portal = _props2.portal,
	        propVisible = _props2.visible,
	        propRenderNode = _props2.renderNode,
	        closeOnEsc = _props2.closeOnEsc,
	        onShow = _props2.onShow,
	        onHide = _props2.onHide,
	        disableScrollLocking = _props2.disableScrollLocking,
	        defaultVisibleTransitionable = _props2.defaultVisibleTransitionable,
	        close = _props2.close,
	        isOpen = _props2.isOpen,
	        actionLeft = _props2.actionLeft,
	        actionRight = _props2.actionRight,
	        transitionName = _props2.transitionName,
	        transitionEnter = _props2.transitionEnter,
	        transitionLeave = _props2.transitionLeave,
	        props = _objectWithoutProperties(_props2, ['style', 'className', 'dialogStyle', 'dialogClassName', 'modal', 'fullPage', 'component', 'transitionEnterTimeout', 'transitionLeaveTimeout', 'lastChild', 'portal', 'visible', 'renderNode', 'closeOnEsc', 'onShow', 'onHide', 'disableScrollLocking', 'defaultVisibleTransitionable', 'close', 'isOpen', 'actionLeft', 'actionRight', 'transitionName', 'transitionEnter', 'transitionLeave']);
	
	    var renderNode = (0, _getField2.default)(this.props, this.context, 'renderNode');
	    var dialog = _react2.default.createElement(_Dialog2.default, _extends({
	      key: 'dialog',
	      style: dialogStyle,
	      className: (0, _classnames2.default)('md-background--card', dialogClassName),
	      ref: this._handleDialogMounting,
	      centered: !fullPage,
	      fullPage: fullPage
	    }, props, {
	      containerX: this._pageX,
	      containerY: this._pageY,
	      onLeave: this._unmountPortal
	    }));
	
	    var container = _react2.default.createElement(
	      _CSSTransitionGroup2.default,
	      {
	        component: component,
	        ref: this._setContainer,
	        style: style,
	        className: (0, _classnames2.default)('md-dialog-container', {
	          'md-overlay': !fullPage,
	          'md-overlay--active': !fullPage && active && propVisible,
	          'md-pointer--hover': !fullPage && !modal && propVisible
	        }, className),
	        transitionName: 'md-dialog--' + (fullPage ? 'full-page' : 'centered'),
	        transitionEnterTimeout: transitionEnterTimeout,
	        transitionLeaveTimeout: transitionLeaveTimeout,
	        tabIndex: -1,
	        onClick: this._handleClick
	      },
	      dialogVisible ? dialog : null
	    );
	
	    if (!portal) {
	      return portalVisible ? container : null;
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      { visible: portalVisible, renderNode: renderNode, lastChild: lastChild },
	      container
	    );
	  };
	
	  return DialogContainer;
	}(_react.PureComponent);
	
	DialogContainer.propTypes = {
	  /**
	   * An id to use for the `Dialog` once it has been opened. This is used for the
	   * [dialog role](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_dialog_role).
	   * This is used to generate an `id` for the `title` prop when it has been defined.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	  /* eslint-enable max-len */
	
	  /**
	   * An optional accessibility prop to use when the `Dialog` is opened. This should be an id
	   * pointing to some text that describes the content of the dialog. For accessibility
	   * reasons, one of the following props must be defined:
	   * - `title`
	   * - `aria-describedby`
	   * - `aria-labelledby`
	   * - `aria-label`
	   *
	   * An example usage:
	   *
	   * ```js
	   * <Dialog id="accessible-example" visible aria-describedby="accessible-content">
	   *   <p id="accessible-content">This is some content that describes the dialog.</p>
	   * </Dialog>
	   * ```
	   */
	  'aria-describedby': (0, _oneRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]), 'title', 'aria-labelledby', 'aria-label'),
	
	  /**
	   * An optional accessibility prop to use when the `title` prop is not given. This should be
	   * an id pointing to a `h` tag that labels the dialog.
	   *
	   * An example usage:
	   *
	   * ```js
	   * <Dialog visible id="accessible-example" aria-labelledby="accessible-dialog-label">
	   *   <h2 id="accessible-dialog-label">Some Accessible Dialog</h2>
	   * </Dialog>
	   * ```
	   */
	  'aria-labelledby': _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional accessibility prop to use when the `title` and `aria-labelledby` props are
	   * not defined. This should be a string that describes what is in the `Dialog`.
	   *
	   * An example usage:
	   *
	   * ```js
	   * <Dialog visible id="accessible-example" aria-label="Some Accessible Dialog">
	   *   <p>Lorem Ipsum</p>
	   * </Dialog>
	   * ```
	   */
	  'aria-label': _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the dialog's container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the dialog's container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the dialog itself when the `visible` prop is `true`.
	   */
	  dialogStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the dialog itself when the `visible` prop is `true`.
	   */
	  dialogClassName: _propTypes2.default.string,
	
	  /**
	   * An optional styke to apply to the title.
	   */
	  titleStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the title.
	   */
	  titleClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the footer. This is used when the `actions`
	   * prop is defined.
	   */
	  footerStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the footer. This is used when the `actions`
	   * prop is defined.
	   */
	  footerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the dialog's content.
	   */
	  contentStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the dialog's content.
	   */
	  contentClassName: _propTypes2.default.string,
	
	  /**
	   * The component to render the dialog's container in.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * The component to render the dialog's content in.
	   */
	  contentComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * The content to display in the dialog once open.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * A single action or a list of actions to display in the dialog. This can either be a list
	   * of `FlatButton` props or `<Button flat {...props} />` elements.
	   */
	  actions: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.object, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.object]))]),
	
	  /**
	   * Boolean if the `Dialog` is current visible.
	   */
	  visible: _propTypes2.default.bool.isRequired,
	
	  /**
	   * An optional function to call when the `visible` prop is changed from `false` to `true`.
	   */
	  onShow: _propTypes2.default.func,
	
	  /**
	   * A function to call that will close the dialog. This is required when the `modal` and `fullPage`
	   * props are not `true`.
	   */
	  onHide: function onHide(props, propName) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    var validator = _propTypes2.default.func;
	    if (!props.modal && !props.fullPage) {
	      validator = validator.isRequired;
	    }
	
	    return validator.apply(undefined, [props, propName].concat(args));
	  },
	
	  /**
	   * Boolean if the dialog should behave like a modal. This means that the dialog can only
	   * be closed by clicking on an action instead of also clicking on the overlay.
	   */
	  modal: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the dialog should be displayed as a full page dialog.
	   */
	  fullPage: function fullPage(props, propName, componentName) {
	    for (var _len2 = arguments.length, args = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	      args[_key2 - 3] = arguments[_key2];
	    }
	
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var err = _propTypes2.default.bool.apply(_propTypes2.default, [props, propName, componentName].concat(args));
	
	    if (!err && props[propName] && typeof props.title !== 'undefined') {
	      err = new Error('You provided a `title` ' + location + ' to the `' + componentNameSafe + '` when `fullPage` ' + 'has been set to true. A title for a full page dialog should be rendered as a child instead.');
	    }
	
	    return err;
	  },
	
	  /**
	   * An optional pageX location to use when rendering a full page dialog. This is used to set the location
	   * the dialog should appear from.
	   */
	  pageX: _propTypes2.default.number,
	
	  /**
	   * An optional pageY location to use when rendering a full page dialog. This is used to set the location
	   * the dialog should appear from.
	   */
	  pageY: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/FocusContainer#additionalFocusKeys}
	   */
	  additionalFocusKeys: _Dialog2.default.propTypes.additionalFocusKeys,
	
	  /**
	   * @see {@link Helpers/FocusContainer#initialFocus}
	   */
	  initialFocus: _Dialog2.default.propTypes.initialFocus,
	
	  /**
	   * @see {@link Helpers/FocusContainer#focusOnMount}
	   */
	  focusOnMount: _Dialog2.default.propTypes.focusOnMount,
	
	  /**
	   * @see {@link Helpers/FocusContainer#containFocus}
	   */
	  containFocus: _Dialog2.default.propTypes.containFocus,
	
	  /**
	   * The transition enter timeout for the dialog.
	   */
	  transitionEnterTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * The transition leave timeout for the dialog.
	   */
	  transitionLeaveTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the dialog should be closable by pressing the escape key.
	   * This will always be considered `false` of the `modal` props is `true`.
	   */
	  closeOnEsc: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the Portal's functionality of rendering in a separate react tree should be applied
	   * to the dialog.
	   *
	   * @see {@link Helpers/Portal}
	   */
	  portal: _propTypes2.default.bool,
	
	  /**
	   * Since the `Dialog` uses the `Portal` component, you can pass an optional HTML Node to render
	   * the dialog in instead of the `document.body`.
	   */
	  renderNode: _propTypes2.default.object,
	
	  /**
	   * Boolean if the dialog should be rendered as the last child in the `renderNode` or `body` instead
	   * of as the first.
	   */
	  lastChild: _propTypes2.default.bool,
	
	  /**
	   * An optional title for the dialog.
	   */
	  title: _propTypes2.default.node,
	
	  /**
	   * Boolean if the dialog should animate into view if it is constructed with `visible` enabled.
	   *
	   * This basically means that if the `Dialog` has `visible` enabled on initial page load, does it animate?
	   * In some cases, it can also mean if the `Dialog` is added to the render tree with `visible` enabled,
	   * does it animate?
	   */
	  defaultVisibleTransitionable: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the Dialog should no longer try to prevent the parent container from scrolling while visible.
	   * In most cases, this will attempt to prevent the main window scrolling. If this dialog is nested in another
	   * dialog, it will attempt to prevent the parent dialog from scrolling.
	   */
	  disableScrollLocking: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the dialog should automatically try to determine if the content
	   * should be padded. It will be padded if the dialog does not contain a `List`.
	   */
	  autopadContent: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the dialog content's size should automatically be resized to overflow
	   * correctly when there is a lot of content. This will calculate and apply some `maxHeight`
	   * to the `contentStyle`.
	   */
	  autosizeContent: _propTypes2.default.bool,
	
	  /**
	   * An optional height to apply to the dialog. This is used if it is easier to just apply height/width
	   * with for specific dialogs instead of in CSS.
	   *
	   * **This prop should not be used if the `fullPage` prop is enabled.**
	   *
	   * @see {@link #fullPage}
	   * @see {@link #width}
	   */
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional width to apply to the dialog. This is used if it is easier to just apply height/width
	   * with for specific dialogs instead of in CSS.
	   *
	   * **This prop should not be used if the `fullPage` prop is enabled.**
	   *
	   * @see {@link #fullPage}
	   * @see {@link #height}
	   */
	  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * Boolean if the actions should be stacked on top of each other. If this value is `undefined`, it will
	   * automatically attempt to guess if the items should be stacked.
	   */
	  stackedActions: _propTypes2.default.bool,
	
	  isOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `visible` instead'),
	  transitionName: (0, _deprecated2.default)(_propTypes2.default.string, 'The transition name will be managed by the component'),
	  transitionEnter: (0, _deprecated2.default)(_propTypes2.default.bool, 'The transition will always be enforced'),
	  transitionLeave: (0, _deprecated2.default)(_propTypes2.default.bool, 'The transition will always be enforced'),
	  actionLeft: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `fullPage` prop instead'),
	  actionRight: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `fullPage` prop instead'),
	  close: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `onHide` instead')
	};
	DialogContainer.defaultProps = {
	  autopadContent: true,
	  autosizeContent: true,
	  component: 'span',
	  closeOnEsc: true,
	  contentComponent: 'section',
	  focusOnMount: true,
	  transitionEnterTimeout: 300,
	  transitionLeaveTimeout: 300,
	  defaultVisibleTransitionable: false
	};
	DialogContainer.contextTypes = {
	  renderNode: _propTypes2.default.object
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._setContainer = function (container) {
	    if (container !== null) {
	      _this2._container = (0, _reactDom.findDOMNode)(container);
	    }
	  };
	
	  this._handleEscClose = function (e) {
	    if ((e.which || e.keyCode) === _keyCodes.ESC) {
	      (_this2.props.onHide || _this2.props.close)(e);
	    }
	  };
	
	  this._mountPortal = function (props) {
	    _this2._mountDialog(props);
	    _this2.setState({ portalVisible: true });
	  };
	
	  this._mountDialog = function (props) {
	    var fullPage = props.fullPage,
	        onShow = props.onShow;
	
	    _this2._inTimeout = setTimeout(function () {
	      _this2._inTimeout = fullPage ? null : setTimeout(function () {
	        _this2._inTimeout = null;
	        _this2.setState({ active: true });
	      }, _CSSTransitionGroupTick2.default);
	      _this2.setState({ dialogVisible: true }, onShow);
	    }, _CSSTransitionGroupTick2.default);
	  };
	
	  this._unmountPortal = function () {
	    _this2.setState({ portalVisible: false });
	  };
	
	  this._handleClick = function (e) {
	    var visible = typeof _this2.props.isOpen !== 'undefined' ? _this2.props.isOpen : _this2.props.visible;
	    if (_this2.props.modal || !visible || e.target !== _this2._container) {
	      return;
	    }
	
	    (_this2.props.onHide || _this2.props.close)(e);
	  };
	
	  this._handleDialogMounting = function (dialog) {
	    var disableScrollLocking = _this2.props.disableScrollLocking;
	
	    if (dialog === null) {
	      if (_this2._activeElement && _this2._activeElement.focus) {
	        _this2._activeElement.focus();
	      }
	
	      if (!disableScrollLocking) {
	        (0, _toggleScroll2.default)(false, _this2.scrollEl);
	      }
	
	      _this2._activeElement = null;
	    } else {
	      var container = document.getElementById(_this2.props.id);
	      if (!container || disableScrollLocking) {
	        return;
	      }
	
	      var el = (0, _getField2.default)(_this2.props, _this2.context, 'renderNode');
	      var node = container.parentNode;
	      while (node && node.classList && !el) {
	        if (node.classList.contains('md-dialog')) {
	          el = node;
	        }
	
	        node = node.parentNode;
	      }
	
	      _this2.scrollEl = el;
	      (0, _toggleScroll2.default)(true, el);
	    }
	  };
	};
	
	exports.default = DialogContainer;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Portal = __webpack_require__(34);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Overlay = function (_PureComponent) {
	  _inherits(Overlay, _PureComponent);
	
	  function Overlay() {
	    _classCallCheck(this, Overlay);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  Overlay.prototype.getChildContext = function getChildContext() {
	    // Always want the overlay to render in a separate subtree until 1.1.0
	    return { isInPortal: false };
	  };
	
	  Overlay.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        visible = _props.visible,
	        renderNode = _props.renderNode,
	        onClick = _props.onClick,
	        style = _props.style,
	        className = _props.className;
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      { visible: visible, renderNode: renderNode },
	      _react2.default.createElement('div', {
	        style: style,
	        className: (0, _classnames2.default)('md-overlay md-overlay--drawer md-pointer--hover', {
	          'md-overlay--active': active
	        }, className),
	        onClick: onClick
	      })
	    );
	  };
	
	  return Overlay;
	}(_react.PureComponent);
	
	Overlay.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  active: _propTypes2.default.bool,
	  visible: _propTypes2.default.bool.isRequired,
	  renderNode: _propTypes2.default.object,
	  onClick: _propTypes2.default.func
	};
	Overlay.childContextTypes = {
	  isInPortal: _propTypes2.default.bool
	};
	exports.default = Overlay;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _controlled = __webpack_require__(15);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _mapToListParts = __webpack_require__(130);
	
	var _mapToListParts2 = _interopRequireDefault(_mapToListParts);
	
	var _getField = __webpack_require__(8);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _anchorShape = __webpack_require__(28);
	
	var _anchorShape2 = _interopRequireDefault(_anchorShape);
	
	var _fixedToShape = __webpack_require__(19);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _positionShape = __webpack_require__(36);
	
	var _positionShape2 = _interopRequireDefault(_positionShape);
	
	var _Menu = __webpack_require__(56);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `DropdownMenu` is just a simple wrapper to the `Menu` component. The main differences
	 * is that the `toggle` component will now be the children and the list of items to display
	 * will be the `menuItems` prop.
	 *
	 * The dropdown menu is mostly used to control the state of the menu and render a single element
	 * as the toggle.
	 */
	var DropdownMenu = function (_PureComponent) {
	  _inherits(DropdownMenu, _PureComponent);
	
	  function DropdownMenu(props) {
	    _classCallCheck(this, DropdownMenu);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));
	
	    _this._handleClick = function (e) {
	      var _this$props = _this.props,
	          onVisibilityChange = _this$props.onVisibilityChange,
	          children = _this$props.children;
	
	      var visible = !(0, _getField2.default)(_this.props, _this.state, 'visible');
	      if (onVisibilityChange) {
	        onVisibilityChange(visible, e);
	      }
	
	      var toggle = _react2.default.Children.only(children);
	      if (toggle.props.onClick) {
	        toggle.props.onClick(e);
	      }
	
	      if (typeof _this.props.visible === 'undefined') {
	        _this.setState({ visible: visible });
	      }
	    };
	
	    _this._handleClose = function (e) {
	      var onVisibilityChange = _this.props.onVisibilityChange;
	
	      var visible = false;
	      if (onVisibilityChange) {
	        onVisibilityChange(visible, e);
	      }
	
	      if (typeof _this.props.visible === 'undefined') {
	        _this.setState({ visible: visible });
	      }
	    };
	
	    _this.state = {};
	    if (typeof props.visible === 'undefined') {
	      _this.state.visible = props.defaultVisible;
	    }
	    return _this;
	  }
	
	  DropdownMenu.prototype.render = function render() {
	    var _props = this.props,
	        id = _props.id,
	        listId = _props.listId,
	        menuItems = _props.menuItems,
	        propChildren = _props.children,
	        simplifiedMenu = _props.simplifiedMenu,
	        propVisible = _props.visible,
	        onVisibilityChange = _props.onVisibilityChange,
	        defaultVisible = _props.defaultVisible,
	        props = _objectWithoutProperties(_props, ['id', 'listId', 'menuItems', 'children', 'simplifiedMenu', 'visible', 'onVisibilityChange', 'defaultVisible']);
	
	    var visible = (0, _getField2.default)(this.props, this.state, 'visible');
	
	    var children = _react2.default.Children.only(propChildren);
	    var toggle = _react2.default.cloneElement(children, {
	      id: children.props.id || id + '-toggle',
	      onClick: this._handleClick
	    });
	
	    var items = void 0;
	    if (!Array.isArray(menuItems)) {
	      items = (0, _mapToListParts2.default)(menuItems);
	    } else {
	      items = menuItems.map(_mapToListParts2.default);
	    }
	
	    return _react2.default.createElement(
	      _Menu2.default,
	      _extends({}, props, {
	        simplified: simplifiedMenu,
	        id: id,
	        listId: listId,
	        toggle: toggle,
	        visible: visible,
	        onClose: this._handleClose
	      }),
	      items
	    );
	  };
	
	  return DropdownMenu;
	}(_react.PureComponent);
	
	DropdownMenu.Positions = _Menu2.default.Positions;
	DropdownMenu.HorizontalAnchors = _Menu2.default.HorizontalAnchors;
	DropdownMenu.VerticalAnchors = _Menu2.default.VerticalAnchors;
	DropdownMenu.propTypes = {
	  /**
	   * An id to use for the menu. This is required for accessibility.
	   *
	   * @see {@link Menus/Menu#id}
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to provide to the menu's list.
	   *
	   * @see {@link Menus/Menu#listId}
	   */
	  listId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply to the menu.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the menu.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the list.
	   */
	  listStyle: _propTypes2.default.object,
	
	  /**
	   * An optional class name to apply to the list.
	   */
	  listClassName: _propTypes2.default.string,
	
	  /**
	   * Any additional props to provide to the list.
	   *
	   * @see {@link Menus/Menu#listProps}
	   */
	  listProps: _propTypes2.default.object,
	
	  /**
	   * The z-depth to use for the list.
	   *
	   * @see {@link Menus/Menu/listZDepth}
	   */
	  listZDepth: _propTypes2.default.number,
	
	  /**
	   * Boolean if the list should be displayed inline.
	   *
	   * @see {@link Lists/List#inline}
	   */
	  listInline: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the list's height should be restricted.
	   *
	   * @see {@link Menus/Menu#listHeightRestricted}
	   */
	  listHeightRestricted: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu's list is currently visible. If this is defined, it will
	   * require the `onVisibilityChange` function to be defined since it will become
	   * a controlled component.
	   */
	  visible: (0, _controlled2.default)(_propTypes2.default.bool, 'onVisibilityChange', 'defaultVisible'),
	
	  /**
	   * Boolean if the menu's list should be visible by default.
	   */
	  defaultVisible: _propTypes2.default.bool.isRequired,
	
	  /**
	   * An optional function to call when the button is clicked.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the visibility changes for the menu. The callback will
	   * include the next visibility state and the event that triggered the change.
	   *
	   * ```js
	   * onVisibilityChange(visible, event);
	   * ```
	   */
	  onVisibilityChange: _propTypes2.default.func,
	
	  /**
	   * This is a 0 to many relationship of `ListItem` to display in the menu's `List`. If the type
	   * of the item is a number or string, it will be passed to the `ListItem` as the `primaryText`.
	   * If it is an object, it should be the shape of the `ListItem` props. If it is a node, it will
	   * just be rendered in the `List`.
	   *
	   * @see {@link Lists/ListItem}
	   * @see {@link Menus/Menu#children}
	   */
	  menuItems: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.node, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.object, _propTypes2.default.node]))]),
	
	  /**
	   * @see {@link Menus/Menu#toggle}
	   */
	  children: _propTypes2.default.element.isRequired,
	
	  /**
	   * The anchor position of the menu's list.
	   *
	   * @see {@link Helpers/Layover#anchor}
	   */
	  anchor: _anchorShape2.default,
	
	  /**
	   * This is the anchor to use when the `position` is set to `Autocomplete.Positions.BELOW`.
	   *
	   * @see {@link Helpers/Layover#belowAnchor}
	   */
	  belowAnchor: _anchorShape2.default,
	
	  /**
	   * This is how the menu's list is fixed to the toggle.
	   *
	   * @see {@link Menus/Menu#fixedTo}
	   */
	  fixedTo: _fixedToShape2.default,
	
	  /**
	   * This is the animation position for the menu's list.
	   *
	   * @see {@link Menus/Menu#position}
	   */
	  position: _positionShape2.default,
	
	  /**
	   * Boolean if the menu's list should gain the cascading styles.
	   *
	   * @see {@link Menus/Menu#cascading}
	   */
	  cascading: _propTypes2.default.bool,
	
	  /**
	   * The zDepth to use for the lists that appear in cascading menus.
	   *
	   * @see {@link Menus/Menu#cascadingZDepth}
	   */
	  cascadingZDepth: _propTypes2.default.number,
	
	  /**
	   * The anchor position for the cascading lists.
	   *
	   * @see {@link Menus/Menu#cascadingAnchor}
	   */
	  cascadingAnchor: _anchorShape2.default,
	
	  /**
	   * Boolean if the menu should display as a full width container. This will *not* update the button
	   * to be full width as well.
	   *
	   * @see {@link Menus/Menu#fullWidth}
	   */
	  fullWidth: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu's container should display as `block` instead of `inline-block`.
	   *
	   * @see {@link Menus/Menu#block}
	   */
	  block: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the list should appear centered related to the button.
	   *
	   * @see {@link Menus/Menu#centered}
	   */
	  centered: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu's list should be the same width as the button.
	   *
	   * @see {@link Menus/Menu#sameWidth}
	   */
	  sameWidth: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Menus/Menu#xThreshold}
	   */
	  xThreshold: _propTypes2.default.number,
	
	  /**
	   * @see {@link Menus/Menu#yThreshold}
	   */
	  yThreshold: _propTypes2.default.number,
	
	  /**
	   * Boolean if the menu's list should be closed when an element outside of the menu has been clicked.
	   *
	   * @see {@link Menus/Menu#closeOnOutsideClick}
	   */
	  closeOnOutsideClick: _propTypes2.default.bool,
	
	  /**
	   * The transition name to use for the menu's list visibility changes.
	   *
	   * @see {@link Menus/Menu#transitionName}
	   */
	  transitionName: _propTypes2.default.string,
	
	  /**
	   * The transition name to use when the menu's list gains visibility.
	   *
	   * @see {@link Menus/Menu#transitionEnterTimeout}
	   */
	  transitionEnterTimeout: _propTypes2.default.number,
	
	  /**
	   * The transition timeout to use when the menu's list loses visibility.
	   *
	   * @see {@link Menus/Menu#transitionLeaveTimeout}
	   */
	  transitionLeaveTimeout: _propTypes2.default.number,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the `fixedTo` element scrolls.
	   *
	   * @see {@link Helpers/Layover#repositionOnScroll}
	   */
	  repositionOnScroll: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the window resizes.
	   *
	   * @see {@link Helpers/Layover#repositionOnResize}
	   */
	  repositionOnResize: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu logic should be simplified without any viewport logic and position
	   * based on the relative position of the menu. This will most like require some additional
	   * styles applied to the menu.
	   *
	   * @see {@link Helpers/Layover#simplified}
	   */
	  simplifiedMenu: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#minLeft}
	   */
	  minLeft: _Menu2.default.propTypes.minLeft,
	
	  /**
	   * @see {@link Helpers/Layover#minRight}
	   */
	  minRight: _Menu2.default.propTypes.minLeft,
	
	  /**
	   * @see {@link Helpers/Layover#minBottom}
	   */
	  minBottom: _Menu2.default.propTypes.minBottom,
	
	  /**
	   * @see {@link Helpers/Layover#fillViewportWidth}
	   */
	  fillViewportWidth: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#fillViewportHeight}
	   */
	  fillViewportHeight: _propTypes2.default.bool
	};
	DropdownMenu.defaultProps = {
	  defaultVisible: false,
	  repositionOnScroll: true,
	  repositionOnResize: false
	};
	exports.default = DropdownMenu;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _AccessibleFakeInkedButton = __webpack_require__(24);
	
	var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	var _TileAddon = __webpack_require__(86);
	
	var _TileAddon2 = _interopRequireDefault(_TileAddon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MiniListItem = function (_PureComponent) {
	  _inherits(MiniListItem, _PureComponent);
	
	  function MiniListItem() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MiniListItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = { active: false }, _this._handleMouseOver = function (e) {
	      if (_this.props.onMouseOver) {
	        _this.props.onMouseOver(e);
	      }
	
	      if (!_this.props.disabled) {
	        _this.setState({ active: true });
	      }
	    }, _this._handleMouseLeave = function (e) {
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(e);
	      }
	
	      if (!_this.props.disabled) {
	        _this.setState({ active: false });
	      }
	    }, _this._handleTouchStart = function (e) {
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(e);
	      }
	
	      _this._touched = true;
	
	      _this.setState({ active: true, touchedAt: Date.now() });
	    }, _this._handleTouchEnd = function (e) {
	      if (_this.props.onTouchEnd) {
	        _this.props.onTouchEnd(e);
	      }
	
	      var time = Date.now() - _this.state.touchedAt;
	      _this._touchTimeout = setTimeout(function () {
	        _this._touchTimeout = null;
	
	        _this.setState({ active: false });
	      }, time > 450 ? 0 : 450 - time);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MiniListItem.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this._touchTimeout) {
	      clearTimeout(this._touchTimeout);
	    }
	  };
	
	  MiniListItem.prototype.render = function render() {
	    var _props = this.props,
	        style = _props.style,
	        className = _props.className,
	        tileStyle = _props.tileStyle,
	        tileClassName = _props.tileClassName,
	        leftIcon = _props.leftIcon,
	        leftAvatar = _props.leftAvatar,
	        active = _props.active,
	        activeClassName = _props.activeClassName,
	        ItemComponent = _props.itemComponent,
	        primaryText = _props.primaryText,
	        secondaryText = _props.secondaryText,
	        rightIcon = _props.rightIcon,
	        rightAvatar = _props.rightAvatar,
	        threeLines = _props.threeLines,
	        children = _props.children,
	        defaultOpen = _props.defaultOpen,
	        isOpen = _props.isOpen,
	        inset = _props.inset,
	        nestedItems = _props.nestedItems,
	        animateNestedItems = _props.animateNestedItems,
	        expanderIcon = _props.expanderIcon,
	        expanderIconChildren = _props.expanderIconChildren,
	        expanderIconClassName = _props.expanderIconClassName,
	        props = _objectWithoutProperties(_props, ['style', 'className', 'tileStyle', 'tileClassName', 'leftIcon', 'leftAvatar', 'active', 'activeClassName', 'itemComponent', 'primaryText', 'secondaryText', 'rightIcon', 'rightAvatar', 'threeLines', 'children', 'defaultOpen', 'isOpen', 'inset', 'nestedItems', 'animateNestedItems', 'expanderIcon', 'expanderIconChildren', 'expanderIconClassName']);
	
	    return _react2.default.createElement(
	      ItemComponent,
	      { style: style, className: className },
	      _react2.default.createElement(
	        _AccessibleFakeInkedButton2.default,
	        _extends({}, props, {
	          style: tileStyle,
	          className: (0, _classnames2.default)('md-list-tile md-list-tile--icon md-list-tile--mini', {
	            'md-list-tile--active': this.state.active && !this._touched
	          }, tileClassName),
	          onMouseOver: this._handleMouseOver,
	          onMouseLeave: this._handleMouseLeave,
	          onTouchStart: this._handleTouchStart,
	          onTouchEnd: this._handleTouchEnd
	        }),
	        _react2.default.createElement(_TileAddon2.default, {
	          active: active,
	          activeClassName: activeClassName,
	          icon: leftIcon,
	          avatar: leftAvatar
	        })
	      )
	    );
	  };
	
	  return MiniListItem;
	}(_react.PureComponent);
	
	MiniListItem.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  tileStyle: _propTypes2.default.object,
	  tileClassName: _propTypes2.default.string,
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	  active: _propTypes2.default.bool,
	  activeClassName: _propTypes2.default.string,
	  leftIcon: _propTypes2.default.node,
	  leftAvatar: _propTypes2.default.node,
	  disabled: _propTypes2.default.bool,
	  onTouchStart: _propTypes2.default.func,
	  onTouchEnd: _propTypes2.default.func,
	  onMouseOver: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  defaultOpen: _propTypes2.default.bool,
	  itemComponent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired
	};
	MiniListItem.defaultProps = {
	  activeClassName: 'md-text--theme-primary',
	  component: 'div',
	  itemComponent: 'li'
	};
	exports.default = MiniListItem;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CSSTransitionGroup = __webpack_require__(38);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _deprecated = __webpack_require__(5);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _isRequiredForA11y = __webpack_require__(16);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _getField = __webpack_require__(8);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _controlled = __webpack_require__(15);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _invalidIf = __webpack_require__(43);
	
	var _invalidIf2 = _interopRequireDefault(_invalidIf);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Drawer = __webpack_require__(166);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _List = __webpack_require__(41);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Toolbar = __webpack_require__(172);
	
	var _Toolbar2 = _interopRequireDefault(_Toolbar);
	
	var _FontIcon = __webpack_require__(12);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _getDeprecatedIcon = __webpack_require__(21);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _isType = __webpack_require__(116);
	
	var _JumpToContentLink = __webpack_require__(170);
	
	var _JumpToContentLink2 = _interopRequireDefault(_JumpToContentLink);
	
	var _CloseButton = __webpack_require__(169);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	var _MiniListItem = __webpack_require__(238);
	
	var _MiniListItem2 = _interopRequireDefault(_MiniListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var DrawerTypes = _Drawer2.default.DrawerTypes;
	
	
	function getNonMiniType(type) {
	  var pMini = DrawerTypes.PERSISTENT_MINI,
	      tMini = DrawerTypes.TEMPORARY_MINI;
	
	  if ([pMini, tMini].indexOf(type) === -1) {
	    return type;
	  }
	
	  return pMini === type ? DrawerTypes.PERSISTENT : DrawerTypes.TEMPORARY;
	}
	
	function toMiniListItem(item, index) {
	  if ((0, _react.isValidElement)(item)) {
	    return item;
	  }
	
	  var divider = item.divider,
	      subheader = item.subheader,
	      key = item.key,
	      itemProps = _objectWithoutProperties(item, ['divider', 'subheader', 'key']);
	
	  if (divider || subheader) {
	    return null;
	  }
	
	  return _react2.default.createElement(_MiniListItem2.default, _extends({ key: key || index }, itemProps));
	}
	
	/**
	 * The `NavigationDrawer` is used when you want a full layout configuration. It is a combination
	 * of the `Toolbar` component and the `Drawer` component. Any props that are not specifically
	 * listed below will be provided to the `Drawer` component. So if there are props on the `Drawer`
	 * that are not listed here, they will be passed along.
	 *
	 * The main benefit of using this component is that it will manage adding respective offset
	 * classes automatically for you to the content and the drawer. It will also manage using
	 * a mini drawer type for you.
	 */
	
	var NavigationDrawer = function (_PureComponent) {
	  _inherits(NavigationDrawer, _PureComponent);
	
	  /**
	   * Determines the current media and returns an object containing matches for `mobile`, `tablet`, `desktop`,
	   * and the current drawer type. This expects a `props` object of the drawer.
	   *
	   * If this is used server side, it will default to only matching mobile.
	   *
	   * @param {Object=} props - The current drawer's prop shape to extract the mobile, tablet, and desktop type/min
	   *    widths. This defaults to the drawer's default props.
	   * @return {Object} an object containing the media matches and the current type to use for the drawer.
	   */
	  NavigationDrawer.getCurrentMedia = function getCurrentMedia() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NavigationDrawer.defaultProps;
	
	    var mobileType = props.mobileDrawerType,
	        tabletType = props.tabletDrawerType,
	        desktopType = props.desktopDrawerType,
	        constantType = props.constantDrawerType,
	        others = _objectWithoutProperties(props, ['mobileDrawerType', 'tabletDrawerType', 'desktopDrawerType', 'constantDrawerType']);
	
	    return _Drawer2.default.getCurrentMedia(_extends({ mobileType: mobileType, tabletType: tabletType, desktopType: desktopType, constantType: constantType }, others));
	  };
	
	  function NavigationDrawer(props) {
	    _classCallCheck(this, NavigationDrawer);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var defaultMedia = props.defaultMedia,
	        defaultVisible = props.defaultVisible,
	        initialDrawerType = props.initialDrawerType;
	
	
	    _this.state = {
	      mobile: initialDrawerType || defaultMedia === 'mobile',
	      tablet: initialDrawerType || defaultMedia === 'tablet',
	      desktop: initialDrawerType || defaultMedia === 'desktop'
	    };
	
	    if (typeof props.drawerType === 'undefined') {
	      _this.state.drawerType = props[(initialDrawerType || defaultMedia) + 'DrawerType'];
	    }
	
	    var type = (0, _getField2.default)(props, _this.state, 'drawerType');
	
	    if (typeof props.visible === 'undefined') {
	      // The logic for determining the visibility is handled by the created mini drawer
	      _this.state.visible = (0, _isType.isPermanent)(type);
	      if (!_this.state.visible && typeof defaultVisible !== 'undefined') {
	        _this.state.visible = defaultVisible;
	      }
	    }
	    return _this;
	  }
	
	  NavigationDrawer.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        persistentIcon = _props.persistentIcon,
	        id = _props.contentId,
	        label = _props.jumpLabel,
	        persistentIconChildren = _props.persistentIconChildren,
	        persistentIconClassName = _props.persistentIconClassName,
	        closeIconChildren = _props.closeIconChildren,
	        closeIconClassName = _props.closeIconClassName;
	
	
	    return {
	      id: id,
	      label: label,
	      closeIcon: (0, _getDeprecatedIcon2.default)(closeIconClassName || persistentIconClassName, closeIconChildren || persistentIconChildren, persistentIcon),
	      onCloseClick: this._toggleVisibility,
	      renderNode: this.context.renderNode
	    };
	  };
	
	  NavigationDrawer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var visible = (0, _getField2.default)(this.props, this.state, 'visible');
	    var nVisible = (0, _getField2.default)(nextProps, this.state, 'visible');
	    if (visible !== nVisible) {
	      this._animate(nextProps);
	    }
	  };
	
	  NavigationDrawer.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this._timeout) {
	      clearTimeout(this._timeout);
	    }
	  };
	
	  NavigationDrawer.prototype.render = function render() {
	    var _props2 = this.props,
	        id = _props2.id,
	        style = _props2.style,
	        className = _props2.className,
	        toolbarStyle = _props2.toolbarStyle,
	        toolbarClassName = _props2.toolbarClassName,
	        drawerStyle = _props2.drawerStyle,
	        drawerClassName = _props2.drawerClassName,
	        contentStyle = _props2.contentStyle,
	        contentClassName = _props2.contentClassName,
	        Content = _props2.contentComponent,
	        miniDrawerStyle = _props2.miniDrawerStyle,
	        miniDrawerClassName = _props2.miniDrawerClassName,
	        miniNavStyle = _props2.miniNavStyle,
	        miniNavClassName = _props2.miniNavClassName,
	        miniDrawerId = _props2.miniDrawerId,
	        miniNavItemsId = _props2.miniNavItemsId,
	        navItems = _props2.navItems,
	        children = _props2.children,
	        drawerId = _props2.drawerId,
	        drawerTitle = _props2.drawerTitle,
	        drawerZDepth = _props2.drawerZDepth,
	        drawerChildren = _props2.drawerChildren,
	        drawerHeaderChildren = _props2.drawerHeaderChildren,
	        drawerTransitionDuration = _props2.drawerTransitionDuration,
	        toolbarId = _props2.toolbarId,
	        toolbarTitle = _props2.toolbarTitle,
	        toolbarTitleMenu = _props2.toolbarTitleMenu,
	        toolbarTitleStyle = _props2.toolbarTitleStyle,
	        toolbarTitleClassName = _props2.toolbarTitleClassName,
	        toolbarActions = _props2.toolbarActions,
	        toolbarProminent = _props2.toolbarProminent,
	        toolbarProminentTitle = _props2.toolbarProminentTitle,
	        toolbarThemeType = _props2.toolbarThemeType,
	        toolbarSingleColor = _props2.toolbarSingleColor,
	        toolbarChildren = _props2.toolbarChildren,
	        toolbarZDepth = _props2.toolbarZDepth,
	        mobileType = _props2.mobileDrawerType,
	        tabletType = _props2.tabletDrawerType,
	        desktopType = _props2.desktopDrawerType,
	        transitionName = _props2.transitionName,
	        transitionEnterTimeout = _props2.transitionEnterTimeout,
	        transitionLeaveTimeout = _props2.transitionLeaveTimeout,
	        extractMini = _props2.extractMini,
	        miniDrawerHeader = _props2.miniDrawerHeader,
	        miniDrawerChildren = _props2.miniDrawerChildren,
	        footer = _props2.footer,
	        includeDrawerHeader = _props2.includeDrawerHeader,
	        contentId = _props2.contentId,
	        contentProps = _props2.contentProps,
	        constantDrawerType = _props2.constantDrawerType,
	        temporaryIcon = _props2.temporaryIcon,
	        temporaryIconChildren = _props2.temporaryIconChildren,
	        temporaryIconClassName = _props2.temporaryIconClassName,
	        menuIconChildren = _props2.menuIconChildren,
	        menuIconClassName = _props2.menuIconClassName,
	        propDrawerType = _props2.drawerType,
	        propDrawerHeader = _props2.drawerHeader,
	        propRenderNode = _props2.renderNode,
	        jumpLabel = _props2.jumpLabel,
	        persistentIcon = _props2.persistentIcon,
	        onDrawerChange = _props2.onDrawerChange,
	        closeIconChildren = _props2.closeIconChildren,
	        closeIconClassName = _props2.closeIconClassName,
	        persistentIconChildren = _props2.persistentIconChildren,
	        persistentIconClassName = _props2.persistentIconClassName,
	        props = _objectWithoutProperties(_props2, ['id', 'style', 'className', 'toolbarStyle', 'toolbarClassName', 'drawerStyle', 'drawerClassName', 'contentStyle', 'contentClassName', 'contentComponent', 'miniDrawerStyle', 'miniDrawerClassName', 'miniNavStyle', 'miniNavClassName', 'miniDrawerId', 'miniNavItemsId', 'navItems', 'children', 'drawerId', 'drawerTitle', 'drawerZDepth', 'drawerChildren', 'drawerHeaderChildren', 'drawerTransitionDuration', 'toolbarId', 'toolbarTitle', 'toolbarTitleMenu', 'toolbarTitleStyle', 'toolbarTitleClassName', 'toolbarActions', 'toolbarProminent', 'toolbarProminentTitle', 'toolbarThemeType', 'toolbarSingleColor', 'toolbarChildren', 'toolbarZDepth', 'mobileDrawerType', 'tabletDrawerType', 'desktopDrawerType', 'transitionName', 'transitionEnterTimeout', 'transitionLeaveTimeout', 'extractMini', 'miniDrawerHeader', 'miniDrawerChildren', 'footer', 'includeDrawerHeader', 'contentId', 'contentProps', 'constantDrawerType', 'temporaryIcon', 'temporaryIconChildren', 'temporaryIconClassName', 'menuIconChildren', 'menuIconClassName', 'drawerType', 'drawerHeader', 'renderNode', 'jumpLabel', 'persistentIcon', 'onDrawerChange', 'closeIconChildren', 'closeIconClassName', 'persistentIconChildren', 'persistentIconClassName']);
	
	    var drawerHeader = this.props.drawerHeader;
	    var _state = this.state,
	        desktop = _state.desktop,
	        tablet = _state.tablet,
	        contentActive = _state.contentActive;
	
	
	    var drawerType = (0, _getField2.default)(this.props, this.state, 'drawerType');
	    var visible = (0, _getField2.default)(this.props, this.state, 'visible');
	    var renderNode = (0, _getField2.default)(this.props, this.context, 'renderNode');
	    var mini = (0, _isType.isMini)(drawerType);
	    var temporary = (0, _isType.isTemporary)(drawerType);
	    var persistent = (0, _isType.isPersistent)(drawerType);
	    var clipped = drawerType === DrawerTypes.CLIPPED;
	    var floating = drawerType === DrawerTypes.FLOATING;
	
	    var offset = desktop || tablet ? !temporary && visible : visible;
	    var toolbarRelative = (0, _classnames2.default)({
	      'md-toolbar-relative': !toolbarProminent && !toolbarProminentTitle,
	      'md-toolbar-relative--prominent': toolbarProminent || toolbarProminentTitle
	    });
	
	    var nav = void 0;
	    if (temporary || persistent) {
	      nav = _react2.default.createElement(_Button2.default, {
	        key: 'nav',
	        onClick: this._toggleVisibility,
	        disabled: persistent && visible,
	        icon: true,
	        iconEl: (0, _getDeprecatedIcon2.default)(menuIconClassName || temporaryIconClassName, menuIconChildren || temporaryIconChildren, temporaryIcon)
	      });
	    }
	
	    var closeButton = void 0;
	    if (persistent) {
	      closeButton = _react2.default.createElement(_CloseButton2.default, null);
	    }
	
	    if (!drawerHeader && includeDrawerHeader) {
	      var _cn;
	
	      drawerHeader = _react2.default.createElement(
	        _Toolbar2.default,
	        {
	          key: 'drawer-header',
	          title: drawerTitle,
	          actions: visible && nav ? closeButton : null,
	          className: (0, _classnames2.default)('md-divider-border md-divider-border--bottom', (_cn = {}, _cn[toolbarRelative] = clipped || floating, _cn))
	        },
	        drawerHeaderChildren,
	        _react2.default.createElement(_JumpToContentLink2.default, null)
	      );
	    }
	    var miniDrawer = void 0;
	    if (mini) {
	      var miniList = void 0;
	      if (extractMini) {
	        miniList = _react2.default.createElement(
	          _List2.default,
	          {
	            id: miniNavItemsId,
	            key: 'mini-nav-items',
	            style: miniNavStyle,
	            className: (0, _classnames2.default)(miniNavClassName, toolbarRelative)
	          },
	          navItems.map(toMiniListItem)
	        );
	      }
	
	      miniDrawer = _react2.default.createElement(
	        _Drawer2.default,
	        {
	          id: miniDrawerId,
	          key: 'mini-drawer',
	          type: drawerType,
	          renderNode: renderNode,
	          'aria-hidden': visible,
	          style: miniDrawerStyle,
	          className: miniDrawerClassName
	        },
	        miniDrawerHeader,
	        miniList,
	        miniDrawerChildren
	      );
	    }
	
	    var desktopOffset = !clipped && !floating && offset;
	
	    return _react2.default.createElement(
	      'div',
	      { id: id, style: style, className: className },
	      _react2.default.createElement(
	        _Toolbar2.default,
	        {
	          id: toolbarId,
	          colored: toolbarThemeType === 'colored',
	          themed: toolbarThemeType === 'themed',
	          singleColor: toolbarSingleColor,
	          style: toolbarStyle,
	          className: (0, _classnames2.default)({
	            'md-toolbar--over-drawer': clipped || floating || mini && !visible
	          }, toolbarClassName),
	          title: toolbarTitle,
	          titleMenu: toolbarTitleMenu,
	          prominent: toolbarProminent,
	          prominentTitle: toolbarProminentTitle,
	          titleStyle: toolbarTitleStyle,
	          titleClassName: (0, _classnames2.default)({
	            'md-title--drawer-active': contentActive,
	            'md-transition--deceleration': offset && visible,
	            'md-transition--acceleration': offset && !visible,
	            'md-title--permanent-offset': desktopOffset && (0, _isType.isPermanent)(drawerType),
	            'md-title--persistent-offset': desktopOffset && persistent
	          }, toolbarTitleClassName),
	          nav: nav,
	          actions: toolbarActions,
	          fixed: true,
	          zDepth: toolbarZDepth
	        },
	        toolbarChildren
	      ),
	      miniDrawer,
	      _react2.default.createElement(
	        _Drawer2.default,
	        _extends({}, props, {
	          id: drawerId,
	          constantType: constantDrawerType,
	          transitionDuration: drawerTransitionDuration,
	          header: drawerHeader,
	          style: drawerStyle,
	          className: drawerClassName,
	          navItems: navItems,
	          renderNode: renderNode,
	          mobileType: mobileType,
	          tabletType: tabletType,
	          desktopType: desktopType,
	          type: getNonMiniType(drawerType),
	          visible: visible,
	          zDepth: drawerZDepth,
	          onVisibilityChange: this._handleVisibility,
	          onMediaTypeChange: this._handleTypeChange
	        }),
	        drawerChildren
	      ),
	      _react2.default.createElement(
	        _CSSTransitionGroup2.default,
	        _extends({}, contentProps, {
	          id: contentId,
	          component: Content,
	          transitionName: transitionName,
	          transitionEnter: !!transitionEnterTimeout,
	          transitionEnterTimeout: transitionEnterTimeout,
	          transitionLeave: !!transitionLeaveTimeout,
	          transitionLeaveTimeout: transitionLeaveTimeout,
	          tabIndex: -1,
	          style: contentStyle,
	          className: (0, _classnames2.default)('md-navigation-drawer-content', {
	            'md-navigation-drawer-content--active': contentActive,
	            'md-navigation-drawer-content--inactive': !visible,
	            'md-navigation-drawer-content--prominent-offset': toolbarProminent || toolbarProminentTitle,
	            'md-transition--deceleration': visible,
	            'md-transition--acceleration': !visible,
	            'md-drawer-relative': offset,
	            'md-drawer-relative--mini': mini && (!visible || temporary)
	          }, toolbarRelative, contentClassName)
	        }),
	        children
	      ),
	      footer
	    );
	  };
	
	  return NavigationDrawer;
	}(_react.PureComponent);
	
	NavigationDrawer.DrawerType = { // deprecated
	  /* eslint-disable no-console */
	  _warned: false,
	  _msg: 'Invalid use of `NavigationDrawer.DrawerType.{{TYPE}}`. The `NavigationDrawer.DrawerType` ' + 'has been deprecated and will be removed in the next major release. Please use the ' + '`NavigationDrawer.DrawerTypes.{{TYPE}}` instead.',
	
	  get FULL_HEIGHT() {
	    if (!this._warned) {
	      console.error(this._msg.replace(/{{TYPE}}/g, 'FULL_HEIGHT'));
	    }
	    this._warned = true;
	
	    return DrawerTypes.FULL_HEIGHT;
	  },
	
	  get CLIPPED() {
	    if (!this._warned) {
	      console.error(this._msg.replace(/{{TYPE}}/g, 'CLIPPED'));
	    }
	    this._warned = true;
	
	    return DrawerTypes.CLIPPED;
	  },
	
	  get FLOATING() {
	    if (!this._warned) {
	      console.error(this._msg.replace(/{{TYPE}}/g, 'FLOATING'));
	    }
	    this._warned = true;
	
	    return DrawerTypes.FLOATING;
	  },
	
	  get PERSISTENT() {
	    if (!this._warned) {
	      console.error(this._msg.replace(/{{TYPE}}/g, 'PERSISTENT'));
	    }
	    this._warned = true;
	
	    return DrawerTypes.PERSISTENT;
	  },
	
	  get PERSISTENT_MINI() {
	    if (!this._warned) {
	      console.error(this._msg.replace(/{{TYPE}}/g, 'PERSISTENT_MINI'));
	    }
	    this._warned = true;
	
	    return DrawerTypes.PERSISTENT_MINI;
	  },
	
	  get TEMPORARY() {
	    if (!this._warned) {
	      console.error(this._msg.replace(/{{TYPE}}/g, 'TEMPORARY'));
	    }
	    this._warned = true;
	
	    return DrawerTypes.TEMPORARY;
	  },
	
	  get TEMPORARY_MINI() {
	    if (!this._warned) {
	      console.error(this._msg.replace(/{{TYPE}}/g, 'TEMPORARY_MINI'));
	    }
	    this._warned = true;
	
	    return DrawerTypes.TEMPORARY_MINI;
	  }
	};
	NavigationDrawer.DrawerTypes = DrawerTypes;
	NavigationDrawer.propTypes = {
	  /**
	   * An optional id to provide to the entire div wrapper.
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to provide to the drawer. This is generally a good idea to provide if
	   * there are any `navItems` defined.
	   *
	   * @see {@link #navItemsId}
	   * @see {@link #miniDrawerId}
	   */
	  drawerId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to provide to the navItems list. If this is omitted and the `drawerId` prop is
	   * defined, it will be defaulted to `${drawerId}-nav-items`.
	   *
	   * @see {@link #drawerId}
	   * @see {@link Drawer#navItemsId}
	   */
	  navItemsId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to apply to mini drawer that gets created when the `drawerType` is set to
	   * one of the mini types.
	   *
	   * @see {@link #drawerId}
	   * @see {@link #miniNavItemsId}
	   */
	  miniDrawerId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to apply to mini drawer's navigation list that gets created when the `drawerType`
	   * is set to one of the mini types.
	   *
	   * @see {@link #navItemsId}
	   * @see {@link #miniDrawerId}
	   */
	  miniNavItemsId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to provide to the main toolbar.
	   */
	  toolbarId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An id to give the main content. A hidden link is created in the main drawer's header that links to the main
	   * content. This is used for keyboard only users to jump the navigation and jump straight to the content.
	   *
	   * If you provide your own `drawerHeader`, it is suggested to include the link yourself.
	   */
	  contentId: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * An optional style to apply to the surrounding container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the surrounding container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the main toolbar.
	   */
	  toolbarStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the toolbar.
	   */
	  toolbarClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the main toolbar's title.
	   */
	  toolbarTitleStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the main toolbar's title.
	   */
	  toolbarTitleClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the drawer.
	   */
	  drawerStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the drawer.
	   */
	  drawerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the `List` surrounding the `navItems`.
	   */
	  navStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `List` surrounding the `navItems`.
	   */
	  navClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the mini drawer that gets created when the `drawerType` is set
	   * to one of the mini types.
	   *
	   * @see {@link #miniDrawerClassName}
	   * @see {@link #miniNavStyle}
	   * @see {@link #miniNavClassName}
	   */
	  miniDrawerStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the mini drawer that gets created when the `drawerType` is set
	   * to one of the mini types.
	   *
	   * @see {@link #miniDrawerStyle}
	   * @see {@link #miniNavStyle}
	   * @see {@link #miniNavClassName}
	   */
	  miniDrawerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the mini drawer's navigation list when the `drawerType` is set
	   * to one of the mini types.
	   *
	   * @see {@link #miniDrawerStyle}
	   * @see {@link #miniDrawerClassName}
	   * @see {@link #miniNavClassName}
	   */
	  miniNavStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the mini drawer's navigation list when the `drawerType` is set
	   * to one of the mini types.
	   *
	   * @see {@link #miniDrawerStyle}
	   * @see {@link #miniDrawerClassName}
	   * @see {@link #miniNavStyle}
	   */
	  miniNavClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the content. This is the container surrounding whatever
	   * `children` are passed in.
	   */
	  contentStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the content. This is the container surrounding whatever
	   * `children` are passed in.
	   */
	  contentClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the overlay.
	   */
	  overlayStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the overlay.
	   */
	  overlayClassName: _propTypes2.default.string,
	
	  /**
	   * The children to display in the main content.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * Boolean if the `drawerHeader` component should be built if the `drawerHeader` prop is not
	   * passed in.
	   */
	  includeDrawerHeader: _propTypes2.default.bool,
	
	  /**
	   * An optional header to display in the drawer. This will normally be the `Toolbar` component
	   * or any other type of header. You can either use this prop with the `CloseButton` component
	   * when displaying a persistent drawer, or use the `drawerTitle` and `drawerHeaderChildren` prop
	   * to build a toolbar.
	   */
	  drawerHeader: _propTypes2.default.node,
	
	  /**
	   * An optional title to use for the drawer's header toolbar. If the `drawerHeader` prop is defined,
	   * this is invalid.
	   */
	  drawerTitle: (0, _invalidIf2.default)(_propTypes2.default.node, 'drawerHeader'),
	
	  /**
	   * An optional zDepth to apply to the drawer. If this is omitted, the value will be set as follows:
	   * - floating || inline = 1
	   * - temporary = 5
	   * - all others = 1
	   *
	   * @see {@link Papers/Paper#zDepth}
	   */
	  drawerZDepth: _propTypes2.default.number,
	
	  /**
	   * Any additional children to display after the `drawerHeader` and `navItems` list in the drawer.
	   */
	  drawerChildren: _propTypes2.default.node,
	
	  /**
	   * Any additional children to display in the drawer's header `Toolbar`. If the `drawerHeader` prop is defined,
	   * this is invalid.
	   */
	  drawerHeaderChildren: (0, _invalidIf2.default)(_propTypes2.default.node, 'drawerHeader'),
	
	  /**
	   * The position for the drawer to be displayed.
	   */
	  position: _propTypes2.default.oneOf(['left', 'right']).isRequired,
	
	  /**
	   * An optional list of elements or props to use to build a navigational list in the drawer.
	   * When the item is an object of props, it will build a `ListItem` component unless a key of
	   * `divider` or `subheader` is set to true. It will then create the Divider or Subheader component
	   * with any other remaining keys.
	   */
	  navItems: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.shape({
	    divider: _propTypes2.default.bool,
	    subheader: _propTypes2.default.bool,
	    primaryText: _propTypes2.default.node
	  })])),
	
	  /**
	   * The drawer type to use for mobile devices.
	   */
	  mobileDrawerType: _propTypes2.default.oneOf([DrawerTypes.TEMPORARY, DrawerTypes.TEMPORARY_MINI]).isRequired,
	
	  /**
	   * The drawer type to use for tablets.
	   */
	  tabletDrawerType: _propTypes2.default.oneOf([DrawerTypes.FULL_HEIGHT, DrawerTypes.CLIPPED, DrawerTypes.FLOATING, DrawerTypes.PERSISTENT, DrawerTypes.PERSISTENT_MINI, DrawerTypes.TEMPORARY, DrawerTypes.TEMPORARY_MINI]).isRequired,
	
	  /**
	   * The drawer type to use for desktop displays.
	   */
	  desktopDrawerType: _propTypes2.default.oneOf([DrawerTypes.FULL_HEIGHT, DrawerTypes.CLIPPED, DrawerTypes.FLOATING, DrawerTypes.PERSISTENT, DrawerTypes.PERSISTENT_MINI, DrawerTypes.TEMPORARY, DrawerTypes.TEMPORARY_MINI]).isRequired,
	
	  /**
	   * An optional drawer type to enforce on all screen sizes. If the drawer type is not
	   * `temporary`, you are required to define the `onMediaTypeChange` prop to handle switching
	   * to temporary when the media matches a mobile device.
	   * ```
	   */
	  drawerType: _propTypes2.default.oneOf([DrawerTypes.FULL_HEIGHT, DrawerTypes.CLIPPED, DrawerTypes.FLOATING, DrawerTypes.PERSISTENT, DrawerTypes.PERSISTENT_MINI, DrawerTypes.TEMPORARY, DrawerTypes.TEMPORARY_MINI]),
	
	  /**
	   * The default media match for the drawer. This will be what is displayed on first render.
	   * The component will adjust itself to the current media after it has mounted, but this
	   * is mostly used for server side rendering.
	   */
	  defaultMedia: _propTypes2.default.oneOf(['mobile', 'tablet', 'desktop']),
	
	  /**
	   * The min width to use for a mobile media query. This prop should match the `md-mobile-min-width`
	   * variable.
	   *
	   * The media query for a mobile device will be:
	   *
	   * ```js
	   * window.matchMedia(
	   *   `screen and (min-width: ${mobileMinWidth}px) and (max-width: ${tabletMinWidth - 1}px`
	   * ).matches;
	   * ```
	   */
	  mobileMinWidth: _propTypes2.default.number.isRequired,
	
	  /**
	   * The min width to use for a tablet media query. This prop should match the `md-tablet-min-width`
	   * variable.
	   *
	   * The media query for a tablet device will be:
	   *
	   * ```js
	   * window.matchMedia(
	   *   `screen and (min-width: ${tabletMinWidth}px) and (max-width: ${desktopWidth - 1}px`
	   * ).matches;
	   * ```
	   */
	  tabletMinWidth: _propTypes2.default.number.isRequired,
	
	  /**
	   * The min width to use for a desktop media query. This prop should match the `md-desktop-min-width`
	   * variable.
	   *
	   * The media query for a tablet device will be:
	   *
	   * ```js
	   * window.matchMedia(`screen and (min-width: ${tabletMinWidth}px)`).matches;
	   * ```
	   */
	  desktopMinWidth: _propTypes2.default.number.isRequired,
	
	  /**
	   * An optional function to call when the type of the drawer changes because of the
	   * new media queries. The callback will include the newly selected drawer type
	   * and an object containing the media matches of `mobile`, `tablet`, and `desktop`.
	   *
	   * ```js
	   * this.props.onMediaTypeChange(NavigationDrawer.DrawerTypes.TEMPORARY, {
	   *   mobile: true,
	   *   tablet: false,
	   *   desktop: false,
	   * });
	   * ```
	   */
	  onMediaTypeChange: _propTypes2.default.func,
	
	  /**
	   * Boolean if the temporary or persistent drawers are visible by default.
	   */
	  defaultVisible: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the temporary or persistent drawers are visible. If this is defined,
	   * it will make the component controlled and require the `onVisibilityChange` prop
	   * to be defined.
	   */
	  visible: (0, _controlled2.default)(_propTypes2.default.bool, 'onVisibilityChange', 'defaultVisible'),
	
	  /**
	   * An optional function to call when the visibility of the drawer changes. The callback
	   * will include the new visibility.
	   *
	   * ```js
	   * onVisibilityChange(false);
	   * ```
	   */
	  onVisibilityChange: _propTypes2.default.func,
	
	  /**
	   * A boolean if the mini drawer's list should be generated from the `navItems` prop. When building
	   * the list, it will extract the `leftIcon` or `leftAvatar` from the `navItem` and then create a
	   * mini `ListItem` containing only that icon or image. Any other event listeners will also be applied.
	   *
	   *
	   * @see {@link #miniDrawerHeader}
	   * @see {@link #miniDrawerChildren}
	   */
	  extractMini: _propTypes2.default.bool,
	
	  /**
	   * An optional header to display in the mini drawer. This will be displayed above the optional
	   * mini nav list that get generated if the `extractMini` prop is `true` and the `miniDrawerChildren`.
	   *
	   * @see {@link #extractMini}
	   */
	  miniDrawerHeader: _propTypes2.default.node,
	
	  /**
	   * Any additional children to display in the mini drawer. This will be displayed after the `miniDrawerHeader`
	   * and the optional mini nav list that gets generated if the `extractMini` prop is `true`.
	   *
	   * @see {@link #extractMini}
	   */
	  miniDrawerChildren: _propTypes2.default.node,
	
	  /**
	   * Boolean if the drawer should automatically close after a nav item has been clicked for `temporary` drawers.
	   */
	  autoclose: _propTypes2.default.bool,
	
	  /**
	   * An optional title to display in the main toolbar. Either the `toolbarTitle` or the `toolbarTitleMenu`
	   * may be defined, not both.
	   */
	  toolbarTitle: (0, _invalidIf2.default)(_propTypes2.default.node, 'toolbarTitleMenu'),
	
	  /**
	   * An optional select field menu to display in the main toolbar. Either the `toolbarTitle` or the `toolbarTitleMenu`
	   * may be defined, not both.
	   */
	  toolbarTitleMenu: _propTypes2.default.element,
	
	  /**
	   * The theme style for the main toolbar.
	   *
	   * @see {@link Toolbars/Toolbar}
	   */
	  toolbarThemeType: _propTypes2.default.oneOf(['default', 'colored', 'themed']).isRequired,
	
	  /**
	   * Boolean if the toolbar's nav, actions, and title should share the same color.
	   */
	  toolbarSingleColor: _propTypes2.default.bool,
	
	  /**
	   * A boolean if the toolbar should be prominent.
	   */
	  toolbarProminent: _propTypes2.default.bool,
	
	  /**
	   * A boolean if the toolbar's title should be prominent.
	   */
	  toolbarProminentTitle: _propTypes2.default.bool,
	
	  /**
	   * A list of elements or a single element to display to the right of the
	   * toolbar's nav, title, and children.
	   *
	   * @see {@link Toolbars/Toolbar#actions}
	   */
	  toolbarActions: _Toolbar2.default.propTypes.actions,
	
	  /**
	   * Any children to display in the toolbar. This will be displayed between the optional title and
	   * actions.
	   */
	  toolbarChildren: _Toolbar2.default.propTypes.children,
	
	  /**
	   * An optional zDepth to apply to the toolbar.
	   *
	   * @see {@link Toolbars/Toolbar#zDepth}
	   */
	  toolbarZDepth: _propTypes2.default.number,
	
	  /**
	   * The component to render the content in.
	   */
	  contentComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * An optional footer display after the main content.
	   */
	  footer: _propTypes2.default.node,
	
	  /**
	   * The icon to use to render the button that will toggle the visibility of the
	   * navigation drawer for `temporary` and `persistent` drawers. This is normally a
	   * hamburger menu.
	   */
	  temporaryIcon: _propTypes2.default.element,
	
	  /**
	   * The icon to use to render the button that appears on a persistent drawer's open
	   * header. This is used to create the `CloseButton` for drawers. When a persistent
	   * drawer is closed, the `temporaryIcon` will be used to create a button to open the drawer.
	   *
	   * If the `drawerHeader` prop is defined, you will have to either include the `CloseButton`
	   * in your header manually, or create your own controlled button to close the drawer.
	   */
	  persistentIcon: _propTypes2.default.element,
	
	  /**
	   * The transition name to use when the page's content changes. If you want to disable
	   * transitions, set both the `transitionEnterTimeout` and `transitionLeaveTimeout` props
	   * to a false-ish value. (`null`, `undefined`, or `0`).
	   */
	  transitionName: _propTypes2.default.string.isRequired,
	
	  /**
	   * The transition enter timeout when the page's content changes. If you want to disable
	   * the enter transition, set this to a false-ish value (`null`, `undefined`, or `0`).
	   */
	  transitionEnterTimeout: _propTypes2.default.number,
	
	  /**
	   * The transition leave timeout when the page's content changes. If you want to disable
	   * the leave transition, set this to a false-ish value (`null`, `undefined`, or `0`).
	   */
	  transitionLeaveTimeout: _propTypes2.default.number,
	
	  /**
	   * The transition duration for the drawer when sliding in and out of view.
	   */
	  drawerTransitionDuration: _propTypes2.default.number.isRequired,
	
	  /**
	   * Any additional props to provide to the main content. This will be applied before any of the generated props,
	   * so this should not include `style`, `className`, or `component`.
	   */
	  contentProps: _propTypes2.default.object,
	
	  /**
	   * The label to use for a keyboard accessibility link that jumps all the navigation and allows a user to focus
	   * the main content. This is created in the drawer's header.
	   */
	  jumpLabel: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the Portal's functionality of rendering in a separate react tree should be applied
	   * to the drawer. The overlay that appears for temporary type drawers will still appear in the
	   * separate subtree.
	   *
	   * @see {@link Helpers/Portal}
	   */
	  portal: _propTypes2.default.bool,
	
	  /**
	   * An optional DOM Node to render the drawer into. The default is to render as
	   * the first child in the `body`.
	   *
	   * > This prop will not be used when the drawer is of the permanent type or `inline` is specified
	   * since the `Portal` component will not be used.
	   */
	  renderNode: _propTypes2.default.object,
	
	  /**
	   * Boolean if the drawer should be rendered as the last child instead of the first child
	   * in the `renderNode` or `body`.
	   *
	   * > This prop will not be used when the drawer is of the permanent type or `inline` is specified
	   * since the `Portal` component will not be used.
	   */
	  lastChild: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `drawerType` should remain constant across all media. This is really only valid
	   * if the `drawerType` is one of the temporary types.
	   */
	  constantDrawerType: _propTypes2.default.bool,
	
	  menuIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `temporaryIcon` instead'),
	  menuIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `temporaryIcon` instead'),
	  closeIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `persistentIcon` instead'),
	  closeIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `persistentIcon` instead'),
	  temporaryIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `temporaryIcon` instead'),
	  temporaryIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `temporaryIcon` instead'),
	  persistentIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `persistentIcon` instead'),
	  persistentIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `persistentIcon` prop instead'),
	  onDrawerChange: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `onVisibilityChange` or `onMediaTypeChange` instead'),
	  onVisibilityToggle: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `onVisibilityChange` instead'),
	  contentTransitionName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `transitionName` instead'),
	  contentTransitionEnterTimeout: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `transtionEnterTimeout` instead'),
	  contentTransitionLeaveTimeout: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `transtionLeaveTimeout` instead'),
	  initialDrawerType: (0, _deprecated2.default)(_propTypes2.default.oneOf(['mobile', 'tablet', 'desktop']), 'Use `defaultMedia` instead')
	};
	NavigationDrawer.contextTypes = {
	  renderNode: _propTypes2.default.object
	};
	NavigationDrawer.childContextTypes = {
	  closeIcon: _propTypes2.default.element,
	  onCloseClick: _propTypes2.default.func,
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	  label: _propTypes2.default.node.isRequired,
	  renderNode: _propTypes2.default.object
	};
	NavigationDrawer.defaultProps = {
	  autoclose: _Drawer2.default.defaultProps.autoclose,
	  contentId: 'main-content',
	  // Defaults to false since it keeps the state of the drawerType in sync and makes the Drawer
	  // controlled. On initial mount without any defaultMedia updates, it would always be considered
	  // temporary
	  constantDrawerType: false,
	  jumpLabel: 'Jump to content',
	  extractMini: true,
	  position: _Drawer2.default.defaultProps.position,
	  defaultMedia: _Drawer2.default.defaultProps.defaultMedia,
	  mobileDrawerType: _Drawer2.default.defaultProps.mobileType,
	  tabletDrawerType: _Drawer2.default.defaultProps.tabletType,
	  desktopDrawerType: _Drawer2.default.defaultProps.desktopType,
	  mobileMinWidth: _Drawer2.default.defaultProps.mobileMinWidth,
	  tabletMinWidth: _Drawer2.default.defaultProps.tabletMinWidth,
	  desktopMinWidth: _Drawer2.default.defaultProps.desktopMinWidth,
	  includeDrawerHeader: true,
	  contentComponent: 'main',
	  temporaryIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'menu'
	  ),
	  toolbarThemeType: 'colored',
	  persistentIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'arrow_back'
	  ),
	  transitionName: 'md-cross-fade',
	  transitionEnterTimeout: 300,
	  drawerTransitionDuration: _Drawer2.default.defaultProps.transitionDuration
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._animate = function () {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.props;
	    var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this2.state;
	
	    if ((0, _isType.isTemporary)((0, _getField2.default)(props, state, 'drawerType'))) {
	      return;
	    }
	
	    if (_this2._timeout) {
	      clearTimeout(_this2._timeout);
	    }
	
	    _this2._timeout = setTimeout(function () {
	      _this2.setState({ contentActive: false });
	    }, props.drawerTransitionDuration);
	
	    _this2.setState({ contentActive: true });
	  };
	
	  this._toggleVisibility = function (e) {
	    var _props3 = _this2.props,
	        onVisibilityToggle = _props3.onVisibilityToggle,
	        onVisibilityChange = _props3.onVisibilityChange,
	        onDrawerChange = _props3.onDrawerChange;
	
	    var visible = !(0, _getField2.default)(_this2.props, _this2.state, 'visible');
	    var callback = onVisibilityChange || onVisibilityToggle || onDrawerChange;
	    if (callback) {
	      callback(visible, e);
	    }
	
	    if (typeof _this2.props.visible === 'undefined') {
	      _this2.setState({ visible: visible });
	      _this2._animate(_this2.props);
	    }
	  };
	
	  this._handleVisibility = function (visible) {
	    var _props4 = _this2.props,
	        onVisibilityToggle = _props4.onVisibilityToggle,
	        onVisibilityChange = _props4.onVisibilityChange,
	        onDrawerChange = _props4.onDrawerChange;
	
	    var callback = onVisibilityChange || onVisibilityToggle || onDrawerChange;
	    if (callback) {
	      callback(visible);
	    }
	
	    if (typeof _this2.props.visible === 'undefined') {
	      _this2.setState({ visible: visible });
	      _this2._animate(_this2.props);
	    }
	  };
	
	  this._handleTypeChange = function (drawerType, mediaState) {
	    var onMediaTypeChange = _this2.props.onMediaTypeChange;
	
	    var state = mediaState;
	    if (onMediaTypeChange) {
	      onMediaTypeChange(drawerType, mediaState);
	    }
	
	    if (typeof _this2.props.drawerType === 'undefined') {
	      state = _extends({}, mediaState, { drawerType: drawerType });
	    }
	
	    _this2.setState(state);
	  };
	};
	
	exports.default = NavigationDrawer;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `PickerControl` component is the button that goes in the header
	 * of a `Picker` component. It is used to switch the view of the `Picker`
	 * from state to state.
	 *
	 * For example, this is the year and date views for the `DatePicker`.
	 */
	var PickerControl = function (_PureComponent) {
	  _inherits(PickerControl, _PureComponent);
	
	  function PickerControl() {
	    _classCallCheck(this, PickerControl);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  PickerControl.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        active = _props.active,
	        props = _objectWithoutProperties(_props, ['className', 'active']);
	
	    return _react2.default.createElement('button', _extends({}, props, {
	      type: 'button',
	      className: (0, _classnames2.default)('md-btn md-pointer--hover md-picker-control md-picker-text', {
	        'md-picker-text--active': active
	      }, className)
	    }));
	  };
	
	  return PickerControl;
	}(_react.PureComponent);
	
	PickerControl.propTypes = {
	  className: _propTypes2.default.string,
	  active: _propTypes2.default.bool.isRequired,
	  onClick: _propTypes2.default.func.isRequired,
	  children: _propTypes2.default.node.isRequired
	};
	exports.default = PickerControl;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(7);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(5);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _isRequiredForA11y = __webpack_require__(16);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _keyCodes = __webpack_require__(14);
	
	var _omit = __webpack_require__(177);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _isValued = __webpack_require__(176);
	
	var _isValued2 = _interopRequireDefault(_isValued);
	
	var _getField = __webpack_require__(8);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _isBetween = __webpack_require__(348);
	
	var _isBetween2 = _interopRequireDefault(_isBetween);
	
	var _handleKeyboardAccessibility = __webpack_require__(57);
	
	var _handleKeyboardAccessibility2 = _interopRequireDefault(_handleKeyboardAccessibility);
	
	var _controlled = __webpack_require__(15);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _FontIcon = __webpack_require__(12);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _anchorShape = __webpack_require__(28);
	
	var _anchorShape2 = _interopRequireDefault(_anchorShape);
	
	var _fixedToShape = __webpack_require__(19);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _positionShape = __webpack_require__(36);
	
	var _positionShape2 = _interopRequireDefault(_positionShape);
	
	var _Menu = __webpack_require__(56);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _ListItem = __webpack_require__(85);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _SelectFieldToggle = __webpack_require__(891);
	
	var _SelectFieldToggle2 = _interopRequireDefault(_SelectFieldToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MOBILE_LIST_PADDING = 8;
	var ARIA_ACTIVE = 'aria-activedescendant';
	
	var SelectField = function (_PureComponent) {
	  _inherits(SelectField, _PureComponent);
	
	  function SelectField(props) {
	    var _listProps;
	
	    _classCallCheck(this, SelectField);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = _extends({
	      error: false,
	      active: false
	    }, _this._getActive(props, { value: props.defaultValue }), {
	      listProps: (_listProps = {
	        role: 'listbox',
	        ref: _this._scrollActiveIntoView
	      }, _listProps[ARIA_ACTIVE] = null, _listProps),
	      match: null,
	      lastSearch: null,
	      value: props.defaultValue,
	      visible: props.defaultVisible
	    });
	
	    _this._items = [];
	    _this._activeItem = null;
	    _this._deleteKeys = _this._getDeleteKeys(props);
	    return _this;
	  }
	
	  SelectField.prototype.componentDidMount = function componentDidMount() {
	    this._container = (0, _reactDom.findDOMNode)(this);
	    this._field = this._container.querySelector('.md-select-field');
	  };
	
	  SelectField.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _props = this.props,
	        itemLabel = _props.itemLabel,
	        itemValue = _props.itemValue,
	        deleteKeys = _props.deleteKeys;
	
	    if (deleteKeys !== nextProps.deleteKeys || itemLabel !== nextProps.itemLabel || itemValue !== nextProps.itemValue) {
	      this._deleteKeys = this._getDeleteKeys(nextProps);
	    }
	
	    if (this.props.value !== nextProps.value || this.props.menuItems !== nextProps.menuItems) {
	      this.setState(this._getActive(nextProps, this.state));
	    }
	  };
	
	  /**
	   * Gets the current value from the select field. This is used when you have an uncontrolled
	   * text field and simply need the value from a ref callback.
	   *
	   * @return {String} the select field's value
	   */
	
	
	  SelectField.prototype._getItemPart = function _getItemPart(item, itemLabel, itemValue) {
	    var preferLabel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	    var type = typeof item === 'undefined' ? 'undefined' : _typeof(item);
	    if (type === 'number' || type === 'string') {
	      return item;
	    } else if (type === 'object') {
	      var key1 = preferLabel ? itemLabel : itemValue;
	      var key2 = preferLabel ? itemValue : itemLabel;
	      return typeof item[key1] !== 'undefined' ? item[key1] : item[key2];
	    }
	
	    return '';
	  };
	
	  SelectField.prototype._getDeleteKeys = function _getDeleteKeys(_ref) {
	    var itemLabel = _ref.itemLabel,
	        itemValue = _ref.itemValue,
	        itemProps = _ref.itemProps,
	        deleteKeys = _ref.deleteKeys;
	
	    var keys = [itemLabel, itemValue, itemProps];
	    if (deleteKeys) {
	      return keys.concat(Array.isArray(deleteKeys) ? deleteKeys : [deleteKeys]);
	    }
	
	    return keys;
	  };
	
	  SelectField.prototype.render = function render() {
	    var _props2 = this.props,
	        id = _props2.id,
	        style = _props2.style,
	        className = _props2.className,
	        listStyle = _props2.listStyle,
	        listClassName = _props2.listClassName,
	        toggleStyle = _props2.toggleStyle,
	        toggleClassName = _props2.toggleClassName,
	        menuItems = _props2.menuItems,
	        anchor = _props2.anchor,
	        belowAnchor = _props2.belowAnchor,
	        fixedTo = _props2.fixedTo,
	        position = _props2.position,
	        xThreshold = _props2.xThreshold,
	        yThreshold = _props2.yThreshold,
	        listZDepth = _props2.listZDepth,
	        listInline = _props2.listInline,
	        listHeightRestricted = _props2.listHeightRestricted,
	        block = _props2.block,
	        centered = _props2.centered,
	        sameWidth = _props2.sameWidth,
	        fullWidth = _props2.fullWidth,
	        repositionOnScroll = _props2.repositionOnScroll,
	        repositionOnResize = _props2.repositionOnResize,
	        simplifiedMenu = _props2.simplifiedMenu,
	        minLeft = _props2.minLeft,
	        minRight = _props2.minRight,
	        minBottom = _props2.minBottom,
	        fillViewportWidth = _props2.fillViewportWidth,
	        fillViewportHeight = _props2.fillViewportHeight,
	        menuTransitionName = _props2.menuTransitionName,
	        menuTransitionEnterTimeout = _props2.menuTransitionEnterTimeout,
	        menuTransitionLeaveTimeout = _props2.menuTransitionLeaveTimeout,
	        isOpen = _props2.isOpen,
	        propError = _props2.error,
	        propMenuId = _props2.menuId,
	        propVisible = _props2.visible,
	        itemLabel = _props2.itemLabel,
	        itemValue = _props2.itemValue,
	        itemProps = _props2.itemProps,
	        getItemProps = _props2.getItemProps,
	        defaultValue = _props2.defaultValue,
	        defaultVisible = _props2.defaultVisible,
	        onClick = _props2.onClick,
	        onKeyDown = _props2.onKeyDown,
	        onVisibilityChange = _props2.onVisibilityChange,
	        deleteKeys = _props2.deleteKeys,
	        stripActiveItem = _props2.stripActiveItem,
	        keyboardMatchingTimeout = _props2.keyboardMatchingTimeout,
	        defaultOpen = _props2.defaultOpen,
	        initiallyOpen = _props2.initiallyOpen,
	        onMenuToggle = _props2.onMenuToggle,
	        stretchList = _props2.stretchList,
	        menuStyle = _props2.menuStyle,
	        menuClassName = _props2.menuClassName,
	        floatingLabel = _props2.floatingLabel,
	        noAutoAdjust = _props2.noAutoAdjust,
	        adjustMinWidth = _props2.adjustMinWidth,
	        props = _objectWithoutProperties(_props2, ['id', 'style', 'className', 'listStyle', 'listClassName', 'toggleStyle', 'toggleClassName', 'menuItems', 'anchor', 'belowAnchor', 'fixedTo', 'position', 'xThreshold', 'yThreshold', 'listZDepth', 'listInline', 'listHeightRestricted', 'block', 'centered', 'sameWidth', 'fullWidth', 'repositionOnScroll', 'repositionOnResize', 'simplifiedMenu', 'minLeft', 'minRight', 'minBottom', 'fillViewportWidth', 'fillViewportHeight', 'menuTransitionName', 'menuTransitionEnterTimeout', 'menuTransitionLeaveTimeout', 'isOpen', 'error', 'menuId', 'visible', 'itemLabel', 'itemValue', 'itemProps', 'getItemProps', 'defaultValue', 'defaultVisible', 'onClick', 'onKeyDown', 'onVisibilityChange', 'deleteKeys', 'stripActiveItem', 'keyboardMatchingTimeout', 'defaultOpen', 'initiallyOpen', 'onMenuToggle', 'stretchList', 'menuStyle', 'menuClassName', 'floatingLabel', 'noAutoAdjust', 'adjustMinWidth']);
	
	    var _props3 = this.props,
	        menuId = _props3.menuId,
	        listId = _props3.listId,
	        error = _props3.error;
	
	    error = error || this.state.error;
	    if (!menuId) {
	      menuId = id + '-menu';
	    }
	
	    if (!listId) {
	      listId = menuId + '-options';
	    }
	
	    var _state = this.state,
	        listProps = _state.listProps,
	        active = _state.active,
	        activeLabel = _state.activeLabel;
	
	    var below = position === SelectField.Positions.BELOW;
	    var visible = typeof isOpen !== 'undefined' ? isOpen : (0, _getField2.default)(this.props, this.state, 'visible');
	    var value = (0, _getField2.default)(this.props, this.state, 'value');
	    var useSameWidth = typeof sameWidth !== 'undefined' ? sameWidth : below;
	
	    var toggle = _react2.default.createElement(_SelectFieldToggle2.default, _extends({}, props, {
	      id: id,
	      style: toggleStyle,
	      className: toggleClassName,
	      visible: visible,
	      value: value,
	      below: below,
	      error: error,
	      active: active,
	      activeLabel: activeLabel,
	      onClick: this._toggle,
	      onFocus: this._handleFocus,
	      onBlur: this._handleBlur
	    }));
	
	    return _react2.default.createElement(
	      _Menu2.default,
	      {
	        id: menuId,
	        listId: listId,
	        style: style,
	        className: (0, _classnames2.default)('md-menu--select-field', className),
	        listProps: listProps,
	        listStyle: listStyle,
	        listClassName: listClassName,
	        toggle: toggle,
	        visible: visible,
	        onClose: this._close,
	        onKeyDown: this._handleKeyDown,
	        onClick: this._handleClick,
	        simplified: simplifiedMenu,
	        anchor: anchor,
	        belowAnchor: belowAnchor,
	        fixedTo: fixedTo,
	        position: position,
	        xThreshold: xThreshold,
	        yThreshold: yThreshold,
	        listZDepth: listZDepth,
	        listInline: listInline,
	        listHeightRestricted: listHeightRestricted,
	        sameWidth: useSameWidth,
	        block: block,
	        centered: centered,
	        fullWidth: fullWidth,
	        minLeft: minLeft,
	        minRight: minRight,
	        minBottom: minBottom,
	        fillViewportWidth: fillViewportWidth,
	        fillViewportHeight: fillViewportHeight,
	        repositionOnScroll: repositionOnScroll,
	        repositionOnResize: repositionOnResize,
	        transitionName: menuTransitionName,
	        transitionEnterTimeout: menuTransitionEnterTimeout,
	        transitionLeaveTimeout: menuTransitionLeaveTimeout
	      },
	      menuItems.reduce(this._reduceItems, [])
	    );
	  };
	
	  _createClass(SelectField, [{
	    key: 'value',
	    get: function get() {
	      return (0, _getField2.default)(this.props, this.state, 'value');
	    }
	  }]);
	
	  return SelectField;
	}(_react.PureComponent);
	
	SelectField.HorizontalAnchors = _Menu2.default.HorizontalAnchors;
	SelectField.VerticalAnchors = _Menu2.default.VerticalAnchors;
	SelectField.Positions = _Menu2.default.Positions;
	SelectField.propTypes = {
	  /**
	   * An id to give the select field. This is required for accessibility.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * An optional name to give to the select field.
	   */
	  name: _propTypes2.default.string,
	
	  /**
	   * An optional id to provide to the select field's menu. If this is omitted,
	   * it will default to `${id}-menu`.
	   */
	  menuId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to provide to the select field's list.
	   *
	   * @see {@link #menuId}
	   * @see {@link Menus/Menu#menuId}
	   */
	  listId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply to the select field's container (the menu).
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the select field's container (the menu).
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the menu's list.
	   */
	  listStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the menu's list.
	   */
	  listClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the select field's toggle.
	   */
	  toggleStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the select field's toggle.
	   */
	  toggleClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the `AccessibleFakeInkedButton` that is the trigger
	   * for the select field.
	   */
	  inputStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `AccessibleFakeInkedButton` that is the trigger
	   * for the select field.
	   */
	  inputClassName: _propTypes2.default.string,
	
	  /**
	   * Boolean if the select field should be have the menu's list visible by default.
	   */
	  defaultVisible: _propTypes2.default.bool.isRequired,
	
	  /**
	   * Boolean if the select field should have the menu's list visible. This will make
	   * the select field controlled and require the `onVisibilityChange` prop to be defined,
	   */
	  visible: (0, _controlled2.default)(_propTypes2.default.bool, 'onVisibilityChange', 'defaultVisible'),
	
	  /**
	   * An optional function to call when the select field's menu has it's visibility changed. The callback
	   * will include the next visible state and the event that triggered it.
	   */
	  onVisibilityChange: _propTypes2.default.func,
	
	  /**
	   * A list of `number`, `string`, or `object` that should be used to create `ListItem`
	   * in the menu's list. When it is an `object`, it will use the `itemLabel` prop as the
	   * `primaryText` and use the value of `itemValue`.
	   *
	   * @see {@link #itemLabel}
	   * @see {@link #itemValue}
	   */
	  menuItems: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.element])).isRequired,
	
	  /**
	   * The amount of time that a list of letters should be used when finding a menu item
	   * while typing. Since a user can select items by typing multiple letters in a row,
	   * this will be used as the timeout for clearing those letters.
	   *
	   * For example:
	   * - User types `g`
	   *
	   * Full match is now `'g'`.
	   *
	   * - User delays 200ms and types `u`
	   *
	   * Full match is now `'gu'`
	   *
	   * - User delays 1000ms and types `a`.
	   *
	   * Full match is now `'a'`
	   */
	  keyboardMatchingTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * The key to use for extracting a menu item's label if the menu item is an object.
	   *
	   * Example:
	   *
	   * ```js
	   * const item = { something: 'My Label', somethingElse: 'value' };
	   * const itemLabel = 'something';
	   * const itemValue = 'somethingElse';
	   * ```
	   */
	  itemLabel: _propTypes2.default.string.isRequired,
	
	  /**
	   * The key to use for extracting a menu item's value if the menu item is an object.
	   *
	   * Example:
	   *
	   * ```js
	   * const item = { something: 'My Label', somethingElse: 'value' };
	   * const itemLabel = 'something';
	   * const itemValue = 'somethingElse';
	   * ```
	   */
	  itemValue: _propTypes2.default.string.isRequired,
	
	  /**
	   * The key to use for extracting a menu item's function
	   * to get additional `ListItem` props if the menu item is an object.
	   *
	   * Example:
	   *
	   * ```js
	   * const item = { something: 'My Label', addProps: ({active}) => active ? {secondaryText: 'some text'} : null };
	   * const itemLabel = 'something';
	   * const itemProps = 'addProps';
	   * ```
	   *
	   * @see {@link #getItemProps}
	   */
	  itemProps: _propTypes2.default.string.isRequired,
	
	  /**
	   * An optional function to get additional `ListItem` props if the menu item is an object.
	   *
	   * An object with the following fields will be passed into the function:
	   * - `index` - item's index
	   * - `active` - whether item is active
	   * - `disabled` - whether item is disabled
	   * - `itemValue` - item's value
	   * - `value` - current list value
	   * - `props` - default `ListItem` props
	   * - `item` - source item's data
	   * - `field` - reference to the component instance
	   */
	  getItemProps: _propTypes2.default.func,
	
	  /**
	   * The default value to use for the select field. If this is set, it should either match
	   * one of the `number` or `string` in your `menuItems` list or be the empty string. If
	   * the `menuItems` is a list of `object`, this value should match one of the menu item's
	   * `itemValue` or be the empty string.
	   *
	   * ```js
	   * const menuItems = [{ label: 'Something': value: 0 }, { label: 'Something else', value: 1 }];
	   *
	   * // both valid
	   * defaultValue={0}
	   * defaultValue=""
	   * ```
	   */
	  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	
	  /**
	   * The value to use for the select field. If this is defined, it becomes a controlled component
	   * and requires the `onChange` prop to be defined. See the `defaultValue` for more behavior info.
	   *
	   * @see {@link #defaultValue}
	   */
	  value: (0, _controlled2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]), 'onChange', 'defaultValue'),
	
	  /**
	   * An optional function to call when the select field's value has been changed either when the user
	   * has click/touched/keyboard selected a value in the list, or the user has selected a value by typing
	   * in the select field while the menu's list is closed.
	   *
	   * The callback will include the next text field value, the selected item's index, the event that
	   * triggered the change, and the id, name, and value of the select field.
	   *
	   * ```js
	   * onChange(value, index, event, { id, name, value });
	   * ```
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * An optional label to use with the select field. This will be a floating label as seen on the text field.
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * An optional placeholder to use in the select field. This will only appear when no value has been selected.
	   */
	  placeholder: _propTypes2.default.string,
	
	  /**
	   * Boolean if the select field should be disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the select field is required. This will update the label and placeholder to include a `*` suffix.
	   */
	  required: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the select field is considered to be in an `error` state.
	   *
	   * @see {@link TextFields/TextField#error}
	   */
	  error: _propTypes2.default.bool,
	
	  /**
	   * An optional text to display when the text select field is in an error state.
	   *
	   * @see {@link TextFields/TextField#errorText}
	   */
	  errorText: _propTypes2.default.node,
	
	  /**
	   * An optional text to display below the select field to provide input help to the user.
	   * This will only be displayed if the select field is not in an error state.
	   *
	   * @see {@link #helpOnFocus}
	   * @see {@link TextFields/TextField#errorText}
	   */
	  helpText: _propTypes2.default.node,
	
	  /**
	   * Boolean if the `helpText` should only appear on focus.
	   *
	   * @see {@link #helpText}
	   * @see {@link TextFields/TextField#helpOnFocus}
	   */
	  helpOnFocus: _propTypes2.default.bool,
	
	  /**
	   * An optional function to call when any element in the select field has been clicked.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `keydown` event has been triggered anywhere in the
	   * select field.
	   */
	  onKeyDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the select field's toggle has gained focus.
	   */
	  onFocus: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the select field's toggle has been blurred. This
	   * will be triggered if the user hits the up or down arrow keys to traverse the list
	   * of items.
	   */
	  onBlur: _propTypes2.default.func,
	
	  /**
	   * The icon to use to display the dropdown arrow.
	   */
	  dropdownIcon: _propTypes2.default.element,
	
	  /**
	   * Boolean if the select field is in a toolbar. This should automatically be injected by the `Toolbar`
	   * component if being used as a `titleMenu` or one of the `actions`.
	   *
	   * @see {@link Toolbars/Toolbar#titleMenu}
	   * @see {@link Toolbars/Toolbar#actions}
	   */
	  toolbar: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the currently active item should be removed from the list of available `menuItems`.
	   * If this is `undefined`, it will strip out the active one only when the
	   * `position === SelectField.Positions.BELOW`.
	   */
	  stripActiveItem: _propTypes2.default.bool,
	
	  /**
	   * The transition name to use when a new value has been selected. By default, it will have the
	   * new item _drop_ into the select field's input location.
	   */
	  transitionName: _propTypes2.default.string.isRequired,
	
	  /**
	   * The transition time to use when a new value has been selected. If this value is `0`, there
	   * will be no transition.
	   */
	  transitionTime: _propTypes2.default.number.isRequired,
	
	  /**
	   * This is how the menu's `List` gets anchored to the select field.
	   *
	   * @see {@link Helpers/Layover#anchor}
	   */
	  anchor: _anchorShape2.default,
	
	  /**
	   * This is the anchor to use when the `position` is set to `Autocomplete.Positions.BELOW`.
	   *
	   * @see {@link Helpers/Layover#belowAnchor}
	   */
	  belowAnchor: _anchorShape2.default,
	
	  /**
	   * This is the animation position for the list that appears.
	   *
	   * @see {@link Helpers/Layover#animationPosition}
	   */
	  position: _positionShape2.default,
	
	  /**
	   * This is how the menu's list will be "fixed" to the `toggle` component.
	   *
	   * @see {@link Helpers/Layover#fixedTo}
	   */
	  fixedTo: _fixedToShape2.default,
	
	  /**
	   * Boolean if the menu's list should appear horizontally instead of vertically.
	   */
	  listInline: _propTypes2.default.bool,
	
	  /**
	   * The list's z-depth for applying box shadow. This should be a number from 0 to 5.
	   */
	  listZDepth: _propTypes2.default.number,
	
	  /**
	   * Boolean if the list should have its height restricted to the `$md-menu-mobile-max-height`/
	   * `$md-menu-desktop-max-height` values.
	   *
	   * @see [md-menu-mobile-max-height](/components/menus?tab=1#variable-md-menu-mobile-max-height)
	   * @see [md-menu-desktop-max-height](/components/menus?tab=1#variable-md-menu-desktop-max-height)
	   */
	  listHeightRestricted: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#xThreshold}
	   */
	  xThreshold: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#yThreshold}
	   */
	  yThreshold: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#closeOnOutsideClick}
	   */
	  closeOnOutsideClick: _propTypes2.default.bool,
	
	  /**
	   * An optional transition name to use for the list appearing/disappearing.
	   *
	   * @see {@link Menus/Menu#transitionName}
	   */
	  menuTransitionName: _propTypes2.default.string,
	
	  /**
	   * @see {@link Helpers/Layover#transitionEnterTimeout}
	   */
	  menuTransitionEnterTimeout: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#transitionLeaveTimeout}
	   */
	  menuTransitionLeaveTimeout: _propTypes2.default.number,
	
	  /**
	   * @see {@link Menus/Menu#block}
	   */
	  block: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Menus/Menu#fullWidth}
	   */
	  fullWidth: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#centered}
	   */
	  centered: _Menu2.default.propTypes.centered,
	
	  /**
	   * @see {@link Helpers/Layover#sameWidth}
	   */
	  sameWidth: _Menu2.default.propTypes.sameWidth,
	
	  /**
	   * Since the `menuItems` get mapped into `ListItem`, this prop is used to remove
	   * any unnecessary props from the `ListItem` itself. This is where you
	   * would remove parts of your object such as `description` or `__metadata__`.
	   */
	  deleteKeys: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]))]),
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the `fixedTo` element scrolls.
	   *
	   * @see {@link Helpers/Layover#repositionOnScroll}
	   */
	  repositionOnScroll: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the window resizes.
	   *
	   * @see {@link Helpers/Layover#repositionOnResize}
	   */
	  repositionOnResize: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu logic should be simplified without any viewport logic and position
	   * based on the relative position of the menu. This will most like require some additional
	   * styles applied to the menu.
	   *
	   * @see {@link Helpers/Layover#simplified}
	   */
	  simplifiedMenu: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#minLeft}
	   */
	  minLeft: _Menu2.default.propTypes.minLeft,
	
	  /**
	   * @see {@link Helpers/Layover#minRight}
	   */
	  minRight: _Menu2.default.propTypes.minLeft,
	
	  /**
	   * @see {@link Helpers/Layover#minBottom}
	   */
	  minBottom: _Menu2.default.propTypes.minBottom,
	
	  /**
	   * @see {@link Helpers/Layover#fillViewportWidth}
	   */
	  fillViewportWidth: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#fillViewportHeight}
	   */
	  fillViewportHeight: _propTypes2.default.bool,
	
	  /**
	   * The direction that the underline should appear from.
	   */
	  lineDirection: _propTypes2.default.oneOf(['left', 'center', 'right']).isRequired,
	
	  iconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `dropdownIcon` instead'),
	  iconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `dropdownIcon` instead'),
	  isOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `visible` instead'),
	  defaultOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `defaultVisible` instead'),
	  initiallyOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `defaultVisible` instead'),
	  onMenuToggle: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `onVisibilityChange` instead'),
	  stretchList: (0, _deprecated2.default)(_propTypes2.default.bool, 'No longer valid after the changes to the `Menu` component. Possibly use `sameWidth` instead'),
	  menuStyle: (0, _deprecated2.default)(_propTypes2.default.object, 'Use `style` instead'),
	  menuClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `className` instead'),
	  floatingLabel: (0, _deprecated2.default)(_propTypes2.default.bool, 'A select field can only have floating labels now. Only provide the `label` prop'),
	  noAutoAdjust: (0, _deprecated2.default)(_propTypes2.default.bool, 'No longer valid to use since select fields are no longer text fields'),
	  adjustMinWidth: (0, _deprecated2.default)(_propTypes2.default.bool, 'No longer valid to use since select fields are no longer text fields')
	};
	SelectField.defaultProps = {
	  anchor: {
	    x: SelectField.HorizontalAnchors.INNER_LEFT,
	    y: SelectField.VerticalAnchors.OVERLAP
	  },
	  fixedTo: _Menu2.default.defaultProps.fixedTo,
	  position: SelectField.Positions.TOP_LEFT,
	  itemLabel: 'label',
	  itemValue: 'value',
	  itemProps: 'getProps',
	  dropdownIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'arrow_drop_down'
	  ),
	  lineDirection: 'left',
	  menuItems: [],
	  defaultValue: '',
	  defaultVisible: false,
	  keyboardMatchingTimeout: 1000,
	  transitionName: 'md-drop',
	  transitionTime: 300,
	  repositionOnScroll: true,
	  repositionOnResize: false
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._getActiveItemLabel = function (item, value, itemLabel, itemValue) {
	    var v = _this2._getItemPart(item, itemLabel, itemValue);
	    var label = _this2._getItemPart(item, itemLabel, itemValue, true);
	
	    return v === value || v === parseFloat(value) ? label : '';
	  };
	
	  this._getActive = function (props, state) {
	    var activeLabel = '';
	    var activeIndex = -1;
	    var value = (0, _getField2.default)(props, state, 'value');
	    if ((0, _isValued2.default)(value)) {
	      var menuItems = props.menuItems,
	          itemLabel = props.itemLabel,
	          itemValue = props.itemValue;
	
	
	      menuItems.some(function (item, index) {
	        activeLabel = _this2._getActiveItemLabel(item, value, itemLabel, itemValue);
	        var found = (0, _isValued2.default)(activeLabel);
	        if (found) {
	          activeIndex = index;
	        }
	
	        return found;
	      });
	    }
	
	    return { activeLabel: activeLabel, activeIndex: activeIndex };
	  };
	
	  this._attemptItemFocus = function (index) {
	    if (index === -1) {
	      return;
	    }
	
	    var item = _this2._items[index];
	    if (item) {
	      item.focus();
	    }
	  };
	
	  this._setListItem = function (item) {
	    if (!item) {
	      return;
	    }
	
	    if (item.props.active) {
	      _this2._activeItem = (0, _reactDom.findDOMNode)(item);
	      item.focus();
	
	      if (!_this2.state.listProps[ARIA_ACTIVE]) {
	        var _extends2;
	
	        _this2.setState({ listProps: _extends({}, _this2.state.listProps, (_extends2 = {}, _extends2[ARIA_ACTIVE] = _this2.props.id + '-options-active', _extends2)) });
	      }
	    }
	
	    _this2._items.push(item);
	  };
	
	  this._scrollActiveIntoView = function (listRef) {
	    if (listRef === null) {
	      _this2._items = [];
	      return;
	    } else if (!_this2._activeItem) {
	      return;
	    }
	
	    var list = (0, _reactDom.findDOMNode)(listRef);
	    var offsetTop = _this2._activeItem.offsetTop;
	
	    list.scrollTop = offsetTop > MOBILE_LIST_PADDING ? offsetTop : 0;
	  };
	
	  this._toggle = function (e) {
	    var _props4 = _this2.props,
	        isOpen = _props4.isOpen,
	        onVisibilityChange = _props4.onVisibilityChange,
	        onMenuToggle = _props4.onMenuToggle;
	
	    var visible = !(typeof isOpen !== 'undefined' ? isOpen : (0, _getField2.default)(_this2.props, _this2.state, 'visible'));
	    if (onMenuToggle || onVisibilityChange) {
	      (onMenuToggle || onVisibilityChange)(visible, e);
	    }
	
	    var state = void 0;
	    if (typeof isOpen === 'undefined' && typeof _this2.props.visible === 'undefined') {
	      state = { visible: visible };
	    }
	
	    if (state) {
	      _this2.setState(state);
	    }
	  };
	
	  this._close = function (e) {
	    if (_this2.props.onVisibilityChange) {
	      _this2.props.onVisibilityChange(false, e);
	    }
	
	    if (e.type === 'keydown' && _this2._field) {
	      _this2._field.focus();
	    }
	
	    var state = void 0;
	    if (_this2.props.required && !(0, _getField2.default)(_this2.props, _this2.state, 'value')) {
	      state = { error: true };
	    }
	
	    if (typeof _this2.props.visible === 'undefined') {
	      state = state || {};
	      state.visible = false;
	    }
	
	    if (state) {
	      _this2.setState(state);
	    }
	  };
	
	  this._handleClick = function (e) {
	    if (_this2.props.onClick) {
	      _this2.props.onClick(e);
	    }
	
	    var isOpen = _this2.props.isOpen;
	
	    var visible = typeof isOpen !== 'undefined' ? isOpen : (0, _getField2.default)(_this2.props, _this2.state, 'visible');
	    if (visible && _this2._container) {
	      var node = e.target;
	      while (_this2._container.contains(node)) {
	        if (node.dataset && typeof node.dataset.id !== 'undefined') {
	          var _node$dataset = node.dataset,
	              id = _node$dataset.id,
	              value = _node$dataset.value;
	
	          _this2._selectItem(parseInt(id, 10), value, e);
	          return;
	        }
	
	        node = node.parentNode;
	      }
	    }
	  };
	
	  this._selectItem = function (dataIndex, dataValue, e) {
	    var _props5 = _this2.props,
	        required = _props5.required,
	        menuItems = _props5.menuItems,
	        itemLabel = _props5.itemLabel,
	        itemValue = _props5.itemValue,
	        onChange = _props5.onChange,
	        id = _props5.id,
	        name = _props5.name;
	
	    var value = _this2._getItemPart(menuItems[dataIndex], itemLabel, itemValue);
	    var prevValue = (0, _getField2.default)(_this2.props, _this2.state, 'value');
	    if (prevValue !== value && onChange) {
	      onChange(value, dataIndex, e, { id: id, name: name, value: value });
	    }
	
	    var state = _extends({}, _this2._getActive({ value: value, itemLabel: itemLabel, itemValue: itemValue, menuItems: menuItems }, {}), {
	      error: !!required && !value && value !== 0
	    });
	
	    if (typeof _this2.props.value === 'undefined') {
	      state.value = value;
	    }
	
	    _this2.setState(state);
	  };
	
	  this._handleFocus = function (e) {
	    if (_this2.props.onFocus) {
	      _this2.props.onFocus(e);
	    }
	
	    _this2.setState({ active: true });
	  };
	
	  this._handleBlur = function (e) {
	    if (_this2.props.onBlur) {
	      _this2.props.onBlur(e);
	    }
	
	    var error = _this2.state.error;
	    var _props6 = _this2.props,
	        isOpen = _props6.isOpen,
	        required = _props6.required;
	
	    var visible = typeof isOpen !== 'undefined' ? isOpen : (0, _getField2.default)(_this2.props, _this2.state, 'visible');
	    var value = (0, _getField2.default)(_this2.props, _this2.state, 'value');
	
	    if (required && !visible) {
	      error = !value;
	    }
	
	    _this2.setState({ active: false, error: error });
	  };
	
	  this._handleKeyDown = function (e) {
	    var _props7 = _this2.props,
	        isOpen = _props7.isOpen,
	        onKeyDown = _props7.onKeyDown;
	
	    if (onKeyDown) {
	      onKeyDown(e);
	    }
	
	    var key = e.which || e.keyCode;
	    var up = key === _keyCodes.UP;
	    var down = key === _keyCodes.DOWN;
	    var visible = typeof isOpen !== 'undefined' ? isOpen : (0, _getField2.default)(_this2.props, _this2.state, 'visible');
	
	    if (up || down) {
	      e.preventDefault();
	
	      if (!visible) {
	        _this2._toggle(e);
	        return;
	      }
	
	      _this2._advanceFocus(up);
	    } else if (!visible && (0, _handleKeyboardAccessibility2.default)(e, _this2._toggle, true, true)) {
	      return;
	    } else if (visible && (key === _keyCodes.ESC || key === _keyCodes.TAB)) {
	      if (_this2._field && key === _keyCodes.ESC) {
	        _this2._field.focus();
	      }
	
	      _this2._close(e);
	      return;
	    } else {
	      _this2._selectItemByLetter(key, e);
	    }
	  };
	
	  this._advanceFocus = function (decrement) {
	    var _props8 = _this2.props,
	        position = _props8.position,
	        stripActiveItem = _props8.stripActiveItem;
	    var activeIndex = _this2.state.activeIndex;
	
	
	    var below = position === SelectField.Positions.BELOW;
	    var value = (0, _getField2.default)(_this2.props, _this2.state, 'value');
	    var valued = (0, _isValued2.default)(value);
	    var itemStripped = (typeof stripActiveItem !== 'undefined' ? stripActiveItem : below) && valued;
	
	    // If the select field is positioned below and there is no value, need to increment the last index
	    // by one since this select field removes the active item. Need to account for that here when there
	    // is no value.
	    var lastIndex = _this2._items.length - (itemStripped ? 0 : 1);
	    if (decrement && activeIndex <= 0 || !decrement && activeIndex >= lastIndex) {
	      return;
	    }
	
	    var nextIndex = Math.max(-1, Math.min(lastIndex, activeIndex + (decrement ? -1 : 1)));
	    if (nextIndex === activeIndex) {
	      return;
	    }
	
	    _this2._attemptItemFocus(nextIndex - (itemStripped ? 1 : 0));
	    _this2.setState({ activeIndex: nextIndex });
	  };
	
	  this._selectItemByLetter = function (key, e) {
	    var charCode = String.fromCharCode(key);
	    var isLetter = charCode && charCode.match(/[A-Za-z0-9-_ ]/);
	    var isKeypad = (0, _isBetween2.default)(key, _keyCodes.KEYPAD_ZERO, _keyCodes.KEYPAD_NINE);
	    if (!(0, _isBetween2.default)(key, _keyCodes.ZERO, _keyCodes.NINE) && !isKeypad && !isLetter) {
	      return;
	    }
	
	    var letter = isLetter ? charCode : String(key - (isKeypad ? _keyCodes.KEYPAD_ZERO : _keyCodes.ZERO));
	
	    if (_this2._matchingTimeout) {
	      clearTimeout(_this2._matchingTimeout);
	    }
	
	    _this2._matchingTimeout = setTimeout(function () {
	      _this2._matchingTimeout = null;
	
	      _this2.setState({ match: null, lastSearch: null });
	    }, _this2.props.keyboardMatchingTimeout);
	
	    _this2._selectFirstMatch(letter, e);
	  };
	
	  this._selectFirstMatch = function (letter, e) {
	    var _props9 = _this2.props,
	        menuItems = _props9.menuItems,
	        itemLabel = _props9.itemLabel,
	        itemValue = _props9.itemValue,
	        isOpen = _props9.isOpen,
	        onChange = _props9.onChange,
	        id = _props9.id,
	        name = _props9.name;
	    var lastSearch = _this2.state.lastSearch;
	
	    var match = -1;
	    var search = ('' + (lastSearch || '') + letter).toUpperCase();
	    menuItems.some(function (item, index) {
	      if (item && (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && item.disabled) {
	        return false;
	      }
	
	      var label = String(_this2._getItemPart(item, itemLabel, itemValue, true));
	      if (label && label.toUpperCase().replace(/\s/g, '').indexOf(search) === 0) {
	        match = index;
	      }
	
	      return match > -1;
	    });
	
	    var state = {
	      match: match,
	      lastSearch: search
	    };
	
	    if (match !== -1) {
	      var activeItem = menuItems[match];
	      state.activeLabel = _this2._getItemPart(activeItem, itemLabel, itemValue, true);
	      state.activeIndex = match;
	
	      var visible = typeof isOpen !== 'undefined' ? isOpen : (0, _getField2.default)(_this2.props, _this2.state, 'visible');
	      if (visible) {
	        if (state.match !== _this2.state.match) {
	          _this2._attemptItemFocus(state.activeIndex);
	        }
	      } else {
	        var value = _this2._getItemPart(activeItem, itemLabel, itemValue);
	        var prevValue = (0, _getField2.default)(_this2.props, _this2.state, 'value');
	
	        if (value !== prevValue && onChange) {
	          onChange(value, match, e, { id: id, name: name, value: value });
	        }
	
	        if (typeof _this2.props.value === 'undefined') {
	          state.value = value;
	        }
	      }
	    }
	
	    _this2.setState(state);
	  };
	
	  this._reduceItems = function (items, item, i) {
	    if (item === null) {
	      return items;
	    } else if (_react2.default.isValidElement(item)) {
	      items.push(item);
	      return items;
	    }
	
	    var _props10 = _this2.props,
	        getItemProps = _props10.getItemProps,
	        id = _props10.id,
	        itemLabel = _props10.itemLabel,
	        itemProps = _props10.itemProps,
	        itemValue = _props10.itemValue,
	        position = _props10.position,
	        stripActiveItem = _props10.stripActiveItem;
	
	    var below = position === SelectField.Positions.BELOW;
	    var value = (0, _getField2.default)(_this2.props, _this2.state, 'value');
	
	    var dataValue = _this2._getItemPart(item, itemLabel, itemValue);
	    var primaryText = _this2._getItemPart(item, itemLabel, itemValue, true);
	
	    var active = dataValue === value || dataValue === parseFloat(value);
	    var stripped = (typeof stripActiveItem !== 'undefined' ? stripActiveItem : below) && active;
	    if (!stripped) {
	      var objectType = (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object';
	      var props = objectType ? (0, _omit2.default)(item, _this2._deleteKeys) : {};
	      var disabled = props.disabled || false;
	      props.ref = disabled ? null : _this2._setListItem;
	      props.id = active ? id + '-options-active' : null;
	      props.active = active;
	      props.tabIndex = -1;
	      props.primaryText = primaryText;
	      props.key = item.key || dataValue;
	      props.role = 'option';
	      props['data-id'] = disabled ? null : i;
	      props['data-value'] = disabled ? null : dataValue;
	
	      var getProps = objectType && item[itemProps] || getItemProps;
	      if (typeof getProps === 'function') {
	        Object.assign(props, getProps({
	          index: i,
	          active: active,
	          disabled: disabled,
	          itemValue: itemValue,
	          value: value,
	          props: props,
	          item: item,
	          field: _this2
	        }));
	      }
	
	      items.push(_react2.default.createElement(_ListItem2.default, props));
	    }
	
	    return items;
	  };
	};
	
	exports.default = SelectField;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(7);
	
	var _CSSTransitionGroup = __webpack_require__(38);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _deprecated = __webpack_require__(5);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _getField = __webpack_require__(8);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _CSSTransitionGroupTick = __webpack_require__(29);
	
	var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);
	
	var _isInvalidAnimate = __webpack_require__(124);
	
	var _isInvalidAnimate2 = _interopRequireDefault(_isInvalidAnimate);
	
	var _Portal = __webpack_require__(34);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Snackbar = __webpack_require__(171);
	
	var _Snackbar2 = _interopRequireDefault(_Snackbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CHAINED_TOAST_DELAY = 50;
	
	/**
	 * The `Snackbar` component is used for displaying a concise and small message to the user about
	 * an operation performed.
	 *
	 * > The main component for the `Snackbar` is actually named the `SnackbarContainer`, so you need
	 * to make sure the import is `react-md/lib/Snackbars` or `react-md/lib/Snackbars/SnackbarContainer`.
	 * The first import is preferable.
	 */
	
	var SnackbarContainer = function (_PureComponent) {
	  _inherits(SnackbarContainer, _PureComponent);
	
	  function SnackbarContainer(props) {
	    _classCallCheck(this, SnackbarContainer);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var visible = !!props.toasts.length;
	    _this.state = {
	      visible: visible,
	      toast: null
	    };
	    return _this;
	  }
	
	  SnackbarContainer.prototype.componentDidMount = function componentDidMount() {
	    var toasts = this.props.toasts;
	
	    if (toasts.length) {
	      this._initAndToast(toasts[0]);
	    }
	  };
	
	  SnackbarContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _nextProps$toasts = nextProps.toasts,
	        toast = _nextProps$toasts[0];
	    var _props$toasts = this.props.toasts,
	        prevToast = _props$toasts[0];
	
	    if (toast === prevToast || toast === this.state.toast) {
	      return;
	    }
	
	    if (!toast) {
	      this._createLeaveTimer();
	    } else if (!this.state.visible) {
	      this._initAndToast(toast);
	    } else {
	      this._createSwapTimer(toast);
	    }
	  };
	
	  SnackbarContainer.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this._initTimeout) {
	      clearTimeout(this._initTimeout);
	    }
	
	    if (this._leaveTimeout) {
	      clearTimeout(this._leaveTimeout);
	    }
	
	    if (this._swapTimeout) {
	      clearTimeout(this._swapTimeout);
	    }
	
	    if (this._dismissTimeout) {
	      clearTimeout(this._dismissTimeout);
	    }
	  };
	
	  /**
	   * This function takes in a new toast object and checks if the message will span
	   * multiple lines of text by creating the new snackbar before the `Snackbar` component
	   * gets made, checking the height of the message, and then removing the temporary
	   * snackbar.
	   */
	
	
	  SnackbarContainer.prototype.render = function render() {
	    var _state = this.state,
	        visible = _state.visible,
	        toast = _state.toast,
	        multiline = _state.multiline;
	
	    var _props = this.props,
	        transitionName = _props.transitionName,
	        transitionEnterTimeout = _props.transitionEnterTimeout,
	        transitionLeaveTimeout = _props.transitionLeaveTimeout,
	        dismiss = _props.dismiss,
	        onDismiss = _props.onDismiss,
	        lastChild = _props.lastChild,
	        portal = _props.portal,
	        propRenderNode = _props.renderNode,
	        toasts = _props.toasts,
	        props = _objectWithoutProperties(_props, ['transitionName', 'transitionEnterTimeout', 'transitionLeaveTimeout', 'dismiss', 'onDismiss', 'lastChild', 'portal', 'renderNode', 'toasts']);
	
	    var renderNode = (0, _getField2.default)(this.props, this.context, 'renderNode');
	
	    var snackbar = void 0;
	    if (toast) {
	      snackbar = _react2.default.createElement(_Snackbar2.default, _extends({}, props, {
	        key: 'snackbar',
	        leaveTimeout: transitionLeaveTimeout,
	        toast: toast,
	        multiline: multiline,
	        onDismiss: onDismiss || dismiss
	      }));
	    }
	
	    var container = _react2.default.createElement(
	      _CSSTransitionGroup2.default,
	      {
	        ref: this._setContainer,
	        key: 'container',
	        className: 'md-snackbar-container',
	        transitionName: transitionName,
	        transitionEnterTimeout: transitionEnterTimeout,
	        transitionLeaveTimeout: transitionLeaveTimeout
	      },
	      snackbar
	    );
	
	    if (!portal) {
	      return visible ? container : null;
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      { visible: visible, renderNode: renderNode, lastChild: lastChild },
	      container
	    );
	  };
	
	  return SnackbarContainer;
	}(_react.PureComponent);
	
	SnackbarContainer.propTypes = {
	  /**
	   * An id for the Snackbar once a toast has been added and is visible. This is a recommended
	   * prop for accessibility concerns. If it is omitted, the id will become `'snackbar-alert'`
	   * when there is no action on the toast, or `'snackbar-alert-dialog'` when there is an action
	   * on the toast.
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply to the snackbar once it appears.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the snackbar once it appears.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An immutable controlled queue of toasts that should appear in the snackbar.
	   * The snackbar will always display the first toast in this list. When the user has
	   * either clicked the action of the toast, or the `autohideTimeout` has been reached,
	   * the `onDismiss` function will be called. The `onDismiss` function should remove the
	   * first toast and return a new list of remaining toasts.
	   *
	   * ```js
	   * let toasts = [];
	   * const onDismiss = () => {
	   *   const [, ...remainingToasts] = toasts;
	   *   toasts = remainingToasts;
	   * };
	   * ```
	   */
	  toasts: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    /**
	     * The text to display in the toast.
	     */
	    text: _propTypes2.default.node.isRequired,
	
	    /**
	     * An optional action to take. If this value is a string, the `label` for the
	     * button will be this value, Otherwise, all the keys in the action object will
	     * be applied to the `Button`.
	     */
	    action: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.shape({
	      onClick: _propTypes2.default.func,
	      children: _propTypes2.default.node,
	      // Deprecated
	      label: _propTypes2.default.node
	    })])
	  })).isRequired,
	
	  /**
	   * A function to call that will dismiss a toast. This will automatically be bound to
	   * any toast that has an `action` and it will also be called when the `autohideTimeout`
	   * has been reached.
	   */
	  onDismiss: _propTypes2.default.func.isRequired,
	
	  /**
	   * Boolean if the snackbar's toasts should automatically be dismissed after the
	   * `autohideTimeout` has been reached.
	   */
	  autohide: _propTypes2.default.bool,
	
	  /**
	   * The amount of time before the snackbar should be dequeued and the next toast
	   * should be displayed.
	   */
	  autohideTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * The transition name to use for the snackbar appearing and disappearing.
	   */
	  transitionName: _propTypes2.default.string.isRequired,
	
	  /**
	   * The transition time for the snackbar to enter. This should match the `$md-snackbar-transition-time`
	   * sass variable.
	   */
	  transitionEnterTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * The transition time for the snackbar to leave. This should match the `$md-snackbar-transition-time`
	   * sass variable.
	   */
	  transitionLeaveTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * When the app contains a floating action button that is fixed to the bottom of the screen,
	   * you should set this to be a ref of the floating action button. When a snackbar appears,
	   * the FAB will be moved to not overlay the snackbar.
	   */
	  fab: function fab(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	    if (!propValue) {
	      return null;
	    }
	
	    if (propType !== 'object' || typeof propValue.render !== 'function' || (0, _isInvalidAnimate2.default)(propValue)) {
	      var componentNameSafe = componentName || '<<anonymous>>';
	      var propFullNameSafe = propFullName || propName;
	      return new Error('Invalid ' + location + ' `' + propFullNameSafe + '` supplied to `' + componentNameSafe + '`, expected a ' + 'ref to a floating `Button` component. This should not be a DOMElement from `findDOMNode` but instead ' + 'the React ref object.');
	    }
	
	    return null;
	  },
	
	  /**
	   * Boolean if the Portal's functionality of rendering in a separate react tree should be applied
	   * to the snackbar.
	   *
	   * @see {@link Helpers/Portal}
	   */
	  portal: _propTypes2.default.bool,
	
	  /**
	   * An optional DOM node to render the Snackbar in. If this is omitted, it will render as the first
	   * child in the `body`.
	   */
	  renderNode: _propTypes2.default.object,
	
	  /**
	   * Boolean if the snackbar should render as the last child in the `renderNode` or `body` instead of
	   * as the first.
	   */
	  lastChild: _propTypes2.default.bool,
	  dismiss: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `onDismiss` instead')
	};
	SnackbarContainer.defaultProps = {
	  autohide: true,
	  toasts: [],
	  autohideTimeout: 3000,
	  transitionName: 'md-snackbar',
	  transitionEnterTimeout: 300,
	  transitionLeaveTimeout: 300
	};
	SnackbarContainer.contextTypes = {
	  renderNode: _propTypes2.default.object
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._setContainer = function (container) {
	    _this2._container = (0, _reactDom.findDOMNode)(container);
	  };
	
	  this._isMultiline = function (toast) {
	    var container = _this2._container;
	    if (container === null) {
	      return false;
	    }
	
	    var message = document.createElement('p');
	    message.classList.add('md-snackbar--toast');
	    message.innerHTML = toast.text;
	
	    var snackbar = void 0;
	    if (toast.action) {
	      message.classList.add('md-snackbar--action');
	
	      snackbar = document.createElement('section');
	      snackbar.className = 'md-snackbar';
	      snackbar.appendChild(message);
	
	      var action = document.createElement('button');
	      action.innerHTML = typeof toast.action === 'string' ? toast.action : toast.action.label;
	      action.className = 'md-btn md-btn--flat md-btn--text md-btn--snackbar';
	      snackbar.appendChild(action);
	    } else {
	      snackbar = message;
	    }
	
	    // Only style we really want from the .md-snackbar
	    snackbar.style.maxWidth = '568px';
	
	    container.appendChild(snackbar);
	    var multiline = message.offsetHeight > 20;
	    container.removeChild(snackbar);
	
	    return multiline;
	  };
	
	  this._initAndToast = function (toast) {
	    _this2._initTimeout = setTimeout(function () {
	      _this2._initTimeout = null;
	
	      _this2.setState({ toast: toast, multiline: _this2._isMultiline(toast) });
	    }, _CSSTransitionGroupTick2.default);
	
	    _this2.setState({ visible: true });
	  };
	
	  this._createLeaveTimer = function () {
	    var time = _this2.props.transitionLeaveTimeout;
	
	    _this2._leaveTimeout = setTimeout(function () {
	      _this2._leaveTimeout = null;
	
	      _this2.setState({ visible: false });
	    }, time + _CSSTransitionGroupTick2.default);
	
	    _this2.setState({ toast: null });
	  };
	
	  this._createSwapTimer = function (toast) {
	    _this2._swapTimeout = setTimeout(function () {
	      _this2._swapTimeout = null;
	
	      _this2.setState({ toast: toast, multiline: _this2._isMultiline(toast) });
	    }, _this2.props.transitionLeaveTimeout + CHAINED_TOAST_DELAY);
	
	    _this2.setState({ toast: null });
	  };
	};
	
	exports.default = SnackbarContainer;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Subheader = undefined;
	
	var _Subheader2 = __webpack_require__(88);
	
	var _Subheader3 = _interopRequireDefault(_Subheader2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Subheader3.default;
	exports.Subheader = _Subheader3.default;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ToolbarTitle = function (_PureComponent) {
	  _inherits(ToolbarTitle, _PureComponent);
	
	  function ToolbarTitle() {
	    _classCallCheck(this, ToolbarTitle);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  ToolbarTitle.prototype.render = function render() {
	    var _props = this.props,
	        title = _props.title,
	        className = _props.className,
	        prominent = _props.prominent,
	        offset = _props.offset,
	        props = _objectWithoutProperties(_props, ['title', 'className', 'prominent', 'offset']);
	
	    if (!title) {
	      return null;
	    }
	
	    var fullClassName = (0, _classnames2.default)('md-title md-title--toolbar', {
	      'md-title--toolbar-prominent': prominent,
	      'md-title--toolbar-offset': offset
	    }, className);
	
	    if ((0, _react.isValidElement)(title)) {
	      var titleEl = _react.Children.only(title);
	      return (0, _react.cloneElement)(title, _extends({}, props, {
	        id: titleEl.props.id || props.id,
	        className: (0, _classnames2.default)(fullClassName, titleEl.props.className)
	      }));
	    }
	
	    return _react2.default.createElement(
	      'h2',
	      _extends({}, props, {
	        className: fullClassName
	      }),
	      title
	    );
	  };
	
	  return ToolbarTitle;
	}(_react.PureComponent);
	
	ToolbarTitle.propTypes = {
	  className: _propTypes2.default.string,
	  prominent: _propTypes2.default.bool,
	  offset: _propTypes2.default.bool,
	  title: _propTypes2.default.node
	};
	exports.default = ToolbarTitle;

/***/ }),
/* 245 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var MOBILE_MIN_WIDTH = exports.MOBILE_MIN_WIDTH = 320;
	var TABLET_MIN_WIDTH = exports.TABLET_MIN_WIDTH = 768;
	var DESKTOP_MIN_WIDTH = exports.DESKTOP_MIN_WIDTH = 1025;

/***/ }),
/* 246 */,
/* 247 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getScroll;
	/** @module utils/Positioning/getScroll */
	
	/**
	 * A utility function to just get an element's scroll x and y
	 * values. This is really just needed because `window` uses
	 * different attributes.
	 *
	 * @param {Object} el - The element to get a scroll value from.
	 * @return {Object} an object containing the scrollX and scrollY of the element.
	 */
	function getScroll(el) {
	  if (typeof el.scrollX !== 'undefined' && typeof el.scrollY !== 'undefined') {
	    return { x: el.scrollX, y: el.scrollY };
	  } else if (typeof el.scrollLeft !== 'undefined' && typeof el.scrollTop !== 'undefined') {
	    return { x: el.scrollLeft, y: el.scrollTop };
	  }
	
	  return { x: 0, y: 0 };
	}

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getSelectedTextPosition;
	
	var _getSelectedText = __webpack_require__(254);
	
	var _getSelectedText2 = _interopRequireDefault(_getSelectedText);
	
	var _getTextWidth = __webpack_require__(128);
	
	var _getTextWidth2 = _interopRequireDefault(_getTextWidth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** @module utils/Positoning/getSelectedTextPosition */
	var ZERO_WIDTH_CHARACTER = '\u200B';
	
	/**
	 * A utility function to attempt to get the current highlighted text position.
	 *
	 * When a context menu is opened, this function attempts to find the bounding client rect
	 * for the highlighted text. However, if the text is in the text field, some weird stuff
	 * happens and it is unable to get it correctly.
	 */
	function getSelectedTextPosition(e) {
	  var height = void 0;
	  var target = e.target,
	      clientX = e.clientX,
	      clientY = e.clientY;
	
	  var text = (0, _getSelectedText2.default)();
	  var width = Math.round((0, _getTextWidth2.default)(text, target) || 0);
	  if (!text || target.classList.contains('md-text-field')) {
	    height = parseInt(window.getComputedStyle(target).fontSize, 10);
	    return {
	      width: width,
	      height: height,
	      left: clientX - width,
	      top: clientY
	    };
	  }
	
	  // All browsers I am supporting have window.getSelection, but better safe than sorry
	  if (window.getSelection) {
	    var selection = window.getSelection();
	    if (selection.rangeCount) {
	      var range = selection.getRangeAt(0).cloneRange();
	      var rect = null;
	      if (range.getClientRects) {
	        var rects = range.getClientRects();
	        if (rects.length > 0) {
	          rect = rects[0];
	        }
	      }
	
	      if (!rect) {
	        var span = document.createElement('span');
	        span.appendChild(document.createTextNode(ZERO_WIDTH_CHARACTER));
	        range.insertNode(span);
	        rect = span.getBoundingClientRect();
	
	        var spanParent = span.parentNode;
	        spanParent.removeChild(span);
	        spanParent.normalize();
	      }
	
	      return rect;
	    }
	  }
	
	  return null;
	}

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isOutOfBounds;
	
	var _getScreenSize = __webpack_require__(127);
	
	var _getScreenSize2 = _interopRequireDefault(_getScreenSize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isOutHorizontally(fixedTo, child, threshold) {
	  var _fixedTo$getBoundingC = fixedTo.getBoundingClientRect(),
	      fixedLeft = _fixedTo$getBoundingC.left,
	      fixedRight = _fixedTo$getBoundingC.right;
	
	  var _child$getBoundingCli = child.getBoundingClientRect(),
	      childLeft = _child$getBoundingCli.left,
	      childRight = _child$getBoundingCli.right;
	
	  var offset = child.offsetWidth * threshold;
	
	  var left = childLeft + offset;
	  var right = childRight - offset;
	
	  var screenEdge = childLeft === 0 || (0, _getScreenSize2.default)('Width') === childRight;
	  return fixedLeft > left || fixedRight < right || screenEdge;
	} /** @module utils/Positioning/isOutOfBounds */
	
	function isOutVertically(fixedTo, child, toggle, threshold) {
	  var _fixedTo$getBoundingC2 = fixedTo.getBoundingClientRect(),
	      fixedTop = _fixedTo$getBoundingC2.top,
	      fixedBottom = _fixedTo$getBoundingC2.bottom;
	
	  var _child$getBoundingCli2 = child.getBoundingClientRect(),
	      childTop = _child$getBoundingCli2.top,
	      childBottom = _child$getBoundingCli2.bottom;
	
	  var offset = toggle.offsetHeight * threshold;
	
	  var screenEdge = childTop === 0 || (0, _getScreenSize2.default)('Height') === childBottom;
	  return fixedTop > childTop + offset || fixedBottom < childTop - offset || screenEdge;
	}
	
	/**
	 * Checks if the fixedTo object for the Layover component is considered
	 * out of bounds relative to the container.
	 *
	 * @param {Object} fixedTo - The Layover's `fixedTo` prop.
	 * @param {Object} child - The Layover's `children` prop as a DOM element.
	 * @param {Object} toggle - The Layover's `toggle` prop as a DOM element.
	 * @param {number} verticalThreshold - The vertical threshold multiplier to apply.
	 * @param {number} horizontalThreshold - The horizontal threshold multiplier to apply.
	 * @return {boolean} true if the Layover's `fixedTo` prop is considered out of bounds.
	 */
	function isOutOfBounds(fixedTo, child, toggle, verticalThreshold, horizontalThreshold) {
	  if (fixedTo === window) {
	    return false;
	  } else if (fixedTo.x || fixedTo.y) {
	    var x = fixedTo.x,
	        y = fixedTo.y;
	
	    return !!y && isOutVertically(y, child, toggle, verticalThreshold) || !!x && isOutHorizontally(x, child, horizontalThreshold);
	  }
	
	  return isOutVertically(fixedTo, child, toggle, verticalThreshold) || isOutHorizontally(fixedTo, child, horizontalThreshold);
	}

/***/ }),
/* 250 */,
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /** @module utils/bem */
	
	
	exports.default = bem;
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A utility function to apply BEM class names to an element.
	 *
	 * ### Examples:
	 * ```js
	 * bem('class') === 'class'
	 * bem('block', 'element') === 'block__element'
	 * bem('block', 'element', 'sub-element') === 'block__element__sub-element'
	 * bem('block', { 'mod-1': true, 'mod-2': false }) === 'block block--mod-1'
	 * bem('block', 'element', { 'mod-1': false, 'mod-2': true }) === 'block__element block__element--mod-2'
	 * bem('block', 'element', {
	 *   'mod-1': false,
	 *   'mod-2': true,
	 * }, 'other', 'class-names') === 'block__element block__element--mod-2 other class-names'
	 * ```
	 *
	 * @param {...String} blocks - 1 to many blocks to use. These names will be joined
	 *    with underscores.
	 * @param {Object=} modifiers - Any conditional modifiers to apply to the blocks. Each
	 *    key in this object will be applied as a `--suffix` to the blocks ONLY when
	 *    their value is true-ish.
	 * @param {...String} others - Any additional class names to apply.
	 * @return {String} the bem-formatted className string.
	 */
	function bem() {
	  var base = [];
	  var modifiers = null;
	  var remaining = -1;
	
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  args.some(function (arg, i) {
	    if (arg) {
	      var type = typeof arg === 'undefined' ? 'undefined' : _typeof(arg);
	      if (type === 'number' || type === 'string') {
	        base.push(arg);
	      } else if (type === 'object') {
	        modifiers = arg;
	        remaining = i + 1;
	      }
	    }
	    return modifiers;
	  });
	
	  var element = base.join('__');
	  if (modifiers) {
	    modifiers = Object.keys(modifiers).reduce(function (obj, key) {
	      obj[element + '--' + key] = modifiers[key];
	      return obj;
	    }, {});
	  }
	  var classes = remaining > -1 ? args.slice(remaining) : null;
	  return (0, _classnames2.default)(element, modifiers, classes).trim();
	}

/***/ }),
/* 252 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = closest;
	/** @module utils/closest */
	
	/**
	 * A _very_ primitive polyfill for the Element.closest function. If this is a browser that doesn't
	 * support it (IE, Edge, etc), it will just keep searching the parent elements until the nodeName
	 * matches the provided type.
	 *
	 * @param {Element} el - the html element to find a closest node type for
	 * @param {String} type - the html element type to find.
	 * @return {Element} the found element or null.
	 */
	function closest(el, type) {
	  if (typeof el.closest === 'function') {
	    return el.closest(type);
	  }
	
	  var nodeType = type.toUpperCase();
	  var node = el.parentElement;
	  while (node && node.parentElement) {
	    if (node.nodeName === nodeType) {
	      return node;
	    }
	
	    node = node.parentElement;
	  }
	
	  return null;
	}

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = addDate;
	
	var _addDay = __webpack_require__(933);
	
	var _addDay2 = _interopRequireDefault(_addDay);
	
	var _addMonth = __webpack_require__(934);
	
	var _addMonth2 = _interopRequireDefault(_addMonth);
	
	var _addYear = __webpack_require__(935);
	
	var _addYear2 = _interopRequireDefault(_addYear);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Adds a given amount to a date.
	 *
	 * @param {Date} date - The date to add
	 * @param {number} amount - The amount to add
	 * @param {string} part - The date part to add to. ['D', 'M', 'Y']
	 * @param {number=1} newMonthDate - An optional date to set in the new month
	 *    if the new month does not have the old date. This only applies to month
	 *    addition.
	 * @return a new Date with the part added or the date if the part is not valid.
	 */
	function addDate(date, amount, part, newMonthDate) {
	  switch (part) {
	    case 'D':
	      return (0, _addDay2.default)(date, amount);
	    case 'M':
	      return (0, _addMonth2.default)(date, amount, newMonthDate);
	    case 'Y':
	      return (0, _addYear2.default)(date, amount);
	    default:
	      return date;
	  }
	}

/***/ }),
/* 254 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getSelectedText;
	/** @module utils/getSelectedText */
	
	/**
	 * A utility function that gets the current selected text in the document. I think
	 * that all the browsers I support have `window.getSelection`, but it falls back to
	 * support others.
	 *
	 * @return {String} the current selection on the page
	 */
	function getSelectedText() {
	  if (typeof window.getSelection !== 'undefined') {
	    return window.getSelection().toString();
	  } else if (typeof document.selection !== 'undefined' && document.selection.type === 'Text') {
	    return document.selection.createRange().text;
	  }
	
	  return '';
	}

/***/ }),
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	/**
	 * A collection of shims that provide minimal functionality of the ES6 collections.
	 *
	 * These implementations are not meant to be used outside of the ResizeObserver
	 * modules as they cover only a limited range of use cases.
	 */
	/* eslint-disable require-jsdoc, valid-jsdoc */
	var MapShim = (function () {
	    if (typeof Map !== 'undefined') {
	        return Map;
	    }
	
	    /**
	     * Returns index in provided array that matches the specified key.
	     *
	     * @param {Array<Array>} arr
	     * @param {*} key
	     * @returns {number}
	     */
	    function getIndex(arr, key) {
	        var result = -1;
	
	        arr.some(function (entry, index) {
	            if (entry[0] === key) {
	                result = index;
	
	                return true;
	            }
	
	            return false;
	        });
	
	        return result;
	    }
	
	    return (function () {
	        function anonymous() {
	            this.__entries__ = [];
	        }
	
	        var prototypeAccessors = { size: { configurable: true } };
	
	        /**
	         * @returns {boolean}
	         */
	        prototypeAccessors.size.get = function () {
	            return this.__entries__.length;
	        };
	
	        /**
	         * @param {*} key
	         * @returns {*}
	         */
	        anonymous.prototype.get = function (key) {
	            var index = getIndex(this.__entries__, key);
	            var entry = this.__entries__[index];
	
	            return entry && entry[1];
	        };
	
	        /**
	         * @param {*} key
	         * @param {*} value
	         * @returns {void}
	         */
	        anonymous.prototype.set = function (key, value) {
	            var index = getIndex(this.__entries__, key);
	
	            if (~index) {
	                this.__entries__[index][1] = value;
	            } else {
	                this.__entries__.push([key, value]);
	            }
	        };
	
	        /**
	         * @param {*} key
	         * @returns {void}
	         */
	        anonymous.prototype.delete = function (key) {
	            var entries = this.__entries__;
	            var index = getIndex(entries, key);
	
	            if (~index) {
	                entries.splice(index, 1);
	            }
	        };
	
	        /**
	         * @param {*} key
	         * @returns {void}
	         */
	        anonymous.prototype.has = function (key) {
	            return !!~getIndex(this.__entries__, key);
	        };
	
	        /**
	         * @returns {void}
	         */
	        anonymous.prototype.clear = function () {
	            this.__entries__.splice(0);
	        };
	
	        /**
	         * @param {Function} callback
	         * @param {*} [ctx=null]
	         * @returns {void}
	         */
	        anonymous.prototype.forEach = function (callback, ctx) {
	            var this$1 = this;
	            if ( ctx === void 0 ) ctx = null;
	
	            for (var i = 0, list = this$1.__entries__; i < list.length; i += 1) {
	                var entry = list[i];
	
	                callback.call(ctx, entry[1], entry[0]);
	            }
	        };
	
	        Object.defineProperties( anonymous.prototype, prototypeAccessors );
	
	        return anonymous;
	    }());
	})();
	
	/**
	 * Detects whether window and document objects are available in current environment.
	 */
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	// Returns global object of a current environment.
	var global$1 = (function () {
	    if (typeof global !== 'undefined' && global.Math === Math) {
	        return global;
	    }
	
	    if (typeof self !== 'undefined' && self.Math === Math) {
	        return self;
	    }
	
	    if (typeof window !== 'undefined' && window.Math === Math) {
	        return window;
	    }
	
	    // eslint-disable-next-line no-new-func
	    return Function('return this')();
	})();
	
	/**
	 * A shim for the requestAnimationFrame which falls back to the setTimeout if
	 * first one is not supported.
	 *
	 * @returns {number} Requests' identifier.
	 */
	var requestAnimationFrame$1 = (function () {
	    if (typeof requestAnimationFrame === 'function') {
	        // It's required to use a bounded function because IE sometimes throws
	        // an "Invalid calling object" error if rAF is invoked without the global
	        // object on the left hand side.
	        return requestAnimationFrame.bind(global$1);
	    }
	
	    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	})();
	
	// Defines minimum timeout before adding a trailing call.
	var trailingTimeout = 2;
	
	/**
	 * Creates a wrapper function which ensures that provided callback will be
	 * invoked only once during the specified delay period.
	 *
	 * @param {Function} callback - Function to be invoked after the delay period.
	 * @param {number} delay - Delay after which to invoke callback.
	 * @returns {Function}
	 */
	var throttle = function (callback, delay) {
	    var leadingCall = false,
	        trailingCall = false,
	        lastCallTime = 0;
	
	    /**
	     * Invokes the original callback function and schedules new invocation if
	     * the "proxy" was called during current request.
	     *
	     * @returns {void}
	     */
	    function resolvePending() {
	        if (leadingCall) {
	            leadingCall = false;
	
	            callback();
	        }
	
	        if (trailingCall) {
	            proxy();
	        }
	    }
	
	    /**
	     * Callback invoked after the specified delay. It will further postpone
	     * invocation of the original function delegating it to the
	     * requestAnimationFrame.
	     *
	     * @returns {void}
	     */
	    function timeoutCallback() {
	        requestAnimationFrame$1(resolvePending);
	    }
	
	    /**
	     * Schedules invocation of the original function.
	     *
	     * @returns {void}
	     */
	    function proxy() {
	        var timeStamp = Date.now();
	
	        if (leadingCall) {
	            // Reject immediately following calls.
	            if (timeStamp - lastCallTime < trailingTimeout) {
	                return;
	            }
	
	            // Schedule new call to be in invoked when the pending one is resolved.
	            // This is important for "transitions" which never actually start
	            // immediately so there is a chance that we might miss one if change
	            // happens amids the pending invocation.
	            trailingCall = true;
	        } else {
	            leadingCall = true;
	            trailingCall = false;
	
	            setTimeout(timeoutCallback, delay);
	        }
	
	        lastCallTime = timeStamp;
	    }
	
	    return proxy;
	};
	
	// Minimum delay before invoking the update of observers.
	var REFRESH_DELAY = 20;
	
	// A list of substrings of CSS properties used to find transition events that
	// might affect dimensions of observed elements.
	var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	
	// Check if MutationObserver is available.
	var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	
	/**
	 * Singleton controller class which handles updates of ResizeObserver instances.
	 */
	var ResizeObserverController = function() {
	    this.connected_ = false;
	    this.mutationEventsAdded_ = false;
	    this.mutationsObserver_ = null;
	    this.observers_ = [];
	
	    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	};
	
	/**
	 * Adds observer to observers list.
	 *
	 * @param {ResizeObserverSPI} observer - Observer to be added.
	 * @returns {void}
	 */
	
	
	/**
	 * Holds reference to the controller's instance.
	 *
	 * @private {ResizeObserverController}
	 */
	
	
	/**
	 * Keeps reference to the instance of MutationObserver.
	 *
	 * @private {MutationObserver}
	 */
	
	/**
	 * Indicates whether DOM listeners have been added.
	 *
	 * @private {boolean}
	 */
	ResizeObserverController.prototype.addObserver = function (observer) {
	    if (!~this.observers_.indexOf(observer)) {
	        this.observers_.push(observer);
	    }
	
	    // Add listeners if they haven't been added yet.
	    if (!this.connected_) {
	        this.connect_();
	    }
	};
	
	/**
	 * Removes observer from observers list.
	 *
	 * @param {ResizeObserverSPI} observer - Observer to be removed.
	 * @returns {void}
	 */
	ResizeObserverController.prototype.removeObserver = function (observer) {
	    var observers = this.observers_;
	    var index = observers.indexOf(observer);
	
	    // Remove observer if it's present in registry.
	    if (~index) {
	        observers.splice(index, 1);
	    }
	
	    // Remove listeners if controller has no connected observers.
	    if (!observers.length && this.connected_) {
	        this.disconnect_();
	    }
	};
	
	/**
	 * Invokes the update of observers. It will continue running updates insofar
	 * it detects changes.
	 *
	 * @returns {void}
	 */
	ResizeObserverController.prototype.refresh = function () {
	    var changesDetected = this.updateObservers_();
	
	    // Continue running updates if changes have been detected as there might
	    // be future ones caused by CSS transitions.
	    if (changesDetected) {
	        this.refresh();
	    }
	};
	
	/**
	 * Updates every observer from observers list and notifies them of queued
	 * entries.
	 *
	 * @private
	 * @returns {boolean} Returns "true" if any observer has detected changes in
	 *  dimensions of it's elements.
	 */
	ResizeObserverController.prototype.updateObservers_ = function () {
	    // Collect observers that have active observations.
	    var activeObservers = this.observers_.filter(function (observer) {
	        return observer.gatherActive(), observer.hasActive();
	    });
	
	    // Deliver notifications in a separate cycle in order to avoid any
	    // collisions between observers, e.g. when multiple instances of
	    // ResizeObserver are tracking the same element and the callback of one
	    // of them changes content dimensions of the observed target. Sometimes
	    // this may result in notifications being blocked for the rest of observers.
	    activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	
	    return activeObservers.length > 0;
	};
	
	/**
	 * Initializes DOM listeners.
	 *
	 * @private
	 * @returns {void}
	 */
	ResizeObserverController.prototype.connect_ = function () {
	    // Do nothing if running in a non-browser environment or if listeners
	    // have been already added.
	    if (!isBrowser || this.connected_) {
	        return;
	    }
	
	    // Subscription to the "Transitionend" event is used as a workaround for
	    // delayed transitions. This way it's possible to capture at least the
	    // final state of an element.
	    document.addEventListener('transitionend', this.onTransitionEnd_);
	
	    window.addEventListener('resize', this.refresh);
	
	    if (mutationObserverSupported) {
	        this.mutationsObserver_ = new MutationObserver(this.refresh);
	
	        this.mutationsObserver_.observe(document, {
	            attributes: true,
	            childList: true,
	            characterData: true,
	            subtree: true
	        });
	    } else {
	        document.addEventListener('DOMSubtreeModified', this.refresh);
	
	        this.mutationEventsAdded_ = true;
	    }
	
	    this.connected_ = true;
	};
	
	/**
	 * Removes DOM listeners.
	 *
	 * @private
	 * @returns {void}
	 */
	ResizeObserverController.prototype.disconnect_ = function () {
	    // Do nothing if running in a non-browser environment or if listeners
	    // have been already removed.
	    if (!isBrowser || !this.connected_) {
	        return;
	    }
	
	    document.removeEventListener('transitionend', this.onTransitionEnd_);
	    window.removeEventListener('resize', this.refresh);
	
	    if (this.mutationsObserver_) {
	        this.mutationsObserver_.disconnect();
	    }
	
	    if (this.mutationEventsAdded_) {
	        document.removeEventListener('DOMSubtreeModified', this.refresh);
	    }
	
	    this.mutationsObserver_ = null;
	    this.mutationEventsAdded_ = false;
	    this.connected_ = false;
	};
	
	/**
	 * "Transitionend" event handler.
	 *
	 * @private
	 * @param {TransitionEvent} event
	 * @returns {void}
	 */
	ResizeObserverController.prototype.onTransitionEnd_ = function (ref) {
	        var propertyName = ref.propertyName; if ( propertyName === void 0 ) propertyName = '';
	
	    // Detect whether transition may affect dimensions of an element.
	    var isReflowProperty = transitionKeys.some(function (key) {
	        return !!~propertyName.indexOf(key);
	    });
	
	    if (isReflowProperty) {
	        this.refresh();
	    }
	};
	
	/**
	 * Returns instance of the ResizeObserverController.
	 *
	 * @returns {ResizeObserverController}
	 */
	ResizeObserverController.getInstance = function () {
	    if (!this.instance_) {
	        this.instance_ = new ResizeObserverController();
	    }
	
	    return this.instance_;
	};
	
	ResizeObserverController.instance_ = null;
	
	/**
	 * Defines non-writable/enumerable properties of the provided target object.
	 *
	 * @param {Object} target - Object for which to define properties.
	 * @param {Object} props - Properties to be defined.
	 * @returns {Object} Target object.
	 */
	var defineConfigurable = (function (target, props) {
	    for (var i = 0, list = Object.keys(props); i < list.length; i += 1) {
	        var key = list[i];
	
	        Object.defineProperty(target, key, {
	            value: props[key],
	            enumerable: false,
	            writable: false,
	            configurable: true
	        });
	    }
	
	    return target;
	});
	
	/**
	 * Returns the global object associated with provided element.
	 *
	 * @param {Object} target
	 * @returns {Object}
	 */
	var getWindowOf = (function (target) {
	    // Assume that the element is an instance of Node, which means that it
	    // has the "ownerDocument" property from which we can retrieve a
	    // corresponding global object.
	    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	
	    // Return the local global object if it's not possible extract one from
	    // provided element.
	    return ownerGlobal || global$1;
	});
	
	// Placeholder of an empty content rectangle.
	var emptyRect = createRectInit(0, 0, 0, 0);
	
	/**
	 * Converts provided string to a number.
	 *
	 * @param {number|string} value
	 * @returns {number}
	 */
	function toFloat(value) {
	    return parseFloat(value) || 0;
	}
	
	/**
	 * Extracts borders size from provided styles.
	 *
	 * @param {CSSStyleDeclaration} styles
	 * @param {...string} positions - Borders positions (top, right, ...)
	 * @returns {number}
	 */
	function getBordersSize(styles) {
	    var positions = [], len = arguments.length - 1;
	    while ( len-- > 0 ) positions[ len ] = arguments[ len + 1 ];
	
	    return positions.reduce(function (size, position) {
	        var value = styles['border-' + position + '-width'];
	
	        return size + toFloat(value);
	    }, 0);
	}
	
	/**
	 * Extracts paddings sizes from provided styles.
	 *
	 * @param {CSSStyleDeclaration} styles
	 * @returns {Object} Paddings box.
	 */
	function getPaddings(styles) {
	    var positions = ['top', 'right', 'bottom', 'left'];
	    var paddings = {};
	
	    for (var i = 0, list = positions; i < list.length; i += 1) {
	        var position = list[i];
	
	        var value = styles['padding-' + position];
	
	        paddings[position] = toFloat(value);
	    }
	
	    return paddings;
	}
	
	/**
	 * Calculates content rectangle of provided SVG element.
	 *
	 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	 *      to be calculated.
	 * @returns {DOMRectInit}
	 */
	function getSVGContentRect(target) {
	    var bbox = target.getBBox();
	
	    return createRectInit(0, 0, bbox.width, bbox.height);
	}
	
	/**
	 * Calculates content rectangle of provided HTMLElement.
	 *
	 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	 * @returns {DOMRectInit}
	 */
	function getHTMLElementContentRect(target) {
	    // Client width & height properties can't be
	    // used exclusively as they provide rounded values.
	    var clientWidth = target.clientWidth;
	    var clientHeight = target.clientHeight;
	
	    // By this condition we can catch all non-replaced inline, hidden and
	    // detached elements. Though elements with width & height properties less
	    // than 0.5 will be discarded as well.
	    //
	    // Without it we would need to implement separate methods for each of
	    // those cases and it's not possible to perform a precise and performance
	    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	    // gives wrong results for elements with width & height less than 0.5.
	    if (!clientWidth && !clientHeight) {
	        return emptyRect;
	    }
	
	    var styles = getWindowOf(target).getComputedStyle(target);
	    var paddings = getPaddings(styles);
	    var horizPad = paddings.left + paddings.right;
	    var vertPad = paddings.top + paddings.bottom;
	
	    // Computed styles of width & height are being used because they are the
	    // only dimensions available to JS that contain non-rounded values. It could
	    // be possible to utilize the getBoundingClientRect if only it's data wasn't
	    // affected by CSS transformations let alone paddings, borders and scroll bars.
	    var width = toFloat(styles.width),
	        height = toFloat(styles.height);
	
	    // Width & height include paddings and borders when the 'border-box' box
	    // model is applied (except for IE).
	    if (styles.boxSizing === 'border-box') {
	        // Following conditions are required to handle Internet Explorer which
	        // doesn't include paddings and borders to computed CSS dimensions.
	        //
	        // We can say that if CSS dimensions + paddings are equal to the "client"
	        // properties then it's either IE, and thus we don't need to subtract
	        // anything, or an element merely doesn't have paddings/borders styles.
	        if (Math.round(width + horizPad) !== clientWidth) {
	            width -= getBordersSize(styles, 'left', 'right') + horizPad;
	        }
	
	        if (Math.round(height + vertPad) !== clientHeight) {
	            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	        }
	    }
	
	    // Following steps can't be applied to the document's root element as its
	    // client[Width/Height] properties represent viewport area of the window.
	    // Besides, it's as well not necessary as the <html> itself neither has
	    // rendered scroll bars nor it can be clipped.
	    if (!isDocumentElement(target)) {
	        // In some browsers (only in Firefox, actually) CSS width & height
	        // include scroll bars size which can be removed at this step as scroll
	        // bars are the only difference between rounded dimensions + paddings
	        // and "client" properties, though that is not always true in Chrome.
	        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	
	        // Chrome has a rather weird rounding of "client" properties.
	        // E.g. for an element with content width of 314.2px it sometimes gives
	        // the client width of 315px and for the width of 314.7px it may give
	        // 314px. And it doesn't happen all the time. So just ignore this delta
	        // as a non-relevant.
	        if (Math.abs(vertScrollbar) !== 1) {
	            width -= vertScrollbar;
	        }
	
	        if (Math.abs(horizScrollbar) !== 1) {
	            height -= horizScrollbar;
	        }
	    }
	
	    return createRectInit(paddings.left, paddings.top, width, height);
	}
	
	/**
	 * Checks whether provided element is an instance of the SVGGraphicsElement.
	 *
	 * @param {Element} target - Element to be checked.
	 * @returns {boolean}
	 */
	var isSVGGraphicsElement = (function () {
	    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	    // interface.
	    if (typeof SVGGraphicsElement !== 'undefined') {
	        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	    }
	
	    // If it's so, then check that element is at least an instance of the
	    // SVGElement and that it has the "getBBox" method.
	    // eslint-disable-next-line no-extra-parens
	    return function (target) { return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function'; };
	})();
	
	/**
	 * Checks whether provided element is a document element (<html>).
	 *
	 * @param {Element} target - Element to be checked.
	 * @returns {boolean}
	 */
	function isDocumentElement(target) {
	    return target === getWindowOf(target).document.documentElement;
	}
	
	/**
	 * Calculates an appropriate content rectangle for provided html or svg element.
	 *
	 * @param {Element} target - Element content rectangle of which needs to be calculated.
	 * @returns {DOMRectInit}
	 */
	function getContentRect(target) {
	    if (!isBrowser) {
	        return emptyRect;
	    }
	
	    if (isSVGGraphicsElement(target)) {
	        return getSVGContentRect(target);
	    }
	
	    return getHTMLElementContentRect(target);
	}
	
	/**
	 * Creates rectangle with an interface of the DOMRectReadOnly.
	 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	 *
	 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	 * @returns {DOMRectReadOnly}
	 */
	function createReadOnlyRect(ref) {
	    var x = ref.x;
	    var y = ref.y;
	    var width = ref.width;
	    var height = ref.height;
	
	    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	    var rect = Object.create(Constr.prototype);
	
	    // Rectangle's properties are not writable and non-enumerable.
	    defineConfigurable(rect, {
	        x: x, y: y, width: width, height: height,
	        top: y,
	        right: x + width,
	        bottom: height + y,
	        left: x
	    });
	
	    return rect;
	}
	
	/**
	 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	 *
	 * @param {number} x - X coordinate.
	 * @param {number} y - Y coordinate.
	 * @param {number} width - Rectangle's width.
	 * @param {number} height - Rectangle's height.
	 * @returns {DOMRectInit}
	 */
	function createRectInit(x, y, width, height) {
	    return { x: x, y: y, width: width, height: height };
	}
	
	/**
	 * Class that is responsible for computations of the content rectangle of
	 * provided DOM element and for keeping track of it's changes.
	 */
	var ResizeObservation = function(target) {
	    this.broadcastWidth = 0;
	    this.broadcastHeight = 0;
	    this.contentRect_ = createRectInit(0, 0, 0, 0);
	
	    this.target = target;
	};
	
	/**
	 * Updates content rectangle and tells whether it's width or height properties
	 * have changed since the last broadcast.
	 *
	 * @returns {boolean}
	 */
	
	
	/**
	 * Reference to the last observed content rectangle.
	 *
	 * @private {DOMRectInit}
	 */
	
	
	/**
	 * Broadcasted width of content rectangle.
	 *
	 * @type {number}
	 */
	ResizeObservation.prototype.isActive = function () {
	    var rect = getContentRect(this.target);
	
	    this.contentRect_ = rect;
	
	    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
	};
	
	/**
	 * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	 * from the corresponding properties of the last observed content rectangle.
	 *
	 * @returns {DOMRectInit} Last observed content rectangle.
	 */
	ResizeObservation.prototype.broadcastRect = function () {
	    var rect = this.contentRect_;
	
	    this.broadcastWidth = rect.width;
	    this.broadcastHeight = rect.height;
	
	    return rect;
	};
	
	var ResizeObserverEntry = function(target, rectInit) {
	    var contentRect = createReadOnlyRect(rectInit);
	
	    // According to the specification following properties are not writable
	    // and are also not enumerable in the native implementation.
	    //
	    // Property accessors are not being used as they'd require to define a
	    // private WeakMap storage which may cause memory leaks in browsers that
	    // don't support this type of collections.
	    defineConfigurable(this, { target: target, contentRect: contentRect });
	};
	
	var ResizeObserverSPI = function(callback, controller, callbackCtx) {
	    this.activeObservations_ = [];
	    this.observations_ = new MapShim();
	
	    if (typeof callback !== 'function') {
	        throw new TypeError('The callback provided as parameter 1 is not a function.');
	    }
	
	    this.callback_ = callback;
	    this.controller_ = controller;
	    this.callbackCtx_ = callbackCtx;
	};
	
	/**
	 * Starts observing provided element.
	 *
	 * @param {Element} target - Element to be observed.
	 * @returns {void}
	 */
	
	
	/**
	 * Registry of the ResizeObservation instances.
	 *
	 * @private {Map<Element, ResizeObservation>}
	 */
	
	
	/**
	 * Public ResizeObserver instance which will be passed to the callback
	 * function and used as a value of it's "this" binding.
	 *
	 * @private {ResizeObserver}
	 */
	
	/**
	 * Collection of resize observations that have detected changes in dimensions
	 * of elements.
	 *
	 * @private {Array<ResizeObservation>}
	 */
	ResizeObserverSPI.prototype.observe = function (target) {
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    // Do nothing if current environment doesn't have the Element interface.
	    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	        return;
	    }
	
	    if (!(target instanceof getWindowOf(target).Element)) {
	        throw new TypeError('parameter 1 is not of type "Element".');
	    }
	
	    var observations = this.observations_;
	
	    // Do nothing if element is already being observed.
	    if (observations.has(target)) {
	        return;
	    }
	
	    observations.set(target, new ResizeObservation(target));
	
	    this.controller_.addObserver(this);
	
	    // Force the update of observations.
	    this.controller_.refresh();
	};
	
	/**
	 * Stops observing provided element.
	 *
	 * @param {Element} target - Element to stop observing.
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.unobserve = function (target) {
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    // Do nothing if current environment doesn't have the Element interface.
	    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	        return;
	    }
	
	    if (!(target instanceof getWindowOf(target).Element)) {
	        throw new TypeError('parameter 1 is not of type "Element".');
	    }
	
	    var observations = this.observations_;
	
	    // Do nothing if element is not being observed.
	    if (!observations.has(target)) {
	        return;
	    }
	
	    observations.delete(target);
	
	    if (!observations.size) {
	        this.controller_.removeObserver(this);
	    }
	};
	
	/**
	 * Stops observing all elements.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.disconnect = function () {
	    this.clearActive();
	    this.observations_.clear();
	    this.controller_.removeObserver(this);
	};
	
	/**
	 * Collects observation instances the associated element of which has changed
	 * it's content rectangle.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.gatherActive = function () {
	        var this$1 = this;
	
	    this.clearActive();
	
	    this.observations_.forEach(function (observation) {
	        if (observation.isActive()) {
	            this$1.activeObservations_.push(observation);
	        }
	    });
	};
	
	/**
	 * Invokes initial callback function with a list of ResizeObserverEntry
	 * instances collected from active resize observations.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.broadcastActive = function () {
	    // Do nothing if observer doesn't have active observations.
	    if (!this.hasActive()) {
	        return;
	    }
	
	    var ctx = this.callbackCtx_;
	
	    // Create ResizeObserverEntry instance for every active observation.
	    var entries = this.activeObservations_.map(function (observation) {
	        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	    });
	
	    this.callback_.call(ctx, entries, ctx);
	    this.clearActive();
	};
	
	/**
	 * Clears the collection of active observations.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.clearActive = function () {
	    this.activeObservations_.splice(0);
	};
	
	/**
	 * Tells whether observer has active observations.
	 *
	 * @returns {boolean}
	 */
	ResizeObserverSPI.prototype.hasActive = function () {
	    return this.activeObservations_.length > 0;
	};
	
	// Registry of internal observers. If WeakMap is not available use current shim
	// for the Map collection as it has all required methods and because WeakMap
	// can't be fully polyfilled anyway.
	var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	
	/**
	 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	 * exposing only those methods and properties that are defined in the spec.
	 */
	var ResizeObserver = function(callback) {
	    if (!(this instanceof ResizeObserver)) {
	        throw new TypeError('Cannot call a class as a function.');
	    }
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    var controller = ResizeObserverController.getInstance();
	    var observer = new ResizeObserverSPI(callback, controller, this);
	
	    observers.set(this, observer);
	};
	
	// Expose public methods of ResizeObserver.
	['observe', 'unobserve', 'disconnect'].forEach(function (method) {
	    ResizeObserver.prototype[method] = function () {
	        return (ref = observers.get(this))[method].apply(ref, arguments);
	        var ref;
	    };
	});
	
	var index = (function () {
	    // Export existing implementation if available.
	    if (typeof global$1.ResizeObserver !== 'undefined') {
	        return global$1.ResizeObserver;
	    }
	
	    return ResizeObserver;
	})();
	
	return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This is just a simple <tfoot> component.
	 */
	var TableFooter = function (_PureComponent) {
	  _inherits(TableFooter, _PureComponent);
	
	  function TableFooter() {
	    _classCallCheck(this, TableFooter);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  TableFooter.prototype.getChildContext = function getChildContext() {
	    return { footer: true };
	  };
	
	  TableFooter.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = _objectWithoutProperties(_props, ['className', 'children']);
	
	    return _react2.default.createElement(
	      'tfoot',
	      _extends({ className: (0, _classnames2.default)('md-table-footer', className) }, props),
	      children
	    );
	  };
	
	  return TableFooter;
	}(_react.PureComponent);
	
	TableFooter.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The children to display. This should really be one or a list of `TableRow`
	   * components.
	   */
	  children: _propTypes2.default.node
	};
	TableFooter.childContextTypes = {
	  footer: _propTypes2.default.bool
	};
	exports.default = TableFooter;

/***/ }),
/* 334 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = findFixedTo;
	function findFixedTo(table) {
	  if (table && table.firstChild.firstChild.classList.contains('md-data-table__scroll-wrapper')) {
	    return {
	      x: table,
	      y: table.firstChild.firstChild
	    };
	  }
	
	  return table;
	}

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _isRequiredForA11y = __webpack_require__(16);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _deprecated = __webpack_require__(5);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _keyCodes = __webpack_require__(14);
	
	var _captureNextEvent = __webpack_require__(125);
	
	var _captureNextEvent2 = _interopRequireDefault(_captureNextEvent);
	
	var _getBtnStyles = __webpack_require__(329);
	
	var _getBtnStyles2 = _interopRequireDefault(_getBtnStyles);
	
	var _FontIcon = __webpack_require__(12);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _IconSeparator = __webpack_require__(83);
	
	var _IconSeparator2 = _interopRequireDefault(_IconSeparator);
	
	var _AccessibleFakeInkedButton = __webpack_require__(24);
	
	var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `FileInput` component is used as simple styling for the `<input type="file" />`.
	 * It will style the input as a raised button by default.
	 */
	var FileInput = function (_PureComponent) {
	  _inherits(FileInput, _PureComponent);
	
	  function FileInput() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FileInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = { hover: false, pressed: false }, _this._handleChange = function (e) {
	      var _this$props = _this.props,
	          multiple = _this$props.multiple,
	          onChange = _this$props.onChange;
	      var files = e.target.files;
	
	      if (onChange) {
	        if (!multiple) {
	          onChange(files[0] || null, e);
	        } else {
	          onChange(Array.prototype.slice.call(files), e);
	        }
	      }
	    }, _this._blur = function () {
	      if (_this.props.disabled) {
	        return;
	      }
	
	      if (_this._timeout) {
	        _this._attemptedBlur = true;
	      } else {
	        _this.setState({ pressed: false });
	      }
	    }, _this._handleMouseUp = function (e) {
	      if (_this.props.onMouseUp) {
	        _this.props.onMouseUp(e);
	      }
	
	      _this._blur();
	    }, _this._handleMouseDown = function (e) {
	      if (_this.props.onMouseDown) {
	        _this.props.onMouseDown(e);
	      }
	
	      if (!_this.props.disabled) {
	        _this.setState({ pressed: true });
	      }
	    }, _this._handleTouchStart = function (e) {
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(e);
	      }
	
	      if (!_this.props.disabled) {
	        _this.setState({ pressed: true });
	      }
	    }, _this._handleTouchEnd = function (e) {
	      if (_this.props.onTouchEnd) {
	        _this.props.onTouchEnd(e);
	      }
	
	      _this._blur();
	      (0, _captureNextEvent2.default)('mouseover');
	    }, _this._handleKeyUp = function (e) {
	      if (_this.props.onKeyUp) {
	        _this.props.onKeyUp(e);
	      }
	
	      if ((e.which || e.keyCode) === _keyCodes.TAB) {
	        window.addEventListener('click', _this._blur);
	        _this.setState({ pressed: true });
	      }
	    }, _this._handleKeyDown = function (e) {
	      if (_this.props.onKeyDown) {
	        _this.props.onKeyDown(e);
	      }
	
	      var key = e.which || e.keyCode;
	
	      if (key === _keyCodes.TAB) {
	        window.removeEventListener('click', _this._blur);
	        _this.setState({ pressed: false });
	      } else if (key === _keyCodes.SPACE || key === _keyCodes.ENTER) {
	        e.preventDefault();
	        e.target.click();
	      }
	    }, _this._handleMouseOver = function (e) {
	      if (_this.props.onMouseOver) {
	        _this.props.onMouseOver(e);
	      }
	
	      if (!_this.props.disabled) {
	        _this.setState({ hover: true });
	      }
	    }, _this._handleMouseLeave = function (e) {
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(e);
	      }
	
	      if (!_this.props.disabled) {
	        _this.setState({ hover: false });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  FileInput.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.disabled && !nextProps.disabled && this.state.hover) {
	      this.setState({ hover: false });
	    }
	  };
	
	  FileInput.prototype.componentWillUpdate = function componentWillUpdate(nextProps, nextState) {
	    var _this2 = this;
	
	    // I honestly don't remember why this was implemented, but it was copied from the Button
	    // component
	    if (!this.state.pressed && nextState.pressed) {
	      this._timeout = setTimeout(function () {
	        _this2._timeout = null;
	        if (_this2._attemptedBlur) {
	          _this2._attemptedBlur = false;
	
	          _this2.setState({ pressed: false });
	        }
	      }, 450);
	    }
	  };
	
	  FileInput.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this._timeout) {
	      clearTimeout(this._timeout);
	    }
	
	    window.removeEventListener('click', this._blur);
	  };
	
	  FileInput.prototype.render = function render() {
	    var _state = this.state,
	        hover = _state.hover,
	        pressed = _state.pressed;
	
	    var _props = this.props,
	        style = _props.style,
	        className = _props.className,
	        labelStyle = _props.labelStyle,
	        labelClassName = _props.labelClassName,
	        label = _props.label,
	        primary = _props.primary,
	        secondary = _props.secondary,
	        flat = _props.flat,
	        id = _props.id,
	        name = _props.name,
	        iconBefore = _props.iconBefore,
	        disabled = _props.disabled,
	        accept = _props.accept,
	        multiple = _props.multiple,
	        swapTheming = _props.swapTheming,
	        allowDuplicates = _props.allowDuplicates,
	        iconChildren = _props.iconChildren,
	        iconClassName = _props.iconClassName,
	        propIcon = _props.icon,
	        onChange = _props.onChange,
	        onKeyUp = _props.onKeyUp,
	        onKeyDown = _props.onKeyDown,
	        onMouseUp = _props.onMouseUp,
	        onMouseDown = _props.onMouseDown,
	        onMouseOver = _props.onMouseOver,
	        onMouseLeave = _props.onMouseLeave,
	        onTouchStart = _props.onTouchStart,
	        onTouchEnd = _props.onTouchEnd,
	        propValue = _props.value,
	        props = _objectWithoutProperties(_props, ['style', 'className', 'labelStyle', 'labelClassName', 'label', 'primary', 'secondary', 'flat', 'id', 'name', 'iconBefore', 'disabled', 'accept', 'multiple', 'swapTheming', 'allowDuplicates', 'iconChildren', 'iconClassName', 'icon', 'onChange', 'onKeyUp', 'onKeyDown', 'onMouseUp', 'onMouseDown', 'onMouseOver', 'onMouseLeave', 'onTouchStart', 'onTouchEnd', 'value']);
	
	    var icon = this.props.icon;
	
	    if (iconClassName || iconChildren) {
	      icon = _react2.default.createElement(
	        _FontIcon2.default,
	        { iconClassName: iconClassName },
	        iconChildren
	      );
	    }
	
	    var labelChildren = label;
	    if (icon) {
	      icon = _react2.default.cloneElement(icon, { inherit: true });
	      labelChildren = _react2.default.createElement(
	        _IconSeparator2.default,
	        { label: label, iconBefore: iconBefore },
	        icon
	      );
	    }
	
	    var value = void 0;
	    if (allowDuplicates) {
	      value = '';
	    }
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, props, {
	        style: style,
	        className: (0, _classnames2.default)('md-inline-block md-file-input-container', className)
	      }),
	      _react2.default.createElement(
	        _AccessibleFakeInkedButton2.default,
	        {
	          component: 'label',
	          htmlFor: id,
	          disabled: disabled,
	          onTouchStart: this._handleTouchStart,
	          onTouchEnd: this._handleTouchEnd,
	          onMouseDown: this._handleMouseDown,
	          onMouseUp: this._handleMouseUp,
	          onKeyDown: this._handleKeyDown,
	          onKeyUp: this._handleKeyUp,
	          onMouseOver: this._handleMouseOver,
	          onMouseLeave: this._handleMouseLeave,
	          style: labelStyle,
	          className: (0, _getBtnStyles2.default)({
	            flat: flat,
	            raised: !flat,
	            disabled: disabled,
	            primary: primary,
	            secondary: secondary,
	            hover: hover,
	            swapTheming: swapTheming,
	            pressed: pressed
	          }, labelClassName)
	        },
	        labelChildren
	      ),
	      _react2.default.createElement('input', {
	        id: id,
	        name: name,
	        accept: accept,
	        type: 'file',
	        multiple: multiple,
	        disabled: disabled,
	        'aria-hidden': 'true',
	        className: 'md-file-input',
	        onChange: this._handleChange,
	        value: value,
	        tabIndex: -1
	      })
	    );
	  };
	
	  return FileInput;
	}(_react.PureComponent);
	
	FileInput.propTypes = {
	  /**
	   * The id for the text field. This is required for a11y and to get the `input type="file"` to
	   * open.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	
	  /**
	   * An optional name to provide to the input.
	   */
	  name: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the label.
	   */
	  labelStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the label.
	   */
	  labelClassName: _propTypes2.default.string,
	
	  /**
	   * Boolean if the `FileInput` should be styled with the primary color.
	   */
	  primary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `FileInput` should be styled with the secondary color.
	   */
	  secondary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `FileInput` should be styled as a flat button instead of a
	   * raised button.
	   */
	  flat: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the theming should be swapped from text to background or vice-versa.
	   *
	   * @see {@link Buttons/Button#swapTheming}
	   */
	  swapTheming: _propTypes2.default.bool,
	
	  /**
	   * This should be a comma separated list of Media Types that the `FileInput` can
	   * accept. If this prop is left blank, any file will be accepted.
	   *
	   * The values can either be:
	   * - A file extension
	   * - audio/*
	   * - video/*
	   * - image/*
	   * - any valid [IANA Media Type](http://www.iana.org/assignments/media-types/media-types.xhtml)
	   *
	   * > NOTE: IE does not enforce this.
	   */
	  accept: _propTypes2.default.string,
	
	  /**
	   * Boolean if the same file is allowed to be uploaded multiple times. This will basically make the
	   * `value` of the file input always blank.
	   */
	  allowDuplicates: _propTypes2.default.bool,
	
	  /**
	   * Boolean if multiple files will be accepted.
	   */
	  multiple: _propTypes2.default.bool,
	
	  /**
	   * A label to display on the `FileInput`. This will be used with the `AccessibleFakeInkedButton` component to
	   * create a `<label>` for the `<input type="file">`.
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * Boolean if the icons should appear before the label.
	   */
	  iconBefore: _propTypes2.default.bool,
	
	  /**
	   * An optional icon to display with the file download. This can be a `FontIcon` or an `SVGIcon`.
	   */
	  icon: _propTypes2.default.element,
	
	  /**
	   * A function to call when the value of the input changes. This will
	   * be triggered when the user selects a new file or cancels the new file selection.
	   *
	   * This function will be given the new [FileList](https://developer.mozilla.org/en-US/docs/Web/API/FileList)
	   * as an array and the change event. If this is not a multiple file input, only the
	   * newly selected File will be given instead of a list of one file. Since this is an
	   * `input` tag, the user will not be able to select the same file multiple times unless
	   * you manually clear the input's value.
	   *
	   * > NOTE: If the user hits cancel, null will be given for a single file input.
	   *
	   * ```js
	   * onChange(files, e);
	   * ```
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * Boolean if the `FileInput` is currently disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional function to call when they keyup event is triggered on the file input's label.
	   */
	  onKeyUp: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when they keydown event is triggered on the file input's label.
	   */
	  onKeyDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when they mouseup event is triggered on the file input's label.
	   */
	  onMouseUp: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when they mousedown event is triggered on the file input's label.
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when they mouseover event is triggered on the file input's label.
	   */
	  onMouseOver: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when they mouseleave event is triggered on the file input's label.
	   */
	  onMouseLeave: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when they touchend event is triggered on the file input's label.
	   */
	  onTouchEnd: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when they touchstart event is triggered on the file input's label.
	   */
	  onTouchStart: _propTypes2.default.func,
	
	  iconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `icon` instead'),
	  iconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `icon` instead'),
	  value: (0, _deprecated2.default)(_propTypes2.default.string, 'There should\'t be a reason to set the value manually. Check out {@link #allowDuplicates} instead')
	};
	FileInput.defaultProps = {
	  label: 'Select a file',
	  icon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'file_upload'
	  ),
	  allowDuplicates: false
	};
	exports.default = FileInput;

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bem2 = __webpack_require__(251);
	
	var _bem3 = _interopRequireDefault(_bem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DIFF_KEYS = ['className', 'align', 'position', 'size', 'offset', 'order', 'phoneSize', 'phoneOrder', 'phoneOffset', 'phoneHidden', 'tabletSize', 'tabletOrder', 'tabletOffset', 'tabletHidden', 'desktopSize', 'desktopOrder', 'desktopOffset', 'desktopHidden'];
	
	var Cell = function (_PureComponent) {
	  _inherits(Cell, _PureComponent);
	
	  /**
	   * A utility function to get the cell's className based on the Cell's props. This is
	   * used behind the scenes to merge and create the className for the cell.
	   *
	   * ### Example:
	   * ```js
	   * <div className={Cell.getClassName()}>A simple cell</div>
	   * <div className={Cell.getClassName({ size: 1 })}>A cell with size 1</div>
	   * ```
	   *
	   * @param {Object=} props - This should be an object of the `Cell`'s props. It
	   *    will extract the needed keys and generate the className.
	   * @return {String} the full className to use for the cell
	   */
	  Cell.getClassName = function getClassName() {
	    var _bem;
	
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var className = props.className,
	        align = props.align,
	        position = props.position,
	        size = props.size,
	        order = props.order,
	        offset = props.offset,
	        phoneSize = props.phoneSize,
	        phoneOrder = props.phoneOrder,
	        phoneOffset = props.phoneOffset,
	        phoneHidden = props.phoneHidden,
	        tabletSize = props.tabletSize,
	        tabletOrder = props.tabletOrder,
	        tabletOffset = props.tabletOffset,
	        tabletHidden = props.tabletHidden,
	        desktopSize = props.desktopSize,
	        desktopOrder = props.desktopOrder,
	        desktopOffset = props.desktopOffset,
	        desktopHidden = props.desktopHidden;
	
	
	    return (0, _bem3.default)('md-cell', (_bem = {}, _bem[align] = align, _bem[position] = position, _bem[size] = size, _bem['order-' + order] = order, _bem[offset + '-offset'] = offset, _bem[phoneSize + '-phone'] = phoneSize, _bem['order-' + phoneOrder + '-phone'] = phoneOrder, _bem[phoneOffset + '-phone-offset'] = phoneOffset, _bem['phone-hidden'] = phoneHidden, _bem[tabletSize + '-tablet'] = tabletSize, _bem['order-' + tabletOrder + '-tablet'] = tabletOrder, _bem[tabletOffset + '-tablet-offset'] = tabletOffset, _bem['tablet-hidden'] = tabletHidden, _bem[desktopSize + '-desktop'] = desktopSize, _bem['order-' + desktopOrder + '-desktop'] = desktopOrder, _bem[desktopOffset + '-desktop-offset'] = desktopOffset, _bem['desktop-hidden'] = desktopHidden, _bem), className);
	  };
	
	  function Cell(props) {
	    _classCallCheck(this, Cell);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this));
	
	    _this.state = { className: Cell.getClassName(props) };
	    return _this;
	  }
	
	  Cell.prototype.componentWillMount = function componentWillMount() {
	    this.setState({ className: Cell.getClassName(this.props) });
	  };
	
	  Cell.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    if (DIFF_KEYS.some(function (key) {
	      return _this2.props[key] !== nextProps[key];
	    })) {
	      this.setState({ className: Cell.getClassName(nextProps) });
	    }
	  };
	
	  Cell.prototype.render = function render() {
	    var className = this.state.className;
	
	    var _props = this.props,
	        style = _props.style,
	        Component = _props.component,
	        children = _props.children,
	        propClassName = _props.className,
	        align = _props.align,
	        position = _props.position,
	        size = _props.size,
	        offset = _props.offset,
	        order = _props.order,
	        phoneSize = _props.phoneSize,
	        phoneOrder = _props.phoneOrder,
	        phoneOffset = _props.phoneOffset,
	        phoneHidden = _props.phoneHidden,
	        tabletSize = _props.tabletSize,
	        tabletOrder = _props.tabletOrder,
	        tabletOffset = _props.tabletOffset,
	        tabletHidden = _props.tabletHidden,
	        desktopSize = _props.desktopSize,
	        desktopOrder = _props.desktopOrder,
	        desktopOffset = _props.desktopOffset,
	        desktopHidden = _props.desktopHidden,
	        props = _objectWithoutProperties(_props, ['style', 'component', 'children', 'className', 'align', 'position', 'size', 'offset', 'order', 'phoneSize', 'phoneOrder', 'phoneOffset', 'phoneHidden', 'tabletSize', 'tabletOrder', 'tabletOffset', 'tabletHidden', 'desktopSize', 'desktopOrder', 'desktopOffset', 'desktopHidden']);
	
	    if (typeof children === 'function') {
	      return children({ style: style, className: className });
	    }
	
	    return _react2.default.createElement(
	      Component,
	      _extends({}, props, { style: style, className: className }),
	      children
	    );
	  };
	
	  return Cell;
	}(_react.PureComponent);
	
	Cell.propTypes = {
	  /**
	   * An optional style to apply to the Cell component. This will only be applied
	   * if the `children` prop is not a callback function.
	   *
	   * @see {@link #children}
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the Cell component. This will only be applied
	   * if the `children` prop is not a callback function.
	   *
	   * @see {@link #children}
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The component to render the Cell as. This should probably not be used as much
	   * as the `children` callback function.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	
	  /**
	   * The children can either be renderable React elements or a callback function
	   * that accepts the style and className props to apply so that the styles can
	   * be manually added to whichever component.
	   */
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	
	  /**
	   * An optional cell alignment to apply. When the `Grid` is not `stacked`,
	   * this will apply to vertical alignment within each "row" of the grid.
	   *
	   * Alignments:
	   * - `top` - This will align to the top of the row
	   * - `middle` - This will align to the middle of the row
	   * - `bottom` - This will align to the bottom of the row
	   * - `stretch` - This will make the cell stretch to fill all the available space
	   *   in the row.
	   *
	   * @see {@link #position}
	   */
	  align: _propTypes2.default.oneOf(['top', 'middle', 'bottom', 'stretch']),
	
	  /**
	   * An optional cell position to apply. When the `Grid` is not `stacked`,
	   * this will apply to horizontal alignment within each "row" of the grid.
	   *
	   * Positions:
	   * - `center` - This will align the cell to be within the center of the row. This really
	   *    just applies `margin-left: auto; margin-right: auto`.
	   * - `right` - This will align the cell to the end of the row. This really just applies `margin-left: auto`.
	   *
	   * @see {@link #align}
	   */
	  position: _propTypes2.default.oneOf(['center', 'right']),
	
	  /**
	   * An optional size to apply to the cell. This sizing will be applied across all media sizes.
	   * If the size is greater than the number of columns allowed for the media size, it will just
	   * span the entire width.
	   */
	  size: _propTypes2.default.number,
	
	  /**
	   * An optional order to apply to the cell. This order will be applied across all media sizes.
	   */
	  order: _propTypes2.default.number,
	
	  /**
	   * An optional offset to apply to the cell. This will add spacing to the left of the cell.
	   */
	  offset: _propTypes2.default.number,
	
	  /**
	   * An optional size to apply to the cell only on phones.
	   */
	  phoneSize: _propTypes2.default.number,
	
	  /**
	   * An optional order to apply to the cell only on phones.
	   */
	  phoneOrder: _propTypes2.default.number,
	
	  /**
	   * An optional offset to apply to the cell only on phones.
	   */
	  phoneOffset: _propTypes2.default.number,
	
	  /**
	   * Boolean if the cell should be hidden on phones only.
	   */
	  phoneHidden: _propTypes2.default.bool,
	
	  /**
	   * An optional size to apply to the cell only on tablets.
	   */
	  tabletSize: _propTypes2.default.number,
	
	  /**
	   * An optional order to apply to the cell only on tablets.
	   */
	  tabletOrder: _propTypes2.default.number,
	
	  /**
	   * An optional offset to apply to the cell only on tablets.
	   */
	  tabletOffset: _propTypes2.default.number,
	
	  /**
	   * Boolean if the cell should be hidden on tablets only.
	   */
	  tabletHidden: _propTypes2.default.bool,
	
	  /**
	   * An optional size to apply to the cell only on desktops.
	   */
	  desktopSize: _propTypes2.default.number,
	
	  /**
	   * An optional order to apply to the cell only on desktops.
	   */
	  desktopOrder: _propTypes2.default.number,
	
	  /**
	   * An optional offset to apply to the cell only on desktops.
	   */
	  desktopOffset: _propTypes2.default.number,
	
	  /**
	   * Boolean if the cell should be hidden on desktops only.
	   */
	  desktopHidden: _propTypes2.default.bool
	};
	Cell.defaultProps = {
	  component: 'div',
	  phoneHidden: false,
	  tabletHidden: false,
	  desktopHidden: false
	};
	exports.default = Cell;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bem2 = __webpack_require__(251);
	
	var _bem3 = _interopRequireDefault(_bem2);
	
	var _isValued = __webpack_require__(176);
	
	var _isValued2 = _interopRequireDefault(_isValued);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DIFF_KEYS = ['className', 'stacked', 'container', 'noSpacing', 'gutter', 'spacing'];
	
	var Grid = function (_PureComponent) {
	  _inherits(Grid, _PureComponent);
	
	  /**
	   * A utility function to get the grid's className based on the Grid's props. This is
	   * used behind the scenes to merge and create the className for the grid.
	   *
	   * ### Example:
	   * ```js
	   * <div className={Grid.getClassName()}>A base grid</div>
	   * <div className={Grid.getClassName({ stacked: true })}>A stacked Grid</div>
	   * ```
	   *
	   * @param {Object=} props - This should be an object of the `Grid`'s props. It
	   *    will extract the needed keys and generate the className.
	   * @return {String} the full className to use for the grid
	   */
	  Grid.getClassName = function getClassName() {
	    var _bem;
	
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var className = props.className,
	        stacked = props.stacked,
	        noSpacing = props.noSpacing,
	        gutter = props.gutter,
	        spacing = props.spacing,
	        container = props.container;
	
	    return (0, _bem3.default)('md-grid', (_bem = {
	      'stacked': stacked,
	      'no-spacing': noSpacing
	    }, _bem[gutter + '-' + spacing] = (0, _isValued2.default)(gutter) && (0, _isValued2.default)(spacing), _bem[container] = container, _bem), className);
	  };
	
	  function Grid(props) {
	    _classCallCheck(this, Grid);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this));
	
	    _this.state = { className: Grid.getClassName(props) };
	    return _this;
	  }
	
	  Grid.prototype.componentWillMount = function componentWillMount() {
	    this.setState({ className: Grid.getClassName(this.props) });
	  };
	
	  Grid.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    if (DIFF_KEYS.some(function (key) {
	      return _this2.props[key] !== nextProps[key];
	    })) {
	      this.setState({ className: Grid.getClassName(nextProps) });
	    }
	  };
	
	  Grid.prototype.render = function render() {
	    var className = this.state.className;
	
	    var _props = this.props,
	        style = _props.style,
	        Component = _props.component,
	        children = _props.children,
	        propClassName = _props.className,
	        container = _props.container,
	        stacked = _props.stacked,
	        noSpacing = _props.noSpacing,
	        gutter = _props.gutter,
	        spacing = _props.spacing,
	        props = _objectWithoutProperties(_props, ['style', 'component', 'children', 'className', 'container', 'stacked', 'noSpacing', 'gutter', 'spacing']);
	
	    if (typeof children === 'function') {
	      return children({ style: style, className: className });
	    }
	
	    return _react2.default.createElement(
	      Component,
	      _extends({}, props, { style: style, className: className }),
	      children
	    );
	  };
	
	  return Grid;
	}(_react.PureComponent);
	
	Grid.propTypes = {
	  /**
	   * An optional style to apply to the Grid component. This will only be applied
	   * if the `children` prop is not a callback function.
	   *
	   * @see {@link #children}
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the Grid component. This will only be applied
	   * if the `children` prop is not a callback function.
	   *
	   * @see {@link #children}
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The component to render the Grid as. This should probably not be used as much
	   * as the `children` callback function.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	
	  /**
	   * The children can either be renderable React elements or a callback function
	   * that accepts the style and className props to apply so that the styles can
	   * be manually added to whichever component.
	   */
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	
	  /**
	   * An optional container name to apply to the Grid. This should be the same name as provided
	   * to the [react-md-make-grid-container](/components/grids?tab=2#mixin-react-md-make-grid-container) mixin.
	   */
	  container: _propTypes2.default.string,
	
	  /**
	   * Boolean if the grid should be placed vertically instead of horizontally.
	   */
	  stacked: _propTypes2.default.bool,
	
	  /**
	   * Boolean if all the gutters and spacing should be removed from the grid.
	   */
	  noSpacing: _propTypes2.default.bool,
	
	  /**
	   * When the [react-md-make-custom-grid](/components/grids?tab=2#mixin-react-md-make-custom-grid) mixin
	   * is used, you can use the `gutter` and `spacing` props on the `Grid` to apply the correct className
	   */
	  gutter: _propTypes2.default.number,
	
	  /**
	   * When the [react-md-make-custom-grid](/components/grids?tab=2#mixin-react-md-make-custom-grid) mixin
	   * is used, you can use the `gutter` and `spacing` props on the `Grid` to apply the correct className
	   */
	  spacing: _propTypes2.default.number
	};
	Grid.defaultProps = {
	  component: 'div',
	  stacked: false,
	  noSpacing: false
	};
	exports.default = Grid;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(7);
	
	var _isValidFocusKeypress = __webpack_require__(921);
	
	var _isValidFocusKeypress2 = _interopRequireDefault(_isValidFocusKeypress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BASE_FOCUSABLE_ELEMENTS = '[href],[tabindex]:not([tabindex="-1"]),input:not([disabled]):not([type="hidden"])';
	var FOCUSABLE_QUERY = ['button', 'textarea', 'select'].reduce(function (queryString, element) {
	  return queryString + ',' + element + ':not([disabled])';
	}, BASE_FOCUSABLE_ELEMENTS);
	
	/**
	 * This component is used for keeping the focus within some container. When the container
	 * is mounted and the `focusOnMount` prop is `true`, it will attempt to focus either:
	 * - an element that matches `document.getElementById(this.props.initialFocus)`
	 * - an element that matches `this._container.querySelector(this.props.initialFocus)`
	 * - the first focusable element in it's children (if `this.props.initialFocus` is omitted)
	 */
	
	var FocusContainer = function (_PureComponent) {
	  _inherits(FocusContainer, _PureComponent);
	
	  function FocusContainer() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FocusContainer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this._enableFocusTrap = function () {
	      window.addEventListener('keydown', _this._handleKeyDown, true);
	    }, _this._disableFocusTrap = function () {
	      window.removeEventListener('keydown', _this._handleKeyDown, true);
	    }, _this._attemptInitialFocus = function () {
	      if (!_this._container) {
	        return;
	      }
	
	      var initialFocus = _this.props.initialFocus;
	
	
	      var toFocus = initialFocus ? document.getElementById(initialFocus) || _this._container.querySelector(initialFocus) : _this._focusables[0];
	
	      var debugError = void 0;
	      if (!toFocus && initialFocus) {
	        debugError = ' The `initialFocus` did not match a document\'s `id` or was an invalid ';
	        debugError += '`querySelector` for the container. `initialFocus`: `' + initialFocus + '`. ';
	        debugError += 'If this was supposed to be an `id`, make sure to prefix with the `#` symbol.';
	      }
	
	      if (false) {
	        throw new Error('You specified that the `FocusContainer` should focus an element on mount, ' + 'but a focusable element was not found in the children. This could be because ' + 'the `initialFocus` prop is an invalid id or query selector, or the children ' + ('do not contain a valid focusable element.' + debugError));
	      }
	
	      if (toFocus) {
	        toFocus.focus();
	      }
	    }, _this._containFocus = function (containerRef) {
	      if (containerRef === null) {
	        _this._container = null;
	        _this._disableFocusTrap();
	        return;
	      }
	
	      var _this$props = _this.props,
	          focusOnMount = _this$props.focusOnMount,
	          containFocus = _this$props.containFocus;
	
	      _this._container = (0, _reactDom.findDOMNode)(containerRef);
	      _this._focusables = [].slice.call(_this._container.querySelectorAll(FOCUSABLE_QUERY));
	
	      if (focusOnMount) {
	        _this._attemptInitialFocus();
	      }
	
	      if (containFocus) {
	        _this._enableFocusTrap();
	      }
	    }, _this._handleKeyDown = function (e) {
	      _this._shifted = e.shiftKey;
	      if (!(0, _isValidFocusKeypress2.default)(e, _this.props.additionalFocusKeys)) {
	        return;
	      } else if (_this._focusables.length === 1) {
	        e.preventDefault();
	        return;
	      }
	
	      var target = e.target,
	          shiftKey = e.shiftKey;
	
	      var _this$_focusables = _this._focusables,
	          first = _this$_focusables[0],
	          focusables = _this$_focusables.slice(1);
	
	      var last = focusables[focusables.length - 1];
	
	      if (shiftKey && target === first) {
	        e.preventDefault();
	        last.focus();
	      } else if (!shiftKey && target === last) {
	        e.preventDefault();
	        first.focus();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  FocusContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.containFocus === nextProps.containFocus) {
	      return;
	    }
	
	    if (nextProps.containFocus) {
	      this._enableFocusTrap();
	      this._attemptInitialFocus();
	    } else {
	      this._disableFocusTrap();
	    }
	  };
	
	  FocusContainer.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (this.props.containFocus && this._container) {
	      this._focusables = [].slice.call(this._container.querySelectorAll(FOCUSABLE_QUERY));
	    }
	  };
	
	  FocusContainer.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.props.containFocus) {
	      this._disableFocusTrap();
	    }
	  };
	
	  /**
	   * Manages the event listeners to contain the focus within some container.  When the container
	   * ref is not null, the container has mounted and then attempts to focus an element inside
	   * if the `focusOnMount` prop is `true`.
	   */
	
	
	  FocusContainer.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.component,
	        initialFocus = _props.initialFocus,
	        focusOnMount = _props.focusOnMount,
	        containFocus = _props.containFocus,
	        additionalFocusKeys = _props.additionalFocusKeys,
	        props = _objectWithoutProperties(_props, ['component', 'initialFocus', 'focusOnMount', 'containFocus', 'additionalFocusKeys']);
	
	    return _react2.default.createElement(Component, _extends({}, props, { ref: this._containFocus }));
	  };
	
	  return FocusContainer;
	}(_react.PureComponent);
	
	FocusContainer.propTypes = {
	  /**
	   * The component to render as. This can be a React DOM element or
	   * a react Component.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The children to display.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * An optional id string or a query selector string to use for the initial focus.
	   * This will only be triggered if the `focusOnMount` prop is `true`. If this is
	   * omitted and the `focusOnMount` prop is `true`, the first focusable element in the
	   * container will be focused.
	   *
	   * Examples:
	   *
	   * ```js
	   * initialFocus="#someAmazingId"
	   * // or
	   * initialFocus=".md-btn,.md-list-tile"
	   * ```
	   */
	  initialFocus: _propTypes2.default.string,
	
	  /**
	   * Boolean if an element in the container should be focused when mounted.
	   */
	  focusOnMount: _propTypes2.default.bool,
	
	  /**
	   * An optional list of additional key codes to use for focus events.
	   */
	  additionalFocusKeys: _propTypes2.default.arrayOf(_propTypes2.default.number),
	
	  /**
	   * Boolean if the focus container should start or stop containing the focus within the container.
	   * This is useful for changing the focus requirements after mount.
	   */
	  containFocus: _propTypes2.default.bool
	};
	FocusContainer.defaultProps = {
	  component: 'div',
	  containFocus: true
	};
	exports.default = FocusContainer;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _deprecated = __webpack_require__(5);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _controlled = __webpack_require__(15);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _anchorShape = __webpack_require__(28);
	
	var _anchorShape2 = _interopRequireDefault(_anchorShape);
	
	var _fixedToShape = __webpack_require__(19);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _positionShape = __webpack_require__(36);
	
	var _positionShape2 = _interopRequireDefault(_positionShape);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _DropdownMenu = __webpack_require__(237);
	
	var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `MenuButton` is a simple wrapper / combination of the `Button` and the `Menu`
	 * components that can be uncontrolled.
	 */
	var MenuButton = function (_PureComponent) {
	  _inherits(MenuButton, _PureComponent);
	
	  function MenuButton() {
	    _classCallCheck(this, MenuButton);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  MenuButton.prototype.render = function render() {
	    var _props = this.props,
	        id = _props.id,
	        listId = _props.listId,
	        buttonId = _props.buttonId,
	        menuStyle = _props.menuStyle,
	        menuClassName = _props.menuClassName,
	        listStyle = _props.listStyle,
	        listClassName = _props.listClassName,
	        listProps = _props.listProps,
	        listZDepth = _props.listZDepth,
	        listInline = _props.listInline,
	        listHeightRestricted = _props.listHeightRestricted,
	        menuItems = _props.menuItems,
	        buttonChildren = _props.buttonChildren,
	        children = _props.children,
	        anchor = _props.anchor,
	        belowAnchor = _props.belowAnchor,
	        fixedTo = _props.fixedTo,
	        position = _props.position,
	        cascading = _props.cascading,
	        cascadingAnchor = _props.cascadingAnchor,
	        cascadingZDepth = _props.cascadingZDepth,
	        fullWidth = _props.fullWidth,
	        block = _props.block,
	        centered = _props.centered,
	        sameWidth = _props.sameWidth,
	        repositionOnScroll = _props.repositionOnScroll,
	        repositionOnResize = _props.repositionOnResize,
	        xThreshold = _props.xThreshold,
	        yThreshold = _props.yThreshold,
	        closeOnOutsideClick = _props.closeOnOutsideClick,
	        transitionName = _props.transitionName,
	        transitionEnterTimeout = _props.transitionEnterTimeout,
	        transitionLeaveTimeout = _props.transitionLeaveTimeout,
	        visible = _props.visible,
	        defaultVisible = _props.defaultVisible,
	        onVisibilityChange = _props.onVisibilityChange,
	        simplifiedMenu = _props.simplifiedMenu,
	        minLeft = _props.minLeft,
	        minRight = _props.minRight,
	        minBottom = _props.minBottom,
	        fillViewportWidth = _props.fillViewportWidth,
	        fillViewportHeight = _props.fillViewportHeight,
	        onMenuClick = _props.onMenuClick,
	        onMenuMouseDown = _props.onMenuMouseDown,
	        onMenuMouseUp = _props.onMenuMouseUp,
	        onMenuMouseEnter = _props.onMenuMouseEnter,
	        onMenuMouseMove = _props.onMenuMouseMove,
	        onMenuMouseLeave = _props.onMenuMouseLeave,
	        onMenuTouchStart = _props.onMenuTouchStart,
	        onMenuTouchMove = _props.onMenuTouchMove,
	        onMenuTouchCancel = _props.onMenuTouchCancel,
	        onMenuTouchEnd = _props.onMenuTouchEnd,
	        onMenuFocus = _props.onMenuFocus,
	        onMenuBlur = _props.onMenuBlur,
	        onMenuKeyDown = _props.onMenuKeyDown,
	        onMenuKeyUp = _props.onMenuKeyUp,
	        isOpen = _props.isOpen,
	        defaultOpen = _props.defaultOpen,
	        onMenuToggle = _props.onMenuToggle,
	        props = _objectWithoutProperties(_props, ['id', 'listId', 'buttonId', 'menuStyle', 'menuClassName', 'listStyle', 'listClassName', 'listProps', 'listZDepth', 'listInline', 'listHeightRestricted', 'menuItems', 'buttonChildren', 'children', 'anchor', 'belowAnchor', 'fixedTo', 'position', 'cascading', 'cascadingAnchor', 'cascadingZDepth', 'fullWidth', 'block', 'centered', 'sameWidth', 'repositionOnScroll', 'repositionOnResize', 'xThreshold', 'yThreshold', 'closeOnOutsideClick', 'transitionName', 'transitionEnterTimeout', 'transitionLeaveTimeout', 'visible', 'defaultVisible', 'onVisibilityChange', 'simplifiedMenu', 'minLeft', 'minRight', 'minBottom', 'fillViewportWidth', 'fillViewportHeight', 'onMenuClick', 'onMenuMouseDown', 'onMenuMouseUp', 'onMenuMouseEnter', 'onMenuMouseMove', 'onMenuMouseLeave', 'onMenuTouchStart', 'onMenuTouchMove', 'onMenuTouchCancel', 'onMenuTouchEnd', 'onMenuFocus', 'onMenuBlur', 'onMenuKeyDown', 'onMenuKeyUp', 'isOpen', 'defaultOpen', 'onMenuToggle']);
	
	    var items = children;
	    var toggleChildren = buttonChildren;
	    if (typeof menuItems !== 'undefined') {
	      toggleChildren = children;
	      items = menuItems;
	    }
	
	    return _react2.default.createElement(
	      _DropdownMenu2.default,
	      {
	        id: id,
	        listId: listId,
	        style: menuStyle,
	        className: menuClassName,
	        listStyle: listStyle,
	        listClassName: listClassName,
	        listProps: listProps,
	        listInline: listInline,
	        listZDepth: listZDepth,
	        listHeightRestricted: listHeightRestricted,
	        visible: typeof isOpen !== 'undefined' ? isOpen : visible,
	        defaultVisible: typeof defaultOpen !== 'undefined' ? defaultOpen : defaultVisible,
	        menuItems: items,
	        simplifiedMenu: simplifiedMenu,
	        anchor: anchor,
	        belowAnchor: belowAnchor,
	        fixedTo: fixedTo,
	        position: position,
	        cascading: cascading,
	        cascadingAnchor: cascadingAnchor,
	        cascadingZDepth: cascadingZDepth,
	        fullWidth: fullWidth,
	        block: block,
	        centered: centered,
	        sameWidth: sameWidth,
	        minLeft: minLeft,
	        minRight: minRight,
	        minBottom: minBottom,
	        fillViewportWidth: fillViewportWidth,
	        fillViewportHeight: fillViewportHeight,
	        repositionOnScroll: repositionOnScroll,
	        repositionOnResize: repositionOnResize,
	        xThreshold: xThreshold,
	        yThreshold: yThreshold,
	        closeOnOutsideClick: closeOnOutsideClick,
	        transitionName: transitionName,
	        transitionEnterTimeout: transitionEnterTimeout,
	        transitionLeaveTimeout: transitionLeaveTimeout,
	        onVisibilityChange: onMenuToggle || onVisibilityChange,
	        onClick: onMenuClick,
	        onMouseDown: onMenuMouseDown,
	        onMouseUp: onMenuMouseUp,
	        onMouseEnter: onMenuMouseEnter,
	        onMouseMove: onMenuMouseMove,
	        onMouseLeave: onMenuMouseLeave,
	        onTouchStart: onMenuTouchStart,
	        onTouchMove: onMenuTouchMove,
	        onTouchCancel: onMenuTouchCancel,
	        onTouchEnd: onMenuTouchEnd,
	        onFocus: onMenuFocus,
	        onBlur: onMenuBlur,
	        onKeyDown: onMenuKeyDown,
	        onKeyUp: onMenuKeyUp
	      },
	      _react2.default.createElement(
	        _Button2.default,
	        _extends({}, props, { id: buttonId }),
	        toggleChildren
	      )
	    );
	  };
	
	  return MenuButton;
	}(_react.PureComponent);
	
	MenuButton.Positions = _DropdownMenu2.default.Positions;
	MenuButton.HorizontalAnchors = _DropdownMenu2.default.HorizontalAnchors;
	MenuButton.VerticalAnchors = _DropdownMenu2.default.VerticalAnchors;
	MenuButton.propTypes = {
	  /**
	   * An id to use for the menu button. This is required for accessibility.
	   *
	   * @see {@link Menus/Menu#id}
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to provide to the menu's list.
	   *
	   * @see {@link Menus/Menu#listId}
	   */
	  listId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to provide to the button. If this is omitted, the button will automatically
	   * gain an id of `${id}-toggle`.
	   */
	  buttonId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply to the button.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the button.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the surrounding menu.
	   */
	  menuStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the surrounding menu.
	   */
	  menuClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the list.
	   */
	  listStyle: _propTypes2.default.object,
	
	  /**
	   * An optional class name to apply to the list.
	   */
	  listClassName: _propTypes2.default.string,
	
	  /**
	   * Any additional props to provide to the list.
	   *
	   * @see {@link Menus/Menu#listProps}
	   */
	  listProps: _propTypes2.default.object,
	
	  /**
	   * The z-depth to use for the list.
	   *
	   * @see {@link Menus/Menu/listZDepth}
	   */
	  listZDepth: _propTypes2.default.number,
	
	  /**
	   * Boolean if the list should be displayed inline.
	   *
	   * @see {@link Lists/List#inline}
	   */
	  listInline: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the list's height should be restricted.
	   *
	   * @see {@link Menus/Menu#listHeightRestricted}
	   */
	  listHeightRestricted: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu's list is currently visible. If this is defined, it will
	   * require the `onVisibilityChange` function to be defined since it will become
	   * a controlled component.
	   */
	  visible: (0, _controlled2.default)(_propTypes2.default.bool, 'onVisibilityChange', 'defaultVisible'),
	
	  /**
	   * Boolean if the menu's list should be visible by default.
	   */
	  defaultVisible: _propTypes2.default.bool.isRequired,
	
	  /**
	   * An optional function to call when the button is clicked.
	   *
	   * @see {@link #onMenuClick}
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mousedown` event is triggered by the button.
	   *
	   * @see {@link #onMenuMouseDown}
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mouseup` event is triggered by the button.
	   *
	   * @see {@link #onMenuMouseUp}
	   */
	  onMouseUp: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mouseenter` event is triggered by the button.
	   *
	   * @see {@link #onMenuMouseEnter}
	   */
	  onMouseEnter: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mousemove` event is triggered by the button.
	   *
	   * @see {@link #onMenuMouseMove}
	   */
	  onMouseMove: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mouseleave` event is triggered by the button.
	   *
	   * @see {@link #onMenuMouseLeave}
	   */
	  onMouseLeave: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `touchstart` event is triggered by the button.
	   *
	   * @see {@link #onMenuTouchStart}
	   */
	  onTouchStart: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `touchmove` event is triggered by the button.
	   *
	   * @see {@link #onMenuTouchMove}
	   */
	  onTouchMove: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `touchend` event is triggered by the button.
	   *
	   * @see {@link #onMenuTouchEnd}
	   */
	  onTouchEnd: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `touchcancel` event is triggered by the button.
	   *
	   * @see {@link #onMenuTouchCancel}
	   */
	  onTouchCancel: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `focus` event is triggered by the button.
	   *
	   * @see {@link #onMenuFocus}
	   */
	  onFocus: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `blur` event is triggered by the button.
	   *
	   * @see {@link #onMenuBlur}
	   */
	  onBlur: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `keydown` event is triggered by the button.
	   *
	   * @see {@link #onMenuKeyDown}
	   */
	  onKeyDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `keyup` event is triggered by the button.
	   *
	   * @see {@link #onMenuKeyUp}
	   */
	  onKeyUp: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the entire `MenuButton` is clicked. This can be triggered
	   * by clicking the button or any list item that appears in the menu list.
	   *
	   * @see {@link #onClick}
	   */
	  onMenuClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `mousedown` event.
	   *
	   * @see {@link #onMouseDown}
	   */
	  onMenuMouseDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `mouseup` event.
	   *
	   * @see {@link #onMouseUp}
	   */
	  onMenuMouseUp: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `mouseenter` event.
	   *
	   * @see {@link #onMouseEnter}
	   */
	  onMenuMouseEnter: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `mousemove` event.
	   *
	   * @see {@link #onMouseMove}
	   */
	  onMenuMouseMove: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `mouseleave` event.
	   *
	   * @see {@link #onMouseLeave}
	   */
	  onMenuMouseLeave: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `touchstart` event.
	   *
	   * @see {@link @onTouchStart}
	   */
	  onMenuTouchStart: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `touchmove` event.
	   *
	   * @see {@link @onTouchMove}
	   */
	  onMenuTouchMove: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `touchend` event.
	   *
	   * @see {@link @onTouchEnd}
	   */
	  onMenuTouchEnd: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `touchcancel` event.
	   *
	   * @see {@link @onTouchCancel}
	   */
	  onMenuTouchCancel: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `focus` event.
	   *
	   * @see {@link #onFocus}
	   */
	  onMenuFocus: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `blur` event.
	   *
	   * @see {@link #onBlur}
	   */
	  onMenuBlur: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `keydown` event.
	   *
	   * @see {@link #onKeyDown}
	   */
	  onMenuKeyDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when any element in the `MenuButton` triggers the `keyup` event.
	   *
	   * @see {@link #onKeyUp}
	   */
	  onMenuKeyUp: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the visibility changes for the menu. The callback will
	   * include the next visibility state and the event that triggered the change.
	   *
	   * ```js
	   * onVisibilityChange(visible, event);
	   * ```
	   */
	  onVisibilityChange: _propTypes2.default.func,
	
	  /**
	   * This is a 0 to many relationship of `ListItem` to display in the menu's `List`. If the type
	   * of the item is a number or string, it will be passed to the `ListItem` as the `primaryText`.
	   * If it is an object, it should be the shape of the `ListItem` props. If it is a node, it will
	   * just be rendered in the `List`.
	   *
	   * @see {@link Lists/ListItem}
	   * @see {@link Menus/Menu#children}
	   */
	  menuItems: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.node, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.object, _propTypes2.default.node]))]),
	
	  /**
	   * This should be the children to use in the `Button` that gets created as the menu's toggle.
	   *
	   * @see {@link Buttons/Button}
	   * @see {@link Menus/Menu#toggle}
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * The anchor position of the menu's list.
	   *
	   * @see {@link Helpers/Layover#anchor}
	   */
	  anchor: _anchorShape2.default,
	
	  /**
	   * This is the anchor to use when the `position` is set to `Autocomplete.Positions.BELOW`.
	   *
	   * @see {@link Helpers/Layover#belowAnchor}
	   */
	  belowAnchor: _anchorShape2.default,
	
	  /**
	   * This is how the menu's list is fixed to the toggle.
	   *
	   * @see {@link Menus/Menu#fixedTo}
	   */
	  fixedTo: _fixedToShape2.default,
	
	  /**
	   * This is the animation position for the menu's list.
	   *
	   * @see {@link Menus/Menu#position}
	   */
	  position: _positionShape2.default,
	
	  /**
	   * Boolean if the menu's list should gain the cascading styles.
	   *
	   * @see {@link Menus/Menu#cascading}
	   */
	  cascading: _propTypes2.default.bool,
	
	  /**
	   * The zDepth to use for the lists that appear in cascading menus.
	   *
	   * @see {@link Menus/Menu#cascadingZDepth}
	   */
	  cascadingZDepth: _propTypes2.default.number,
	
	  /**
	   * The anchor position for the cascading lists.
	   *
	   * @see {@link Menus/Menu#cascadingAnchor}
	   */
	  cascadingAnchor: _anchorShape2.default,
	
	  /**
	   * Boolean if the menu should display as a full width container. This will *not* update the button
	   * to be full width as well.
	   *
	   * @see {@link Menus/Menu#fullWidth}
	   */
	  fullWidth: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu's container should display as `block` instead of `inline-block`.
	   *
	   * @see {@link Menus/Menu#block}
	   */
	  block: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the list should appear centered related to the button.
	   *
	   * @see {@link Menus/Menu#centered}
	   */
	  centered: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu's list should be the same width as the button.
	   *
	   * @see {@link Menus/Menu#sameWidth}
	   */
	  sameWidth: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Menus/Menu#xThreshold}
	   */
	  xThreshold: _propTypes2.default.number,
	
	  /**
	   * @see {@link Menus/Menu#yThreshold}
	   */
	  yThreshold: _propTypes2.default.number,
	
	  /**
	   * Boolean if the menu's list should be closed when an element outside of the menu has been clicked.
	   *
	   * @see {@link Menus/Menu#closeOnOutsideClick}
	   */
	  closeOnOutsideClick: _propTypes2.default.bool,
	
	  /**
	   * The transition name to use for the menu's list visibility changes.
	   *
	   * @see {@link Menus/Menu#transitionName}
	   */
	  transitionName: _propTypes2.default.string,
	
	  /**
	   * The transition name to use when the menu's list gains visibility.
	   *
	   * @see {@link Menus/Menu#transitionEnterTimeout}
	   */
	  transitionEnterTimeout: _propTypes2.default.number,
	
	  /**
	   * The transition timeout to use when the menu's list loses visibility.
	   *
	   * @see {@link Menus/Menu#transitionLeaveTimeout}
	   */
	  transitionLeaveTimeout: _propTypes2.default.number,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the `fixedTo` element scrolls.
	   *
	   * @see {@link Helpers/Layover#repositionOnScroll}
	   */
	  repositionOnScroll: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the window resizes.
	   *
	   * @see {@link Helpers/Layover#repositionOnResize}
	   */
	  repositionOnResize: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu logic should be simplified without any viewport logic and position
	   * based on the relative position of the menu. This will most like require some additional
	   * styles applied to the menu.
	   *
	   * @see {@link Helpers/Layover#simplified}
	   */
	  simplifiedMenu: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#minLeft}
	   */
	  minLeft: _DropdownMenu2.default.propTypes.minLeft,
	
	  /**
	   * @see {@link Helpers/Layover#minRight}
	   */
	  minRight: _DropdownMenu2.default.propTypes.minLeft,
	
	  /**
	   * @see {@link Helpers/Layover#minBottom}
	   */
	  minBottom: _DropdownMenu2.default.propTypes.minBottom,
	
	  /**
	   * @see {@link Helpers/Layover#fillViewportWidth}
	   */
	  fillViewportWidth: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#fillViewportHeight}
	   */
	  fillViewportHeight: _propTypes2.default.bool,
	
	  buttonChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'To build a button, put any elements in the `children`. The `ListItem` have been moved to the `menuItems` prop'),
	  onMenuToggle: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `onVisibilityChange` instead'),
	  isOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `visible` instead'),
	  defaultOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `defaultVisible` instead')
	};
	MenuButton.defaultProps = {
	  defaultVisible: false,
	  repositionOnScroll: true,
	  repositionOnResize: false
	};
	exports.default = MenuButton;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _isRequiredForA11y = __webpack_require__(16);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _Menu = __webpack_require__(56);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _AccessibleFakeInkedButton = __webpack_require__(24);
	
	var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	var _mapToListParts = __webpack_require__(130);
	
	var _mapToListParts2 = _interopRequireDefault(_mapToListParts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `MenuTab` component is used when there are too many desktop tabs
	 * to be displayed without any overflow. If the `Tabs` component is used,
	 * this will automatically be included when the `menuOverflow` prop is true.
	 */
	var MenuTab = function (_PureComponent) {
	  _inherits(MenuTab, _PureComponent);
	
	  function MenuTab() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MenuTab);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = { visible: false }, _this._toggleVisible = function (e) {
	      if (_this.props.onClick) {
	        _this.props.onClick(e);
	      }
	
	      _this.setState({ visible: !_this.state.visible });
	    }, _this._handleClose = function () {
	      _this.setState({ visible: false });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MenuTab.prototype.render = function render() {
	    var _props = this.props,
	        id = _props.id,
	        style = _props.style,
	        className = _props.className,
	        tabStyle = _props.tabStyle,
	        tabClassName = _props.tabClassName,
	        tabs = _props.tabs,
	        label = _props.label,
	        activeTabIndex = _props.activeTabIndex,
	        overflowAtIndex = _props.overflowAtIndex,
	        props = _objectWithoutProperties(_props, ['id', 'style', 'className', 'tabStyle', 'tabClassName', 'tabs', 'label', 'activeTabIndex', 'overflowAtIndex']);
	
	    var active = activeTabIndex >= overflowAtIndex;
	
	    var tab = _react2.default.createElement(
	      _AccessibleFakeInkedButton2.default,
	      _extends({}, props, {
	        onClick: this._toggleVisible,
	        style: tabStyle,
	        className: (0, _classnames2.default)('md-tab md-tab--menu', tabClassName)
	      }),
	      label
	    );
	
	    return _react2.default.createElement(
	      _Menu2.default,
	      {
	        id: id,
	        style: style,
	        className: (0, _classnames2.default)('md-menu--tab', {
	          'md-tab--active': active,
	          'md-tab--inactive': !active
	        }, className),
	        toggle: tab,
	        visible: this.state.visible,
	        onClose: this._handleClose
	      },
	      tabs.map(_mapToListParts2.default)
	    );
	  };
	
	  return MenuTab;
	}(_react.PureComponent);
	
	MenuTab.propTypes = {
	  /**
	   * An id to give the tab's menu.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * The current active tab index. This is used to determine which list item
	   * is active in the menu, and if the styles for an active tab should be applied
	   * to the menu.
	   */
	  activeTabIndex: _propTypes2.default.number.isRequired,
	
	  /**
	   * An tab index that caused the overflow to happen.
	   */
	  overflowAtIndex: _propTypes2.default.number.isRequired,
	
	  /**
	   * A list of tabs that should be rendered in the menu once opened. This can either
	   * be:
	   *
	   * - a `ListItem`, `Divider`, or `Subheader` component
	   * - a string to use as the `primaryText` for a list item
	   * - an object that defines props to generate a `ListItem`, `Divider`, or `Subheader` component
	   */
	  tabs: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.shape({
	    divider: _propTypes2.default.bool,
	    subheader: _propTypes2.default.bool,
	    primaryText: _propTypes2.default.node
	  })])).isRequired,
	
	  /**
	   * An optional style to apply to the menu.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the menu.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the tab in the menu.
	   */
	  tabStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the tab in the menu.
	   */
	  tabClassName: _propTypes2.default.string,
	
	  /**
	   * An optional function to call when the tab is clicked.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * The label to display in the tab. This should normally be some text with
	   * a drop down arrow next to it.
	   */
	  label: _propTypes2.default.node.isRequired
	};
	exports.default = MenuTab;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _isRequiredForA11y = __webpack_require__(16);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This component is just a simple accessibility wrapper when using tabs. If you use the
	 * `TabsContainer` component, you *should* not manually use this as the `TabsContainer`
	 * generates this for you.
	 */
	var TabPanel = function (_PureComponent) {
	  _inherits(TabPanel, _PureComponent);
	
	  function TabPanel() {
	    _classCallCheck(this, TabPanel);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  TabPanel.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.component,
	        id = _props.id,
	        active = _props.active,
	        className = _props.className,
	        controlledById = _props.controlledById,
	        children = _props.children,
	        props = _objectWithoutProperties(_props, ['component', 'id', 'active', 'className', 'controlledById', 'children']);
	
	    return _react2.default.createElement(
	      Component,
	      _extends({}, props, {
	        id: id,
	        className: (0, _classnames2.default)('md-tab-panel', className),
	        role: 'tabpanel',
	        'aria-hidden': !active,
	        'aria-labelledby': controlledById
	      }),
	      children
	    );
	  };
	
	  return TabPanel;
	}(_react.PureComponent);
	
	TabPanel.propTypes = {
	  /**
	   * An id for the panel. This is used for a11y. This should equal the `controlsId`
	   * of whichever tab's children will be placed in here.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * An id for the tab that owns this panel. This should equal the `id` of whichever
	   * tab's children will be placed in here.
	   */
	  controlledById: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The component to render the panel as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * Boolean if the panel is currently active. This is used to generated the `aria-hidden`
	   * attribute.
	   */
	  active: _propTypes2.default.bool,
	
	  /**
	   * Any children to display.
	   */
	  children: _propTypes2.default.node
	};
	TabPanel.defaultProps = {
	  component: 'div'
	};
	exports.default = TabPanel;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(11);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FloatingLabel = function (_PureComponent) {
	  _inherits(FloatingLabel, _PureComponent);
	
	  function FloatingLabel() {
	    _classCallCheck(this, FloatingLabel);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  FloatingLabel.prototype.render = function render() {
	    var _cn;
	
	    var _props = this.props,
	        label = _props.label,
	        htmlFor = _props.htmlFor,
	        className = _props.className,
	        floating = _props.floating,
	        active = _props.active,
	        error = _props.error,
	        disabled = _props.disabled,
	        iconOffset = _props.iconOffset,
	        customSize = _props.customSize,
	        props = _objectWithoutProperties(_props, ['label', 'htmlFor', 'className', 'floating', 'active', 'error', 'disabled', 'iconOffset', 'customSize']);
	
	    if (!label) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      'label',
	      _extends({}, props, {
	        htmlFor: htmlFor,
	        className: (0, _classnames2.default)('md-floating-label', (_cn = {
	          'md-floating-label--inactive': !floating,
	          'md-floating-label--inactive-sized': !floating && !customSize
	        }, _cn['md-floating-label--' + customSize] = customSize, _cn['md-floating-label--inactive-' + customSize] = customSize && !floating, _cn['md-floating-label--floating'] = floating, _cn['md-floating-label--icon-offset'] = iconOffset, _cn), (0, _themeColors2.default)({
	          disabled: disabled,
	          error: error,
	          hint: !active,
	          primary: active
	        }, className))
	      }),
	      label
	    );
	  };
	
	  return FloatingLabel;
	}(_react.PureComponent);
	
	FloatingLabel.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  label: _propTypes2.default.node,
	  floating: _propTypes2.default.bool,
	  error: _propTypes2.default.bool,
	  active: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  iconOffset: _propTypes2.default.bool,
	  customSize: _propTypes2.default.string,
	  htmlFor: _propTypes2.default.string
	};
	exports.default = FloatingLabel;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Divider = __webpack_require__(69);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextFieldDivider = function (_PureComponent) {
	  _inherits(TextFieldDivider, _PureComponent);
	
	  function TextFieldDivider() {
	    _classCallCheck(this, TextFieldDivider);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  TextFieldDivider.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        error = _props.error,
	        lineDirection = _props.lineDirection,
	        className = _props.className,
	        props = _objectWithoutProperties(_props, ['active', 'error', 'lineDirection', 'className']);
	
	    return _react2.default.createElement(_Divider2.default, _extends({}, props, {
	      className: (0, _classnames2.default)('md-divider--text-field md-divider--expand-from-' + lineDirection, {
	        'md-divider--text-field-expanded': active,
	        'md-divider--text-field-active': !error && active,
	        'md-divider--text-field-error': error
	      }, className)
	    }));
	  };
	
	  return TextFieldDivider;
	}(_react.PureComponent);
	
	TextFieldDivider.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  active: _propTypes2.default.bool,
	  error: _propTypes2.default.bool,
	  lineDirection: _propTypes2.default.oneOf(['left', 'center', 'right'])
	};
	exports.default = TextFieldDivider;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(11);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _Message = __webpack_require__(912);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextFieldMessage = function (_PureComponent) {
	  _inherits(TextFieldMessage, _PureComponent);
	
	  function TextFieldMessage(props) {
	    _classCallCheck(this, TextFieldMessage);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));
	
	    _this.state = {
	      message: props.error && props.errorText || props.helpText || props.errorText,
	      isMessageVisible: _this._isMessageVisible(props)
	    };
	    return _this;
	  }
	
	  TextFieldMessage.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var keys = ['active', 'error', 'helpOnFocus', 'helpText', 'errorText'];
	    if (this._anyChanges(keys, this.props, nextProps)) {
	      this.setState({
	        isMessageVisible: this._isMessageVisible(nextProps),
	        message: nextProps.error && nextProps.errorText || nextProps.helpText || nextProps.errorText
	      });
	    }
	  };
	
	  TextFieldMessage.prototype._anyChanges = function _anyChanges(keys, p1, p2) {
	    var changed = false;
	    keys.some(function (key) {
	      if (p1[key] !== p2[key]) {
	        changed = true;
	      }
	
	      return changed;
	    });
	
	    return changed;
	  };
	
	  TextFieldMessage.prototype._isMessageVisible = function _isMessageVisible(props) {
	    var error = props.error,
	        errorText = props.errorText,
	        helpText = props.helpText,
	        helpOnFocus = props.helpOnFocus,
	        active = props.active;
	
	    if (error && errorText) {
	      return true;
	    }
	
	    return !!(helpText && (!helpOnFocus || active));
	  };
	
	  TextFieldMessage.prototype.render = function render() {
	    var _props = this.props,
	        maxLength = _props.maxLength,
	        error = _props.error,
	        className = _props.className,
	        errorText = _props.errorText,
	        helpText = _props.helpText,
	        currentLength = _props.currentLength,
	        leftIcon = _props.leftIcon,
	        rightIcon = _props.rightIcon,
	        block = _props.block,
	        active = _props.active;
	    var _state = this.state,
	        isMessageVisible = _state.isMessageVisible,
	        message = _state.message;
	
	
	    if (currentLength === 'undefined' || !helpText && !errorText && !maxLength) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)('md-text-field-message-container', {
	          'md-text-field-message-container--count-only': !message || !isMessageVisible,
	          'md-text-field-message-container--left-icon-offset': leftIcon,
	          'md-text-field-message-container--right-icon-offset': rightIcon,
	          'md-full-width': !block
	        }, (0, _themeColors2.default)({ error: error, disabled: !error }), className)
	      },
	      _react2.default.createElement(
	        _Message2.default,
	        { key: 'message', active: isMessageVisible },
	        message
	      ),
	      _react2.default.createElement(
	        _Message2.default,
	        { key: 'counter', className: 'md-text-field-message--counter', active: active },
	        maxLength ? currentLength + ' / ' + maxLength : null
	      )
	    );
	  };
	
	  return TextFieldMessage;
	}(_react.PureComponent);
	
	TextFieldMessage.propTypes = {
	  className: _propTypes2.default.string,
	  error: _propTypes2.default.bool,
	  helpText: _propTypes2.default.node,
	  errorText: _propTypes2.default.node,
	  active: _propTypes2.default.bool,
	  helpOnFocus: _propTypes2.default.bool,
	  maxLength: _propTypes2.default.number,
	  currentLength: _propTypes2.default.number,
	  leftIcon: _propTypes2.default.bool,
	  rightIcon: _propTypes2.default.bool,
	  block: _propTypes2.default.bool
	};
	exports.default = TextFieldMessage;

/***/ }),
/* 345 */,
/* 346 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/** @module utils/DateUtils/DateTimeFormat */
	
	/**
	 * A _really_ terrible DateTimeFormat mock if it is not available in
	 * the browser or node version.
	 */
	var DateTimeFormat = function () {
	  if (typeof Intl !== 'undefined' && typeof Intl.DateTimeFormat !== 'undefined') {
	    return Intl.DateTimeFormat;
	  }
	
	  // Very bad 'mock' of Intl.DateTimeFormat
	  return function () {
	    // eslint-disable-line no-shadow
	    function DateTimeFormat(locales, formatOptions) {
	      _classCallCheck(this, DateTimeFormat);
	
	      this.locales = locales;
	      this.options = formatOptions;
	    }
	
	    DateTimeFormat.prototype.format = function format(date) {
	      return date.toLocaleString();
	    };
	
	    return DateTimeFormat;
	  }();
	}();
	
	exports.default = DateTimeFormat;

/***/ }),
/* 347 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = formatTime;
	/** @module utils/DateUtils/formatTime */
	
	/**
	 * Formats a date as a time string using the DateTimeFormat function and locales.
	 *
	 * @param {function} DateTimeFormat the DateTimeFormat function to use.
	 * @param {string|string[]} locales the locales to use.
	 * @param {Boolean} showSeconds boolean if seconds should be formatted
	 * @param {Date} time the time to format into a string.
	 * @return a string of the formatted time.
	 */
	function formatTime(DateTimeFormat, locales, showSeconds, time) {
	  var format = void 0;
	  if (showSeconds === true) {
	    format = { hour: 'numeric', minute: '2-digit', second: '2-digit' };
	  } else {
	    format = { hour: 'numeric', minute: '2-digit' };
	  }
	
	  return new DateTimeFormat(locales, format).format(time);
	}

/***/ }),
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = oneRequired;
	/** @module utils/PropTypes/oneRequired */
	
	/**
	 * A simple prop type validation that makes sure that at least this prop or one of the
	 * other defined prop names are defined for a component.
	 *
	 * @param {function} validator - The PropType validator for the current prop.
	 * @param {...String} otherPropNames - A single or list of prop names that could be defined
	 * @return {Error} a prop type validation error or null.
	 */
	function oneRequired(validator) {
	  for (var _len = arguments.length, otherPropNames = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    otherPropNames[_key - 1] = arguments[_key];
	  }
	
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	    var allPropNames = [propFullNameSafe].concat(otherPropNames);
	
	    for (var _len2 = arguments.length, args = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
	      args[_key2 - 5] = arguments[_key2];
	    }
	
	    var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	    if (!err && !allPropNames.filter(function (pn) {
	      return typeof props[pn] !== 'undefined';
	    }).length) {
	      err = new Error('One of the following props are required for the ' + componentNameSafe + ' component. ' + ('`' + allPropNames.join('`, `') + '`.'));
	    }
	
	    return err;
	  };
	}

/***/ }),
/* 352 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = addSuffix;
	/** @module utils/StringUtils/addSuffix */
	
	/**
	 * Optionally adds a suffix to a string if it does
	 * not already contain that string.
	 *
	 * @param {String} str - The string to modify
	 * @param {String} suffix - The suffix to add
	 *
	 * @return {String} the string with a suffix
	 */
	function addSuffix(str, suffix) {
	  if (!str || typeof str !== 'string') {
	    return str;
	  }
	
	  return str.indexOf(suffix) === -1 ? str.trim() + ' ' + suffix : str;
	}

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getLastDay;
	
	var _isValidDate = __webpack_require__(58);
	
	var _isValidDate2 = _interopRequireDefault(_isValidDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Gets the last day in a month as a new Date.
	 *
	 * @param {Date} date - The date to get the last date in a month for
	 * @return {Date} the last day in the month as a date object or null.
	 */
	function getLastDay(date) {
	  if (!(0, _isValidDate2.default)(date)) {
	    return null;
	  }
	
	  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
	}

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = toDayOfWeek;
	
	var _isValidDate = __webpack_require__(58);
	
	var _isValidDate2 = _interopRequireDefault(_isValidDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Takes in a date and returns a new date at the specified day of week.
	 *
	 * Examples:
	 * // to Sunday
	 * - toDayOfWeek(new Date(2018, 0, 1), 0) == new Date(2017, 11, 31)
	 *
	 * // to Monday
	 * - toDayOfWeek(new Date(2018, 0, 1), 1) == new Date(2018, 0, 1)
	 *
	 * @param {Date} date - The date to convert to a day of week
	 * @param {number=0} dow - The day of the week to convert to
	 * @return {Date} the new date set at the day of week or null if the
	 *    date is invalid or false-ish.
	 */
	function toDayOfWeek(date) {
	  var dow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  if (!(0, _isValidDate2.default)(date)) {
	    return null;
	  }
	
	  var d = new Date(date);
	  var day = date.getDay();
	  var diff = d.getDate() - day + dow;
	  return new Date(d.setDate(diff));
	}

/***/ }),
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _default = {
	  RESISTANCE_COEF: 0.6,
	  // This value is closed to what browsers are using internally to
	  // trigger a native scroll.
	  UNCERTAINTY_THRESHOLD: 3 // px
	
	};
	exports.default = _default;

/***/ }),
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */
/***/ (function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	module.exports = _assertThisInitialized;

/***/ }),
/* 372 */
/***/ (function(module, exports) {

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	module.exports = _classCallCheck;

/***/ }),
/* 373 */
/***/ (function(module, exports) {

	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	module.exports = _createClass;

/***/ }),
/* 374 */
/***/ (function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(379);
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) setPrototypeOf(subClass, superClass);
	}
	
	module.exports = _inherits;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	var objectWithoutPropertiesLoose = __webpack_require__(377);
	
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = objectWithoutPropertiesLoose(source, excluded);
	  var key, i;
	
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutProperties;

/***/ }),
/* 377 */
/***/ (function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(380);
	
	var assertThisInitialized = __webpack_require__(371);
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }
	
	  return assertThisInitialized(self);
	}
	
	module.exports = _possibleConstructorReturn;

/***/ }),
/* 379 */
/***/ (function(module, exports) {

	function _setPrototypeOf(o, p) {
	  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	module.exports = _setPrototypeOf;

/***/ }),
/* 380 */
/***/ (function(module, exports) {

	function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }
	
	function _typeof(obj) {
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    module.exports = _typeof = function _typeof(obj) {
	      return _typeof2(obj);
	    };
	  } else {
	    module.exports = _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
	    };
	  }
	
	  return _typeof(obj);
	}
	
	module.exports = _typeof;

/***/ }),
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(755);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Hero = function (_Component) {
	  _inherits(Hero, _Component);
	
	  function Hero() {
	    _classCallCheck(this, Hero);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Hero.prototype.render = function render() {
	    return _react2.default.createElement(
	      "section",
	      { className: "cover-photo" },
	      _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement("div", { className: "circle one" }),
	        _react2.default.createElement("div", { className: "circle two" }),
	        _react2.default.createElement("div", { className: "circle three" }),
	        _react2.default.createElement("div", { className: "circle four" }),
	        _react2.default.createElement("div", { className: "circle five" }),
	        _react2.default.createElement(
	          "div",
	          { className: "text-wrapper" },
	          _react2.default.createElement(
	            "h1",
	            { className: "text" },
	            "Mohamed Azazy"
	          ),
	          _react2.default.createElement(
	            "h2",
	            { className: "text" },
	            "UI/UX Designer"
	          )
	        )
	      )
	    );
	  };
	
	  return Hero;
	}(_react.Component);
	
	exports.default = Hero;
	module.exports = exports["default"];

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMd = __webpack_require__(918);
	
	__webpack_require__(756);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Intro = function (_Component) {
	    _inherits(Intro, _Component);
	
	    function Intro() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Intro);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Intro.prototype.render = function render() {
	        return _react2.default.createElement(
	            'section',
	            { className: 'intro-wrapper' },
	            _react2.default.createElement(
	                'div',
	                { className: '-text-wrapper' },
	                _react2.default.createElement(
	                    'h2',
	                    { className: '-section-header' },
	                    '\u062A\u0635\u0645\u064A\u0645 \u0645\u0648\u0627\u0642\u0639 \u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A \u0648\u0627\u0644\u0647\u0648\u064A\u0629 \u0627\u0644\u062A\u062C\u0627\u0631\u064A\u0629'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    { className: '-section-descr' },
	                    '\u062A\u0635\u0645\u064A\u0645 \u0627\u0644\u062A\u062C\u0631\u0628\u0629 \u0627\u0644\u0631\u0642\u0645\u064A\u0629 \u0644\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0643\u062D\u062C\u0631 \u0623\u0633\u0627\u0633 \u0644\u0643\u0644 \u0645\u0634\u0631\u0648\u0639 \u0648\u062A\u0635\u0645\u064A\u0645 \u0648\u0627\u062C\u0647\u0629 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0644\u0644\u062A\u0637\u0628\u064A\u0642\u0627\u062A \u062D\u062A\u0649 \u0627\u0644\u062A\u0633\u0644\u064A\u0645 \u0625\u0644\u0649 \u0641\u0631\u064A\u0642 \u0645\u0646 \u0627\u0644\u0645\u0637\u0648\u0631\u064A\u0646'
	                )
	            ),
	            _react2.default.createElement(
	                _reactMd.Grid,
	                { className: '-features hide' },
	                _react2.default.createElement(
	                    _reactMd.Cell,
	                    { size: 4 },
	                    '6'
	                ),
	                _react2.default.createElement(
	                    _reactMd.Cell,
	                    { size: 4 },
	                    '4'
	                ),
	                _react2.default.createElement(
	                    _reactMd.Cell,
	                    { size: 4 },
	                    '2'
	                )
	            )
	        );
	    };
	
	    return Intro;
	}(_react.Component);
	
	exports.default = Intro;
	module.exports = exports['default'];

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Hero = __webpack_require__(395);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Intro = __webpack_require__(396);
	
	var _Intro2 = _interopRequireDefault(_Intro);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HomeContainer = function (_Component) {
	  _inherits(HomeContainer, _Component);
	
	  function HomeContainer() {
	    _classCallCheck(this, HomeContainer);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  HomeContainer.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(_Hero2.default, null),
	      _react2.default.createElement(_Intro2.default, null)
	    );
	  };
	
	  return HomeContainer;
	}(_react.Component);
	
	exports.default = HomeContainer;
	module.exports = exports["default"];

/***/ }),
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(33);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _SEO = __webpack_require__(139);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _SiteConfig = __webpack_require__(20);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _HomeContainer = __webpack_require__(397);
	
	var _HomeContainer2 = _interopRequireDefault(_HomeContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import PostListing from "../components/PostListing/PostListing";
	
	
	var Index = function (_React$Component) {
	  _inherits(Index, _React$Component);
	
	  function Index() {
	    _classCallCheck(this, Index);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Index.prototype.render = function render() {
	    //const postEdges = this.props.data.allMarkdownRemark.edges;
	    return _react2.default.createElement(
	      "div",
	      { className: "index-container" },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          "title",
	          null,
	          _SiteConfig2.default.siteTitle
	        ),
	        _react2.default.createElement("link", { rel: "canonical", href: "" + _SiteConfig2.default.siteUrl })
	      ),
	      _react2.default.createElement(_HomeContainer2.default, null)
	    );
	  };
	
	  return Index;
	}(_react2.default.Component);
	
	exports.default = Index;
	
	/* eslint no-undef: "off"*/
	// export const pageQuery = graphql`
	//   query IndexQuery {
	//     allMarkdownRemark(
	//       limit: 2000
	//       sort: { fields: [frontmatter___date], order: DESC }
	//     ) {
	//       edges {
	//         node {
	//           fields {
	//             slug
	//           }
	//           excerpt
	//           timeToRead
	//           frontmatter {
	//             title
	//             tags
	//             cover
	//             date
	//           }
	//         }
	//       }
	//     }
	//   }
	// `;
	
	module.exports = exports["default"];

/***/ }),
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 756 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(7);
	
	var _CSSTransitionGroup = __webpack_require__(38);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _getField = __webpack_require__(8);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _omit = __webpack_require__(177);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _findIgnoreCase = __webpack_require__(942);
	
	var _findIgnoreCase2 = _interopRequireDefault(_findIgnoreCase);
	
	var _fuzzyFilter = __webpack_require__(943);
	
	var _fuzzyFilter2 = _interopRequireDefault(_fuzzyFilter);
	
	var _caseInsensitiveFilter = __webpack_require__(932);
	
	var _caseInsensitiveFilter2 = _interopRequireDefault(_caseInsensitiveFilter);
	
	var _getTextWidth = __webpack_require__(128);
	
	var _getTextWidth2 = _interopRequireDefault(_getTextWidth);
	
	var _oneRequiredForA11y = __webpack_require__(175);
	
	var _oneRequiredForA11y2 = _interopRequireDefault(_oneRequiredForA11y);
	
	var _controlled = __webpack_require__(15);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _invalidIf = __webpack_require__(43);
	
	var _invalidIf2 = _interopRequireDefault(_invalidIf);
	
	var _keyCodes = __webpack_require__(14);
	
	var _anchorShape = __webpack_require__(28);
	
	var _anchorShape2 = _interopRequireDefault(_anchorShape);
	
	var _fixedToShape = __webpack_require__(19);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _positionShape = __webpack_require__(36);
	
	var _positionShape2 = _interopRequireDefault(_positionShape);
	
	var _ListItem = __webpack_require__(85);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _Menu = __webpack_require__(56);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _TextField = __webpack_require__(89);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `Autocomplete` component is useful for presenting real-time suggestions, completions,
	 * or filtering.
	 */
	var Autocomplete = function (_PureComponent) {
	  _inherits(Autocomplete, _PureComponent);
	
	  function Autocomplete(props) {
	    _classCallCheck(this, Autocomplete);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var defaultValue = props.defaultValue,
	        data = props.data,
	        dataLabel = props.dataLabel,
	        filter = props.filter;
	
	
	    var matches = [];
	    if (defaultValue && filter) {
	      matches = filter(data, defaultValue, dataLabel);
	    } else if (!filter) {
	      matches = data;
	    }
	
	    _this.state = {
	      value: defaultValue,
	      matches: matches,
	      visible: false,
	      matchIndex: -1,
	      manualFocus: false,
	      suggestion: '',
	      suggestionIndex: -1
	    };
	    return _this;
	  }
	
	  Autocomplete.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextValue = nextProps.value,
	        data = nextProps.data,
	        filter = nextProps.filter,
	        dataLabel = nextProps.dataLabel;
	
	    var dataDiff = data !== this.props.data;
	    if (nextValue !== this.props.value || dataDiff) {
	      var _state = this.state,
	          visible = _state.visible,
	          matches = _state.matches;
	
	      var value = (0, _getField2.default)(nextProps, this.state, 'value');
	
	      if (filter) {
	        matches = filter(data, value, dataLabel);
	      } else if (dataDiff) {
	        matches = data;
	      }
	
	      if (this.state.focus) {
	        visible = !!matches.length;
	      }
	
	      this.setState({ matches: matches, visible: visible });
	    }
	  };
	
	  Autocomplete.prototype.componentWillUpdate = function componentWillUpdate(nextProps, nextState) {
	    if (this.state.visible !== nextState.visible) {
	      var menuFn = nextProps['onMenu' + (nextState.visible ? 'Open' : 'Close')];
	      if (menuFn) {
	        menuFn();
	      }
	    }
	  };
	
	  /**
	   * Gets the current value from the text field. This is used when you have an uncontrolled
	   * text field and simply need the value from a ref callback.
	   *
	   * @return {String} the text field's value
	   */
	
	
	  Autocomplete.prototype.render = function render() {
	    var _state2 = this.state,
	        visible = _state2.visible,
	        matches = _state2.matches,
	        tabbed = _state2.tabbed,
	        focus = _state2.focus,
	        suggestionStyle = _state2.suggestionStyle;
	
	    var _props = this.props,
	        fullWidth = _props.fullWidth,
	        block = _props.block,
	        style = _props.style,
	        className = _props.className,
	        listStyle = _props.listStyle,
	        listClassName = _props.listClassName,
	        textFieldStyle = _props.textFieldStyle,
	        textFieldClassName = _props.textFieldClassName,
	        inlineSuggestionStyle = _props.inlineSuggestionStyle,
	        inlineSuggestionClassName = _props.inlineSuggestionClassName,
	        menuId = _props.menuId,
	        inline = _props.inline,
	        anchor = _props.anchor,
	        belowAnchor = _props.belowAnchor,
	        position = _props.position,
	        fixedTo = _props.fixedTo,
	        listId = _props.listId,
	        listInline = _props.listInline,
	        listZDepth = _props.listZDepth,
	        listHeightRestricted = _props.listHeightRestricted,
	        xThreshold = _props.xThreshold,
	        yThreshold = _props.yThreshold,
	        closeOnOutsideClick = _props.closeOnOutsideClick,
	        transitionName = _props.transitionName,
	        transitionEnterTimeout = _props.transitionEnterTimeout,
	        transitionLeaveTimeout = _props.transitionLeaveTimeout,
	        centered = _props.centered,
	        sameWidth = _props.sameWidth,
	        repositionOnScroll = _props.repositionOnScroll,
	        repositionOnResize = _props.repositionOnResize,
	        simplifiedMenu = _props.simplifiedMenu,
	        minLeft = _props.minLeft,
	        minRight = _props.minRight,
	        minBottom = _props.minBottom,
	        fillViewportWidth = _props.fillViewportWidth,
	        fillViewportHeight = _props.fillViewportHeight,
	        propValue = _props.value,
	        total = _props.total,
	        offset = _props.offset,
	        filter = _props.filter,
	        data = _props.data,
	        dataLabel = _props.dataLabel,
	        dataValue = _props.dataValue,
	        deleteKeys = _props.deleteKeys,
	        defaultValue = _props.defaultValue,
	        clearOnAutocomplete = _props.clearOnAutocomplete,
	        autocompleteWithLabel = _props.autocompleteWithLabel,
	        findInlineSuggestion = _props.findInlineSuggestion,
	        inlineSuggestionPadding = _props.inlineSuggestionPadding,
	        onAutocomplete = _props.onAutocomplete,
	        onMenuOpen = _props.onMenuOpen,
	        onMenuClose = _props.onMenuClose,
	        onBlur = _props.onBlur,
	        onFocus = _props.onFocus,
	        onKeyDown = _props.onKeyDown,
	        onMouseDown = _props.onMouseDown,
	        onChange = _props.onChange,
	        props = _objectWithoutProperties(_props, ['fullWidth', 'block', 'style', 'className', 'listStyle', 'listClassName', 'textFieldStyle', 'textFieldClassName', 'inlineSuggestionStyle', 'inlineSuggestionClassName', 'menuId', 'inline', 'anchor', 'belowAnchor', 'position', 'fixedTo', 'listId', 'listInline', 'listZDepth', 'listHeightRestricted', 'xThreshold', 'yThreshold', 'closeOnOutsideClick', 'transitionName', 'transitionEnterTimeout', 'transitionLeaveTimeout', 'centered', 'sameWidth', 'repositionOnScroll', 'repositionOnResize', 'simplifiedMenu', 'minLeft', 'minRight', 'minBottom', 'fillViewportWidth', 'fillViewportHeight', 'value', 'total', 'offset', 'filter', 'data', 'dataLabel', 'dataValue', 'deleteKeys', 'defaultValue', 'clearOnAutocomplete', 'autocompleteWithLabel', 'findInlineSuggestion', 'inlineSuggestionPadding', 'onAutocomplete', 'onMenuOpen', 'onMenuClose', 'onBlur', 'onFocus', 'onKeyDown', 'onMouseDown', 'onChange']);
	
	    delete props.focusInputOnAutocomplete;
	
	    var value = (0, _getField2.default)(this.props, this.state, 'value');
	
	    var autocomplete = _react2.default.createElement(_TextField2.default, _extends({}, props, {
	      'aria-autocomplete': inline ? 'inline' : 'list',
	      style: textFieldStyle,
	      className: (0, _classnames2.default)('md-autocomplete', textFieldClassName),
	      key: 'autocomplete',
	      ref: this._setField,
	      value: value,
	      onKeyDown: this._handleTextFieldKeyDown,
	      onMouseDown: this._toggleMenu,
	      onChange: this._handleChange,
	      onFocus: this._handleFocus,
	      onBlur: this._handleBlur,
	      fullWidth: fullWidth,
	      block: block
	    }));
	
	    if (inline) {
	      var suggestion = void 0;
	      if (focus && this.state.suggestion) {
	        suggestion = _react2.default.createElement(
	          'span',
	          {
	            key: 'suggestion',
	            style: _extends({}, suggestionStyle, inlineSuggestionStyle),
	            className: (0, _classnames2.default)('md-autocomplete-suggestion', {
	              'md-autocomplete-suggestion--floating': props.label,
	              'md-autocomplete-suggestion--block': block
	            }, inlineSuggestionClassName)
	          },
	          this.state.suggestion
	        );
	      }
	
	      return _react2.default.createElement(
	        _CSSTransitionGroup2.default,
	        {
	          component: 'div',
	          style: style,
	          className: (0, _classnames2.default)('md-menu-container md-autocomplete-container', className, {
	            'md-full-width': fullWidth || block
	          }),
	          transitionName: 'opacity',
	          transitionEnterTimeout: 150,
	          transitionLeave: !tabbed,
	          transitionLeaveTimeout: 150,
	          onTouchStart: this._handleTouchStart
	        },
	        autocomplete,
	        suggestion
	      );
	    }
	
	    return _react2.default.createElement(
	      _Menu2.default,
	      {
	        id: menuId || props.id + '-menu',
	        listId: listId,
	        ref: this._setMenu,
	        toggle: autocomplete,
	        visible: visible,
	        onClick: this._handleClick,
	        onClose: this._close,
	        onKeyDown: this._handleMenuKeyDown,
	        simplified: simplifiedMenu,
	        sameWidth: sameWidth,
	        centered: centered,
	        anchor: anchor,
	        belowAnchor: belowAnchor,
	        position: position,
	        fixedTo: fixedTo,
	        listInline: listInline,
	        listZDepth: listZDepth,
	        listHeightRestricted: listHeightRestricted,
	        xThreshold: xThreshold,
	        yThreshold: yThreshold,
	        closeOnOutsideClick: closeOnOutsideClick,
	        transitionName: transitionName,
	        transitionEnterTimeout: transitionEnterTimeout,
	        transitionLeaveTimeout: transitionLeaveTimeout,
	        fullWidth: fullWidth || block,
	        style: style,
	        className: (0, _classnames2.default)('md-autocomplete-container', className),
	        listStyle: listStyle,
	        listClassName: (0, _classnames2.default)('md-autocomplete-list', listClassName),
	        repositionOnScroll: repositionOnScroll,
	        repositionOnResize: repositionOnResize,
	        minLeft: minLeft,
	        minRight: minRight,
	        minBottom: minBottom,
	        fillViewportWidth: fillViewportWidth,
	        fillViewportHeight: fillViewportHeight
	      },
	      matches.map(this._mapToListItem)
	    );
	  };
	
	  _createClass(Autocomplete, [{
	    key: 'value',
	    get: function get() {
	      return (0, _getField2.default)(this.props, this.state, 'value');
	    }
	
	    /**
	     * Just check if the click target is in a list item.. if it is, autocomplete the text field
	     * with that item.
	     */
	
	
	    /**
	     * The `mousedown` event is used instead of `click` because of the order
	     * of the `mousedown`, `focus`, and `click` events.
	     */
	
	
	    /**
	     * Allows touch devices to autocomplete the inline view by tapping:
	     * - the suggestion text
	     * - the text field IF there is a suggestion visible
	     */
	
	  }]);
	
	  return Autocomplete;
	}(_react.PureComponent);
	
	Autocomplete.HorizontalAnchors = _Menu2.default.HorizontalAnchors;
	Autocomplete.VerticalAnchors = _Menu2.default.VerticalAnchors;
	Autocomplete.Positions = _Menu2.default.Positions;
	Autocomplete.fuzzyFilter = _fuzzyFilter2.default;
	Autocomplete.caseInsensitiveFilter = _caseInsensitiveFilter2.default;
	Autocomplete.findIgnoreCase = _findIgnoreCase2.default;
	Autocomplete.propTypes = {
	  /**
	   * An id to give the autocomplete. Either this or the `menuId` is required for accessibility.
	   *
	   * @see {@link #menuId}
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * The menu id to provide to the autocomplete. Either this prop or the `id` prop is required. If
	   * this props is omitted, the menuId will become: `${id}-menu`
	   */
	  menuId: (0, _oneRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]), 'id'),
	
	  /**
	   * An optional id to provide to the menu's list.
	   *
	   * @see {@link Menus/Menu#listId}
	   */
	  listId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply to the menu that contains the autocomplete.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the menu that contains the autocomplete.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the autocomplete's text field.
	   */
	  textFieldStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the autocomplete's text field.
	   */
	  textFieldClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the autocomplete's text field input itself.
	   */
	  inputStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the autocomplete's input field itself.
	   */
	  inputClassName: _propTypes2.default.string,
	
	  /**
	   * The optional style to apply to the opened menu List if the
	   * `Autocomplete` is not using `inline` suggestions.
	   */
	  listStyle: _propTypes2.default.object,
	
	  /**
	   * The optional className to apply to the opened menu List if the
	   * `Autocomplete` is not using `inline` suggestions.
	   */
	  listClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the inline suggestion when using `inline` mode.
	   */
	  inlineSuggestionStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the inline suggestion when using `inline` mode.
	   */
	  inlineSuggestionClassName: _propTypes2.default.string,
	
	  /**
	   * Boolean if the autocomplete is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * A label to display with the autocomplete.
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * An optional value to use for the text field. This will force this component
	   * to be controlled and require the `onChange` function.
	   */
	  value: (0, _controlled2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]), 'onChange'),
	
	  /**
	   * The default value for the autocomplete's text field.
	   */
	  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	
	  /**
	   * An object key to use to extract the text to be compared for filtering.
	   * This will only be applied if the given `data` prop is an array of objects.
	   */
	  dataLabel: _propTypes2.default.string.isRequired,
	
	  /**
	   * An optional object key to use to extract the `value` of the given `data` prop.
	   * This is really only used with generating a unique react key. The unique react
	   * key with either be:
	   * - the datum if it is a string or number
	   * - the `key` attribute of the datum object
	   * - the `datum[dataValue]`
	   * - or the `datum[dataLabel]`
	   */
	  dataValue: _propTypes2.default.string,
	
	  /**
	   * A single key or an array of keys to delete from your data object before passing
	   * to the `ListItem` component.
	   */
	  deleteKeys: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
	
	  /**
	   * The data that will be used for autocomplete suggestions. This can either be
	   * an array of string, number, or object. If it is an array of objects, the key
	   * `dataLabel` is required.
	   *
	   * ```docgen
	   * PropTypes.arrayOf(PropTypes.oneOfType([
	   *   PropTypes.element,
	   *   PropTypes.string,
	   *   PropTypes.number,
	   *   PropTypes.shape({
	   *     [dataLabel]: PropTypes.oneOfType([
	   *       PropTypes.string,
	   *       PropTypes.number,
	   *       PropTypes.node,
	   *     ]).isRequired,
	   *   }),
	   * ])).isRequired
	   * ```
	   */
	  data: function data(props, propName, component) {
	    for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      others[_key - 3] = arguments[_key];
	    }
	
	    var _PropTypes$arrayOf, _PropTypes$shape;
	
	    var dataLabel = props.dataLabel;
	
	    return (_PropTypes$arrayOf = _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.shape((_PropTypes$shape = {}, _PropTypes$shape[dataLabel] = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.node]).isRequired, _PropTypes$shape))]))).isRequired.apply(_PropTypes$arrayOf, [props, propName, component].concat(others));
	  },
	
	  /**
	   * An optional number representing the total number of results in the `data` prop.
	   * This should really only be used when the data is paginated. When this is set,
	   * each item in the suggestion menu will be updated with the `aria-setsize` and
	   * `aria-posinset`.
	   *
	   * @see {@link #offset}
	   */
	  total: (0, _invalidIf2.default)(_propTypes2.default.number, 'inline'),
	
	  /**
	   * An optional number representing the data's offset if the results were paginated.
	   * This is used for accessibility with the `aria-posinset` attribute.
	   *
	   * @see {@link #total}
	   */
	  offset: _propTypes2.default.number.isRequired,
	
	  /**
	   * An optional function to use to filter the `data`. If you have a sexy backend
	   * using solr or some other search/indexer, it is recommended to set this prop to
	   * `null`.
	   */
	  filter: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `Autocomplete`'s text field has a `keydown` event.
	   */
	  onKeyDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `Autocomplete`'s text field has a `mousedown` event.
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `Autocomplete`'s text field value changes.
	   * The callback will be given the new value and the change event.
	   *
	   * `onChange(textFeldValue, event)`
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `Autocomplete`'s text field is focused.
	   */
	  onFocus: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the entire `Autocomplete` component is blurred.
	   * This will be triggered when the window is clicked or when a user tabs away from
	   * the autocomplete.
	   */
	  onBlur: _propTypes2.default.func,
	
	  /**
	   * Boolean if this text field should be styled as a full width text field.
	   * Floating labels and the text field indicator will be removed automatically.
	   */
	  block: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the autocomplete should span the entire width.
	   */
	  fullWidth: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `Autocomplete` should display suggestions inline instead
	   * of in a `Menu`.
	   */
	  inline: _propTypes2.default.bool,
	
	  /**
	   * The amount of padding to use between the current text and the inline suggestion text.
	   */
	  inlineSuggestionPadding: _propTypes2.default.number.isRequired,
	
	  /**
	   * The function to call to find a suggestion for an inline autocomplete. This function
	   * expects to return a single result of a number or a string.
	   *
	   * ```js
	   * @param {Array<Object|String|Number>} data - The data prop to search.
	   * @param {String} value - The current value to use for searching.
	   * @param {String} dataLabel - The `dataLabel` prop to use if a datum is an object.
	   * @return {String|Number} the found suggestion or false-ish
	   * ```
	   */
	  findInlineSuggestion: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when an autocomplete suggestion is clicked either
	   * by using the mouse, the enter/space key, or touch. The match index and current
	   * `dataLabel` will be given back.
	   *
	   * `onAutocomplete(suggestion, suggestionIndex, matches);`
	   *
	   * @see {@link #autocompleteWithLabel}
	   */
	  onAutocomplete: _propTypes2.default.func,
	
	  /**
	   * Boolean if the `onAutocomplete` should attempt send the `suggestion[dataLabel]` instead
	   * of `suggestion[dataValue]` when the data is an object.
	   *
	   * @see {@link #onAutocomplete}
	   */
	  autocompleteWithLabel: _propTypes2.default.bool,
	
	  /**
	   * A boolean if the text field's value should be reset to the empty string when
	   * an item is auto-completed. This is useful if you do not want a fully controlled
	   * component and the values are stored outside of the `TextField`. (like `Chips`).
	   */
	  clearOnAutocomplete: _propTypes2.default.bool,
	
	  /**
	   * An optional function to call when the `Autocomplete` suggestion menu opens.
	   */
	  onMenuOpen: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `Autocomplete` suggestion menu closes.
	   */
	  onMenuClose: _propTypes2.default.func,
	
	  /**
	   * This prop is used for disabling the browser's default autocomplete suggestions
	   * of previously typed values in the text field. By default, this is disabled.
	   */
	  autoComplete: _propTypes2.default.oneOf(['on', 'off']),
	
	  /**
	   * Boolean if the `input` should be focused again after a suggestion was clicked.
	   *
	   * This is really only added for keyboard support and the fact that each of suggestions
	   * are focusable.
	   */
	  focusInputOnAutocomplete: _propTypes2.default.bool,
	
	  /**
	   * This is how the menu's `List` gets anchored to the `toggle` element.
	   *
	   * @see {@link Helpers/Layover#anchor}
	   */
	  anchor: _anchorShape2.default,
	
	  /**
	   * This is the anchor to use when the `position` is set to `Autocomplete.Positions.BELOW`.
	   *
	   * @see {@link Helpers/Layover#belowAnchor}
	   */
	  belowAnchor: _anchorShape2.default,
	
	  /**
	   * This is the animation position for the list that appears.
	   *
	   * @see {@link Helpers/Layover#animationPosition}
	   */
	  position: _positionShape2.default,
	
	  /**
	   * This is how the menu's list will be "fixed" to the `toggle` component.
	   *
	   * @see {@link Helpers/Layover#fixedTo}
	   */
	  fixedTo: _fixedToShape2.default,
	
	  /**
	   * Boolean if the menu's list should appear horizontally instead of vertically.
	   */
	  listInline: _propTypes2.default.bool,
	
	  /**
	   * The list's z-depth for applying box shadow. This should be a number from 0 to 5.
	   */
	  listZDepth: _propTypes2.default.number,
	
	  /**
	   * Boolean if the list should have its height restricted to the `$md-menu-mobile-max-height`/
	   * `$md-menu-desktop-max-height` values.
	   *
	   * @see [md-menu-mobile-max-height](/components/menus?tab=2#variable-md-menu-mobile-max-height)
	   * @see [md-menu-desktop-max-height](/components/menus?tab=2#variable-md-menu-desktop-max-height)
	   */
	  listHeightRestricted: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#xThreshold}
	   */
	  xThreshold: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#yThreshold}
	   */
	  yThreshold: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#closeOnOutsideClick}
	   */
	  closeOnOutsideClick: _propTypes2.default.bool,
	
	  /**
	   * An optional transition name to use for the list appearing/disappearing.
	   *
	   * @see {@link Helpers/Layover#transitionName}
	   */
	  transitionName: _propTypes2.default.string,
	
	  /**
	   * @see {@link Helpers/Layover#transitionEnterTimeout}
	   */
	  transitionEnterTimeout: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#transitionLeaveTimeout}
	   */
	  transitionLeaveTimeout: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#centered}
	   */
	  centered: _Menu2.default.propTypes.centered,
	
	  /**
	   * @see {@link Helpers/Layover#sameWidth}
	   */
	  sameWidth: _Menu2.default.propTypes.sameWidth,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the `fixedTo` element scrolls.
	   *
	   * @see {@link Helpers/Layover#repositionOnScroll}
	   */
	  repositionOnScroll: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the window resizes.
	   *
	   * @see {@link Helpers/Layover#repositionOnResize}
	   */
	  repositionOnResize: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu logic should be simplified without any viewport logic and position
	   * based on the relative position of the menu. This will most like require some additional
	   * styles applied to the menu.
	   *
	   * @see {@link Helpers/Layover#simplified}
	   */
	  simplifiedMenu: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#minLeft}
	   */
	  minLeft: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#minRight}
	   */
	  minRight: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#minBottom}
	   */
	  minBottom: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#fillViewportWidth}
	   */
	  fillViewportWidth: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#fillViewportHeight}
	   */
	  fillViewportHeight: _propTypes2.default.bool,
	
	  /**
	   * @see {@link TextFields#toolbar}
	   */
	  toolbar: _propTypes2.default.bool
	};
	Autocomplete.defaultProps = {
	  autocompleteWithLabel: false,
	  position: _Menu2.default.Positions.BELOW,
	  sameWidth: true,
	  offset: 0,
	  fullWidth: true,
	  defaultValue: '',
	  dataLabel: 'primaryText',
	  filter: Autocomplete.fuzzyFilter,
	  findInlineSuggestion: Autocomplete.findIgnoreCase,
	  autoComplete: 'off',
	  repositionOnScroll: true,
	  repositionOnResize: true,
	  inlineSuggestionPadding: 6
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._close = function (e) {
	    if (_this2.props.onBlur) {
	      _this2.props.onBlur(e);
	    }
	
	    _this2.setState({ visible: false });
	  };
	
	  this._handleChange = function (value, event) {
	    var _props2 = _this2.props,
	        onChange = _props2.onChange,
	        filter = _props2.filter,
	        findInlineSuggestion = _props2.findInlineSuggestion,
	        data = _props2.data,
	        dataLabel = _props2.dataLabel,
	        inline = _props2.inline;
	
	
	    if (onChange) {
	      onChange(value, event);
	    }
	
	    if (inline) {
	      // If findInlineSuggestion does not exist, assume that `onChange` will handle it.
	      return findInlineSuggestion ? _this2._findInlineSuggestions(value) : null;
	    }
	
	    var visible = _this2.state.visible;
	
	    var matches = value || !filter ? _this2.state.matches : [];
	    if (value && filter) {
	      matches = filter(data, value, dataLabel);
	    }
	
	    if (filter) {
	      visible = !!matches.length;
	    }
	
	    return _this2.setState({ matches: matches, visible: visible, value: value });
	  };
	
	  this._handleFocus = function (e) {
	    if (_this2.props.onFocus) {
	      _this2.props.onFocus(e);
	    }
	
	    var value = e.target.value;
	
	    if (_this2.props.inline && value) {
	      if (_this2.props.findInlineSuggestion) {
	        _this2._findInlineSuggestions(value);
	      }
	
	      return;
	    }
	
	    _this2.setState({
	      matchIndex: -1,
	      visible: !_this2.state.manualFocus && !!value && !!_this2.state.matches.length,
	      manualFocus: false,
	      focus: true
	    });
	  };
	
	  this._handleBlur = function (e) {
	    if (_this2.props.inline || !_this2.state.matches.length) {
	      if (_this2.props.onBlur) {
	        _this2.props.onBlur(e);
	      }
	    }
	
	    _this2.setState({ focus: false });
	  };
	
	  this._handleInlineAutocomplete = function () {
	    var _state3 = _this2.state,
	        suggestionIndex = _state3.suggestionIndex,
	        matches = _state3.matches;
	
	    if (suggestionIndex === -1) {
	      return;
	    }
	
	    var _props3 = _this2.props,
	        data = _props3.data,
	        dataLabel = _props3.dataLabel,
	        dataValue = _props3.dataValue,
	        label = _props3.autocompleteWithLabel,
	        onAutocomplete = _props3.onAutocomplete;
	
	
	    var value = data[suggestionIndex];
	    if (onAutocomplete) {
	      var v = value;
	      if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	        if (!label) {
	          v = value[dataValue];
	        } else {
	          v = value[dataLabel];
	        }
	      }
	
	      onAutocomplete(v, suggestionIndex, matches);
	    }
	
	    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	      value = value[dataLabel];
	    }
	
	    _this2.setState({
	      value: value,
	      suggestion: '',
	      suggestionIndex: -1,
	      tabbed: true
	    });
	  };
	
	  this._handleTextFieldKeyDown = function (e) {
	    var _props4 = _this2.props,
	        inline = _props4.inline,
	        onKeyDown = _props4.onKeyDown;
	    var suggestionIndex = _this2.state.suggestionIndex;
	
	
	    var key = e.which || e.keyCode;
	    if (onKeyDown) {
	      onKeyDown(e);
	    }
	
	    if (inline && key === _keyCodes.TAB && suggestionIndex !== -1) {
	      // Autocomplete the text field
	      e.preventDefault();
	      _this2._handleInlineAutocomplete();
	    }
	  };
	
	  this._handleMenuKeyDown = function (e) {
	    var key = e.which || e.keyCode;
	    if (key === _keyCodes.TAB) {
	      if (_this2.props.onBlur) {
	        _this2.props.onBlur(e);
	      }
	
	      _this2.setState({ visible: false });
	    } else if (key === _keyCodes.UP || key === _keyCodes.DOWN) {
	      _this2._focusSuggestion(key === _keyCodes.UP, e);
	    }
	  };
	
	  this._handleClick = function (e) {
	    var target = e.target;
	    while (_this2._menu && _this2._menu.contains(target)) {
	      if (target.classList.contains('md-list-item')) {
	        var items = target.parentNode.querySelectorAll('.md-list-item');
	        items = Array.prototype.slice.call(items);
	
	        return _this2._handleItemClick(items.indexOf(target));
	      }
	
	      target = target.parentNode;
	    }
	
	    return null;
	  };
	
	  this._handleItemClick = function (index) {
	    if (index === -1) {
	      return;
	    }
	
	    var matches = _this2.state.matches;
	    var _props5 = _this2.props,
	        data = _props5.data,
	        dataLabel = _props5.dataLabel,
	        dataValue = _props5.dataValue,
	        filter = _props5.filter,
	        onAutocomplete = _props5.onAutocomplete,
	        clearOnAutocomplete = _props5.clearOnAutocomplete,
	        focusInputOnAutocomplete = _props5.focusInputOnAutocomplete,
	        label = _props5.autocompleteWithLabel;
	
	
	    var value = matches.filter(function (m) {
	      return !_react2.default.isValidElement(m);
	    })[index];
	    if (onAutocomplete) {
	      var v = value;
	      if ((typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object') {
	        if (!label) {
	          v = value[dataValue];
	        } else {
	          v = value[dataLabel];
	        }
	      }
	
	      onAutocomplete(v, index, matches);
	    }
	
	    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	      value = value[dataLabel];
	    }
	
	    value = clearOnAutocomplete ? '' : value;
	    var callback = void 0;
	    if (focusInputOnAutocomplete) {
	      callback = function callback() {
	        _this2._field.focus();
	      };
	    }
	
	    _this2.setState({
	      visible: false,
	      manualFocus: focusInputOnAutocomplete,
	      matches: filter ? filter(data, value, dataLabel) : matches,
	      value: value
	    }, callback);
	  };
	
	  this._focusSuggestion = function (negative, e) {
	    e.preventDefault();
	    var _state4 = _this2.state,
	        matchIndex = _state4.matchIndex,
	        matches = _state4.matches;
	
	    var l = matches.length;
	
	    var index = void 0;
	    if (negative && matchIndex === -1 || !negative && matchIndex >= l) {
	      return;
	    } else if (negative) {
	      index = matchIndex - 1;
	      if (index === -1) {
	        _this2._field.focus();
	      }
	    } else {
	      index = Math.min(l, matchIndex + 1);
	    }
	
	    if (index !== -1 && index !== matchIndex) {
	      var item = _this2._menu.querySelectorAll('.md-list-tile')[index];
	      if (item) {
	        item.focus();
	      }
	    }
	
	    _this2.setState({ matchIndex: index });
	  };
	
	  this._findInlineSuggestions = function (value) {
	    var _props6 = _this2.props,
	        data = _props6.data,
	        dataLabel = _props6.dataLabel,
	        findInlineSuggestion = _props6.findInlineSuggestion,
	        inlineSuggestionPadding = _props6.inlineSuggestionPadding;
	
	
	    var suggestion = findInlineSuggestion(data, value, dataLabel);
	    if ((typeof suggestion === 'undefined' ? 'undefined' : _typeof(suggestion)) === 'object') {
	      throw new Error('`findInlineSuggestion` should return a string or a number, but got an object.', suggestion);
	    }
	
	    var suggestionStyle = _this2.state.suggestionStyle;
	
	    var suggestionIndex = -1;
	    if (suggestion) {
	      // Find index of suggestion
	      data.some(function (datum, i) {
	        var d = (typeof dataum === 'undefined' ? 'undefined' : _typeof(dataum)) === 'object' ? datum[dataLabel] : datum;
	        if (d === suggestion) {
	          suggestionIndex = i;
	        }
	
	        return suggestionIndex !== -1;
	      });
	
	      // Strip already used letters
	      suggestion = suggestion.toString().substring(value.length, suggestion.length);
	
	      // Position the inline suggestion next to the text
	      var width = (0, _getTextWidth2.default)(value, _this2._field);
	      if (width !== null) {
	        width += inlineSuggestionPadding;
	      }
	
	      if (width !== null && (!suggestionStyle || suggestionStyle.left !== width)) {
	        suggestionStyle = { left: width };
	      }
	    }
	
	    _this2.setState({
	      value: value,
	      suggestion: suggestion,
	      suggestionIndex: suggestionIndex,
	      suggestionStyle: suggestionStyle,
	      tabbed: false,
	      focus: true
	    });
	  };
	
	  this._mapToListItem = function (match, i) {
	    if (_react2.default.isValidElement(match)) {
	      return match;
	    }
	
	    var _props7 = _this2.props,
	        dataLabel = _props7.dataLabel,
	        dataValue = _props7.dataValue,
	        deleteKeys = _props7.deleteKeys,
	        total = _props7.total,
	        offset = _props7.offset,
	        data = _props7.data;
	
	    var props = void 0;
	    switch (typeof match === 'undefined' ? 'undefined' : _typeof(match)) {
	      case 'string':
	      case 'number':
	        props = {
	          key: match,
	          primaryText: match
	        };
	        break;
	      default:
	        if (deleteKeys) {
	          props = (0, _omit2.default)(match, typeof deleteKeys === 'string' ? [deleteKeys] : deleteKeys);
	        } else {
	          props = match;
	        }
	
	        props = _extends({}, props, {
	          key: match.key || dataValue && match[dataValue] || match[dataLabel],
	          primaryText: match[dataLabel]
	        });
	    }
	
	    if (typeof total !== 'undefined' && data.length < total) {
	      props['aria-setsize'] = total;
	      props['aria-posinset'] = i + 1 + offset;
	    }
	
	    // Allows focus, but does not let tab focus. This is so up and down keys work.
	    return _react2.default.createElement(_ListItem2.default, _extends({ tabIndex: -1 }, props));
	  };
	
	  this._toggleMenu = function (e) {
	    if (_this2.props.onMouseDown) {
	      _this2.props.onMouseDown(e);
	    }
	
	    if (!_this2.props.inline && _this2.state.matches.length && (0, _getField2.default)(_this2.props, _this2.state, 'value')) {
	      _this2.setState({ visible: !_this2.state.visible });
	    }
	  };
	
	  this._handleTouchStart = function (e) {
	    var target = e.target;
	    var suggestion = _this2.state.suggestion;
	
	    if (target.classList.contains('md-autocomplete-suggestion') && suggestion) {
	      _this2._handleInlineAutocomplete();
	    }
	  };
	
	  this._setField = function (field) {
	    if (field) {
	      _this2._field = field.getField();
	    }
	  };
	
	  this._setMenu = function (menu) {
	    _this2._menu = (0, _reactDom.findDOMNode)(menu);
	  };
	};
	
	exports.default = Autocomplete;

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _isRequiredForA11y = __webpack_require__(16);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _themeColors = __webpack_require__(11);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The main use case of the `Badge` component is for notifications. It can
	 * however also place any content floating to whatever children are supplied.
	 */
	var Badge = function (_PureComponent) {
	  _inherits(Badge, _PureComponent);
	
	  function Badge(props) {
	    _classCallCheck(this, Badge);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));
	
	    var single = _this._isSingleChild(props);
	    _this.state = {
	      single: single,
	      element: single && (0, _react.isValidElement)(props.children),
	      count: _this._normalizeCount(props)
	    };
	    return _this;
	  }
	
	  Badge.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _props = this.props,
	        badgeContent = _props.badgeContent,
	        max = _props.max,
	        children = _props.children;
	
	    var nextState = void 0;
	    if (badgeContent !== nextProps.badgeContent || max !== nextProps.max) {
	      nextState = { count: this._normalizeCount(nextProps) };
	    }
	
	    if (children !== nextProps.children) {
	      nextState = nextState || {};
	      nextState.single = this._isSingleChild(nextProps);
	      nextState.element = nextState.single && (0, _react.isValidElement)(nextProps.children);
	    }
	
	    if (nextState) {
	      this.setState(nextState);
	    }
	  };
	
	  Badge.prototype._isSingleChild = function _isSingleChild(_ref) {
	    var children = _ref.children;
	
	    return _react.Children.count(children) === 1;
	  };
	
	  Badge.prototype._normalizeCount = function _normalizeCount(_ref2) {
	    var badgeContent = _ref2.badgeContent,
	        max = _ref2.max;
	
	    var count = void 0;
	    if (max) {
	      var n = parseInt(badgeContent, 10);
	      if (!Number.isNaN(n) && n.toString() === badgeContent.toString()) {
	        count = n > max ? max + '+' : n;
	      }
	    }
	
	    return count;
	  };
	
	  Badge.prototype.render = function render() {
	    var _state = this.state,
	        count = _state.count,
	        single = _state.single,
	        element = _state.element;
	
	    var _props2 = this.props,
	        className = _props2.className,
	        badgeStyle = _props2.badgeStyle,
	        badgeClassName = _props2.badgeClassName,
	        badgeContent = _props2.badgeContent,
	        Component = _props2.component,
	        children = _props2.children,
	        primary = _props2.primary,
	        secondary = _props2.secondary,
	        defaultTheme = _props2.default,
	        circular = _props2.circular,
	        badgeId = _props2.badgeId,
	        invisibleOnZero = _props2.invisibleOnZero,
	        max = _props2.max,
	        props = _objectWithoutProperties(_props2, ['className', 'badgeStyle', 'badgeClassName', 'badgeContent', 'component', 'children', 'primary', 'secondary', 'default', 'circular', 'badgeId', 'invisibleOnZero', 'max']);
	
	    var useCircular = typeof circular !== 'undefined' ? circular : typeof count !== 'undefined';
	    var content = children;
	    if (single && element) {
	      var c = _react.Children.only(content);
	      if (!c.props['aria-describedby']) {
	        content = (0, _react.cloneElement)(c, { 'aria-describedby': badgeId });
	      }
	    } else if (single && !element && !props['aria-describedby']) {
	      props['aria-describedby'] = badgeId;
	    }
	
	    var badge = _react2.default.createElement(
	      'span',
	      {
	        id: badgeId,
	        key: 'badge',
	        role: 'status',
	        style: badgeStyle,
	        className: (0, _classnames2.default)('md-badge', {
	          'md-badge--circular': useCircular,
	          'md-badge--default': defaultTheme
	        }, (0, _themeColors2.default)({
	          primary: primary,
	          secondary: secondary,
	          text: useCircular,
	          themeText: !primary && !secondary
	        }, badgeClassName))
	      },
	      count || badgeContent
	    );
	
	    return _react2.default.createElement(
	      Component,
	      _extends({}, props, {
	        className: (0, _classnames2.default)('md-badge-container md-inline-block', className)
	      }),
	      content,
	      invisibleOnZero && count === 0 ? null : badge
	    );
	  };
	
	  return Badge;
	}(_react.PureComponent);
	
	Badge.propTypes = {
	  /**
	   * An optional style to apply to the badge's container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the badge's container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the badge.
	   */
	  badgeStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the badge.
	   */
	  badgeClassName: _propTypes2.default.string,
	
	  /**
	   * The id to give the badge's content. This is required to help with the
	   * `aria-describedby` attribute that should be applied to one of the children.
	   *
	   * If there is only one child that is a valid React element, the `aria-describedby`
	   * will automatically be cloned into that child (so make sure your component passes
	   * that prop correctly).
	   *
	   * If there is only one child, but it is a string or number, the badge's container
	   * will be updated to include the `aria-describedby`.
	   *
	   * If there is more than child, you are required to add it to a child yourself.
	   */
	  badgeId: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * The content to display with the badge's content. The size of this
	   * element is determinate of the location of the content. You might have
	   * to update the positioning yourself.
	   */
	  children: _propTypes2.default.node.isRequired,
	
	  /**
	   * The component to render the badge as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	  /**
	   * The content to display in the badge. If the content is a number or a number string,
	   * the number will be normalized if `normalizeContent` is enabled.
	   */
	  badgeContent: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.node]).isRequired,
	
	  /**
	   * This will basically update the display value of the content to only be 2 digits. If
	   * a number is greater than 99, 99+ will be displayed instead. This is really just to
	   * keep the count inside the circular bubble.
	   */
	  max: _propTypes2.default.number,
	
	  /**
	   * Boolean if the primary color background should get applied to the badge's content.
	   */
	  primary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the secondary color background should get applied to the badge's content.
	   */
	  secondary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the default styles should be applied.
	   */
	  default: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the badge's content should appear in a circular container. If this is
	   * undefined, the content will be in a circular container if the badgeContent is a number.
	   */
	  circular: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the badge's notification should be invisible when the count is 0.
	   */
	  invisibleOnZero: _propTypes2.default.bool
	};
	Badge.defaultProps = {
	  max: 99,
	  component: 'div'
	};
	exports.default = Badge;

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(11);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _AccessibleFakeInkedButton = __webpack_require__(24);
	
	var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	var _Collapse = __webpack_require__(55);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _FontIcons = __webpack_require__(54);
	
	var _FontIcons2 = _interopRequireDefault(_FontIcons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `BottomNav` component is used for rendering the navigation tab/link in the `BottomNavigation`
	 * component.
	 */
	var BottomNav = function (_PureComponent) {
	  _inherits(BottomNav, _PureComponent);
	
	  function BottomNav() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BottomNav);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this._handleClick = function (e) {
	      var _this$props = _this.props,
	          onClick = _this$props.onClick,
	          onNavChange = _this$props.onNavChange,
	          index = _this$props.index;
	
	      if (onClick) {
	        onClick(index, e);
	      }
	
	      if (onNavChange) {
	        onNavChange(index, e);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BottomNav.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        fixed = _props.fixed,
	        className = _props.className,
	        colored = _props.colored,
	        animate = _props.animate,
	        iconClassName = _props.iconClassName,
	        iconChildren = _props.iconChildren,
	        index = _props.index,
	        propIcon = _props.icon,
	        propLabel = _props.label,
	        onClick = _props.onClick,
	        onNavChange = _props.onNavChange,
	        props = _objectWithoutProperties(_props, ['active', 'fixed', 'className', 'colored', 'animate', 'iconClassName', 'iconChildren', 'index', 'icon', 'label', 'onClick', 'onNavChange']);
	
	    var _props2 = this.props,
	        label = _props2.label,
	        icon = _props2.icon;
	
	    var labelClassName = (0, _classnames2.default)('md-bottom-nav-label', { 'md-bottom-nav-label--shifting-inactive': !active && !fixed });
	    if (_react.Children.count(label) === 1 && (0, _react.isValidElement)(label)) {
	      var labelEl = _react.Children.only(label);
	      label = (0, _react.cloneElement)(label, {
	        className: (0, _classnames2.default)(labelClassName, labelEl.props.className)
	      });
	    } else {
	      label = _react2.default.createElement(
	        'div',
	        { className: labelClassName },
	        label
	      );
	    }
	
	    if (!icon && (iconClassName || iconChildren)) {
	      // Deprecated
	      icon = _react2.default.createElement(
	        _FontIcons2.default,
	        { iconClassName: iconClassName, inherit: true },
	        iconChildren
	      );
	    } else if (icon) {
	      icon = _react2.default.cloneElement(icon, { inherit: true });
	    }
	
	    return _react2.default.createElement(
	      _AccessibleFakeInkedButton2.default,
	      _extends({}, props, {
	        onClick: this._handleClick,
	        className: (0, _classnames2.default)('md-bottom-nav', {
	          'md-bottom-nav--active': active,
	          'md-bottom-nav--fixed': fixed,
	          'md-bottom-nav--shifting': !fixed,
	          'md-bottom-nav--shifting-active': !fixed && active,
	          'md-bottom-nav--shifting-inactive': !fixed && !active
	        }, (0, _themeColors2.default)({ primary: !colored && active, text: !active && !colored }, className))
	      }),
	      icon,
	      _react2.default.createElement(
	        _Collapse2.default,
	        { collapsed: !fixed && !active, animate: animate },
	        label
	      )
	    );
	  };
	
	  return BottomNav;
	}(_react.PureComponent);
	
	BottomNav.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	  active: _propTypes2.default.bool,
	  fixed: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  index: _propTypes2.default.number.isRequired,
	  label: _propTypes2.default.node.isRequired,
	  colored: _propTypes2.default.bool,
	  iconChildren: _propTypes2.default.node,
	  iconClassName: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  onNavChange: _propTypes2.default.func,
	  role: _propTypes2.default.string,
	  animate: _propTypes2.default.bool,
	  icon: _propTypes2.default.element
	};
	BottomNav.defaultProps = {
	  component: 'a',
	  role: null
	};
	exports.default = BottomNav;

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(5);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _getField = __webpack_require__(8);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _controlled = __webpack_require__(15);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _touches = __webpack_require__(126);
	
	var _Portal = __webpack_require__(34);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Paper = __webpack_require__(37);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _BottomNav = __webpack_require__(838);
	
	var _BottomNav2 = _interopRequireDefault(_BottomNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `BottomNavigation` component is an alternative to the `NavigationDrawer` for handling navigation
	 * only on mobile devices.
	 */
	var BottomNavigation = function (_PureComponent) {
	  _inherits(BottomNavigation, _PureComponent);
	
	  function BottomNavigation(props) {
	    _classCallCheck(this, BottomNavigation);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var visible = typeof props.initiallyVisible === 'boolean' ? props.initiallyVisible : props.defaultVisible;
	    _this.state = {
	      visible: visible,
	      portalVisible: visible
	    };
	
	    if (typeof props.activeIndex === 'undefined') {
	      _this.state.activeIndex = props.defaultActiveIndex;
	    }
	    return _this;
	  }
	
	  BottomNavigation.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.dynamic) {
	      this._addTouchEvents();
	    }
	  };
	
	  BottomNavigation.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var dynamic = nextProps.dynamic;
	
	    if (this.props.dynamic === dynamic) {
	      return;
	    }
	
	    if (dynamic) {
	      this._addTouchEvents();
	    } else {
	      this._removeTouchEvents();
	    }
	  };
	
	  BottomNavigation.prototype.componentWillUpdate = function componentWillUpdate(nextProps, nextState) {
	    if (this.state.visible !== nextState.visible && nextProps.onVisibilityChange) {
	      nextProps.onVisibilityChange(nextState.visible);
	    }
	  };
	
	  BottomNavigation.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.props.dynamic) {
	      this._removeTouchEvents();
	    }
	
	    if (this._timeout) {
	      clearTimeout(this._timeout);
	    }
	  };
	
	  BottomNavigation.prototype.render = function render() {
	    var _this2 = this;
	
	    var _state = this.state,
	        visible = _state.visible,
	        portalVisible = _state.portalVisible;
	
	    var _props = this.props,
	        className = _props.className,
	        actions = _props.actions,
	        colored = _props.colored,
	        dynamic = _props.dynamic,
	        lastChild = _props.lastChild,
	        animate = _props.animate,
	        portal = _props.portal,
	        propLinks = _props.links,
	        propActiveIndex = _props.activeIndex,
	        propRenderNode = _props.renderNode,
	        onNavChange = _props.onNavChange,
	        onVisibilityChange = _props.onVisibilityChange,
	        defaultVisible = _props.defaultVisible,
	        defaultActiveIndex = _props.defaultActiveIndex,
	        dynamicThreshold = _props.dynamicThreshold,
	        transitionDuration = _props.transitionDuration,
	        onChange = _props.onChange,
	        initiallyVisible = _props.initiallyVisible,
	        containerStyle = _props.containerStyle,
	        containerClassName = _props.containerClassName,
	        transitionName = _props.transitionName,
	        transitionEnterTimeout = _props.transitionEnterTimeout,
	        transitionLeaveTimeout = _props.transitionLeaveTimeout,
	        props = _objectWithoutProperties(_props, ['className', 'actions', 'colored', 'dynamic', 'lastChild', 'animate', 'portal', 'links', 'activeIndex', 'renderNode', 'onNavChange', 'onVisibilityChange', 'defaultVisible', 'defaultActiveIndex', 'dynamicThreshold', 'transitionDuration', 'onChange', 'initiallyVisible', 'containerStyle', 'containerClassName', 'transitionName', 'transitionEnterTimeout', 'transitionLeaveTimeout']);
	
	    var links = this.props.links;
	
	    if (actions) {
	      links = actions;
	    }
	
	    var fixed = links.length === 3;
	    var activeIndex = (0, _getField2.default)(this.props, this.state, 'activeIndex');
	    var renderNode = (0, _getField2.default)(this.props, this.context, 'renderNode');
	    var navigation = _react2.default.createElement(
	      _Paper2.default,
	      _extends({}, props, {
	        key: 'navigation',
	        className: (0, _classnames2.default)('md-bottom-navigation', {
	          'md-background--card': !colored,
	          'md-background--primary': colored,
	          'md-bottom-navigation--dynamic': dynamic,
	          'md-bottom-navigation--dynamic-inactive': dynamic && !visible
	        }, className),
	        role: 'navigation'
	      }),
	      links.map(function (action, index) {
	        return _react2.default.createElement(_BottomNav2.default, _extends({}, action, {
	          animate: animate,
	          key: action.key || index,
	          index: index,
	          onNavChange: _this2._handleNavChange,
	          active: activeIndex === index,
	          colored: colored,
	          fixed: fixed
	        }));
	      })
	    );
	
	    if (!portal) {
	      return portalVisible ? navigation : null;
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      { renderNode: renderNode, visible: portalVisible, lastChild: lastChild },
	      navigation
	    );
	  };
	
	  return BottomNavigation;
	}(_react.PureComponent);
	
	BottomNavigation.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * A list of objects to generate a bottom navigation link. There must be at least 3 and no more
	   * than 5 links. A link gets rendered as the `AccessibleFakeButton` component, so any additional
	   * props in the link's shape will be passed along.
	   *
	   * ```docgen
	   * PropTypes.arrayOf(PropTypes.shape({
	   *   label: PropTypes.node.isRequired,
	   *   icon: PropTypes.element,
	   *   component: PropTypes.oneOfType([
	   *      PropTypes.func,
	   *      PropTypes.string,
	   *   ]),
	   * }).isRequired
	   * ```
	   */
	  links: function links(props, propName, component) {
	    for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      args[_key - 3] = arguments[_key];
	    }
	
	    var _PropTypes$arrayOf;
	
	    var links = props[propName] || props.actions;
	    var len = links.length;
	
	    if (len < 3) {
	      return new Error('Only ' + len + ' `' + propName + '` were given to the ' + component + '. At least 3 are required.');
	    } else if (len > 5) {
	      return new Error(len + ' `' + propName + '` were given to the ' + component + '. No more than 5 may be given.');
	    }
	
	    return (_PropTypes$arrayOf = _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      label: _propTypes2.default.node.isRequired,
	      icon: _propTypes2.default.element,
	      iconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `icon` instead'),
	      iconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `icon` instead'),
	      component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string])
	    }))).isRequired.apply(_PropTypes$arrayOf, [props, propName, component].concat(args));
	  },
	
	  /**
	   * Boolean if the bottom navigation should be colored with the primary color or whatever color
	   * was a result of the `react-md-theme-bottom-navigations-colored` mixin.
	   */
	  colored: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the bottom navigation should dynamically appear based on scrolling. When the user
	   * scrolls the `dynamicThreshold` amount, this component will either disappear (scrolling down)
	   * or appear (scrolling up).
	   */
	  dynamic: _propTypes2.default.bool,
	
	  /**
	   * The distance a user must scroll before the bottom navigation appears or disappears when it is `dynamic`.
	   */
	  dynamicThreshold: _propTypes2.default.number.isRequired,
	
	  /**
	   * An optional function to call when a link has been clicked. The callback will
	   * include the new active index and the click event.
	   *
	   * ```js
	   * onNavChange(newActiveIndex, event);
	   * ```
	   */
	  onNavChange: _propTypes2.default.func,
	
	  /**
	   * An optional active index to use. This will make the component controlled and require the
	   * `onNavChange` prop to be defined.
	   */
	  activeIndex: (0, _controlled2.default)(_propTypes2.default.number, 'onNavChange', 'defaultActiveIndex'),
	
	  /**
	   * The index for the link that is active by default.
	   */
	  defaultActiveIndex: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the bottom navigation is visible by default. This *should* probably always
	   * be true.
	   */
	  defaultVisible: _propTypes2.default.bool.isRequired,
	
	  /**
	   * The component to render the bottom navigation as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * Boolean if the Portal's functionality of rendering in a separate react tree should be applied
	   * to the bottom navigation.
	   *
	   * @see {@link Helpers/Portal}
	   */
	  portal: _propTypes2.default.bool,
	
	  /**
	   * Since the `BottomNavigation` component uses the `Portal` component, you can pass an optional
	   * HTML Node to render in.
	   */
	  renderNode: _propTypes2.default.object,
	
	  /**
	   * Boolean if the bottom navigation should render as the last child in the `renderNode` or `body`
	   * instead of as the first.
	   */
	  lastChild: _propTypes2.default.bool,
	
	  /**
	   * The transition duration for the dynamic bottom navigation to appear or disappear. This should
	   * match the `$md-bottom-navigation-transition-time` variable.
	   */
	  transitionDuration: _propTypes2.default.number.isRequired,
	
	  /**
	   * An optional function to call when the visibility of the bottom navigation changes. The callback
	   * will include the new visibility.
	   *
	   * ```js
	   * onVisibilityChange(!visible);
	   * ```
	   */
	  onVisibilityChange: _propTypes2.default.func,
	
	  /**
	   * Boolean if the label on a shifting navigation should animate in and out.
	   */
	  animate: _propTypes2.default.bool,
	
	  onChange: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `onNavChange` instead'),
	  initiallyVisible: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `defaultVisible` instead'),
	  initialActiveIndex: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `defaultActiveIndex` instead'),
	  containerStyle: (0, _deprecated2.default)(_propTypes2.default.object, 'Use `style` instead'),
	  containerClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `className` instead'),
	  transitionName: (0, _deprecated2.default)(_propTypes2.default.string, 'There is no CSSTransitionGroup used anymore'),
	  transitionEnterTimeout: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `transitionDuration` instead'),
	  transitionLeaveTimeout: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `transitionDuration` instead'),
	  actions: (0, _deprecated2.default)(_propTypes2.default.array, 'Use `links` instead')
	};
	BottomNavigation.defaultProps = {
	  animate: true,
	  defaultActiveIndex: 0,
	  component: 'footer',
	  defaultVisible: true,
	  transitionDuration: 300,
	  portal: false,
	  dynamicThreshold: 5
	};
	BottomNavigation.contextTypes = {
	  renderNode: _propTypes2.default.object
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this._addTouchEvents = function () {
	    (0, _touches.addTouchEvent)(window, 'start', _this3._handleTouchStart);
	    (0, _touches.addTouchEvent)(window, 'move', _this3._handleTouchMove);
	    (0, _touches.addTouchEvent)(window, 'end', _this3._handleTouchEnd);
	  };
	
	  this._removeTouchEvents = function () {
	    (0, _touches.removeTouchEvent)(window, 'start', _this3._handleTouchStart);
	    (0, _touches.removeTouchEvent)(window, 'move', _this3._handleTouchMove);
	    (0, _touches.removeTouchEvent)(window, 'end', _this3._handleTouchEnd);
	  };
	
	  this._animateIn = function () {
	    if (_this3._timeout) {
	      clearTimeout(_this3._timeout);
	    }
	
	    _this3._timeout = setTimeout(function () {
	      _this3._timeout = null;
	      _this3.setState({ visible: true });
	    }, 17);
	
	    _this3.setState({ portalVisible: true });
	  };
	
	  this._animateOut = function () {
	    if (_this3._timeout) {
	      clearTimeout(_this3._timeout);
	    }
	
	    _this3._timeout = setTimeout(function () {
	      _this3._timeout = null;
	      _this3.setState({ portalVisible: false });
	    }, _this3.props.transitionDuration);
	
	    _this3.setState({ visible: false });
	  };
	
	  this._handleTouchStart = function (e) {
	    var pageY = e.changedTouches[0].pageY;
	
	
	    _this3._pageY = pageY;
	    _this3._scrolling = true;
	  };
	
	  this._handleTouchMove = function (e) {
	    var visible = _this3.state.visible;
	
	    if (!_this3._scrolling) {
	      return;
	    }
	
	    var touchY = e.changedTouches[0].pageY;
	    var dynamicThreshold = _this3.props.dynamicThreshold;
	
	    var passedThreshold = Math.abs(_this3._pageY - touchY) >= dynamicThreshold;
	    if (_this3._pageY > touchY && visible && passedThreshold) {
	      _this3._pageY = touchY;
	      _this3._animateOut();
	    } else if (_this3._pageY < touchY && !visible && passedThreshold) {
	      _this3._pageY = touchY;
	      _this3._animateIn();
	    }
	  };
	
	  this._handleTouchEnd = function () {
	    _this3._scrolling = false;
	  };
	
	  this._handleNavChange = function (index, e) {
	    if (_this3.props.onNavChange || _this3.props.onChange) {
	      (_this3.props.onNavChange || _this3.props.onChange)(index, e);
	    }
	
	    if (typeof _this3.props.activeIndex === 'undefined') {
	      _this3.setState({ activeIndex: index });
	    }
	  };
	};
	
	exports.default = BottomNavigation;

/***/ }),
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(5);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _requiredForA11yIfNot = __webpack_require__(930);
	
	var _requiredForA11yIfNot2 = _interopRequireDefault(_requiredForA11yIfNot);
	
	var _invalidIf = __webpack_require__(43);
	
	var _invalidIf2 = _interopRequireDefault(_invalidIf);
	
	var _FontIcon = __webpack_require__(12);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _getDeprecatedIcon = __webpack_require__(21);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _contextTypes = __webpack_require__(163);
	
	var _contextTypes2 = _interopRequireDefault(_contextTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `DataTable` component is used to manage the state of all rows.
	 * This can either be a __plain__ table or a __data__ table.
	 *
	 * A __data__ table will include checkboxes on each row while a __plain__ table
	 * will not.
	 */
	var DataTable = function (_PureComponent) {
	  _inherits(DataTable, _PureComponent);
	
	  function DataTable(props) {
	    _classCallCheck(this, DataTable);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this));
	
	    _initialiseProps.call(_this);
	
	    var rows = props.defaultSelectedRows;
	    _this.state = {
	      header: false,
	      indeterminate: props.indeterminate ? false : undefined,
	      allSelected: _this._allSelected(rows),
	      selectedRows: rows
	    };
	
	    _this._removed = 0;
	    _this._initial = true;
	    return _this;
	  }
	
	  DataTable.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        checkedIcon = _props.checkedIcon,
	        uncheckedIcon = _props.uncheckedIcon,
	        indeterminateIcon = _props.indeterminateIcon,
	        plain = _props.plain,
	        baseId = _props.baseId,
	        selectableRows = _props.selectableRows,
	        checkboxHeaderLabel = _props.checkboxHeaderLabel,
	        checkboxLabelTemplate = _props.checkboxLabelTemplate,
	        fixedHeader = _props.fixedHeader,
	        fixedFooter = _props.fixedFooter,
	        checkedIconChildren = _props.checkedIconChildren,
	        checkedIconClassName = _props.checkedIconClassName,
	        uncheckedIconChildren = _props.uncheckedIconChildren,
	        uncheckedIconClassName = _props.uncheckedIconClassName,
	        indeterminateIconChildren = _props.indeterminateIconChildren,
	        indeterminateIconClassName = _props.indeterminateIconClassName;
	
	
	    return {
	      checkedIcon: (0, _getDeprecatedIcon2.default)(checkedIconClassName, checkedIconChildren, checkedIcon),
	      uncheckedIcon: (0, _getDeprecatedIcon2.default)(uncheckedIconClassName, uncheckedIconChildren, uncheckedIcon),
	      indeterminateIcon: (0, _getDeprecatedIcon2.default)(indeterminateIconClassName, indeterminateIconChildren, indeterminateIcon),
	      indeterminate: this.state.indeterminate,
	      plain: plain,
	      allSelected: this.state.allSelected,
	      selectedRows: this.state.selectedRows,
	      toggleSelectedRow: this._toggleSelectedRow,
	      createCheckbox: this._createCheckbox,
	      removeCheckbox: this._removeCheckbox,
	      baseId: baseId,
	      baseName: baseId + '-control',
	      selectableRows: selectableRows,
	      checkboxHeaderLabel: checkboxHeaderLabel,
	      checkboxLabelTemplate: checkboxLabelTemplate,
	      fixedHeader: fixedHeader,
	      fixedFooter: fixedFooter
	    };
	  };
	
	  DataTable.prototype.componentDidUpdate = function componentDidUpdate() {
	    this._removed = 0;
	    this._initial = false;
	  };
	
	  DataTable.prototype._allSelected = function _allSelected(rows) {
	    var all = rows.length !== 0;
	    rows.some(function (checked) {
	      if (!checked) {
	        all = false;
	      }
	
	      return !all;
	    });
	
	    return all;
	  };
	
	  DataTable.prototype.render = function render() {
	    var _cn;
	
	    var _props2 = this.props,
	        style = _props2.style,
	        className = _props2.className,
	        tableStyle = _props2.tableStyle,
	        tableClassName = _props2.tableClassName,
	        fixedWrapperStyle = _props2.fixedWrapperStyle,
	        fixedWrapperClassName = _props2.fixedWrapperClassName,
	        fixedScrollWrapperStyle = _props2.fixedScrollWrapperStyle,
	        fixedScrollWrapperClassName = _props2.fixedScrollWrapperClassName,
	        children = _props2.children,
	        plain = _props2.plain,
	        responsive = _props2.responsive,
	        fixedHeader = _props2.fixedHeader,
	        fixedFooter = _props2.fixedFooter,
	        fixedDividers = _props2.fixedDividers,
	        fixedHeight = _props2.fixedHeight,
	        fixedWidth = _props2.fixedWidth,
	        headerHeight = _props2.headerHeight,
	        footerHeight = _props2.footerHeight,
	        fullWidth = _props2.fullWidth,
	        indeterminate = _props2.indeterminate,
	        indeterminateIcon = _props2.indeterminateIcon,
	        checkedIcon = _props2.checkedIcon,
	        uncheckedIcon = _props2.uncheckedIcon,
	        defaultSelectedRows = _props2.defaultSelectedRows,
	        baseId = _props2.baseId,
	        onRowToggle = _props2.onRowToggle,
	        selectableRows = _props2.selectableRows,
	        checkboxHeaderLabel = _props2.checkboxHeaderLabel,
	        checkboxLabelTemplate = _props2.checkboxLabelTemplate,
	        checkedIconChildren = _props2.checkedIconChildren,
	        checkedIconClassName = _props2.checkedIconClassName,
	        uncheckedIconChildren = _props2.uncheckedIconChildren,
	        uncheckedIconClassName = _props2.uncheckedIconClassName,
	        indeterminateIconChildren = _props2.indeterminateIconChildren,
	        indeterminateIconClassName = _props2.indeterminateIconClassName,
	        props = _objectWithoutProperties(_props2, ['style', 'className', 'tableStyle', 'tableClassName', 'fixedWrapperStyle', 'fixedWrapperClassName', 'fixedScrollWrapperStyle', 'fixedScrollWrapperClassName', 'children', 'plain', 'responsive', 'fixedHeader', 'fixedFooter', 'fixedDividers', 'fixedHeight', 'fixedWidth', 'headerHeight', 'footerHeight', 'fullWidth', 'indeterminate', 'indeterminateIcon', 'checkedIcon', 'uncheckedIcon', 'defaultSelectedRows', 'baseId', 'onRowToggle', 'selectableRows', 'checkboxHeaderLabel', 'checkboxLabelTemplate', 'checkedIconChildren', 'checkedIconClassName', 'uncheckedIconChildren', 'uncheckedIconClassName', 'indeterminateIconChildren', 'indeterminateIconClassName']);
	
	    var table = _react2.default.createElement(
	      'table',
	      _extends({}, props, {
	        ref: this._setTable,
	        style: responsive ? tableStyle : style,
	        className: (0, _classnames2.default)('md-data-table', (_cn = {
	          'md-data-table--plain': plain,
	          'md-data-table--full-width': fullWidth
	        }, _cn[className] = !responsive && className, _cn[tableClassName] = responsive && tableClassName, _cn))
	      }),
	      children
	    );
	
	    if (!responsive) {
	      return table;
	    }
	
	    var content = table;
	    if (fixedHeader || fixedFooter) {
	      var height = fixedHeight;
	      if (fixedHeight) {
	        if (fixedHeader) {
	          height -= headerHeight;
	        }
	
	        if (fixedFooter) {
	          height -= footerHeight;
	        }
	      }
	
	      var borderTop = fixedHeader;
	      var borderBot = fixedFooter;
	      if (typeof fixedDividers === 'boolean') {
	        borderTop = borderTop && fixedDividers;
	        borderBot = borderBot && fixedDividers;
	      } else {
	        borderTop = borderTop && (typeof fixedDividers.header === 'undefined' || fixedDividers.header);
	        borderBot = borderBot && (typeof fixedDividers.footer === 'undefined' || fixedDividers.footer);
	      }
	
	      content = _react2.default.createElement(
	        'div',
	        {
	          style: fixedWrapperStyle,
	          className: (0, _classnames2.default)('md-data-table__fixed-wrapper', {
	            'md-data-table__fixed-wrapper--header': fixedHeader,
	            'md-data-table__fixed-wrapper--footer': fixedFooter
	          }, fixedWrapperClassName)
	        },
	        _react2.default.createElement(
	          'div',
	          {
	            style: _extends({ height: height }, fixedScrollWrapperStyle),
	            className: (0, _classnames2.default)('md-data-table__scroll-wrapper', {
	              'md-divider-border': fixedDividers,
	              'md-divider-border--top': borderTop,
	              'md-divider-border--bottom': borderBot
	            }, fixedScrollWrapperClassName)
	          },
	          table
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      'div',
	      {
	        style: _extends({ width: fixedWidth }, style),
	        className: (0, _classnames2.default)('md-data-table--responsive', {
	          'md-data-table--fixed': fixedHeader || fixedFooter
	        }, className)
	      },
	      content
	    );
	  };
	
	  return DataTable;
	}(_react.PureComponent);
	
	DataTable.propTypes = {
	  /**
	   * A base id to use for every checkbox or `EditDialogColumn` in the data table. This is
	   * required for a11y if the data table is not plain. It is recommended to always provide
	   * this prop if you are using any of the advanced table components to auto-generate unique
	   * ids for each element.
	   *
	   * @see {@link DataTables/EditDialogColumn}
	   * @see {@link DataTables/SelectFieldColumn}
	   * @see {@link DataTables/DropdownMenuColumn}
	   * @see {@link DataTables/MenuButtonColumn}
	   * @see {@link DataTables/TablePagination}
	   */
	  baseId: (0, _requiredForA11yIfNot2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]), 'plain'),
	
	  /**
	   * Optional style to apply to the table. If the table is `responsive`, this will be applied to the surrounding `div`
	   * instead of the table itself. Use the `tableStyle` in this case.
	   *
	   * @see {@link #tableStyle}
	   * @see {@link #responsive}
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the table. If the table is `responsive`, this will be applied to the
	   * surrounding `div` instead of the table itself. Use the `tableClassName` in this case.
	   *
	   * @see {@link #tableClassName}
	   * @see {@link #responsive}
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the `table` itself when the `responsive` prop is enabled. If the table is not
	   * `responsive`, use the `style` prop.
	   *
	   * @see {@link #style}
	   * @see {@link #responsive}
	   */
	  tableStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `table` itself when the `responsive` prop is enabled. If the table is not
	   * `responsive`, use the `className` prop.
	   *
	   * @see {@link #className}
	   * @see {@link #responsive}
	   */
	  tableClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the fixed table wrapper that appears when there is a fixed
	   * header or a fixed footer.
	   *
	   * @see {@link #fixedHeader}
	   * @see {@link #fixedFooter}
	   * @see {@link #fixedWrapperClassName}
	   * @see {@link #fixedScrollWrapperStyle}
	   * @see {@link #fixedScrollWrapperClassName}
	   */
	  fixedWrapperStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the fixed table wrapper that appears when there is a fixed
	   * header or a fixed footer.
	   *
	   * @see {@link #fixedHeader}
	   * @see {@link #fixedFooter}
	   * @see {@link #fixedWrapperStyle}
	   * @see {@link #fixedScrollWrapperStyle}
	   * @see {@link #fixedScrollWrapperClassName}
	   */
	  fixedWrapperClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the fixed table wrapper's scroll container that appears when there is a fixed
	   * header or a fixed footer.
	   *
	   * @see {@link #fixedHeader}
	   * @see {@link #fixedFooter}
	   * @see {@link #fixedWrapperStyle}
	   * @see {@link #fixedWrapperClassName}
	   * @see {@link #fixedScrollWrapperStyle}
	   */
	  fixedScrollWrapperStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the fixed table wrapper's scroll container that appears when there is a fixed
	   * header or a fixed footer.
	   *
	   * @see {@link #fixedHeader}
	   * @see {@link #fixedFooter}
	   * @see {@link #fixedWrapperStyle}
	   * @see {@link #fixedWrapperClassName}
	   * @see {@link #fixedScrollWrapperStyle}
	   */
	  fixedScrollWrapperClassName: _propTypes2.default.string,
	
	  /**
	   * The table contents to display. This *should* be a list of `TableHeader` and `TableBody`
	   * components.
	   */
	  children: _propTypes2.default.node.isRequired,
	
	  /**
	   * An optional array of booleans denoting if a row is selected.
	   * This is an associative array so the index must match the row
	   * number in the `TableBody` component.
	   */
	  defaultSelectedRows: _propTypes2.default.arrayOf(_propTypes2.default.bool).isRequired,
	
	  /**
	   * Boolean if the table is responsive. This will wrap the table in a container
	   * that allows scrolling to the right if overflow exists.
	   */
	  responsive: _propTypes2.default.bool.isRequired,
	
	  /**
	   * Boolean if this table should not include the checkboxes on each row.
	   * This really means that the entire table is unselectable and you wish
	   * to display as a normal table.
	   */
	  plain: _propTypes2.default.bool,
	
	  /**
	   * The checked checkbox icon to display when a row is selected. This really defaults
	   * to the `checkedCheckboxIcon` prop from the `SelectionControl`.
	   *
	   * @see {@link SelectionControls/SelectionControl#checkedCheckboxIcon}
	   */
	  checkedIcon: _propTypes2.default.element,
	
	  /**
	   * The unchecked checkbox icon to display when a row is selected. This really defaults
	   * to the `uncheckedCheckboxIcon` prop from the `SelectionControl`.
	   *
	   * @see {@link SelectionControls/SelectionControl#uncheckedCheckboxIcon}
	   */
	  uncheckedIcon: _propTypes2.default.element,
	
	  /**
	   * An optional function to call when a non-plain data table has a row toggled. The callback
	   * will include:
	   * - the row id
	   * - boolean if the row is now checked
	   * - the total count of rows selected
	   * - the change event
	   *
	   * All rows will be toggled on or off when the row id is 0 and a `thead` exists in the table.
	   */
	  onRowToggle: (0, _invalidIf2.default)(_propTypes2.default.func, 'plain'),
	
	  /**
	   * Boolean if the `DataTable` should inject checkboxes at the start of each row.
	   */
	  selectableRows: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the checkboxes in the table should also include an _indeterminate_ state.
	   * It will use the `indeterminateIconChildren` and `indeterminateIconClassName` when at least
	   * 1 row has been checked, but not all rows.
	   */
	  indeterminate: _propTypes2.default.bool,
	
	  /**
	   * An optional icon to display when the selected state is indeterminate.
	   *
	   * @see {@link #indeterminate}
	   */
	  indeterminateIcon: _propTypes2.default.element,
	
	  /**
	   * This is the aria-label to apply to the checkbox in the table's header. This
	   * is just used for accessibility since the checkboxes have no visible label.
	   */
	  checkboxHeaderLabel: _propTypes2.default.string.isRequired,
	
	  /**
	   * This is the aria-label to apply to a checkbox in the table's body. This can either
	   * be a constant string that will replace `{{row}}` with the current row index, or
	   * a function that takes the row index and returns a string.
	   *
	   * ```js
	   * checkboxLabelTemplate={rowIndex => `Toggle row ${row}`}
	   * ```
	   */
	  checkboxLabelTemplate: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * Boolean if the table should include a fixed header. This will allow the `TableHeader` component
	   * to stay fixed to the top of the table while the `TableBody` scrolls horizontally.
	   *
	   * @see {@link #fixedFooter}
	   * @see [react-md-make-fixed-table](/components/data-tables?tab=2#mixin-react-md-make-fixed-table)
	   */
	  fixedHeader: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the table should include a fixed footer. This will allow the `TableFooter` component
	   * to stay fixed to the bottom of the table while the `TableBody` scrolls horizontally.
	   *
	   * @see {@link #fixedHeader}
	   * @see [react-md-make-fixed-table](/components/data-tables?tab=2#mixin-react-md-make-fixed-table)
	   */
	  fixedFooter: _propTypes2.default.bool,
	
	  /**
	   * Either a boolean or a shape of booleans for if a divider should appear at the top or bottom of the table
	   * when there is a fixed header/footer. By default, this will automatically create dividers.
	   *
	   * @see {@link #fixedHeader}
	   * @see {@link #fixedFooter}
	   */
	  fixedDividers: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
	    header: _propTypes2.default.bool,
	    footer: _propTypes2.default.bool
	  })]),
	
	  /**
	   * An optional height to set for a table with a fixed header and/or a fixed footer. It is recommended to use
	   * the related `react-md-make-fixed-table` mixin instead.
	   *
	   * @see {@link #headerHeight}
	   * @see {@link #footerHeight}
	   */
	  fixedHeight: _propTypes2.default.number,
	
	  /**
	   * An optional width to set for a table with a fixed header and/or a fixed footer. It is recommended to use
	   * the related `react-md-make-fixed-table` mixin instead.
	   */
	  fixedWidth: _propTypes2.default.number,
	
	  /**
	   * This is the height of the table's header columns. This should be equal to the `md-data-table-header-height`
	   * variable.
	   *
	   * @see [md-data-table-header-height](/components/data-tables?tab=2#variable-md-data-table-header-height)
	   * @see {@link #fixedHeight}
	   */
	  headerHeight: _propTypes2.default.number.isRequired,
	
	  /**
	   * This is the height of the table's header columns. This should be equal to the `md-data-table-header-height`
	   * variable.
	   *
	   * @see [md-data-table-column-height](/components/data-tables?tab=2#variable-md-data-table-column-height)
	   * @see {@link #fixedHeight}
	   */
	  footerHeight: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the `<table>` element should always span the entire width of its container.
	   */
	  fullWidth: _propTypes2.default.bool,
	
	  indeterminateIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `indeterminateIcon` prop instead'),
	  indeterminateIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `indeterminateIcon` prop instead'),
	  checkedIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `checkedIcon` prop instead'),
	  checkedIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `checkedIcon` prop instead'),
	  uncheckedIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `uncheckedIcon` prop instead'),
	  uncheckedIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `uncheckedIcon` prop instead')
	};
	DataTable.defaultProps = {
	  indeterminateIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'indeterminate_check_box'
	  ),
	  defaultSelectedRows: [],
	  responsive: true,
	  selectableRows: true,
	  checkboxHeaderLabel: 'Toggle All Rows',
	  checkboxLabelTemplate: 'Toggle row {{row}}',
	  fixedHeader: false,
	  fixedFooter: false,
	  fixedDividers: true,
	  headerHeight: 56,
	  footerHeight: 48,
	  fullWidth: true
	};
	DataTable.childContextTypes = _contextTypes2.default;
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._setTable = function (table) {
	    _this2._table = table;
	  };
	
	  this._createCheckbox = function (index) {
	    _this2.setState(function (state, props) {
	      var selectedRows = state.selectedRows.slice();
	      // Only use the default selected rows prop on first mount. If other changes occur after,
	      // default to false.
	      var selected = _this2._initial && props.defaultSelectedRows[index] || false;
	      selectedRows.splice(index, 0, selected);
	      return { selectedRows: selectedRows, allSelected: _this2._allSelected(selectedRows) };
	    });
	  };
	
	  this._removeCheckbox = function (index) {
	    _this2.setState(function (state) {
	      // When multiple checkboxes are removed in a render cycle, they are removed in list order.
	      // So to keep the index correct while removing, need to keep subtract the provided index by
	      // the current number of removed elements. This value gets reset to 0 after a finished cycle.
	      var selectedRows = state.selectedRows.slice();
	
	      // This is really ugly. React 16 doesn't need to track all this while React 15 does
	      if (_react2.default.version && _react2.default.version.match(/^16\./)) {
	        selectedRows.splice(index, 1);
	      } else {
	        selectedRows.splice(index - _this2._removed, 1);
	        _this2._removed += 1;
	      }
	      return { selectedRows: selectedRows, allSelected: _this2._allSelected(selectedRows) };
	    });
	  };
	
	  this._toggleSelectedRow = function (row, header, e) {
	    var selectedRows = void 0;
	    var allSelected = _this2.state.allSelected;
	    var selectedCount = 0;
	    var i = _this2._table && _this2._table.querySelector('.md-table-header') ? row - 1 : row;
	    var checked = e.target.checked;
	
	    if (header) {
	      selectedRows = _this2.state.selectedRows.map(function () {
	        return checked;
	      });
	      allSelected = checked;
	      selectedCount = !checked ? 0 : selectedRows.length;
	    } else {
	      selectedRows = _this2.state.selectedRows.slice();
	      selectedRows[i] = !selectedRows[i];
	      selectedCount = selectedRows.filter(function (b) {
	        return b;
	      }).length;
	      allSelected = selectedCount === selectedRows.length;
	    }
	
	    if (_this2.props.onRowToggle) {
	      _this2.props.onRowToggle(row, checked, selectedCount, e);
	    }
	
	    var indeterminate = _this2.props.indeterminate && !allSelected && selectedCount > 0;
	
	    _this2.setState({ selectedRows: selectedRows, allSelected: allSelected, indeterminate: indeterminate });
	  };
	};
	
	exports.default = DataTable;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _fixedToShape = __webpack_require__(19);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _withTableFixes = __webpack_require__(233);
	
	var _withTableFixes2 = _interopRequireDefault(_withTableFixes);
	
	var _DropdownMenu = __webpack_require__(237);
	
	var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);
	
	var _TableColumn = __webpack_require__(82);
	
	var _TableColumn2 = _interopRequireDefault(_TableColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DropdownMenuColumn = function (_PureComponent) {
	  _inherits(DropdownMenuColumn, _PureComponent);
	
	  function DropdownMenuColumn() {
	    _classCallCheck(this, DropdownMenuColumn);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  DropdownMenuColumn.prototype.render = function render() {
	    var _props = this.props,
	        style = _props.style,
	        className = _props.className,
	        menuStyle = _props.menuStyle,
	        menuClassName = _props.menuClassName,
	        header = _props.header,
	        adjusted = _props.adjusted,
	        tooltipLabel = _props.tooltipLabel,
	        tooltipDelay = _props.tooltipDelay,
	        tooltipPosition = _props.tooltipPosition,
	        props = _objectWithoutProperties(_props, ['style', 'className', 'menuStyle', 'menuClassName', 'header', 'adjusted', 'tooltipLabel', 'tooltipDelay', 'tooltipPosition']);
	
	    return _react2.default.createElement(
	      _TableColumn2.default,
	      {
	        style: style,
	        className: className,
	        header: header,
	        adjusted: adjusted,
	        tooltipLabel: tooltipLabel,
	        tooltipDelay: tooltipDelay,
	        tooltipPosition: tooltipPosition
	      },
	      _react2.default.createElement(_DropdownMenu2.default, _extends({}, props, { style: menuStyle, className: menuClassName }))
	    );
	  };
	
	  return DropdownMenuColumn;
	}(_react.PureComponent);
	
	DropdownMenuColumn.Positions = _DropdownMenu2.default.Positions;
	DropdownMenuColumn.HorizontalAnchors = _DropdownMenu2.default.HorizontalAnchors;
	DropdownMenuColumn.VerticalAnchors = _DropdownMenu2.default.VerticalAnchors;
	DropdownMenuColumn.propTypes = {
	  /**
	   * An optional id to use for the menu button in the column. If this is omitted, it's value will be
	   * `${rowId}-${cellIndex}-menu-button`
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * This is the optional style to apply to the `TableColumn`.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * This is the optional className to apply to the `TableColumn`.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The is the optional style to apply to the menu button's menu container.
	   *
	   * @see {@link Menus/DropdownMenu#style}
	   */
	  menuStyle: _propTypes2.default.object,
	
	  /**
	   * The is the optional class name to apply to the menu button's menu container.
	   *
	   * @see {@link Menus/DropdownMenu#className}
	   */
	  menuClassName: _propTypes2.default.string,
	
	  /**
	   * This is how the select field should be fixed within the table. When this is omitted,
	   * it will automatically use the responsive table as the fixture so that the select field
	   * will close/adjust itself to the scrolling of the table.
	   *
	   * @see {@link Helpers/Layover#fixedTo}
	   */
	  fixedTo: _fixedToShape2.default,
	
	  /**
	   * The optional tooltip to render on hover.
	   *
	   * @see {@link DataTables/TableColumn#tooltipLabel}
	   */
	  tooltipLabel: _propTypes2.default.string,
	
	  /**
	   * An optional delay to apply to the tooltip before it appears.
	   *
	   * @see {@link DataTables/TableColumn#tooltipDelay}
	   */
	  tooltipDelay: _propTypes2.default.number,
	
	  /**
	   * The position of the tooltip.
	   *
	   * @see {@link DataTables/TableColumn#tooltipPosition}
	   */
	  tooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the `fixedTo` element scrolls.
	   *
	   * @see {@link Helpers/Layover#repositionOnScroll}
	   */
	  repositionOnScroll: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the window resizes.
	   *
	   * @see {@link Helpers/Layover#repositionOnResize}
	   */
	  repositionOnResize: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu logic should be simplified without any viewport logic and position
	   * based on the relative position of the menu. This will most like require some additional
	   * styles applied to the menu.
	   *
	   * @see {@link Helpers/Layover#simplified}
	   */
	  simplifiedMenu: _propTypes2.default.bool,
	
	  /**
	   * This is injected by the `TableRow` component.
	   * @access private
	   */
	  header: _propTypes2.default.bool,
	
	  /**
	   * @access private
	   */
	  adjusted: _propTypes2.default.bool
	};
	DropdownMenuColumn.defaultProps = {
	  simplifiedMenu: false
	};
	exports.default = (0, _withTableFixes2.default)(DropdownMenuColumn, 'menu-button');

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(11);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _AccessibleFakeButton = __webpack_require__(70);
	
	var _AccessibleFakeButton2 = _interopRequireDefault(_AccessibleFakeButton);
	
	var _Layover = __webpack_require__(84);
	
	var _Layover2 = _interopRequireDefault(_Layover);
	
	var _Dialog = __webpack_require__(234);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditDialog = function (_PureComponent) {
	  _inherits(EditDialog, _PureComponent);
	
	  function EditDialog() {
	    _classCallCheck(this, EditDialog);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  EditDialog.prototype.render = function render() {
	    var _props = this.props,
	        id = _props.id,
	        dialogStyle = _props.dialogStyle,
	        dialogClassName = _props.dialogClassName,
	        dialogContentStyle = _props.dialogContentStyle,
	        dialogContentClassName = _props.dialogContentClassName,
	        textFieldId = _props.textFieldId,
	        visible = _props.visible,
	        header = _props.header,
	        onOpen = _props.onOpen,
	        children = _props.children,
	        label = _props.label,
	        title = _props.title,
	        large = _props.large,
	        actions = _props.actions,
	        placeholder = _props.placeholder,
	        dialogZDepth = _props.dialogZDepth,
	        props = _objectWithoutProperties(_props, ['id', 'dialogStyle', 'dialogClassName', 'dialogContentStyle', 'dialogContentClassName', 'textFieldId', 'visible', 'header', 'onOpen', 'children', 'label', 'title', 'large', 'actions', 'placeholder', 'dialogZDepth']);
	
	    var field = _react2.default.createElement(
	      _AccessibleFakeButton2.default,
	      {
	        className: (0, _classnames2.default)('md-edit-dialog__label', {
	          'md-edit-dialog__header': header
	        }, (0, _themeColors2.default)({ hint: placeholder || header })),
	        noFocusOutline: visible,
	        onClick: onOpen,
	        onFocus: onOpen
	      },
	      label
	    );
	
	    return _react2.default.createElement(
	      _Layover2.default,
	      _extends({}, props, {
	        id: id + '-layover',
	        toggle: field,
	        visible: visible,
	        block: true,
	        belowAnchor: null
	      }),
	      _react2.default.createElement(
	        _Dialog2.default,
	        {
	          id: id,
	          'aria-labelledby': !large ? textFieldId : undefined,
	          style: dialogStyle,
	          className: (0, _classnames2.default)('md-edit-dialog', (0, _themeColors2.default)({ background: true, themeText: false }), dialogClassName),
	          contentStyle: dialogContentStyle,
	          contentClassName: (0, _classnames2.default)('md-edit-dialog__content', dialogContentClassName),
	          title: large ? title : null,
	          focusOnMount: true,
	          containFocus: !!large,
	          paddedContent: false,
	          actions: large ? actions : null,
	          zDepth: dialogZDepth
	        },
	        children
	      )
	    );
	  };
	
	  return EditDialog;
	}(_react.PureComponent);
	
	EditDialog.propTypes = {
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  textFieldId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  dialogStyle: _propTypes2.default.object,
	  dialogClassName: _propTypes2.default.string,
	  dialogContentStyle: _propTypes2.default.object,
	  dialogContentClassName: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  onOpen: _propTypes2.default.func.isRequired,
	  onClose: _propTypes2.default.func.isRequired,
	  visible: _propTypes2.default.bool.isRequired,
	  label: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	  placeholder: _propTypes2.default.bool,
	  title: _propTypes2.default.node,
	  large: _propTypes2.default.bool,
	  actions: _Dialog2.default.propTypes.actions,
	  dialogZDepth: _propTypes2.default.number,
	  header: _propTypes2.default.bool
	};
	exports.default = EditDialog;

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(7);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(5);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _keyCodes = __webpack_require__(14);
	
	var _getField = __webpack_require__(8);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _themeColors = __webpack_require__(11);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _viewport = __webpack_require__(174);
	
	var _viewport2 = _interopRequireDefault(_viewport);
	
	var _controlled = __webpack_require__(15);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _anchorShape = __webpack_require__(28);
	
	var _anchorShape2 = _interopRequireDefault(_anchorShape);
	
	var _fixedToShape = __webpack_require__(19);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _positionShape = __webpack_require__(36);
	
	var _positionShape2 = _interopRequireDefault(_positionShape);
	
	var _Layover = __webpack_require__(84);
	
	var _Layover2 = _interopRequireDefault(_Layover);
	
	var _FontIcon = __webpack_require__(12);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _getDeprecatedIcon = __webpack_require__(21);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _TextField = __webpack_require__(89);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _TableColumn = __webpack_require__(82);
	
	var _TableColumn2 = _interopRequireDefault(_TableColumn);
	
	var _EditDialog = __webpack_require__(849);
	
	var _EditDialog2 = _interopRequireDefault(_EditDialog);
	
	var _findTable = __webpack_require__(164);
	
	var _findTable2 = _interopRequireDefault(_findTable);
	
	var _findFixedTo = __webpack_require__(334);
	
	var _findFixedTo2 = _interopRequireDefault(_findFixedTo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `EditDialogColumn` is used when there should be used when a table column's value
	 * can be changed. It can either be displayed as a dialog or inline.
	 *
	 * All props that are not documented but provided will be passed on to the `TextField`
	 * component.
	 */
	var EditDialogColumn = function (_PureComponent) {
	  _inherits(EditDialogColumn, _PureComponent);
	
	  function EditDialogColumn(props) {
	    _classCallCheck(this, EditDialogColumn);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      visible: props.defaultVisible,
	      value: props.defaultValue,
	      cancelValue: props.defaultValue,
	      actions: _this._makeActions(props),
	      cellIndex: undefined
	    };
	    return _this;
	  }
	
	  EditDialogColumn.prototype.componentDidMount = function componentDidMount() {
	    this._column = (0, _reactDom.findDOMNode)(this);
	    this._table = (0, _findTable2.default)(this._column);
	    this._fixedTo = (0, _findFixedTo2.default)(this._table);
	
	    // If a developer creates their own component to wrap the EditDialogColumn, the cellIndex prop
	    // might not be defined if they don't pass ...props
	    var cellIndex = this.props.cellIndex;
	
	    if (!cellIndex && cellIndex !== 0) {
	      var columns = [].slice.call(this._column.parentNode.querySelectorAll('th,td'));
	      this.setState({ cellIndex: columns.indexOf(this._column) }); // eslint-disable-line react/no-did-mount-set-state
	    }
	  };
	
	  EditDialogColumn.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _props = this.props,
	        okLabel = _props.okLabel,
	        okPrimary = _props.okPrimary,
	        okSecondary = _props.okSecondary,
	        okProps = _props.okProps,
	        cancelLabel = _props.cancelLabel,
	        cancelPrimary = _props.cancelPrimary,
	        cancelSecondary = _props.cancelSecondary,
	        cancelProps = _props.cancelProps;
	
	
	    if (okLabel !== nextProps.okLabel || okPrimary !== nextProps.okPrimary || okSecondary !== nextProps.okSecondary || cancelLabel !== nextProps.cancelLabel || cancelPrimary !== nextProps.cancelPrimary || cancelSecondary !== nextProps.cancelSecondary || okProps !== nextProps.okProps || cancelProps !== nextProps.cancelProps) {
	      this.setState({ actions: this._makeActions(nextProps) });
	    }
	  };
	
	  EditDialogColumn.prototype.render = function render() {
	    var rowId = this.context.rowId;
	
	    var _props2 = this.props,
	        style = _props2.style,
	        className = _props2.className,
	        layoverStyle = _props2.layoverStyle,
	        layoverClassName = _props2.layoverClassName,
	        dialogStyle = _props2.dialogStyle,
	        dialogClassName = _props2.dialogClassName,
	        dialogContentStyle = _props2.dialogContentStyle,
	        dialogContentClassName = _props2.dialogContentClassName,
	        dialogZDepth = _props2.dialogZDepth,
	        textFieldStyle = _props2.textFieldStyle,
	        textFieldClassName = _props2.textFieldClassName,
	        inputClassName = _props2.inputClassName,
	        large = _props2.large,
	        title = _props2.title,
	        inline = _props2.inline,
	        inlineIcon = _props2.inlineIcon,
	        maxLength = _props2.maxLength,
	        label = _props2.label,
	        placeholder = _props2.placeholder,
	        header = _props2.header,
	        anchor = _props2.anchor,
	        belowAnchor = _props2.belowAnchor,
	        fixedTo = _props2.fixedTo,
	        animationPosition = _props2.animationPosition,
	        xThreshold = _props2.xThreshold,
	        yThreshold = _props2.yThreshold,
	        centered = _props2.centered,
	        sameWidth = _props2.sameWidth,
	        repositionOnScroll = _props2.repositionOnScroll,
	        repositionOnResize = _props2.repositionOnResize,
	        transitionName = _props2.transitionName,
	        transitionEnterTimeout = _props2.transitionEnterTimeout,
	        transitionLeaveTimeout = _props2.transitionLeaveTimeout,
	        tooltipLabel = _props2.tooltipLabel,
	        tooltipDelay = _props2.tooltipDelay,
	        tooltipPosition = _props2.tooltipPosition,
	        onClick = _props2.onClick,
	        onMouseDown = _props2.onMouseDown,
	        onMouseUp = _props2.onMouseUp,
	        onTouchStart = _props2.onTouchStart,
	        onTouchEnd = _props2.onTouchEnd,
	        onMouseEnter = _props2.onMouseEnter,
	        onMouseOver = _props2.onMouseOver,
	        onMouseLeave = _props2.onMouseLeave,
	        onTouchMove = _props2.onTouchMove,
	        simplifiedDialog = _props2.simplifiedDialog,
	        minLeft = _props2.minLeft,
	        minRight = _props2.minRight,
	        minBottom = _props2.minBottom,
	        noIcon = _props2.noIcon,
	        inlineIconChildren = _props2.inlineIconChildren,
	        inlineIconClassName = _props2.inlineIconClassName,
	        propId = _props2.id,
	        propDialogId = _props2.dialogId,
	        propCellIndex = _props2.cellIndex,
	        onOkClick = _props2.onOkClick,
	        okLabel = _props2.okLabel,
	        okPrimary = _props2.okPrimary,
	        okSecondary = _props2.okSecondary,
	        okProps = _props2.okProps,
	        onCancelClick = _props2.onCancelClick,
	        cancelLabel = _props2.cancelLabel,
	        cancelPrimary = _props2.cancelPrimary,
	        cancelSecondary = _props2.cancelSecondary,
	        cancelProps = _props2.cancelProps,
	        okOnOutsideClick = _props2.okOnOutsideClick,
	        defaultValue = _props2.defaultValue,
	        adjusted = _props2.adjusted,
	        scrollIntoView = _props2.scrollIntoView,
	        scrollIntoViewPadding = _props2.scrollIntoViewPadding,
	        defaultVisible = _props2.defaultVisible,
	        visibleOnFocus = _props2.visibleOnFocus,
	        scrollThreshold = _props2.scrollThreshold,
	        enforceMinWidth = _props2.enforceMinWidth,
	        transitionDuration = _props2.transitionDuration,
	        props = _objectWithoutProperties(_props2, ['style', 'className', 'layoverStyle', 'layoverClassName', 'dialogStyle', 'dialogClassName', 'dialogContentStyle', 'dialogContentClassName', 'dialogZDepth', 'textFieldStyle', 'textFieldClassName', 'inputClassName', 'large', 'title', 'inline', 'inlineIcon', 'maxLength', 'label', 'placeholder', 'header', 'anchor', 'belowAnchor', 'fixedTo', 'animationPosition', 'xThreshold', 'yThreshold', 'centered', 'sameWidth', 'repositionOnScroll', 'repositionOnResize', 'transitionName', 'transitionEnterTimeout', 'transitionLeaveTimeout', 'tooltipLabel', 'tooltipDelay', 'tooltipPosition', 'onClick', 'onMouseDown', 'onMouseUp', 'onTouchStart', 'onTouchEnd', 'onMouseEnter', 'onMouseOver', 'onMouseLeave', 'onTouchMove', 'simplifiedDialog', 'minLeft', 'minRight', 'minBottom', 'noIcon', 'inlineIconChildren', 'inlineIconClassName', 'id', 'dialogId', 'cellIndex', 'onOkClick', 'okLabel', 'okPrimary', 'okSecondary', 'okProps', 'onCancelClick', 'cancelLabel', 'cancelPrimary', 'cancelSecondary', 'cancelProps', 'okOnOutsideClick', 'defaultValue', 'adjusted', 'scrollIntoView', 'scrollIntoViewPadding', 'defaultVisible', 'visibleOnFocus', 'scrollThreshold', 'enforceMinWidth', 'transitionDuration']);
	
	    var _state = this.state,
	        visible = _state.visible,
	        actions = _state.actions;
	
	    var value = (0, _getField2.default)(this.props, this.state, 'value');
	    var cellIndex = (0, _getField2.default)(this.props, this.state, 'cellIndex');
	
	    var _props3 = this.props,
	        id = _props3.id,
	        dialogId = _props3.dialogId;
	
	    if (!dialogId) {
	      dialogId = (id || rowId + '-' + cellIndex) + '-edit-dialog';
	    }
	
	    if (!id) {
	      id = dialogId + '-field';
	    }
	
	    var inlineEditIcon = void 0;
	    if (inline && !noIcon) {
	      var icon = (0, _getDeprecatedIcon2.default)(inlineIconClassName, inlineIconChildren, inlineIcon);
	      if (icon) {
	        inlineEditIcon = _react2.default.cloneElement(icon, { key: 'edit-icon' });
	      }
	    }
	
	    var numeric = props.type === 'number';
	    var field = _react2.default.createElement(_TextField2.default, _extends({}, props, {
	      ref: this._setField,
	      style: textFieldStyle,
	      className: (0, _classnames2.default)({ 'md-edit-dialog__blocked-field': inline }, textFieldClassName),
	      inputClassName: (0, _classnames2.default)({
	        'md-edit-dialog__header': header && inline,
	        'md-text-right': numeric
	      }, (0, _themeColors2.default)({ hint: header && inline }), inputClassName),
	      id: id,
	      label: label,
	      placeholder: placeholder,
	      value: value,
	      onFocus: this._handleFocus,
	      onChange: this._handleChange,
	      onKeyDown: this._handleKeyDown,
	      block: inline,
	      maxLength: visible ? maxLength : null,
	      rightIcon: inlineEditIcon
	    }));
	
	    var children = void 0;
	    if (inline) {
	      children = field;
	    } else {
	      var dialogLabel = value || value === 0 ? value : placeholder || label;
	      children = _react2.default.createElement(
	        _EditDialog2.default,
	        {
	          style: layoverStyle,
	          className: layoverClassName,
	          dialogStyle: dialogStyle,
	          dialogClassName: dialogClassName,
	          dialogContentStyle: dialogContentStyle,
	          dialogContentClassName: dialogContentClassName,
	          id: dialogId,
	          textFieldId: id,
	          visible: visible,
	          onOpen: this._handleOpen,
	          onClose: this._handleClose,
	          label: dialogLabel,
	          actions: actions,
	          large: large,
	          title: title,
	          header: header,
	          placeholder: dialogLabel === placeholder || dialogLabel === label,
	          simplified: simplifiedDialog,
	          anchor: anchor,
	          belowAnchor: belowAnchor,
	          animationPosition: animationPosition,
	          xThreshold: xThreshold,
	          yThreshold: yThreshold,
	          centered: centered,
	          sameWidth: sameWidth,
	          minLeft: minLeft,
	          minRight: minRight,
	          minBottom: minBottom,
	          fixedTo: typeof fixedTo !== 'undefined' ? fixedTo : this._fixedTo,
	          dialogZDepth: dialogZDepth,
	          repositionOnScroll: repositionOnScroll,
	          repositionOnResize: repositionOnResize,
	          transitionName: transitionName,
	          transitionEnterTimeout: transitionEnterTimeout,
	          transitionLeaveTimeout: transitionLeaveTimeout
	        },
	        field
	      );
	    }
	
	    return _react2.default.createElement(
	      _TableColumn2.default,
	      {
	        style: style,
	        numeric: numeric,
	        className: (0, _classnames2.default)('md-edit-dialog-column', className),
	        header: header,
	        adjusted: false,
	        tooltipLabel: tooltipLabel,
	        tooltipDelay: tooltipDelay,
	        tooltipPosition: tooltipPosition,
	        onClick: onClick,
	        onMouseDown: onMouseDown,
	        onMouseUp: onMouseUp,
	        onTouchStart: onTouchStart,
	        onTouchMove: onTouchMove,
	        onMouseEnter: onMouseEnter,
	        onMouseOver: onMouseOver,
	        onMouseLeave: onMouseLeave,
	        onTouchEnd: onTouchEnd
	      },
	      children
	    );
	  };
	
	  return EditDialogColumn;
	}(_react.PureComponent);
	
	EditDialogColumn.VerticalAnchors = _Layover2.default.VerticalAnchors;
	EditDialogColumn.HorizontalAnchors = _Layover2.default.HorizontalAnchors;
	EditDialogColumn.Positions = _Layover2.default.Positions;
	EditDialogColumn.propTypes = {
	  /**
	   * An optional id to use for the text field in the column. If this is omitted,
	   * the id will be `${dialogId}-field`.
	   *
	   * @see {@link #dialogId}
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to use for the dialog that appears in the column. If this is omitted,
	   * the id will be `${rowId}-${cellIndex}-edit-dialog-field`.
	   */
	  dialogId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * The optional style to apply to the edit dialog's column.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * The optional className to apply to the edit dialog's column.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the dialog's surrounding `Layover` component.
	   */
	  layoverStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to the dialog's surrounding `Layover` component.
	   */
	  layoverClassName: _propTypes2.default.string,
	
	  /**
	   * The optional style to apply to the edit dialog.
	   */
	  dialogStyle: _propTypes2.default.object,
	
	  /**
	   * The optional className to apply to the edit dialog.
	   */
	  dialogClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the dialog's content area. This is the area
	   * that holds the text field.
	   */
	  dialogContentStyle: _propTypes2.default.object,
	
	  /**
	   * An optional class name to apply to the dialog's content area. This is the area
	   * that holds the text field.
	   */
	  dialogContentClassName: _propTypes2.default.string,
	
	  /**
	   * The zDepth to apply to the dialog when not inline.
	   *
	   * @see {@link Papers/Paper#zDepth}
	   */
	  dialogZDepth: _propTypes2.default.number.isRequired,
	
	  /**
	   * An optional style to apply to the text field.
	   */
	  textFieldStyle: _propTypes2.default.object,
	
	  /**
	   * An optional class name to apply to the text field.
	   */
	  textFieldClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the text field's input.
	   */
	  inputStyle: _propTypes2.default.object,
	
	  /**
	   * An optional class name to apply to the text field's input.
	   */
	  inputClassName: _propTypes2.default.string,
	
	  /**
	   * Boolean if the edit dialog is currently disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the text field should be editable inline instead of in a dialog.
	   *
	   * @see {@link #inlineIcon}
	   */
	  inline: _propTypes2.default.bool,
	
	  /**
	   * An optional icon to set for the inline edit dialog column. Setting this prop to null
	   * will not render an icon.
	   */
	  inlineIcon: _propTypes2.default.element,
	
	  /**
	   * The default value to use for the text field.
	   */
	  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	
	  /**
	   * A value to use for the edit dialog text field. This will make the component controlled
	   * so you will need to provide an `onChange` function.
	   */
	  value: (0, _controlled2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]), 'onChange', 'defaultValue'),
	
	  /**
	   * An optional function to call when the text field's value has changed. This is required
	   * if the `value` prop has been defined.
	   *
	   * @see {@link TextFields/TextField#onChange}
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the text field gains focus.
	   */
	  onFocus: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the keydown event is triggered on the text field.
	   */
	  onKeyDown: _propTypes2.default.func,
	
	  /**
	   * An optional label for the text field. When displaying an `inline` edit dialog column,
	   * the `placeholder` prop should be used instead. This is because the text field changes
	   * to the `block` type when `inline`.
	   *
	   * @see {@link #inline}
	   * @see {@link #placeholder}
	   * @see {@link TextFields/TextField#block}
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * An optional placeholder for the text field.
	   */
	  placeholder: _propTypes2.default.string,
	
	  /**
	   * Boolean if the edit dialog should become a large dialog. When the dialog is large,
	   * the `title` prop is required.
	   *
	   * A large dialog has a Title followed by the text field, and then a cancel and ok action
	   * buttons below.
	   */
	  large: _propTypes2.default.bool,
	
	  /**
	   * The title to use for the large edit dialog. This prop is required if the `large` prop
	   * is enabled.
	   */
	  title: _propTypes2.default.node,
	
	  /**
	   * An optional `maxLength` to apply to the text field.
	   *
	   * @see {@link TextFields/TextField#maxLength}
	   */
	  maxLength: _propTypes2.default.number,
	
	  /**
	   * An optional function to call when the "Ok" button has been clicked, the user presses enter
	   * on * the text field or when the `okOnOutsideClick` prop has been enabled and the user clicks
	   * somewhere on the page.
	   *
	   * The callback will include the current value and the click or keypress event.
	   * ```js
	   * onOkClick(value, event)
	   * ```
	   *
	   * @see {@link #large}
	   */
	  onOkClick: _propTypes2.default.func,
	
	  /**
	   * The label to use for the "Ok" button in large dialogs.
	   *
	   * @see {@link #large}
	   */
	  okLabel: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the "Ok" button in large dialogs should be styled with the primary color.
	   * To get a `default` styled button, set both `okPrimary` and `okSecondary` (or omit `okSecondary`)
	   * to `false`.
	   *
	   * @see {@link #large}
	   * @see {@link #okSecondary}
	   */
	  okPrimary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the "Ok" button in large dialogs should be styled with the secondary color.
	   *
	   * @see {@link #large}
	   * @see {@link #okPrimary}
	   */
	  okSecondary: _propTypes2.default.bool,
	
	  /**
	   * Any additional props to apply to the "Ok" button. This will override any of the other
	   * button props.
	   *
	   * @see {@link #okLabel}
	   * @see {@link #okPrimary}
	   * @see {@link #okSecondary}
	   */
	  okProps: _propTypes2.default.object,
	
	  /**
	   * An optional function to call when the "Cancel" button has been clicked in large edit dialogs.
	   * The callback will include the text field's value before any edits occurred and the click event.
	   *
	   * ```js
	   * onCancelClick(previousValue, event)
	   * ```
	   *
	   * @see {@link #large}
	   */
	  onCancelClick: _propTypes2.default.func,
	
	  /**
	   * The label to give to the "Cancel" button in large edit dialogs.
	   *
	   * @see {@link #large}
	   */
	  cancelLabel: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the "Cancel" button in large dialogs should be styled with the primary color.
	   * To get a `default` styled button, set both `cancelPrimary` and `cancelSecondary` (or
	   * omit `cancelSecondary`) to `false`.
	   *
	   * @see {@link #large}
	   * @see {@link #cancelSecondary}
	   */
	  cancelPrimary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the "Cancel" button in large dialogs should be styled with the secondary color.
	   *
	   * @see {@link #large}
	   * @see {@link #cancelPrimary}
	   */
	  cancelSecondary: _propTypes2.default.bool,
	
	  /**
	   * Any additional props to apply to the "Cancel" button. This will override any of the other
	   * button props.
	   *
	   * @see {@link #cancelLabel}
	   * @see {@link #cancelPrimary}
	   * @see {@link #cancelSecondary}
	   */
	  cancelProps: _propTypes2.default.object,
	
	  /**
	   * Boolean if the action for clicking somewhere on on the page while the dialog is open
	   * saves the changes or cancels to the previous value before opening the dialog.
	   *
	   * @see {@link #onOkClick}
	   * @see {@link #onCancelClick}
	   */
	  okOnOutsideClick: _propTypes2.default.bool,
	
	  /**
	   * An optional function to call when a user clicks out of the text field.
	   */
	  onOutsideClick: _propTypes2.default.func,
	
	  /**
	   * Boolean if the edit dialog should be closed if the user clicks somewhere else on the page
	   * while the dialog is open.
	   */
	  closeOnOutsideClick: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the Edit Dialog should be visible by default. This only applies when the `inline` prop
	   * is not enabled.
	   */
	  defaultVisible: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the edit dialog should automatically open when the text field is focused for non-inline
	   * dialogs. This is enabled by default for backwards compatibility.
	   */
	  visibleOnFocus: _propTypes2.default.bool,
	
	  /**
	   * The type for the text field in the edit dialog.
	   *
	   * @see {@link TextFields/TextField#type}
	   */
	  type: _propTypes2.default.string,
	
	  /**
	   * This is how the dialog gets "anchored" to the table column.
	   *
	   * @see {@link Helpers/Layover#anchor}
	   */
	  anchor: _anchorShape2.default,
	
	  /**
	   * This is the anchor to use when the `position` is set to `Autocomplete.Positions.BELOW`.
	   *
	   * @see {@link Helpers/Layover#belowAnchor}
	   */
	  belowAnchor: _anchorShape2.default,
	
	  /**
	   * This is the animation position to use for the dialog.
	   *
	   * @see {@link Helpers/Layover#animationPosition}
	   */
	  animationPosition: _positionShape2.default,
	
	  /**
	   * This is how the dialog should be fixed within the table. When this is omitted, it will
	   * automatically use the responsive table as the fixture so that the dialog will close/adjust itself
	   * to the scrolling of the table.
	   *
	   * @see {@link Helpers/Layover#fixedTo}
	   */
	  fixedTo: _fixedToShape2.default,
	
	  /**
	   * @see {@link Helpers/Layover#xThreshold}
	   */
	  xThreshold: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#yThreshold}
	   */
	  yThreshold: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#centered}
	   */
	  centered: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#sameWidth}
	   */
	  sameWidth: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#transitionName}
	   */
	  transitionName: _propTypes2.default.string,
	
	  /**
	   * @see {@link Helpers/Layover#transitionEnterTimeout}
	   */
	  transitionEnterTimeout: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#transitionLeaveTimeout}
	   */
	  transitionLeaveTimeout: _propTypes2.default.number,
	
	  /**
	   * The optional tooltip to render on hover.
	   */
	  tooltipLabel: _propTypes2.default.node,
	
	  /**
	   * An optional delay to apply to the tooltip before it appears.
	   */
	  tooltipDelay: _propTypes2.default.number,
	
	  /**
	   * The position of the tooltip.
	   */
	  tooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the `fixedTo` element scrolls.
	   *
	   * @see {@link Helpers/Layover#repositionOnScroll}
	   */
	  repositionOnScroll: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the window resizes.
	   *
	   * @see {@link Helpers/Layover#repositionOnResize}
	   */
	  repositionOnResize: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the dialog logic should be simplified without any viewport logic and position
	   * based on the relative position of the menu. This will most like require some additional
	   * styles applied to the dialog.
	   *
	   * @see {@link Helpers/Layover#simplified}
	   */
	  simplifiedDialog: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#minLeft}
	   */
	  minLeft: _Layover2.default.propTypes.minLeft,
	
	  /**
	   * @see {@link Helpers/Layover#minRight}
	   */
	  minRight: _Layover2.default.propTypes.minLeft,
	
	  /**
	   * @see {@link Helpers/Layover#minBottom}
	   */
	  minBottom: _Layover2.default.propTypes.minBottom,
	
	  /**
	   * Boolean if the edit dialog should attempt to scroll into view if the full
	   * dialog can not be displayed in the viewport when it was toggled open.
	   *
	   * @see {@link #scrollIntoViewPadding}
	   */
	  scrollIntoView: _propTypes2.default.bool,
	
	  /**
	   * The amount of padding that should be applied when the cell is scrolled into view.
	   * This will be applied to the left of the cell.
	   */
	  scrollIntoViewPadding: _propTypes2.default.number,
	
	  /**
	   * An optional function to call when the `click` event is triggered in the column.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mousedown` event is triggered in the column.
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mouseup` event is triggered in the column.
	   */
	  onMouseUp: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `touchstart` event is triggered in the column.
	   */
	  onTouchStart: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `touchend` event is triggered in the column.
	   */
	  onTouchEnd: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mouseenter` event is triggered in the column.
	   */
	  onMouseEnter: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mouseover` event is triggered in the column.
	   */
	  onMouseOver: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `mouseleave` event is triggered in the column.
	   */
	  onMouseLeave: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `touchmove` event is triggered in the column.
	   */
	  onTouchMove: _propTypes2.default.func,
	
	  /**
	   * This is injected by the `TableRow` component.
	   * @access private
	   */
	  header: _propTypes2.default.bool,
	
	  /**
	   * This is injected by the `TableRow` component and used to help generate the unique id for the text
	   * field.
	   *
	   * @access private
	   */
	  cellIndex: _propTypes2.default.number,
	
	  /**
	   * @access private
	   */
	  adjusted: _propTypes2.default.bool,
	
	  inlineIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `inlineIcon` prop instead'),
	  inlineIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `inlineIcon` prop instead'),
	  noIcon: (0, _deprecated2.default)(_propTypes2.default.bool, 'Set the `inlineIcon` prop to `null` instead'),
	  enforceMinWidth: (0, _deprecated2.default)(_propTypes2.default.bool, 'The min width will always be enforced based on the `$md-edit-dialog-min-width` Sass variable'),
	  scrollThreshold: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `xThreshold` and `yThreshold` instead'),
	  transitionDuration: (0, _deprecated2.default)(_propTypes2.default.number, 'use `transitionEnterTimeout` and `transitionLeaveTimeout` instead')
	};
	EditDialogColumn.defaultProps = {
	  type: 'text',
	  defaultValue: '',
	  okOnOutsideClick: true,
	  inlineIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'edit'
	  ),
	  okLabel: 'Save',
	  okPrimary: true,
	  cancelLabel: 'Cancel',
	  cancelPrimary: true,
	  animationPosition: EditDialogColumn.Positions.BELOW,
	  dialogZDepth: 1,
	  repositionOnScroll: true,
	  repositionOnResize: false,
	  scrollIntoView: true,
	  scrollIntoViewPadding: 16,
	  minLeft: 0,
	  minRight: 0,
	  minBottom: 0,
	  visibleOnFocus: true,
	  defaultVisible: false
	};
	EditDialogColumn.contextTypes = {
	  rowId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._setField = function (field) {
	    _this2._field = field;
	  };
	
	  this._makeActions = function (props) {
	    var okLabel = props.okLabel,
	        okPrimary = props.okPrimary,
	        okSecondary = props.okSecondary,
	        okProps = props.okProps,
	        cancelLabel = props.cancelLabel,
	        cancelPrimary = props.cancelPrimary,
	        cancelSecondary = props.cancelSecondary,
	        cancelProps = props.cancelProps;
	
	
	    return [_extends({
	      key: 'cancel',
	      children: cancelLabel,
	      primary: cancelPrimary && !cancelSecondary,
	      secondary: cancelSecondary
	    }, cancelProps, {
	      onClick: _this2._handleCancel
	    }), _extends({
	      key: 'ok',
	      children: okLabel,
	      primary: okPrimary && !okSecondary,
	      secondary: okSecondary
	    }, okProps, {
	      onClick: _this2._handleOk
	    })];
	  };
	
	  this._handleOpen = function (e) {
	    if (_this2._skipNextOpen) {
	      _this2._skipNextOpen = false;
	    } else if (_this2.props.visibleOnFocus || !e || e.type !== 'focus') {
	      var _props4 = _this2.props,
	          scrollIntoView = _props4.scrollIntoView,
	          scrollIntoViewPadding = _props4.scrollIntoViewPadding;
	
	      if (scrollIntoView) {
	        var vp = (0, _viewport2.default)(_this2._column);
	        if (vp !== true && _this2._table && _this2._column && !_this2.props.inline) {
	          _this2._table.scrollLeft = _this2._column.offsetLeft - scrollIntoViewPadding;
	        }
	      }
	
	      _this2.setState({ visible: true, cancelValue: (0, _getField2.default)(_this2.props, _this2.state, 'value') });
	    }
	  };
	
	  this._handleClose = function (e) {
	    var _props5 = _this2.props,
	        onOutsideClick = _props5.onOutsideClick,
	        okOnOutsideClick = _props5.okOnOutsideClick;
	
	    if (onOutsideClick) {
	      onOutsideClick(e);
	    }
	
	    if (okOnOutsideClick) {
	      _this2._handleOk(e);
	    } else {
	      _this2._handleCancel(e);
	    }
	  };
	
	  this._handleChange = function (value, e) {
	    if (_this2.props.onChange) {
	      _this2.props.onChange(value, e);
	    }
	
	    if (typeof _this2.props.value === 'undefined') {
	      _this2.setState({ value: value });
	    }
	  };
	
	  this._handleFocus = function (e) {
	    if (_this2.props.onFocus) {
	      _this2.props.onFocus(e);
	    }
	
	    if (_this2.props.inline) {
	      _this2.setState({ cancelValue: e.target.value });
	    }
	  };
	
	  this._handleKeyDown = function (e) {
	    var _props6 = _this2.props,
	        onKeyDown = _props6.onKeyDown,
	        okOnOutsideClick = _props6.okOnOutsideClick,
	        large = _props6.large;
	
	    if (onKeyDown) {
	      onKeyDown(e);
	    }
	
	    var key = e.which || e.keyCode;
	    if (key === _keyCodes.ENTER) {
	      _this2._handleOk(e);
	    } else if (key === _keyCodes.ESC) {
	      _this2._handleCancel(e);
	    } else if (key === _keyCodes.TAB && !large) {
	      // infinitely opens otherwise...
	      _this2._skipNextOpen = e.shiftKey;
	
	      if (okOnOutsideClick) {
	        _this2._handleOk(e);
	      } else {
	        _this2._handleCancel(e);
	      }
	    }
	  };
	
	  this._handleOk = function (e) {
	    if (_this2.props.onOkClick) {
	      _this2.props.onOkClick((0, _getField2.default)(_this2.props, _this2.state, 'value'), e);
	    }
	
	    _this2.setState({ visible: false });
	  };
	
	  this._handleCancel = function (e) {
	    var value = _this2.state.cancelValue;
	    if (_this2.props.onCancelClick) {
	      _this2.props.onCancelClick(value, e);
	    }
	
	    var state = { visible: false };
	    if (typeof _this2.props.value === 'undefined') {
	      state.value = value;
	    }
	
	    _this2.setState(state);
	  };
	};
	
	exports.default = EditDialogColumn;

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _fixedToShape = __webpack_require__(19);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _withTableFixes = __webpack_require__(233);
	
	var _withTableFixes2 = _interopRequireDefault(_withTableFixes);
	
	var _MenuButton = __webpack_require__(339);
	
	var _MenuButton2 = _interopRequireDefault(_MenuButton);
	
	var _TableColumn = __webpack_require__(82);
	
	var _TableColumn2 = _interopRequireDefault(_TableColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MenuButtonColumn = function (_PureComponent) {
	  _inherits(MenuButtonColumn, _PureComponent);
	
	  function MenuButtonColumn() {
	    _classCallCheck(this, MenuButtonColumn);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  MenuButtonColumn.prototype.render = function render() {
	    var _props = this.props,
	        style = _props.style,
	        className = _props.className,
	        menuStyle = _props.menuStyle,
	        menuClassName = _props.menuClassName,
	        header = _props.header,
	        adjusted = _props.adjusted,
	        tooltipLabel = _props.tooltipLabel,
	        tooltipDelay = _props.tooltipDelay,
	        tooltipPosition = _props.tooltipPosition,
	        props = _objectWithoutProperties(_props, ['style', 'className', 'menuStyle', 'menuClassName', 'header', 'adjusted', 'tooltipLabel', 'tooltipDelay', 'tooltipPosition']);
	
	    return _react2.default.createElement(
	      _TableColumn2.default,
	      {
	        style: style,
	        className: className,
	        header: header,
	        adjusted: adjusted,
	        tooltipLabel: tooltipLabel,
	        tooltipDelay: tooltipDelay,
	        tooltipPosition: tooltipPosition
	      },
	      _react2.default.createElement(_MenuButton2.default, _extends({}, props, { style: menuStyle, className: menuClassName }))
	    );
	  };
	
	  return MenuButtonColumn;
	}(_react.PureComponent);
	
	MenuButtonColumn.Positions = _MenuButton2.default.Positions;
	MenuButtonColumn.HorizontalAnchors = _MenuButton2.default.HorizontalAnchors;
	MenuButtonColumn.VerticalAnchors = _MenuButton2.default.VerticalAnchors;
	MenuButtonColumn.propTypes = {
	  /**
	   * An optional id to use for the menu button in the column. If this is omitted, it's value will be
	   * `${rowId}-${cellIndex}-menu-button`
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * This is the optional style to apply to the `TableColumn`.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * This is the optional className to apply to the `TableColumn`.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The is the optional style to apply to the menu button's menu container.
	   *
	   * @see {@link Menus/MenuButton#style}
	   */
	  menuStyle: _propTypes2.default.object,
	
	  /**
	   * The is the optional class name to apply to the menu button's menu container.
	   *
	   * @see {@link Menus/MenuButton#className}
	   */
	  menuClassName: _propTypes2.default.string,
	
	  /**
	   * This is how the select field should be fixed within the table. When this is omitted,
	   * it will automatically use the responsive table as the fixture so that the select field
	   * will close/adjust itself to the scrolling of the table.
	   *
	   * @see {@link Helpers/Layover#fixedTo}
	   */
	  fixedTo: _fixedToShape2.default,
	
	  /**
	   * The optional tooltip to render on hover.
	   *
	   * @see {@link DataTables/TableColumn#tooltipLabel}
	   */
	  tooltipLabel: _propTypes2.default.string,
	
	  /**
	   * An optional delay to apply to the tooltip before it appears.
	   *
	   * @see {@link DataTables/TableColumn#tooltipDelay}
	   */
	  tooltipDelay: _propTypes2.default.number,
	
	  /**
	   * The position of the tooltip.
	   *
	   * @see {@link DataTables/TableColumn#tooltipPosition}
	   */
	  tooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the `fixedTo` element scrolls.
	   *
	   * @see {@link Helpers/Layover#repositionOnScroll}
	   */
	  repositionOnScroll: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the window resizes.
	   *
	   * @see {@link Helpers/Layover#repositionOnResize}
	   */
	  repositionOnResize: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu logic should be simplified without any viewport logic and position
	   * based on the relative position of the menu. This will most like require some additional
	   * styles applied to the menu.
	   *
	   * @see {@link Helpers/Layover#simplified}
	   */
	  simplifiedMenu: _propTypes2.default.bool,
	
	  /**
	   * This is injected by the `TableRow` component.
	   * @access private
	   */
	  header: _propTypes2.default.bool,
	
	  /**
	   * @access private
	   */
	  adjusted: _propTypes2.default.bool
	};
	MenuButtonColumn.defaultProps = {
	  simplifiedMenu: false
	};
	exports.default = (0, _withTableFixes2.default)(MenuButtonColumn, 'menu-button');

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(5);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _fixedToShape = __webpack_require__(19);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _positionShape = __webpack_require__(36);
	
	var _positionShape2 = _interopRequireDefault(_positionShape);
	
	var _SelectField = __webpack_require__(241);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	var _withTableFixes = __webpack_require__(233);
	
	var _withTableFixes2 = _interopRequireDefault(_withTableFixes);
	
	var _TableColumn = __webpack_require__(82);
	
	var _TableColumn2 = _interopRequireDefault(_TableColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `SelectFieldColumn` component is just a simple wrapper between a `SelectField` and
	 * the `TableColumn` components.
	 *
	 * All props that are on the `SelectField` are also available here (except the naming of style or className).
	 * See the [SelectField](/components/select-fields?tab=1#select-field-proptypes) for remaining prop descriptions.
	 */
	var SelectFieldColumn = function (_PureComponent) {
	  _inherits(SelectFieldColumn, _PureComponent);
	
	  function SelectFieldColumn() {
	    _classCallCheck(this, SelectFieldColumn);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  SelectFieldColumn.prototype.render = function render() {
	    var _props = this.props,
	        style = _props.style,
	        className = _props.className,
	        menuStyle = _props.menuStyle,
	        menuClassName = _props.menuClassName,
	        header = _props.header,
	        tooltipLabel = _props.tooltipLabel,
	        tooltipDelay = _props.tooltipDelay,
	        tooltipPosition = _props.tooltipPosition,
	        adjusted = _props.adjusted,
	        wrapperStyle = _props.wrapperStyle,
	        wrapperClassName = _props.wrapperClassName,
	        props = _objectWithoutProperties(_props, ['style', 'className', 'menuStyle', 'menuClassName', 'header', 'tooltipLabel', 'tooltipDelay', 'tooltipPosition', 'adjusted', 'wrapperStyle', 'wrapperClassName']);
	
	    return _react2.default.createElement(
	      _TableColumn2.default,
	      {
	        header: header,
	        style: style,
	        className: (0, _classnames2.default)('md-select-field-column', className),
	        adjusted: false,
	        tooltipLabel: tooltipLabel,
	        tooltipDelay: tooltipDelay,
	        tooltipPosition: tooltipPosition
	      },
	      _react2.default.createElement(_SelectField2.default, _extends({}, props, { style: menuStyle, className: menuClassName }))
	    );
	  };
	
	  return SelectFieldColumn;
	}(_react.PureComponent);
	
	SelectFieldColumn.VerticalAnchors = _SelectField2.default.VerticalAnchors;
	SelectFieldColumn.HorizontalAnchors = _SelectField2.default.HorizontalAnchors;
	SelectFieldColumn.Positions = _SelectField2.default.Positions;
	SelectFieldColumn.propTypes = {
	  /**
	   * An optional id to use for the select field in the column. If this is omitted, it's value will be
	   * `${rowId}-${cellIndex}-select-field`
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * This is the optional style to apply to the `TableColumn`.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * This is the optional className to apply to the `TableColumn`.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The is the optional style to apply to the select field's menu container.
	   *
	   * @see {@link SelectFields/SelectField#style}
	   */
	  menuStyle: _propTypes2.default.object,
	
	  /**
	   * The is the optional class name to apply to the select field's menu container.
	   *
	   * @see {@link SelectFields/SelectField#className}
	   */
	  menuClassName: _propTypes2.default.string,
	
	  /**
	   * This is how the select field should be fixed within the table. When this is omitted,
	   * it will automatically use the responsive table as the fixture so that the select field
	   * will close/adjust itself to the scrolling of the table.
	   *
	   * @see {@link Helpers/Layover#fixedTo}
	   */
	  fixedTo: _fixedToShape2.default,
	
	  /**
	   * Boolean if the select field should span the entire width of the column.
	   */
	  fullWidth: _propTypes2.default.bool,
	
	  /**
	   * The position for the select field.
	   *
	   * @see {@link SelectFields/SelectField#position}
	   */
	  position: _positionShape2.default,
	
	  /**
	   * This is injected by the `TableRow` component.
	   * @access private
	   */
	  header: _propTypes2.default.bool,
	
	  /**
	   * @access private
	   */
	  adjusted: _propTypes2.default.bool,
	
	  /**
	   * The optional tooltip to render on hover.
	   *
	   * @see {@link DataTables/TableColumn#tooltipLabel}
	   */
	  tooltipLabel: _propTypes2.default.string,
	
	  /**
	   * An optional delay to apply to the tooltip before it appears.
	   *
	   * @see {@link DataTables/TableColumn#tooltipDelay}
	   */
	  tooltipDelay: _propTypes2.default.number,
	
	  /**
	   * The position of the tooltip.
	   *
	   * @see {@link DataTables/TableColumn#tooltipPosition}
	   */
	  tooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the `fixedTo` element scrolls.
	   *
	   * @see {@link Helpers/Layover#repositionOnScroll}
	   */
	  repositionOnScroll: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the window resizes.
	   *
	   * @see {@link Helpers/Layover#repositionOnResize}
	   */
	  repositionOnResize: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu logic should be simplified without any viewport logic and position
	   * based on the relative position of the menu. This will most like require some additional
	   * styles applied to the menu.
	   *
	   * @see {@link Helpers/Layover#simplified}
	   */
	  simplifiedMenu: _propTypes2.default.bool,
	
	  wrapperStyle: (0, _deprecated2.default)(_propTypes2.default.object, 'There is no longer a wrapper'),
	  wrapperClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'There is no longer a wrapper')
	};
	SelectFieldColumn.defaultProps = {
	  position: SelectFieldColumn.Positions.BELOW,
	  fullWidth: true,
	  repositionOnScroll: true,
	  repositionOnResize: false,
	  simplifiedMenu: false
	};
	exports.default = (0, _withTableFixes2.default)(SelectFieldColumn, 'select-field');

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _contextTypes = __webpack_require__(163);
	
	var _contextTypes2 = _interopRequireDefault(_contextTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `TableBody` component is used for managing the state of all
	 * `TableRow` inside of it.
	 */
	var TableBody = function (_Component) {
	  _inherits(TableBody, _Component);
	
	  function TableBody() {
	    _classCallCheck(this, TableBody);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  TableBody.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        className = _props.className,
	        props = _objectWithoutProperties(_props, ['children', 'className']);
	
	    var selectedRows = this.context.selectedRows;
	
	
	    var rows = children ? _react.Children.map(_react.Children.toArray(children), function (row, i) {
	      var uncontrolled = typeof row.props.selected === 'undefined';
	      return _react2.default.cloneElement(row, {
	        selected: uncontrolled ? selectedRows[i] : row.props.selected
	      });
	    }) : null;
	
	    return _react2.default.createElement(
	      'tbody',
	      _extends({}, props, { className: (0, _classnames2.default)('md-table-body', className) }),
	      rows
	    );
	  };
	
	  return TableBody;
	}(_react.Component);
	
	TableBody.propTypes = {
	  /**
	   * An optional style to apply to the tbody.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the tbody.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * A list or a single item of `TableRow` components to render.
	   */
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)])
	};
	TableBody.contextTypes = _contextTypes2.default;
	exports.default = TableBody;

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CSSTransitionGroup = __webpack_require__(38);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CSSTransitionGroupTick = __webpack_require__(29);
	
	var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);
	
	var _oneRequired = __webpack_require__(351);
	
	var _oneRequired2 = _interopRequireDefault(_oneRequired);
	
	var _invalidIf = __webpack_require__(43);
	
	var _invalidIf2 = _interopRequireDefault(_invalidIf);
	
	var _CardTitleBlock = __webpack_require__(330);
	
	var _CardTitleBlock2 = _interopRequireDefault(_CardTitleBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `TableCardHeader` is used when contextual actions should appear when
	 * a user selects a row.
	 */
	var TableCardHeader = function (_PureComponent) {
	  _inherits(TableCardHeader, _PureComponent);
	
	  function TableCardHeader(props) {
	    _classCallCheck(this, TableCardHeader);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));
	
	    _this.state = { animating: false };
	    return _this;
	  }
	
	  TableCardHeader.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    var visible = this.props.visible;
	    var nVisible = nextProps.visible,
	        transitionEnterTimeout = nextProps.transitionEnterTimeout,
	        transitionLeaveTimeout = nextProps.transitionLeaveTimeout;
	
	    var timeout = !nVisible ? transitionLeaveTimeout : transitionEnterTimeout;
	    if (visible !== nVisible) {
	      if (this._timeout) {
	        clearTimeout(this._timeout);
	      }
	
	      this._timeout = setTimeout(function () {
	        _this2._timeout = setTimeout(function () {
	          _this2._timeout = null;
	          _this2.setState({ animating: false });
	        }, timeout);
	      }, _CSSTransitionGroupTick2.default);
	
	      if (!this.state.animating) {
	        this.setState({ animating: true });
	      }
	    }
	  };
	
	  TableCardHeader.prototype._cloneCellRight = function _cloneCellRight(noAdjust, children) {
	    if (noAdjust || !children) {
	      return children;
	    }
	
	    return _react.Children.map(_react.Children.toArray(children), function (child, i) {
	      if (i === 0) {
	        return (0, _react.cloneElement)(child, { className: (0, _classnames2.default)('md-cell--right', child.props.className) });
	      }
	
	      return child;
	    });
	  };
	
	  TableCardHeader.prototype._cloneLeftChildren = function _cloneLeftChildren(noClone, children) {
	    if (noClone || !children) {
	      return children;
	    }
	
	    return _react.Children.map(_react.Children.toArray(children), function (child) {
	      return (0, _react.cloneElement)(child, {
	        className: (0, _classnames2.default)('md-btn--dialog', child.props.className)
	      });
	    });
	  };
	
	  TableCardHeader.prototype.render = function render() {
	    var animating = this.state.animating;
	
	    var _props = this.props,
	        style = _props.style,
	        className = _props.className,
	        title = _props.title,
	        titleId = _props.titleId,
	        actions = _props.actions,
	        contextualTitleId = _props.contextualTitleId,
	        contextualChildren = _props.contextualChildren,
	        noActionsAdjust = _props.noActionsAdjust,
	        noChildrenAdjust = _props.noChildrenAdjust,
	        noLeftChildrenClone = _props.noLeftChildrenClone,
	        visible = _props.visible,
	        propChildren = _props.children,
	        propLeftChildren = _props.leftChildren,
	        propContextualTitle = _props.contextualTitle,
	        props = _objectWithoutProperties(_props, ['style', 'className', 'title', 'titleId', 'actions', 'contextualTitleId', 'contextualChildren', 'noActionsAdjust', 'noChildrenAdjust', 'noLeftChildrenClone', 'visible', 'children', 'leftChildren', 'contextualTitle']);
	
	    var _props2 = this.props,
	        children = _props2.children,
	        leftChildren = _props2.leftChildren,
	        contextualTitle = _props2.contextualTitle;
	
	    children = this._cloneCellRight(noChildrenAdjust, children);
	    leftChildren = this._cloneLeftChildren(noLeftChildrenClone, leftChildren);
	
	    if (title) {
	      children = _react2.default.createElement(
	        'div',
	        { className: 'md-card-title', key: 'main-title' },
	        _react2.default.createElement(_CardTitleBlock2.default, { id: titleId, title: title }),
	        children
	      );
	    } else if (leftChildren) {
	      leftChildren = _react.Children.toArray(leftChildren);
	
	      if (children) {
	        children = leftChildren.concat(_react.Children.toArray(children));
	      } else {
	        children = leftChildren;
	      }
	    }
	
	    if (contextualTitle) {
	      contextualTitle = _react2.default.createElement(
	        'h2',
	        {
	          id: contextualTitleId,
	          className: 'md-card-title--title md-card-title--title-contextual',
	          tabIndex: contextualTitleId ? -1 : null
	        },
	        contextualTitle
	      );
	    }
	
	    var contextualHeader = _react2.default.createElement(
	      'div',
	      { key: 'contextual-header', className: 'md-card-title md-card-title--contextual' },
	      contextualTitle,
	      contextualChildren,
	      this._cloneCellRight(noActionsAdjust, actions)
	    );
	
	    var mergedStyles = style;
	    if (animating) {
	      mergedStyles = Object.assign({}, style, { overflow: 'hidden' });
	    }
	
	    return _react2.default.createElement(
	      _CSSTransitionGroup2.default,
	      _extends({}, props, {
	        style: mergedStyles,
	        className: (0, _classnames2.default)('md-table-card-header', {
	          'md-table-card-header--no-title': !title
	        }, className)
	      }),
	      children,
	      visible ? contextualHeader : null
	    );
	  };
	
	  return TableCardHeader;
	}(_react.PureComponent);
	
	TableCardHeader.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The component to render as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * The transition name to use when the contextual header appears.
	   */
	  transitionName: _propTypes2.default.string.isRequired,
	
	  /**
	   * The transition time to use when the contextual header appears.
	   */
	  transitionEnterTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * The transition time to use when the contextual header disappears.
	   */
	  transitionLeaveTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * An optional title to display. It is invalid to have both `title` and `leftChildren`
	   * defined as only one will be used.
	   */
	  title: (0, _oneRequired2.default)(_propTypes2.default.node, 'leftChildren', 'children'),
	
	  /**
	   * An optional id to provide to the title.
	   */
	  titleId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional title to display in the contextual header. This will get wrapped in an `h2`
	   * tag and additional styles applied.
	   */
	  contextualTitle: _propTypes2.default.node,
	
	  /**
	   * An optional id to provide to the contextual title.
	   */
	  contextualTitleId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * Any additional children to display in the contextual header. This will be displayed after
	   * the optional `contextualTile` and before the `actions`.
	   */
	  contextualChildren: _propTypes2.default.node,
	
	  /**
	   * An optional button or list of buttons to display instead of a title.
	   */
	  leftChildren: (0, _invalidIf2.default)(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)]), 'title'),
	
	  /**
	   * An additional children to display after the `title` or `leftChildren` prop.
	   * This is _normally_ a list of icon button or menu button.
	   */
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)]),
	
	  /**
	   * An optional button/menu button or a list of button/menu button to display in the
	   * contextual header once the user has selected a row or multiple rows.
	   */
	  actions: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)]),
	
	  /**
	   * Boolean if the `actions` prop should not have each element cloned with additional
	   * class names.
	   */
	  noActionsAdjust: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `children` prop should not have each element cloned with additional
	   * class names.
	   */
	  noChildrenAdjust: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `leftChildren` prop should not have each element cloned with additional
	   * class names.
	   */
	  noLeftChildrenClone: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the contextual header is currently visible.
	   */
	  visible: _propTypes2.default.bool.isRequired
	};
	TableCardHeader.defaultProps = {
	  component: 'header',
	  transitionName: 'md-drop-down',
	  transitionEnterTimeout: 150,
	  transitionLeaveTimeout: 150
	};
	exports.default = TableCardHeader;

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SelectionControl = __webpack_require__(87);
	
	var _SelectionControl2 = _interopRequireDefault(_SelectionControl);
	
	var _findTable = __webpack_require__(164);
	
	var _findTable2 = _interopRequireDefault(_findTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableCheckbox = function (_Component) {
	  _inherits(TableCheckbox, _Component);
	
	  function TableCheckbox() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TableCheckbox);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this._td = null, _this._header = false, _this._handleMount = function (td) {
	      if (td) {
	        var header = (0, _findTable2.default)(td).querySelector('thead');
	        var index = td.parentNode.rowIndex - (header ? 1 : 0);
	
	        if (td.parentNode.parentNode.tagName === 'TBODY') {
	          _this.context.createCheckbox(index);
	        }
	        _this._td = td;
	        _this._header = header;
	      } else if (_this._td) {
	        var _index = _this._td.parentNode.rowIndex;
	        _this.context.removeCheckbox(_index - (_this._header ? 1 : 0));
	        _this._td = null;
	        _this._header = false;
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  TableCheckbox.prototype.render = function render() {
	    var _props = this.props,
	        checked = _props.checked,
	        index = _props.index,
	        props = _objectWithoutProperties(_props, ['checked', 'index']);
	
	    var _context = this.context,
	        checkedIcon = _context.checkedIcon,
	        uncheckedIcon = _context.uncheckedIcon,
	        indeterminateIcon = _context.indeterminateIcon,
	        indeterminate = _context.indeterminate,
	        header = _context.header,
	        footer = _context.footer,
	        rowId = _context.rowId,
	        baseName = _context.baseName,
	        checkboxHeaderLabel = _context.checkboxHeaderLabel,
	        checkboxLabelTemplate = _context.checkboxLabelTemplate;
	
	
	    var Cell = header ? 'th' : 'td';
	    var label = void 0;
	    if (header) {
	      label = checkboxHeaderLabel;
	    } else if (typeof checkboxLabelTemplate === 'function') {
	      label = checkboxLabelTemplate(index);
	    } else {
	      label = checkboxLabelTemplate.replace(/{{row}}/g, index);
	    }
	
	    var content = _react2.default.createElement(_SelectionControl2.default, _extends({}, props, {
	      id: rowId,
	      name: baseName + '-checkbox',
	      type: 'checkbox',
	      checked: checked,
	      checkedCheckboxIcon: checkedIcon,
	      uncheckedCheckboxIcon: header && indeterminate ? indeterminateIcon : uncheckedIcon,
	      'aria-label': label
	    }));
	    var fixedHeader = header && this.context.fixedHeader;
	    var fixedFooter = footer && this.context.fixedFooter;
	
	    if (fixedHeader) {
	      content = _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('md-table-column__fixed', {
	            'md-table-column__fixed--header': fixedHeader,
	            'md-table-column__fixed--footer': fixedFooter
	          })
	        },
	        _react2.default.cloneElement(content, {
	          className: (0, _classnames2.default)({
	            'md-table-checkbox--header': header,
	            'md-table-checkbox--footer': footer
	          })
	        })
	      );
	    }
	
	    return _react2.default.createElement(
	      Cell,
	      {
	        className: (0, _classnames2.default)('md-table-checkbox', {
	          'md-table-column--fixed': fixedHeader
	        }),
	        scope: header ? 'col' : undefined,
	        ref: this._handleMount
	      },
	      content
	    );
	  };
	
	  return TableCheckbox;
	}(_react.Component);
	
	TableCheckbox.propTypes = {
	  index: _propTypes2.default.number,
	  checked: _propTypes2.default.bool
	};
	TableCheckbox.contextTypes = {
	  rowId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	  baseName: _propTypes2.default.string.isRequired,
	  indeterminate: _propTypes2.default.bool,
	  checkedIcon: _propTypes2.default.element,
	  uncheckedIcon: _propTypes2.default.element,
	  indeterminateIcon: _propTypes2.default.element,
	  checkboxHeaderLabel: _propTypes2.default.string.isRequired,
	  checkboxLabelTemplate: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	  createCheckbox: _propTypes2.default.func.isRequired,
	  removeCheckbox: _propTypes2.default.func.isRequired,
	  header: _propTypes2.default.bool,
	  footer: _propTypes2.default.bool,
	  fixedHeader: _propTypes2.default.bool.isRequired,
	  fixedFooter: _propTypes2.default.bool.isRequired
	};
	exports.default = TableCheckbox;

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _contextTypes = __webpack_require__(163);
	
	var _contextTypes2 = _interopRequireDefault(_contextTypes);
	
	var _headerContextTypes = __webpack_require__(232);
	
	var _headerContextTypes2 = _interopRequireDefault(_headerContextTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A `thead` component to use in the `DataTable` component. This
	 * will automatically update the header row to check if it is selected
	 * and inject a function to toggle all rows selected if the row is
	 * uncontrolled. It will also automatically attempt to set the `TableColumn`
	 * components to be the header type.
	 */
	var TableHeader = function (_Component) {
	  _inherits(TableHeader, _Component);
	
	  function TableHeader() {
	    _classCallCheck(this, TableHeader);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  TableHeader.prototype.getChildContext = function getChildContext() {
	    return _extends({}, this.context, {
	      header: true
	    });
	  };
	
	  TableHeader.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = _objectWithoutProperties(_props, ['className', 'children']);
	
	    var allSelected = this.context.allSelected;
	
	    var header = _react2.default.Children.only(children);
	    var selected = typeof header.props.selected === 'undefined' ? allSelected : header.props.selected;
	
	    var row = _react2.default.cloneElement(header, { selected: selected });
	
	    return _react2.default.createElement(
	      'thead',
	      _extends({}, props, { className: (0, _classnames2.default)('md-table-header', className) }),
	      row
	    );
	  };
	
	  return TableHeader;
	}(_react.Component);
	
	TableHeader.contextTypes = _contextTypes2.default;
	TableHeader.childContextTypes = _headerContextTypes2.default;
	TableHeader.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the table header
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * This should be a single `TableRow` component. The `custom` validation will
	   * warn you if there are more than one children given or none at all.
	   */
	  children: function children(props, propName, component) {
	    try {
	      _react2.default.Children.only(props.children);
	      return null;
	    } catch (e) {
	      var amt = props.children ? props.children.length : 0;
	      return new Error('There must only be one child in a \'' + component + '\', but ' + amt + ' were given.');
	    }
	  }
	};
	exports.default = TableHeader;

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(5);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _getField = __webpack_require__(8);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _ResizeObserver = __webpack_require__(35);
	
	var _ResizeObserver2 = _interopRequireDefault(_ResizeObserver);
	
	var _SelectField = __webpack_require__(241);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _FontIcon = __webpack_require__(12);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _getDeprecatedIcon = __webpack_require__(21);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _findTable = __webpack_require__(164);
	
	var _findTable2 = _interopRequireDefault(_findTable);
	
	var _TableFooter = __webpack_require__(333);
	
	var _TableFooter2 = _interopRequireDefault(_TableFooter);
	
	var _TableColumn = __webpack_require__(82);
	
	var _TableColumn2 = _interopRequireDefault(_TableColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `TablePagination` component is used to generate the table footer that helps
	 * pagination through a large dataset by limiting the number of rows per page.
	 * The pagination will always be placed persistently at the bottom of the table
	 * so that when a user scrolls to the right, they will always be able to use the
	 * pagination.
	 */
	var TablePagination = function (_PureComponent) {
	  _inherits(TablePagination, _PureComponent);
	
	  function TablePagination(props, context) {
	    _classCallCheck(this, TablePagination);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    var controlledPage = typeof props.page !== 'undefined';
	    var controlledRowsPerPage = typeof props.rowsPerPage !== 'undefined';
	    var rowsPerPage = controlledRowsPerPage ? props.rowsPerPage : props.defaultRowsPerPage;
	    var page = controlledPage ? props.page : props.defaultPage;
	    _this.state = {
	      start: (page - 1) * rowsPerPage,
	      controlsMarginLeft: 0
	    };
	
	    if (!controlledPage) {
	      _this.state.page = page;
	    }
	
	    if (!controlledRowsPerPage) {
	      _this.state.rowsPerPage = props.defaultRowsPerPage;
	    }
	
	    _this._table = null;
	    _this._ticking = false;
	    return _this;
	  }
	
	  TablePagination.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _props = this.props,
	        rowsPerPage = _props.rowsPerPage,
	        page = _props.page;
	
	    if (page !== nextProps.page || rowsPerPage !== nextProps.rowsPerPage) {
	      var rpp = (0, _getField2.default)(nextProps, this.state, 'rowsPerPage');
	      var p = (0, _getField2.default)(nextProps, this.state, 'page');
	
	      this.setState({ start: (p - 1) * rpp });
	    }
	  };
	
	  TablePagination.prototype.render = function render() {
	    var _state = this.state,
	        controlsMarginLeft = _state.controlsMarginLeft,
	        start = _state.start;
	
	    var _props2 = this.props,
	        className = _props2.className,
	        selectFieldStyle = _props2.selectFieldStyle,
	        selectFieldClassName = _props2.selectFieldClassName,
	        selectFieldInputStyle = _props2.selectFieldInputStyle,
	        selectFieldInputClassName = _props2.selectFieldInputClassName,
	        rows = _props2.rows,
	        rowsPerPageLabel = _props2.rowsPerPageLabel,
	        rowsPerPageItems = _props2.rowsPerPageItems,
	        incrementIcon = _props2.incrementIcon,
	        decrementIcon = _props2.decrementIcon,
	        simplifiedMenu = _props2.simplifiedMenu,
	        incrementIconChildren = _props2.incrementIconChildren,
	        incrementIconClassName = _props2.incrementIconClassName,
	        decrementIconChildren = _props2.decrementIconChildren,
	        decrementIconClassName = _props2.decrementIconClassName,
	        propId = _props2.id,
	        propIncrementId = _props2.incrementId,
	        propDecrementId = _props2.decrementId,
	        onPagination = _props2.onPagination,
	        propRowsPerPage = _props2.rowsPerPage,
	        propPage = _props2.page,
	        defaultPage = _props2.defaultPage,
	        defaultRowsPerPage = _props2.defaultRowsPerPage,
	        props = _objectWithoutProperties(_props2, ['className', 'selectFieldStyle', 'selectFieldClassName', 'selectFieldInputStyle', 'selectFieldInputClassName', 'rows', 'rowsPerPageLabel', 'rowsPerPageItems', 'incrementIcon', 'decrementIcon', 'simplifiedMenu', 'incrementIconChildren', 'incrementIconClassName', 'decrementIconChildren', 'decrementIconClassName', 'id', 'incrementId', 'decrementId', 'onPagination', 'rowsPerPage', 'page', 'defaultPage', 'defaultRowsPerPage']);
	
	    var baseId = this.context.baseId;
	
	    var rowsPerPage = (0, _getField2.default)(this.props, this.state, 'rowsPerPage');
	    var _props3 = this.props,
	        id = _props3.id,
	        incrementId = _props3.incrementId,
	        decrementId = _props3.decrementId;
	
	    if (!id) {
	      id = baseId + '-pagination';
	    }
	
	    if (!incrementId) {
	      incrementId = id + '-increment-btn';
	    }
	
	    if (!decrementId) {
	      decrementId = id + '-decrement-btn';
	    }
	
	    var pagination = start + 1 + '-' + Math.min(rows, start + rowsPerPage) + ' of ' + rows;
	    return _react2.default.createElement(
	      _TableFooter2.default,
	      _extends({}, props, { className: (0, _classnames2.default)('md-table-footer--pagination', className) }),
	      _react2.default.createElement(_ResizeObserver2.default, { watchWidth: true, component: 'tr', onResize: this._throttledPosition }),
	      _react2.default.createElement(_ResizeObserver2.default, { watchWidth: true, component: 'tr', target: this._table, onResize: this._throttledPosition }),
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          _TableColumn2.default,
	          { colSpan: '100%' },
	          _react2.default.createElement(
	            'div',
	            {
	              ref: this._setControls,
	              className: 'md-table-pagination md-table-pagination--controls md-text',
	              style: { marginLeft: controlsMarginLeft }
	            },
	            _react2.default.createElement(
	              'span',
	              { className: 'md-table-pagination__label' },
	              rowsPerPageLabel
	            ),
	            _react2.default.createElement(_SelectField2.default, {
	              id: id,
	              menuItems: rowsPerPageItems,
	              position: _SelectField2.default.Positions.BELOW,
	              style: selectFieldStyle,
	              className: selectFieldClassName,
	              inputStyle: selectFieldInputStyle,
	              inputClassName: (0, _classnames2.default)('md-select-field--pagination', selectFieldInputClassName),
	              value: rowsPerPage,
	              onChange: this._setRowsPerPage,
	              simplifiedMenu: simplifiedMenu
	            }),
	            _react2.default.createElement(
	              'span',
	              { className: 'md-table-pagination--label' },
	              pagination
	            ),
	            _react2.default.createElement(_Button2.default, {
	              id: decrementId,
	              icon: true,
	              onClick: this._decrement,
	              disabled: start === 0,
	              iconEl: (0, _getDeprecatedIcon2.default)(decrementIconClassName, decrementIconChildren, decrementIcon)
	            }),
	            _react2.default.createElement(_Button2.default, {
	              id: incrementId,
	              icon: true,
	              onClick: this._increment,
	              disabled: start + rowsPerPage >= rows,
	              iconEl: (0, _getDeprecatedIcon2.default)(incrementIconClassName, incrementIconChildren, incrementIcon)
	            })
	          ),
	          _react2.default.createElement('div', { className: 'md-table-pagination' })
	        )
	      )
	    );
	  };
	
	  return TablePagination;
	}(_react.PureComponent);
	
	TablePagination.propTypes = {
	  /**
	   * An optional id to provide to the select field. If this is omitted, it will be
	   * the `DataTable`'s `baseId` with '-pagination'.
	   *
	   * @see {@link DataTables/DataTable#baseId}
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to provide to the increment icon button. If this is omitted, it will be
	   * the `id` with '-increment-btn'.
	   *
	   * @see {@link #id}
	   */
	  incrementId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to provide to the decrement icon button. If this is omitted, it will be
	   * the `id` with '-decrement-btn'.
	   *
	   * @see {@link #id}
	   */
	  decrementId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply to the `tfoot` tag.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `tfoot` tag.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the select field.
	   *
	   * @see {@link SelectFields/SelectField#style}
	   */
	  selectFieldStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the select field.
	   *
	   * @see {@link SelectFields/SelectField#className}
	   */
	  selectFieldClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the select field's input.
	   *
	   * @see {@link SelectFields/SelectField#inputStyle}
	   */
	  selectFieldInputStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the select field's input.
	   *
	   * @see {@link SelectFields/SelectField#inputClassName}
	   */
	  selectFieldInputClassName: _propTypes2.default.string,
	
	  /**
	   * Boolean if the select field should use the simplified menu logic.
	   *
	   * @see {@link Helpers/Layover#simplified}
	   */
	  simplifiedMenu: _propTypes2.default.bool,
	
	  /**
	   * A function to call when a user clicks the increment or decrement pagination
	   * icon button. This function will be given the new start index and the number
	   * or rows per page as well as the current page.
	   *
	   * ```js
	   * onPagination(newStart, rowsPerPage, currentPage);
	   * ```
	   */
	  onPagination: _propTypes2.default.func.isRequired,
	
	  /**
	   * The current value for the select field holding the number of rows per page.
	   */
	  rowsPerPage: _propTypes2.default.number,
	
	  /**
	   * The current page for the pagination. This will make the component controlled, so the only way to get pagination
	   * is making sure you are updating this prop after the `onPagination` callback is called.
	   *
	   * Pages start from 1 instead of 0.
	   */
	  page: _propTypes2.default.number,
	
	  /**
	   * The default page to start from for the pagination. Pages start from 1 instead of 0.
	   */
	  defaultPage: _propTypes2.default.number.isRequired,
	
	  /**
	   * The default number of rows per page to display. This will be the value for the
	   * `SelectField`.
	   */
	  defaultRowsPerPage: _propTypes2.default.number.isRequired,
	
	  /**
	   * The label to use for the rows per page `SelectField`.
	   */
	  rowsPerPageLabel: _propTypes2.default.node.isRequired,
	
	  /**
	   * A list of numbers for the amount of rows per page to display at a time.
	   * This will be rendered into the `SelectField`.
	   */
	  rowsPerPageItems: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
	
	  /**
	   * The total number of rows that can be displayed. This is the unfiltered/non-subset
	   * number of rows. This is used to help calculate the increment/decrement values to
	   * display and determine if the user can increment/decrement again.
	   */
	  rows: _propTypes2.default.number.isRequired,
	
	  /**
	   * The icon to use for the increment icon button.
	   */
	  incrementIcon: _propTypes2.default.element,
	
	  /**
	   * The icon to use for the decrement icon button.
	   */
	  decrementIcon: _propTypes2.default.element,
	
	  incrementIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `incrementIcon` prop instead'),
	  incrementIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `incrementIcon` prop instead'),
	  decrementIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `decrementIcon` prop instead'),
	  decrementIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `decrementIcon` prop instead')
	};
	TablePagination.contextTypes = {
	  baseId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	  fixedFooter: _propTypes2.default.bool
	};
	TablePagination.defaultProps = {
	  defaultPage: 1,
	  defaultRowsPerPage: 10,
	  rowsPerPageLabel: 'Rows per page:',
	  rowsPerPageItems: [10, 20, 30, 40, 50, 100],
	  incrementIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'keyboard_arrow_right'
	  ),
	  decrementIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'keyboard_arrow_left'
	  ),
	  simplifiedMenu: false
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._setControls = function (controls) {
	    _this2._controls = controls;
	    _this2._table = (0, _findTable2.default)(controls);
	
	    if (_this2._table && _this2.context.fixedFooter) {
	      _this2._table.addEventListener('scroll', _this2._throttledPosition);
	    }
	  };
	
	  this._position = function () {
	    if (_this2._table) {
	      var fixedFooter = _this2.context.fixedFooter;
	      var _table = _this2._table,
	          offsetWidth = _table.offsetWidth,
	          scrollLeft = _table.scrollLeft;
	
	
	      var controlsMarginLeft = offsetWidth - _this2._controls.offsetWidth;
	      if (fixedFooter) {
	        controlsMarginLeft += scrollLeft;
	      }
	
	      _this2.setState({
	        controlsMarginLeft: Math.max(24, controlsMarginLeft)
	      });
	    }
	  };
	
	  this._throttledPosition = function () {
	    if (!_this2._ticking) {
	      requestAnimationFrame(function () {
	        _this2._ticking = false;
	        _this2._position();
	      });
	    }
	
	    _this2._ticking = true;
	  };
	
	  this._increment = function () {
	    var _props4 = _this2.props,
	        rows = _props4.rows,
	        onPagination = _props4.onPagination;
	    var start = _this2.state.start;
	
	    var rowsPerPage = (0, _getField2.default)(_this2.props, _this2.state, 'rowsPerPage');
	    var page = (0, _getField2.default)(_this2.props, _this2.state, 'page');
	
	    // Only correct multiple of rows per page
	    var max = rows - rows % rowsPerPage;
	
	    var newStart = Math.min(start + rowsPerPage, max);
	    var nextPage = page + 1;
	
	    onPagination(newStart, rowsPerPage, nextPage);
	    if (typeof _this2.props.page === 'undefined') {
	      _this2.setState({ start: newStart, page: nextPage });
	    }
	  };
	
	  this._decrement = function () {
	    var start = _this2.state.start;
	
	    var page = (0, _getField2.default)(_this2.props, _this2.state, 'page');
	    var rowsPerPage = (0, _getField2.default)(_this2.props, _this2.state, 'rowsPerPage');
	    var newStart = Math.max(0, start - rowsPerPage);
	    var nextPage = page - 1;
	
	    _this2.props.onPagination(newStart, rowsPerPage, nextPage);
	    if (typeof _this2.props.page === 'undefined') {
	      _this2.setState({ start: newStart, page: nextPage });
	    }
	  };
	
	  this._setRowsPerPage = function (rowsPerPage) {
	    var page = 1;
	    var newStart = 0;
	    _this2.props.onPagination(newStart, rowsPerPage, page);
	    var nextState = void 0;
	    if (typeof _this2.props.rowsPerPage === 'undefined') {
	      nextState = { rowsPerPage: rowsPerPage };
	    }
	
	    if (typeof _this2.props.page === 'undefined') {
	      nextState = nextState || {};
	      nextState.start = newStart;
	    }
	
	    if (nextState) {
	      _this2.setState(nextState);
	    }
	  };
	};
	
	exports.default = TablePagination;

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _deprecated = __webpack_require__(5);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _getField = __webpack_require__(8);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _headerContextTypes = __webpack_require__(232);
	
	var _headerContextTypes2 = _interopRequireDefault(_headerContextTypes);
	
	var _rowContextTypes = __webpack_require__(859);
	
	var _rowContextTypes2 = _interopRequireDefault(_rowContextTypes);
	
	var _TableCheckbox = __webpack_require__(855);
	
	var _TableCheckbox2 = _interopRequireDefault(_TableCheckbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A component for displaying a row in a `DataTable`. This will
	 * automatically add a `Checkbox` component to the row if it is not
	 * a `plain` table.
	 */
	var TableRow = function (_Component) {
	  _inherits(TableRow, _Component);
	
	  function TableRow(props, context) {
	    _classCallCheck(this, TableRow);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this._handleMouseOver = function (e) {
	      if (_this.props.onMouseOver) {
	        _this.props.onMouseOver(e);
	      }
	
	      if (_this.context.header) {
	        return;
	      }
	
	      var target = e.target;
	      while (target && target.parentNode) {
	        if (target.classList && _this._ignoreHoverState(target.classList)) {
	          _this.setState({ hover: false });
	          return;
	        }
	
	        target = target.parentNode;
	      }
	
	      _this.setState({ hover: true });
	    };
	
	    _this._handleMouseLeave = function (e) {
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(e);
	      }
	
	      if (_this.context.header) {
	        return;
	      }
	
	      _this.setState({ hover: false });
	    };
	
	    _this._handleCheckboxClick = function (checked, e) {
	      var rowIndex = _this._row.rowIndex;
	
	      if (_this.props.onCheckboxClick) {
	        _this.props.onCheckboxClick(rowIndex, checked, e);
	      }
	
	      _this.context.toggleSelectedRow(rowIndex, _this.context.header, e);
	    };
	
	    _this._setRow = function (row) {
	      _this._row = row;
	    };
	
	    _this.state = { hover: false };
	    return _this;
	  }
	
	  TableRow.prototype.getChildContext = function getChildContext() {
	    var _context = this.context,
	        baseId = _context.baseId,
	        context = _objectWithoutProperties(_context, ['baseId']);
	
	    var id = baseId + '-' + (this._row ? this._row.rowIndex : null);
	    return _extends({}, context, {
	      rowId: context.header ? baseId + '-toggle-all' : id
	    });
	  };
	
	  /**
	   * Need to ignore adding the hover state if the mouse is over a menu/menu item
	   * or the edit dialog is open.
	   *
	   * @param {Function} classList - the classList to use for checking cn
	   * @return {Boolean} true if the hover state should be ignored for this classList
	   */
	
	
	  TableRow.prototype._ignoreHoverState = function _ignoreHoverState(classList) {
	    return classList.contains('md-list--menu') || classList.contains('md-edit-dialog');
	  };
	
	  TableRow.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        selected = _props.selected,
	        selectable = _props.selectable,
	        onCheckboxClick = _props.onCheckboxClick,
	        autoAdjust = _props.autoAdjust,
	        props = _objectWithoutProperties(_props, ['className', 'children', 'selected', 'selectable', 'onCheckboxClick', 'autoAdjust']);
	
	    var hover = this.state.hover;
	
	
	    var checkbox = void 0;
	    if (typeof selectable !== 'undefined' ? selectable : !this.context.plain && this.context.selectableRows) {
	      checkbox = _react2.default.createElement(_TableCheckbox2.default, {
	        key: 'checkbox',
	        checked: selected,
	        onChange: this._handleCheckboxClick,
	        index: this._row ? this._row.rowIndex : null
	      });
	    }
	
	    var length = _react.Children.count(children) - 1;
	    var columns = _react.Children.map(_react.Children.toArray(children), function (col, i) {
	      var adjusted = col.props.adjusted;
	      if (typeof adjusted === 'undefined') {
	        adjusted = i === length ? false : undefined;
	      }
	
	      return (0, _react.cloneElement)(col, {
	        cellIndex: i + (checkbox ? 1 : 0),
	        header: (0, _getField2.default)(col.props, _this2.context, 'header'),
	        adjusted: adjusted
	      });
	    });
	
	    return _react2.default.createElement(
	      'tr',
	      _extends({}, props, {
	        ref: this._setRow,
	        className: (0, _classnames2.default)('md-table-row', className, {
	          'md-table-row--hover': hover,
	          'md-table-row--active': !this.context.header && selected
	        }),
	        onMouseOver: this._handleMouseOver,
	        onMouseLeave: this._handleMouseLeave
	      }),
	      checkbox,
	      columns
	    );
	  };
	
	  return TableRow;
	}(_react.Component);
	
	TableRow.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the row.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * A single or list of `TableColumn` to display in the table.
	   *
	   * > The specs "require" at least 3 columns for a non-plain data table, but that isn't
	   * strictly enforced here.
	   */
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)]).isRequired,
	
	  /**
	   * An optional onClick function to call when a row is clicked.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * A function to call when the checkbox is clicked. This
	   * function will will be called with `(rowIndex, checked, event)`.
	   * The `TableBody` and `TableHeader` components will automatically
	   * merge in a function to toggle the checkbox.
	   */
	  onCheckboxClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call onMouseOver.
	   */
	  onMouseOver: _propTypes2.default.func,
	
	  /**
	   * An optional function to call onMouseLeave.
	   */
	  onMouseLeave: _propTypes2.default.func,
	
	  /**
	   * Boolean if the row is currently selected. If this value will be
	   * injected by the `TableHeader` or `TableBody` component.
	   */
	  selected: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the current row is selectable. This value will take precedence over anything inherited
	   * by the `DataTable`.
	   */
	  selectable: _propTypes2.default.bool,
	
	  autoAdjust: (0, _deprecated2.default)(_propTypes2.default.bool, 'Manually specify `grow` on one of the columns instead')
	};
	TableRow.contextTypes = _headerContextTypes2.default;
	TableRow.childContextTypes = _rowContextTypes2.default;
	exports.default = TableRow;

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _headerContextTypes = __webpack_require__(232);
	
	var _headerContextTypes2 = _interopRequireDefault(_headerContextTypes);
	
	var _omit = __webpack_require__(177);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rowContextTypes = (0, _omit2.default)(_extends({}, _headerContextTypes2.default, {
	  rowId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	}), ['baseId']);
	
	exports.default = rowContextTypes;

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DialogTitle = function (_PureComponent) {
	  _inherits(DialogTitle, _PureComponent);
	
	  function DialogTitle() {
	    _classCallCheck(this, DialogTitle);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  DialogTitle.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        className = _props.className,
	        props = _objectWithoutProperties(_props, ['children', 'className']);
	
	    if (!children) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      'h2',
	      _extends({}, props, { className: (0, _classnames2.default)('md-title md-title--dialog', className) }),
	      children
	    );
	  };
	
	  return DialogTitle;
	}(_react.PureComponent);
	
	DialogTitle.propTypes = {
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.node
	};
	exports.default = DialogTitle;

/***/ }),
/* 861 */,
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(7);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keyCodes = __webpack_require__(14);
	
	var _handleWindowClickListeners = __webpack_require__(90);
	
	var _handleWindowClickListeners2 = _interopRequireDefault(_handleWindowClickListeners);
	
	var _ResizeObserver = __webpack_require__(35);
	
	var _ResizeObserver2 = _interopRequireDefault(_ResizeObserver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `ExpansionList` component is a wrapper for the `ExpansionPanel` that helps
	 * determine which `ExpansionPanel` currently has tab focus and adjusts the column
	 * sizes in the header of the `ExpansionPanel`.
	 *
	 * The `ExpansionList` and `ExpansionPanel` components should have probably been
	 * implemented as a `table` instead of a `ul || ol` since it is more column based,
	 * but it would complicate the API to have dynamic row generation for the expanded
	 * panels. The expanded panels _might_ not follow the same column widths as their labels
	 * so a singular row with a div for expanded content might not work correctly.
	 */
	var ExpansionList = function (_PureComponent) {
	  _inherits(ExpansionList, _PureComponent);
	
	  function ExpansionList() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ExpansionList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = { columnWidths: [], focusedIndex: -1, overflown: false }, _this._setContainer = function (container) {
	      if (container !== null) {
	        _this._container = (0, _reactDom.findDOMNode)(container);
	        window.addEventListener('keyup', _this._determineTabFocus);
	
	        _this._width = _this._container.offsetWidth;
	        _this._calcColumnWidths();
	      }
	    }, _this._determineTabFocus = function (e) {
	      if ((e.which || e.keyCode) === _keyCodes.TAB) {
	        var panels = Array.prototype.slice.call((0, _reactDom.findDOMNode)(_this).querySelectorAll('.md-panel-header'));
	        _this.setState({ focusedIndex: panels.indexOf(e.target) });
	      }
	    }, _this._removeFocus = function () {
	      _this.setState({ focusedIndex: -1 });
	    }, _this._isOverflown = function (widths) {
	      if (!_this._container) {
	        return false;
	      }
	
	      var panel = _this._container.querySelector('.md-panel-header');
	      if (!panel) {
	        return false;
	      }
	
	      var collapser = _this._container.querySelector('.md-expansion-panel__collapser');
	      var collapserWidth = collapser ? collapser.offsetWidth : 0;
	      var styles = window.getComputedStyle(panel);
	      var maxWidth = panel.offsetWidth - parseFloat(styles.paddingLeft) - parseFloat(styles.paddingRight) - collapserWidth;
	
	      var totalWidth = widths.reduce(function (total, w) {
	        return total + w;
	      }, 0);
	      return totalWidth > maxWidth;
	    }, _this._getColumnWidths = function () {
	      if (!_this._container) {
	        return _this.state.columnWidths;
	      }
	
	      return [].slice.call(_this._container.querySelectorAll('.md-panel-header')).reduce(function (maxes, row) {
	        var columns = row.querySelectorAll('.md-panel-column');
	        for (var i = 0; i < columns.length; i++) {
	          var col = columns[i];
	          // Need to reset the widths if it has already been calculated to get a more accurate measurement.
	          var _col$style = col.style,
	              width = _col$style.width,
	              minWidth = _col$style.minWidth;
	
	          col.style.width = 'auto';
	          col.style.minWidth = 'auto';
	
	          // Only need to include the offsetWidth of the column because the child will really
	          // determine the width of the column. Since it has already been defined at this point,
	          // no additional work needs to be done.
	          maxes[i] = Math.max(col.offsetWidth, maxes[i] || 0);
	          col.style.width = width;
	          col.style.minWidth = minWidth;
	        }
	
	        return maxes;
	      }, [0]);
	    }, _this._calcColumnWidths = function () {
	      var columnWidths = _this.state.columnWidths;
	
	      var nextWidths = _this._getColumnWidths();
	      var overflown = _this._isOverflown(nextWidths);
	      if (_this.state.overflown !== overflown || columnWidths.length !== nextWidths.length || nextWidths.some(function (w, i) {
	        return w !== columnWidths[i];
	      })) {
	        _this.setState({ columnWidths: nextWidths, overflown: overflown });
	      }
	    }, _this._handleResize = function (_ref) {
	      var width = _ref.width;
	      var recalculateThreshold = _this.props.recalculateThreshold;
	
	      if (_this._width !== width && Math.abs(width - _this._width) >= recalculateThreshold) {
	        _this._width = width;
	        _this._calcColumnWidths();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ExpansionList.prototype.getChildContext = function getChildContext() {
	    var animateContent = this.props.animateContent;
	
	    return { animateContent: animateContent };
	  };
	
	  ExpansionList.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.children !== nextProps.children) {
	      this._calcColumnWidths();
	    }
	  };
	
	  ExpansionList.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    var focusedIndex = this.state.focusedIndex;
	
	    if (prevState.focusedIndex === focusedIndex || prevState.focusedIndex > -1 && focusedIndex > -1) {
	      return;
	    }
	
	    (0, _handleWindowClickListeners2.default)(this._removeFocus, this.state.focusedIndex !== -1);
	  };
	
	  ExpansionList.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.state.focusedIndex === -1) {
	      (0, _handleWindowClickListeners2.default)(this._removeFocus, false);
	    }
	
	    window.removeEventListener('keyup', this._determineTabFocus);
	  };
	
	  /**
	   * Since this should really be rendered as a table, need to calculate the max width for each _column_
	   * on the panel's header and apply that as a min width for the other panels.
	   */
	
	
	  ExpansionList.prototype.render = function render() {
	    var _state = this.state,
	        columnWidths = _state.columnWidths,
	        focusedIndex = _state.focusedIndex,
	        overflown = _state.overflown;
	
	    var _props = this.props,
	        children = _props.children,
	        className = _props.className,
	        Component = _props.component,
	        animateContent = _props.animateContent,
	        recalculateThreshold = _props.recalculateThreshold,
	        props = _objectWithoutProperties(_props, ['children', 'className', 'component', 'animateContent', 'recalculateThreshold']);
	
	    var panels = _react.Children.map(children, function (child, i) {
	      return (0, _react.cloneElement)(child, {
	        key: child.key || i,
	        overflown: overflown,
	        columnWidths: columnWidths,
	        focused: focusedIndex === i
	      });
	    });
	    return _react2.default.createElement(
	      Component,
	      _extends({}, props, {
	        ref: this._setContainer,
	        className: (0, _classnames2.default)('md-expansion-panel-list', className)
	      }),
	      _react2.default.createElement(_ResizeObserver2.default, { watchWidth: true, onResize: this._handleResize }),
	      panels
	    );
	  };
	
	  return ExpansionList;
	}(_react.PureComponent);
	
	ExpansionList.propTypes = {
	  /**
	   * An optional style object to apply to the list.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the list.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The children should be a list or singular `ExpansionPanel` component
	   * to render with some additional props injected.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * The component to render the list as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	  /**
	   * Boolean if all the expansion panels in the list should animate when their content's visibility
	   * changes. This is just a quicker way to disable all animations instead of having to toggle it off
	   * on each panel.
	   *
	   * > The default value is really `true` since it gets passed down to the `Collapse` component.
	   */
	  animateContent: _propTypes2.default.bool,
	
	  /**
	   * The threshold that should be used for when the list should recalculate the positioning of all
	   * the columns. This will only compare the difference between updates.
	   * So if the size changes from 80 -> 120 -> 160 -> 140. It will only update on the third resize (160)
	   */
	  recalculateThreshold: _propTypes2.default.number.isRequired
	};
	ExpansionList.defaultProps = {
	  component: 'ul',
	  recalculateThreshold: 80
	};
	ExpansionList.childContextTypes = {
	  animateContent: _propTypes2.default.bool
	};
	exports.default = ExpansionList;

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(7);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(5);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _getField = __webpack_require__(8);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _themeColors = __webpack_require__(11);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _getCollapserStyles = __webpack_require__(129);
	
	var _getCollapserStyles2 = _interopRequireDefault(_getCollapserStyles);
	
	var _controlled = __webpack_require__(15);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _Paper = __webpack_require__(37);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _AccessibleFakeButton = __webpack_require__(70);
	
	var _AccessibleFakeButton2 = _interopRequireDefault(_AccessibleFakeButton);
	
	var _Collapse = __webpack_require__(55);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _FontIcon = __webpack_require__(12);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _getDeprecatedIcon = __webpack_require__(21);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _PanelContent = __webpack_require__(864);
	
	var _PanelContent2 = _interopRequireDefault(_PanelContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LABEL_FONT_SIZE = 15;
	var LINE_HEIGHT = 1.42857;
	var SINGLE_LINE_HEIGHT = LABEL_FONT_SIZE * LINE_HEIGHT;
	
	/**
	 * The `ExpansionPanel` component needs to be used with the `ExpansionList`
	 * component. The only reason is that the `ExpansionPanel` should really
	 * be rendered as a table, but it was a bit hard to have a single component
	 * dynamically rendering another row when expanded. It couldn't be in the
	 * same row since the expanded content might not have the same columns.
	 */
	
	var ExpansionPanel = function (_PureComponent) {
	  _inherits(ExpansionPanel, _PureComponent);
	
	  function ExpansionPanel(props, context) {
	    _classCallCheck(this, ExpansionPanel);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props, context));
	
	    _this._determineIfTwoLine = function () {
	      var twoLine = false;
	      Array.prototype.slice.call((0, _reactDom.findDOMNode)(_this).querySelectorAll('.md-panel-column')).some(function (el) {
	        return twoLine = el.offsetHeight > SINGLE_LINE_HEIGHT;
	      });
	
	      _this.setState({ twoLine: twoLine });
	    };
	
	    _this._handleClick = function () {
	      var expanded = !_this._isExpanded(_this.props, _this.state);
	      if (_this.props.onExpandToggle) {
	        _this.props.onExpandToggle(expanded);
	      }
	
	      if (typeof _this.props.expanded === 'undefined') {
	        _this.setState({ expanded: expanded });
	      }
	    };
	
	    _this._handleSave = function (e) {
	      var _this$props = _this.props,
	          onSave = _this$props.onSave,
	          onExpandToggle = _this$props.onExpandToggle,
	          closeOnSave = _this$props.closeOnSave;
	
	      if (onSave) {
	        onSave(e);
	      }
	
	      if (closeOnSave) {
	        if (onExpandToggle) {
	          onExpandToggle(false);
	        }
	
	        if (typeof _this.props.expanded === 'undefined') {
	          _this.setState({ expanded: false });
	        }
	      }
	    };
	
	    _this._handleCancel = function (e) {
	      var _this$props2 = _this.props,
	          onCancel = _this$props2.onCancel,
	          onExpandToggle = _this$props2.onExpandToggle,
	          closeOnCancel = _this$props2.closeOnCancel;
	
	      if (onCancel) {
	        onCancel(e);
	      }
	
	      if (closeOnCancel) {
	        if (onExpandToggle) {
	          onExpandToggle(false);
	        }
	
	        if (typeof _this.props.expanded === 'undefined') {
	          _this.setState({ expanded: false });
	        }
	      }
	    };
	
	    _this.state = {
	      received: false,
	      twoLine: false
	    };
	
	    if (typeof props.expanded === 'undefined') {
	      _this.state.expanded = props.defaultExpanded;
	    }
	    return _this;
	  }
	
	  ExpansionPanel.prototype.componentDidMount = function componentDidMount() {
	    this._determineIfTwoLine();
	  };
	
	  ExpansionPanel.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (false) {
	      if (nextProps.columnWidths.length === 0) {
	        // Hopefully a nice warning about fixing the missing props injected from ExpansionList
	        /* eslint-disable no-console */
	        console.error('The `ExpansionPanel` component expects the `columnWidths` prop to be injected from the ' + '`ExpansionList` component. It could be missing because:' + '\n - you have a wrapper component with extra functionality' + '\n - the `ExpansionPanel` is not a direct child of the `ExpansionList` component' + '\n\nYou can fix this by making sure to pass `this.props.focused` and `this.props.columnWidths` ' + 'within your wrapper component and making the `ExpansionPanel` a direct child of `ExpansionList`.');
	      }
	
	      this.setState({ received: true });
	    }
	  };
	
	  ExpansionPanel.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this.props.label === prevProps.label && this.props.secondaryLabel === prevProps.secondaryLabel) {
	      return;
	    }
	
	    this._determineIfTwoLine();
	  };
	
	  ExpansionPanel.prototype._isExpanded = function _isExpanded(props, state) {
	    return typeof props.expanded === 'undefined' ? state.expanded : props.expanded;
	  };
	
	  ExpansionPanel.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        label = _props.label,
	        secondaryLabel = _props.secondaryLabel,
	        expandedSecondaryLabel = _props.expandedSecondaryLabel,
	        children = _props.children,
	        focused = _props.focused,
	        columnWidths = _props.columnWidths,
	        saveType = _props.saveType,
	        saveLabel = _props.saveLabel,
	        savePrimary = _props.savePrimary,
	        saveSecondary = _props.saveSecondary,
	        saveProps = _props.saveProps,
	        cancelType = _props.cancelType,
	        cancelLabel = _props.cancelLabel,
	        cancelPrimary = _props.cancelPrimary,
	        cancelSecondary = _props.cancelSecondary,
	        cancelProps = _props.cancelProps,
	        headerStyle = _props.headerStyle,
	        headerClassName = _props.headerClassName,
	        contentStyle = _props.contentStyle,
	        contentClassName = _props.contentClassName,
	        tabIndex = _props.tabIndex,
	        overflown = _props.overflown,
	        footer = _props.footer,
	        footerChildren = _props.footerChildren,
	        footerStyle = _props.footerStyle,
	        footerClassName = _props.footerClassName,
	        expandIconChildren = _props.expandIconChildren,
	        expandIconClassName = _props.expandIconClassName,
	        propAnimateContent = _props.animateContent,
	        propExpanded = _props.expanded,
	        propExpanderIcon = _props.expanderIcon,
	        defaultExpanded = _props.defaultExpanded,
	        closeOnSave = _props.closeOnSave,
	        closeOnCancel = _props.closeOnCancel,
	        onSave = _props.onSave,
	        onCancel = _props.onCancel,
	        onExpandToggle = _props.onExpandToggle,
	        props = _objectWithoutProperties(_props, ['className', 'label', 'secondaryLabel', 'expandedSecondaryLabel', 'children', 'focused', 'columnWidths', 'saveType', 'saveLabel', 'savePrimary', 'saveSecondary', 'saveProps', 'cancelType', 'cancelLabel', 'cancelPrimary', 'cancelSecondary', 'cancelProps', 'headerStyle', 'headerClassName', 'contentStyle', 'contentClassName', 'tabIndex', 'overflown', 'footer', 'footerChildren', 'footerStyle', 'footerClassName', 'expandIconChildren', 'expandIconClassName', 'animateContent', 'expanded', 'expanderIcon', 'defaultExpanded', 'closeOnSave', 'closeOnCancel', 'onSave', 'onCancel', 'onExpandToggle']);
	
	    var twoLine = this.state.twoLine;
	
	    var expanded = this._isExpanded(this.props, this.state);
	    var animateContent = (0, _getField2.default)(this.props, this.context, 'animateContent');
	
	    var columns = _react.Children.map(expanded && expandedSecondaryLabel || secondaryLabel, function (panelLabel, i) {
	      var _ref;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: (_ref = {}, _ref['' + (overflown ? 'width' : 'minWidth')] = columnWidths[i + 1], _ref),
	          className: (0, _classnames2.default)('md-panel-column', {
	            'md-panel-column--overflown': overflown
	          }, (0, _themeColors2.default)({ text: true }))
	        },
	        panelLabel
	      );
	    });
	
	    if (!Array.isArray(columns)) {
	      columns = [columns];
	    }
	
	    columns.unshift(_react2.default.createElement(
	      'div',
	      {
	        key: 'main-label',
	        style: { minWidth: columnWidths[0] },
	        className: (0, _classnames2.default)('md-panel-column', (0, _themeColors2.default)({ text: true }))
	      },
	      label
	    ));
	
	    var expanderIcon = (0, _getDeprecatedIcon2.default)(expandIconClassName, expandIconChildren, this.props.expanderIcon);
	    expanderIcon = _react2.default.Children.only(expanderIcon);
	    expanderIcon = _react2.default.cloneElement(expanderIcon, {
	      className: (0, _getCollapserStyles2.default)({
	        flipped: expanded
	      }, 'md-expansion-panel__collapser md-cell--right', expanderIcon.props.className)
	    });
	
	    return _react2.default.createElement(
	      _Paper2.default,
	      _extends({}, props, {
	        className: (0, _classnames2.default)('md-expansion-panel', {
	          'md-expansion-panel--expanded': expanded
	        }, className),
	        'aria-expanded': expanded
	      }),
	      _react2.default.createElement(
	        _AccessibleFakeButton2.default,
	        {
	          onClick: this._handleClick,
	          style: headerStyle,
	          className: (0, _classnames2.default)('md-panel-header', {
	            'md-panel-header--expanded': expanded || twoLine,
	            'md-panel-header--focused': focused
	          }, headerClassName),
	          tabIndex: tabIndex
	        },
	        columns,
	        expanderIcon
	      ),
	      _react2.default.createElement(
	        _Collapse2.default,
	        { collapsed: !expanded, animate: animateContent },
	        _react2.default.createElement(
	          _PanelContent2.default,
	          {
	            style: contentStyle,
	            className: contentClassName,
	            footerStyle: footerStyle,
	            footerClassName: footerClassName,
	            onSave: this._handleSave,
	            onCancel: this._handleCancel,
	            saveType: saveType,
	            saveLabel: saveLabel,
	            savePrimary: savePrimary,
	            saveSecondary: saveSecondary,
	            saveProps: saveProps,
	            cancelType: cancelType,
	            cancelLabel: cancelLabel,
	            cancelPrimary: cancelPrimary,
	            cancelSecondary: cancelSecondary,
	            cancelProps: cancelProps,
	            footer: footer,
	            footerChildren: footerChildren
	          },
	          children
	        )
	      )
	    );
	  };
	
	  return ExpansionPanel;
	}(_react.PureComponent);
	
	ExpansionPanel.propTypes = {
	  /**
	   * An optional style to apply to the panel.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the panel.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An options style to apply to the panel's header content. This is the
	   * section that toggles the children to be visible and label columns.
	   */
	  headerStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the panel's header content. This is the
	   * section that toggles the children to be visible and label columns.
	   */
	  headerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the element surrounding the children when expanded.
	   */
	  contentStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the element surrounding the children when expanded.
	   */
	  contentClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the footer when the `footer` prop is `undefined`.
	   *
	   * @see {@link #footer}
	   */
	  footerStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the footer when the `footer` prop is `undefined`.
	   *
	   * @see {@link #footer}
	   */
	  footerClassName: _propTypes2.default.string,
	
	  /**
	   * The main label to display in the unexpanded panel.
	   */
	  label: _propTypes2.default.node.isRequired,
	
	  /**
	   * Any additional columns to display after the main label. If this is a `list`
	   * instead of a singular item, they will each be formatted as a column.
	   */
	  secondaryLabel: _propTypes2.default.node,
	
	  /**
	   * Any additional columns to display after the main label when the panel is
	   * expanded. If this is omitted, the default `secondaryLabel` will be displayed
	   * instead.
	   */
	  expandedSecondaryLabel: _propTypes2.default.node,
	
	  /**
	   * The component to render the panel as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	  /**
	   * The content to display once the panel is toggled open.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * A boolean if the panel is currently expanded. This will force the component
	   * to be controlled and require's the `onExpandToggle` function to be defined.
	   */
	  expanded: (0, _controlled2.default)(_propTypes2.default.bool, 'onExpandToggle', 'defaultExpanded'),
	
	  /**
	   * Boolean if an uncontrolled panel should be expanded by default.
	   */
	  defaultExpanded: _propTypes2.default.bool.isRequired,
	
	  /**
	   * The icon to display for expanding the expansion panel.
	   */
	  expanderIcon: _propTypes2.default.element,
	
	  /**
	   * Boolean if the `ExpansionPanel` is currently tab focused. This is injected
	   * and managed by the `ExpansionList` component. Do not set yourself.
	   */
	  focused: _propTypes2.default.bool.isRequired,
	
	  /**
	   * A list of min-widths to apply to each column in the panel header. This is injected
	   * and managed by the `ExpansionList` component. Do not set yourself.
	   */
	  columnWidths: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
	
	  /**
	   * Boolean if the panel has too much content so that it overflowns. This is injected
	   * and managed by the `ExpansionList` component. Do not set yourself.
	   *
	   * When this is active, it will truncate all columns except for the main label and the
	   * toggle icon.
	   */
	  overflown: _propTypes2.default.bool,
	
	  /**
	   * A function to call when the expansion panel's expanded state is toggled.
	   * The callback for this function will include the new expanded state.
	   *
	   * `onExpandToggle(expanded)`
	   */
	  onExpandToggle: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the Save button is clicked on the expanded panel.
	   */
	  onSave: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the Cancel button is clicked on the expanded panel.
	   */
	  onCancel: _propTypes2.default.func,
	
	  /**
	   * Boolean if the panel should close when the Save button is clicked.
	   */
	  closeOnSave: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the panel should close when the Cancel button is clicked.
	   */
	  closeOnCancel: _propTypes2.default.bool,
	
	  /**
	   * An optional button type to apply to the Save button. This will get
	   * passed to the `FlatButton`.
	   */
	  saveType: _propTypes2.default.oneOf(['button', 'submit', 'reset']),
	
	  /**
	   * The label for the Save button.
	   */
	  saveLabel: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the Save button should be styled with the primary color.
	   */
	  savePrimary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the Save button should be styled with the secondary color,
	   */
	  saveSecondary: _propTypes2.default.bool,
	
	  /**
	   * Any additional props to provide/override for the save button in the
	   * footer of the panel.
	   */
	  saveProps: _propTypes2.default.object,
	
	  /**
	   * An optional button type to apply to the Cancel button. This will get
	   * passed to the `FlatButton`.
	   */
	  cancelType: _propTypes2.default.oneOf(['button', 'submit', 'reset']),
	
	  /**
	   * The label for the Cancel button.
	   */
	  cancelLabel: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the Cancel button should be styled with the primary color,
	   */
	  cancelPrimary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the Cancel button should be styled with the secondary color,
	   */
	  cancelSecondary: _propTypes2.default.bool,
	
	  /**
	   * Any additional props to provide/override for the cancel button in the
	   * footer of the panel.
	   */
	  cancelProps: _propTypes2.default.object,
	
	  /**
	   * The tab index for the panel's header. This allows keyboard navigation.
	   */
	  tabIndex: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the panel's content should animate when the content's visibility changes. This
	   * can also be toggled from the `ExpansionList` component if all `ExpansionPanel` in the list
	   * should not animate. This only affects the height transition.
	   *
	   * > The default value is really `true` since it gets passed down to the `Collapse` component.
	   */
	  animateContent: _propTypes2.default.bool,
	
	  /**
	   * This prop controls the footer for the expansion panel. If this prop is `undefined`, it will
	   * go with the default behavior of generating the save and cancel buttons with the save and cancel
	   * props.
	   *
	   * If this value is `null`, there will be no footer created.
	   *
	   * Finally, if this prop is defined as any renderable item, it will be displayed in place of the
	   * footer.
	   *
	   * @see {@link #footerChildren}
	   */
	  footer: _propTypes2.default.node,
	
	  /**
	   * Any additional children that should be displayed in the footer of the panel. These children
	   * will be placed after the action buttons.
	   */
	  footerChildren: _propTypes2.default.node,
	  expandIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `expanderIcon` instead'),
	  expandIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `expanderIcon` instead')
	};
	ExpansionPanel.defaultProps = {
	  defaultExpanded: false,
	  expanderIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'keyboard_arrow_down'
	  ),
	  component: 'li',
	  saveLabel: 'Save',
	  cancelLabel: 'Cancel',
	  savePrimary: true,
	  tabIndex: 0,
	  closeOnSave: true,
	  closeOnCancel: true,
	  focused: false,
	  columnWidths: []
	};
	ExpansionPanel.contextTypes = {
	  animateContent: _propTypes2.default.bool
	};
	exports.default = ExpansionPanel;

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DialogFooter = __webpack_require__(165);
	
	var _DialogFooter2 = _interopRequireDefault(_DialogFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `PanelContent` component is for displaying the expanded content
	 * for an `ExpansionPanel`. It will display any children in a `md-panel-content`
	 * container followed by a `Divider` and the `PanelControls` .
	 */
	var PanelContent = function (_PureComponent) {
	  _inherits(PanelContent, _PureComponent);
	
	  function PanelContent() {
	    _classCallCheck(this, PanelContent);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  PanelContent.prototype.render = function render() {
	    var _props = this.props,
	        style = _props.style,
	        footerStyle = _props.footerStyle,
	        footerClassName = _props.footerClassName,
	        contentStyle = _props.contentStyle,
	        className = _props.className,
	        children = _props.children,
	        onSave = _props.onSave,
	        onCancel = _props.onCancel,
	        saveProps = _props.saveProps,
	        saveType = _props.saveType,
	        saveLabel = _props.saveLabel,
	        savePrimary = _props.savePrimary,
	        saveSecondary = _props.saveSecondary,
	        cancelProps = _props.cancelProps,
	        cancelType = _props.cancelType,
	        cancelLabel = _props.cancelLabel,
	        cancelPrimary = _props.cancelPrimary,
	        cancelSecondary = _props.cancelSecondary,
	        footer = _props.footer,
	        footerChildren = _props.footerChildren;
	
	
	    var actions = [_extends({
	      type: cancelType,
	      label: cancelLabel,
	      primary: cancelPrimary,
	      secondary: cancelSecondary
	    }, cancelProps, {
	      onClick: onCancel
	    }), _extends({
	      type: saveType,
	      label: saveLabel,
	      primary: savePrimary,
	      secondary: saveSecondary
	    }, saveProps, {
	      onClick: onSave
	    })];
	
	    var actionFooter = null;
	    if (typeof footer === 'undefined') {
	      actionFooter = _react2.default.createElement(
	        _DialogFooter2.default,
	        {
	          actions: actions,
	          style: footerStyle,
	          className: (0, _classnames2.default)('md-divider-border md-divider-border--top', footerClassName)
	        },
	        footerChildren
	      );
	    } else if (footer !== null) {
	      actionFooter = footer;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { style: style },
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('md-panel-content', className), style: contentStyle },
	        children
	      ),
	      actionFooter
	    );
	  };
	
	  return PanelContent;
	}(_react.PureComponent);
	
	PanelContent.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  footerStyle: _propTypes2.default.object,
	  footerClassName: _propTypes2.default.string,
	  contentStyle: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  onSave: _propTypes2.default.func.isRequired,
	  onCancel: _propTypes2.default.func.isRequired,
	  saveProps: _propTypes2.default.object,
	  saveType: _propTypes2.default.string,
	  saveLabel: _propTypes2.default.node.isRequired,
	  savePrimary: _propTypes2.default.bool,
	  saveSecondary: _propTypes2.default.bool,
	  cancelProps: _propTypes2.default.object,
	  cancelType: _propTypes2.default.string,
	  cancelLabel: _propTypes2.default.node.isRequired,
	  cancelPrimary: _propTypes2.default.bool,
	  cancelSecondary: _propTypes2.default.bool,
	  footer: _propTypes2.default.node,
	  footerChildren: _propTypes2.default.node
	};
	exports.default = PanelContent;

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(7);
	
	var _FileInput = __webpack_require__(335);
	
	var _FileInput2 = _interopRequireDefault(_FileInput);
	
	var _deprecated = __webpack_require__(5);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _omit = __webpack_require__(177);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `FileUpload` component is used to upload files locally This is a wrapper of the `FileInput` component
	 * with some additional functionality so any props that are undocumented on `FileUpload` but are present
	 * on `FileInput` are correctly provided. If you want to upload files to a server, use
	 * [FormData](https://developer.mozilla.org/en-US/docs/Web/API/FormData)
	 * by attaching the `File`.
	 *
	 * Quick example:
	 *
	 * ```js
	 * function upload(file) {
	 *   fetch('/api/images', {
	 *     method: 'POST',
	 *     body: new FormData().append('file', file),
	 *   });
	 * }
	 * ```
	 *
	 * An upload can be aborted by calling the `abort(file || fileName)` function. If
	 * the file or fileName are omitted, it will *attempt* to abort the current
	 * file that is uploading. Unreliable for multi-select.
	 *
	 * ```js
	 * <FileUpload ref="upload" />
	 * <Button raised onClick={() => this.refs.upload.abort()} label="Abort! Abort!" />
	 * ```
	 */
	var FileUpload = function (_PureComponent) {
	  _inherits(FileUpload, _PureComponent);
	
	  function FileUpload() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FileUpload);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = {}, _this.abort = function (file) {
	      var fileName = file;
	      if (!file) {
	        // Attempt to remove first file added...
	        fileName = Object.keys(_this.state)[0];
	      } else if (typeof file.name === 'string') {
	        fileName = file.name;
	      }
	
	      var reader = _this.state[fileName];
	      if (reader) {
	        reader.abort();
	        (0, _reactDom.findDOMNode)(_this).querySelector('.md-file-input').value = '';
	
	        _this.setState((0, _omit2.default)(_this.state, [fileName]));
	      }
	    }, _this._uploadFile = function (file) {
	      var _this$props = _this.props,
	          onAbort = _this$props.onAbort,
	          onError = _this$props.onError,
	          onLoad = _this$props.onLoad,
	          onLoadStart = _this$props.onLoadStart,
	          onLoadEnd = _this$props.onLoadEnd,
	          onProgress = _this$props.onProgress,
	          readAs = _this$props.readAs;
	      var name = file.name,
	          type = file.type;
	
	
	      var fr = new FileReader();
	      if (onError) {
	        fr.onerror = function (e) {
	          onError(file, e.target.error, e);
	        };
	      }
	
	      if (onAbort) {
	        fr.onabort = function (e) {
	          onAbort(file, e);
	        };
	      }
	
	      if (onLoadStart) {
	        fr.onloadstart = function (e) {
	          onLoadStart(file, e);
	        };
	      }
	
	      if (onLoadEnd) {
	        fr.onloadend = function (e) {
	          onLoadEnd(file, e);
	        };
	      }
	
	      fr.onload = function (e) {
	        if (onLoad) {
	          onLoad(file, e.target.result, e);
	        }
	
	        _this.setState((0, _omit2.default)(_this.state, [name]));
	      };
	
	      if (onProgress) {
	        fr.onprogress = function (e) {
	          if (e.lengthComputable) {
	            onProgress(file, e.loaded / e.total * 100, e);
	          }
	        };
	      }
	
	      if (readAs) {
	        if (typeof readAs === 'function') {
	          readAs(type, file, fr);
	        } else {
	          fr['readAs' + readAs](file);
	        }
	      } else if (type.match(/image|video|audio|application\/pdf/) || name.match(/\.mkv$/)) {
	        fr.readAsDataURL(file);
	      } else if (type.match(/application\/json/)) {
	        fr.readAsText(file);
	      } else if (type.match(/application|model|multipart/) || name.match(/(w|e)ar$/)) {
	        fr.readAsArrayBuffer(file);
	      } else {
	        fr.readAsText(file);
	      }
	
	      return fr;
	    }, _this._handleUpload = function (fileList, e) {
	      if (_this.props.onChange) {
	        _this.props.onChange(fileList, e);
	      }
	
	      if (!fileList) {
	        return;
	      }
	      var _this$props2 = _this.props,
	          maxSize = _this$props2.maxSize,
	          onSizeError = _this$props2.onSizeError;
	
	      var files = Array.isArray(fileList) ? fileList : [fileList];
	
	      var errorFiles = [];
	      if (maxSize) {
	        errorFiles = files.filter(function (file) {
	          return file.size > maxSize;
	        });
	        files = files.filter(function (file) {
	          return file.size <= maxSize;
	        });
	      }
	
	      if (errorFiles.length) {
	        onSizeError(errorFiles);
	      }
	
	      if (!files.length) {
	        return;
	      }
	
	      var nextState = {};
	      files.forEach(function (file) {
	        var fileReader = _this._uploadFile(file);
	        nextState[file.name] = fileReader;
	      });
	
	      _this.setState(nextState);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  /**
	   * Attempts to abort the upload of a file. This function takes an optional `file` or `fileName`
	   * as it's parameter. If the parameter is omitted, it attempts to abort the first file that was
	   * added. If the `onAbort` function was given, it will be called as well.
	   *
	   * @param {Object|string} file - The file or the file name to use to find the
	   *     correct `FileReader`.
	   */
	
	
	  FileUpload.prototype.render = function render() {
	    var _props = this.props,
	        maxSize = _props.maxSize,
	        readAs = _props.readAs,
	        onLoad = _props.onLoad,
	        onLoadStart = _props.onLoadStart,
	        onLoadEnd = _props.onLoadEnd,
	        onProgress = _props.onProgress,
	        onAbort = _props.onAbort,
	        onError = _props.onError,
	        onSizeError = _props.onSizeError,
	        props = _objectWithoutProperties(_props, ['maxSize', 'readAs', 'onLoad', 'onLoadStart', 'onLoadEnd', 'onProgress', 'onAbort', 'onError', 'onSizeError']);
	
	    return _react2.default.createElement(_FileInput2.default, _extends({}, props, { onChange: this._handleUpload }));
	  };
	
	  return FileUpload;
	}(_react.PureComponent);
	
	FileUpload.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the label.
	   */
	  labelStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the label.
	   */
	  labelClassName: _propTypes2.default.string,
	
	  /**
	   * Boolean if the `FileInput` should be styled with the primary color.
	   */
	  primary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `FileInput` should be styled with the secondary color.
	   */
	  secondary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `FileInput` should be styled as a flat button instead of a
	   * raised button.
	   */
	  flat: _propTypes2.default.bool,
	
	  /**
	   * This should be a comma separated list of Media Types that the `FileInput` can
	   * accept. If this prop is left blank, any file will be accepted.
	   *
	   * The values can either be:
	   * - A file extension
	   * - audio/*
	   * - video/*
	   * - image/*
	   * - any valid [IANA Media Type](http://www.iana.org/assignments/media-types/media-types.xhtml)
	   */
	  accept: _propTypes2.default.string,
	
	  /**
	   * Boolean if multiple files will be accepted.
	   */
	  multiple: _propTypes2.default.bool,
	
	  /**
	   * A label to display on the `FileInput`.
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * The icon children to use for the upload icon.
	   */
	  iconChildren: _propTypes2.default.node,
	
	  /**
	   * The icon className to use for the upload icon.
	   */
	  iconClassName: _propTypes2.default.string,
	
	  /**
	   * An optional max size for the file. If the file is greater than
	   * this limit, the file will not be uploaded.
	   */
	  maxSize: _propTypes2.default.number,
	
	  /**
	   * A required function to call when the `maxSize` prop is set. It will
	   * be given a list of files that were too big.
	   */
	  onSizeError: function onSizeError(props, propName, component) {
	    for (var _len2 = arguments.length, others = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	      others[_key2 - 3] = arguments[_key2];
	    }
	
	    if (typeof props.maxSize === 'number') {
	      var _PropTypes$func;
	
	      return (_PropTypes$func = _propTypes2.default.func).isRequired.apply(_PropTypes$func, [props, propName, component].concat(others));
	    }
	
	    return null;
	  },
	
	  /**
	   * You can force the `FileReader` to read the file as a specific type
	   * if you do not trust the *amazing* regex I have for choosing the correct
	   * one.
	   *
	   * ```js
	   * if(type.match(/image|video|audio/)) {
	   *   fr.readAsDataURL(file);
	   * } else if(type.match(/application|model|multipart/)) {
	   *   fr.readAsArrayBuffer(file);
	   * } else {
	   *   fr.readAsText(file);
	   * }
	   * ```
	   *
	   * > `.yml` and `.js` both are considered `application`, so it definitely fails there.
	   *
	   * If this prop is a function, you will be given the file's type, the file object, and
	   * the file reader. You will then need to call `fileReader.readAsYOUR_CORRECT_TYPE(file)`.
	   */
	  readAs: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['DataURL', 'ArrayBuffer', 'Text']), _propTypes2.default.func]),
	
	  /**
	   * An optional function to call when the `FileUpload` aborts. The current
	   * file and the abort event are given. This might not be the most useful
	   * function to use since you will need to manually call abort yourself anyways.
	   */
	  onAbort: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `FileUpload` errors. The current
	   * file, the error, and the error event are given.
	   *
	   * ```js
	   * onError(file, event.target.error, event);
	   * ```
	   */
	  onError: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `FileUpload` loads. The current
	   * file, the load result, and the load event are given.
	   *
	   * ```js
	   * onLoad(file, event.target.result, event);
	   * ```
	   *
	   * The load result will either be:
	   * - a data URL
	   * - a plain text string
	   * - an array buffer
	   *
	   * depending on what type the file is.
	   */
	  onLoad: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `FileUpload` starts loading. The current
	   * file and the load start event are given.
	   */
	  onLoadStart: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `FileUpload` finishes loading. The
	   * current file and the load end event are given.
	   */
	  onLoadEnd: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `FileUpload` progress. The current
	   * file, upload progress, and the progress event are given. The progress
	   * will be a number between 0 and 100 that has not been rounded.
	   *
	   * ```js
	   * onProgress(file, progress, event);
	   * ```
	   */
	  onProgress: _propTypes2.default.func,
	
	  /**
	   * Boolean if the same file is allowed to be uploaded multiple times. This will basically make the
	   * `value` of the file input always blank.
	   */
	  allowDuplicates: _propTypes2.default.bool,
	
	  /**
	   * An optional function to call when a file selects or unselects a file.
	   * This will be called before any local uploading occurs.
	   *
	   * ```js
	   * onChange(file(s) || null, event);
	   * ```
	   */
	  onChange: _propTypes2.default.func,
	  value: (0, _deprecated2.default)(_propTypes2.default.string, 'There should\'t be a reason to set the value manually. Check out {@link #allowDuplicates} instead')
	};
	exports.default = FileUpload;

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Grid = __webpack_require__(337);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Cell = __webpack_require__(336);
	
	var _Cell2 = _interopRequireDefault(_Cell);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DIFF_KEYS = ['className', 'cellClassName', 'stacked', 'container', 'noSpacing', 'gutter', 'spacing', 'align', 'position', 'size', 'offset', 'order', 'phoneSize', 'phoneOrder', 'phoneOffset', 'phoneHidden', 'tabletSize', 'tabletOrder', 'tabletOffset', 'tabletHidden', 'desktopSize', 'desktopOrder', 'desktopOffset', 'desktopHidden'];
	
	var GridList = function (_PureComponent) {
	  _inherits(GridList, _PureComponent);
	
	  /**
	   * A utility function to get the grid's className based on the `Grid`'s and `Cell`'s
	   * props. This is * used behind the scenes to merge and create the className for the grid.
	   *
	   * ### Example:
	   * ```js
	   * const { className, cellClassName } = GridList.getClassNames();
	   * const { className, cellClassName } = GridList.getClassNames({ size: 1, container: 'custom' });
	   * ```
	   *
	   * @param {Object=} props - This should be an object of the `Grid`'s props. It
	   *    will extract the needed keys and generate the classNames.
	   * @return {Object} an object containing the `className` and `cellClassName` attributes.
	   */
	  GridList.getClassNames = function getClassNames() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var className = props.className,
	        cellClassName = props.cellClassName,
	        remaining = _objectWithoutProperties(props, ['className', 'cellClassName']);
	
	    return {
	      className: _Grid2.default.getClassName(_extends({ className: className }, remaining)),
	      cellClassName: _Cell2.default.getClassName(_extends({ className: cellClassName }, remaining))
	    };
	  };
	
	  function GridList(props) {
	    _classCallCheck(this, GridList);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this));
	
	    _this.state = GridList.getClassNames(props);
	    return _this;
	  }
	
	  GridList.prototype.componentWillMount = function componentWillMount() {
	    this.setState(GridList.getClassNames(this.props));
	  };
	
	  GridList.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    if (DIFF_KEYS.some(function (key) {
	      return _this2.props[key] !== nextProps[key];
	    })) {
	      this.setState(GridList.getClassNames(nextProps));
	    }
	  };
	
	  GridList.prototype.render = function render() {
	    var _state = this.state,
	        className = _state.className,
	        cellClassName = _state.cellClassName;
	
	    var _props = this.props,
	        style = _props.style,
	        cellStyle = _props.cellStyle,
	        Component = _props.component,
	        children = _props.children,
	        propClassName = _props.className,
	        propCellClassName = _props.cellClassName,
	        container = _props.container,
	        noSpacing = _props.noSpacing,
	        stacked = _props.stacked,
	        gutter = _props.gutter,
	        spacing = _props.spacing,
	        align = _props.align,
	        position = _props.position,
	        size = _props.size,
	        offset = _props.offset,
	        order = _props.order,
	        phoneSize = _props.phoneSize,
	        phoneOrder = _props.phoneOrder,
	        phoneOffset = _props.phoneOffset,
	        phoneHidden = _props.phoneHidden,
	        tabletSize = _props.tabletSize,
	        tabletOrder = _props.tabletOrder,
	        tabletOffset = _props.tabletOffset,
	        tabletHidden = _props.tabletHidden,
	        desktopSize = _props.desktopSize,
	        desktopOrder = _props.desktopOrder,
	        desktopOffset = _props.desktopOffset,
	        desktopHidden = _props.desktopHidden,
	        props = _objectWithoutProperties(_props, ['style', 'cellStyle', 'component', 'children', 'className', 'cellClassName', 'container', 'noSpacing', 'stacked', 'gutter', 'spacing', 'align', 'position', 'size', 'offset', 'order', 'phoneSize', 'phoneOrder', 'phoneOffset', 'phoneHidden', 'tabletSize', 'tabletOrder', 'tabletOffset', 'tabletHidden', 'desktopSize', 'desktopOrder', 'desktopOffset', 'desktopHidden']);
	
	    if (typeof children === 'function') {
	      return children({ style: style, className: className, cellStyle: cellStyle, cellClassName: cellClassName });
	    }
	
	    return _react2.default.createElement(
	      Component,
	      _extends({}, props, { style: style, className: className }),
	      _react2.default.Children.map(children, function (child) {
	        if (!child) {
	          return child;
	        }
	
	        var childStyle = child.props.style;
	        if (cellStyle) {
	          childStyle = childStyle ? _extends({}, cellStyle, childStyle) : cellStyle;
	        }
	
	        return _react2.default.cloneElement(child, {
	          style: childStyle,
	          className: (0, _classnames2.default)(child.props.className, cellClassName)
	        });
	      })
	    );
	  };
	
	  return GridList;
	}(_react.PureComponent);
	
	GridList.propTypes = {
	  /**
	   * An optional style to apply to the Grid component. This will only be applied
	   * if the `children` prop is not a callback function.
	   *
	   * @see {@link #children}
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the Grid component. This will only be applied
	   * if the `children` prop is not a callback function.
	   *
	   * @see {@link #children}
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to each child. This will only be applied
	   * if the `children` prop is not a callback function.
	   *
	   * @see {@link #children}
	   */
	  cellStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to each child. This will only be applied
	   * if the `children` prop is not a callback function.
	   *
	   * @see {@link #children}
	   */
	  cellClassName: _propTypes2.default.string,
	
	  /**
	   * The component to render the Cell as. This should probably not be used as much
	   * as the `children` callback function.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	
	  /**
	   * The children can either be renderable React elements or a callback function
	   * that accepts the style and className props to apply so that the styles can
	   * be manually added to whichever component.
	   */
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	
	  /**
	   * An optional container name to apply to the Grid. This should be the same name as provided
	   * to the [react-md-make-grid-container](/components/grids?tab=2#mixin-react-md-make-grid-container) mixin.
	   */
	  container: _propTypes2.default.string,
	
	  /**
	   * Boolean if the grid should be placed vertically instead of horizontally.
	   */
	  stacked: _propTypes2.default.bool,
	
	  /**
	   * Boolean if all the gutters and spacing should be removed from the grid.
	   */
	  noSpacing: _propTypes2.default.bool,
	
	  /**
	   * When the [react-md-make-custom-grid](/components/grids?tab=2#mixin-react-md-make-custom-grid) mixin
	   * is used, you can use the `gutter` and `spacing` props on the `Grid` to apply the correct className
	   */
	  gutter: _propTypes2.default.number,
	
	  /**
	   * When the [react-md-make-custom-grid](/components/grids?tab=2#mixin-react-md-make-custom-grid) mixin
	   * is used, you can use the `gutter` and `spacing` props on the `Grid` to apply the correct className
	   */
	  spacing: _propTypes2.default.number,
	
	  /**
	   * An optional cell alignment to apply. When the `Grid` is not `stacked`,
	   * this will apply to vertical alignment within each "row" of the grid.
	   *
	   * Alignments:
	   * - `top` - This will align to the top of the row
	   * - `middle` - This will align to the middle of the row
	   * - `bottom` - This will align to the bottom of the row
	   * - `stretch` - This will make the cell stretch to fill all the available space
	   *   in the row.
	   *
	   * @see {@link #position}
	   */
	  align: _propTypes2.default.oneOf(['top', 'middle', 'bottom', 'stretch']),
	
	  /**
	   * An optional cell position to apply. When the `Grid` is not `stacked`,
	   * this will apply to horizontal alignment within each "row" of the grid.
	   *
	   * Positions:
	   * - `center` - This will align the cell to be within the center of the row. This really
	   *    just applies `margin-left: auto; margin-right: auto`.
	   * - `right` - This will align the cell to the end of the row. This really just applies `margin-left: auto`.
	   *
	   * @see {@link #align}
	   */
	  position: _propTypes2.default.oneOf(['center', 'right']),
	
	  /**
	   * An optional size to apply to the cell. This sizing will be applied across all media sizes.
	   * If the size is greater than the number of columns allowed for the media size, it will just
	   * span the entire width.
	   */
	  size: _propTypes2.default.number,
	
	  /**
	   * An optional order to apply to the cell. This order will be applied across all media sizes.
	   */
	  order: _propTypes2.default.number,
	
	  /**
	   * An optional offset to apply to the cell. This will add spacing to the left of the cell.
	   */
	  offset: _propTypes2.default.number,
	
	  /**
	   * An optional size to apply to the cell only on phones.
	   */
	  phoneSize: _propTypes2.default.number,
	
	  /**
	   * An optional order to apply to the cell only on phones.
	   */
	  phoneOrder: _propTypes2.default.number,
	
	  /**
	   * An optional offset to apply to the cell only on phones.
	   */
	  phoneOffset: _propTypes2.default.number,
	
	  /**
	   * Boolean if the cell should be hidden on phones only.
	   */
	  phoneHidden: _propTypes2.default.bool,
	
	  /**
	   * An optional size to apply to the cell only on tablets.
	   */
	  tabletSize: _propTypes2.default.number,
	
	  /**
	   * An optional order to apply to the cell only on tablets.
	   */
	  tabletOrder: _propTypes2.default.number,
	
	  /**
	   * An optional offset to apply to the cell only on tablets.
	   */
	  tabletOffset: _propTypes2.default.number,
	
	  /**
	   * Boolean if the cell should be hidden on tablets only.
	   */
	  tabletHidden: _propTypes2.default.bool,
	
	  /**
	   * An optional size to apply to the cell only on desktops.
	   */
	  desktopSize: _propTypes2.default.number,
	
	  /**
	   * An optional order to apply to the cell only on desktops.
	   */
	  desktopOrder: _propTypes2.default.number,
	
	  /**
	   * An optional offset to apply to the cell only on desktops.
	   */
	  desktopOffset: _propTypes2.default.number,
	
	  /**
	   * Boolean if the cell should be hidden on desktops only.
	   */
	  desktopHidden: _propTypes2.default.bool
	};
	GridList.defaultProps = {
	  component: 'div',
	  stacked: false,
	  noSpacing: false,
	  phoneHidden: false,
	  tabletHidden: false,
	  desktopHidden: false
	};
	exports.default = GridList;

/***/ }),
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(11);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _ListItemText = __webpack_require__(168);
	
	var _ListItemText2 = _interopRequireDefault(_ListItemText);
	
	var _TileAddon = __webpack_require__(86);
	
	var _TileAddon2 = _interopRequireDefault(_TileAddon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ListItemControl = function (_PureComponent) {
	  _inherits(ListItemControl, _PureComponent);
	
	  function ListItemControl() {
	    _classCallCheck(this, ListItemControl);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  ListItemControl.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        tileStyle = _props.tileStyle,
	        tileClassName = _props.tileClassName,
	        primaryAction = _props.primaryAction,
	        secondaryAction = _props.secondaryAction,
	        primaryText = _props.primaryText,
	        secondaryText = _props.secondaryText,
	        threeLines = _props.threeLines,
	        leftIcon = _props.leftIcon,
	        leftAvatar = _props.leftAvatar,
	        rightIcon = _props.rightIcon,
	        rightAvatar = _props.rightAvatar,
	        props = _objectWithoutProperties(_props, ['className', 'tileStyle', 'tileClassName', 'primaryAction', 'secondaryAction', 'primaryText', 'secondaryText', 'threeLines', 'leftIcon', 'leftAvatar', 'rightIcon', 'rightAvatar']);
	
	    var control = _react.Children.only(primaryAction || secondaryAction);
	    var text = _react2.default.createElement(_ListItemText2.default, {
	      key: 'text',
	      primaryText: control.props.label || primaryText,
	      secondaryText: secondaryText,
	      className: (0, _classnames2.default)({
	        'md-tile-content--left-icon': leftIcon,
	        'md-tile-content--left-avatar': leftAvatar,
	        'md-tile-content--left-button': primaryAction,
	        'md-tile-content--right-padding': primaryAction
	      })
	    });
	    control = (0, _react.cloneElement)(control, {
	      className: (0, _classnames2.default)('md-list-control', {
	        'md-list-control--right': secondaryAction
	      }, control.props.className),
	      label: text
	    });
	
	    var leftNode = _react2.default.createElement(_TileAddon2.default, {
	      key: 'left-addon',
	      icon: leftIcon,
	      avatar: leftAvatar
	    });
	
	    var rightNode = _react2.default.createElement(_TileAddon2.default, {
	      key: 'right-addon',
	      icon: rightIcon,
	      avatar: rightAvatar
	    });
	
	    var icond = !!leftIcon || !!rightIcon;
	    var avatard = !!leftAvatar || !!rightAvatar;
	
	    return _react2.default.createElement(
	      'li',
	      _extends({}, props, { className: (0, _classnames2.default)('md-list-item', className) }),
	      _react2.default.createElement(
	        'div',
	        {
	          style: tileStyle,
	          className: (0, _classnames2.default)('md-list-tile', {
	            'md-list-tile--icon': !secondaryText && icond && !avatard,
	            'md-list-tile--avatar': !secondaryText && avatard,
	            'md-list-tile--two-lines': secondaryText && !threeLines,
	            'md-list-tile--three-lines': secondaryText && threeLines,
	            'md-list-tile--control-left': primaryAction,
	            'md-list-tile--control-right': secondaryAction
	          }, (0, _themeColors2.default)({ text: true }), tileClassName)
	        },
	        leftNode,
	        control,
	        rightNode
	      )
	    );
	  };
	
	  return ListItemControl;
	}(_react.PureComponent);
	
	ListItemControl.propTypes = {
	  /**
	   * An optional style to apply to the `.md-list-item`.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `.md-list-item`.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the `.md-list-tile`.
	   */
	  tileStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `.md-list-tile`.
	   */
	  tileClassName: _propTypes2.default.string,
	
	  /**
	   * The primary text to display in the `ListItemControl`. The `primaryAction` or
	   * `secondaryAction` will end up getting the `label` prop injected into it with
	   * a combination of the `primaryText` and `secondaryText`. If the `primaryAction`
	   * or `secondaryAction` already have a label prop, the `label` prop will be used
	   * as the `primaryText`.
	   */
	  primaryText: _propTypes2.default.node,
	
	  /**
	   * An optional secondary text that can be displayed in the label of the `primaryAction`
	   * or `secondaryAction`.
	   */
	  secondaryText: _propTypes2.default.node,
	
	  /**
	   * Boolean if the primary and secondary text will span three lines.
	   */
	  threeLines: _propTypes2.default.bool,
	
	  /**
	   * The primary action of the `ListItemControl`. This _should_ normally
	   * be a type of `SelectionControl`
	   */
	  primaryAction: _propTypes2.default.element,
	
	  /**
	   * The secondary action of the `ListItemControl`. This _should_ normally
	   * be a type of `SelectionControl`. If it is a selection control,
	   * make sure to add the `labelBefore` prop to get correct positioning.
	   */
	  secondaryAction: _propTypes2.default.element,
	
	  /**
	   * An optional `FontIcon` to display to the left of the action.
	   */
	  leftIcon: _propTypes2.default.node,
	
	  /**
	   * An optional `Avatar` to display to the left of the action.
	   */
	  leftAvatar: _propTypes2.default.node,
	
	  /**
	   * An optional `FontIcon` to display to the right of the action.
	   */
	  rightIcon: _propTypes2.default.node,
	
	  /**
	   * An optional `FontIcon` to display to the right of the action.
	   */
	  rightAvatar: _propTypes2.default.node,
	
	  /**
	   * Defines the number of items in the list. This is only required when all items in the
	   * list are not present in the DOM.
	   *
	   * @see https://www.w3.org/TR/wai-aria/states_and_properties#aria-setsize
	   */
	  'aria-setsize': _propTypes2.default.number,
	
	  /**
	   * Defines the items position in the list. This is only required when all items in the list
	   * are not present in the DOM. The custom validation just requires this prop if the `aria-setsize`
	   * prop is defined as a helpful reminder.
	   *
	   * @see https://www.w3.org/TR/wai-aria/states_and_properties#aria-posinset
	   */
	  'aria-posinset': function ariaPosinset(props, propName) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    var validator = _propTypes2.default.number;
	    if (typeof props['aria-setsize'] !== 'undefined') {
	      validator = validator.isRequired;
	    }
	
	    return validator.apply(undefined, [props, propName].concat(args));
	  }
	};
	exports.default = ListItemControl;

/***/ }),
/* 871 */,
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(11);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This component renders a selectable date in the `CalendarMonth` component.
	 */
	var CalendarDate = function (_PureComponent) {
	  _inherits(CalendarDate, _PureComponent);
	
	  function CalendarDate(props) {
	    _classCallCheck(this, CalendarDate);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));
	
	    _this._setFocus = function (btn) {
	      if (btn && _this.props.active) {
	        btn.focus();
	      }
	    };
	
	    _this._handleClick = function (e) {
	      _this.props.onClick(new Date(_this.props.date), e);
	    };
	
	    _this._setActive = function () {
	      if (!_this.props.disabled) {
	        _this.setState({ desktopActive: true });
	      }
	    };
	
	    _this._setInactive = function () {
	      if (!_this.props.disabled) {
	        _this.setState({ desktopActive: false });
	      }
	    };
	
	    _this.state = _extends({}, _this._getFormattedDate(props), { desktopActive: false });
	    return _this;
	  }
	
	  CalendarDate.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _props = this.props,
	        DateTimeFormat = _props.DateTimeFormat,
	        locales = _props.locales,
	        date = _props.date;
	
	    if (DateTimeFormat !== nextProps.DateTimeFormat || locales !== nextProps.locales || date !== nextProps.date) {
	      this.setState(this._getFormattedDate(nextProps));
	    }
	  };
	
	  CalendarDate.prototype._getFormattedDate = function _getFormattedDate(_ref) {
	    var DateTimeFormat = _ref.DateTimeFormat,
	        locales = _ref.locales,
	        date = _ref.date;
	
	    return {
	      date: new DateTimeFormat(locales, { day: 'numeric' }).format(date)
	    };
	  };
	
	  CalendarDate.prototype.render = function render() {
	    var _state = this.state,
	        date = _state.date,
	        desktopActive = _state.desktopActive;
	    var _props2 = this.props,
	        disabled = _props2.disabled,
	        active = _props2.active,
	        today = _props2.today,
	        className = _props2.className;
	
	
	    var fullyActive = today && !active && !desktopActive;
	    return _react2.default.createElement(
	      'button',
	      {
	        type: 'button',
	        ref: this._setFocus,
	        onFocus: this._setActive,
	        onBlur: this._setInactive,
	        onMouseOver: this._setActive,
	        onMouseLeave: this._setInactive,
	        className: (0, _classnames2.default)('md-calendar-date md-calendar-date--btn', {
	          'md-calendar-date--btn-active': active || desktopActive,
	          'md-pointer--hover': !disabled
	        }, (0, _themeColors2.default)({ disabled: disabled, primary: fullyActive }), 'md-btn', className),
	        onClick: this._handleClick,
	        disabled: disabled
	      },
	      _react2.default.createElement(
	        'span',
	        {
	          className: (0, _classnames2.default)('md-calendar-date--date', {
	            'md-picker-text--active': active || desktopActive,
	            'md-font-bold': fullyActive
	          })
	        },
	        date
	      )
	    );
	  };
	
	  return CalendarDate;
	}(_react.PureComponent);
	
	CalendarDate.propTypes = {
	  className: _propTypes2.default.string,
	  date: _propTypes2.default.instanceOf(Date).isRequired,
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
	  disabled: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func.isRequired,
	  active: _propTypes2.default.bool,
	  today: _propTypes2.default.bool
	};
	exports.default = CalendarDate;

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(11);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _isMonthBefore = __webpack_require__(937);
	
	var _isMonthBefore2 = _interopRequireDefault(_isMonthBefore);
	
	var _toDayOfWeek = __webpack_require__(354);
	
	var _toDayOfWeek2 = _interopRequireDefault(_toDayOfWeek);
	
	var _addDate = __webpack_require__(253);
	
	var _addDate2 = _interopRequireDefault(_addDate);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This component renders the controls for a `DatePicker`'s Calendar.
	 * This will render a next and previous month button along with the
	 * current month/year. It also renders the abbreviiations for the days
	 * of the week.
	 */
	var CalendarHeader = function (_PureComponent) {
	  _inherits(CalendarHeader, _PureComponent);
	
	  function CalendarHeader(props) {
	    _classCallCheck(this, CalendarHeader);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));
	
	    _this.state = _this._createState(props);
	    return _this;
	  }
	
	  CalendarHeader.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _props = this.props,
	        DateTimeFormat = _props.DateTimeFormat,
	        locales = _props.locales,
	        date = _props.date;
	
	    if (DateTimeFormat !== nextProps.DateTimeFormat || locales !== nextProps.locales || date !== nextProps.date) {
	      this.setState(this._createState(nextProps));
	    }
	  };
	
	  CalendarHeader.prototype._createState = function _createState() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props,
	        DateTimeFormat = _ref.DateTimeFormat,
	        locales = _ref.locales,
	        date = _ref.date,
	        firstDayOfWeek = _ref.firstDayOfWeek,
	        titleFormat = _ref.titleFormat,
	        weekdayClassName = _ref.weekdayClassName,
	        weekdayFormat = _ref.weekdayFormat;
	
	    var firstDay = (0, _toDayOfWeek2.default)(date, firstDayOfWeek);
	    var formatter = new DateTimeFormat(locales, { weekday: weekdayFormat });
	    var dows = [];
	    for (var i = 0; i < 7; i++) {
	      var dow = formatter.format((0, _addDate2.default)(firstDay, i, 'D'));
	      dows.push(_react2.default.createElement(
	        'h4',
	        {
	          key: i,
	          className: (0, _classnames2.default)('md-calendar-date md-calendar-dow', (0, _themeColors2.default)({ disabled: true }), weekdayClassName)
	        },
	        dow
	      ));
	    }
	
	    return {
	      dows: dows,
	      title: new DateTimeFormat(locales, titleFormat).format(date)
	    };
	  };
	
	  CalendarHeader.prototype.render = function render() {
	    var _state = this.state,
	        dows = _state.dows,
	        title = _state.title;
	    var _props2 = this.props,
	        date = _props2.date,
	        minDate = _props2.minDate,
	        maxDate = _props2.maxDate,
	        onPreviousClick = _props2.onPreviousClick,
	        previousIcon = _props2.previousIcon,
	        onNextClick = _props2.onNextClick,
	        nextIcon = _props2.nextIcon,
	        titleClassName = _props2.titleClassName;
	
	
	    var isPreviousDisabled = (0, _isMonthBefore2.default)(minDate, date);
	    var isNextDisabled = (0, _isMonthBefore2.default)(date, maxDate);
	    return _react2.default.createElement(
	      'header',
	      { className: 'md-calendar-header' },
	      _react2.default.createElement(
	        'div',
	        { className: 'md-calendar-controls' },
	        _react2.default.createElement(_Button2.default, {
	          icon: true,
	          onClick: onPreviousClick,
	          disabled: isPreviousDisabled,
	          className: 'md-calendar-control',
	          iconEl: previousIcon
	        }),
	        _react2.default.createElement(
	          'h4',
	          { className: (0, _classnames2.default)('md-title', titleClassName) },
	          title
	        ),
	        _react2.default.createElement(_Button2.default, {
	          icon: true,
	          onClick: onNextClick,
	          disabled: isNextDisabled,
	          className: 'md-calendar-control',
	          iconEl: nextIcon
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'md-calendar-dows' },
	        dows
	      )
	    );
	  };
	
	  return CalendarHeader;
	}(_react.PureComponent);
	
	CalendarHeader.propTypes = {
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  date: _propTypes2.default.instanceOf(Date).isRequired,
	  minDate: _propTypes2.default.instanceOf(Date),
	  maxDate: _propTypes2.default.instanceOf(Date),
	  previousIcon: _propTypes2.default.element,
	  onPreviousClick: _propTypes2.default.func.isRequired,
	  nextIcon: _propTypes2.default.node,
	  onNextClick: _propTypes2.default.func.isRequired,
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
	  /**
	   * The first day of week: 0 for Sunday, 1 for Monday, 2 for Tuesday, and so on.
	   */
	  firstDayOfWeek: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5, 6]),
	  /**
	   * An optional className to apply to the title.
	   */
	  titleClassName: _propTypes2.default.string,
	  /**
	   * The DateTimeFormat options to apply to format the title.
	   */
	  titleFormat: _propTypes2.default.shape({
	    era: _propTypes2.default.oneOf(['narrow', 'short', 'long']),
	    year: _propTypes2.default.oneOf(['numeric', '2-digit']),
	    month: _propTypes2.default.oneOf(['numeric', '2-digit', 'narrow', 'short', 'long'])
	  }),
	  /**
	   * An optional className to apply to a weekday.
	   */
	  weekdayClassName: _propTypes2.default.string,
	  /**
	   * The DateTimeFormat option to apply to format a weekday.
	   */
	  weekdayFormat: _propTypes2.default.oneOf(['narrow', 'short', 'long'])
	};
	CalendarHeader.defaultProps = {
	  firstDayOfWeek: 0,
	  titleFormat: { month: 'long', year: 'numeric' },
	  weekdayFormat: 'narrow'
	};
	exports.default = CalendarHeader;

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _addDate = __webpack_require__(253);
	
	var _addDate2 = _interopRequireDefault(_addDate);
	
	var _getLastDay = __webpack_require__(353);
	
	var _getLastDay2 = _interopRequireDefault(_getLastDay);
	
	var _stripTime = __webpack_require__(941);
	
	var _stripTime2 = _interopRequireDefault(_stripTime);
	
	var _toDayOfWeek = __webpack_require__(354);
	
	var _toDayOfWeek2 = _interopRequireDefault(_toDayOfWeek);
	
	var _CalendarDate = __webpack_require__(872);
	
	var _CalendarDate2 = _interopRequireDefault(_CalendarDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This component renders a month for the calendar view of the `DatePicker`.
	 */
	var CalendarMonth = function (_PureComponent) {
	  _inherits(CalendarMonth, _PureComponent);
	
	  function CalendarMonth() {
	    _classCallCheck(this, CalendarMonth);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  CalendarMonth.prototype.render = function render() {
	    var _props = this.props,
	        calendarDate = _props.calendarDate,
	        calendarTempDate = _props.calendarTempDate,
	        onCalendarDateClick = _props.onCalendarDateClick,
	        minDate = _props.minDate,
	        maxDate = _props.maxDate,
	        DateTimeFormat = _props.DateTimeFormat,
	        locales = _props.locales,
	        className = _props.className,
	        firstDayOfWeek = _props.firstDayOfWeek,
	        disableWeekEnds = _props.disableWeekEnds,
	        dateClassName = _props.dateClassName,
	        showAllDays = _props.showAllDays,
	        outerDateClassName = _props.outerDateClassName,
	        disableOuterDates = _props.disableOuterDates,
	        props = _objectWithoutProperties(_props, ['calendarDate', 'calendarTempDate', 'onCalendarDateClick', 'minDate', 'maxDate', 'DateTimeFormat', 'locales', 'className', 'firstDayOfWeek', 'disableWeekEnds', 'dateClassName', 'showAllDays', 'outerDateClassName', 'disableOuterDates']);
	
	    var days = [];
	    var firstDay = (0, _stripTime2.default)(calendarDate);
	    firstDay.setDate(1);
	    var lastDay = (0, _getLastDay2.default)(calendarDate);
	    var currentDate = (0, _toDayOfWeek2.default)(firstDay, 0);
	    var endDate = (0, _toDayOfWeek2.default)(lastDay, 6);
	    var activeDateTime = (0, _stripTime2.default)(calendarTempDate).getTime();
	    var todayTime = new Date().getTime();
	
	    if (firstDayOfWeek) {
	      currentDate = (0, _addDate2.default)(currentDate, firstDayOfWeek > firstDay.getDay() ? firstDayOfWeek - 7 : firstDayOfWeek, 'D');
	      endDate = (0, _addDate2.default)(endDate, firstDayOfWeek > lastDay.getDay() ? firstDayOfWeek - 7 : firstDayOfWeek, 'D');
	    }
	
	    while (currentDate <= endDate) {
	      var key = currentDate.getMonth() + '-' + currentDate.getDate();
	      var currentMonth = currentDate.getMonth() === calendarDate.getMonth();
	
	      var date = void 0;
	      if (currentMonth || showAllDays) {
	        var _cn;
	
	        var time = currentDate.getTime();
	        var isMinDateDisabled = minDate && minDate.getTime() > time;
	        var isMaxDateDisabled = maxDate && maxDate.getTime() < time;
	        var isWeekendDisabled = disableWeekEnds && (currentDate.getDay() === 0 || currentDate.getDay() === 6);
	        var disabled = !currentMonth && disableOuterDates || isMinDateDisabled || isMaxDateDisabled || isWeekendDisabled;
	
	        date = _react2.default.createElement(_CalendarDate2.default, {
	          key: key,
	          className: (0, _classnames2.default)(dateClassName, (_cn = {}, _cn[outerDateClassName] = !currentMonth && outerDateClassName, _cn)),
	          today: time === todayTime,
	          active: time === activeDateTime,
	          disabled: disabled,
	          onClick: onCalendarDateClick,
	          date: currentDate,
	          DateTimeFormat: DateTimeFormat,
	          locales: locales
	        });
	      } else {
	        date = _react2.default.createElement('div', { key: key, className: 'md-calendar-date' });
	      }
	
	      days.push(date);
	      currentDate = (0, _addDate2.default)(currentDate, 1, 'D');
	    }
	
	    return _react2.default.createElement(
	      'div',
	      _extends({ className: (0, _classnames2.default)('md-calendar-month', className) }, props),
	      days
	    );
	  };
	
	  return CalendarMonth;
	}(_react.PureComponent);
	
	CalendarMonth.propTypes = {
	  /**
	   * A className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The current selected date of the calendar. This is
	   * the date after hitting the Ok button or `value` || `defaultValue`.
	   */
	  calendarDate: _propTypes2.default.instanceOf(Date).isRequired,
	
	  /**
	   * The current selected date of the calendar before verifying
	   * the new date.
	   */
	  calendarTempDate: _propTypes2.default.instanceOf(Date).isRequired,
	
	  /**
	   * An optional min date for the calendar. This will disable any
	   * dates that come before this date in the month.
	   */
	  minDate: _propTypes2.default.instanceOf(Date),
	
	  /**
	   * An optional max date for the calendar. This will disable any
	   * dates that come after this date in the month.
	   */
	  maxDate: _propTypes2.default.instanceOf(Date),
	
	  /**
	   * A function to call that will select a new date.
	   */
	  onCalendarDateClick: _propTypes2.default.func.isRequired,
	
	  /**
	   * The first day of week: 0 for Sunday, 1 for Monday, 2 for Tuesday, and so on.
	   */
	  firstDayOfWeek: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5, 6]),
	
	  /**
	   * True if weekends are to be greyed out.
	   */
	  disableWeekEnds: _propTypes2.default.bool,
	
	  /**
	   * An optional className to apply to a date.
	   */
	  dateClassName: _propTypes2.default.string,
	
	  /**
	   * True if dates from adjacent months should be shown.
	   */
	  showAllDays: _propTypes2.default.bool,
	  disableOuterDates: _propTypes2.default.bool,
	
	  /**
	   * An optional className to apply to a date from an adjacent month.
	   */
	  outerDateClassName: _propTypes2.default.string,
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired
	};
	CalendarMonth.defaultProps = {
	  firstDayOfWeek: 0
	};
	exports.default = CalendarMonth;

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isValidClick = __webpack_require__(246);
	
	var _isValidClick2 = _interopRequireDefault(_isValidClick);
	
	var _captureNextEvent = __webpack_require__(125);
	
	var _captureNextEvent2 = _interopRequireDefault(_captureNextEvent);
	
	var _touches = __webpack_require__(126);
	
	var _calcTimeFromPoint = __webpack_require__(922);
	
	var _calcTimeFromPoint2 = _interopRequireDefault(_calcTimeFromPoint);
	
	var _calcPageOffset = __webpack_require__(349);
	
	var _calcPageOffset2 = _interopRequireDefault(_calcPageOffset);
	
	var _ResizeObserver = __webpack_require__(35);
	
	var _ResizeObserver2 = _interopRequireDefault(_ResizeObserver);
	
	var _ClockTime = __webpack_require__(877);
	
	var _ClockTime2 = _interopRequireDefault(_ClockTime);
	
	var _ClockHand = __webpack_require__(876);
	
	var _ClockHand2 = _interopRequireDefault(_ClockHand);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `ClockFace` component is used for rendering all the clock's times
	 * and the clock hand.
	 */
	var ClockFace = function (_PureComponent) {
	  _inherits(ClockFace, _PureComponent);
	
	  function ClockFace(props) {
	    _classCallCheck(this, ClockFace);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));
	
	    _this._setFace = function (face) {
	      _this._face = face;
	      _this._setPositioning();
	    };
	
	    _this._setPositioning = function () {
	      if (!_this._face) {
	        return;
	      }
	
	      var radius = _this._face.offsetWidth / 2;
	      var offset = (0, _calcPageOffset2.default)(_this._face);
	      _this._center = { x: offset.left + radius, y: offset.top + radius };
	      _this._left = offset.left;
	      _this._top = offset.top;
	
	      if (_this.state.radius !== radius) {
	        _this.setState({ radius: radius });
	      }
	    };
	
	    _this._handleMouseEnter = function () {
	      var hoverMode = _this.props.hoverMode;
	
	
	      if (hoverMode) {
	        _this._enableMouseMoving();
	      }
	    };
	
	    _this._handleMouseLeave = function () {
	      var hoverMode = _this.props.hoverMode;
	
	
	      if (hoverMode) {
	        _this._disableMouseMoving();
	      }
	    };
	
	    _this._handleMouseDown = function (e) {
	      if (!(0, _isValidClick2.default)(e)) {
	        return;
	      }
	
	      var hoverMode = _this.props.hoverMode;
	
	
	      if (!hoverMode) {
	        _this._enableMouseMoving();
	      }
	    };
	
	    _this._handleMouseMove = function (e) {
	      if (!_this.state.moving) {
	        return;
	      }
	
	      e.preventDefault();
	      _this._calcNewTime(e);
	    };
	
	    _this._handleMouseUp = function (e) {
	      if (!(0, _isValidClick2.default)(e)) {
	        return;
	      }
	
	      var _this$props = _this.props,
	          onTimeChosen = _this$props.onTimeChosen,
	          hoverMode = _this$props.hoverMode;
	
	
	      if (_this._face) {
	        if (_this._face.contains(e.target)) {
	          onTimeChosen();
	          _this._calcNewTime(e);
	        } else {
	          (0, _captureNextEvent2.default)('click');
	        }
	      }
	
	      if (!hoverMode) {
	        _this._disableMouseMoving();
	      }
	    };
	
	    _this._handleTouchStart = function () {
	      (0, _captureNextEvent2.default)('mousedown');
	
	      (0, _touches.addTouchEvent)(window, 'move', _this._handleTouchMove);
	      (0, _touches.addTouchEvent)(window, 'end', _this._handleTouchEnd);
	      _this.setState({ moving: true });
	    };
	
	    _this._handleTouchMove = function (e) {
	      if (!_this.state.moving) {
	        return;
	      }
	
	      _this._calcNewTime(e);
	    };
	
	    _this._handleTouchEnd = function (e) {
	      _this._calcNewTime(e);
	      if (_this._face && !_this._face.contains(e.target)) {
	        (0, _captureNextEvent2.default)('click');
	      }
	
	      (0, _touches.removeTouchEvent)(window, 'move', _this._handleTouchMove);
	      (0, _touches.removeTouchEvent)(window, 'end', _this._handleTouchEnd);
	
	      _this.setState({ moving: false });
	    };
	
	    _this._calcNewTime = function (e) {
	      var _ref = e.changedTouches ? e.changedTouches[0] : e,
	          x = _ref.pageX,
	          y = _ref.pageY;
	
	      var innerRadius = _this.state.radius - 48;
	      var _this$props2 = _this.props,
	          onChange = _this$props2.onChange,
	          minutes = _this$props2.minutes,
	          timePeriod = _this$props2.timePeriod;
	
	      onChange((0, _calcTimeFromPoint2.default)({ x: x, y: y }, _this._center, innerRadius, minutes, timePeriod));
	    };
	
	    _this._enableMouseMoving = function () {
	      window.addEventListener('mousemove', _this._handleMouseMove);
	      window.addEventListener('mouseup', _this._handleMouseUp);
	
	      _this.setState({ moving: true });
	    };
	
	    _this._disableMouseMoving = function () {
	      window.removeEventListener('mousemove', _this._handleMouseMove);
	      window.removeEventListener('mouseup', _this._handleMouseUp);
	
	      _this.setState({ moving: false });
	    };
	
	    _this.state = { radius: 136, moving: false };
	    _this._center = {};
	    return _this;
	  }
	
	  ClockFace.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('mousemove', this._handleMouseMove);
	    window.removeEventListener('mouseup', this._handleMouseMove);
	
	    (0, _touches.removeTouchEvent)(window, 'move', this._handleTouchMove);
	    (0, _touches.removeTouchEvent)(window, 'end', this._handleTouchEnd);
	    clearInterval(this.interval);
	  };
	
	  ClockFace.prototype.render = function render() {
	    var _props = this.props,
	        time = _props.time,
	        minutes = _props.minutes,
	        timePeriod = _props.timePeriod,
	        onChange = _props.onChange,
	        hoverMode = _props.hoverMode;
	    var radius = this.state.radius;
	
	    var size = !minutes && !timePeriod ? 24 : 12;
	    var times = Array.apply(null, new Array(size)).map(function (_, i) {
	      var clockTime = i + 1;
	      if (minutes) {
	        clockTime = clockTime * 5 % 60;
	      } else {
	        clockTime %= 24;
	      }
	
	      return _react2.default.createElement(_ClockTime2.default, {
	        key: 'time-' + i,
	        index: i + 1,
	        time: clockTime,
	        active: clockTime === time,
	        radius: radius,
	        onKeyboardFocus: onChange
	      });
	    });
	
	    return _react2.default.createElement(
	      'div',
	      {
	        ref: this._setFace,
	        className: 'md-clock-face md-block-centered md-pointer--hover',
	        onMouseDown: this._handleMouseDown,
	        onMouseEnter: hoverMode ? this._handleMouseEnter : undefined,
	        onMouseLeave: hoverMode ? this._handleMouseLeave : undefined,
	        onTouchStart: this._handleTouchStart
	      },
	      _react2.default.createElement(_ResizeObserver2.default, { watchHeight: true, onResize: this._setPositioning }),
	      times,
	      _react2.default.createElement(_ClockHand2.default, { time: time, coords: radius, minutes: minutes })
	    );
	  };
	
	  return ClockFace;
	}(_react.PureComponent);
	
	ClockFace.propTypes = {
	  /**
	   * The current time for the clock.
	   */
	  time: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the clock is on the minutes view.
	   */
	  minutes: _propTypes2.default.bool.isRequired,
	
	  /**
	   * A function to call when a new time is selected. It gives the
	   * new time value. If it is 12 o'clock, 0 will be given.
	   */
	  onChange: _propTypes2.default.func.isRequired,
	
	  /**
	   * An optional time period string. This should be either AM or PM
	   * if the locale uses them.
	   */
	  timePeriod: _propTypes2.default.string,
	
	  /**
	   * If true the hover mode of the Time Picker is activated.
	   * In hover mode no clicks are required to start selecting an hour
	   * and the timemode switches automatically when a time was chosen.
	   * When a minute is selected the chosen time is applied automatically.
	   */
	  hoverMode: _propTypes2.default.bool,
	
	  onTimeChosen: _propTypes2.default.func.isRequired
	};
	exports.default = ClockFace;

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `ClockHand` component is just used to display the hand of the clock
	 * and a ball to surround the selected time.
	 */
	var ClockHand = function (_PureComponent) {
	  _inherits(ClockHand, _PureComponent);
	
	  function ClockHand(props) {
	    _classCallCheck(this, ClockHand);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));
	
	    _this.state = { active: false };
	    return _this;
	  }
	
	  ClockHand.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    if (this.props.minutes !== nextProps.minutes) {
	      if (this.state.timeout) {
	        clearTimeout(this.state.timeout);
	      }
	
	      this.setState({
	        active: true,
	        timeout: setTimeout(function () {
	          return _this2.setState({ active: false, timeout: null });
	        }, 150)
	      });
	    }
	  };
	
	  ClockHand.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.state.timeout) {
	      clearTimeout(this.state.timeout);
	    }
	  };
	
	  ClockHand.prototype._calcCurrentDegrees = function _calcCurrentDegrees(_ref) {
	    var time = _ref.time,
	        minutes = _ref.minutes;
	
	    var timeAt0Deg = minutes ? 15 : 3;
	    var sectors = minutes ? 60 : 12;
	
	    return (time % sectors - timeAt0Deg) * (360 / sectors);
	  };
	
	  ClockHand.prototype.render = function render() {
	    var _props = this.props,
	        coords = _props.coords,
	        time = _props.time,
	        minutes = _props.minutes;
	
	
	    var degrees = this._calcCurrentDegrees(this.props);
	    var invisibleMinute = false;
	    if (minutes) {
	      invisibleMinute = degrees % (360 / 12) !== 0;
	    }
	
	    var rotateTransform = 'rotate3d(0, 0, 1, ' + degrees + 'deg)';
	    return _react2.default.createElement('div', {
	      className: (0, _classnames2.default)('md-clock-hand md-background--primary', {
	        'md-clock-hand--active': this.state.active,
	        'md-clock-hand--minute-hover': invisibleMinute,
	        'md-clock-hand--inner': !minutes && (time > 12 || time === 0)
	      }),
	      style: {
	        left: coords,
	        top: coords,
	        WebkitTransform: rotateTransform,
	        MozTransform: rotateTransform,
	        msTransform: rotateTransform,
	        transform: rotateTransform
	      }
	    });
	  };
	
	  return ClockHand;
	}(_react.PureComponent);
	
	ClockHand.propTypes = {
	  /**
	   * This is the x and y coordinate to use for the center of the `ClockFace`.
	   * This should really be whatever the radius of the `ClockFace` is.
	   */
	  coords: _propTypes2.default.number,
	
	  /**
	   * The current time of the clock.
	   */
	  time: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the clock is displaying minutes instead of hours.
	   */
	  minutes: _propTypes2.default.bool.isRequired
	};
	exports.default = ClockHand;

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keyCodes = __webpack_require__(14);
	
	var _themeColors = __webpack_require__(11);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CLOCK_PADDING = 4;
	
	/**
	 * The `ClockTime` component is used for positioning hours or minutes
	 * in a clock. The time will be positioned based on it's given index
	 * and the radius of the clock.
	 */
	
	var ClockTime = function (_PureComponent) {
	  _inherits(ClockTime, _PureComponent);
	
	  function ClockTime(props) {
	    _classCallCheck(this, ClockTime);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));
	
	    _this._handleKeyUp = function (e) {
	      if ((e.which || e.keyCode) === _keyCodes.TAB) {
	        _this.props.onKeyboardFocus(_this.props.time);
	      }
	    };
	
	    _this._setTime = function (time) {
	      _this._time = time;
	      if (time !== null) {
	        _this._setPosition(_this.props, time);
	
	        if (_this.props.active) {
	          time.focus();
	        }
	      }
	    };
	
	    _this._setPosition = function (_ref, time) {
	      var radius = _ref.radius,
	          index = _ref.index;
	
	      // 36 is default size for the time
	      var size = (time.offsetWidth || 36) / 2;
	      var timeRadians = Math.PI / 2 - index * (Math.PI / 6);
	      var innerCircle = index > 12;
	
	      var outerRadius = radius - size;
	      var innerRadius = outerRadius - CLOCK_PADDING - (innerCircle ? size * 2 : 0);
	
	      _this.setState({
	        style: {
	          top: outerRadius - innerRadius * Math.sin(timeRadians),
	          left: outerRadius + innerRadius * Math.cos(timeRadians)
	        }
	      });
	    };
	
	    _this.state = {
	      // default size in scss
	      size: 18
	    };
	    return _this;
	  }
	
	  ClockTime.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.radius !== nextProps.radius || this.props.index !== nextProps.index) {
	      this._setPosition(nextProps, this._time);
	    }
	  };
	
	  ClockTime.prototype.render = function render() {
	    var _props = this.props,
	        time = _props.time,
	        active = _props.active;
	
	    return _react2.default.createElement(
	      'div',
	      {
	        ref: this._setTime,
	        tabIndex: 0,
	        className: (0, _classnames2.default)('md-clock-time md-text-no-select md-pointer--none', {
	          'md-picker-text--active': active
	        }, (0, _themeColors2.default)({ text: !active })),
	        style: this.state.style,
	        onKeyUp: this._handleKeyUp
	      },
	      _react2.default.createElement(
	        'span',
	        { className: 'md-clock-time-value' },
	        time
	      )
	    );
	  };
	
	  return ClockTime;
	}(_react.PureComponent);
	
	ClockTime.propTypes = {
	  /**
	   * The index of the current time to be displayed. This
	   * should be a number between 1 and 24.
	   */
	  index: _propTypes2.default.number.isRequired,
	
	  /**
	   * The time number to display.
	   */
	  time: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if this time is currently selected.
	   */
	  active: _propTypes2.default.bool.isRequired,
	
	  /**
	   * The radius of the clock.
	   */
	  radius: _propTypes2.default.number.isRequired,
	
	  onKeyboardFocus: _propTypes2.default.func.isRequired
	};
	exports.default = ClockTime;

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DialogFooter = __webpack_require__(165);
	
	var _DialogFooter2 = _interopRequireDefault(_DialogFooter);
	
	var _DatePickerHeader = __webpack_require__(881);
	
	var _DatePickerHeader2 = _interopRequireDefault(_DatePickerHeader);
	
	var _DatePickerCalendar = __webpack_require__(879);
	
	var _DatePickerCalendar2 = _interopRequireDefault(_DatePickerCalendar);
	
	var _YearPicker = __webpack_require__(887);
	
	var _YearPicker2 = _interopRequireDefault(_YearPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DatePicker = function (_PureComponent) {
	  _inherits(DatePicker, _PureComponent);
	
	  function DatePicker() {
	    _classCallCheck(this, DatePicker);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  DatePicker.prototype.render = function render() {
	    var _cn;
	
	    var _props = this.props,
	        okLabel = _props.okLabel,
	        okPrimary = _props.okPrimary,
	        onOkClick = _props.onOkClick,
	        cancelLabel = _props.cancelLabel,
	        cancelPrimary = _props.cancelPrimary,
	        onCancelClick = _props.onCancelClick,
	        DateTimeFormat = _props.DateTimeFormat,
	        locales = _props.locales,
	        calendarTempDate = _props.calendarTempDate,
	        calendarMode = _props.calendarMode,
	        changeCalendarMode = _props.changeCalendarMode,
	        style = _props.style,
	        className = _props.className,
	        inline = _props.inline,
	        icon = _props.icon,
	        displayMode = _props.displayMode,
	        firstDayOfWeek = _props.firstDayOfWeek,
	        disableWeekEnds = _props.disableWeekEnds,
	        showAllDays = _props.showAllDays,
	        disableOuterDates = _props.disableOuterDates,
	        headerClassName = _props.headerClassName,
	        contentClassName = _props.contentClassName,
	        footerClassName = _props.footerClassName,
	        calendarClassName = _props.calendarClassName,
	        yearPickerClassName = _props.yearPickerClassName,
	        calendarDateClassName = _props.calendarDateClassName,
	        calendarOuterDateClassName = _props.calendarOuterDateClassName,
	        calendarTitleClassName = _props.calendarTitleClassName,
	        calendarTitleFormat = _props.calendarTitleFormat,
	        calendarWeekdayClassName = _props.calendarWeekdayClassName,
	        calendarWeekdayFormat = _props.calendarWeekdayFormat,
	        props = _objectWithoutProperties(_props, ['okLabel', 'okPrimary', 'onOkClick', 'cancelLabel', 'cancelPrimary', 'onCancelClick', 'DateTimeFormat', 'locales', 'calendarTempDate', 'calendarMode', 'changeCalendarMode', 'style', 'className', 'inline', 'icon', 'displayMode', 'firstDayOfWeek', 'disableWeekEnds', 'showAllDays', 'disableOuterDates', 'headerClassName', 'contentClassName', 'footerClassName', 'calendarClassName', 'yearPickerClassName', 'calendarDateClassName', 'calendarOuterDateClassName', 'calendarTitleClassName', 'calendarTitleFormat', 'calendarWeekdayClassName', 'calendarWeekdayFormat']);
	
	    var picker = void 0;
	    if (calendarMode === 'calendar') {
	      picker = _react2.default.createElement(_DatePickerCalendar2.default, _extends({}, props, {
	        key: 'calendar',
	        className: calendarClassName,
	        calendarTempDate: calendarTempDate,
	        DateTimeFormat: DateTimeFormat,
	        locales: locales,
	        firstDayOfWeek: firstDayOfWeek,
	        disableWeekEnds: disableWeekEnds,
	        showAllDays: showAllDays,
	        disableOuterDates: disableOuterDates,
	        dateClassName: calendarDateClassName,
	        outerDateClassName: calendarOuterDateClassName,
	        titleClassName: calendarTitleClassName,
	        titleFormat: calendarTitleFormat,
	        weekdayClassName: calendarWeekdayClassName,
	        weekdayFormat: calendarWeekdayFormat
	      }));
	    } else {
	      picker = _react2.default.createElement(_YearPicker2.default, _extends({}, props, {
	        key: 'year',
	        className: yearPickerClassName,
	        calendarTempDate: calendarTempDate,
	        DateTimeFormat: DateTimeFormat,
	        locales: locales
	      }));
	    }
	
	    var actions = [{
	      key: 'cancel',
	      onClick: onCancelClick,
	      primary: cancelPrimary,
	      secondary: !cancelPrimary,
	      label: cancelLabel
	    }, {
	      key: 'ok',
	      onClick: onOkClick,
	      primary: okPrimary,
	      secondary: !okPrimary,
	      label: okLabel
	    }];
	
	    return _react2.default.createElement(
	      'div',
	      {
	        style: style,
	        className: (0, _classnames2.default)('md-picker md-picker--date', (_cn = {}, _cn['md-picker--' + displayMode] = displayMode, _cn['md-picker--inline'] = inline, _cn['md-picker--inline-icon'] = inline && icon, _cn), className)
	      },
	      _react2.default.createElement(_DatePickerHeader2.default, {
	        className: headerClassName,
	        DateTimeFormat: DateTimeFormat,
	        locales: locales,
	        calendarTempDate: calendarTempDate,
	        calendarMode: calendarMode,
	        changeCalendarMode: changeCalendarMode
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('md-picker-content-container', contentClassName) },
	        picker,
	        _react2.default.createElement(_DialogFooter2.default, {
	          className: footerClassName,
	          actions: actions
	        })
	      )
	    );
	  };
	
	  return DatePicker;
	}(_react.PureComponent);
	
	DatePicker.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  okLabel: _propTypes2.default.node.isRequired,
	  okPrimary: _propTypes2.default.bool.isRequired,
	  onOkClick: _propTypes2.default.func.isRequired,
	  cancelLabel: _propTypes2.default.node.isRequired,
	  cancelPrimary: _propTypes2.default.bool.isRequired,
	  onCancelClick: _propTypes2.default.func.isRequired,
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
	  calendarDate: _propTypes2.default.instanceOf(Date).isRequired,
	  calendarTempDate: _propTypes2.default.instanceOf(Date).isRequired,
	  calendarMode: _propTypes2.default.oneOf(['calendar', 'year']).isRequired,
	  changeCalendarMode: _propTypes2.default.func.isRequired,
	  icon: _propTypes2.default.bool,
	  inline: _propTypes2.default.bool,
	  displayMode: _propTypes2.default.oneOf(['landscape', 'portrait']),
	
	  /**
	   * The first day of week: 0 for Sunday, 1 for Monday, 2 for Tuesday, and so on.
	   */
	  firstDayOfWeek: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5, 6]),
	
	  /**
	   * True if weekends are to be greyed out.
	   */
	  disableWeekEnds: _propTypes2.default.bool,
	
	  /**
	   * True if dates from adjacent months should be shown in calendar.
	   */
	  showAllDays: _propTypes2.default.bool,
	  disableOuterDates: _propTypes2.default.bool,
	
	  /**
	   * An optional className to apply to the header of date picker.
	   */
	  headerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the content container of date picker.
	   */
	  contentClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the footer of date picker.
	   */
	  footerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the calendar container of date picker.
	   */
	  calendarClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the year picker of date picker.
	   */
	  yearPickerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to a date in calendar.
	   */
	  calendarDateClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to a date from an adjacent month in calendar.
	   */
	  calendarOuterDateClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the title in calendar header.
	   */
	  calendarTitleClassName: _propTypes2.default.string,
	
	  /**
	   * The DateTimeFormat options to apply to format the title in calendar header.
	   */
	  calendarTitleFormat: _propTypes2.default.shape({
	    era: _propTypes2.default.oneOf(['narrow', 'short', 'long']),
	    year: _propTypes2.default.oneOf(['numeric', '2-digit']),
	    month: _propTypes2.default.oneOf(['numeric', '2-digit', 'narrow', 'short', 'long'])
	  }),
	
	  /**
	   * An optional className to apply to a weekday in calendar header.
	   */
	  calendarWeekdayClassName: _propTypes2.default.string,
	
	  /**
	   * The DateTimeFormat option to apply to format a weekday in calendar header.
	   */
	  calendarWeekdayFormat: _propTypes2.default.oneOf(['narrow', 'short', 'long'])
	};
	exports.default = DatePicker;

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CalendarMonth = __webpack_require__(874);
	
	var _CalendarMonth2 = _interopRequireDefault(_CalendarMonth);
	
	var _CalendarHeader = __webpack_require__(873);
	
	var _CalendarHeader2 = _interopRequireDefault(_CalendarHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DatePickerCalendar = function (_PureComponent) {
	  _inherits(DatePickerCalendar, _PureComponent);
	
	  function DatePickerCalendar() {
	    _classCallCheck(this, DatePickerCalendar);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  DatePickerCalendar.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        previousIcon = _props.previousIcon,
	        onPreviousClick = _props.onPreviousClick,
	        nextIcon = _props.nextIcon,
	        onNextClick = _props.onNextClick,
	        calendarDate = _props.calendarDate,
	        calendarTempDate = _props.calendarTempDate,
	        onCalendarDateClick = _props.onCalendarDateClick,
	        DateTimeFormat = _props.DateTimeFormat,
	        locales = _props.locales,
	        minDate = _props.minDate,
	        maxDate = _props.maxDate,
	        firstDayOfWeek = _props.firstDayOfWeek,
	        disableWeekEnds = _props.disableWeekEnds,
	        showAllDays = _props.showAllDays,
	        disableOuterDates = _props.disableOuterDates,
	        dateClassName = _props.dateClassName,
	        outerDateClassName = _props.outerDateClassName,
	        titleClassName = _props.titleClassName,
	        titleFormat = _props.titleFormat,
	        weekdayClassName = _props.weekdayClassName,
	        weekdayFormat = _props.weekdayFormat;
	
	
	    return _react2.default.createElement(
	      'section',
	      { className: (0, _classnames2.default)('md-picker-content md-picker-content--calendar', className) },
	      _react2.default.createElement(_CalendarHeader2.default, {
	        date: calendarDate,
	        minDate: minDate,
	        maxDate: maxDate,
	        DateTimeFormat: DateTimeFormat,
	        locales: locales,
	        onPreviousClick: onPreviousClick,
	        previousIcon: previousIcon,
	        onNextClick: onNextClick,
	        nextIcon: nextIcon,
	        firstDayOfWeek: firstDayOfWeek,
	        titleClassName: titleClassName,
	        titleFormat: titleFormat,
	        weekdayClassName: weekdayClassName,
	        weekdayFormat: weekdayFormat
	      }),
	      _react2.default.createElement(_CalendarMonth2.default, {
	        key: new DateTimeFormat(locales).format(calendarDate),
	        calendarDate: calendarDate,
	        calendarTempDate: calendarTempDate,
	        onCalendarDateClick: onCalendarDateClick,
	        minDate: minDate,
	        maxDate: maxDate,
	        DateTimeFormat: DateTimeFormat,
	        locales: locales,
	        firstDayOfWeek: firstDayOfWeek,
	        disableWeekEnds: disableWeekEnds,
	        showAllDays: showAllDays,
	        disableOuterDates: disableOuterDates,
	        dateClassName: dateClassName,
	        outerDateClassName: outerDateClassName
	      })
	    );
	  };
	
	  return DatePickerCalendar;
	}(_react.PureComponent);
	
	DatePickerCalendar.propTypes = {
	  className: _propTypes2.default.string,
	  previousIcon: _propTypes2.default.element,
	  onPreviousClick: _propTypes2.default.func.isRequired,
	  nextIcon: _propTypes2.default.element,
	  onNextClick: _propTypes2.default.func.isRequired,
	  onCalendarDateClick: _propTypes2.default.func.isRequired,
	  calendarDate: _propTypes2.default.instanceOf(Date).isRequired,
	  calendarTempDate: _propTypes2.default.instanceOf(Date).isRequired,
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
	  minDate: _propTypes2.default.instanceOf(Date),
	  maxDate: _propTypes2.default.instanceOf(Date),
	
	  /**
	   * The first day of week: 0 for Sunday, 1 for Monday, 2 for Tuesday, and so on.
	   */
	  firstDayOfWeek: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5, 6]),
	
	  /**
	   * True if weekends are to be greyed out.
	   */
	  disableWeekEnds: _propTypes2.default.bool,
	
	  /**
	   * True if dates from adjacent months should be shown.
	   */
	  showAllDays: _propTypes2.default.bool,
	  disableOuterDates: _propTypes2.default.bool,
	
	  /**
	   * An optional className to apply to a date in calendar.
	   */
	  dateClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to a date from an adjacent month.
	   */
	  outerDateClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the title in calendar header.
	   */
	  titleClassName: _propTypes2.default.string,
	
	  /**
	   * The DateTimeFormat options to apply to format the title in calendar header.
	   */
	  titleFormat: _propTypes2.default.shape({
	    era: _propTypes2.default.oneOf(['narrow', 'short', 'long']),
	    year: _propTypes2.default.oneOf(['numeric', '2-digit']),
	    month: _propTypes2.default.oneOf(['numeric', '2-digit', 'narrow', 'short', 'long'])
	  }),
	
	  /**
	   * An optional className to apply to a weekday in calendar header.
	   */
	  weekdayClassName: _propTypes2.default.string,
	
	  /**
	   * The DateTimeFormat option to apply to format a weekday in calendar header.
	   */
	  weekdayFormat: _propTypes2.default.oneOf(['narrow', 'short', 'long'])
	};
	exports.default = DatePickerCalendar;

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _isRequiredForA11y = __webpack_require__(16);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _deprecated = __webpack_require__(5);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _keyCodes = __webpack_require__(14);
	
	var _getField = __webpack_require__(8);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _handleWindowClickListeners = __webpack_require__(90);
	
	var _handleWindowClickListeners2 = _interopRequireDefault(_handleWindowClickListeners);
	
	var _handleKeyboardAccessibility = __webpack_require__(57);
	
	var _handleKeyboardAccessibility2 = _interopRequireDefault(_handleKeyboardAccessibility);
	
	var _controlled = __webpack_require__(15);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _addDate = __webpack_require__(253);
	
	var _addDate2 = _interopRequireDefault(_addDate);
	
	var _isSameDay = __webpack_require__(938);
	
	var _isSameDay2 = _interopRequireDefault(_isSameDay);
	
	var _DateTimeFormat = __webpack_require__(346);
	
	var _DateTimeFormat2 = _interopRequireDefault(_DateTimeFormat);
	
	var _Collapse = __webpack_require__(55);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _FontIcon = __webpack_require__(12);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _getDeprecatedIcon = __webpack_require__(21);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _TextField = __webpack_require__(89);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _DialogContainer = __webpack_require__(235);
	
	var _DialogContainer2 = _interopRequireDefault(_DialogContainer);
	
	var _DatePicker = __webpack_require__(878);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable new-cap,no-shadow */
	
	
	/**
	 * The `DatePickerContainer` component is a wrapper for the main `DatePicker` component
	 * to manage the state and _logic_ for rendering the `DatePicker`. This component will
	 * either render inline or in a `Dialog` depending if the `inline` prop is set to `true`.
	 *
	 * NOTE: This component is actually exported as `DatePicker` when using the `import { member }` syntax.
	 * The following two lines are equivalent:
	 *
	 * ```js
	 * import { DatePicker } from 'react-md/lib/Pickers';
	 * import DatePicker from 'react-md/lib/Pickers/DatePickerContainer';
	 * ```
	 */
	var DatePickerContainer = function (_PureComponent) {
	  _inherits(DatePickerContainer, _PureComponent);
	
	  function DatePickerContainer(props) {
	    _classCallCheck(this, DatePickerContainer);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var date = void 0;
	    var value = void 0;
	    var defaultValue = props.defaultValue,
	        DateTimeFormat = props.DateTimeFormat,
	        locales = props.locales,
	        formatOptions = props.formatOptions,
	        minDate = props.minDate,
	        maxDate = props.maxDate;
	
	
	    if (typeof props.value !== 'undefined') {
	      date = _this._getDate(props.value);
	    } else if (defaultValue) {
	      date = _this._getDate(defaultValue);
	      value = typeof defaultValue === 'string' ? defaultValue : DateTimeFormat(locales, formatOptions).format(defaultValue);
	    } else {
	      date = new Date();
	      value = '';
	    }
	
	    date = _this._validateDateRange(date, minDate, maxDate);
	
	    var defaultCalendarDate = typeof props.initialCalendarDate !== 'undefined' ? props.initialCalendarDate : props.defaultCalendarDate;
	    var calendarTempDate = date;
	    if (typeof defaultCalendarDate !== 'undefined' && !props.value && !props.defaultValue) {
	      calendarTempDate = _this._getDate(defaultCalendarDate);
	      date = calendarTempDate;
	    } else if (calendarTempDate === null) {
	      calendarTempDate = new Date();
	      date = new Date();
	    }
	
	    var visible = typeof props.initiallyOpen !== 'undefined' ? props.initiallyOpen : !!props.defaultVisible;
	
	    _this.state = {
	      value: value,
	      visible: visible,
	      calendarDate: date,
	      calendarTempDate: calendarTempDate,
	      calendarMode: props.initialCalendarMode || props.defaultCalendarMode
	    };
	    return _this;
	  }
	
	  DatePickerContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var value = nextProps.value,
	        minDate = nextProps.minDate,
	        maxDate = nextProps.maxDate;
	
	    var minEqual = (0, _isSameDay2.default)(this.props.minDate, minDate);
	    var maxEqual = (0, _isSameDay2.default)(this.props.maxDate, maxDate);
	    if (this.props.value !== value || !minEqual || !maxEqual) {
	      var calendarDate = this.state.calendarDate;
	
	      if (typeof value !== 'undefined') {
	        calendarDate = this._getDate(value);
	      }
	
	      calendarDate = this._validateDateRange(calendarDate, minDate, maxDate);
	
	      if (!(0, _isSameDay2.default)(this.state.calendarDate, calendarDate)) {
	        this.setState({ calendarDate: calendarDate, calendarTempDate: calendarDate });
	      }
	    }
	  };
	
	  DatePickerContainer.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    var _props = this.props,
	        inline = _props.inline,
	        isOpen = _props.isOpen;
	
	    var visible = typeof isOpen !== 'undefined' ? isOpen : (0, _getField2.default)(this.props, this.state, 'visible');
	    var pVisible = typeof prevProps.isOpen !== 'undefined' ? prevProps.isOpen : (0, _getField2.default)(prevProps, prevState, 'visible');
	
	    if (visible === pVisible) {
	      return;
	    }
	
	    if (visible) {
	      if (inline) {
	        (0, _handleWindowClickListeners2.default)(this._handleOutsideClick, true);
	        window.addEventListener('keydown', this._closeOnEsc);
	      }
	    } else if (inline) {
	      (0, _handleWindowClickListeners2.default)(this._handleOutsideClick, false);
	      window.removeEventListener('keydown', this._closeOnEsc);
	    }
	  };
	
	  DatePickerContainer.prototype.componentWillUnmount = function componentWillUnmount() {
	    var visible = typeof this.props.isOpen !== 'undefined' ? this.props.isOpen : (0, _getField2.default)(this.props, this.state, 'visible');
	
	    if (visible && this.props.inline) {
	      (0, _handleWindowClickListeners2.default)(this._handleOutsideClick, false);
	      window.removeEventListener('keydown', this._closeOnEsc);
	    }
	  };
	
	  DatePickerContainer.prototype._getDate = function _getDate(value) {
	    if (value === '' || value === null) {
	      return new Date();
	    } else if (typeof value === 'string') {
	      return new Date(value);
	    }
	
	    return value;
	  };
	
	  /**
	   * Gets the current value from the date picker as a formatted string.
	   *
	   * @param {Object} props? the props object to use.
	   * @param {Object} state? the state object to use.
	   * @return {String} a formatted date string or the empty string.
	   */
	  DatePickerContainer.prototype._getFormattedValue = function _getFormattedValue(props, state) {
	    var DateTimeFormat = props.DateTimeFormat,
	        locales = props.locales,
	        formatOptions = props.formatOptions;
	
	    var value = (0, _getField2.default)(props, state, 'value');
	    if (!value) {
	      return '';
	    } else if (value instanceof Date) {
	      return DateTimeFormat(locales, formatOptions).format(new Date(value));
	    } else {
	      return value;
	    }
	  };
	
	  /**
	   * Attempts to validate the `calendarDate` in the state against the min and
	   * max dates.
	   *
	   * This will return null if the current calendarDate is still within the range.
	   *
	   * @param {Date} calendarDate - The current calendar date to compare to.
	   * @param {Date} minDate - An optional min date to compare to.
	   * @param {Date} maxDate - An optional max date to compare to.
	   * @return {Object} - The new state object with the updated calendarDate and
	   *    calendarTempDate keys or null.
	   */
	
	
	  DatePickerContainer.prototype._validateDateRange = function _validateDateRange(calendarDate, minDate, maxDate) {
	    var date = calendarDate;
	    if (minDate && minDate > calendarDate) {
	      date = new Date(minDate);
	    }
	
	    if (maxDate && maxDate < calendarDate) {
	      date = new Date(maxDate);
	    }
	
	    return date;
	  };
	
	  DatePickerContainer.prototype.render = function render() {
	    var _props2 = this.props,
	        style = _props2.style,
	        className = _props2.className,
	        pickerStyle = _props2.pickerStyle,
	        pickerClassName = _props2.pickerClassName,
	        pickerHeaderClassName = _props2.pickerHeaderClassName,
	        pickerContentClassName = _props2.pickerContentClassName,
	        pickerFooterClassName = _props2.pickerFooterClassName,
	        inputStyle = _props2.inputStyle,
	        inputClassName = _props2.inputClassName,
	        textFieldStyle = _props2.textFieldStyle,
	        textFieldClassName = _props2.textFieldClassName,
	        label = _props2.label,
	        placeholder = _props2.placeholder,
	        icon = _props2.icon,
	        inline = _props2.inline,
	        displayMode = _props2.displayMode,
	        fullWidth = _props2.fullWidth,
	        lineDirection = _props2.lineDirection,
	        id = _props2.id,
	        disabled = _props2.disabled,
	        closeOnEsc = _props2.closeOnEsc,
	        animateInline = _props2.animateInline,
	        portal = _props2.portal,
	        renderNode = _props2.renderNode,
	        lastChild = _props2.lastChild,
	        block = _props2.block,
	        paddedBlock = _props2.paddedBlock,
	        active = _props2.active,
	        error = _props2.error,
	        floating = _props2.floating,
	        required = _props2.required,
	        leftIconStateful = _props2.leftIconStateful,
	        rightIcon = _props2.rightIcon,
	        rightIconStateful = _props2.rightIconStateful,
	        customSize = _props2.customSize,
	        errorText = _props2.errorText,
	        helpText = _props2.helpText,
	        helpOnFocus = _props2.helpOnFocus,
	        inlineIndicator = _props2.inlineIndicator,
	        disableScrollLocking = _props2.disableScrollLocking,
	        ariaLabel = _props2['aria-label'],
	        propNextIcon = _props2.nextIcon,
	        propPreviousIcon = _props2.previousIcon,
	        isOpen = _props2.isOpen,
	        previousIconChildren = _props2.previousIconChildren,
	        previousIconClassName = _props2.previousIconClassName,
	        nextIconChildren = _props2.nextIconChildren,
	        nextIconClassName = _props2.nextIconClassName,
	        propValue = _props2.value,
	        propVisible = _props2.visible,
	        defaultValue = _props2.defaultValue,
	        defaultVisible = _props2.defaultVisible,
	        onChange = _props2.onChange,
	        readOnly = _props2.readOnly,
	        onVisibilityChange = _props2.onVisibilityChange,
	        defaultCalendarDate = _props2.defaultCalendarDate,
	        initialCalendarDate = _props2.initialCalendarDate,
	        initiallyOpen = _props2.initiallyOpen,
	        adjustMinWidth = _props2.adjustMinWidth,
	        props = _objectWithoutProperties(_props2, ['style', 'className', 'pickerStyle', 'pickerClassName', 'pickerHeaderClassName', 'pickerContentClassName', 'pickerFooterClassName', 'inputStyle', 'inputClassName', 'textFieldStyle', 'textFieldClassName', 'label', 'placeholder', 'icon', 'inline', 'displayMode', 'fullWidth', 'lineDirection', 'id', 'disabled', 'closeOnEsc', 'animateInline', 'portal', 'renderNode', 'lastChild', 'block', 'paddedBlock', 'active', 'error', 'floating', 'required', 'leftIconStateful', 'rightIcon', 'rightIconStateful', 'customSize', 'errorText', 'helpText', 'helpOnFocus', 'inlineIndicator', 'disableScrollLocking', 'aria-label', 'nextIcon', 'previousIcon', 'isOpen', 'previousIconChildren', 'previousIconClassName', 'nextIconChildren', 'nextIconClassName', 'value', 'visible', 'defaultValue', 'defaultVisible', 'onChange', 'readOnly', 'onVisibilityChange', 'defaultCalendarDate', 'initialCalendarDate', 'initiallyOpen', 'adjustMinWidth']);
	
	    var nextIcon = (0, _getDeprecatedIcon2.default)(nextIconClassName, nextIconChildren, propNextIcon);
	    var previousIcon = (0, _getDeprecatedIcon2.default)(previousIconClassName, previousIconChildren, propPreviousIcon);
	    var visible = typeof isOpen !== 'undefined' ? isOpen : (0, _getField2.default)(this.props, this.state, 'visible');
	
	    var picker = _react2.default.createElement(_DatePicker2.default, _extends({}, this.state, props, {
	      nextIcon: nextIcon,
	      previousIcon: previousIcon,
	      icon: !!icon,
	      inline: inline,
	      style: pickerStyle,
	      className: pickerClassName,
	      headerClassName: pickerHeaderClassName,
	      contentClassName: pickerContentClassName,
	      footerClassName: pickerFooterClassName,
	      displayMode: displayMode,
	      onCancelClick: this._handleCancelClick,
	      onOkClick: this._handleOkClick,
	      changeCalendarMode: this._changeCalendarMode,
	      onPreviousClick: this._previousMonth,
	      onNextClick: this._nextMonth,
	      onCalendarDateClick: this._setCalendarTempDate,
	      onCalendarYearClick: this._setCalendarTempYear
	    }));
	
	    var content = void 0;
	    if (inline) {
	      content = _react2.default.createElement(
	        _Collapse2.default,
	        { collapsed: !visible, animate: animateInline },
	        picker
	      );
	    } else {
	      content = _react2.default.createElement(
	        _DialogContainer2.default,
	        {
	          id: id + '-dialog',
	          visible: visible,
	          onHide: this._handleCancelClick,
	          dialogClassName: 'md-dialog--picker',
	          contentClassName: 'md-dialog-content--picker',
	          'aria-label': ariaLabel,
	          closeOnEsc: closeOnEsc,
	          renderNode: renderNode,
	          portal: portal,
	          lastChild: lastChild,
	          focusOnMount: false,
	          disableScrollLocking: disableScrollLocking
	        },
	        picker
	      );
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { style: style, className: (0, _classnames2.default)('md-picker-container', className), ref: this._setContainer },
	      _react2.default.createElement(_TextField2.default, {
	        id: id,
	        style: textFieldStyle,
	        className: (0, _classnames2.default)({ 'md-pointer--hover': !disabled }, textFieldClassName),
	        inputStyle: inputStyle,
	        inputClassName: (0, _classnames2.default)({ 'md-pointer--hover': !disabled }, inputClassName),
	        active: active || visible,
	        error: error,
	        floating: floating || visible,
	        required: required,
	        disabled: disabled,
	        leftIcon: icon,
	        leftIconStateful: leftIconStateful,
	        rightIcon: rightIcon,
	        rightIconStateful: rightIconStateful,
	        inlineIndicator: inlineIndicator,
	        block: block,
	        paddedBlock: paddedBlock,
	        fullWidth: fullWidth,
	        lineDirection: lineDirection,
	        customSize: customSize,
	        helpText: helpText,
	        helpOnFocus: helpOnFocus,
	        errorText: errorText,
	        label: label,
	        placeholder: placeholder,
	        onClick: this._toggleOpen,
	        onKeyDown: this._handleKeyDown,
	        value: this._getFormattedValue(this.props, this.state),
	        readOnly: true
	      }),
	      content
	    );
	  };
	
	  return DatePickerContainer;
	}(_react.PureComponent);
	
	DatePickerContainer.propTypes = {
	  /**
	   * An id for the text field in the date picker. This is require for a11y.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	
	  /**
	   * An aria label for the dialog. This is required for a11y.
	   */
	  'aria-label': (0, _isRequiredForA11y2.default)(_propTypes2.default.string),
	
	  /**
	   * An optional style to apply to the date picker's container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the date picker's container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the date picker.
	   */
	  pickerStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the date picker.
	   */
	  pickerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the header of date picker.
	   */
	  pickerHeaderClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the content container of date picker.
	   */
	  pickerContentClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the footer of date picker.
	   */
	  pickerFooterClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the calendar container of date picker.
	   */
	  calendarClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the year picker of date picker.
	   */
	  yearPickerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the input tag.
	   */
	  inputStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the input tag.
	   */
	  inputClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the text field's container.
	   */
	  textFieldStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the text field's container.
	   */
	  textFieldClassName: _propTypes2.default.string,
	
	  /**
	   * An optional icon to display with the date picker.
	   *
	   * @see {@link TextFields/TextField#leftIcon}
	   */
	  icon: _propTypes2.default.node,
	
	  /**
	   * Boolean if the date picker is open by default.
	   */
	  defaultVisible: _propTypes2.default.bool,
	
	  /**
	   * An optional label to be displayed in the date picker's text
	   * field.
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * An optional placeholder to be displayed in the date picker's text field.
	   */
	  placeholder: _propTypes2.default.string,
	
	  /**
	   * The value of the date picker. This will make the date picker
	   * be a controlled component. This value should either be a
	   * formatted date string or a date object.
	   */
	  value: (0, _controlled2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]), 'onChange', 'defaultValue'),
	
	  /**
	   * An optional default value to give for the date picker. This should
	   * either be a formatted date string or a date object.
	   */
	  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]),
	
	  /**
	   * An optional date to use when the calendar is opened for the first time.
	   * If this is omitted, it will either be the `defaultValue`, `value`, or
	   * today.
	   */
	  defaultCalendarDate: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]),
	
	  /**
	   * An optional function to call when the selected date is changed
	   * by hitting the OK button. The newly formatted date string,
	   * the new Date object, and the change event will be given.
	   *
	   * `onChange(dateString, dateObject, event)`.
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * A function to format the dates since it should be formatted to the user's
	   * locale. This _should_ be the `Intl.DateTimeFormat` function. You
	   * can also create your own if you really wanted. Inadvisable though.
	   *
	   * See [intl-polyfill](https://github.com/andyearnshaw/Intl.js/) for more info.
	   */
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	
	  /**
	   * The locales to use for formatting the date. This will default to using
	   * the user's language in the browser or `'en-US'` when server rendering.
	   */
	  locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
	
	  /**
	   * The label to use for the ok button on the date picker.
	   */
	  okLabel: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the ok button should be styled with the primary color.
	   */
	  okPrimary: _propTypes2.default.bool,
	
	  /**
	   * The label to use for the cancel button on the date picker.
	   */
	  cancelLabel: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the cancel button should be styled with the primary color.
	   */
	  cancelPrimary: _propTypes2.default.bool,
	
	  /**
	   * The initial mode to open the calendar in.
	   */
	  defaultCalendarMode: _propTypes2.default.oneOf(['calendar', 'year']),
	
	  /**
	   * The icon to use to display the previous month icon in the calendar.
	   */
	  previousIcon: _propTypes2.default.node,
	
	  /**
	   * The icon to use to display the next month icon in the calendar.
	   */
	  nextIcon: _propTypes2.default.node,
	
	  /**
	   * An optional min date to use for the date picker. This will prevent
	   * any dates before this time to be chosen.
	   */
	  minDate: _propTypes2.default.instanceOf(Date),
	
	  /**
	   * An optional max date to use for the date picker. This will prevent
	   * any dates after this time to be chosen.
	   */
	  maxDate: function maxDate(props, propName, component) {
	    for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      others[_key - 3] = arguments[_key];
	    }
	
	    var err = _propTypes2.default.instanceOf(Date).apply(undefined, [props, propName, component].concat(others));
	    if (err || !props.minDate || !props[propName]) {
	      return err;
	    }
	
	    var minDate = props.minDate,
	        maxDate = props.maxDate;
	
	    if (minDate > maxDate) {
	      return new Error('The min date: \'' + minDate + '\' is greater than the max date: \'' + maxDate + '\'');
	    }
	
	    return null;
	  },
	
	  /**
	   * Boolean if the date should automatically be selected when a user clicks
	   * on a new date instead of making them hit the ok button.
	   */
	  autoOk: _propTypes2.default.bool,
	
	  /**
	   * The number of years to display.
	   */
	  yearsDisplayed: _propTypes2.default.number,
	
	  /**
	   * Boolean if the date picker should be displayed inline instead of in a
	   * dialog.
	   */
	  inline: _propTypes2.default.bool,
	
	  /**
	   * An optional force of the display mode of the date picker.
	   * This _should_ not really be used since there are media queries
	   * to use the correct mode based on device orientation.
	   */
	  displayMode: _propTypes2.default.oneOf(['landscape', 'portrait']),
	
	  /**
	   * The DateTimeFormat options to apply to format the date.
	   */
	  formatOptions: _propTypes2.default.shape({
	    weekday: _propTypes2.default.oneOf(['narrow', 'short', 'long']),
	    era: _propTypes2.default.oneOf(['narrow', 'short', 'long']),
	    year: _propTypes2.default.oneOf(['numeric', '2-digit']),
	    month: _propTypes2.default.oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
	    day: _propTypes2.default.oneOf(['numeric', '2-digit']),
	    hour: _propTypes2.default.oneOf(['numeric', '2-digit']),
	    minute: _propTypes2.default.oneOf(['numeric', '2-digit']),
	    second: _propTypes2.default.oneOf(['numeric', '2-digit']),
	    timeZoneName: _propTypes2.default.oneOf(['short', 'long'])
	  }),
	
	  /**
	   * Boolean if the text field for the Date Picker should be displayed as full width.
	   */
	  fullWidth: _propTypes2.default.bool,
	
	  /**
	   * The direction that the text field divider expands from when the text field
	   * in the date picker gains focus.
	   */
	  lineDirection: _propTypes2.default.oneOf(['left', 'center', 'right']),
	
	  /**
	   * An optional boolean if the time picker is current visible by dialog or inline.
	   * If this is set, the `onOpenToggle` function is required.
	   */
	  visible: (0, _controlled2.default)(_propTypes2.default.bool, 'onVisibilityChange', 'defaultVisible'),
	
	  /**
	   * An optional function to call when the date picker is opened in either a dialog, or
	   * inline. The callback will include the next state.
	   *
	   * ```js
	   * onVisibilityChange(!visible, e);
	   * ```
	   */
	  onVisibilityChange: _propTypes2.default.func,
	
	  /**
	   * Boolean if the time picker is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the dialog should be able to close if a keyboard user presses the escape key.
	   */
	  closeOnEsc: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the inline time picker's visibility should be animated.
	   */
	  animateInline: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the time is required.
	   *
	   * @see {@link TextFields/TextField#required}
	   */
	  required: _propTypes2.default.bool,
	
	  /**
	   * @see {@link TextFields/TextField#block}
	   */
	  block: _TextField2.default.propTypes.block,
	
	  /**
	   * @see {@link TextFields/TextField#paddedBlock}
	   */
	  paddedBlock: _TextField2.default.propTypes.paddedBlock,
	
	  /**
	   * @see {@link TextFields/TextField#active}
	   */
	  active: _TextField2.default.propTypes.active,
	
	  /**
	   * @see {@link TextFields/TextField#error}
	   */
	  error: _TextField2.default.propTypes.error,
	
	  /**
	   * @see {@link TextFields/TextField#floating}
	   */
	  floating: _TextField2.default.propTypes.floating,
	
	  /**
	   * @see {@link TextFields/TextField#leftIconStateful}
	   */
	  leftIconStateful: _TextField2.default.propTypes.leftIconStateful,
	
	  /**
	   * @see {@link TextFields/TextField#rightIcon}
	   */
	  rightIcon: _TextField2.default.propTypes.rightIcon,
	
	  /**
	   * @see {@link TextFields/TextField#rightIconStateful}
	   */
	  rightIconStateful: _TextField2.default.propTypes.rightIconStateful,
	
	  /**
	   * @see {@link TextFields/TextField#customSize}
	   */
	  customSize: _TextField2.default.propTypes.customSize,
	
	  /**
	   * @see {@link TextFields/TextField#errorText}
	   */
	  errorText: _TextField2.default.propTypes.errorText,
	
	  /**
	   * @see {@link TextFields/TextField#helpText}
	   */
	  helpText: _TextField2.default.propTypes.helpText,
	
	  /**
	   * @see {@link TextFields/TextField#helpOnFocus}
	   */
	  helpOnFocus: _TextField2.default.propTypes.helpOnFocus,
	
	  /**
	   * @see {@link TextFields/TextField#inlineIndicator}
	   */
	  inlineIndicator: _TextField2.default.propTypes.inlineIndicator,
	
	  /**
	   * Boolean if the Portal's functionality of rendering in a separate react tree should be applied
	   * to the dialog.
	   *
	   * @see {@link Helpers/Portal}
	   */
	  portal: _propTypes2.default.bool,
	
	  /**
	   * An optional DOM Node to render the dialog into. The default is to render as the first child
	   * in the `body`.
	   */
	  renderNode: _propTypes2.default.object,
	
	  /**
	   * Boolean if the DatePicker should be read only. This will prevent the user from opening the picker
	   * and only display the current date in the text field.
	   */
	  readOnly: _propTypes2.default.bool,
	
	  /**
	   * The first day of week: 0 for Sunday, 1 for Monday, 2 for Tuesday, and so on.
	   */
	  firstDayOfWeek: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5, 6]),
	
	  /**
	   * True if weekends are to be greyed out.
	   */
	  disableWeekEnds: _propTypes2.default.bool,
	
	  /**
	   * True if dates from adjacent months should be shown in calendar.
	   */
	  showAllDays: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the dates from adjacent months should be disabled. This will only
	   * do something if the `showAllDays` prop is enabled as well.
	   *
	   * This is really only helpful if youd like the other days to appear, but not be
	   * clickable until the user switches to that month.
	   *
	   * @see {@link #showAllDays}
	   */
	  disableOuterDates: _propTypes2.default.bool,
	
	  /**
	   * An optional className to apply to a date in calendar.
	   */
	  calendarDateClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to a date from an adjacent month in calendar. This will be applied
	   * along with the `calendarDateClassName`.
	   *
	   * @see {@link #showAllDays}
	   * @see {@link #calendarDateClassName}
	   */
	  calendarOuterDateClassName: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the title in calendar header.
	   */
	  calendarTitleClassName: _propTypes2.default.string,
	
	  /**
	   * The DateTimeFormat options to apply to format the title in calendar header.
	   */
	  calendarTitleFormat: _propTypes2.default.shape({
	    era: _propTypes2.default.oneOf(['narrow', 'short', 'long']),
	    year: _propTypes2.default.oneOf(['numeric', '2-digit']),
	    month: _propTypes2.default.oneOf(['numeric', '2-digit', 'narrow', 'short', 'long'])
	  }),
	
	  /**
	   * An optional className to apply to a weekday in calendar header.
	   */
	  calendarWeekdayClassName: _propTypes2.default.string,
	
	  /**
	   * The DateTimeFormat option to apply to format a weekday in calendar header.
	   */
	  calendarWeekdayFormat: _propTypes2.default.oneOf(['narrow', 'short', 'long']),
	
	  /**
	   * @see {@link Dialogs/DialogContainer#disableScrollLocking}
	   */
	  disableScrollLocking: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the dialog should be rendered as the last child of the `renderNode` or `body` instead
	   * of the first.
	   */
	  lastChild: _propTypes2.default.bool,
	
	  previousIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `previousIcon` prop instead'),
	  previousIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `previousIcon` prop instead'),
	  nextIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'use the `nextIcon` prop instead'),
	  nextIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `nextIcon` prop instead'),
	  adjustMinWidth: (0, _deprecated2.default)(_propTypes2.default.bool, 'No longer valid for a text field'),
	  isOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `visible` instead'),
	  initiallyOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `defaultVisible` instead'),
	  initialCalendarDate: (0, _deprecated2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]), 'Use `defaultCalendarDate` instead'),
	  initialCalendarMode: (0, _deprecated2.default)(_propTypes2.default.oneOf(['calendar', 'year']), 'Use `defaultCalendarMode` instead'),
	  initialYearsDisplayed: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `yearsDisplayed` instead. I have not implemented infinite loading years')
	};
	DatePickerContainer.defaultProps = {
	  animateInline: true,
	  previousIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'chevron_left'
	  ),
	  nextIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'chevron_right'
	  ),
	  autoOk: false,
	  icon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'date_range'
	  ),
	  yearsDisplayed: 100,
	  defaultCalendarMode: 'calendar',
	  DateTimeFormat: _DateTimeFormat2.default, // eslint-disable-line object-shorthand
	  locales: typeof window !== 'undefined' ? window.navigator.userLanguage || window.navigator.language : 'en-US',
	  okLabel: 'Ok',
	  okPrimary: true,
	  cancelLabel: 'Cancel',
	  cancelPrimary: true,
	  closeOnEsc: true,
	  disableScrollLocking: false,
	  'aria-label': 'Pick a date'
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._setContainer = function (container) {
	    _this2._container = container;
	  };
	
	  this._closeOnEsc = function (e) {
	    if ((e.which || e.keyCode) === _keyCodes.ESC) {
	      _this2._handleCancelClick(e);
	    }
	  };
	
	  this._handleOutsideClick = function (e) {
	    if (_this2._container && !_this2._container.contains(e.target)) {
	      _this2._handleCancelClick(e);
	    }
	  };
	
	  this._toggleOpen = function (e) {
	    if (_this2.props.disabled || _this2.props.readOnly) {
	      return;
	    }
	
	    var visible = !(typeof _this2.props.isOpen !== 'undefined' ? _this2.props.isOpen : (0, _getField2.default)(_this2.props, _this2.state, 'visible'));
	
	    if (_this2.props.onVisibilityChange) {
	      _this2.props.onVisibilityChange(visible, e);
	    }
	
	    if (typeof _this2.props.isOpen === 'undefined' && typeof _this2.props.visible === 'undefined') {
	      _this2.setState({ visible: visible });
	    }
	  };
	
	  this._handleKeyDown = function (e) {
	    (0, _handleKeyboardAccessibility2.default)(e, _this2._toggleOpen, true, true);
	
	    if ((e.which || e.keyCode) === _keyCodes.TAB && _this2.state.active) {
	      _this2.setState({ active: false });
	    }
	  };
	
	  this._handleOkClick = function (e) {
	    var _props3 = _this2.props,
	        DateTimeFormat = _props3.DateTimeFormat,
	        locales = _props3.locales,
	        onChange = _props3.onChange,
	        formatOptions = _props3.formatOptions,
	        onVisibilityChange = _props3.onVisibilityChange;
	
	    var value = DateTimeFormat(locales, formatOptions).format(_this2.state.calendarTempDate);
	    if (onChange) {
	      onChange(value, new Date(_this2.state.calendarTempDate), e);
	    }
	
	    if (onVisibilityChange) {
	      onVisibilityChange(false, e);
	    }
	
	    var state = void 0;
	    if (typeof _this2.props.value === 'undefined') {
	      state = { value: value };
	    }
	
	    if (typeof _this2.props.visible === 'undefined' && typeof _this2.props.isOpen === 'undefined') {
	      state = state || {};
	      state.visible = false;
	    }
	
	    if (state) {
	      _this2.setState(state);
	    }
	  };
	
	  this._handleCancelClick = function (e) {
	    var state = { calendarTempDate: _this2.state.calendarDate };
	    if (typeof _this2.props.isOpen === 'undefined' && typeof _this2.props.isOpen === 'undefined') {
	      state.visible = false;
	    }
	
	    if (_this2.props.onVisibilityChange) {
	      _this2.props.onVisibilityChange(false, e);
	    }
	
	    _this2.setState(state);
	  };
	
	  this._changeCalendarMode = function (calendarMode) {
	    if (_this2.state.calendarMode === calendarMode) {
	      return;
	    }
	
	    _this2.setState({ calendarMode: calendarMode });
	  };
	
	  this._previousMonth = function () {
	    var calendarDate = (0, _addDate2.default)(_this2.state.calendarDate, -1, 'M');
	    _this2.setState({ calendarDate: calendarDate });
	  };
	
	  this._nextMonth = function () {
	    var calendarDate = (0, _addDate2.default)(_this2.state.calendarDate, 1, 'M');
	    _this2.setState({ calendarDate: calendarDate });
	  };
	
	  this._setCalendarTempDate = function (calendarTempDate) {
	    var _props4 = _this2.props,
	        autoOk = _props4.autoOk,
	        DateTimeFormat = _props4.DateTimeFormat,
	        locales = _props4.locales,
	        onChange = _props4.onChange,
	        formatOptions = _props4.formatOptions;
	
	
	    var state = { calendarTempDate: calendarTempDate };
	    if (autoOk) {
	      var value = DateTimeFormat(locales, formatOptions).format(calendarTempDate);
	      if (onChange) {
	        onChange(value, new Date(calendarTempDate));
	      }
	
	      if (typeof _this2.props.value === 'undefined') {
	        state.value = value;
	      }
	
	      _this2._timeout = setTimeout(function () {
	        _this2._timeout = null;
	
	        if (_this2.props.onVisibilityChange) {
	          _this2.props.onVisibilityChange(false);
	        }
	
	        if (typeof _this2.props.visible === 'undefined' && typeof _this2.props.isOpen === 'undefined') {
	          _this2.setState({ visible: false });
	        }
	      });
	    }
	    _this2.setState(state);
	  };
	
	  this._setCalendarTempYear = function (year) {
	    var _state = _this2.state,
	        calendarTempDate = _state.calendarTempDate,
	        calendarDate = _state.calendarDate;
	
	    if (calendarTempDate.getFullYear() === year) {
	      return;
	    }
	
	    var _props5 = _this2.props,
	        minDate = _props5.minDate,
	        maxDate = _props5.maxDate;
	
	    var nextDate = new Date(calendarDate.setFullYear(year));
	    var nextTemp = new Date(calendarTempDate.setFullYear(year));
	
	    if (minDate && nextTemp < minDate) {
	      nextDate = new Date(minDate);
	      nextTemp = new Date(minDate);
	    }
	
	    if (maxDate && nextTemp > maxDate) {
	      nextDate = new Date(maxDate);
	      nextTemp = new Date(maxDate);
	    }
	
	    _this2.setState({
	      calendarDate: nextDate,
	      calendarTempDate: nextTemp
	    });
	  };
	};
	
	exports.default = DatePickerContainer;

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PickerControl = __webpack_require__(240);
	
	var _PickerControl2 = _interopRequireDefault(_PickerControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable new-cap */
	
	
	/**
	 * The `DatePickerHeader` component is the component that holds the
	 * current year and the current date. It allows the user to switch
	 * between calendar and year picker mode.
	 */
	var DatePickerHeader = function (_PureComponent) {
	  _inherits(DatePickerHeader, _PureComponent);
	
	  function DatePickerHeader(props) {
	    _classCallCheck(this, DatePickerHeader);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));
	
	    _this._selectYear = function (e) {
	      _this.props.changeCalendarMode('year', e);
	    };
	
	    _this._selectCalendar = function (e) {
	      _this.props.changeCalendarMode('calendar', e);
	    };
	
	    _this.state = _this._getFormattedDate(props);
	    return _this;
	  }
	
	  DatePickerHeader.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _props = this.props,
	        DateTimeFormat = _props.DateTimeFormat,
	        locales = _props.locales,
	        calendarTempDate = _props.calendarTempDate,
	        changeCalendarMode = _props.changeCalendarMode;
	
	    if (DateTimeFormat !== nextProps.DateTimeFormat || locales !== nextProps.locales || calendarTempDate !== nextProps.calendarTempDate || changeCalendarMode !== nextProps.changeCalendarMode) {
	      this.setState(this._getFormattedDate(nextProps));
	    }
	  };
	
	  DatePickerHeader.prototype._getFormattedDate = function _getFormattedDate(_ref) {
	    var DateTimeFormat = _ref.DateTimeFormat,
	        locales = _ref.locales,
	        calendarTempDate = _ref.calendarTempDate;
	
	    return {
	      year: DateTimeFormat(locales, { year: 'numeric' }).format(calendarTempDate),
	      weekday: DateTimeFormat(locales, { weekday: 'short' }).format(calendarTempDate),
	      date: DateTimeFormat(locales, { month: 'short', day: '2-digit' }).format(calendarTempDate)
	    };
	  };
	
	  DatePickerHeader.prototype.render = function render() {
	    var _state = this.state,
	        year = _state.year,
	        weekday = _state.weekday,
	        date = _state.date;
	    var _props2 = this.props,
	        calendarMode = _props2.calendarMode,
	        className = _props2.className;
	
	    return _react2.default.createElement(
	      'header',
	      { className: (0, _classnames2.default)('md-picker-header', className) },
	      _react2.default.createElement(
	        _PickerControl2.default,
	        { onClick: this._selectYear, active: calendarMode === 'year' },
	        _react2.default.createElement(
	          'h6',
	          { className: 'md-subheading-1' },
	          year
	        )
	      ),
	      _react2.default.createElement(
	        _PickerControl2.default,
	        { onClick: this._selectCalendar, active: calendarMode === 'calendar' },
	        _react2.default.createElement(
	          'h4',
	          { className: 'md-display-1' },
	          weekday + ',',
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'h4',
	          { className: 'md-display-1' },
	          date
	        )
	      )
	    );
	  };
	
	  return DatePickerHeader;
	}(_react.PureComponent);
	
	DatePickerHeader.propTypes = {
	  className: _propTypes2.default.string,
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
	  calendarTempDate: _propTypes2.default.instanceOf(Date).isRequired,
	  calendarMode: _propTypes2.default.oneOf(['calendar', 'year']).isRequired,
	  changeCalendarMode: _propTypes2.default.func.isRequired
	};
	exports.default = DatePickerHeader;

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _addHours = __webpack_require__(919);
	
	var _addHours2 = _interopRequireDefault(_addHours);
	
	var _PickerControl = __webpack_require__(240);
	
	var _PickerControl2 = _interopRequireDefault(_PickerControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This component displays a section for switching between the AM
	 * and PM time periods.
	 */
	var TimePeriods = function (_PureComponent) {
	  _inherits(TimePeriods, _PureComponent);
	
	  function TimePeriods() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TimePeriods);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this._setAM = function () {
	      if (_this.props.timePeriod !== 'AM') {
	        _this.props.setTempTime((0, _addHours2.default)(_this.props.tempTime, -12));
	      }
	    }, _this._setPM = function () {
	      if (_this.props.timePeriod !== 'PM') {
	        _this.props.setTempTime((0, _addHours2.default)(_this.props.tempTime, 12));
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  TimePeriods.prototype.render = function render() {
	    var timePeriod = this.props.timePeriod;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'md-time-periods' },
	      _react2.default.createElement(
	        _PickerControl2.default,
	        { onClick: this._setAM, active: timePeriod === 'AM' },
	        _react2.default.createElement(
	          'h6',
	          { className: 'md-time-period' },
	          'AM'
	        )
	      ),
	      _react2.default.createElement(
	        _PickerControl2.default,
	        { onClick: this._setPM, active: timePeriod === 'PM' },
	        _react2.default.createElement(
	          'h6',
	          { className: 'md-time-period' },
	          'PM'
	        )
	      )
	    );
	  };
	
	  return TimePeriods;
	}(_react.PureComponent);
	
	TimePeriods.propTypes = {
	  /**
	   * The current time for the time picker.
	   */
	  tempTime: _propTypes2.default.instanceOf(Date).isRequired,
	
	  /**
	   * A function to update the time for the time picker.
	   */
	  setTempTime: _propTypes2.default.func.isRequired,
	
	  /**
	   * The current time period.
	   */
	  timePeriod: _propTypes2.default.string.isRequired
	};
	exports.default = TimePeriods;

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ClockFace = __webpack_require__(875);
	
	var _ClockFace2 = _interopRequireDefault(_ClockFace);
	
	var _DialogFooter = __webpack_require__(165);
	
	var _DialogFooter2 = _interopRequireDefault(_DialogFooter);
	
	var _TimePickerHeader = __webpack_require__(885);
	
	var _TimePickerHeader2 = _interopRequireDefault(_TimePickerHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `TimePicker` component is used to display a time picker
	 * in the `TimePickerContainer` component.
	 */
	var TimePicker = function (_PureComponent) {
	  _inherits(TimePicker, _PureComponent);
	
	  function TimePicker() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TimePicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this._updateTime = function (newTime) {
	      var timePart = newTime;
	      var _this$props = _this.props,
	          tempTime = _this$props.tempTime,
	          setTempTime = _this$props.setTempTime,
	          timeMode = _this$props.timeMode,
	          timePeriod = _this$props.timePeriod;
	
	      var time = new Date(tempTime);
	      if (timeMode === 'hour') {
	        var isAM = timePeriod === 'AM';
	        var is12 = timePart === 12;
	        if (timePeriod && isAM && is12) {
	          timePart = 0;
	        } else if (timePeriod && !isAM && !is12) {
	          timePart += 12;
	        }
	
	        time.setHours(timePart);
	      }
	
	      if (timeMode === 'minute') {
	        time.setMinutes(timePart);
	      }
	
	      if (timeMode === 'second') {
	        time.setSeconds(timePart);
	      }
	
	      setTempTime(time);
	    }, _this._handleTimeChosen = function () {
	      var _this$props2 = _this.props,
	          hoverMode = _this$props2.hoverMode,
	          setTimeMode = _this$props2.setTimeMode,
	          onOkClick = _this$props2.onOkClick,
	          timeMode = _this$props2.timeMode;
	
	
	      if (hoverMode) {
	        if (timeMode === 'hour') {
	          setTimeMode('minute');
	        } else {
	          onOkClick();
	        }
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  /**
	   * Takes in the new time (number o'clock or minutes), updates the temp time
	   * with that new time, and then calls the setTempTime prop.
	   */
	
	
	  TimePicker.prototype.render = function render() {
	    var _cn;
	
	    var _props = this.props,
	        okLabel = _props.okLabel,
	        okPrimary = _props.okPrimary,
	        onOkClick = _props.onOkClick,
	        cancelLabel = _props.cancelLabel,
	        cancelPrimary = _props.cancelPrimary,
	        onCancelClick = _props.onCancelClick,
	        style = _props.style,
	        className = _props.className,
	        setTimeMode = _props.setTimeMode,
	        setTempTime = _props.setTempTime,
	        timeMode = _props.timeMode,
	        tempTime = _props.tempTime,
	        hours = _props.hours,
	        minutes = _props.minutes,
	        seconds = _props.seconds,
	        timePeriod = _props.timePeriod,
	        displayMode = _props.displayMode,
	        inline = _props.inline,
	        icon = _props.icon,
	        hoverMode = _props.hoverMode,
	        showSeconds = _props.showSeconds;
	
	
	    var hoursInt = parseInt(hours, 10);
	    var minutesInt = parseInt(minutes.replace(/[^0-9]/g, ''), 10);
	    var secondsInt = void 0;
	    if (showSeconds) secondsInt = parseInt(seconds.replace(/[^0-9]/g, ''), 10);
	
	    var actions = [{
	      key: 'cancel',
	      onClick: onCancelClick,
	      primary: cancelPrimary,
	      secondary: !cancelPrimary,
	      label: cancelLabel
	    }, {
	      key: 'ok',
	      onClick: onOkClick,
	      primary: okPrimary,
	      secondary: !okPrimary,
	      label: okLabel
	    }];
	
	    var time = void 0;
	    if (timeMode === 'hour') time = hoursInt;
	    if (timeMode === 'minute') time = minutesInt;
	    if (timeMode === 'second') time = secondsInt;
	
	    return _react2.default.createElement(
	      'div',
	      {
	        style: style,
	        className: (0, _classnames2.default)('md-picker md-picker--time', (_cn = {}, _cn['md-picker--' + displayMode] = displayMode, _cn['md-picker--inline'] = inline, _cn['md-picker--inline-icon'] = inline && icon, _cn), className)
	      },
	      _react2.default.createElement(_TimePickerHeader2.default, {
	        tempTime: tempTime,
	        timeMode: timeMode,
	        setTimeMode: setTimeMode,
	        setTempTime: setTempTime,
	        hours: hours,
	        minutes: minutes,
	        seconds: seconds,
	        timePeriod: timePeriod,
	        showSeconds: showSeconds
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'md-picker-content-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'md-picker-content md-picker-content--clock' },
	          _react2.default.createElement(_ClockFace2.default, {
	            time: time,
	            minutes: timeMode === 'minute' || timeMode === 'second',
	            onChange: this._updateTime,
	            timePeriod: timePeriod,
	            hoverMode: hoverMode,
	            onTimeChosen: this._handleTimeChosen
	          })
	        ),
	        _react2.default.createElement(_DialogFooter2.default, { actions: actions })
	      )
	    );
	  };
	
	  return TimePicker;
	}(_react.PureComponent);
	
	TimePicker.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  okLabel: _propTypes2.default.node.isRequired,
	  okPrimary: _propTypes2.default.bool.isRequired,
	  onOkClick: _propTypes2.default.func.isRequired,
	  cancelLabel: _propTypes2.default.node.isRequired,
	  cancelPrimary: _propTypes2.default.bool.isRequired,
	  onCancelClick: _propTypes2.default.func.isRequired,
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
	  icon: _propTypes2.default.bool,
	  inline: _propTypes2.default.bool,
	  displayMode: _propTypes2.default.oneOf(['landscape', 'portrait']),
	
	  /**
	   * A function that will switch the state from hour to minute.
	   */
	  setTimeMode: _propTypes2.default.func.isRequired,
	
	  /**
	   * A function that will update the time for the TimePicker before
	   * the user selects ok. This function will be given a new Date object
	   * with a modified time.
	   */
	  setTempTime: _propTypes2.default.func.isRequired,
	
	  /**
	   * The current display mode of the time picker.
	   */
	  timeMode: _propTypes2.default.oneOf(['hour', 'minute', 'second']).isRequired,
	
	  /**
	   * The current time as a date object that is being displayed in the
	   * time picker.
	   */
	  tempTime: _propTypes2.default.instanceOf(Date).isRequired,
	
	  /**
	   * A string that is a representation of the hours in the user's locale.
	   */
	  hours: _propTypes2.default.string.isRequired,
	
	  /**
	   * A string that is a representation of the minutes in the user's locale.
	   * This will also include any separator the locale uses.
	   *
	   * Example: ':15' in '3:15 PM' for 'en-US'
	   */
	  minutes: _propTypes2.default.string.isRequired,
	
	  /**
	   * A string that is a representation of the seconds in the user's locale.
	   * This will also include any separator the locale uses.
	   *
	   * Example: ':00' in '3:15:00 PM' for 'en-US'
	   */
	  seconds: _propTypes2.default.string,
	
	  /**
	   * An optional time period if a user's locale uses it.
	   */
	  timePeriod: _propTypes2.default.string,
	
	  /**
	   * If true the hover mode of the Time Picker is activated.
	   * In hover mode no clicks are required to start selecting an hour
	   * and the timemode switches automatically when a time was chosen.
	   * When a minute is selected the chosen time is applied automatically.
	   */
	  hoverMode: _propTypes2.default.bool,
	
	  /**
	   * A boolean that if true, seconds are displayed
	   */
	  showSeconds: _propTypes2.default.bool
	};
	exports.default = TimePicker;

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _isRequiredForA11y = __webpack_require__(16);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _deprecated = __webpack_require__(5);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _keyCodes = __webpack_require__(14);
	
	var _getField = __webpack_require__(8);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _handleWindowClickListeners = __webpack_require__(90);
	
	var _handleWindowClickListeners2 = _interopRequireDefault(_handleWindowClickListeners);
	
	var _handleKeyboardAccessibility = __webpack_require__(57);
	
	var _handleKeyboardAccessibility2 = _interopRequireDefault(_handleKeyboardAccessibility);
	
	var _controlled = __webpack_require__(15);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _DateTimeFormat = __webpack_require__(346);
	
	var _DateTimeFormat2 = _interopRequireDefault(_DateTimeFormat);
	
	var _formatTime = __webpack_require__(347);
	
	var _formatTime2 = _interopRequireDefault(_formatTime);
	
	var _extractTimeParts = __webpack_require__(920);
	
	var _extractTimeParts2 = _interopRequireDefault(_extractTimeParts);
	
	var _DialogContainer = __webpack_require__(235);
	
	var _DialogContainer2 = _interopRequireDefault(_DialogContainer);
	
	var _FontIcon = __webpack_require__(12);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _TextField = __webpack_require__(89);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _Collapse = __webpack_require__(55);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _TimePicker = __webpack_require__(883);
	
	var _TimePicker2 = _interopRequireDefault(_TimePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-shadow */
	
	
	/**
	 * The `TimePickerContainer` component is a wrapper for the main `TimePicker` component
	 * to manage the state and _logic_ for rendering the `TimePicker`. This component will
	 * either render inline or in a `Dialog` depending if the `inline` prop is set
	 * to `true`.
	 *
	 * NOTE: This component is actually exported as `TimePicker` when using the `import { member }` syntax.
	 * The following two lines are equivalent:
	 *
	 * ```js
	 * import { TimePicker } from 'react-md/lib/Pickers';
	 * import TimePicker from 'react-md/lib/Pickers/TimePickerContainer';
	 * ```
	 */
	var TimePickerContainer = function (_PureComponent) {
	  _inherits(TimePickerContainer, _PureComponent);
	
	  function TimePickerContainer(props) {
	    _classCallCheck(this, TimePickerContainer);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var initialDate = void 0;
	    if (props.defaultValue) {
	      initialDate = new Date(props.defaultValue);
	    } else if (props.value) {
	      initialDate = new Date(props.value);
	    } else {
	      initialDate = new Date();
	    }
	
	    var visible = typeof props.initiallyOpen !== 'undefined' ? props.initiallyOpen : !!props.defaultVisible;
	
	    _this.state = _extends({
	      visible: visible
	    }, _this._getTimeParts(initialDate, props), {
	      value: props.defaultValue,
	      time: initialDate,
	      timeMode: props.initialTimeMode || props.defaultTimeMode,
	      tempTime: initialDate
	    });
	    return _this;
	  }
	
	  TimePickerContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.value !== nextProps.value) {
	      var time = nextProps.value || new Date();
	      this.setState(_extends({ tempTime: time }, this._getTimeParts(time, nextProps)));
	    }
	  };
	
	  TimePickerContainer.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    var _props = this.props,
	        inline = _props.inline,
	        isOpen = _props.isOpen;
	
	    var visible = typeof isOpen !== 'undefined' ? isOpen : (0, _getField2.default)(this.props, this.state, 'visible');
	    var pVisible = typeof prevProps.isOpen !== 'undefined' ? prevProps.isOpen : (0, _getField2.default)(prevProps, prevState, 'visible');
	
	    if (visible === pVisible) {
	      return;
	    }
	
	    if (visible) {
	      if (inline) {
	        (0, _handleWindowClickListeners2.default)(this._handleOutsideClick, true);
	        window.addEventListener('keydown', this._closeOnEsc);
	      }
	    } else if (inline) {
	      (0, _handleWindowClickListeners2.default)(this._handleOutsideClick, false);
	      window.removeEventListener('keydown', this._closeOnEsc);
	    }
	  };
	
	  TimePickerContainer.prototype.componentWillUnmount = function componentWillUnmount() {
	    var visible = typeof this.props.isOpen !== 'undefined' ? this.props.isOpen : (0, _getField2.default)(this.props, this.state, 'visible');
	    if (visible && this.props.inline) {
	      (0, _handleWindowClickListeners2.default)(this._handleOutsideClick, false);
	      window.removeEventListener('keydown', this._closeOnEsc);
	    }
	  };
	
	  TimePickerContainer.prototype._getTimeParts = function _getTimeParts(date, props) {
	    return (0, _extractTimeParts2.default)(props.DateTimeFormat, props.locales, props.showSeconds, date);
	  };
	
	  TimePickerContainer.prototype._getTextFieldValue = function _getTextFieldValue(props, state) {
	    var DateTimeFormat = props.DateTimeFormat,
	        locales = props.locales,
	        showSeconds = props.showSeconds;
	
	    var value = (0, _getField2.default)(props, state, 'value');
	    if (!value) {
	      return '';
	    } else if (value instanceof Date) {
	      return (0, _formatTime2.default)(DateTimeFormat, locales, showSeconds, value);
	    } else {
	      // currently don't support value of string
	      return value;
	    }
	  };
	
	  TimePickerContainer.prototype.render = function render() {
	    var _state = this.state,
	        timeMode = _state.timeMode,
	        tempTime = _state.tempTime,
	        hours = _state.hours,
	        minutes = _state.minutes,
	        seconds = _state.seconds,
	        timePeriod = _state.timePeriod;
	
	    var _props2 = this.props,
	        style = _props2.style,
	        className = _props2.className,
	        pickerStyle = _props2.pickerStyle,
	        pickerClassName = _props2.pickerClassName,
	        inputStyle = _props2.inputStyle,
	        inputClassName = _props2.inputClassName,
	        textFieldStyle = _props2.textFieldStyle,
	        textFieldClassName = _props2.textFieldClassName,
	        id = _props2.id,
	        disabled = _props2.disabled,
	        label = _props2.label,
	        placeholder = _props2.placeholder,
	        icon = _props2.icon,
	        inline = _props2.inline,
	        displayMode = _props2.displayMode,
	        fullWidth = _props2.fullWidth,
	        lineDirection = _props2.lineDirection,
	        closeOnEsc = _props2.closeOnEsc,
	        hoverMode = _props2.hoverMode,
	        showSeconds = _props2.showSeconds,
	        portal = _props2.portal,
	        renderNode = _props2.renderNode,
	        lastChild = _props2.lastChild,
	        animateInline = _props2.animateInline,
	        block = _props2.block,
	        paddedBlock = _props2.paddedBlock,
	        active = _props2.active,
	        error = _props2.error,
	        floating = _props2.floating,
	        required = _props2.required,
	        leftIconStateful = _props2.leftIconStateful,
	        rightIcon = _props2.rightIcon,
	        rightIconStateful = _props2.rightIconStateful,
	        customSize = _props2.customSize,
	        errorText = _props2.errorText,
	        helpText = _props2.helpText,
	        helpOnFocus = _props2.helpOnFocus,
	        inlineIndicator = _props2.inlineIndicator,
	        disableScrollLocking = _props2.disableScrollLocking,
	        ariaLabel = _props2['aria-label'],
	        propValue = _props2.value,
	        propVisible = _props2.visible,
	        readOnly = _props2.readOnly,
	        defaultValue = _props2.defaultValue,
	        defaultVisible = _props2.defaultVisible,
	        defaultTimeMode = _props2.defaultTimeMode,
	        onVisibilityChange = _props2.onVisibilityChange,
	        isOpen = _props2.isOpen,
	        initialTimeMode = _props2.initialTimeMode,
	        initiallyOpen = _props2.initiallyOpen,
	        props = _objectWithoutProperties(_props2, ['style', 'className', 'pickerStyle', 'pickerClassName', 'inputStyle', 'inputClassName', 'textFieldStyle', 'textFieldClassName', 'id', 'disabled', 'label', 'placeholder', 'icon', 'inline', 'displayMode', 'fullWidth', 'lineDirection', 'closeOnEsc', 'hoverMode', 'showSeconds', 'portal', 'renderNode', 'lastChild', 'animateInline', 'block', 'paddedBlock', 'active', 'error', 'floating', 'required', 'leftIconStateful', 'rightIcon', 'rightIconStateful', 'customSize', 'errorText', 'helpText', 'helpOnFocus', 'inlineIndicator', 'disableScrollLocking', 'aria-label', 'value', 'visible', 'readOnly', 'defaultValue', 'defaultVisible', 'defaultTimeMode', 'onVisibilityChange', 'isOpen', 'initialTimeMode', 'initiallyOpen']);
	
	    var visible = typeof this.props.isOpen !== 'undefined' ? this.props.isOpen : (0, _getField2.default)(this.props, this.state, 'visible');
	
	    var picker = _react2.default.createElement(_TimePicker2.default, _extends({}, props, {
	      inline: inline,
	      icon: !!icon,
	      tempTime: tempTime,
	      timeMode: timeMode,
	      seconds: seconds,
	      hours: hours,
	      minutes: minutes,
	      timePeriod: timePeriod,
	      style: pickerStyle,
	      className: pickerClassName,
	      displayMode: displayMode,
	      onOkClick: this._handleOkClick,
	      onCancelClick: this._handleCancelClick,
	      setTimeMode: this._setTimeMode,
	      setTempTime: this._setTempTime,
	      hoverMode: hoverMode,
	      showSeconds: showSeconds
	    }));
	
	    var content = void 0;
	    if (inline) {
	      content = _react2.default.createElement(
	        _Collapse2.default,
	        { collapsed: !visible, animate: animateInline },
	        picker
	      );
	    } else {
	      content = _react2.default.createElement(
	        _DialogContainer2.default,
	        {
	          id: id + '-dialog',
	          visible: visible,
	          onHide: this._handleCancelClick,
	          dialogClassName: 'md-dialog--picker',
	          contentClassName: 'md-dialog-content--picker',
	          'aria-label': ariaLabel,
	          closeOnEsc: closeOnEsc,
	          portal: portal,
	          lastChild: lastChild,
	          renderNode: renderNode,
	          focusOnMount: false,
	          disableScrollLocking: disableScrollLocking
	        },
	        picker
	      );
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { style: style, className: (0, _classnames2.default)('md-picker-container', className), ref: this._setContainer },
	      _react2.default.createElement(_TextField2.default, {
	        id: id,
	        style: textFieldStyle,
	        className: (0, _classnames2.default)({ 'md-pointer--hover': !disabled }, textFieldClassName),
	        inputStyle: inputStyle,
	        inputClassName: (0, _classnames2.default)({ 'md-pointer--hover': !disabled }, inputClassName),
	        active: active || visible,
	        error: error,
	        floating: floating || visible,
	        required: required,
	        disabled: disabled,
	        leftIcon: icon,
	        leftIconStateful: leftIconStateful,
	        rightIcon: rightIcon,
	        rightIconStateful: rightIconStateful,
	        inlineIndicator: inlineIndicator,
	        block: block,
	        paddedBlock: paddedBlock,
	        fullWidth: fullWidth,
	        lineDirection: lineDirection,
	        customSize: customSize,
	        helpText: helpText,
	        helpOnFocus: helpOnFocus,
	        errorText: errorText,
	        label: label,
	        placeholder: placeholder,
	        onClick: this._toggleOpen,
	        onKeyDown: this._handleKeyDown,
	        value: this._getTextFieldValue(this.props, this.state),
	        readOnly: true
	      }),
	      content
	    );
	  };
	
	  return TimePickerContainer;
	}(_react.PureComponent);
	
	TimePickerContainer.propTypes = {
	  /**
	   * An id for the text field in the time picker. This is require for a11y.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	
	  /**
	   * An aria-label to apply to the dialog when it has been opened. This is required for
	   * a11y.
	   */
	  'aria-label': (0, _isRequiredForA11y2.default)(_propTypes2.default.string),
	
	  /**
	   * An optional style to apply to the time picker's container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the time picker's container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the time picker.
	   */
	  pickerStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the time picker.
	   */
	  pickerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the input tag.
	   */
	  inputStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the input tag.
	   */
	  inputClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the text field's container.
	   */
	  textFieldStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the text field's container.
	   */
	  textFieldClassName: _propTypes2.default.string,
	
	  /**
	   * An optional icon to display with the time picker.
	   *
	   * @see {@link TextFields/TextField#leftIcon}
	   */
	  icon: _propTypes2.default.node,
	
	  /**
	   * Boolean if the time picker is open by default.
	   */
	  defaultVisible: _propTypes2.default.bool,
	
	  /**
	   * An optional label to be displayed in the time picker's text
	   * field.
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * An optional placeholder to be displayed in the time picker's text field.
	   */
	  placeholder: _propTypes2.default.string,
	
	  /**
	   * The value of the time picker. This will make the time picker
	   * be a controlled component.
	   */
	  value: (0, _controlled2.default)(_propTypes2.default.instanceOf(Date), 'onChange', 'defaultValue'),
	
	  /**
	   * An optional function to call when the selected date is changed
	   * by hitting the OK button. The newly formatted time string,
	   * the new Date object, and the change event will be given.
	   *
	   * `onChange(timeString, dateObject, event)`.
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * An optional default value to give for the year picker.
	   */
	  defaultValue: _propTypes2.default.instanceOf(Date),
	
	  /**
	   * A function to format the dates since it should be formatted to the user's
	   * locale. This _should_ be the `Intl.DateTimeFormat` function. You
	   * can also create your own if you really wanted. Inadvisable though.
	   *
	   * See [intl-polyfill](https://github.com/andyearnshaw/Intl.js/) for more info.
	   */
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	
	  /**
	   * The locales to use for formatting the date. This will default to using
	   * the user's language in the browser or `'en-US'` when server rendering.
	   */
	  locales: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
	
	  /**
	   * The label to use for the ok button on the year picker.
	   */
	  okLabel: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the ok button should be styled with the primary color.
	   */
	  okPrimary: _propTypes2.default.bool,
	
	  /**
	   * The label to use for the cancel button on the year picker.
	   */
	  cancelLabel: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the cancel button should be styled with the primary color.
	   */
	  cancelPrimary: _propTypes2.default.bool,
	
	  /**
	   * The default mode to open the time picker in.
	   */
	  defaultTimeMode: _propTypes2.default.oneOf(['hour', 'minute', 'second']),
	
	  /**
	   * Boolean if the date should automatically be selected when a user clicks
	   * on a new date instead of making them hit the ok button.
	   */
	  autoOk: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the date picker should be displayed inline instead of in a
	   * dialog.
	   */
	  inline: _propTypes2.default.bool,
	
	  /**
	   * An optional force of the display mode of the date picker.
	   * This _should_ not really be used since there are media queries
	   * to use the correct mode based on device orientation.
	   */
	  displayMode: _propTypes2.default.oneOf(['landscape', 'portrait']),
	
	  /**
	   * Boolean if the text field for the Time Picker should be displayed as full width.
	   */
	  fullWidth: _propTypes2.default.bool,
	
	  /**
	   * The direction that the text field divider expands from when the text field
	   * in the date picker gains focus.
	   */
	  lineDirection: _propTypes2.default.oneOf(['left', 'center', 'right']),
	
	  /**
	   * An optional boolean if the time picker is current visible by dialog or inline.
	   * If this is set, the `onVisibilityChange` function is required.
	   */
	  visible: (0, _controlled2.default)(_propTypes2.default.bool, 'onVisibilityChange', 'defaultVisible'),
	
	  /**
	   * An optional function to call when the date picker is opened in either a dialog, or
	   * inline. The callback will include the next state.
	   *
	   * ```js
	   * onVisibilityChange(!visible, e);
	   * ```
	   */
	  onVisibilityChange: _propTypes2.default.func,
	
	  /**
	   * Boolean if the time picker is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the dialog should be able to close if a keyboard user presses the escape key.
	   */
	  closeOnEsc: _propTypes2.default.bool,
	
	  /**
	   * If true the hover mode of the Time Picker is activated.
	   * In hover mode no clicks are required to start selecting an hour
	   * and the time mode switches automatically when a time was chosen.
	   * When a minute is selected the chosen time is applied automatically.
	   */
	  hoverMode: _propTypes2.default.bool,
	
	  /**
	   * If true seconds will be selectable in the Time Picker.
	   */
	  showSeconds: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the inline time picker's visibility should be animated.
	   */
	  animateInline: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the time is required.
	   *
	   * @see {@link TextFields/TextField#required}
	   */
	  required: _propTypes2.default.bool,
	
	  /**
	   * @see {@link TextFields/TextField#block}
	   */
	  block: _TextField2.default.propTypes.block,
	
	  /**
	   * @see {@link TextFields/TextField#paddedBlock}
	   */
	  paddedBlock: _TextField2.default.propTypes.paddedBlock,
	
	  /**
	   * @see {@link TextFields/TextField#active}
	   */
	  active: _TextField2.default.propTypes.active,
	
	  /**
	   * @see {@link TextFields/TextField#error}
	   */
	  error: _TextField2.default.propTypes.error,
	
	  /**
	   * @see {@link TextFields/TextField#floating}
	   */
	  floating: _TextField2.default.propTypes.floating,
	
	  /**
	   * @see {@link TextFields/TextField#leftIconStateful}
	   */
	  leftIconStateful: _TextField2.default.propTypes.leftIconStateful,
	
	  /**
	   * @see {@link TextFields/TextField#rightIcon}
	   */
	  rightIcon: _TextField2.default.propTypes.rightIcon,
	
	  /**
	   * @see {@link TextFields/TextField#rightIconStateful}
	   */
	  rightIconStateful: _TextField2.default.propTypes.rightIconStateful,
	
	  /**
	   * @see {@link TextFields/TextField#customSize}
	   */
	  customSize: _TextField2.default.propTypes.customSize,
	
	  /**
	   * @see {@link TextFields/TextField#errorText}
	   */
	  errorText: _TextField2.default.propTypes.errorText,
	
	  /**
	   * @see {@link TextFields/TextField#helpText}
	   */
	  helpText: _TextField2.default.propTypes.helpText,
	
	  /**
	   * @see {@link TextFields/TextField#helpOnFocus}
	   */
	  helpOnFocus: _TextField2.default.propTypes.helpOnFocus,
	
	  /**
	   * @see {@link TextFields/TextField#inlineIndicator}
	   */
	  inlineIndicator: _TextField2.default.propTypes.inlineIndicator,
	
	  /**
	   * Boolean if the Portal's functionality of rendering in a separate react tree should be applied
	   * to the dialog.
	   *
	   * @see {@link Helpers/Portal}
	   */
	  portal: _propTypes2.default.bool,
	
	  /**
	   * An optional DOM Node to render the dialog into. The default is to render as the first child
	   * in the `body`.
	   */
	  renderNode: _propTypes2.default.object,
	
	  /**
	   * Boolean if the dialog should be rendered as the last child of the `renderNode` or `body` instead
	   * of the first.
	   */
	  lastChild: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Dialogs/DialogContainer#disableScrollLocking}
	   */
	  disableScrollLocking: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the TimePicker should be read only. This will prevent the user from opening the picker
	   * and only display the current date in the text field.
	   */
	  readOnly: _propTypes2.default.bool,
	
	  isOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `visible` instead'),
	  initiallyOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `defaultVisible` instead'),
	  initialTimeMode: (0, _deprecated2.default)(_propTypes2.default.oneOf(['hour', 'minute']), 'Use `defaultTimeMode` instead')
	};
	TimePickerContainer.defaultProps = {
	  animateInline: true,
	  defaultTimeMode: 'hour',
	  icon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'access_time'
	  ),
	  DateTimeFormat: _DateTimeFormat2.default, // eslint-disable-line object-shorthand
	  locales: typeof window !== 'undefined' ? window.navigator.userLanguage || window.navigator.language : 'en-US',
	  okLabel: 'Ok',
	  okPrimary: true,
	  cancelLabel: 'Cancel',
	  cancelPrimary: true,
	  closeOnEsc: true,
	  disableScrollLocking: false,
	  'aria-label': 'Select a time',
	  hoverMode: false,
	  showSeconds: false
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._setContainer = function (container) {
	    _this2._container = container;
	  };
	
	  this._closeOnEsc = function (e) {
	    if ((e.which || e.keyCode) === _keyCodes.ESC) {
	      _this2._handleCancelClick(e);
	    }
	  };
	
	  this._handleOutsideClick = function (e) {
	    if (_this2._container && !_this2._container.contains(e.target)) {
	      _this2._handleCancelClick(e);
	    }
	  };
	
	  this._toggleOpen = function (e) {
	    if (_this2.props.disabled || _this2.props.readOnly) {
	      return;
	    }
	
	    var visible = !(typeof _this2.props.isOpen !== 'undefined' ? _this2.props.isOpen : (0, _getField2.default)(_this2.props, _this2.state, 'visible'));
	
	    if (_this2.props.onVisibilityChange) {
	      _this2.props.onVisibilityChange(visible, e);
	    }
	
	    if (typeof _this2.props.isOpen === 'undefined' && typeof _this2.props.visible === 'undefined') {
	      var hoverMode = _this2.props.hoverMode;
	
	
	      if (hoverMode) {
	        _this2._setTimeMode('hour');
	      }
	
	      _this2.setState({ visible: visible });
	    }
	  };
	
	  this._setTimeMode = function (timeMode) {
	    if (_this2.state.timeMode === timeMode) {
	      return;
	    }
	
	    _this2.setState({ timeMode: timeMode });
	  };
	
	  this._setTempTime = function (time) {
	    if (_this2.state.tempTime === time) {
	      return;
	    }
	
	    _this2.setState(_extends({ tempTime: time }, _this2._getTimeParts(time, _this2.props)));
	  };
	
	  this._handleKeyDown = function (e) {
	    (0, _handleKeyboardAccessibility2.default)(e, _this2._toggleOpen, true, true);
	
	    if ((e.which || e.keyCode) === _keyCodes.TAB && _this2.state.active) {
	      _this2.setState({ active: false });
	    }
	  };
	
	  this._handleOkClick = function (e) {
	    var _props3 = _this2.props,
	        onVisibilityChange = _props3.onVisibilityChange,
	        onChange = _props3.onChange,
	        DateTimeFormat = _props3.DateTimeFormat,
	        locales = _props3.locales,
	        showSeconds = _props3.showSeconds;
	
	    var value = new Date(_this2.state.tempTime);
	    if (onChange) {
	      onChange((0, _formatTime2.default)(DateTimeFormat, locales, showSeconds, value), value, e);
	    }
	
	    if (onVisibilityChange) {
	      onVisibilityChange(false, e);
	    }
	
	    var state = _extends({ time: value }, _this2._getTimeParts(value, _this2.props));
	    if (typeof _this2.props.value === 'undefined') {
	      state.value = value;
	    }
	
	    if (typeof _this2.props.isOpen === 'undefined' && typeof _this2.props.visible === 'undefined') {
	      state.visible = false;
	    }
	
	    _this2.setState(state);
	  };
	
	  this._handleCancelClick = function (e) {
	    if (_this2.props.onVisibilityChange) {
	      _this2.props.onVisibilityChange(false, e);
	    }
	
	    var state = void 0;
	    if (typeof _this2.props.isOpen === 'undefined' && typeof _this2.props.visible === 'undefined') {
	      state = { visible: false };
	    }
	
	    var value = (0, _getField2.default)(_this2.props, _this2.state, 'value');
	    if (value) {
	      state = _extends({}, state, _this2._getTimeParts(value, _this2.props));
	      state.tempTime = _this2.state.time;
	    }
	
	    if (state) {
	      _this2.setState(state);
	    }
	  };
	};
	
	exports.default = TimePickerContainer;

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TimePeriods = __webpack_require__(882);
	
	var _TimePeriods2 = _interopRequireDefault(_TimePeriods);
	
	var _PickerControl = __webpack_require__(240);
	
	var _PickerControl2 = _interopRequireDefault(_PickerControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `TimePickerHeader` component is used for rendering the
	 * current time for the `TimePicker` as well as switching between
	 * the different views for the time picker.
	 */
	var TimePickerHeader = function (_PureComponent) {
	  _inherits(TimePickerHeader, _PureComponent);
	
	  function TimePickerHeader() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TimePickerHeader);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this._setHour = function () {
	      _this.props.setTimeMode('hour');
	    }, _this._setMinute = function () {
	      _this.props.setTimeMode('minute');
	    }, _this._setSecond = function () {
	      _this.props.setTimeMode('second');
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  TimePickerHeader.prototype.render = function render() {
	    var _props = this.props,
	        timeMode = _props.timeMode,
	        hours = _props.hours,
	        minutes = _props.minutes,
	        seconds = _props.seconds,
	        timePeriod = _props.timePeriod,
	        setTempTime = _props.setTempTime,
	        tempTime = _props.tempTime,
	        showSeconds = _props.showSeconds;
	
	    var timePeriods = void 0;
	    if (timePeriod) {
	      timePeriods = _react2.default.createElement(_TimePeriods2.default, { tempTime: tempTime, setTempTime: setTempTime, timePeriod: timePeriod });
	    }
	
	    var secondsControl = showSeconds === true ? _react2.default.createElement(
	      _PickerControl2.default,
	      { onClick: this._setSecond, active: timeMode === 'second' },
	      _react2.default.createElement(
	        'h4',
	        { className: 'md-display-3' },
	        seconds
	      )
	    ) : null;
	
	    return _react2.default.createElement(
	      'header',
	      { className: 'md-picker-header md-text-right' },
	      _react2.default.createElement(
	        _PickerControl2.default,
	        { onClick: this._setHour, active: timeMode === 'hour' },
	        _react2.default.createElement(
	          'h4',
	          { className: 'md-display-3' },
	          hours
	        )
	      ),
	      _react2.default.createElement(
	        _PickerControl2.default,
	        { onClick: this._setMinute, active: timeMode === 'minute' },
	        _react2.default.createElement(
	          'h4',
	          { className: 'md-display-3' },
	          minutes
	        )
	      ),
	      secondsControl,
	      timePeriods
	    );
	  };
	
	  return TimePickerHeader;
	}(_react.PureComponent);
	
	TimePickerHeader.propTypes = {
	  /**
	   * The current time of the time picker.
	   */
	  tempTime: _propTypes2.default.instanceOf(Date).isRequired,
	
	  /**
	   * The current time type that is being changed.
	   */
	  timeMode: _propTypes2.default.oneOf(['hour', 'minute', 'second']).isRequired,
	
	  /**
	   * A function to update the time mode.
	   */
	  setTimeMode: _propTypes2.default.func.isRequired,
	
	  /**
	   * A function to update the time for the time picker.
	   */
	  setTempTime: _propTypes2.default.func.isRequired,
	
	  /**
	   * A formatted hours string for the user's locale. This
	   * would be '3' for en-US if the time was '3:15'
	   */
	  hours: _propTypes2.default.string.isRequired,
	
	  /**
	   * A formatted minutes string for the user's locale.
	   * This would be ':15' for en-US if the time was '3:15'.
	   */
	  minutes: _propTypes2.default.string.isRequired,
	
	  /**
	   * A formatted seconds string for the user's locale.
	   * This would be ':00' for en-US if the time was '3:15:00'.
	   */
	  seconds: _propTypes2.default.string,
	
	  /**
	   * An optional time period to use for locales that use
	   * 12 hour clocks and AM/PM.
	   */
	  timePeriod: _propTypes2.default.string,
	
	  /**
	   * A boolean that if true, seconds are displayed
	   */
	  showSeconds: _propTypes2.default.bool
	};
	exports.default = TimePickerHeader;

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(11);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This is a component for rendering a year in the Date Picker's Year picker
	 * list.
	 */
	var Year = function (_PureComponent) {
	  _inherits(Year, _PureComponent);
	
	  function Year() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Year);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = { desktopActive: false }, _this._setActiveFocus = function (btn) {
	      if (btn && _this.props.active) {
	        btn.focus();
	      }
	    }, _this._setActive = function () {
	      _this.setState({ desktopActive: true });
	    }, _this._setInactive = function () {
	      _this.setState({ desktopActive: false });
	    }, _this._handleClick = function (e) {
	      _this.props.onClick(_this.props.year, e);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Year.prototype.render = function render() {
	    var desktopActive = this.state.desktopActive;
	    var _props = this.props,
	        active = _props.active,
	        className = _props.className,
	        year = _props.year;
	
	    return _react2.default.createElement(
	      'button',
	      {
	        type: 'button',
	        ref: this._setActiveFocus,
	        className: (0, _classnames2.default)('md-year', { 'md-year--active': active }, (0, _themeColors2.default)({
	          text: !active && !desktopActive,
	          primary: active || desktopActive
	        }), 'md-btn md-pointer--hover md-full-width', className),
	        onClick: this._handleClick
	      },
	      year
	    );
	  };
	
	  return Year;
	}(_react.PureComponent);
	
	Year.propTypes = {
	  className: _propTypes2.default.string,
	  active: _propTypes2.default.bool.isRequired,
	  onClick: _propTypes2.default.func.isRequired,
	  year: _propTypes2.default.number.isRequired
	};
	exports.default = Year;

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Year = __webpack_require__(886);
	
	var _Year2 = _interopRequireDefault(_Year);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `YearPicker` component is the Year view in a `DatePicker`. This
	 * will display a list of years to select from within the given range.
	 */
	var YearPicker = function (_PureComponent) {
	  _inherits(YearPicker, _PureComponent);
	
	  function YearPicker(props) {
	    _classCallCheck(this, YearPicker);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));
	
	    _this.state = _this._getYearRange(props);
	    return _this;
	  }
	
	  YearPicker.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.yearsDisplayed !== nextProps.yearsDisplayed) {
	      this.setState(this._getFullYear(nextProps));
	    }
	  };
	
	  /**
	   * Gets the current start and end years for the year picker.
	   *
	   * @param {Object} props - The current props to extract the year range from.
	   * @return {Object} an object containign the start and end years
	   */
	
	
	  YearPicker.prototype._getYearRange = function _getYearRange(_ref) {
	    var minDate = _ref.minDate,
	        maxDate = _ref.maxDate,
	        yearsDisplayed = _ref.yearsDisplayed,
	        calendarTempDate = _ref.calendarTempDate;
	
	    var year = calendarTempDate.getFullYear();
	    var range = !minDate && !maxDate ? parseInt(yearsDisplayed / 2, 10) : yearsDisplayed;
	
	    var startYear = void 0;
	    var endYear = void 0;
	    if (minDate && maxDate) {
	      startYear = minDate.getFullYear();
	      endYear = maxDate.getFullYear();
	    } else if (!minDate && !maxDate) {
	      startYear = year - range;
	      endYear = year + range;
	      if (yearsDisplayed % 2 === 0) {
	        endYear -= 1;
	      }
	    } else if (!maxDate) {
	      startYear = minDate.getFullYear();
	      endYear = startYear + yearsDisplayed - 1;
	    } else {
	      endYear = maxDate.getFullYear();
	      startYear = endYear - yearsDisplayed + 1;
	    }
	
	    return { startYear: startYear, endYear: endYear };
	  };
	
	  YearPicker.prototype._setContainer = function _setContainer(container) {
	    if (container === null) {
	      return;
	    }
	
	    var offsetHeight = container.offsetHeight,
	        offsetWidth = container.offsetWidth;
	
	    var _container$querySelec = container.querySelector('.md-year--active'),
	        top = _container$querySelec.offsetTop,
	        height = _container$querySelec.offsetHeight;
	
	    // Portrait seems to be 3/4 of the way while landscape is about 1/2
	
	
	    if (offsetHeight > offsetWidth) {
	      container.scrollTop = top - offsetHeight * 3 / 4;
	    } else {
	      container.scrollTop = top - offsetHeight / 2 + height / 2;
	    }
	  };
	
	  YearPicker.prototype.render = function render() {
	    var _state = this.state,
	        startYear = _state.startYear,
	        endYear = _state.endYear;
	
	
	    var currentYear = this.props.calendarTempDate.getFullYear();
	    var years = [];
	    for (var year = startYear; year <= endYear; year++) {
	      years.push(_react2.default.createElement(_Year2.default, {
	        key: year,
	        year: year,
	        active: year === currentYear,
	        onClick: this.props.onCalendarYearClick
	      }));
	    }
	
	    return _react2.default.createElement(
	      'section',
	      {
	        className: (0, _classnames2.default)('md-picker-content md-picker-content--year', this.props.className),
	        ref: this._setContainer
	      },
	      _react2.default.createElement(
	        'ol',
	        { className: 'md-years' },
	        years
	      )
	    );
	  };
	
	  return YearPicker;
	}(_react.PureComponent);
	
	YearPicker.propTypes = {
	  className: _propTypes2.default.string,
	  calendarTempDate: _propTypes2.default.instanceOf(Date).isRequired,
	  onCalendarYearClick: _propTypes2.default.func.isRequired,
	  yearsDisplayed: _propTypes2.default.number.isRequired,
	  minDate: _propTypes2.default.instanceOf(Date),
	  maxDate: _propTypes2.default.instanceOf(Date)
	};
	exports.default = YearPicker;

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _isRequiredForA11y = __webpack_require__(16);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _between = __webpack_require__(91);
	
	var _between2 = _interopRequireDefault(_between);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ROATE_DISTANCE = 360 * 1.75;
	var BASE_SIZE = 24; // font-icon font size
	
	/**
	 * The `CircularProgress` component is used to give visual feedback while your app
	 * is loading.
	 *
	 * There are two different types of circular progress bars: `Determinate` and `Indeterminate`.
	 *
	 * A `Determinate` circular progress bar should be used when you want to keep track of the current
	 * progress. An example would be downloading a file.
	 *
	 * An `Indeterminate` circular progress bar should be used when you can not keep track of the progress
	 * yourself. An example would be waiting for some API call to complete.
	 */
	
	var CircularProgress = function (_PureComponent) {
	  _inherits(CircularProgress, _PureComponent);
	
	  function CircularProgress() {
	    _classCallCheck(this, CircularProgress);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  /* eslint-disable max-len */
	  CircularProgress.prototype.render = function render() {
	    var _props = this.props,
	        scale = _props.scale,
	        style = _props.style,
	        className = _props.className,
	        value = _props.value,
	        determinateDashoffset = _props.determinateDashoffset,
	        centered = _props.centered,
	        props = _objectWithoutProperties(_props, ['scale', 'style', 'className', 'value', 'determinateDashoffset', 'centered']);
	
	    var isDeterminate = typeof value === 'number';
	    var circleStyle = void 0;
	    var svgStyle = style;
	    if (isDeterminate) {
	      var rotate = 'rotate3d(0, 0, 1, ' + ROATE_DISTANCE / 100 * value + 'deg)';
	      circleStyle = {
	        strokeDashoffset: determinateDashoffset - determinateDashoffset / 100 * value
	      };
	
	      svgStyle = Object.assign({}, style, {
	        WebkitTransform: (0, _classnames2.default)(style.WebkitTransform, rotate),
	        MozTransform: (0, _classnames2.default)(style.MozTransform, rotate),
	        transform: (0, _classnames2.default)(style.transform, rotate)
	      });
	    }
	
	    var accessibilityProps = {
	      role: 'progressbar',
	      'aria-valuemin': 0,
	      'aria-valuemax': 100
	    };
	
	    if (isDeterminate) {
	      accessibilityProps['aria-valuenow'] = value;
	    }
	
	    return _react2.default.createElement(
	      'svg',
	      _extends({}, props, accessibilityProps, {
	        style: svgStyle,
	        className: (0, _classnames2.default)('md-progress md-progress--circular', {
	          'md-block-centered': centered,
	          'md-progress--circular-determinate': isDeterminate,
	          'md-progress--circular-indeterminate': !isDeterminate
	        }, className),
	        width: scale * BASE_SIZE,
	        height: scale * BASE_SIZE,
	        viewBox: '0 0 66 66'
	      }),
	      _react2.default.createElement('circle', {
	        className: (0, _classnames2.default)('md-circular-progress-path', {
	          'md-circular-progress-path--animated': !isDeterminate
	        }),
	        strokeWidth: '6',
	        strokeLinecap: 'round',
	        style: circleStyle,
	        cx: '33',
	        cy: '33',
	        r: '30'
	      })
	    );
	  };
	
	  return CircularProgress;
	}(_react.PureComponent);
	
	CircularProgress.propTypes = {
	  /**
	   * The `id` prop is required for accessibility concerns.
	   * [Progress Bar Role](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_progressbar_role)
	   *
	   * > If the progressbar is describing the loading progress of a particular region of a page, the author
	   * __SHOULD__ use aria-describedby to point to the status, and set the aria-busy attribute to true on the
	   * region until it is finished loading. It is not possible for the user to alter the value of a progressbar
	   * because it is always readonly.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /* eslint-enable max-len */
	
	  /**
	   * A style object to apply to the SVG. If this is a determinate `CircularProgress`,
	   * the `transform` (and vendor prefixes) styles will be merged with the current
	   * progress rotation.
	   */
	  style: _propTypes2.default.object.isRequired,
	
	  /**
	   * An optional className to apply to the SVG.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The current value of the progress. If this value is defined, it will
	   * be converted to a determinate circular progress. The progress will not
	   * advance unless this value changes.
	   *
	   * This value should also be a number between 0 and 100.
	   */
	  value: (0, _between2.default)(_propTypes2.default.number, 0, 100),
	
	  /**
	   * The scale for the circular progress.
	   */
	  scale: _propTypes2.default.number.isRequired,
	
	  /**
	   * You probably don't want to update this. I'm not good at SVG. This should
	   * match the SCSS variable `$md-circular-progress-stroke-dashoffset`.
	   */
	  determinateDashoffset: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the progress should be centered in it's container.
	   */
	  centered: _propTypes2.default.bool
	};
	CircularProgress.defaultProps = {
	  style: {},
	  scale: 1,
	  determinateDashoffset: 187,
	  centered: true
	};
	exports.default = CircularProgress;

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _isRequiredForA11y = __webpack_require__(16);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _between = __webpack_require__(91);
	
	var _between2 = _interopRequireDefault(_between);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * There are 3 different types of linear progress bars: `Determinate`,
	 * `Indeterminate`, and `Query Indeterminate`.
	 *
	 * A `Determinate` linear progress bar should be used when you can keep track of the
	 * progress and have a percentage complete you can work with. An example would be
	 * uploading/downloading a file.
	 *
	 * An `Indeterminate` linear progress bar should be used when you can not keep track
	 * of the progress yourself. An example might be waiting for an API call to complete.
	 *
	 * A `Query Indeterminate` linear progress bar is used when you are combining
	 * `Indeterminate` and `Determinate`. A Linear Progress component can be displayed
	 * as a query indeterminate progress bar by adding the prop `query={true}` to the
	 * component. Until a progress value is given, it will display the query linear
	 * progress animation. Afterwards, it will start the determinate animation of where
	 * you manually keep updating the value of the progress.
	 */
	var LinearProgress = function (_PureComponent) {
	  _inherits(LinearProgress, _PureComponent);
	
	  function LinearProgress() {
	    _classCallCheck(this, LinearProgress);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  /* eslint-disable max-len */
	  LinearProgress.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        progressClassName = _props.progressClassName,
	        progressStyle = _props.progressStyle,
	        value = _props.value,
	        query = _props.query,
	        centered = _props.centered,
	        props = _objectWithoutProperties(_props, ['className', 'progressClassName', 'progressStyle', 'value', 'query', 'centered']);
	
	    var isDeterminate = typeof value === 'number';
	
	    var accessibilityProps = {
	      role: 'progressbar',
	      'aria-valuemin': 0,
	      'aria-valuemax': 100
	    };
	
	    var style = void 0;
	    if (isDeterminate) {
	      style = { width: value + '%' };
	      accessibilityProps['aria-valuenow'] = value;
	    }
	    if (progressStyle) {
	      style = Object.assign(style || {}, typeof progressStyle === 'function' ? progressStyle(value, this) : progressStyle);
	    }
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, props, {
	        className: (0, _classnames2.default)('md-progress md-progress--linear', { 'md-block-centered': centered }, className)
	      }),
	      _react2.default.createElement('div', _extends({}, accessibilityProps, {
	        style: style,
	        className: (0, _classnames2.default)('md-progress--linear-active', {
	          'md-progress--linear-query': query,
	          'md-progress--linear-determinate': isDeterminate,
	          'md-progress--linear-indeterminate': !isDeterminate
	        }, typeof progressClassName === 'function' ? progressClassName(value, this) : progressClassName)
	      }))
	    );
	  };
	
	  return LinearProgress;
	}(_react.PureComponent);
	
	LinearProgress.propTypes = {
	  /**
	   * The `id` prop is required for accessibility concerns.
	   * [Progress Bar Role](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_progressbar_role)
	   *
	   * > If the progressbar is describing the loading progress of a particular region of a page, the author
	   * __SHOULD__ use aria-describedby to point to the status, and set the aria-busy attribute to true on the
	   * region until it is finished loading. It is not possible for the user to alter the value of a progressbar
	   * because it is always readonly.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /* eslint-enable max-len */
	  /**
	   * An optional className to apply to the linear progress container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional className to apply to the progress bar element.
	   *
	   * If a function is specified it will be called to get necessary className.
	   * Current progress value and reference to the component will be passed into the function.
	   */
	  progressClassName: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply to the progress bar element.
	   *
	   * If a function is specified it will be called to get necessary style.
	   * Current progress value and reference to the component will be passed into the function.
	   */
	  progressStyle: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
	
	  /**
	   * The current value of the progress. If this value is defined, it will
	   * be converted to a determinate circular progress. The progress will not
	   * advance unless this value changes.
	   *
	   * This value should also be a number between 0 and 100.
	   */
	  value: (0, _between2.default)(_propTypes2.default.number, 0, 100),
	
	  /**
	   * Boolean if this should be a query indeterminate progress bar.
	   */
	  query: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the Linear Progress should be centered. This
	   * will only work if the `max-width` style is set.
	   */
	  centered: _propTypes2.default.bool
	};
	LinearProgress.defaultProps = {
	  query: false
	};
	exports.default = LinearProgress;

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CSSTransitionGroupTick = __webpack_require__(29);
	
	var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);
	
	var _themeColors = __webpack_require__(11);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _FontIcon = __webpack_require__(12);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _AccessibleFakeInkedButton = __webpack_require__(24);
	
	var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	var _IconSeparator = __webpack_require__(83);
	
	var _IconSeparator2 = _interopRequireDefault(_IconSeparator);
	
	var _Paper = __webpack_require__(37);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _TextFieldDivider = __webpack_require__(343);
	
	var _TextFieldDivider2 = _interopRequireDefault(_TextFieldDivider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectFieldInput = function (_PureComponent) {
	  _inherits(SelectFieldInput, _PureComponent);
	
	  function SelectFieldInput() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SelectFieldInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = { transition: null }, _this._timeout = null, _this._transitionNewValue = function () {
	      var _this$props = _this.props,
	          transitionTime = _this$props.transitionTime,
	          transitionName = _this$props.transitionName;
	
	      if (_this._timeout) {
	        clearTimeout(_this._timeout);
	      }
	
	      _this._timeout = setTimeout(function () {
	        _this._timeout = setTimeout(function () {
	          _this._timeout = null;
	          _this.setState({ transition: null });
	        }, transitionTime);
	
	        _this.setState({ transition: _this.state.transition + ' ' + transitionName + '-enter-active' });
	      }, _CSSTransitionGroupTick2.default);
	
	      _this.setState({ transition: transitionName + '-enter' });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  SelectFieldInput.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.value !== nextProps.value) {
	      this._transitionNewValue();
	    }
	  };
	
	  SelectFieldInput.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this._timeout) {
	      clearTimeout(this._timeout);
	    }
	  };
	
	  SelectFieldInput.prototype.render = function render() {
	    var _props = this.props,
	        id = _props.id,
	        className = _props.className,
	        name = _props.name,
	        value = _props.value,
	        label = _props.label,
	        placeholder = _props.placeholder,
	        active = _props.active,
	        activeLabel = _props.activeLabel,
	        error = _props.error,
	        disabled = _props.disabled,
	        required = _props.required,
	        toolbar = _props.toolbar,
	        below = _props.below,
	        lineDirection = _props.lineDirection,
	        dropdownIcon = _props.dropdownIcon,
	        iconChildren = _props.iconChildren,
	        iconClassName = _props.iconClassName,
	        transitionName = _props.transitionName,
	        transitionTime = _props.transitionTime,
	        props = _objectWithoutProperties(_props, ['id', 'className', 'name', 'value', 'label', 'placeholder', 'active', 'activeLabel', 'error', 'disabled', 'required', 'toolbar', 'below', 'lineDirection', 'dropdownIcon', 'iconChildren', 'iconClassName', 'transitionName', 'transitionTime']);
	
	    var transition = this.state.transition;
	
	
	    var divider = void 0;
	    if (!below && !toolbar) {
	      divider = _react2.default.createElement(_TextFieldDivider2.default, {
	        key: 'text-divider',
	        active: active,
	        error: error,
	        lineDirection: lineDirection,
	        className: 'md-divider--select-field'
	      });
	    }
	
	    var visibleLabel = activeLabel;
	    if (!activeLabel && activeLabel !== 0) {
	      visibleLabel = (!label || active) && placeholder || '';
	    }
	
	    var labelActive = !!activeLabel || activeLabel === 0;
	
	    var icon = dropdownIcon;
	    if (iconClassName || iconChildren) {
	      icon = _react2.default.createElement(
	        _FontIcon2.default,
	        { iconClassName: iconClassName },
	        iconChildren
	      );
	    }
	    icon = _react2.default.cloneElement(icon, { disabled: disabled });
	
	    return _react2.default.createElement(
	      _AccessibleFakeInkedButton2.default,
	      _extends({}, props, {
	        id: id + '-toggle',
	        role: 'listbox',
	        disabled: disabled,
	        component: _Paper2.default,
	        zDepth: below && active ? 1 : 0,
	        inkDisabled: !below,
	        className: (0, _classnames2.default)('md-select-field', (0, _themeColors2.default)({
	          disabled: disabled,
	          hint: !labelActive && placeholder,
	          text: labelActive
	        }), className)
	      }),
	      _react2.default.createElement(
	        _IconSeparator2.default,
	        {
	          label: visibleLabel,
	          labelClassName: transition,
	          className: (0, _classnames2.default)('md-text-field', {
	            'md-text-field--margin': !below && !label,
	            'md-text-field--floating-margin': label,
	            'md-text-field--toolbar': toolbar && !below,
	            'md-select-field--text-field': !below,
	            'md-select-field--btn': below
	          })
	        },
	        icon
	      ),
	      divider,
	      _react2.default.createElement('input', {
	        key: 'value',
	        type: 'hidden',
	        id: id,
	        name: name,
	        value: value,
	        required: required,
	        disabled: disabled
	      })
	    );
	  };
	
	  return SelectFieldInput;
	}(_react.PureComponent);
	
	SelectFieldInput.propTypes = {
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  name: _propTypes2.default.string,
	  value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	  disabled: _propTypes2.default.bool,
	  required: _propTypes2.default.bool,
	  label: _propTypes2.default.node,
	  placeholder: _propTypes2.default.string,
	  active: _propTypes2.default.bool,
	  activeLabel: _propTypes2.default.node,
	  below: _propTypes2.default.bool,
	  error: _propTypes2.default.bool,
	  toolbar: _propTypes2.default.bool,
	  dropdownIcon: _propTypes2.default.element,
	  iconClassName: _propTypes2.default.string,
	  iconChildren: _propTypes2.default.node,
	  transitionName: _propTypes2.default.string.isRequired,
	  transitionTime: _propTypes2.default.number.isRequired,
	  lineDirection: _TextFieldDivider2.default.propTypes.lineDirection
	};
	SelectFieldInput.defaultProps = {
	  transitionName: 'md-drop',
	  transitionTime: 300
	};
	exports.default = SelectFieldInput;

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _addSuffix = __webpack_require__(352);
	
	var _addSuffix2 = _interopRequireDefault(_addSuffix);
	
	var _isValued = __webpack_require__(176);
	
	var _isValued2 = _interopRequireDefault(_isValued);
	
	var _FloatingLabel = __webpack_require__(342);
	
	var _FloatingLabel2 = _interopRequireDefault(_FloatingLabel);
	
	var _TextFieldMessage = __webpack_require__(344);
	
	var _TextFieldMessage2 = _interopRequireDefault(_TextFieldMessage);
	
	var _SelectFieldInput = __webpack_require__(890);
	
	var _SelectFieldInput2 = _interopRequireDefault(_SelectFieldInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectFieldToggle = function (_PureComponent) {
	  _inherits(SelectFieldToggle, _PureComponent);
	
	  function SelectFieldToggle() {
	    _classCallCheck(this, SelectFieldToggle);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  SelectFieldToggle.prototype.render = function render() {
	    var _props = this.props,
	        id = _props.id,
	        style = _props.style,
	        className = _props.className,
	        inputStyle = _props.inputStyle,
	        inputClassName = _props.inputClassName,
	        required = _props.required,
	        disabled = _props.disabled,
	        active = _props.active,
	        error = _props.error,
	        errorText = _props.errorText,
	        helpText = _props.helpText,
	        helpOnFocus = _props.helpOnFocus,
	        visible = _props.visible,
	        activeLabel = _props.activeLabel,
	        propLabel = _props.label,
	        propPlaceholder = _props.placeholder,
	        props = _objectWithoutProperties(_props, ['id', 'style', 'className', 'inputStyle', 'inputClassName', 'required', 'disabled', 'active', 'error', 'errorText', 'helpText', 'helpOnFocus', 'visible', 'activeLabel', 'label', 'placeholder']);
	
	    var _props2 = this.props,
	        label = _props2.label,
	        placeholder = _props2.placeholder;
	
	    if (required) {
	      if (label) {
	        label = (0, _addSuffix2.default)(label, '*');
	      }
	
	      if (placeholder && !label) {
	        placeholder = (0, _addSuffix2.default)(placeholder, '*');
	      }
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { style: style, className: (0, _classnames2.default)('md-select-field__toggle', className) },
	      _react2.default.createElement(_FloatingLabel2.default, {
	        label: label,
	        htmlFor: id,
	        active: active || visible,
	        error: error,
	        floating: (0, _isValued2.default)(activeLabel) || active || visible,
	        disabled: disabled
	      }),
	      _react2.default.createElement(_SelectFieldInput2.default, _extends({}, props, {
	        id: id,
	        style: inputStyle,
	        className: inputClassName,
	        label: label,
	        placeholder: placeholder,
	        activeLabel: activeLabel,
	        active: active,
	        error: error,
	        disabled: disabled
	      })),
	      _react2.default.createElement(_TextFieldMessage2.default, {
	        active: active || visible,
	        error: error,
	        errorText: errorText,
	        helpText: helpText,
	        helpOnFocus: helpOnFocus,
	        leftIcon: false,
	        rightIcon: false
	      })
	    );
	  };
	
	  return SelectFieldToggle;
	}(_react.PureComponent);
	
	SelectFieldToggle.propTypes = {
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  inputStyle: _propTypes2.default.object,
	  inputClassName: _propTypes2.default.string,
	  activeLabel: _propTypes2.default.node,
	  value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  required: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  label: _propTypes2.default.string,
	  placeholder: _propTypes2.default.string,
	  active: _propTypes2.default.bool,
	  error: _propTypes2.default.bool,
	  errorText: _propTypes2.default.node,
	  helpText: _propTypes2.default.node,
	  helpOnFocus: _propTypes2.default.bool,
	  below: _propTypes2.default.bool,
	  visible: _propTypes2.default.bool
	};
	exports.default = SelectFieldToggle;

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _deprecated = __webpack_require__(5);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _isRequiredForA11y = __webpack_require__(16);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _controlled = __webpack_require__(15);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _getDeprecatedIcon = __webpack_require__(21);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _FontIcon = __webpack_require__(12);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _SelectionControl = __webpack_require__(87);
	
	var _SelectionControl2 = _interopRequireDefault(_SelectionControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `Checkbox` component is used for the selection of multiple options from a set.
	 */
	var Checkbox = function (_PureComponent) {
	  _inherits(Checkbox, _PureComponent);
	
	  function Checkbox() {
	    _classCallCheck(this, Checkbox);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  Checkbox.prototype.render = function render() {
	    var _props = this.props,
	        checkedIcon = _props.checkedIcon,
	        uncheckedIcon = _props.uncheckedIcon,
	        checkedIconChildren = _props.checkedIconChildren,
	        checkedIconClassName = _props.checkedIconClassName,
	        uncheckedIconChildren = _props.uncheckedIconChildren,
	        uncheckedIconClassName = _props.uncheckedIconClassName,
	        props = _objectWithoutProperties(_props, ['checkedIcon', 'uncheckedIcon', 'checkedIconChildren', 'checkedIconClassName', 'uncheckedIconChildren', 'uncheckedIconClassName']);
	
	    var checked = (0, _getDeprecatedIcon2.default)(checkedIconClassName, checkedIconChildren, checkedIcon);
	    var unchecked = (0, _getDeprecatedIcon2.default)(uncheckedIconClassName, uncheckedIconChildren, uncheckedIcon);
	
	    return _react2.default.createElement(_SelectionControl2.default, _extends({
	      type: 'checkbox',
	      checkedCheckboxIcon: checked,
	      uncheckedCheckboxIcon: unchecked,
	      __superSecreteProp: true
	    }, props));
	  };
	
	  return Checkbox;
	}(_react.PureComponent);
	
	Checkbox.propTypes = {
	  /**
	   * An id to use with the checkbox. This is used for accessibility and so that the label
	   * triggers the checkbox toggle.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	
	  /**
	   * An optional style to apply to the checkbox's container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the checkbox's container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * A label to display with the checkbox. This is required for accessibility and triggering
	   * the toggle.
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * Boolean if the label should appear before the checkbox icon.
	   */
	  labelBefore: _propTypes2.default.bool,
	
	  /**
	   * A name to use for the `Checkbox`. This is required for accessibility. If the checkbox is
	   * part of a group, it is recommended to make this a string ending in `[]` so that the
	   * value can be found from `document.querySelector('input[name="someName[]"]').value`.
	   */
	  name: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * Boolean if the `Checkbox` is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional function to call when the `checked` state of the `Checkbox` changes.
	   * The callback will include the new checked state and the changeEvent.
	   *
	   * ```js
	   * onChange(changeEvent.target.checked, changeEvent);
	   * ```
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * An optional value for the `Checkbox`. It is recommended to use a value though.
	   */
	  value: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * Boolean if the `Checkbox` is checked by default.
	   */
	  defaultChecked: _propTypes2.default.bool,
	
	  /**
	   * A boolean if the `Checkbox` is currently checked. This will required the `onChange` prop
	   * to be defined.
	   */
	  checked: (0, _controlled2.default)(_propTypes2.default.bool, 'onChange', 'defaultChecked'),
	
	  /**
	   * Boolean if the `Checkbox` should be displayed inline.
	   */
	  inline: _propTypes2.default.bool,
	
	  /**
	   * The icon to display when the checkbox is checked.
	   */
	  checkedIcon: _propTypes2.default.node,
	
	  /**
	   * The icon to display when the checkbox is unchecked.
	   */
	  uncheckedIcon: _propTypes2.default.node,
	
	  checkedIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `checkedIcon` instead'),
	  checkedIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `checkedIcon` instead'),
	  uncheckedIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `uncheckedIcon` instead'),
	  uncheckedIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `uncheckedIcon` instead')
	};
	Checkbox.defaultProps = {
	  checkedIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'check_box'
	  ),
	  uncheckedIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'check_box_outline_blank'
	  )
	};
	exports.default = Checkbox;

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _deprecated = __webpack_require__(5);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _isRequiredForA11y = __webpack_require__(16);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _getDeprecatedIcon = __webpack_require__(21);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _FontIcon = __webpack_require__(12);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _SelectionControl = __webpack_require__(87);
	
	var _SelectionControl2 = _interopRequireDefault(_SelectionControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `Radio` component is used for the selection of a single option from a set. Unfortunately
	 * the `Radio` component must always be controlled because of the `FontIcon` toggles and how
	 * the `radio` input type works. It is recommended to use the `SelectionControlGroup` component
	 * to manage the `radio`.
	 */
	var Radio = function (_PureComponent) {
	  _inherits(Radio, _PureComponent);
	
	  function Radio() {
	    _classCallCheck(this, Radio);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  Radio.prototype.render = function render() {
	    var _props = this.props,
	        checkedIcon = _props.checkedIcon,
	        uncheckedIcon = _props.uncheckedIcon,
	        checkedIconChildren = _props.checkedIconChildren,
	        checkedIconClassName = _props.checkedIconClassName,
	        uncheckedIconChildren = _props.uncheckedIconChildren,
	        uncheckedIconClassName = _props.uncheckedIconClassName,
	        props = _objectWithoutProperties(_props, ['checkedIcon', 'uncheckedIcon', 'checkedIconChildren', 'checkedIconClassName', 'uncheckedIconChildren', 'uncheckedIconClassName']);
	
	    var checked = (0, _getDeprecatedIcon2.default)(checkedIconClassName, checkedIconChildren, checkedIcon);
	    var unchecked = (0, _getDeprecatedIcon2.default)(uncheckedIconClassName, uncheckedIconChildren, uncheckedIcon);
	
	    return _react2.default.createElement(_SelectionControl2.default, _extends({
	      type: 'radio',
	      checkedCheckboxIcon: checked,
	      uncheckedCheckboxIcon: unchecked,
	      __superSecreteProp: true
	    }, props));
	  };
	
	  return Radio;
	}(_react.PureComponent);
	
	Radio.propTypes = {
	  /**
	   * An id to use with the radio. This is used for accessibility and so that the label
	   * triggers the radio toggle.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	
	  /**
	   * An optional style to apply to the radio's container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the radio's container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * A label to display with the radio. This is required for accessibility and triggering
	   * the toggle.
	   */
	  label: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the label should appear before the radio icon.
	   */
	  labelBefore: _propTypes2.default.bool,
	
	  /**
	   * A name to use for the `Radio`. This is required for accessibility.
	   */
	  name: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * Boolean if the `Radio` is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * A function to call when the `Radio` triggers the `change` event. The `onChange` callback
	   * will include the current value of the checked `radio` and the change event.
	   *
	   * ```js
	   * onChange(changeEvent.target.value, changeEvent);
	   * ```
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * The value for the `Radio` component.
	   */
	  value: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.string]).isRequired,
	
	  /**
	   * A boolean if the `Radio` is currently checked.
	   */
	  checked: _propTypes2.default.bool.isRequired,
	
	  /**
	   * Boolean if the `Radio` should be displayed inline.
	   */
	  inline: _propTypes2.default.bool,
	
	  /**
	   * The icon to display when the radio is checked/selected.
	   */
	  checkedIcon: _propTypes2.default.node.isRequired,
	
	  /**
	   * The icon to display when the radio is not checked/selected.
	   */
	  uncheckedIcon: _propTypes2.default.node.isRequired,
	  checkedIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `checkedIcon` instead'),
	  checkedIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `checkedIcon` instead'),
	  uncheckedIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `uncheckedIcon` instead'),
	  uncheckedIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `uncheckedIcon` instead')
	};
	Radio.defaultProps = {
	  checkedIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'radio_button_checked'
	  ),
	  uncheckedIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'radio_button_unchecked'
	  )
	};
	exports.default = Radio;

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keyCodes = __webpack_require__(14);
	
	var _getField = __webpack_require__(8);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _minMaxLoop = __webpack_require__(926);
	
	var _minMaxLoop2 = _interopRequireDefault(_minMaxLoop);
	
	var _controlled = __webpack_require__(15);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _SelectionControl = __webpack_require__(87);
	
	var _SelectionControl2 = _interopRequireDefault(_SelectionControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A custom PropTypes validator to make sure that each `control` in the `controls` prop
	 * contains the given `propName`, or the `SelectionControlGroup` has defined that prop.
	 */
	function requiredByAllControls(validator) {
	  return function validate(props, propName, component) {
	    for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      others[_key - 3] = arguments[_key];
	    }
	
	    var err = validator.apply(undefined, [props, propName, component].concat(others));
	
	    if (!err && typeof props[propName] === 'undefined') {
	      var invalids = props.controls.filter(function (c) {
	        return !c[propName];
	      }).map(function (_, i) {
	        return i;
	      });
	      if (invalids.length) {
	        var invalidPrefix = invalids.length === props.controls.length ? 'All `controls`' : 'The `controls` at indexes `' + invalids.join('`, `') + '`';
	        var invalidMsg = invalidPrefix + ' are missing the `' + propName + '` prop.';
	
	        err = new Error('The `' + propName + '` prop is required to make `' + component + '` accessible for users of ' + ('assistive technologies such as screen readers. Either add the `' + propName + '` to the `' + component + '` ') + ('or add the `' + propName + '` to each `control` in the `controls` prop. ' + invalidMsg));
	      }
	    }
	
	    return err;
	  };
	}
	
	/**
	 * The `SelectionControlGroup` component is used to simplify the generation of a list
	 * of `SelectionControl`. Any common props are extracted to this component and passed
	 * to the `SelectionControl`.
	 */
	
	var SelectionControlGroup = function (_PureComponent) {
	  _inherits(SelectionControlGroup, _PureComponent);
	
	  function SelectionControlGroup(props) {
	    _classCallCheck(this, SelectionControlGroup);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));
	
	    _this._setGroup = function (group) {
	      _this._group = group;
	    };
	
	    _this._handleChange = function (e) {
	      var value = e.target.value;
	      if (_this.props.type === 'checkbox') {
	        var checked = e.target.checked;
	
	        var currentValue = (0, _getField2.default)(_this.props, _this.state, 'value');
	        var existsIndex = currentValue.indexOf(value);
	        if (existsIndex === -1 && checked) {
	          value = '' + (currentValue ? currentValue + ',' : '') + value;
	        } else if (existsIndex > -1 && !checked) {
	          value = currentValue.replace(new RegExp(value + ',?'), '');
	        } else {
	          value = currentValue;
	        }
	      }
	
	      if (_this.props.onChange) {
	        _this.props.onChange(value, e);
	      }
	
	      if (typeof _this.props.value === 'undefined') {
	        _this.setState({ value: value });
	      }
	    };
	
	    _this._handleKeyDown = function (e) {
	      if (_this.props.onKeyDown) {
	        _this.props.onKeyDown(e);
	      }
	
	      var key = e.which || e.keyCode;
	      var dec = key === _keyCodes.UP || key === _keyCodes.LEFT;
	      var inc = key === _keyCodes.DOWN || key === _keyCodes.RIGHT;
	      if (!_this._group || !dec && !inc) {
	        return;
	      }
	
	      e.preventDefault();
	      var radios = _this._group.querySelectorAll('*[role="radio"]');
	      _this._activeIndex = (0, _minMaxLoop2.default)(_this._activeIndex, 0, radios.length - 1, inc);
	      radios[_this._activeIndex].focus();
	      var value = _this.props.controls[_this._activeIndex].value;
	
	      if ((0, _getField2.default)(_this.props, _this.state, 'value') !== value) {
	        if (_this.props.onChange) {
	          _this.props.onChange(value, e);
	        }
	
	        if (typeof _this.props.value === 'undefined') {
	          _this.setState({ value: value });
	        }
	      }
	    };
	
	    var radio = props.type === 'radio';
	    _this.state = {};
	
	    if (typeof props.value === 'undefined') {
	      var value = props.defaultValue;
	
	      if (typeof value === 'undefined') {
	        value = radio ? props.controls[0].value : '';
	      }
	
	      _this.state.value = value;
	    }
	
	    var groupValue = (0, _getField2.default)(props, _this.state, 'value');
	    _this._activeIndex = -1;
	    props.controls.some(function (_ref, i) {
	      var value = _ref.value;
	
	      if (value === groupValue) {
	        _this._activeIndex = i;
	      }
	
	      return _this._activeIndex > -1;
	    });
	    return _this;
	  }
	
	  SelectionControlGroup.prototype._isChecked = function _isChecked(value, controlValue, type) {
	    return type === 'radio' ? value === controlValue : value.split(',').indexOf(controlValue) !== -1;
	  };
	
	  SelectionControlGroup.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        id = _props.id,
	        name = _props.name,
	        type = _props.type,
	        label = _props.label,
	        labelClassName = _props.labelClassName,
	        className = _props.className,
	        controlStyle = _props.controlStyle,
	        controlClassName = _props.controlClassName,
	        Component = _props.component,
	        LabelComponent = _props.labelComponent,
	        inline = _props.inline,
	        disabled = _props.disabled,
	        checkedRadioIcon = _props.checkedRadioIcon,
	        uncheckedRadioIcon = _props.uncheckedRadioIcon,
	        checkedCheckboxIcon = _props.checkedCheckboxIcon,
	        uncheckedCheckboxIcon = _props.uncheckedCheckboxIcon,
	        ControlComponent = _props.controlComponent,
	        propValue = _props.value,
	        propControls = _props.controls,
	        defaultValue = _props.defaultValue,
	        props = _objectWithoutProperties(_props, ['id', 'name', 'type', 'label', 'labelClassName', 'className', 'controlStyle', 'controlClassName', 'component', 'labelComponent', 'inline', 'disabled', 'checkedRadioIcon', 'uncheckedRadioIcon', 'checkedCheckboxIcon', 'uncheckedCheckboxIcon', 'controlComponent', 'value', 'controls', 'defaultValue']);
	
	    var value = (0, _getField2.default)(this.props, this.state, 'value');
	    var radio = type === 'radio';
	
	    var controls = this.props.controls.map(function (control, i) {
	      var style = control.style;
	      if (controlStyle) {
	        style = style ? _extends({}, controlStyle, style) : controlStyle;
	      }
	
	      var checked = _this2._isChecked(value, control.value, type);
	      var controlProps = _extends({
	        id: '' + id + i,
	        key: 'control' + i,
	        name: '' + name + (type === 'checkbox' ? '[]' : ''),
	        type: type,
	        inline: inline,
	        disabled: disabled,
	        checked: checked,
	        tabIndex: !radio || checked || i === 0 && _this2._activeIndex === -1 ? undefined : -1,
	        checkedRadioIcon: checkedRadioIcon,
	        uncheckedRadioIcon: uncheckedRadioIcon,
	        checkedCheckboxIcon: checkedCheckboxIcon,
	        uncheckedCheckboxIcon: uncheckedCheckboxIcon,
	        'aria-describedby': id + '-group-label'
	      }, control, {
	        style: style,
	        className: (0, _classnames2.default)(controlClassName, control.className)
	      });
	
	      return _react2.default.createElement(ControlComponent, controlProps);
	    });
	
	    var ariaLabel = void 0;
	    if (label) {
	      ariaLabel = _react2.default.createElement(
	        LabelComponent,
	        { className: labelClassName, id: id + '-group-label' },
	        label
	      );
	    }
	
	    return _react2.default.createElement(
	      Component,
	      _extends({}, props, {
	        ref: this._setGroup,
	        className: (0, _classnames2.default)('md-selection-control-group', className),
	        onChange: this._handleChange,
	        onKeyDown: radio ? this._handleKeyDown : null
	      }),
	      ariaLabel,
	      controls
	    );
	  };
	
	  return SelectionControlGroup;
	}(_react.PureComponent);
	
	SelectionControlGroup.propTypes = {
	  /**
	   * An optional style to apply to the container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to every `SelectionControl`. This will be merged with any `style`
	   * that a `control` might have.
	   */
	  controlStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to every `SelectionControl`. This will be merged with any
	   * `className` that a `control` might have.
	   */
	  controlClassName: _propTypes2.default.string,
	
	  /**
	   * An optional base id to apply to each `SelectionControl`. When this is included, the id for
	   * each control will start with this and end with their current index. If this is omitted,
	   * each `control` in the `controls` prop *must* have an `id` prop. This is required for
	   * accessibility.
	   */
	  id: requiredByAllControls(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * The type to apply to each `SelectionControl` in the group. Only `checkbox` and `radio` is
	   * valid for a grouping.
	   */
	  type: _propTypes2.default.oneOf(['checkbox', 'radio']).isRequired,
	
	  /**
	   * The component to render the `SelectionControlGroup` in. This can only be a valid dom element
	   * since it relies on the ref callback to add keyboard accessibility.
	   */
	  component: _propTypes2.default.string.isRequired,
	
	  /**
	   * An optional label to display above the group of `SelectionControl`s.
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * An optional className to apply to the node surrounding the `label` prop.
	   */
	  labelClassName: _propTypes2.default.string,
	
	  /**
	   * The component to render each item in the `controls` list as. By default, this will be the
	   * `SelectionControl` component but you can change this to any React component that accepts
	   * the selection control props. It is currently provided:
	   *
	   * ```js
	   * const controlProps = {
	   *   id: `${id}${i}`,
	   *   key: `control${i}`,
	   *   name: `${name}${type === 'checkbox' ? '[]' : ''}`,
	   *   type,
	   *   inline,
	   *   disabled,
	   *   checked,
	   *   tabIndex: !radio || checked || (i === 0 && this._activeIndex === -1) ? undefined : -1,
	   *   checkedRadioIcon,
	   *   uncheckedRadioIcon,
	   *   checkedCheckboxIcon,
	   *   uncheckedCheckboxIcon,
	   *   ...control,
	   *   style,
	   *   className: cn(controlClassName, control.className),
	   * };
	   * ```
	   */
	  controlComponent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	  /**
	   * The component to render the optional `label` in.
	   */
	  labelComponent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	  /**
	   * An optional function to call when any `SelectionControl`'s `checked` state is changed
	   * in the group. If the `type` of the group is `radio`, the `value` of the `checked` radio
	   * will be given in the callback. If the `type` of the group is `checkbox`, a comma-delimited
	   * string of all `checked` checkboxes values will be given.
	   *
	   * ```js
	   * // checkbox
	   * onChange('Alpha,Omega', changeEvent);
	   *
	   * // radio
	   * onChange('Omega', changeEvent);
	   * ```
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * A name to use for each `SelectionControl` in the group. If the `type` of the group is
	   * `checkbox`, the name will be updated to be an array name so that using
	   * `document.querySelector('input[name="yourName[]"].value` will give the comma-delimited
	   * string of checked checkboxes.
	   *
	   * It is either required to have this prop set or every `control` in the `controls` prop to
	   * have the `name` prop.
	   */
	  name: requiredByAllControls(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * The default value for the `SelectionControlGroup`. This can either be a single value
	   * or a comma-delimited string of checkbox values. When the `type` of the group is `radio`
	   * and the group is uncontrolled, it is recommended to set this prop. Otherwise the first
	   * value of the `controls` prop will be used as the default value.
	   */
	  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional value to use for the `SelectionControlGroup`. This will make the component
	   * controlled and require the `onChange` prop to be defined. Like the `defaultValue`, this
	   * can either be a single value or a comma-delimited list of checkbox values.
	   */
	  value: (0, _controlled2.default)(_propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.string]), 'onChange'),
	
	  /**
	   * A list of objects to create the `SelectionControl` components. The shape of the object
	   * is the `propTypes` of the `SelectionControl` component, except that `value` prop is
	   * now required.
	   *
	   * The `SelectionControl` will inherit any inheritable props from the `SelectionControlGroup`.
	   */
	  controls: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    key: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    label: _propTypes2.default.node.isRequired,
	    value: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.string]).isRequired
	  })).isRequired,
	
	  /**
	   * Boolean if the `SelectionControl` should be displayed inline.
	   */
	  inline: _propTypes2.default.bool,
	
	  /**
	   * Boolean if all the selection controls in the group are disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional function to call when the keydown event is triggered.
	   */
	  onKeyDown: _propTypes2.default.func,
	
	  /**
	   * An icon to use for a checked `radio` control. This will be applied to each
	   * control that has a `type="radio"` in the `controls` list. This is just a simpler
	   * way of applying the custom icons for each radio in the list.
	   *
	   * This will default to the `checkedRadioIcon` on the `SelectionControl`.
	   *
	   * @see {@link #controls}
	   * @see {@link #uncheckedRadioIcon}
	   * @see {@link SelectionControls/SelectionControls#checkedRadioIcon}
	   * @see {@link SelectionControls/SelectionControls#uncheckedRadioIcon}
	   */
	  checkedRadioIcon: _propTypes2.default.node,
	
	  /**
	   * An icon to use for an unchecked `radio` control. This will be applied to each
	   * control that has a `type="radio"` in the `controls` list. This is just a simpler
	   * way of applying the custom icons for each radio in the list.
	   *
	   * This will default to the `uncheckedRadioIcon` on the `SelectionControl`.
	   *
	   * @see {@link #controls}
	   * @see {@link #checkedRadioIcon}
	   * @see {@link SelectionControls/SelectionControls#checkedRadioIcon}
	   * @see {@link SelectionControls/SelectionControls#uncheckedRadioIcon}
	   */
	  uncheckedRadioIcon: _propTypes2.default.node,
	
	  /**
	   * An icon to use for a checked `checkbox` control. This will be applied to each
	   * control that has a `type="checkbox"` in the `controls` list. This is just a simpler
	   * way of applying the custom icons for each checkbox in the list.
	   *
	   * This will default to the `checkedCheckboxIcon` on the `SelectionControl`.
	   *
	   * @see {@link #controls}
	   * @see {@link #uncheckedCheckboxIcon}
	   * @see {@link SelectionControls/SelectionControls#checkedCheckboxIcon}
	   * @see {@link SelectionControls/SelectionControls#uncheckedCheckboxIcon}
	   */
	  checkedCheckboxIcon: _propTypes2.default.node,
	
	  /**
	   * An icon to use for an unchecked `checkbox` control. This will be applied to each
	   * control that has a `type="checkbox"` in the `controls` list. This is just a simpler
	   * way of applying the custom icons for each checkbox in the list.
	   *
	   * This will default to the `uncheckedCheckboxIcon` on the `SelectionControl`.
	   *
	   * @see {@link #controls}
	   * @see {@link #checkedCheckboxIcon}
	   * @see {@link SelectionControls/SelectionControls#checkedCheckboxIcon}
	   * @see {@link SelectionControls/SelectionControls#uncheckedCheckboxIcon}
	   */
	  uncheckedCheckboxIcon: _propTypes2.default.node
	};
	SelectionControlGroup.defaultProps = {
	  component: 'fieldset',
	  labelComponent: 'legend',
	  labelClassName: 'md-subheading-1',
	  controlComponent: _SelectionControl2.default
	};
	exports.default = SelectionControlGroup;

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _deprecated = __webpack_require__(5);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _isRequiredForA11y = __webpack_require__(16);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _controlled = __webpack_require__(15);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _SelectionControl = __webpack_require__(87);
	
	var _SelectionControl2 = _interopRequireDefault(_SelectionControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Switch = function (_PureComponent) {
	  _inherits(Switch, _PureComponent);
	
	  function Switch() {
	    _classCallCheck(this, Switch);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  Switch.prototype.render = function render() {
	    var _props = this.props,
	        toggled = _props.toggled,
	        defaultToggled = _props.defaultToggled,
	        props = _objectWithoutProperties(_props, ['toggled', 'defaultToggled']);
	
	    if (typeof toggled !== 'undefined' && typeof props.checked === 'undefined') {
	      props.checked = toggled;
	    }
	
	    if (typeof defaultToggled !== 'undefined' && typeof props.defaultChecked === 'undefined') {
	      props.defaultChecked = defaultToggled;
	    }
	
	    return _react2.default.createElement(_SelectionControl2.default, _extends({ type: 'switch' }, props, { __superSecreteProp: true }));
	  };
	
	  return Switch;
	}(_react.PureComponent);
	
	Switch.propTypes = {
	  /**
	   * An id to use with the switch. This is used for accessibility and so that the label
	   * triggers the switch toggle.
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	
	  /**
	   * An optional style to apply to the switch's container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the switch's container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * A label to display with the switch. This is required for accessibility and triggering
	   * the toggle.
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * Boolean if the label should appear before the switch.
	   */
	  labelBefore: _propTypes2.default.bool,
	
	  /**
	   * A name to use for the `Switch`. This is required for accessibility since behind the scenes
	   * the `Switch` is renders as an `<input type="checkbox" />`.
	   */
	  name: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * Boolean if the `Switch` is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional function to call when the `checked` state of the `Switch` changes.
	   * The callback will include the new checked state and the changeEvent.
	   *
	   * ```js
	   * onChange(changeEvent.target.checked, changeEvent);
	   * ```
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * An optional value for the `Switch`. It is recommended to use a value though.
	   */
	  value: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * Boolean if the `Switch` is checked by default.
	   */
	  defaultChecked: _propTypes2.default.bool,
	
	  /**
	   * A boolean if the `Switch` is currently checked. This will required the `onChange` prop
	   * to be defined.
	   */
	  checked: (0, _controlled2.default)(_propTypes2.default.bool, 'onChange', 'defaultChecked'),
	
	  defaultToggled: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use the `defaultChecked` prop instead'),
	  toggled: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use the `checked` prop instead')
	};
	exports.default = Switch;

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _AccessibleFakeInkedButton = __webpack_require__(24);
	
	var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DISABLED_INTERACTIONS = ['mouse'];
	
	/**
	 * This is the `Thumb` for the switch. The `ink` in the Thumb is only active on touch and keyboard
	 * interactions, so the `AccessibleFakeInkButton` does not work for this case.
	 *
	 * This component really just is used for custom inkage.
	 */
	
	var SwitchThumb = function (_PureComponent) {
	  _inherits(SwitchThumb, _PureComponent);
	
	  function SwitchThumb() {
	    _classCallCheck(this, SwitchThumb);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  SwitchThumb.prototype.render = function render() {
	    var _props = this.props,
	        disabled = _props.disabled,
	        checked = _props.checked,
	        className = _props.className,
	        disabledInteractions = _props.disabledInteractions,
	        props = _objectWithoutProperties(_props, ['disabled', 'checked', 'className', 'disabledInteractions']);
	
	    return _react2.default.createElement(_AccessibleFakeInkedButton2.default, _extends({}, props, {
	      disabled: disabled,
	      disabledInteractions: disabledInteractions || DISABLED_INTERACTIONS,
	      inkContainerClassName: 'md-ink-container--2x',
	      className: (0, _classnames2.default)('md-switch-thumb', {
	        'md-switch-thumb--disabled': disabled,
	        'md-switch-thumb--on': checked,
	        'md-switch-thumb--off': !checked
	      }, className)
	    }));
	  };
	
	  return SwitchThumb;
	}(_react.PureComponent);
	
	SwitchThumb.propTypes = {
	  className: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  checked: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  disabledInteractions: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['keyboard', 'touch', 'mouse']))
	};
	exports.default = SwitchThumb;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SwitchThumb = __webpack_require__(896);
	
	var _SwitchThumb2 = _interopRequireDefault(_SwitchThumb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SwitchTrack = function (_PureComponent) {
	  _inherits(SwitchTrack, _PureComponent);
	
	  function SwitchTrack() {
	    _classCallCheck(this, SwitchTrack);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  SwitchTrack.prototype.render = function render() {
	    var _props = this.props,
	        disabled = _props.disabled,
	        checked = _props.checked,
	        className = _props.className,
	        inkDisabled = _props.inkDisabled,
	        disabledInteractions = _props.disabledInteractions,
	        props = _objectWithoutProperties(_props, ['disabled', 'checked', 'className', 'inkDisabled', 'disabledInteractions']);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, props, {
	        className: (0, _classnames2.default)('md-switch-track', {
	          'md-pointer--hover': !disabled,
	          'md-switch-track--disabled': disabled,
	          'md-switch-track--on': checked,
	          'md-switch-track--off': !checked
	        }, className)
	      }),
	      _react2.default.createElement(_SwitchThumb2.default, {
	        disabled: disabled,
	        checked: checked,
	        onClick: props.onClick,
	        inkDisabled: inkDisabled,
	        disabledInteractions: disabledInteractions
	      })
	    );
	  };
	
	  return SwitchTrack;
	}(_react.PureComponent);
	
	SwitchTrack.propTypes = {
	  className: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  checked: _propTypes2.default.bool,
	  inkDisabled: _propTypes2.default.bool,
	  disabledInteractions: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['keyboard', 'touch', 'mouse']))
	};
	exports.default = SwitchTrack;

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DiscreteValue = function (_PureComponent) {
	  _inherits(DiscreteValue, _PureComponent);
	
	  function DiscreteValue() {
	    _classCallCheck(this, DiscreteValue);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  DiscreteValue.prototype.render = function render() {
	    var _props = this.props,
	        style = _props.style,
	        className = _props.className,
	        discrete = _props.discrete,
	        dragging = _props.dragging,
	        thumbLeft = _props.thumbLeft,
	        active = _props.active,
	        value = _props.value,
	        valuePrecision = _props.valuePrecision,
	        props = _objectWithoutProperties(_props, ['style', 'className', 'discrete', 'dragging', 'thumbLeft', 'active', 'value', 'valuePrecision']);
	
	    if (!discrete || !active) {
	      return null;
	    }
	
	    var valueStr = value.toFixed(valuePrecision);
	    if (valuePrecision > 0) {
	      var _valueStr$split = valueStr.split('.'),
	          w = _valueStr$split[0],
	          d = _valueStr$split[1];
	
	      if (parseInt(d, 10) === 0) {
	        valueStr = w;
	      }
	    }
	    return _react2.default.createElement(
	      'span',
	      _extends({}, props, {
	        style: Object.assign({}, style, { left: thumbLeft }),
	        className: (0, _classnames2.default)('md-slider-discrete-value', className, {
	          'md-slider-discrete-value--dragging': dragging
	        })
	      }),
	      valueStr
	    );
	  };
	
	  return DiscreteValue;
	}(_react.PureComponent);
	
	DiscreteValue.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  discrete: _propTypes2.default.bool,
	  dragging: _propTypes2.default.bool,
	  active: _propTypes2.default.bool,
	  value: _propTypes2.default.number.isRequired,
	  thumbLeft: _propTypes2.default.string.isRequired,
	  valuePrecision: _propTypes2.default.number.isRequired
	};
	exports.default = DiscreteValue;

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(7);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(5);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _isRequiredForA11y = __webpack_require__(16);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _keyCodes = __webpack_require__(14);
	
	var _getField = __webpack_require__(8);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _isValidClick = __webpack_require__(246);
	
	var _isValidClick2 = _interopRequireDefault(_isValidClick);
	
	var _touches = __webpack_require__(126);
	
	var _calculateValueDistance = __webpack_require__(924);
	
	var _calculateValueDistance2 = _interopRequireDefault(_calculateValueDistance);
	
	var _isWithinStep = __webpack_require__(925);
	
	var _isWithinStep2 = _interopRequireDefault(_isWithinStep);
	
	var _controlled = __webpack_require__(15);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _SliderLabel = __webpack_require__(900);
	
	var _SliderLabel2 = _interopRequireDefault(_SliderLabel);
	
	var _Track = __webpack_require__(903);
	
	var _Track2 = _interopRequireDefault(_Track);
	
	var _TextField = __webpack_require__(89);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `Slider` component is used to let users select a value from a continuous
	 * or discrete range of values by moving the slider thumb.
	 *
	 * When the user has finished dragging the Slider or increments the value by using
	 * the edit field/keyboard arrows, the value will be rounded to the nearest `step`.
	 */
	var Slider = function (_PureComponent) {
	  _inherits(Slider, _PureComponent);
	
	  function Slider(props) {
	    _classCallCheck(this, Slider);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var min = props.min,
	        max = props.max,
	        step = props.step;
	
	    var scale = Math.abs(max - min) / step;
	
	    var value = typeof props.value !== 'undefined' ? props.value : props.defaultValue;
	
	    if (typeof value === 'undefined') {
	      value = min;
	    }
	
	    var distance = _this._calcDistance(value, min, max);
	    var thumbLeft = _this._calcLeft(distance);
	    var trackFillWidth = distance + '%';
	
	    if (typeof props.value !== 'undefined') {
	      value = undefined;
	    }
	
	    var trackWidth = void 0;
	    if (props.label && !props.editable && !props.leftIcon && !props.rightIcon) {
	      trackWidth = '100%';
	    }
	
	    _this.state = {
	      value: value,
	      scale: scale,
	      distance: distance,
	      thumbLeft: thumbLeft,
	      trackWidth: trackWidth,
	      trackFillWidth: trackFillWidth,
	      active: false,
	      dragging: false,
	      maskInked: false
	    };
	    _this._dragAdded = false;
	    return _this;
	  }
	
	  Slider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _props = this.props,
	        leftIcon = _props.leftIcon,
	        rightIcon = _props.rightIcon,
	        label = _props.label,
	        min = _props.min,
	        max = _props.max,
	        step = _props.step,
	        value = _props.value;
	
	    if (value !== nextProps.value) {
	      var distance = this._calcDistance(nextProps.value, nextProps.min, nextProps.max);
	      this.setState({ distance: distance, trackFillWidth: distance + '%', thumbLeft: this._calcLeft(distance) });
	    }
	
	    if (leftIcon !== nextProps.leftIcon || rightIcon !== nextProps.rightIcon || label !== nextProps.label) {
	      this._calcTrackWidth(nextProps);
	    }
	
	    if (min !== nextProps.min || max !== nextProps.max || step !== nextProps.step) {
	      this.setState({ scale: Math.abs(nextProps.max - nextProps.min) / nextProps.step });
	    }
	  };
	
	  Slider.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    var _state = this.state,
	        active = _state.active,
	        manualIncrement = _state.manualIncrement;
	
	    var fn = window[(active ? 'add' : 'remove') + 'EventListener'];
	    if (active !== prevState.active) {
	      fn('click', this._blurOnOutsideClick);
	
	      if (active) {
	        this._focusThumb();
	      }
	    }
	
	    var addDrag = active && !manualIncrement;
	    fn = window[(addDrag ? 'add' : 'remove') + 'EventListener'];
	    if (this._dragAdded !== addDrag) {
	      fn('mousemove', this._handleDragMove);
	      fn('mouseup', this._handleDragEnd);
	      (0, _touches.setTouchEvent)(addDrag, window, 'move', this._handleDragMove);
	      (0, _touches.setTouchEvent)(addDrag, window, 'end', this._handleDragEnd);
	
	      this._dragAdded = addDrag;
	    }
	  };
	
	  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
	    var rm = window.removeEventListener;
	    rm('click', this._blurOnOutsideClick);
	    rm('mousemove', this._handleMouseMove);
	    rm('mouseup', this._handleMouseUp);
	    (0, _touches.removeTouchEvent)(window, 'move', this._handleDragMove);
	    (0, _touches.removeTouchEvent)(window, 'end', this._handleDragEnd);
	
	    if (this._inkTimeout) {
	      clearTimeout(this._inkTimeout);
	    }
	
	    if (this._focusTimeout) {
	      clearTimeout(this._focusTimeout);
	    }
	  };
	
	  /**
	   * Gets the `left` position for the thumb based on the value given.
	   *
	   * @param {number} value - The current value.
	   * @return {string} the `calc` string.
	   */
	
	
	  Slider.prototype._calcLeft = function _calcLeft(value) {
	    return 'calc(' + value + '% - 6px)';
	  };
	
	  Slider.prototype._calcDistance = function _calcDistance(value, min, max) {
	    return Math.max(0, Math.min(100, (value - min) / (max - min) * 100));
	  };
	
	  /**
	   * Checks if a classList does not contain all the *bad* class names.
	   *
	   * @param {function} classList - The classList to check.
	   * @return {Boolean} true if the classList does not contain any of the *bad* class names.
	   */
	
	
	  Slider.prototype._isValidClassList = function _isValidClassList(classList) {
	    var invalid = false;
	    ['md-slider-label', 'md-slider-ind', 'md-icon'].some(function (cl) {
	      invalid = classList.contains(cl);
	      return invalid;
	    });
	
	    return !invalid;
	  };
	
	  Slider.prototype._isInTextField = function _isInTextField(e) {
	    var className = e.target.className;
	
	    // SVG's className is an object instead of a string
	
	    return typeof className.match === 'function' && className.match(/text-field/);
	  };
	
	  /**
	   * Checks if the target is within the text field container.
	   *
	   * @param {Object} target - The event target.
	   * @return {Boolean} true if the target is in the text field.
	   */
	
	
	  /**
	   * Updates the slider's thumb position and the slider's track fill width based
	   * on the thumb's current x position on the screen.
	   *
	   * The slider distance will be *normalized* when:
	   *  - The user does a quick jump
	   *  - The user stops dragging with the mouse
	   *  - The user drops dragging with touch
	   *
	   * If the position is not *normalized*, the `onDragChange` prop will be called
	   * with the new distance percentage, the value, and the move event.
	   *
	   * The `onChange` function will always be called.
	   *
	   * @param {Object} e - The current event to extract an x location from
	   * @param {bool} normalize - Boolean if the distance should be normalized
	   *    to the current scale of the slider.
	   */
	
	
	  /**
	   * This will either allow a user to start dragging the slider or quickly
	   * jump to a new value on the slider if the slider is not disabled.
	   *
	   * This will handle the `touchstart` and `mousedown` events.
	   *
	   * @param {Object} e - The touchstart or mousedown event.
	   */
	
	
	  /**
	   * This will set the active state of the slider to false if the user
	   * clicks outside of the slider's container.
	   *
	   * @param {Object} e - The window's click event.
	   */
	
	
	  /**
	   * Updates the slider with the `step` prop and calls the `onChange`
	   * function with the new value.
	   *
	   * @param {number} incrementedValue - The newly incremented value of the slider.
	   * @param {Object} e - Either the text field's change event, mouse down event, or
	   *    touch start event.
	   * @param {bool} disableTransition - Boolean if the jump's transition should be disabled.
	   */
	
	
	  /**
	   * This will increment the Slider's value by the `step` prop. If the left or
	   * right key arrow is pressed.
	   *
	   * @param {Object} e - the keydown event.
	   */
	
	
	  /**
	   * This function will animate the discrete Slider's ink if it gains focus
	   * by a tab event.
	   *
	   * @param {Object} e - the key up event.
	   */
	
	
	  /**
	   * For some reason the width of the track gets set to 0 if the `Slider` has a label and
	   * does not include the `leftIcon`, `rightIcon`, and is not `editable` OR it is
	   * `editable` and does not include the `leftIcon`. All other cases the width works
	   * correctly.
	   *
	   * This function just checks these things, and sets the width accordingly.
	   */
	
	
	  /**
	   * The ink for a Discrete slider is only visible for a short time on initial
	   * focus. This function will handle the in/out transitions.
	   */
	
	
	  /**
	   * This is a helper function for focusing the Slider's thumb component. There
	   * is a short delay because the body sometimes gets focused immediately after
	   * if there is no timeout..
	   */
	
	
	  Slider.prototype.render = function render() {
	    var _state2 = this.state,
	        dragging = _state2.dragging,
	        active = _state2.active,
	        thumbLeft = _state2.thumbLeft,
	        trackFillWidth = _state2.trackFillWidth,
	        maskInked = _state2.maskInked,
	        trackWidth = _state2.trackWidth,
	        scale = _state2.scale,
	        distance = _state2.distance;
	
	    var _props2 = this.props,
	        id = _props2.id,
	        min = _props2.min,
	        max = _props2.max,
	        disabled = _props2.disabled,
	        className = _props2.className,
	        trackStyle = _props2.trackStyle,
	        trackClassName = _props2.trackClassName,
	        thumbStyle = _props2.thumbStyle,
	        thumbClassName = _props2.thumbClassName,
	        discreteValueStyle = _props2.discreteValueStyle,
	        discreteValueClassName = _props2.discreteValueClassName,
	        label = _props2.label,
	        editable = _props2.editable,
	        step = _props2.step,
	        inputWidth = _props2.inputWidth,
	        leftIcon = _props2.leftIcon,
	        rightIcon = _props2.rightIcon,
	        discrete = _props2.discrete,
	        discreteTicks = _props2.discreteTicks,
	        tickWidth = _props2.tickWidth,
	        valuePrecision = _props2.valuePrecision,
	        propValue = _props2.value,
	        onChange = _props2.onChange,
	        onDragChange = _props2.onDragChange,
	        discreteInkTransitionTime = _props2.discreteInkTransitionTime,
	        stepPrecision = _props2.stepPrecision,
	        props = _objectWithoutProperties(_props2, ['id', 'min', 'max', 'disabled', 'className', 'trackStyle', 'trackClassName', 'thumbStyle', 'thumbClassName', 'discreteValueStyle', 'discreteValueClassName', 'label', 'editable', 'step', 'inputWidth', 'leftIcon', 'rightIcon', 'discrete', 'discreteTicks', 'tickWidth', 'valuePrecision', 'value', 'onChange', 'onDragChange', 'discreteInkTransitionTime', 'stepPrecision']);
	
	    var value = (0, _getField2.default)(this.props, this.state);
	    var rightChildren = rightIcon;
	    if (editable) {
	      rightChildren = _react2.default.createElement(_TextField2.default, {
	        id: id + '-editor',
	        ref: this._setField,
	        type: 'number',
	        value: value,
	        inputClassName: 'md-slider-editor',
	        style: { width: inputWidth },
	        onChange: this._handleTextFieldChange,
	        step: step
	      });
	    }
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, props, {
	        ref: this._setNode,
	        className: (0, _classnames2.default)('md-slider-container', className, {
	          'md-pointer--hover': !disabled
	        }),
	        onMouseDown: this._handleDragStart,
	        onTouchStart: this._handleDragStart
	      }),
	      _react2.default.createElement(
	        _SliderLabel2.default,
	        { htmlFor: id },
	        label
	      ),
	      _react2.default.createElement('input', {
	        id: id,
	        type: 'range',
	        className: 'md-slider-input',
	        readOnly: true,
	        min: min,
	        max: max,
	        value: value,
	        disabled: disabled
	      }),
	      leftIcon,
	      _react2.default.createElement(_Track2.default, {
	        ref: this._setTrack,
	        style: Object.assign({}, trackStyle, { width: trackWidth }),
	        className: (0, _classnames2.default)(trackClassName, {
	          'md-slider-track--ind-left': leftIcon,
	          'md-slider-track--ind-right': rightIcon
	        }),
	        thumbStyle: thumbStyle,
	        thumbClassName: thumbClassName,
	        discreteValueStyle: discreteValueStyle,
	        discreteValueClassName: discreteValueClassName,
	        active: active,
	        dragging: dragging,
	        disabled: disabled,
	        thumbLeft: thumbLeft,
	        trackFillWidth: trackFillWidth,
	        on: !disabled && distance > 0,
	        off: distance === 0,
	        maskInked: maskInked,
	        onThumbKeyUp: this._handleKeyUp,
	        onThumbKeyDown: this._handleKeyDown,
	        onThumbFocus: this._handleFocus,
	        discrete: discrete,
	        tickWidth: tickWidth,
	        discreteTicks: discreteTicks,
	        valuePrecision: valuePrecision,
	        step: step,
	        scale: scale,
	        value: value
	      }),
	      rightChildren
	    );
	  };
	
	  return Slider;
	}(_react.PureComponent);
	
	Slider.propTypes = {
	  /**
	   * An id to use for the `Slider`. This is required if the `label` prop
	   * is defined.
	   */
	  id: function id(props, propName, component) {
	    for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      others[_key - 3] = arguments[_key];
	    }
	
	    if (typeof props.label === 'undefined') {
	      return _propTypes2.default.string.apply(_propTypes2.default, [props, propName, component].concat(others));
	    }
	
	    return (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])).apply(undefined, [props, propName, component].concat(others));
	  },
	
	  /**
	   * An optional style to apply to the slider's container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the slider's container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the slider's thumb.
	   */
	  thumbStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the slider's thumb.
	   */
	  thumbClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the slider's track.
	   */
	  trackStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the slider's track.
	   */
	  trackClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the slider's track fill.
	   */
	  trackFillStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the slider's track fill.
	   */
	  trackFillClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to a discrete slider's value.
	   */
	  discreteValueStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to a discrete slider's value.
	   */
	  discreteValueClassName: _propTypes2.default.string,
	
	  /**
	   * The default value for the slider. This number must be between the min and max values if
	   * defined. If this is undefined, it's value will be set to the min value.
	   */
	  defaultValue: _propTypes2.default.number,
	
	  /**
	   * The min value for the slider. This value **must** be less than the `max` value.
	   */
	  min: function min(props, propName, component) {
	    for (var _len2 = arguments.length, others = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	      others[_key2 - 3] = arguments[_key2];
	    }
	
	    var _PropTypes$number;
	
	    var err = (_PropTypes$number = _propTypes2.default.number).isRequired.apply(_PropTypes$number, [props, propName, component].concat(others));
	    if (!err) {
	      var min = props[propName];
	      var name = void 0;
	      if (min > props.value) {
	        name = 'value';
	      } else if (typeof props.defaultValue !== 'undefined' && min > props.defaultValue) {
	        name = 'defaultValue';
	      }
	
	      if (name) {
	        err = new Error('The \'' + propName + '\' prop must be less than or equal to the \'' + name + '\' prop for the \'' + component + '\' but ' + ('received: \'min: ' + min + '\' and \'' + name + ': ' + props[name] + '\''));
	      }
	    }
	
	    return err;
	  },
	
	  /**
	   * The max value for the slider. This value **must** be greater than the `min` value.
	   */
	  max: function max(props, propName, component) {
	    for (var _len3 = arguments.length, others = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
	      others[_key3 - 3] = arguments[_key3];
	    }
	
	    var _PropTypes$number2;
	
	    var err = (_PropTypes$number2 = _propTypes2.default.number).isRequired.apply(_PropTypes$number2, [props, propName, component].concat(others));
	    if (!err) {
	      var max = props[propName];
	      var name = void 0;
	      if (max < props.value) {
	        name = 'value';
	      } else if (max < props.defaultValue) {
	        name = 'defaultValue';
	      }
	
	      if (name) {
	        err = new Error('The \'' + propName + '\' prop must be greater than or equal to the \'' + name + '\' prop for the \'' + component + '\' but ' + ('received: \'' + propName + ': ' + max + '\' and \'' + name + ': ' + props[name] + '\''));
	      }
	    }
	
	    return err;
	  },
	
	  /**
	   * Boolean if the slider is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional value for the slider. This will make the component controlled
	   * and require the `onChange` function.
	   */
	  value: (0, _controlled2.default)(_propTypes2.default.number, 'onChange'),
	
	  /**
	   * This is called when the slider's value gets updated. The value can be updated
	   * by one of the following:
	   *
	   * - Clicking a section of the slider
	   * - Dragging the slider with the mouse
	   * - Touching a section of the slider.
	   * - Dragging the slider with touch
	   * - Using the text field to update the value either by typing or incrementing
	   * - Using the left or right arrow keys to increment/decrement the value.
	   *
	   * The callback for this function is as follows:
	   *
	   * ```js
	   * onChange(value, event);
	   * ```
	   *
	   * where the event can either be:
	   * - a touch start event
	   * - a touch move event
	   * - a touch end event
	   * - a mouse down event
	   * - a mouse move event
	   * - a mouse up event
	   * - a key up event
	   * - a key down event
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * This is only called when the user is dragging the slider with either
	   * the mouse or touch. Probably not really useful. It just includes the
	   * new drag percentage while the `onChange` does not.
	   *
	   * The callback for this function is defined as:
	   *
	   * ```js
	   * onDragChange(dragPercentage, value, (touchMove || mouseMove) event);
	   * ```
	   */
	  onDragChange: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the slider's container has
	   * the mousedown event.
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the slider's container has
	   * the touchstart event.
	   */
	  onTouchStart: _propTypes2.default.func,
	
	  /**
	   * An optional icon or letter to place to the left of the slider.
	   * if you want to use a non-font icon or a letter, use the `md-slider-ind`
	   * className on your element.
	   */
	  leftIcon: _propTypes2.default.element,
	
	  /**
	   * An optional icon or letter to place to the right of the slider.
	   * if you want to use a non-font icon or a letter, use the `md-slider-ind`
	   * className on your element.
	   *
	   * > NOTE: This can not be used if the `editable` prop is true.
	   */
	  rightIcon: _propTypes2.default.element,
	
	  /**
	   * An optional label to display above the slider. If this prop
	   * is set, then an `id` must also be given.
	   */
	  label: _propTypes2.default.node,
	
	  /**
	   * The incremental amount when the user hits left or right with the
	   * keyboard arrows, or the user hits the up or down buttons in the
	   * editable number text field. This number must be a number between
	   * 0 and 1 or a whole number above 1.
	   */
	  step: function step(props, propName, component) {
	    for (var _len4 = arguments.length, others = Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++) {
	      others[_key4 - 3] = arguments[_key4];
	    }
	
	    var _PropTypes$number3;
	
	    var err = (_PropTypes$number3 = _propTypes2.default.number).isRequired.apply(_PropTypes$number3, [props, propName, component].concat(others));
	    if (!err) {
	      var step = props[propName];
	      if (step <= 0) {
	        err = new Error('The \'' + propName + '\' for the \'' + component + '\' must be a number greater than 0. The ' + ('current value is \'' + step + '\'.'));
	      } else {
	        var valueDefined = typeof props.value !== 'undefined';
	        var defaultDefined = typeof props.defaultValue !== 'undefined';
	        var value = props.value;
	        if (!valueDefined) {
	          value = defaultDefined ? props.defaultValue : props.min;
	        }
	
	        var name = void 0;
	        if (!(0, _isWithinStep2.default)(value, step)) {
	          if (valueDefined) {
	            name = 'value';
	          } else if (defaultDefined) {
	            name = 'defaultValue';
	          } else {
	            name = 'min';
	          }
	        }
	
	        if (name) {
	          err = new Error('The \'' + name + '\' prop on \'' + component + '\' should be a number divisible by the ' + ('\'' + propName + '\' prop. The current value is \'' + props[name] + '\' and the \'' + propName + '\' ') + ('is \'' + step + '\'.'));
	        }
	      }
	    }
	
	    return err;
	  },
	
	  /**
	   * Boolean if the Slider should be editable. This will place a number text field
	   * to the right of the slider. If this prop is set to `true`, the `rightIcon`
	   * prop can not be set.
	   */
	  editable: function editable(props, propName, component) {
	    for (var _len5 = arguments.length, others = Array(_len5 > 3 ? _len5 - 3 : 0), _key5 = 3; _key5 < _len5; _key5++) {
	      others[_key5 - 3] = arguments[_key5];
	    }
	
	    var _PropTypes$bool;
	
	    if (typeof props[propName] === 'undefined') {
	      return null;
	    }
	
	    var err = (_PropTypes$bool = _propTypes2.default.bool).isRequired.apply(_PropTypes$bool, [props, propName, component].concat(others));
	    if (!err && typeof props.rightIcon !== 'undefined') {
	      err = new Error('The \'' + component + '\' is unable to be \'editable\' and include a \'rightIcon\'.');
	    }
	
	    return err;
	  },
	
	  /**
	   * The width for the number text field when the Slider is editable.
	   */
	  inputWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	
	  /**
	   * Boolean if the slider should be discrete. This will update the slider to include a
	   * _balloon_ with the current value inside. It will also not allow the `Slider` to be
	   * editable.
	   */
	  discrete: function discrete(props, propName, component) {
	    for (var _len6 = arguments.length, others = Array(_len6 > 3 ? _len6 - 3 : 0), _key6 = 3; _key6 < _len6; _key6++) {
	      others[_key6 - 3] = arguments[_key6];
	    }
	
	    if (typeof props[propName] === 'undefined') {
	      return null;
	    }
	
	    var err = _propTypes2.default.bool.apply(_propTypes2.default, [props, propName, component].concat(others));
	    if (!err && typeof props.editable !== 'undefined') {
	      err = new Error('The \'' + component + '\' cannot be \'discrete\' and \'editable\'. Please choose one.');
	    }
	
	    return err;
	  },
	
	  /**
	   * The width of each tick for a discrete slider with ticks. This can either be a number
	   * which gets converted to `px`, or a valid CSS unit.
	   */
	  tickWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	
	  /**
	   * This is number divisible by the total number of values included in the Slider. Every
	   * value that is divisible by this number will include a tick mark. It is common recommended
	   * to have this equal to the `step` prop.
	   *
	   * This prop is completely optional.
	   */
	  discreteTicks: function discreteTicks(props, propName, component) {
	    for (var _len7 = arguments.length, others = Array(_len7 > 3 ? _len7 - 3 : 0), _key7 = 3; _key7 < _len7; _key7++) {
	      others[_key7 - 3] = arguments[_key7];
	    }
	
	    if (typeof props[propName] === 'undefined') {
	      return null;
	    }
	
	    var err = _propTypes2.default.number.apply(_propTypes2.default, [props, propName, component].concat(others));
	    if (!err) {
	      var min = props.min,
	          max = props.max,
	          step = props.step;
	
	      var range = Math.abs(max - min);
	
	      if (range / props[propName] % 1 !== 0) {
	        err = new Error('The \'' + propName + '\' must be a number divisible by the range set by the \'min\' and ' + ('\'max\' props. The current range is \'' + range + '\' by including the min: \'' + min + '\' and ') + ('max: \'' + max + '\' values. The current value of \'' + propName + '\' is \'' + props[propName] + '\'.'));
	      } else if (props[propName] % step !== 0) {
	        err = new Error('The \'step\' prop must be a number divisible by the \'' + propName + '\'. It is common to have ' + ('them as the same value. The current \'step\' is \'' + step + '\' and the \'' + propName + '\' is \'' + props[propName] + '\'.'));
	      }
	    }
	
	    return err;
	  },
	
	  /**
	   * The transition time for a discrete Slider's keyboard focus ink. This should match the
	   * `md-slider-discrete-ink-transition-time` value in your SCSS. This is used because
	   * the ink is only visible temporarily for a discrete slider when keyboard focusing.
	   */
	  discreteInkTransitionTime: _propTypes2.default.number.isRequired,
	
	  /**
	   * The precision that the value should be rounded to when the Slider is updated. This
	   * needs to be a whole number greater than or equal to 0.
	   */
	  valuePrecision: function valuePrecision(props, propName, component) {
	    for (var _len8 = arguments.length, others = Array(_len8 > 3 ? _len8 - 3 : 0), _key8 = 3; _key8 < _len8; _key8++) {
	      others[_key8 - 3] = arguments[_key8];
	    }
	
	    var _PropTypes$number4;
	
	    var err = (_PropTypes$number4 = _propTypes2.default.number).isRequired.apply(_PropTypes$number4, [props, propName, component].concat(others));
	    if (!err) {
	      var precision = props[propName];
	
	      if (precision % 1 !== 0 || precision < 0) {
	        err = new Error('The \'' + propName + '\' must be a positive whole number or 0 on the \'' + component + '\'. ' + ('The current \'' + propName + '\' is \'' + precision + '\''));
	      }
	    }
	
	    return err;
	  },
	
	  stepPrecision: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `step` and `valuePrecision` instead')
	};
	Slider.defaultProps = {
	  min: 0,
	  max: 100,
	  step: 1,
	  inputWidth: 40,
	  tickWidth: 6,
	  discreteInkTransitionTime: 300,
	  valuePrecision: 0
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._isTextField = function (target) {
	    return _this2._field && _this2._field.contains(target);
	  };
	
	  this._updatePosition = function (e, normalize) {
	    var x = (e.changedTouches ? e.changedTouches[0] : e).clientX;
	    var scale = _this2.state.scale;
	    var _props3 = _this2.props,
	        onChange = _props3.onChange,
	        onDragChange = _props3.onDragChange,
	        min = _props3.min,
	        max = _props3.max,
	        step = _props3.step;
	
	    var _calculateValueDistan = (0, _calculateValueDistance2.default)(x, _this2._track.offsetWidth, _this2._track.getBoundingClientRect().left, scale, step, min, max, normalize),
	        value = _calculateValueDistan.value,
	        distance = _calculateValueDistan.distance;
	
	    var isNewValue = (0, _getField2.default)(_this2.props, _this2.state, 'value') !== value;
	    if (onChange && isNewValue) {
	      onChange(value, e);
	    }
	
	    if (!normalize && onDragChange && (isNewValue || _this2.state.distance !== distance)) {
	      onDragChange(distance, value, e);
	    }
	
	    var state = {
	      active: true,
	      distance: distance,
	      manualIncrement: false,
	      dragging: !normalize,
	      thumbLeft: _this2._calcLeft(distance),
	      trackFillWidth: distance + '%'
	    };
	
	    if (e.type === 'touchend' || e.type === 'mousedown') {
	      state.maskInked = false;
	    }
	
	    if (typeof _this2.props.value === 'undefined') {
	      state.value = value;
	    }
	
	    _this2.setState(state);
	  };
	
	  this._handleDragStart = function (e) {
	    if (e.type === 'mousedown' && _this2.props.onMouseDown) {
	      _this2.props.onMouseDown(e);
	    } else if (e.type === 'touchstart' && _this2.props.onTouchStart) {
	      _this2.props.onTouchStart(e);
	    }
	
	    if (_this2.props.disabled || e.type === 'mousedown' && !(0, _isValidClick2.default)(e, 'mousedown') || _this2._isInTextField(e)) {
	      return;
	    }
	
	    var classList = e.target.classList;
	
	    var isDiscreteValue = classList.contains('md-slider-discrete-value');
	    if (classList.contains('md-slider-thumb') || isDiscreteValue) {
	      // Prevents text highlighting while dragging.
	      if (e.type.match(/mouse/)) {
	        e.preventDefault();
	      }
	      _this2.setState({ dragging: true, active: true, manualIncrement: false, maskInked: false });
	    } else if (!_this2._isTextField(e.target) && _this2._isValidClassList(classList)) {
	      _this2._updatePosition(e, true);
	    }
	  };
	
	  this._setNode = function (node) {
	    _this2._node = (0, _reactDom.findDOMNode)(node);
	  };
	
	  this._setTrack = function (track) {
	    _this2._track = (0, _reactDom.findDOMNode)(track);
	  };
	
	  this._setField = function (field) {
	    _this2._field = (0, _reactDom.findDOMNode)(field);
	    _this2._calcTrackWidth(_this2.props);
	  };
	
	  this._handleDragMove = function (e) {
	    if (_this2.props.disabled || !_this2.state.dragging) {
	      return;
	    }
	
	    // Stops the text highlighting while dragging
	    if (e.type.match(/mouse/)) {
	      e.preventDefault();
	    }
	
	    _this2._updatePosition(e, false);
	  };
	
	  this._handleDragEnd = function (e) {
	    if (!_this2.state.dragging || _this2.props.disabled || e.type === 'mouseup' && !(0, _isValidClick2.default)(e)) {
	      return;
	    }
	
	    _this2._updatePosition(e, true);
	  };
	
	  this._blurOnOutsideClick = function (e) {
	    if (_this2.state.dragging && !_this2.state.manualIncrement || _this2.props.disabled) {
	      return;
	    }
	
	    if (!_this2._node.contains(e.target)) {
	      _this2.setState({ active: false, maskInked: false });
	    }
	  };
	
	  this._handleIncrement = function (incrementedValue, e, disableTransition) {
	    var _props4 = _this2.props,
	        onChange = _props4.onChange,
	        min = _props4.min,
	        max = _props4.max,
	        discrete = _props4.discrete;
	
	
	    var value = Math.max(min, Math.min(max, incrementedValue));
	    var distance = _this2._calcDistance(value, min, max);
	
	    if (onChange) {
	      onChange(value, e);
	    }
	
	    var state = {
	      distance: distance,
	      manualIncrement: true,
	      thumbLeft: _this2._calcLeft(distance),
	      trackFillWidth: distance + '%',
	      dragging: Math.abs(_this2.state.distance - distance) < 2 && disableTransition
	    };
	
	    if (typeof _this2.props.value === 'undefined') {
	      state.value = value;
	    }
	
	    if (e.type === 'keydown' && !discrete) {
	      state.maskInked = true;
	    }
	
	    _this2.setState(state);
	  };
	
	  this._handleTextFieldChange = function (newValue, e) {
	    _this2._handleIncrement(newValue, e, false);
	  };
	
	  this._handleKeyDown = function (e) {
	    var key = e.which || e.keyCode;
	    var _props5 = _this2.props,
	        min = _props5.min,
	        max = _props5.max,
	        step = _props5.step,
	        disabled = _props5.disabled;
	
	    if (disabled) {
	      return;
	    }
	
	    if (key === _keyCodes.TAB) {
	      _this2.setState({ active: false, maskInked: false });
	      return;
	    } else if (key !== _keyCodes.LEFT && key !== _keyCodes.RIGHT) {
	      return;
	    }
	
	    var nextValue = (0, _getField2.default)(_this2.props, _this2.state, 'value');
	    nextValue = Math.max(min, Math.min((key === _keyCodes.LEFT ? -step : step) + nextValue, max));
	
	    _this2._handleIncrement(nextValue, e, true);
	  };
	
	  this._handleKeyUp = function (e) {
	    if ((e.which || e.keyCode) !== _keyCodes.TAB) {
	      return;
	    }
	
	    if (_this2.props.discrete) {
	      _this2._animateDiscreteInk();
	    }
	
	    _this2.setState({ maskInked: true });
	  };
	
	  this._handleFocus = function () {
	    _this2.setState({ active: true });
	  };
	
	  this._calcTrackWidth = function (props) {
	    var editable = props.editable,
	        leftIcon = props.leftIcon,
	        rightIcon = props.rightIcon,
	        inputWidth = props.inputWidth,
	        label = props.label;
	
	
	    if (!label) {
	      _this2.setState({ trackWidth: null });
	      return;
	    }
	
	    var trackWidth = null;
	    if (!leftIcon && !rightIcon && !editable) {
	      trackWidth = '100%';
	    } else if (_this2._field && editable && !leftIcon) {
	      var cs = window.getComputedStyle(_this2._field);
	      var pl = parseInt(cs.getPropertyValue('padding-left'), 10) || 0;
	      var ml = parseInt(cs.getPropertyValue('margin-left'), 10) || 0;
	
	      trackWidth = pl + ml + inputWidth;
	    }
	
	    if (trackWidth !== _this2.state.trackWidth) {
	      _this2.setState({ trackWidth: trackWidth });
	    }
	  };
	
	  this._animateDiscreteInk = function () {
	    var wait = _this2.props.discreteInkTransitionTime;
	    if (_this2._inkTimeout) {
	      clearTimeout(_this2._inkTimeout);
	    }
	
	    _this2._inkTimeout = setTimeout(function () {
	      _this2.setState({ leaving: true, maskInked: false });
	
	      _this2._inkTimeout = setTimeout(function () {
	        _this2._inkTimeout = null;
	        _this2.setState({ leaving: false });
	      }, wait);
	    }, wait);
	  };
	
	  this._focusThumb = function () {
	    if (_this2._focusTimeout) {
	      clearTimeout(_this2._focusTimeout);
	    }
	
	    _this2._focusTimeout = setTimeout(function () {
	      _this2._focusTimeout = null;
	      if (!_this2._thumb) {
	        _this2._thumb = _this2._node.querySelector('.md-slider-thumb');
	      }
	
	      _this2._thumb.focus();
	    }, 100);
	  };
	};
	
	exports.default = Slider;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(11);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This is just the label component for the slider. It will
	 * return null if there are no children to display.
	 */
	var SliderLabel = function (_PureComponent) {
	  _inherits(SliderLabel, _PureComponent);
	
	  function SliderLabel() {
	    _classCallCheck(this, SliderLabel);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  SliderLabel.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        className = _props.className,
	        htmlFor = _props.htmlFor,
	        props = _objectWithoutProperties(_props, ['children', 'className', 'htmlFor']);
	
	    if (!children) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      'label',
	      _extends({}, props, {
	        htmlFor: htmlFor,
	        className: (0, _classnames2.default)('md-slider-label', (0, _themeColors2.default)({ text: true }), className)
	      }),
	      children
	    );
	  };
	
	  return SliderLabel;
	}(_react.PureComponent);
	
	SliderLabel.propTypes = {
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  htmlFor: function htmlFor(props, propName, component) {
	    for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      others[_key - 3] = arguments[_key];
	    }
	
	    var _PropTypes$string;
	
	    if (typeof props.children === 'undefined') {
	      return null;
	    }
	
	    return (_PropTypes$string = _propTypes2.default.string).isRequired.apply(_PropTypes$string, [props, propName, component].concat(others));
	  }
	};
	exports.default = SliderLabel;

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _AccessibleFakeButton = __webpack_require__(70);
	
	var _AccessibleFakeButton2 = _interopRequireDefault(_AccessibleFakeButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `Thumb` component is the little ball for the slider.
	 */
	var Thumb = function (_PureComponent) {
	  _inherits(Thumb, _PureComponent);
	
	  function Thumb() {
	    _classCallCheck(this, Thumb);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  Thumb.prototype.render = function render() {
	    var _props = this.props,
	        style = _props.style,
	        className = _props.className,
	        on = _props.on,
	        off = _props.off,
	        active = _props.active,
	        disabled = _props.disabled,
	        dragging = _props.dragging,
	        thumbLeft = _props.thumbLeft,
	        discrete = _props.discrete,
	        props = _objectWithoutProperties(_props, ['style', 'className', 'on', 'off', 'active', 'disabled', 'dragging', 'thumbLeft', 'discrete']);
	
	    return _react2.default.createElement(_AccessibleFakeButton2.default, _extends({
	      disabled: disabled
	    }, props, {
	      style: Object.assign({}, style, { left: thumbLeft }),
	      className: (0, _classnames2.default)('md-slider-thumb', className, {
	        'md-slider-thumb--active': active,
	        'md-slider-thumb--dragging': dragging,
	        'md-slider-thumb--disabled': disabled,
	        'md-slider-thumb--on': on,
	        'md-slider-thumb--continuous-off': !discrete && off,
	        'md-slider-thumb--discrete': discrete,
	        'md-slider-thumb--discrete-on': discrete && active && on,
	        'md-slider-thumb--discrete-off': discrete && !disabled && off,
	        'md-slider-thumb--discrete-active': discrete && active,
	        'md-slider-thumb--discrete-active-off': discrete && active && off
	      })
	    }));
	  };
	
	  return Thumb;
	}(_react.PureComponent);
	
	Thumb.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  thumbLeft: _propTypes2.default.string.isRequired,
	  on: _propTypes2.default.bool,
	  off: _propTypes2.default.bool,
	  active: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  dragging: _propTypes2.default.bool,
	  discrete: _propTypes2.default.bool
	};
	exports.default = Thumb;

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `ThumbMask` component is used for either:
	 *
	 *  - rendering the ink behind the `Thumb` component when the `Thumb`
	 *  has keyboard focus or touch focus
	 *  - rendering a underlay to make the `Track` look broken for disabled
	 *  Sliders.
	 */
	var ThumbMask = function (_PureComponent) {
	  _inherits(ThumbMask, _PureComponent);
	
	  function ThumbMask() {
	    _classCallCheck(this, ThumbMask);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  ThumbMask.prototype.render = function render() {
	    var _props = this.props,
	        style = _props.style,
	        className = _props.className,
	        thumbLeft = _props.thumbLeft,
	        disabled = _props.disabled,
	        dragging = _props.dragging,
	        maskInked = _props.maskInked,
	        discrete = _props.discrete,
	        leaving = _props.leaving,
	        props = _objectWithoutProperties(_props, ['style', 'className', 'thumbLeft', 'disabled', 'dragging', 'maskInked', 'discrete', 'leaving']);
	
	    return _react2.default.createElement('span', _extends({}, props, {
	      style: Object.assign({}, style, { left: thumbLeft }),
	      className: (0, _classnames2.default)('md-slider-thumb md-slider-thumb--mask', className, {
	        'md-slider-thumb--dragging': dragging,
	        'md-slider-thumb--mask-inked': maskInked,
	        'md-slider-thumb--mask-disabled': disabled,
	        'md-slider-thumb--discrete-mask-inked': maskInked && discrete,
	        'md-slider-thumb--discrete-mask-leaving': discrete && leaving
	      })
	    }));
	  };
	
	  return ThumbMask;
	}(_react.PureComponent);
	
	ThumbMask.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  thumbLeft: _propTypes2.default.string.isRequired,
	  maskInked: _propTypes2.default.bool,
	  dragging: _propTypes2.default.bool,
	  discrete: _propTypes2.default.bool,
	  leaving: _propTypes2.default.bool
	};
	exports.default = ThumbMask;

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _updateUnit = __webpack_require__(927);
	
	var _updateUnit2 = _interopRequireDefault(_updateUnit);
	
	var _TrackFill = __webpack_require__(904);
	
	var _TrackFill2 = _interopRequireDefault(_TrackFill);
	
	var _Thumb = __webpack_require__(901);
	
	var _Thumb2 = _interopRequireDefault(_Thumb);
	
	var _ThumbMask = __webpack_require__(902);
	
	var _ThumbMask2 = _interopRequireDefault(_ThumbMask);
	
	var _DiscreteValue = __webpack_require__(898);
	
	var _DiscreteValue2 = _interopRequireDefault(_DiscreteValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var half = function half(w) {
	  return w / 2;
	};
	
	/**
	 * The `Track` component is used for showing the current state of the slider.
	 * It will render the `TrackFill`, `Thumb`, and `ThumbMask` components.
	 */
	
	var Track = function (_PureComponent) {
	  _inherits(Track, _PureComponent);
	
	  function Track() {
	    _classCallCheck(this, Track);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  Track.prototype.render = function render() {
	    var _props = this.props,
	        on = _props.on,
	        off = _props.off,
	        active = _props.active,
	        disabled = _props.disabled,
	        dragging = _props.dragging,
	        className = _props.className,
	        thumbLeft = _props.thumbLeft,
	        trackFillWidth = _props.trackFillWidth,
	        trackFillStyle = _props.trackFillStyle,
	        trackFillClassName = _props.trackFillClassName,
	        discreteValueStyle = _props.discreteValueStyle,
	        discreteValueClassName = _props.discreteValueClassName,
	        maskInked = _props.maskInked,
	        maskLeaving = _props.maskLeaving,
	        thumbStyle = _props.thumbStyle,
	        thumbClassName = _props.thumbClassName,
	        discrete = _props.discrete,
	        onThumbFocus = _props.onThumbFocus,
	        onThumbKeyUp = _props.onThumbKeyUp,
	        onThumbKeyDown = _props.onThumbKeyDown,
	        value = _props.value,
	        tickWidth = _props.tickWidth,
	        discreteTicks = _props.discreteTicks,
	        scale = _props.scale,
	        step = _props.step,
	        valuePrecision = _props.valuePrecision,
	        props = _objectWithoutProperties(_props, ['on', 'off', 'active', 'disabled', 'dragging', 'className', 'thumbLeft', 'trackFillWidth', 'trackFillStyle', 'trackFillClassName', 'discreteValueStyle', 'discreteValueClassName', 'maskInked', 'maskLeaving', 'thumbStyle', 'thumbClassName', 'discrete', 'onThumbFocus', 'onThumbKeyUp', 'onThumbKeyDown', 'value', 'tickWidth', 'discreteTicks', 'scale', 'step', 'valuePrecision']);
	
	    var ticks = [];
	    if (typeof discreteTicks !== 'undefined' && !disabled && discrete) {
	      var amt = scale / (discreteTicks / step);
	      var offset = (0, _updateUnit2.default)(tickWidth, half, 'px');
	      var inc = 100 / amt;
	
	      for (var i = 0; i <= amt; i++) {
	        var left = i * inc + '%';
	        var width = tickWidth;
	        if (i === 0 || i === amt) {
	          width = (0, _updateUnit2.default)(tickWidth, half);
	        } else {
	          left = 'calc(' + left + ' - ' + offset + ')';
	        }
	
	        ticks.push(_react2.default.createElement('span', {
	          key: 'tick-' + i,
	          className: 'md-slider-discrete-tick',
	          style: { left: left, width: width }
	        }));
	      }
	    }
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, props, { className: (0, _classnames2.default)('md-slider-track', className) }),
	      ticks,
	      _react2.default.createElement(_TrackFill2.default, {
	        style: trackFillStyle,
	        className: trackFillClassName,
	        disabled: disabled,
	        dragging: dragging,
	        trackFillWidth: trackFillWidth
	      }),
	      _react2.default.createElement(_Thumb2.default, {
	        style: thumbStyle,
	        className: thumbClassName,
	        on: on,
	        off: off,
	        disabled: disabled,
	        dragging: dragging,
	        active: active,
	        thumbLeft: thumbLeft,
	        onFocus: onThumbFocus,
	        onKeyUp: onThumbKeyUp,
	        onKeyDown: onThumbKeyDown,
	        discrete: discrete
	      }),
	      _react2.default.createElement(_DiscreteValue2.default, {
	        style: discreteValueStyle,
	        className: discreteValueClassName,
	        discrete: discrete,
	        dragging: dragging,
	        active: active,
	        value: value,
	        thumbLeft: thumbLeft,
	        valuePrecision: valuePrecision
	      }),
	      _react2.default.createElement(_ThumbMask2.default, {
	        dragging: dragging,
	        disabled: disabled,
	        thumbLeft: thumbLeft,
	        maskInked: maskInked,
	        discrete: discrete,
	        leaving: maskLeaving
	      })
	    );
	  };
	
	  return Track;
	}(_react.PureComponent);
	
	Track.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  thumbStyle: _propTypes2.default.object,
	  thumbClassName: _propTypes2.default.string,
	  trackFillStyle: _propTypes2.default.object,
	  trackFillClassName: _propTypes2.default.string,
	  discreteValueStyle: _propTypes2.default.object,
	  discreteValueClassName: _propTypes2.default.string,
	  on: _propTypes2.default.bool,
	  off: _propTypes2.default.bool,
	  active: _propTypes2.default.bool,
	  dragging: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  thumbLeft: _propTypes2.default.string.isRequired,
	  trackFillWidth: _propTypes2.default.string.isRequired,
	  value: _propTypes2.default.number.isRequired,
	  discrete: _propTypes2.default.bool,
	  maskInked: _propTypes2.default.bool,
	  maskLeaving: _propTypes2.default.bool,
	  onThumbKeyUp: _propTypes2.default.func.isRequired,
	  onThumbKeyDown: _propTypes2.default.func.isRequired,
	  onThumbFocus: _propTypes2.default.func.isRequired,
	  scale: _propTypes2.default.number,
	  step: _propTypes2.default.number,
	  discreteTicks: _propTypes2.default.number,
	  tickWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  valuePrecision: _propTypes2.default.number.isRequired
	};
	exports.default = Track;

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `TrackFill` component is used for showing a colored bar
	 * within the `Track` component to show the `Slider`'s position.
	 *
	 * If the `Slider` is disabled, this will just return null.
	 */
	var TrackFill = function (_PureComponent) {
	  _inherits(TrackFill, _PureComponent);
	
	  function TrackFill() {
	    _classCallCheck(this, TrackFill);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  TrackFill.prototype.render = function render() {
	    var _props = this.props,
	        style = _props.style,
	        className = _props.className,
	        trackFillWidth = _props.trackFillWidth,
	        dragging = _props.dragging,
	        disabled = _props.disabled,
	        props = _objectWithoutProperties(_props, ['style', 'className', 'trackFillWidth', 'dragging', 'disabled']);
	
	    if (disabled) {
	      return null;
	    }
	
	    return _react2.default.createElement('hr', _extends({}, props, {
	      style: Object.assign({}, style, { width: trackFillWidth }),
	      className: (0, _classnames2.default)('md-slider-track-fill', className, {
	        'md-slider-track-fill--dragging': dragging
	      })
	    }));
	  };
	
	  return TrackFill;
	}(_react.PureComponent);
	
	TrackFill.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  dragging: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  trackFillWidth: _propTypes2.default.string.isRequired
	};
	exports.default = TrackFill;

/***/ }),
/* 905 */,
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _oneRequired = __webpack_require__(351);
	
	var _oneRequired2 = _interopRequireDefault(_oneRequired);
	
	var _AccessibleFakeInkedButton = __webpack_require__(24);
	
	var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `Tab` component is used for rendering a single tab in the `Tabs` component.
	 * It can optionally have either a `label`, an `icon` or both.
	 */
	var Tab = function (_PureComponent) {
	  _inherits(Tab, _PureComponent);
	
	  function Tab() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Tab);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this._handleClick = function (e) {
	      if (_this.props.onClick) {
	        _this.props.onClick(_this.props.index, _this.props.id, _this.props.controlsId, _this.props.children, e);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Tab.prototype.render = function render() {
	    var _cn;
	
	    var _props = this.props,
	        id = _props.id,
	        controlsId = _props.controlsId,
	        className = _props.className,
	        activeClassName = _props.activeClassName,
	        inactiveClassName = _props.inactiveClassName,
	        active = _props.active,
	        propIcon = _props.icon,
	        propLabel = _props.label,
	        index = _props.index,
	        props = _objectWithoutProperties(_props, ['id', 'controlsId', 'className', 'activeClassName', 'inactiveClassName', 'active', 'icon', 'label', 'index']);
	
	    var _props2 = this.props,
	        icon = _props2.icon,
	        label = _props2.label;
	
	    if (icon) {
	      var iconEl = _react.Children.only(icon);
	      icon = (0, _react.cloneElement)(icon, {
	        className: (0, _classnames2.default)('md-icon--tab', iconEl.props.className)
	      });
	    }
	
	    if ((0, _react.isValidElement)(label)) {
	      var labelEl = _react.Children.only(label);
	      label = (0, _react.cloneElement)(label, {
	        className: (0, _classnames2.default)('md-tab-label', labelEl.props.className)
	      });
	    } else {
	      label = _react2.default.createElement(
	        'div',
	        { className: 'md-tab-label' },
	        label
	      );
	    }
	    return _react2.default.createElement(
	      _AccessibleFakeInkedButton2.default,
	      _extends({}, props, {
	        id: id,
	        role: 'tab',
	        onClick: this._handleClick,
	        className: (0, _classnames2.default)('md-tab', (_cn = {
	          'md-tab--icon': label && icon
	        }, _cn[activeClassName] = activeClassName && active, _cn[inactiveClassName] = inactiveClassName && !active, _cn), className),
	        'aria-controls': controlsId,
	        'aria-selected': active
	      }),
	      icon,
	      label
	    );
	  };
	
	  return Tab;
	}(_react.PureComponent);
	
	Tab.propTypes = {
	  /**
	   * An id for the tab. This is required for a11y. If you use the `Tabs` component, this
	   * will automatically be generated for you and injected into this component.
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An id for a `TabPanel` that holds the children from this tab. This is required for a11y.
	   * If you use the `Tabs` component, this will automatically be generated for you and injected
	   * into this component.
	   */
	  controlsId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The className to use when the tab is currently active. The default className does
	   * not actually apply any styles.
	   *
	   * @see {@link Tabs/Tabs#activeTabClassName}
	   */
	  activeClassName: _propTypes2.default.string,
	
	  /**
	   * The className to use when the tab is not active. By default, this will set inactive
	   * tabs' color to `$md-white-base`. This works great if the tabs are placed on a
	   * colored toolbar but fails when the tabs are not colored or on a white background.
	   * In these cases, it is recommended to change this value to `md-text--secondary`
	   * or some other class name.
	   *
	   * @see {@link Tabs/Tabs#inactiveTabClassName}
	   */
	  inactiveClassName: _propTypes2.default.string,
	
	  /**
	   * The component to render as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * Any children to display once the tab has been selected.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * An optional icon to display in the tab. This can either be used alone, or it
	   * will be placed above the `label` if both are given.
	   */
	  icon: _propTypes2.default.element,
	
	  /**
	   * An optional label to display in the tab. This can either be used alone, or it
	   * will be placed below the `icon` if both are given.
	   */
	  label: (0, _oneRequired2.default)(_propTypes2.default.node, 'icon'),
	
	  /**
	   * An optional function to call when the tab is clicked. The callback includes this tab's index,
	   * id, controlsId, children, and finally click event. All the additional parameters are included
	   * if you are not using the `TabsContainer` component. The `id` and `controlsId` are mainly passed
	   * for accessibility.
	   *
	   * ```js
	   * onClick(index, id, controlsId, children, event);
	   * ```
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * Boolean if the tab is currently active. If you use the `Tabs` component, this is automatically
	   * injected.
	   */
	  active: _propTypes2.default.bool,
	
	  /**
	   * Tab's index. If you use the `Tabs` component, this is automatically injected.
	   */
	  index: _propTypes2.default.number
	};
	Tab.defaultProps = {
	  component: 'li',
	  activeClassName: 'md-tab--active',
	  inactiveClassName: 'md-tab--inactive'
	};
	exports.default = Tab;

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMotion = __webpack_require__(356);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabIndicator = function (_PureComponent) {
	  _inherits(TabIndicator, _PureComponent);
	
	  function TabIndicator() {
	    _classCallCheck(this, TabIndicator);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  TabIndicator.prototype.render = function render() {
	    var visible = this.props.visible;
	
	    return _react2.default.createElement(
	      _reactMotion.Motion,
	      {
	        style: {
	          x: (0, _reactMotion.spring)(this.props.offset),
	          width: (0, _reactMotion.spring)(this.props.width),
	          height: (0, _reactMotion.spring)(visible ? 2 : 0)
	        }
	      },
	      function (_ref) {
	        var x = _ref.x,
	            height = _ref.height,
	            width = _ref.width;
	
	        var transform = 'translate3d(' + x + 'px, 0, 0)';
	        return _react2.default.createElement('span', {
	          style: {
	            height: height,
	            width: width,
	            WebkitTransform: transform,
	            MozTransform: transform,
	            msTransform: transform,
	            transform: transform
	          },
	          className: 'md-tab-indicator'
	        });
	      }
	    );
	  };
	
	  return TabIndicator;
	}(_react.PureComponent);
	
	TabIndicator.propTypes = {
	  offset: _propTypes2.default.number.isRequired,
	  width: _propTypes2.default.number.isRequired,
	  visible: _propTypes2.default.bool
	};
	exports.default = TabIndicator;

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(18);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabOverflowButton = function (_PureComponent) {
	  _inherits(TabOverflowButton, _PureComponent);
	
	  function TabOverflowButton() {
	    _classCallCheck(this, TabOverflowButton);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  TabOverflowButton.prototype.render = function render() {
	    var _props = this.props,
	        left = _props.left,
	        icon = _props.icon,
	        props = _objectWithoutProperties(_props, ['left', 'icon']);
	
	    return _react2.default.createElement(_Button2.default, _extends({}, props, {
	      icon: true,
	      className: (0, _classnames2.default)('md-icon--inherit md-btn--tab-overflow', {
	        'md-btn--tab-overflow-left': left,
	        'md-btn--tab-overflow-right': !left,
	        'md-btn--tab-overflow-icon': icon
	      })
	    }));
	  };
	
	  return TabOverflowButton;
	}(_react.PureComponent);
	
	TabOverflowButton.propTypes = {
	  left: _propTypes2.default.bool,
	  icon: _propTypes2.default.bool
	};
	exports.default = TabOverflowButton;

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(5);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _isRequiredForA11y = __webpack_require__(16);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _getField = __webpack_require__(8);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _controlled = __webpack_require__(15);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _TabIndicator = __webpack_require__(907);
	
	var _TabIndicator2 = _interopRequireDefault(_TabIndicator);
	
	var _IconSeparator = __webpack_require__(83);
	
	var _IconSeparator2 = _interopRequireDefault(_IconSeparator);
	
	var _ResizeObserver = __webpack_require__(35);
	
	var _ResizeObserver2 = _interopRequireDefault(_ResizeObserver);
	
	var _FontIcon = __webpack_require__(12);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _getDeprecatedIcon = __webpack_require__(21);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _MenuTab = __webpack_require__(340);
	
	var _MenuTab2 = _interopRequireDefault(_MenuTab);
	
	var _TabOverflowButton = __webpack_require__(908);
	
	var _TabOverflowButton2 = _interopRequireDefault(_TabOverflowButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MOBILE_PADDING = 72;
	var DESKTOP_PADDING = 80;
	var MOBILE_TAB_MIN_WIDTH = 72;
	var DESKTOP_TAB_MIN_WIDTH = 160;
	
	/**
	 * The `Tabs` component is used to manage the state of which tab is currently active.
	 */
	
	var Tabs = function (_PureComponent) {
	  _inherits(Tabs, _PureComponent);
	
	  function Tabs(props) {
	    _classCallCheck(this, Tabs);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));
	
	    _this._setContainer = function (container) {
	      _this._container = container;
	      _this._positionElements(_this._container !== null);
	    };
	
	    _this._positionElements = function (initialRender) {
	      initialRender = typeof initialRender === 'boolean' && initialRender;
	      if (!_this._container) {
	        return;
	      }
	
	      var _this$props = _this.props,
	          centered = _this$props.centered,
	          overflowMenu = _this$props.overflowMenu;
	      var mobile = _this.props.mobile;
	
	
	      var paddingLeft = void 0;
	      if (!centered && _this._shouldAlign(_this.props)) {
	        paddingLeft = _this._calcPaddingLeft(_this._container, mobile);
	      }
	
	      var overflowAtIndex = void 0;
	      if (!mobile) {
	        overflowAtIndex = _this._calcOverflowIndex(_this._container, paddingLeft, overflowMenu);
	      }
	
	      var indicatorPosition = _this._calcIndicatorPosition(_this._container, initialRender ? paddingLeft : 0);
	
	      _this.setState(_extends({ mobile: mobile, paddingLeft: paddingLeft, overflowAtIndex: overflowAtIndex }, indicatorPosition), _this._scrollActiveIntoView);
	    };
	
	    _this._scrollActiveIntoView = function () {
	      if (!_this._container || !_this.state.mobile) {
	        return;
	      }
	
	      var active = _this._container.querySelector('.md-tab--active');
	      if (!active) {
	        return;
	      }
	
	      var allTabs = Array.prototype.slice.call(_this._container.querySelectorAll('.md-tab'));
	      if (allTabs[0] === active) {
	        _this._container.scrollLeft = 0;
	        return;
	      }
	
	      var _this$_container = _this._container,
	          containerWidth = _this$_container.offsetWidth,
	          scrollLeft = _this$_container.scrollLeft;
	      var activeWidth = active.offsetWidth,
	          activeOffset = active.offsetLeft;
	
	      var inFullViewLeft = activeOffset - scrollLeft >= 0;
	      var inFullViewRight = activeOffset + activeWidth - (containerWidth + scrollLeft) <= 0;
	      if (inFullViewLeft && inFullViewRight) {
	        return;
	      }
	
	      var offset = 0;
	      allTabs.some(function (tab, i) {
	        if (i < _this.props.activeTabIndex) {
	          offset += tab.offsetWidth;
	        }
	
	        return i < _this.state.activeTabIndex;
	      });
	
	      _this._container.scrollLeft = offset;
	    };
	
	    _this._handleTabChange = function (index, tabId, tabControlsId, tabChildren, event) {
	      if (_this.props.onTabChange) {
	        _this.props.onTabChange(index, tabId, tabControlsId, tabChildren, event);
	      }
	
	      if (typeof _this.props.activeTabIndex === 'undefined') {
	        _this.setState(_extends({
	          activeTabIndex: index
	        }, _this._calcIndicatorPosition(_this._container, 0, index, _this.state.overflowAtIndex)));
	      }
	    };
	
	    _this._mapToOverflowTabProps = function (tab, i) {
	      var index = i + _this.state.overflowAtIndex;
	      var active = (0, _getField2.default)(_this.props, _this.state, 'activeTabIndex') === index;
	      var tabEl = _react.Children.only(tab);
	      var handleTabChange = _this._handleTabChange;
	
	      return {
	        active: active,
	        primaryText: tabEl.props.label,
	        onClick: function handleClick(event) {
	          var _tabEl$props = tabEl.props,
	              onClick = _tabEl$props.onClick,
	              id = _tabEl$props.id,
	              controlsId = _tabEl$props.controlsId,
	              children = _tabEl$props.children;
	
	          if (onClick) {
	            onClick(index, event);
	          }
	
	          handleTabChange(index, id, controlsId, children, event);
	        }
	      };
	    };
	
	    _this._nextIndexes = function (increment) {
	      var _this$state = _this.state,
	          overflowIndex = _this$state.overflowIndex,
	          overflowAtIndex = _this$state.overflowAtIndex;
	
	      var visibleAmt = (overflowAtIndex - overflowIndex) * (increment ? 1 : -1);
	
	      _this.setState({
	        overflowIndex: overflowIndex + visibleAmt,
	        overflowAtIndex: overflowAtIndex + visibleAmt
	      });
	    };
	
	    _this._showNextTabs = function () {
	      _this._nextIndexes(true);
	    };
	
	    _this._showPreviousTabs = function () {
	      _this._nextIndexes(false);
	    };
	
	    var defaultTabIndex = typeof props.activeTabIndex === 'undefined' ? props.defaultTabIndex : props.activeTabIndex;
	    var indicatorWidth = props.mobile ? MOBILE_TAB_MIN_WIDTH : DESKTOP_TAB_MIN_WIDTH;
	    _this.state = {
	      indicatorWidth: indicatorWidth,
	      indicatorOffset: indicatorWidth * defaultTabIndex,
	      indicatorVisible: true,
	      overflowIndex: 0
	    };
	
	    if (typeof props.activeTabIndex === 'undefined') {
	      _this.state.activeTabIndex = defaultTabIndex;
	    }
	    return _this;
	  }
	
	  Tabs.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.activeTabIndex !== nextProps.activeTabIndex) {
	      this.setState(_extends({}, this._calcIndicatorPosition(this._container, 0, nextProps.activeTabIndex, this.state.overflowAtIndex)), this._scrollActiveIntoView);
	    } else if (!this._shouldAlign(nextProps) && this._shouldAlign(this.props)) {
	      this.setState({ paddingLeft: null });
	    }
	  };
	
	  Tabs.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    if (this._shouldAlign(this.props) && this.state.overflowAtIndex !== prevState.overflowAtIndex) {
	      var paddingLeft = this._calcPaddingLeft(this._container, this.state.mobile);
	      // Have to wait for the overflow menus to appear, then wop
	      /* eslint-disable react/no-did-update-set-state */
	      this.setState({ paddingLeft: paddingLeft });
	    } else {
	      var labels = _react.Children.map(_react.Children.toArray(this.props.children), function (_ref) {
	        var label = _ref.props.label;
	        return label;
	      });
	      var prevLabels = _react.Children.map(_react.Children.toArray(prevProps.children), function (_ref2) {
	        var label = _ref2.props.label;
	        return label;
	      });
	      if (labels.length !== prevLabels.length || labels.filter(function (_, i) {
	        return labels[i] !== prevLabels[i];
	      }).length) {
	        this.setState(_extends({}, this._calcIndicatorPosition(this._container, 0, this.props.activeTabIndex, this.state.overflowAtIndex)), this._scrollActiveIntoView);
	      }
	    }
	  };
	
	  Tabs.prototype._shouldAlign = function _shouldAlign(props) {
	    return typeof props.alignToKeyline === 'boolean' ? props.alignToKeyline : _react.Children.toArray(props.children).filter(function (child) {
	      return !!child;
	    }).length > 3;
	  };
	
	  Tabs.prototype._calcPaddingLeft = function _calcPaddingLeft(container, mobile) {
	    var mediaPadding = mobile ? MOBILE_PADDING : DESKTOP_PADDING;
	    var tab = container.querySelector('.md-tab');
	
	    var _tab$querySelector = tab.querySelector('.md-tab-label'),
	        labelOffset = _tab$querySelector.offsetLeft;
	
	    return mediaPadding - labelOffset;
	  };
	
	  Tabs.prototype._calcOverflowIndex = function _calcOverflowIndex(container) {
	    var paddingLeft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    var menu = arguments[2];
	
	    var containerWidth = container.offsetWidth;
	    var overflowIndex = 0;
	    if (containerWidth < container.scrollWidth) {
	      var tabs = Array.prototype.slice.call(container.querySelectorAll('.md-tab'));
	      var totalWidth = 0;
	      tabs.some(function (tab, i) {
	        overflowIndex = i;
	        totalWidth += tab.offsetWidth;
	
	        return totalWidth > containerWidth;
	      });
	    }
	
	    return Math.max(0, overflowIndex - (menu ? 1 : 0));
	  };
	
	  Tabs.prototype._calcIndicatorPosition = function _calcIndicatorPosition(container) {
	    var paddingLeft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    var activeTabIndex = arguments[2];
	    var overflowAtIndex = arguments[3];
	
	    var activeItem = void 0;
	    if (typeof activeTabIndex === 'number') {
	      if (overflowAtIndex > 0 && activeTabIndex >= overflowAtIndex) {
	        activeItem = container.querySelector('.md-menu--tab');
	      } else {
	        activeItem = container.querySelectorAll('.md-tab')[activeTabIndex];
	      }
	    } else {
	      activeItem = container.querySelector('.md-tab--active');
	    }
	
	    if (!activeItem) {
	      return { indicatorVisible: false };
	    }
	
	    var _activeItem = activeItem,
	        indicatorWidth = _activeItem.offsetWidth,
	        indicatorOffset = _activeItem.offsetLeft;
	
	    return {
	      indicatorWidth: indicatorWidth,
	      indicatorOffset: indicatorOffset + paddingLeft,
	      indicatorVisible: !overflowAtIndex || overflowAtIndex > activeTabIndex
	    };
	  };
	
	  Tabs.prototype.render = function render() {
	    var _this2 = this;
	
	    var _state = this.state,
	        indicatorOffset = _state.indicatorOffset,
	        indicatorWidth = _state.indicatorWidth,
	        indicatorVisible = _state.indicatorVisible,
	        overflowIndex = _state.overflowIndex,
	        overflowAtIndex = _state.overflowAtIndex,
	        paddingLeft = _state.paddingLeft;
	
	    var _props = this.props,
	        Component = _props.component,
	        style = _props.style,
	        className = _props.className,
	        activeTabClassName = _props.activeTabClassName,
	        inactiveTabClassName = _props.inactiveTabClassName,
	        colored = _props.colored,
	        centered = _props.centered,
	        tabId = _props.tabId,
	        overflowMenu = _props.overflowMenu,
	        overflowMenuLabel = _props.overflowMenuLabel,
	        nextIcon = _props.nextIcon,
	        previousIcon = _props.previousIcon,
	        overflowMenuIcon = _props.overflowMenuIcon,
	        overflowMenuIconChildren = _props.overflowMenuIconChildren,
	        overflowMenuIconClassName = _props.overflowMenuIconClassName,
	        nextIconChildren = _props.nextIconChildren,
	        nextIconClassName = _props.nextIconClassName,
	        previousIconChildren = _props.previousIconChildren,
	        previousIconClassName = _props.previousIconClassName,
	        propActiveIndex = _props.activeTabIndex,
	        defaultTabIndex = _props.defaultTabIndex,
	        onTabChange = _props.onTabChange,
	        alignToKeyline = _props.alignToKeyline,
	        mobile = _props.mobile,
	        defaultMedia = _props.defaultMedia,
	        desktopMinWidth = _props.desktopMinWidth,
	        props = _objectWithoutProperties(_props, ['component', 'style', 'className', 'activeTabClassName', 'inactiveTabClassName', 'colored', 'centered', 'tabId', 'overflowMenu', 'overflowMenuLabel', 'nextIcon', 'previousIcon', 'overflowMenuIcon', 'overflowMenuIconChildren', 'overflowMenuIconClassName', 'nextIconChildren', 'nextIconClassName', 'previousIconChildren', 'previousIconClassName', 'activeTabIndex', 'defaultTabIndex', 'onTabChange', 'alignToKeyline', 'mobile', 'defaultMedia', 'desktopMinWidth']);
	
	    var activeTabIndex = (0, _getField2.default)(this.props, this.state, 'activeTabIndex');
	
	    var icon = false;
	    var children = _react.Children.map(_react.Children.toArray(this.props.children), function (tab, index) {
	      var handleOnClick = function handleOnClick(tabIndex, id, tabControlsId, tabChildren, event) {
	        if (tab.props.onClick) {
	          tab.props.onClick(tabId, id, tabControlsId, tabChildren, event);
	        }
	
	        _this2._handleTabChange(tabIndex, id, tabControlsId, tabChildren, event);
	      };
	
	      if (tab.props.icon) {
	        icon = true;
	      }
	
	      return (0, _react.cloneElement)(tab, {
	        index: index,
	        activeClassName: activeTabClassName,
	        inactiveClassName: inactiveTabClassName,
	        id: tab.props.id || tabId + '-' + index,
	        controlsId: tab.props.controlsId || tabId + '-panel-' + index,
	        active: index === activeTabIndex,
	        onClick: handleOnClick
	      });
	    });
	
	    var overflow = void 0;
	    var nextControl = void 0;
	    var previousControl = void 0;
	    if (overflowAtIndex) {
	      var length = children.length;
	      if (overflowMenu) {
	        overflow = _react2.default.createElement(_MenuTab2.default, {
	          id: tabId + '-overflow-menu',
	          activeTabIndex: activeTabIndex,
	          overflowAtIndex: overflowAtIndex,
	          label: _react2.default.createElement(
	            _IconSeparator2.default,
	            { label: overflowMenuLabel },
	            (0, _getDeprecatedIcon2.default)(overflowMenuIconClassName, overflowMenuIconChildren, overflowMenuIcon)
	          ),
	          tabs: children.slice(overflowAtIndex, children.length).map(this._mapToOverflowTabProps)
	        });
	      }
	
	      children = children.slice(overflowIndex, overflowAtIndex);
	
	      if (!overflowMenu && overflowIndex > 0) {
	        previousControl = _react2.default.createElement(_TabOverflowButton2.default, {
	          left: true,
	          icon: icon,
	          iconEl: (0, _getDeprecatedIcon2.default)(previousIconClassName, previousIconChildren, previousIcon),
	          onClick: this._showPreviousTabs
	        });
	      }
	
	      if (!overflowMenu && length > 3 && overflowAtIndex + overflowIndex <= length) {
	        nextControl = _react2.default.createElement(_TabOverflowButton2.default, {
	          icon: icon,
	          onClick: this._showNextTabs,
	          iconEl: (0, _getDeprecatedIcon2.default)(nextIconClassName, nextIconChildren, nextIcon)
	        });
	      }
	    }
	
	    return _react2.default.createElement(
	      Component,
	      _extends({}, props, {
	        style: _extends({}, style, { paddingLeft: paddingLeft }),
	        className: (0, _classnames2.default)('md-tabs', {
	          'md-tabs--pagination': overflowAtIndex && !overflowMenu,
	          'md-tabs--centered': centered,
	          'md-background--primary': colored
	        }, className),
	        role: 'tablist'
	      }),
	      _react2.default.createElement(_ResizeObserver2.default, { watchWidth: true, watchHeight: true, onResize: this._positionElements, elRef: this._setContainer }),
	      previousControl,
	      children,
	      nextControl,
	      overflow,
	      _react2.default.createElement(_TabIndicator2.default, { offset: indicatorOffset, width: indicatorWidth, visible: indicatorVisible })
	    );
	  };
	
	  return Tabs;
	}(_react.PureComponent);
	
	Tabs.propTypes = {
	  /**
	   * A base id to use for each `Tab`. When the child tabs are created, they are cloned
	   * with some additional accessibility props. Each tab will get a prop with this and the
	   * current index of the tab.
	   */
	  tabId: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * The className to use when a tab is currently active. The default className does not
	   * actually apply any styles.
	   *
	   * If this prop is set, it will override any `activeClassName` props applied to the child
	   * `Tab`s. Either set a custom `activeClassName` on each `Tab`, or use this prop to apply
	   * the same `activeClassName` to each `Tab`.
	   *
	   * @see {@link Tabs/Tab#activeClassName}
	   */
	  activeTabClassName: _propTypes2.default.string,
	
	  /**
	   * The className to use when the tab is not active and not selected. By default,
	   * this will set inactive tabs' color to `$md-white-base`. This works great
	   * if the tabs are placed on a colored toolbar but fails when the tabs are not colored
	   * or on a white background. In these cases, it is recommended to change this value
	   * to `md-text--secondary` or some other class name.
	   *
	   * If this prop is set, it will override any `inactiveClassName` props applied to the child
	   * `Tab`s. Either set a custom `inactiveClassName` on each `Tab`, or use this prop to apply
	   * the same `inactiveClassName` to each `Tab`.
	   *
	   * @see {@link Tabs/Tab#inactiveClassName}
	   */
	  inactiveTabClassName: _propTypes2.default.string,
	
	  /**
	   * The component to render the tabs in.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * This should either be a single `Tab` component or a list of `Tab` components. Unfortunately,
	   * the child *must* be exactly a `Tab` component because this is unable to extract the correct
	   * `label` and `children` from a custom `Tab` component.
	   */
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)]).isRequired,
	
	  /**
	   * Boolean if the tabs should be centered instead of aligned to the keyline. The tabs will
	   * only be aligned to the keyline when there are more than 3 tabs and the `alignToKeyline`
	   * prop is `false`.
	   */
	  centered: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the tabs should align to a toolbar's title keyline. If this is undefined,
	   * the tabs will try to align to the keyline when there are more than 3 tabs.
	   */
	  alignToKeyline: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the tabs should be colored with the primary color. If this is false or undefined,
	   * the tabs will be colored for the light or dark theme.
	   */
	  colored: _propTypes2.default.bool,
	
	  /**
	   * A boolean if the overflow tabs on desktop displays should appear in a menu. If this is false,
	   * the additional tabs will be available by using pagination buttons.
	   */
	  overflowMenu: _propTypes2.default.bool,
	
	  /**
	   * An optional function to call when the active tab is changed. The callback will include
	   * the new active tab index and a click event.
	   *
	   * ```js
	   * onTabChange(newTabIndex, event);
	   * ```
	   */
	  onTabChange: _propTypes2.default.func,
	
	  /**
	   * An optional active tab index to use. If this is defined, it will make the component controlled
	   * and require the `onTabChange` prop to be defined.
	   */
	  activeTabIndex: (0, _controlled2.default)(_propTypes2.default.number, 'onTabChange', 'defaultTabIndex'),
	
	  /**
	   * The default tab index to use when the component is uncontrolled.
	   */
	  defaultTabIndex: _propTypes2.default.number.isRequired,
	
	  /**
	   * When the `overflowMenu` prop is false, this will be used to render the "next slice of tabs"
	   * when there are too many tabs to display at once on desktop screens.
	   */
	  nextIcon: _propTypes2.default.element,
	
	  /**
	   * When the `overflowMenu` prop is false, this will be used to render the "previous slice of tabs"
	   * when there are too many tabs to display at once on desktop screens.
	   */
	  previousIcon: _propTypes2.default.element,
	
	  /**
	   * When the `overflowMenu` prop is true, this will be used to render the `MenuTab` overflow menu.
	   * This will be to render the icon to the right of the label.
	   */
	  overflowMenuIcon: _propTypes2.default.element,
	
	  /**
	   * When the `overflowMenu` prop is true, this will be used to render the `MenuTab` overflow menu.
	   * This will be the text that displays as a tab.
	   */
	  overflowMenuLabel: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the tabs are currently rendered on a mobile or tablet device. This is used to calculate
	   * overflow/padding on the tabs.
	   */
	  mobile: _propTypes2.default.bool,
	  defaultMedia: (0, _deprecated2.default)(_propTypes2.default.oneOf(['mobile', 'tablet', 'desktop']), 'Use `mobile` instead'),
	  desktopMinWidth: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `mobile` instead'),
	  nextIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `nextIcon` prop instead'),
	  nextIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `nextIcon` prop instead'),
	  previousIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `previousIcon` prop instead'),
	  previousIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `previousIcon` prop instead'),
	  overflowMenuIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `overflowMenuIcon` prop instead'),
	  overflowMenuIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `overflowMenuIcon` prop instead')
	};
	Tabs.defaultProps = {
	  component: 'ul',
	  defaultTabIndex: 0,
	  nextIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'keyboard_arrow_right'
	  ),
	  previousIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'keyboard_arrow_left'
	  ),
	  overflowMenuLabel: 'More',
	  overflowMenuIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'arrow_drop_down'
	  )
	};
	exports.default = Tabs;

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(7);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSwipeableViews = __webpack_require__(992);
	
	var _reactSwipeableViews2 = _interopRequireDefault(_reactSwipeableViews);
	
	var _getField = __webpack_require__(8);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _controlled = __webpack_require__(15);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _between = __webpack_require__(91);
	
	var _between2 = _interopRequireDefault(_between);
	
	var _ResizeObserver = __webpack_require__(35);
	
	var _ResizeObserver2 = _interopRequireDefault(_ResizeObserver);
	
	var _Paper = __webpack_require__(37);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _TabPanel = __webpack_require__(341);
	
	var _TabPanel2 = _interopRequireDefault(_TabPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `TabsContainer` component is used when you want to have your `Tabs` connected with
	 * the `SwipeableViews`. This component will traverse the children subtree and extract out
	 * the `children` from each tab, and render them in a swipeable container. However,
	 * since this is using the `React.Children` traversal, You will have to keep the `Tabs`
	 * and `Tab` component as a direct descendent. You are unable to make a separate component
	 * that encompasses the `Tab` component.
	 *
	 * ```js
	 * // valid
	 * <TabsContainer>
	 *   <Tabs>
	 *     <Tab />
	 *   </Tabs>
	 * </TabsContainer>
	 *
	 * // invalid
	 * <TabsContainer>
	 *   <Tabs>
	 *     <MyCustomTab />
	 *   </Tabs>
	 * </TabsContainer>
	 * ```
	 *
	 * This is because it seems you are unable to access the `MyCustomTab`'s child Tab props correctly.
	 * You can however have the tab's children as a separate component if you wish.
	 */
	var TabsContainer = function (_PureComponent) {
	  _inherits(TabsContainer, _PureComponent);
	
	  function TabsContainer(props) {
	    _classCallCheck(this, TabsContainer);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));
	
	    _this._handleTabChange = function (index, tabId, tabControlsId, tabChildren, event) {
	      if (_this.props.onTabChange) {
	        _this.props.onTabChange(index, tabId, tabControlsId, tabChildren, event);
	      }
	
	      if (typeof _this.props.activeTabIndex === 'undefined') {
	        _this.setState({ activeTabIndex: index });
	      }
	    };
	
	    _this._handleSwipeChange = function (activeTabIndex) {
	      _this._handleTabChange(activeTabIndex);
	    };
	
	    _this._setContainer = function (container) {
	      _this._container = (0, _reactDom.findDOMNode)(container);
	    };
	
	    _this._resizePanel = function () {
	      if (!_this._container) {
	        return;
	      }
	
	      var activePanel = _this._container.querySelector('.md-tab-panel[aria-hidden=false]');
	      if (activePanel && _this.state.panelHeight !== activePanel.scrollHeight) {
	        _this.setState({ panelHeight: activePanel.scrollHeight });
	      }
	    };
	
	    _this.state = {};
	    if (typeof props.activeTabIndex === 'undefined') {
	      _this.state.activeTabIndex = props.defaultTabIndex;
	    }
	    return _this;
	  }
	
	  TabsContainer.prototype.componentDidMount = function componentDidMount() {
	    this._resizePanel();
	  };
	
	  TabsContainer.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    var prevIndex = (0, _getField2.default)(prevProps, prevState, 'activeTabIndex');
	    var currIndex = (0, _getField2.default)(this.props, this.state, 'activeTabIndex');
	
	    if (prevIndex !== currIndex) {
	      this._resizePanel();
	    }
	  };
	
	  TabsContainer.prototype.render = function render() {
	    var _this2 = this,
	        _baseSlideStyle;
	
	    var panelHeight = this.state.panelHeight;
	
	    var _props = this.props,
	        Component = _props.component,
	        style = _props.style,
	        className = _props.className,
	        panelStyle = _props.panelStyle,
	        panelClassName = _props.panelClassName,
	        panelComponent = _props.panelComponent,
	        headerStyle = _props.headerStyle,
	        headerClassName = _props.headerClassName,
	        slideStyle = _props.slideStyle,
	        slideHeightProp = _props.slideHeightProp,
	        swipeableViewsStyle = _props.swipeableViewsStyle,
	        swipeableViewsClassName = _props.swipeableViewsClassName,
	        headerComponent = _props.headerComponent,
	        headerZDepth = _props.headerZDepth,
	        children = _props.children,
	        colored = _props.colored,
	        fixed = _props.fixed,
	        labelAndIcon = _props.labelAndIcon,
	        swipeableViewsProps = _props.swipeableViewsProps,
	        themed = _props.themed,
	        propToolbar = _props.toolbar,
	        propActiveTabeIndex = _props.activeTabIndex,
	        onTabChange = _props.onTabChange,
	        defaultTabIndex = _props.defaultTabIndex,
	        props = _objectWithoutProperties(_props, ['component', 'style', 'className', 'panelStyle', 'panelClassName', 'panelComponent', 'headerStyle', 'headerClassName', 'slideStyle', 'slideHeightProp', 'swipeableViewsStyle', 'swipeableViewsClassName', 'headerComponent', 'headerZDepth', 'children', 'colored', 'fixed', 'labelAndIcon', 'swipeableViewsProps', 'themed', 'toolbar', 'activeTabIndex', 'onTabChange', 'defaultTabIndex']);
	
	    var toolbar = this.props.toolbar;
	
	
	    var activeTabIndex = (0, _getField2.default)(this.props, this.state, 'activeTabIndex');
	
	    var tabsEl = _react.Children.only(children);
	    var tabId = tabsEl.props.tabId;
	    var content = _react.Children.map(tabsEl.props.children, function (tab, index) {
	      if (!tab) {
	        return tab;
	      }
	
	      return _react2.default.createElement(
	        _TabPanel2.default,
	        {
	          id: tab.props.controlsId || tabId + '-panel-' + index,
	          active: activeTabIndex === index,
	          style: panelStyle,
	          className: panelClassName,
	          component: panelComponent,
	          controlledById: tab.props.id || tabId + '-' + index
	        },
	        _react2.default.createElement(_ResizeObserver2.default, { watchHeight: true, onResize: _this2._resizePanel }),
	        tab.props.children
	      );
	    });
	
	    var childrenProps = _react.Children.only(children).props;
	    var tabs = (0, _react.cloneElement)(children, {
	      colored: typeof childrenProps.colored !== 'undefined' ? childrenProps.colored : colored,
	      onTabChange: this._handleTabChange,
	      activeTabIndex: activeTabIndex
	    });
	
	    var prominentToolbar = false;
	    if (toolbar) {
	      var toolbarProps = _react.Children.only(toolbar).props;
	      toolbar = (0, _react.cloneElement)(toolbar, {
	        component: toolbarProps.component || 'div',
	        colored: typeof toolbarProps.colored !== 'undefined' ? childrenProps.colored : colored
	      });
	
	      prominentToolbar = toolbarProps.prominent || toolbarProps.prominentTitle;
	    }
	
	    var header = void 0;
	    if (fixed) {
	      header = _react2.default.createElement(
	        _Paper2.default,
	        {
	          style: headerStyle,
	          className: (0, _classnames2.default)('md-tabs-fixed-container', {
	            'md-toolbar--themed': themed
	          }, headerClassName),
	          zDepth: headerZDepth,
	          component: headerComponent
	        },
	        toolbar,
	        tabs
	      );
	    }
	
	    var baseSlideStyle = (_baseSlideStyle = {}, _baseSlideStyle[slideHeightProp] = panelHeight, _baseSlideStyle);
	
	    return _react2.default.createElement(
	      Component,
	      _extends({
	        style: style,
	        className: (0, _classnames2.default)('md-tabs-container', className)
	      }, props, {
	        ref: this._setContainer
	      }),
	      header,
	      header ? null : toolbar,
	      header ? null : tabs,
	      _react2.default.createElement(
	        _reactSwipeableViews2.default,
	        _extends({}, swipeableViewsProps, {
	          style: swipeableViewsStyle,
	          className: (0, _classnames2.default)('md-tabs-content', {
	            'md-tabs-content--offset': !toolbar && !labelAndIcon && fixed,
	            'md-tabs-content--offset-icon': !toolbar && fixed && labelAndIcon,
	            'md-tabs-content--offset-toolbar': toolbar && fixed && !prominentToolbar && !labelAndIcon,
	            'md-tabs-content--offset-toolbar-prominent': toolbar && fixed && prominentToolbar && !labelAndIcon,
	            'md-tabs-content--offset-toolbar-icon': fixed && toolbar && labelAndIcon && !prominentToolbar,
	            'md-tabs-content--offset-toolbar-prominent-icon': fixed && toolbar && labelAndIcon && prominentToolbar
	          }, swipeableViewsClassName),
	          slideStyle: _extends({}, baseSlideStyle, typeof slideStyle === 'function' ? slideStyle(baseSlideStyle, panelHeight) : slideStyle),
	          index: activeTabIndex,
	          onChangeIndex: this._handleSwipeChange
	        }),
	        content
	      )
	    );
	  };
	
	  return TabsContainer;
	}(_react.PureComponent);
	
	TabsContainer.propTypes = {
	  /**
	   * An optional style to apply to the container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to each `TabPanel` that gets generated. Each tab's children
	   * will get wrapped in a `TabPanel` component.
	   */
	  panelStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to each each `TabPanel` that gets generated. Each tab's
	   * children will get wrapped in a `TabPanel` component.
	   */
	  panelClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the header component when the tabs are fixed to the top of the page.
	   * The optional toolbar and tabs get wrapped in a `Paper` component.
	   */
	  headerStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the header component when the tabs are fixed to the top of the page.
	   * The optional toolbar and tabs get wrapped in a `Paper` component.
	   */
	  headerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the `SwipeableViews`.
	   *
	   * @see https://github.com/oliviertassinari/react-swipeable-views#user-content-swipeableviews-
	   */
	  swipeableViewsStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `SwipeableViews` container.
	   */
	  swipeableViewsClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to each slide component or a function that returns such style.
	   *
	   * Default style and height of slide component will be passed in the function.
	   * The function should return a style that will be merged with default style, or `null`.
	   *
	   * @see https://github.com/oliviertassinari/react-swipeable-views#user-content-swipeableviews-
	   */
	  slideStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
	
	  /**
	   * The property that should be used to set height of a slide component.
	   */
	  slideHeightProp: _propTypes2.default.oneOf(['height', 'minHeight', 'maxHeight']),
	
	  /**
	   * This should be a `Tabs` component with children of `Tab`. This is used to figure out which
	   * tab's content is currently visible.
	   */
	  children: _propTypes2.default.element.isRequired,
	
	  /**
	   * The component to render the container as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * The component to render each `TabPanel` as.
	   */
	  panelComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	
	  /**
	   * An optional toolbar to render above the tabs.
	   */
	  toolbar: _propTypes2.default.element,
	
	  /**
	   * An optional active tab index to use. If this is defined, the component will be controlled
	   * and require the `onTabChange` prop to be defined.
	   */
	  activeTabIndex: (0, _controlled2.default)(_propTypes2.default.number, 'onTabChange', 'defaultTabIndex'),
	
	  /**
	   * An optional function to call when a new tab is selected by swiping or clicking a tab. When
	   * a new tab has been clicked, the callback will include the active tab index, the tab's `id`,
	   * the tab's `controlsId`, the tab's `children`, and the click event.
	   *
	   * If the tab was changed by swiping, it will only contain the new active tab index.
	   *
	   * ```js
	   * onTabChange(newActiveTabIndex, tabId, tabControlsId, tabChildren, event);
	   * ```
	   */
	  onTabChange: _propTypes2.default.func,
	
	  /**
	   * The default tab index to use when the component is uncontrolled.
	   */
	  defaultTabIndex: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the `toolbar` and `Tabs` should be cloned with `colored: true`.
	   */
	  colored: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `toolbar` should be applied with the theme color. This _really_ only
	   * applies when you create a `fixed` tabs container.
	   */
	  themed: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the tabs and the optional toolbar should be fixed to the top of the page.
	   */
	  fixed: _propTypes2.default.bool,
	
	  /**
	   * A boolean if a `fixed` `TabsContainer` has tabs with a label and an icon.
	   */
	  labelAndIcon: _propTypes2.default.bool,
	
	  /**
	   * An optional component to render the fixed tabs header as.
	   */
	  headerComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	
	  /**
	   * The zDepth for the fixed tabs header.
	   */
	  headerZDepth: (0, _between2.default)(_propTypes2.default.number, 0, 5),
	
	  /**
	   * Any additional props to apply to the SwipeableViews component. View the
	   * [SwipeableViews API](https://github.com/oliviertassinari/react-swipeable-views#api)
	   * for valid attributes.
	   *
	   * You will not be able to set the `style`, `className`, `slideStyle`, `index`,
	   * or `onChangeIndex` props for the SwipeableViews.
	   *
	   * The styling and classnames can be updated with the other TabsContainer props.
	   */
	  swipeableViewsProps: _propTypes2.default.object
	};
	TabsContainer.defaultProps = {
	  component: 'section',
	  defaultTabIndex: 0,
	  headerZDepth: 1,
	  slideHeightProp: 'height'
	};
	exports.default = TabsContainer;

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(11);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _TextArea = __webpack_require__(914);
	
	var _TextArea2 = _interopRequireDefault(_TextArea);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This component either renders a base `input` tag or the `TextArea` component.
	 */
	var InputField = function (_PureComponent) {
	  _inherits(InputField, _PureComponent);
	
	  function InputField() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, InputField);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.getField = function () {
	      // eslint-disable-line arrow-body-style
	      return typeof _this.props.rows === 'undefined' ? _this._field : _this._field.getField();
	    }, _this.getValue = function () {
	      if (typeof _this.props.rows === 'undefined') {
	        return _this._field.value;
	      }
	
	      return _this._field.getValue();
	    }, _this.focus = function () {
	      _this._field.focus();
	    }, _this.blur = function () {
	      _this._field.blur();
	    }, _this._setField = function (field) {
	      _this._field = field;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  InputField.prototype.render = function render() {
	    var _cn;
	
	    var _props = this.props,
	        className = _props.className,
	        rows = _props.rows,
	        label = _props.label,
	        customSize = _props.customSize,
	        fullWidth = _props.fullWidth,
	        type = _props.type,
	        passwordVisible = _props.passwordVisible,
	        block = _props.block,
	        inlineIndicator = _props.inlineIndicator,
	        maxRows = _props.maxRows,
	        props = _objectWithoutProperties(_props, ['className', 'rows', 'label', 'customSize', 'fullWidth', 'type', 'passwordVisible', 'block', 'inlineIndicator', 'maxRows']);
	
	    var multiline = typeof rows !== 'undefined';
	    var Component = multiline ? _TextArea2.default : 'input';
	    if (!multiline) {
	      props.type = passwordVisible ? 'text' : type;
	    } else {
	      props.label = label;
	      props.block = block;
	      props.maxRows = maxRows;
	    }
	
	    return (0, _react.createElement)(Component, _extends({}, props, {
	      rows: rows,
	      ref: this._setField,
	      className: (0, _classnames2.default)('md-text-field', (_cn = {
	        'md-text-field--inline-indicator': inlineIndicator || !multiline && type === 'password',
	        'md-text-field--multiline': multiline,
	        'md-text-field--margin': !block && !multiline && !label,
	        'md-text-field--floating-margin': !block && !multiline && label
	      }, _cn['md-text-field--' + customSize] = customSize, _cn['md-full-width'] = fullWidth, _cn), (0, _themeColors2.default)({ disabled: props.disabled, text: !props.disabled }, className))
	    }));
	  };
	
	  return InputField;
	}(_react.PureComponent);
	
	InputField.propTypes = {
	  id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  type: _propTypes2.default.string,
	  placeholder: _propTypes2.default.string,
	  block: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  rows: _propTypes2.default.number,
	  maxRows: _propTypes2.default.number,
	  label: _propTypes2.default.node,
	  fullWidth: _propTypes2.default.bool,
	  customSize: _propTypes2.default.string,
	  passwordVisible: _propTypes2.default.bool,
	  inlineIndicator: _propTypes2.default.bool
	};
	exports.default = InputField;

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Message = function (_PureComponent) {
	  _inherits(Message, _PureComponent);
	
	  function Message() {
	    _classCallCheck(this, Message);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  Message.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        children = _props.children,
	        className = _props.className;
	
	
	    if (!children) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      {
	        'aria-hidden': !active,
	        className: (0, _classnames2.default)('md-text-field-message', 'md-text-field-message--' + (active ? '' : 'in') + 'active', className)
	      },
	      children
	    );
	  };
	
	  return Message;
	}(_react.PureComponent);
	
	Message.propTypes = {
	  active: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.node
	};
	exports.default = Message;

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keyCodes = __webpack_require__(14);
	
	var _themeColors = __webpack_require__(11);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PasswordButton = function (_PureComponent) {
	  _inherits(PasswordButton, _PureComponent);
	
	  function PasswordButton() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PasswordButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = { keyboardFocus: false }, _this._handleOutsideClick = function (e) {
	      if (_this._button && !_this._button.contains(e.target)) {
	        window.removeEventListener('click', _this._handleOutsideClick);
	        _this.setState({ keyboardFocus: false });
	      }
	    }, _this._handleBlur = function () {
	      if (_this.state.keyboardFocus) {
	        _this.setState({ keyboardFocus: false });
	      }
	    }, _this._handleKeyUp = function (e) {
	      var key = e.which || e.keyCode;
	      if (key === _keyCodes.TAB) {
	        _this.setState({ keyboardFocus: true });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  PasswordButton.prototype.render = function render() {
	    var keyboardFocus = this.state.keyboardFocus;
	
	    var _props = this.props,
	        active = _props.active,
	        passwordVisible = _props.passwordVisible,
	        block = _props.block,
	        floating = _props.floating,
	        icon = _props.icon,
	        props = _objectWithoutProperties(_props, ['active', 'passwordVisible', 'block', 'floating', 'icon']);
	
	    return _react2.default.createElement(
	      'button',
	      _extends({}, props, {
	        onBlur: this._handleBlur,
	        onKeyUp: this._handleKeyUp,
	        type: 'button',
	        className: (0, _classnames2.default)('md-text-field-inline-indicator md-password-btn md-pointer--hover', {
	          'md-password-btn--focus': keyboardFocus,
	          'md-password-btn--invisible': active && !passwordVisible,
	          'md-text-field-inline-indicator--floating': floating,
	          'md-text-field-inline-indicator--block': block
	        }, (0, _themeColors2.default)({ disabled: !active, hint: active }))
	      }),
	      icon
	    );
	  };
	
	  return PasswordButton;
	}(_react.PureComponent);
	
	PasswordButton.propTypes = {
	  active: _propTypes2.default.bool,
	  passwordVisible: _propTypes2.default.bool,
	  icon: _propTypes2.default.element,
	  block: _propTypes2.default.bool,
	  floating: _propTypes2.default.bool
	};
	exports.default = PasswordButton;

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ResizeObserver = __webpack_require__(35);
	
	var _ResizeObserver2 = _interopRequireDefault(_ResizeObserver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `TextArea` component is used to allow a dynamic height for the
	 * `textarea`. The height will keep on changing until the maxRows prop
	 * is met or infinitely if it does not exist, or is 0.
	 */
	var TextArea = function (_PureComponent) {
	  _inherits(TextArea, _PureComponent);
	
	  function TextArea() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TextArea);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = { height: null }, _this.getField = function () {
	      return _this._field;
	    }, _this.getValue = function () {
	      return _this._field.value;
	    }, _this.focus = function () {
	      _this._field.focus();
	    }, _this.blur = function () {
	      _this._field.blur();
	    }, _this._calcRowHeight = function () {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props,
	          rows = _ref.rows;
	
	      if (!_this._field) {
	        return 19;
	      }
	
	      var height = _this._field.style.height;
	      _this._field.style.height = 'auto';
	      var rowHeight = _this._field.offsetHeight / rows;
	      _this._field.style.height = height;
	      return rowHeight;
	    }, _this._setMask = function (mask) {
	      _this._mask = mask;
	    }, _this._setField = function (field) {
	      _this._field = field;
	    }, _this._handleResize = function () {
	      _this._rowHeight = _this._calcRowHeight();
	      _this._syncHeightWithMask();
	    }, _this._syncHeightWithMask = function (value) {
	      // The mask is always null in snapshot teseting
	      if (!_this._mask) {
	        return;
	      }
	
	      if (value !== undefined) {
	        _this._mask.value = value;
	      }
	
	      var height = _this._mask.scrollHeight;
	      if (height === undefined) {
	        return;
	      }
	
	      var _this$props = _this.props,
	          rows = _this$props.rows,
	          maxRows = _this$props.maxRows;
	
	      if (maxRows && maxRows > 0) {
	        height = Math.min(height, _this._rowHeight * maxRows);
	      }
	
	      height = Math.max(_this._rowHeight * rows, height);
	      _this.setState({ height: height });
	    }, _this._handleChange = function (e) {
	      _this._syncHeightWithMask(e.target.value, e);
	
	      if (_this.props.onChange) {
	        _this.props.onChange(e);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  TextArea.prototype.componentDidMount = function componentDidMount() {
	    this._rowHeight = this._calcRowHeight();
	    this._syncHeightWithMask();
	  };
	
	  TextArea.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.rows !== nextProps.rows) {
	      this._rowHeight = this._calcRowHeight(nextProps);
	    }
	
	    if (this.props.value !== nextProps.value || this.props.maxRows !== nextProps.maxRows) {
	      this._syncHeightWithMask(nextProps.value);
	    }
	  };
	
	  TextArea.prototype.render = function render() {
	    var height = this.state.height;
	
	    var _props = this.props,
	        style = _props.style,
	        defaultValue = _props.defaultValue,
	        value = _props.value,
	        className = _props.className,
	        label = _props.label,
	        block = _props.block,
	        maxRows = _props.maxRows,
	        onChange = _props.onChange,
	        props = _objectWithoutProperties(_props, ['style', 'defaultValue', 'value', 'className', 'label', 'block', 'maxRows', 'onChange']);
	
	    return _react2.default.createElement(
	      'div',
	      {
	        style: { height: height && height + 5 },
	        className: (0, _classnames2.default)('md-text-field-multiline-container', {
	          'md-text-field--margin': !label && !block,
	          'md-text-field--floating-margin': label && !block
	        })
	      },
	      _react2.default.createElement(_ResizeObserver2.default, { watchWidth: true, onResize: this._handleResize }),
	      _react2.default.createElement('textarea', {
	        ref: this._setMask,
	        className: (0, _classnames2.default)(className, 'md-text-field--multiline-mask'),
	        readOnly: true,
	        rows: props.rows,
	        tabIndex: -1,
	        style: style,
	        defaultValue: defaultValue,
	        'aria-hidden': true,
	        value: value
	      }),
	      _react2.default.createElement('textarea', _extends({}, props, {
	        ref: this._setField,
	        style: Object.assign({}, style, { height: height }),
	        className: className,
	        defaultValue: defaultValue,
	        value: value,
	        onChange: this._handleChange
	      }))
	    );
	  };
	
	  return TextArea;
	}(_react.PureComponent);
	
	TextArea.propTypes = {
	  id: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  rows: _propTypes2.default.number.isRequired,
	  maxRows: _propTypes2.default.number,
	  onChange: _propTypes2.default.func,
	  defaultValue: _propTypes2.default.string,
	  floatingLabel: _propTypes2.default.bool,
	  value: _propTypes2.default.string,
	  block: _propTypes2.default.bool,
	  label: _propTypes2.default.node
	};
	exports.default = TextArea;

/***/ }),
/* 915 */,
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Tooltipped;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TooltipContainer = __webpack_require__(345);
	
	var _TooltipContainer2 = _interopRequireDefault(_TooltipContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * Adds a tooltip for a component/element given as the only child.
	 *
	 * The component should render its children, or the tooltip will not be shown.
	 * Also the component should be positioned by `className` or `style`
	 * (CSS property `position` should have value `relative`, `absolute` or `fixed`),
	 * or the tooltip can appear incorrectly.
	 * Use `setPosition={true}` to automatically add `position: 'relative'` to the `style` of the wrapped component.
	 *
	 * Besides of `children` and `setPosition` all props set for `Tooltipped` component are passed through
	 * to `TooltipContainer` that is added as a child of the wrapped component and controls the tooltip.
	 *
	 * ```js
	 * <Tooltipped
	 *   label="Tooltip for text"
	 *   position="left"
	 *   delay={1000}
	 * >
	 *   <span style={{position: 'absolute', top: '10px', left: '70%'}}>
	 *     Some text
	 *     <div>Another line of text</div>
	 *   </span>
	 * </Tooltipped>
	 * ```
	 *
	 * ```js
	 * <Tooltipped
	 *   setPosition={true}
	 *   label="Avatar's tooltip"
	 *   position="top"
	 * >
	 *   <span style={{marginLeft: '30px'}}>
	 *       <Avatar random>T</Avatar>
	 *   </span>
	 * </Tooltipped>
	 * ```
	 */
	function Tooltipped(_ref) {
	  var children = _ref.children,
	      setPosition = _ref.setPosition,
	      props = _objectWithoutProperties(_ref, ['children', 'setPosition']);
	
	  var target = _react2.default.Children.only(children);
	  var targetProps = target.props;
	
	  if (props.label) {
	    var clonedProps = targetProps;
	    if (setPosition) {
	      clonedProps = _extends({}, clonedProps, {
	        style: _extends({}, clonedProps.style, { position: 'relative' })
	      });
	    }
	
	    target = _react2.default.cloneElement(target, clonedProps, [targetProps.children, _react2.default.createElement(_TooltipContainer2.default, _extends({ key: 'tooltipContainer' }, props))]);
	  }
	
	  return target;
	}
	
	Tooltipped.displayName = 'Tooltipped';
	
	Tooltipped.propTypes = {
	  /**
	   * A component/element the tooltip should be linked to.
	   */
	  children: _propTypes2.default.element.isRequired,
	  /**
	   * Tooltip's content.
	   */
	  label: _propTypes2.default.node,
	  /**
	   * Whether `position: relative` should be added to the `style` property of the wrapped component.
	   */
	  setPosition: _propTypes2.default.bool
	};

/***/ }),
/* 917 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = '1.4.2';

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.bem = exports.Version = exports.Tooltipped = exports.injectTooltip = exports.Toolbar = exports.TextField = exports.TabPanel = exports.MenuTab = exports.Tab = exports.Tabs = exports.TabsContainer = exports.Subheader = exports.SVGIcon = exports.Snackbar = exports.Slider = exports.SelectField = exports.Switch = exports.Radio = exports.Checkbox = exports.SelectionControlGroup = exports.SelectionControl = exports.LinearProgress = exports.CircularProgress = exports.TimePicker = exports.DatePicker = exports.Paper = exports.NavigationDrawer = exports.MenuButton = exports.DropdownMenu = exports.Menu = exports.MediaOverlay = exports.Media = exports.ListItemControl = exports.ListItem = exports.List = exports.injectInk = exports.ResizeObserver = exports.Portal = exports.IconSeparator = exports.Layover = exports.FocusContainer = exports.Collapse = exports.AccessibleFakeInkedButton = exports.AccessibleFakeButton = exports.GridList = exports.Cell = exports.Grid = exports.FontIcon = exports.FileUpload = exports.FileInput = exports.ExpansionList = exports.ExpansionPanel = exports.Drawer = exports.Divider = exports.Dialog = exports.DialogContainer = exports.TableCardHeader = exports.DropdownMenuColumn = exports.MenuButtonColumn = exports.SelectFieldColumn = exports.EditDialogColumn = exports.TablePagination = exports.TableColumn = exports.TableRow = exports.TableFooter = exports.TableBody = exports.TableHeader = exports.DataTable = exports.Chip = exports.CardText = exports.CardTitle = exports.CardActions = exports.Card = exports.Button = exports.BottomNavigation = exports.Badge = exports.Avatar = exports.Autocomplete = undefined;
	
	var _Autocomplete2 = __webpack_require__(836);
	
	var _Autocomplete3 = _interopRequireDefault(_Autocomplete2);
	
	var _Avatar2 = __webpack_require__(327);
	
	var _Avatar3 = _interopRequireDefault(_Avatar2);
	
	var _Badge2 = __webpack_require__(837);
	
	var _Badge3 = _interopRequireDefault(_Badge2);
	
	var _BottomNavigation2 = __webpack_require__(839);
	
	var _BottomNavigation3 = _interopRequireDefault(_BottomNavigation2);
	
	var _Button2 = __webpack_require__(18);
	
	var _Button3 = _interopRequireDefault(_Button2);
	
	var _Card2 = __webpack_require__(68);
	
	var _Card3 = _interopRequireDefault(_Card2);
	
	var _CardActions2 = __webpack_require__(162);
	
	var _CardActions3 = _interopRequireDefault(_CardActions2);
	
	var _CardTitle2 = __webpack_require__(53);
	
	var _CardTitle3 = _interopRequireDefault(_CardTitle2);
	
	var _CardText2 = __webpack_require__(52);
	
	var _CardText3 = _interopRequireDefault(_CardText2);
	
	var _Chip2 = __webpack_require__(332);
	
	var _Chip3 = _interopRequireDefault(_Chip2);
	
	var _DataTable2 = __webpack_require__(847);
	
	var _DataTable3 = _interopRequireDefault(_DataTable2);
	
	var _TableHeader2 = __webpack_require__(856);
	
	var _TableHeader3 = _interopRequireDefault(_TableHeader2);
	
	var _TableBody2 = __webpack_require__(853);
	
	var _TableBody3 = _interopRequireDefault(_TableBody2);
	
	var _TableFooter2 = __webpack_require__(333);
	
	var _TableFooter3 = _interopRequireDefault(_TableFooter2);
	
	var _TableRow2 = __webpack_require__(858);
	
	var _TableRow3 = _interopRequireDefault(_TableRow2);
	
	var _TableColumn2 = __webpack_require__(82);
	
	var _TableColumn3 = _interopRequireDefault(_TableColumn2);
	
	var _TablePagination2 = __webpack_require__(857);
	
	var _TablePagination3 = _interopRequireDefault(_TablePagination2);
	
	var _EditDialogColumn2 = __webpack_require__(850);
	
	var _EditDialogColumn3 = _interopRequireDefault(_EditDialogColumn2);
	
	var _SelectFieldColumn2 = __webpack_require__(852);
	
	var _SelectFieldColumn3 = _interopRequireDefault(_SelectFieldColumn2);
	
	var _MenuButtonColumn2 = __webpack_require__(851);
	
	var _MenuButtonColumn3 = _interopRequireDefault(_MenuButtonColumn2);
	
	var _DropdownMenuColumn2 = __webpack_require__(848);
	
	var _DropdownMenuColumn3 = _interopRequireDefault(_DropdownMenuColumn2);
	
	var _TableCardHeader2 = __webpack_require__(854);
	
	var _TableCardHeader3 = _interopRequireDefault(_TableCardHeader2);
	
	var _DialogContainer2 = __webpack_require__(235);
	
	var _DialogContainer3 = _interopRequireDefault(_DialogContainer2);
	
	var _Dialog2 = __webpack_require__(234);
	
	var _Dialog3 = _interopRequireDefault(_Dialog2);
	
	var _Divider2 = __webpack_require__(69);
	
	var _Divider3 = _interopRequireDefault(_Divider2);
	
	var _Drawer2 = __webpack_require__(166);
	
	var _Drawer3 = _interopRequireDefault(_Drawer2);
	
	var _ExpansionPanel2 = __webpack_require__(863);
	
	var _ExpansionPanel3 = _interopRequireDefault(_ExpansionPanel2);
	
	var _ExpansionList2 = __webpack_require__(862);
	
	var _ExpansionList3 = _interopRequireDefault(_ExpansionList2);
	
	var _FileInput2 = __webpack_require__(335);
	
	var _FileInput3 = _interopRequireDefault(_FileInput2);
	
	var _FileUpload2 = __webpack_require__(865);
	
	var _FileUpload3 = _interopRequireDefault(_FileUpload2);
	
	var _FontIcon2 = __webpack_require__(12);
	
	var _FontIcon3 = _interopRequireDefault(_FontIcon2);
	
	var _Grid2 = __webpack_require__(337);
	
	var _Grid3 = _interopRequireDefault(_Grid2);
	
	var _Cell2 = __webpack_require__(336);
	
	var _Cell3 = _interopRequireDefault(_Cell2);
	
	var _GridList2 = __webpack_require__(866);
	
	var _GridList3 = _interopRequireDefault(_GridList2);
	
	var _AccessibleFakeButton2 = __webpack_require__(70);
	
	var _AccessibleFakeButton3 = _interopRequireDefault(_AccessibleFakeButton2);
	
	var _AccessibleFakeInkedButton2 = __webpack_require__(24);
	
	var _AccessibleFakeInkedButton3 = _interopRequireDefault(_AccessibleFakeInkedButton2);
	
	var _Collapse2 = __webpack_require__(55);
	
	var _Collapse3 = _interopRequireDefault(_Collapse2);
	
	var _FocusContainer2 = __webpack_require__(338);
	
	var _FocusContainer3 = _interopRequireDefault(_FocusContainer2);
	
	var _Layover2 = __webpack_require__(84);
	
	var _Layover3 = _interopRequireDefault(_Layover2);
	
	var _IconSeparator2 = __webpack_require__(83);
	
	var _IconSeparator3 = _interopRequireDefault(_IconSeparator2);
	
	var _Portal2 = __webpack_require__(34);
	
	var _Portal3 = _interopRequireDefault(_Portal2);
	
	var _ResizeObserver2 = __webpack_require__(35);
	
	var _ResizeObserver3 = _interopRequireDefault(_ResizeObserver2);
	
	var _injectInk2 = __webpack_require__(167);
	
	var _injectInk3 = _interopRequireDefault(_injectInk2);
	
	var _List2 = __webpack_require__(41);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _ListItem2 = __webpack_require__(85);
	
	var _ListItem3 = _interopRequireDefault(_ListItem2);
	
	var _ListItemControl2 = __webpack_require__(870);
	
	var _ListItemControl3 = _interopRequireDefault(_ListItemControl2);
	
	var _Media2 = __webpack_require__(120);
	
	var _Media3 = _interopRequireDefault(_Media2);
	
	var _MediaOverlay2 = __webpack_require__(121);
	
	var _MediaOverlay3 = _interopRequireDefault(_MediaOverlay2);
	
	var _Menu2 = __webpack_require__(56);
	
	var _Menu3 = _interopRequireDefault(_Menu2);
	
	var _DropdownMenu2 = __webpack_require__(237);
	
	var _DropdownMenu3 = _interopRequireDefault(_DropdownMenu2);
	
	var _MenuButton2 = __webpack_require__(339);
	
	var _MenuButton3 = _interopRequireDefault(_MenuButton2);
	
	var _NavigationDrawer2 = __webpack_require__(239);
	
	var _NavigationDrawer3 = _interopRequireDefault(_NavigationDrawer2);
	
	var _Paper2 = __webpack_require__(37);
	
	var _Paper3 = _interopRequireDefault(_Paper2);
	
	var _DatePickerContainer = __webpack_require__(880);
	
	var _DatePickerContainer2 = _interopRequireDefault(_DatePickerContainer);
	
	var _TimePickerContainer = __webpack_require__(884);
	
	var _TimePickerContainer2 = _interopRequireDefault(_TimePickerContainer);
	
	var _CircularProgress2 = __webpack_require__(888);
	
	var _CircularProgress3 = _interopRequireDefault(_CircularProgress2);
	
	var _LinearProgress2 = __webpack_require__(889);
	
	var _LinearProgress3 = _interopRequireDefault(_LinearProgress2);
	
	var _SelectionControl2 = __webpack_require__(87);
	
	var _SelectionControl3 = _interopRequireDefault(_SelectionControl2);
	
	var _SelectionControlGroup2 = __webpack_require__(894);
	
	var _SelectionControlGroup3 = _interopRequireDefault(_SelectionControlGroup2);
	
	var _Checkbox2 = __webpack_require__(892);
	
	var _Checkbox3 = _interopRequireDefault(_Checkbox2);
	
	var _Radio2 = __webpack_require__(893);
	
	var _Radio3 = _interopRequireDefault(_Radio2);
	
	var _Switch2 = __webpack_require__(895);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _SelectField2 = __webpack_require__(241);
	
	var _SelectField3 = _interopRequireDefault(_SelectField2);
	
	var _Slider2 = __webpack_require__(899);
	
	var _Slider3 = _interopRequireDefault(_Slider2);
	
	var _SnackbarContainer = __webpack_require__(242);
	
	var _SnackbarContainer2 = _interopRequireDefault(_SnackbarContainer);
	
	var _SVGIcon2 = __webpack_require__(123);
	
	var _SVGIcon3 = _interopRequireDefault(_SVGIcon2);
	
	var _Subheader2 = __webpack_require__(88);
	
	var _Subheader3 = _interopRequireDefault(_Subheader2);
	
	var _TabsContainer2 = __webpack_require__(910);
	
	var _TabsContainer3 = _interopRequireDefault(_TabsContainer2);
	
	var _Tabs2 = __webpack_require__(909);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	var _Tab2 = __webpack_require__(906);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	var _MenuTab2 = __webpack_require__(340);
	
	var _MenuTab3 = _interopRequireDefault(_MenuTab2);
	
	var _TabPanel2 = __webpack_require__(341);
	
	var _TabPanel3 = _interopRequireDefault(_TabPanel2);
	
	var _TextField2 = __webpack_require__(89);
	
	var _TextField3 = _interopRequireDefault(_TextField2);
	
	var _Toolbar2 = __webpack_require__(172);
	
	var _Toolbar3 = _interopRequireDefault(_Toolbar2);
	
	var _injectTooltip2 = __webpack_require__(173);
	
	var _injectTooltip3 = _interopRequireDefault(_injectTooltip2);
	
	var _Tooltipped2 = __webpack_require__(916);
	
	var _Tooltipped3 = _interopRequireDefault(_Tooltipped2);
	
	var _Version2 = __webpack_require__(917);
	
	var _Version3 = _interopRequireDefault(_Version2);
	
	var _bem2 = __webpack_require__(251);
	
	var _bem3 = _interopRequireDefault(_bem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Autocomplete = _Autocomplete3.default;
	exports.Avatar = _Avatar3.default;
	exports.Badge = _Badge3.default;
	exports.BottomNavigation = _BottomNavigation3.default;
	exports.Button = _Button3.default;
	exports.Card = _Card3.default;
	exports.CardActions = _CardActions3.default;
	exports.CardTitle = _CardTitle3.default;
	exports.CardText = _CardText3.default;
	exports.Chip = _Chip3.default;
	exports.DataTable = _DataTable3.default;
	exports.TableHeader = _TableHeader3.default;
	exports.TableBody = _TableBody3.default;
	exports.TableFooter = _TableFooter3.default;
	exports.TableRow = _TableRow3.default;
	exports.TableColumn = _TableColumn3.default;
	exports.TablePagination = _TablePagination3.default;
	exports.EditDialogColumn = _EditDialogColumn3.default;
	exports.SelectFieldColumn = _SelectFieldColumn3.default;
	exports.MenuButtonColumn = _MenuButtonColumn3.default;
	exports.DropdownMenuColumn = _DropdownMenuColumn3.default;
	exports.TableCardHeader = _TableCardHeader3.default;
	exports.DialogContainer = _DialogContainer3.default;
	exports.Dialog = _Dialog3.default;
	exports.Divider = _Divider3.default;
	exports.Drawer = _Drawer3.default;
	exports.ExpansionPanel = _ExpansionPanel3.default;
	exports.ExpansionList = _ExpansionList3.default;
	exports.FileInput = _FileInput3.default;
	exports.FileUpload = _FileUpload3.default;
	exports.FontIcon = _FontIcon3.default;
	exports.Grid = _Grid3.default;
	exports.Cell = _Cell3.default;
	exports.GridList = _GridList3.default;
	exports.AccessibleFakeButton = _AccessibleFakeButton3.default;
	exports.AccessibleFakeInkedButton = _AccessibleFakeInkedButton3.default;
	exports.Collapse = _Collapse3.default;
	exports.FocusContainer = _FocusContainer3.default;
	exports.Layover = _Layover3.default;
	exports.IconSeparator = _IconSeparator3.default;
	exports.Portal = _Portal3.default;
	exports.ResizeObserver = _ResizeObserver3.default;
	exports.injectInk = _injectInk3.default;
	exports.List = _List3.default;
	exports.ListItem = _ListItem3.default;
	exports.ListItemControl = _ListItemControl3.default;
	exports.Media = _Media3.default;
	exports.MediaOverlay = _MediaOverlay3.default;
	exports.Menu = _Menu3.default;
	exports.DropdownMenu = _DropdownMenu3.default;
	exports.MenuButton = _MenuButton3.default;
	exports.NavigationDrawer = _NavigationDrawer3.default;
	exports.Paper = _Paper3.default;
	exports.DatePicker = _DatePickerContainer2.default;
	exports.TimePicker = _TimePickerContainer2.default;
	exports.CircularProgress = _CircularProgress3.default;
	exports.LinearProgress = _LinearProgress3.default;
	exports.SelectionControl = _SelectionControl3.default;
	exports.SelectionControlGroup = _SelectionControlGroup3.default;
	exports.Checkbox = _Checkbox3.default;
	exports.Radio = _Radio3.default;
	exports.Switch = _Switch3.default;
	exports.SelectField = _SelectField3.default;
	exports.Slider = _Slider3.default;
	exports.Snackbar = _SnackbarContainer2.default;
	exports.SVGIcon = _SVGIcon3.default;
	exports.Subheader = _Subheader3.default;
	exports.TabsContainer = _TabsContainer3.default;
	exports.Tabs = _Tabs3.default;
	exports.Tab = _Tab3.default;
	exports.MenuTab = _MenuTab3.default;
	exports.TabPanel = _TabPanel3.default;
	exports.TextField = _TextField3.default;
	exports.Toolbar = _Toolbar3.default;
	exports.injectTooltip = _injectTooltip3.default;
	exports.Tooltipped = _Tooltipped3.default;
	exports.Version = _Version3.default;
	exports.bem = _bem3.default;

/***/ }),
/* 919 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = addHours;
	/** @module utils/DateUtils/addHours */
	
	/**
	 * Adds hours to a date.
	 *
	 * @param {Date} time the time to increment
	 * @param {number} hours the number of hours to increment by.
	 * @return a new Date with the new hours set.
	 */
	function addHours(time, hours) {
	  var t = new Date(time.getTime());
	  t.setHours(t.getHours() + hours);
	  return t;
	}

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = extractTimeParts;
	
	var _formatTime = __webpack_require__(347);
	
	var _formatTime2 = _interopRequireDefault(_formatTime);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Extracts the hours, minutes, and optional time period from
	 * a date time.
	 *
	 * @param {function} DateTimeFormat the DateTimeFormat function to use.
	 * @param {string|string[]} locales the locales to use.
	 * @param {Boolean} showSeconds boolean if seconds should be extracted
	 * @param {Date} time the time to extract from.
	 * @return {Object} an object of { hours, minutes, timePeriod }
	 */
	function extractTimeParts(DateTimeFormat, locales, showSeconds, time) {
	  var hours = void 0;
	  var minutes = void 0;
	  var seconds = void 0;
	  var minuteSeparator = void 0;
	  var secondSeparator = void 0;
	  var remaining = void 0;
	  var formatted = (0, _formatTime2.default)(DateTimeFormat, locales, showSeconds, time);
	  // IE does not like lookaheads or splitting on [^0-9]
	  // it will include the non-printable characters..
	
	  if (showSeconds === true) {
	    var _formatted$match = formatted.match(/[0-9]+/g);
	
	    hours = _formatted$match[0];
	    minutes = _formatted$match[1];
	    seconds = _formatted$match[2];
	
	    var _formatted$match2 = formatted.match(/[ ,.:A-z]+/g);
	
	    minuteSeparator = _formatted$match2[0];
	    secondSeparator = _formatted$match2[1];
	    remaining = _formatted$match2.slice(2);
	  } else {
	    var _formatted$match3 = formatted.match(/[0-9]+/g);
	
	    hours = _formatted$match3[0];
	    minutes = _formatted$match3[1];
	
	    var _formatted$match4 = formatted.match(/[ ,.:A-z]+/g);
	
	    minuteSeparator = _formatted$match4[0];
	    remaining = _formatted$match4.slice(1);
	  }
	
	  var timePeriod = void 0;
	  if (remaining && remaining.length) {
	    timePeriod = remaining.join('').trim();
	  }
	
	  if (showSeconds === true) {
	    return {
	      hours: hours,
	      minutes: minuteSeparator + minutes,
	      seconds: secondSeparator + seconds,
	      timePeriod: timePeriod
	    };
	  }
	
	  return {
	    hours: hours,
	    minutes: minuteSeparator + minutes,
	    timePeriod: timePeriod
	  };
	} /** @module utils/DateUtils/extractTimeParts */

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isValidFocusKeypress;
	
	var _keyCodes = __webpack_require__(14);
	
	/**
	 * Checks if a keydown or keyup event's key was the TAB key or any additional valid
	 * keys that were passed in.
	 *
	 * @param {Object} event - The event to check.
	 * @param {Array.<number>=} additionalKeys - An optional array of additional key codes
	 *    that are considered valid for a focus event.
	 */
	function isValidFocusKeypress(event, additionalKeys) {
	  var key = event.which || event.keyCode;
	  return key === _keyCodes.TAB || additionalKeys && additionalKeys.indexOf(key) !== -1;
	} /** @module utils/EventUtils/isValidFocusKeypress */

/***/ }),
/* 922 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = calcTimeFromPoint;
	/** @module utils/NumberUtils/calcTimeFromPoint */
	
	function isPointInCircle(cx, cy, r, x, y) {
	  var distance = Math.pow(cx - x, 2) + Math.pow(cy - y, 2);
	  return distance <= Math.pow(r, 2);
	}
	
	function toDegrees(radians) {
	  return radians * (180 / Math.PI);
	}
	
	/**
	 * Takes a point from a mouse or touch event and a center point of a circle to determine
	 * what the new time should be.
	 *
	 * If the point.y < center.y, the point is in the top half of the circle.
	 * If the point.x < center.x, the point is in the left half of the circle.
	 *
	 * @param {Object} point - The mouse or touch event's point that contains an x and y coordinate.
	 * @param {Object} center - The center point for the circle that contains an x and y coordinate.
	 * @param {Number} innerRadius - An inner radius for clocks that have 24 hour times. This is
	 *    a circle that contains hours 12-23.
	 * @param {Boolean} minutes - Boolena if the current time to be calculated is minutes instead of
	 *    hours.
	 * @param {Boolean} hour12 - Boolean if the clock is a 12 hour clock.
	 * @return {Number} the new time.
	 */
	function calcTimeFromPoint(point, center, innerRadius, minutes, hour12) {
	  var x = point.x - center.x;
	  var y = point.y - center.y;
	  var degrees = toDegrees(Math.atan2(y, x));
	  var sectors = minutes ? 60 : 12;
	  var sectorSize = 360 / sectors;
	  var time = Math.round(degrees / sectorSize);
	
	  // Since the css transform has 0π at π/2 place, we need to offset the
	  // time to that location.
	  time += minutes ? 15 : 3;
	
	  // If time is still negative, it is in the top half of the circle
	  if (time < 0) {
	    time += sectors;
	  }
	
	  // Finally, if it is a 24 hour clock, need to check if the point is actually
	  // selecting hours 13 - 24 (0).
	  if (!minutes && !hour12) {
	    var isInCircle = isPointInCircle(0, 0, innerRadius, x, y);
	
	    if (time === 0 && !isInCircle || time !== 0 && isInCircle) {
	      time += 12;
	    }
	  }
	
	  return time;
	}

/***/ }),
/* 923 */,
/* 924 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = calculateValueDistance;
	/** @module utils/NumberUtils/calculateValueDistance */
	
	/**
	 * This calculates the distance from a screen x location to a position in some element
	 * by comparing the width of the element and the element's page position to the screen
	 * x position.
	 *
	 * If the distance is not _normalized_ the distance will be updated to be a percentage
	 * of the element's total width.
	 *
	 * @param {Number} x - the screen x location.
	 * @param {Number} width - the element's width
	 * @param {Number} left - the element's page x position.
	 * @param {Boolean} normalize - boolean if the distance should be a percentage.
	 *
	 * @return {Number} the distance from the element's left position to the page x
	 *    location.
	 */
	function calculateDistance(x, width, left, normalize) {
	  var distance = Math.min(width, Math.max(0, x - left));
	
	  return normalize ? distance : distance / width * 100;
	}
	
	/**
	 * This calculates the new value and distance for a slider. It will compare the page x
	 * location of a touch or mouse event to the slider's track page x position. If the
	 * final value and distance should be _normalized_, they will be updated to be rounded
	 * with the scale and steps in mind.
	 *
	 * The distance will always be contained within a percentage of 0 - 100 while the
	 * value will be contained within the min and max values.
	 *
	 * @param {Number} x - the page x location of the touch or mouse event.
	 * @param {Number} width - the slider's width
	 * @param {Number} left - the slider's left position in the page.
	 * @param {Number} scale - the total number values included in the slider.
	 * @param {Number} step - the amount to increment by.
	 * @param {Number} min - the min value for the slider.
	 * @param {Number} max - the max value for the slider.
	 * @param {Boolean} normalize - boolean if the vaue and distance should be _normalized_.
	 *
	 * @return {Object} an object with the value and distance.
	 */
	function calculateValueDistance(x, width, left, scale, step, min, max, normalize) {
	  var value = void 0;
	  var distance = calculateDistance(x, width, left, normalize);
	  if (normalize) {
	    value = Math.round(distance / (width / scale));
	    if (step < 1) {
	      var decimals = String(step).split('.')[1];
	      var corrector = typeof decimals !== 'undefined' && decimals.length > 0 ? Math.pow(10, decimals.length) : 1;
	
	      var modded = value * corrector % (step * corrector);
	      if (modded !== 0 && modded >= step / 2) {
	        value += step - modded;
	      } else if (modded !== 0) {
	        value -= modded;
	      }
	    }
	
	    distance = value / scale * 100;
	    value = value * step + min;
	  } else {
	    value = min + step * Math.round(distance / 100 * scale);
	  }
	
	  return {
	    distance: Math.max(0, Math.min(100, distance)),
	    value: Math.max(min, Math.min(max, value))
	  };
	}

/***/ }),
/* 925 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isWithinStep;
	/** @module utils/NumberUtils/isWithinStep */
	
	/**
	 * Checks if a provided value is within the current step. I don't remember the main
	 * usage for this, but it is for the Slider component.
	 *
	 * @param {number} value - the current value
	 * @param {number} step - the step value
	 * @return {Boolean} true if the vlaue is within the step
	 */
	function isWithinStep(value, step) {
	  var decimals = String(step).split('.')[1];
	  var corrector = typeof decimals !== 'undefined' && decimals.length > 0 ? Math.pow(10, decimals.length) : 1;
	
	  return value * corrector % (step * corrector) === 0;
	}

/***/ }),
/* 926 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = minMaxLoop;
	/** @module utils/NumberUtils/minMaxLoop */
	
	/**
	 * Keeps a number within the min and max values. When the number becomes less
	 * than the min, it will loop around and be the max value. When the number is
	 * greater than the max, it will loop around and be the min value.
	 *
	 * @param {Number} current - the current number
	 * @param {Number} min - the minimum number allowed
	 * @param {Number} max - the maximum number allowed
	 * @param {Boolean} increment - boolean if the value should be incremented or decremented by
	 *    1.
	 * @return {Number} the next number
	 */
	function minMaxLoop(current, min, max) {
	  var increment = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	  var next = current + (increment ? 1 : -1);
	  if (max < next) {
	    next = min;
	  } else if (next < min) {
	    next = max;
	  }
	
	  return next;
	}

/***/ }),
/* 927 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = updateUnit;
	/** @module utils/NumberUtils/updateUnit */
	
	/**
	 * Takes in a css unit (px, rem, em, etc) or a number and applies a function to the
	 * number part of the unit.
	 *
	 * If the unit was a number to start with and a `toUnit` is given, the number will
	 * be given the `toUnit`. Otherwise the number will be returned.
	 *
	 * If the unit was a string, the original units will be applied back to the updated
	 * unit's value.
	 *
	 * @param {number|String} unit - the unit to apply a function to.
	 * @param {function} fn - the function to apply to the number.
	 * @param {String=} toUnit - an optional unit to cast the updated unit to.
	 *
	 * @return {String|number} the updated unit.
	 */
	function updateUnit(unit, fn, toUnit) {
	  var updated = fn(parseInt(unit, 10));
	
	  if (typeof unit === 'number') {
	    return toUnit ? '' + updated + toUnit : updated;
	  }
	
	  return '' + updated + unit.replace(/[0-9]/g, '');
	}

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = minNumber;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Validates the a prop's value is greater than or equal to the minimum value.
	 *
	 * @param {Number} min - the minimum value for the prop.
	 * @param {Boolean} required - Boolean if the prop is required.
	 * @return {Error} an error or null.
	 */
	function minNumber(min, required) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    var validator = _propTypes2.default.number;
	    if (required) {
	      validator = validator.isRequired;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	    if (!required && !err && props[propName] < min) {
	      err = new Error('The ' + location + ' `' + propFullNameSafe + '` must be greater than or equal to the min value ' + ('`' + min + '` but received `' + props[propName] + '` for the `' + componentNameSafe + '` component.'));
	    }
	
	    return err;
	  };
	} /** @module utils/PropTypes/minNumber */

/***/ }),
/* 929 */,
/* 930 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = requiredForA11yIfNot;
	/** @module utils/PropTypes/requiredForA11yIfNot */
	
	/**
	 * This validator checks that the current prop is valid and defined ONLY if
	 * any of the `otherPropNames` are not true or defined.
	 *
	 * @param {function} validator - The React PropTypes validator to use for the given prop.
	 * @param {String[]} otherPropNames - Any other prop names to validate against.
	 * @return {Error} an error or null
	 */
	function requiredForA11yIfNot(validator) {
	  for (var _len = arguments.length, otherPropNames = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    otherPropNames[_key - 1] = arguments[_key];
	  }
	
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	    var defined = typeof props[propName] !== 'undefined';
	
	    for (var _len2 = arguments.length, args = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
	      args[_key2 - 5] = arguments[_key2];
	    }
	
	    var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	    if (!err && !defined && !otherPropNames.filter(function (pn) {
	      return !!props[pn];
	    }).length) {
	      err = new Error('The `' + propFullNameSafe + '` ' + location + ' is required to make `' + componentNameSafe + '` accessible ' + 'for users of assistive technologies such as screen readers.');
	    }
	
	    return err;
	  };
	}

/***/ }),
/* 931 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = capitalizeFirst;
	/** @module utils/StringUtils/capitlizeFirst */
	
	/**
	 * Capitalizes the first letter of a string. If the string is falsish, it will be
	 * returned as is. If the string is only one letter long, it will be capitalized;
	 *
	 * @param {String} str - The string to capitalize.
	 * @return {String} the updated string or false-ish self.
	 */
	function capitalizeFirst(str) {
	  if (!str) {
	    return str;
	  } else if (str.length === 1) {
	    return str.toUpperCase();
	  }
	
	  return "" + str.charAt(0).toUpperCase() + str.substring(1, str.length);
	}

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /** @module utils/caseInsensitiveFilter */
	
	
	exports.default = caseInsensitiveFilter;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This function does a simple ignore case search of some `filterText` for every
	 * item in a `haystack`. It will only include items that are:
	 *  - not null or undefined
	 *  - valid React Components
	 *  - a number or string that contains each letter/number in exact order ignoring case
	 *  - an object's `dataLabel` value that contains each letter/number in exact order ignoring case.
	 *
	 * Example:
	 *
	 * ```js
	 * const haystack = ['Apple', 'Banana', 'Orange'];
	 * caseInsensitiveFilter(haystack, 'An') // ['Banana', 'Orange'];
	 * caseInsensitiveFilter(haystack, 'ae') // []
	 * ```
	 *
	 * @param {Array.<string|number|Object|function>} haystack - the haystack to search
	 * @param {string} filterText - the filter text to use.
	 * @param {string=} dataLabel - the data label to use if the element is an object.
	 *
	 * @return {Array.<string|number|Object|function>} a filtered list.
	 */
	function caseInsensitiveFilter(haystack, filterText, dataLabel) {
	  var needle = filterText.toLowerCase();
	
	  return haystack.filter(function (hay) {
	    if (hay === null || typeof hay === 'undefined') {
	      return false;
	    } else if (_react2.default.isValidElement(hay)) {
	      return true;
	    }
	
	    var value = void 0;
	    switch (typeof hay === 'undefined' ? 'undefined' : _typeof(hay)) {
	      case 'string':
	      case 'number':
	        value = hay.toString();
	        break;
	      default:
	        value = hay[dataLabel];
	    }
	
	    return value && value.toLowerCase().indexOf(needle) !== -1;
	  });
	}

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = addDay;
	
	var _isValidDate = __webpack_require__(58);
	
	var _isValidDate2 = _interopRequireDefault(_isValidDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Adds the specified number of days to a provided date. If the date
	 * is null, an invalid formatted date, or not a Date instance, null
	 * will be returned instead.
	 *
	 * @param {Date} date - The date to update
	 * @param {number} amount - The number of days to add. This can be positive
	 *    or negative.
	 * @return {Date} a new date with the number of days added or null.
	 */
	function addDay(date, amount) {
	  if (!(0, _isValidDate2.default)(date)) {
	    return null;
	  }
	
	  var d = new Date(date);
	  d.setDate(d.getDate() + amount);
	  return d;
	}

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = addMonth;
	
	var _isValidDate = __webpack_require__(58);
	
	var _isValidDate2 = _interopRequireDefault(_isValidDate);
	
	var _getDaysInMonth = __webpack_require__(936);
	
	var _getDaysInMonth2 = _interopRequireDefault(_getDaysInMonth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Adds the specified number of months to a provided date. If the date
	 * is null, an invalid formatted date, or not a Date instance, null
	 * will be returned instead.
	 *
	 * When a new month is returned, it will make sure that the date matches
	 * the date in the old month if possible, if the new month does not have
	 * include the new date, the `newMonthDate` will be used instead.
	 *
	 * @param {Date} date - The date to update
	 * @param {number} amount - The number of months to add. This can be positive
	 *    or negative.
	 * @param {number=1} newMonthDate - An optional date to set in the new month
	 *    if the new month does not have the old date.
	 * @return {Date} a new date with the number of days added or null.
	 */
	function addMonth(date, amount, newMonthDate) {
	  if (!(0, _isValidDate2.default)(date)) {
	    return null;
	  } else if (amount === 0) {
	    return new Date(date);
	  }
	
	  if (!newMonthDate) {
	    // 0 is invalid for this case
	    newMonthDate = date.getDate();
	  }
	
	  var d = new Date(date);
	  d.setDate(1); // reset to first day to prevent month overflows
	  d.setMonth(d.getMonth() + amount);
	
	  if (newMonthDate !== 1 && newMonthDate <= (0, _getDaysInMonth2.default)(d)) {
	    // set the date back to the correct day if it still exists within the month
	    d.setDate(newMonthDate);
	  }
	
	  return d;
	}

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = addYear;
	
	var _isValidDate = __webpack_require__(58);
	
	var _isValidDate2 = _interopRequireDefault(_isValidDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Adds the specified number of years to a provided date. If the date
	 * is null, an invalid formatted date, or not a Date instance, null
	 * will be returned instead.
	 *
	 * @param {Date} date - The date to update
	 * @param {number} amount - The number of years to add. This can be positive
	 *    or negative.
	 * @return {Date} a new date with the number of years added or null.
	 */
	function addYear(date, amount) {
	  if (!(0, _isValidDate2.default)(date)) {
	    return null;
	  }
	
	  var d = new Date(date);
	  d.setFullYear(d.getFullYear() + amount);
	
	  return d;
	}

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getDaysInMonth;
	
	var _getLastDay = __webpack_require__(353);
	
	var _getLastDay2 = _interopRequireDefault(_getLastDay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Gets the number of days in a month for the provided date.
	 *
	 * @param {Date} date - The date to get the number of days for
	 * @return {number} the number of days in the month or -1 if it is false-ish
	 *    or an invalid date object.
	 */
	function getDaysInMonth(date) {
	  var day = (0, _getLastDay2.default)(date);
	  return day === null ? -1 : day.getDate();
	}

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isMonthBefore;
	
	var _isValidDate = __webpack_require__(58);
	
	var _isValidDate2 = _interopRequireDefault(_isValidDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Checks if a date is the month before another date without time
	 *
	 * @param {Date} date the date to check if it is before the other
	 * @param {Date} toCompare the date to compare to
	 * @return true if the date is before the other date's first day of month.
	 */
	function isMonthBefore(date, toCompare) {
	  if (!(0, _isValidDate2.default)(date) || !(0, _isValidDate2.default)(toCompare)) {
	    return false;
	  }
	
	  var d1 = new Date(date.getFullYear(), date.getMonth(), 1);
	  var d2 = new Date(toCompare.getFullYear(), toCompare.getMonth() - 1, 1);
	  return d1 > d2;
	}

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isSameDay;
	
	var _isSameMonth = __webpack_require__(939);
	
	var _isSameMonth2 = _interopRequireDefault(_isSameMonth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Checks if two dates are part of the same date. This will also
	 * make sure the dates are part of the same year and month.
	 *
	 * @param {Date} d1 - The first date to compare.
	 * @param {Date} d2 - The second date to compare.
	 * @param {boolean=false} bothNullValue - boolean for what should be returned if
	 *  both values are null.
	 * @return {boolean} true if both the dates are defined and part of the same year, month, and day
	 *  or if both values are null it will return the `bothNullValue`.
	 */
	function isSameDay(d1, d2) {
	  var bothNullValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (!d1 && !d2) {
	    return bothNullValue;
	  }
	
	  return (0, _isSameMonth2.default)(d1, d2, bothNullValue) && d1.getDate() === d2.getDate();
	}

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isSameMonth;
	
	var _isSameYear = __webpack_require__(940);
	
	var _isSameYear2 = _interopRequireDefault(_isSameYear);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Checks if two dates are part of the same month. This will also
	 * make sure the dates are part of the same year.
	 *
	 * @param {Date} d1 - The first date to compare.
	 * @param {Date} d2 - The second date to compare.
	 * @param {boolean=false} bothNullValue - boolean for what should be returned if
	 *  both values are null.
	 * @return {boolean} true if both the dates are defined and part of the same year and month
	 *  or if both values are null it will return the `bothNullValue`
	 */
	function isSameMonth(d1, d2) {
	  var bothNullValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (!d1 && !d2) {
	    return bothNullValue;
	  }
	
	  return (0, _isSameYear2.default)(d1, d2, bothNullValue) && d1.getMonth() === d2.getMonth();
	}

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isSameYear;
	
	var _isValidDate = __webpack_require__(58);
	
	var _isValidDate2 = _interopRequireDefault(_isValidDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Checks if two dates are part of the same year.
	 *
	 * @param {Date} d1 - The first date to compare.
	 * @param {Date} d2 - The second date to compare.
	 * @param {boolean=false} bothNullValue - boolean for what should be returned if
	 *  both values are null.
	 * @return {boolean} true if both the dates are defined and part of the same year or
	 *  if both values are null it will return the `bothNullValue`.
	 */
	function isSameYear(d1, d2) {
	  var bothNullValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (!d1 && !d2) {
	    return bothNullValue;
	  } else if (!(0, _isValidDate2.default)(d1) || !(0, _isValidDate2.default)(d2)) {
	    return false;
	  }
	
	  return d1.getFullYear() === d2.getFullYear();
	}

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = stripTime;
	
	var _isValidDate = __webpack_require__(58);
	
	var _isValidDate2 = _interopRequireDefault(_isValidDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Removes all the time parts (hours, minutes, seconds, milliseconds) from a date.
	 * The hour of the stripped time is set to 1 by default to help with cross-browser
	 * date implementations and how hour 0 sometimes is the previous day.
	 *
	 * @param {Date} date the date to strip
	 * @param {number=0} hours - the fake hours to set for the stripped time date.
	 * @return a new Date with the time stripped.
	 */
	function stripTime(date) {
	  var hours = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  if (!(0, _isValidDate2.default)(date)) {
	    return null;
	  }
	
	  var d = new Date(date);
	  d.setHours(hours, 0, 0, 0);
	
	  return d;
	}

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /** @module utils/findIgnoreCase */
	
	
	exports.default = findIgnoreCase;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This function finds the first item in a `haystack` that starts with every
	 * letter of the `value` in order. It will ignore:
	 *  - null or undefined
	 *  - valid React components
	 *
	 * @param {Array.<string|number|Object|function>} haystack - the haystack to search.
	 * @param {string} value - the current value to use.
	 * @param {string=} dataLabel - the object key to use to extract the comparing value.
	 *
	 * @return {string} the found element or the empty string.
	 */
	function findIgnoreCase(haystack, value, dataLabel) {
	  var needle = value ? value.toLowerCase() : '';
	
	  if (!needle) {
	    return needle;
	  }
	
	  var suggestion = '';
	  haystack.some(function (hay) {
	    if (hay === null || typeof hay === 'undefined' || _react2.default.isValidElement(hay)) {
	      return false;
	    }
	
	    var hayStr = (typeof hay === 'undefined' ? 'undefined' : _typeof(hay)) === 'object' ? hay[dataLabel] : hay.toString();
	
	    if (hayStr.toLowerCase().indexOf(needle) === 0) {
	      suggestion = hayStr;
	    }
	
	    return suggestion;
	  });
	
	  return suggestion;
	}

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /** @module utils/fuzzyFilter */
	
	
	exports.default = fuzzyFilter;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This function does a simple fuzzy search of some `needle` for every
	 * item in a `haystack`. It will only include items that are:
	 *  - not null or undefined
	 *  - valid React Components
	 *  - a number or string that contains each letter/number in order ignoring case
	 *  - an object's `dataLabel` value that contains each letter/number in order ignoring case.
	 *
	 * Example:
	 * ```js
	 * const haystack = ['Apple', 'Banana', 'Orange'];
	 * fuzzyFilter(haystack, 'An') // ['Banana', 'Orange'];
	 * fuzzyFilter(haystack, 'ae') // ['Apple']
	 * ```
	 *
	 * @param {Array.<string|number|Object|function>} haystack - the haystack to search
	 * @param {string} needle - the filter text to use.
	 * @param {string=} dataLabel - the data label to use if the element is an object.
	 *
	 * @return {Array.<string|number|Object|function>} a filtered list.
	 */
	function fuzzyFilter(haystack, needle, dataLabel) {
	  // Create an amazing regex that matches the letters in order
	  // and escapes any strings that could be part of a regex.
	  var reg = new RegExp(('' + needle).split('').join('\\w*').replace(/(\(|\||\)|\\(?!w\*)|\[|\|-|\.|\^|\+|\$|\?|^(?!w)\*)/g, '\\$1')
	  // Couldn't get the matching of two '*' working, so replace them here..
	  .replace(/\*\*/g, '*\\*'), 'i');
	
	  return haystack.filter(function (hay) {
	    if (hay === null || typeof hay === 'undefined') {
	      return false;
	    } else if (_react2.default.isValidElement(hay)) {
	      return true;
	    }
	
	    var value = void 0;
	    switch (typeof hay === 'undefined' ? 'undefined' : _typeof(hay)) {
	      case 'string':
	      case 'number':
	        value = hay.toString();
	        break;
	      default:
	        value = hay[dataLabel];
	    }
	
	    return value && value.match(reg);
	  });
	}

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = toggleScroll;
	
	var _getPagePosition = __webpack_require__(350);
	
	var _getPagePosition2 = _interopRequireDefault(_getPagePosition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A utility function for toggling the overflow visibility on an element. This will either target
	 * the given `selector`, or the `body` tag to set a `className`.
	 *
	 * If the `visible` param is `undefined`, the className will be toggled.
	 * If the `visible` param is `true`, the className will be added.
	 * If the `visible` param is `false`, the className will be removed.
	 *
	 *
	 * > This depends on the `classList` attribute on elements.
	 *
	 * @param {bool=} visible - An optional boolean to determine how the `className` will be applied.
	 * @param {string|Object=} selector - An optional query selector string to use to select an element.
	 * @param {string=} className - The className to apply. Defaults to 'md-overflow-hidden'
	 */
	function toggleScroll(scrollable, selector) {
	  var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'md-no-scroll';
	
	  var queryable = !selector || typeof selector === 'string';
	  var el = void 0;
	  if (queryable) {
	    el = selector ? document.querySelector(selector) : document.querySelector('html');
	  } else {
	    el = selector;
	  }
	
	  if (!el) {
	    return;
	  }
	
	  if (typeof scrollable === 'undefined') {
	    scrollable = !el.classList.contains(className);
	  }
	
	  if (scrollable && !el.classList.contains(className)) {
	    el.style.top = '-' + (queryable ? (0, _getPagePosition2.default)('y') : el.scrollTop) + 'px';
	    el.classList.add(className);
	  } else if (!scrollable && el.classList.contains(className)) {
	    var scrollTop = Math.abs(parseInt(el.style.top, 10));
	    el.classList.remove(className);
	    el.style.top = null;
	
	    if (!selector) {
	      window.scrollTo(0, scrollTop);
	    } else {
	      el.scrollTop = scrollTop;
	    }
	  }
	} /** @module utils/toggleScroll */

/***/ }),
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(97);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _warning = _interopRequireDefault(__webpack_require__(45));
	
	var checkIndexBounds = function checkIndexBounds(props) {
	  var index = props.index,
	      children = props.children;
	
	  var childrenCount = _react.default.Children.count(children);
	
	   false ? (0, _warning.default)(index >= 0 && index <= childrenCount, "react-swipeable-view: the new index: ".concat(index, " is out of bounds: [0-").concat(childrenCount, "].")) : void 0;
	};
	
	var _default = checkIndexBounds;
	exports.default = _default;

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(97);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = computeIndex;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _constant = _interopRequireDefault(__webpack_require__(365));
	
	function computeIndex(params) {
	  var children = params.children,
	      startIndex = params.startIndex,
	      startX = params.startX,
	      pageX = params.pageX,
	      viewLength = params.viewLength,
	      resistance = params.resistance;
	  var indexMax = _react.default.Children.count(children) - 1;
	  var index = startIndex + (startX - pageX) / viewLength;
	  var newStartX;
	
	  if (!resistance) {
	    // Reset the starting point
	    if (index < 0) {
	      index = 0;
	      newStartX = (index - startIndex) * viewLength + pageX;
	    } else if (index > indexMax) {
	      index = indexMax;
	      newStartX = (index - startIndex) * viewLength + pageX;
	    }
	  } else if (index < 0) {
	    index = Math.exp(index * _constant.default.RESISTANCE_COEF) - 1;
	  } else if (index > indexMax) {
	    index = indexMax + 1 - Math.exp((indexMax - index) * _constant.default.RESISTANCE_COEF);
	  }
	
	  return {
	    index: index,
	    startX: newStartX
	  };
	}

/***/ }),
/* 988 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var getDisplaySameSlide = function getDisplaySameSlide(props, nextProps) {
	  var displaySameSlide = false;
	
	  if (props.children.length && nextProps.children.length) {
	    var oldChildren = props.children[props.index];
	    var oldKey = oldChildren ? oldChildren.key : 'empty';
	
	    if (oldKey !== null) {
	      var newChildren = nextProps.children[nextProps.index];
	      var newKey = newChildren ? newChildren.key : 'empty';
	
	      if (oldKey === newKey) {
	        displaySameSlide = true;
	      }
	    }
	  }
	
	  return displaySameSlide;
	};
	
	var _default = getDisplaySameSlide;
	exports.default = _default;

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(97);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "checkIndexBounds", {
	  enumerable: true,
	  get: function get() {
	    return _checkIndexBounds.default;
	  }
	});
	Object.defineProperty(exports, "computeIndex", {
	  enumerable: true,
	  get: function get() {
	    return _computeIndex.default;
	  }
	});
	Object.defineProperty(exports, "constant", {
	  enumerable: true,
	  get: function get() {
	    return _constant.default;
	  }
	});
	Object.defineProperty(exports, "getDisplaySameSlide", {
	  enumerable: true,
	  get: function get() {
	    return _getDisplaySameSlide.default;
	  }
	});
	Object.defineProperty(exports, "mod", {
	  enumerable: true,
	  get: function get() {
	    return _mod.default;
	  }
	});
	
	var _checkIndexBounds = _interopRequireDefault(__webpack_require__(986));
	
	var _computeIndex = _interopRequireDefault(__webpack_require__(987));
	
	var _constant = _interopRequireDefault(__webpack_require__(365));
	
	var _getDisplaySameSlide = _interopRequireDefault(__webpack_require__(988));
	
	var _mod = _interopRequireDefault(__webpack_require__(990));

/***/ }),
/* 990 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	// Extended version of % with negative integer support.
	function mod(n, m) {
	  var q = n % m;
	  return q < 0 ? q + m : q;
	}
	
	var _default = mod;
	exports.default = _default;

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(97);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDomTreeShapes = getDomTreeShapes;
	exports.findNativeHandler = findNativeHandler;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(374));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(376));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(372));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(373));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(378));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(375));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _warning = _interopRequireDefault(__webpack_require__(45));
	
	var _properties = _interopRequireDefault(__webpack_require__(151));
	
	var _on = _interopRequireDefault(__webpack_require__(295));
	
	var _off = _interopRequireDefault(__webpack_require__(294));
	
	var _reactSwipeableViewsCore = __webpack_require__(989);
	
	function addEventListenerEnhanced(node, event, handler, options) {
	  (0, _on.default)(node, event, handler, options);
	  return {
	    remove: function remove() {
	      (0, _off.default)(node, event, handler, options);
	    }
	  };
	}
	
	var styleInjected = false; // Support old version of iOS and IE 10.
	// To be deleted in 2019.
	
	function injectStyle() {
	  // Inject once for all the instances
	  if (!styleInjected) {
	    var style = document.createElement('style');
	    style.innerHTML = "\n      .react-swipeable-view-container {\n        display: -webkit-box;\n        display: -ms-flexbox;\n      }\n      .react-swipeable-view-container > div {\n        -ms-flex-negative: 0;\n      }\n    ";
	
	    if (document.body) {
	      document.body.appendChild(style);
	    }
	
	    styleInjected = true;
	  }
	}
	
	var styles = {
	  container: {
	    direction: 'ltr',
	    display: 'flex',
	    willChange: 'transform'
	  },
	  slide: {
	    width: '100%',
	    WebkitFlexShrink: 0,
	    flexShrink: 0,
	    overflow: 'auto'
	  }
	};
	var axisProperties = {
	  root: {
	    x: {
	      overflowX: 'hidden'
	    },
	    'x-reverse': {
	      overflowX: 'hidden'
	    },
	    y: {
	      overflowY: 'hidden'
	    },
	    'y-reverse': {
	      overflowY: 'hidden'
	    }
	  },
	  flexDirection: {
	    x: 'row',
	    'x-reverse': 'row-reverse',
	    y: 'column',
	    'y-reverse': 'column-reverse'
	  },
	  transform: {
	    x: function x(translate) {
	      return "translate(".concat(-translate, "%, 0)");
	    },
	    'x-reverse': function xReverse(translate) {
	      return "translate(".concat(translate, "%, 0)");
	    },
	    y: function y(translate) {
	      return "translate(0, ".concat(-translate, "%)");
	    },
	    'y-reverse': function yReverse(translate) {
	      return "translate(0, ".concat(translate, "%)");
	    }
	  },
	  length: {
	    x: 'width',
	    'x-reverse': 'width',
	    y: 'height',
	    'y-reverse': 'height'
	  },
	  rotationMatrix: {
	    x: {
	      x: [1, 0],
	      y: [0, 1]
	    },
	    'x-reverse': {
	      x: [-1, 0],
	      y: [0, 1]
	    },
	    y: {
	      x: [0, 1],
	      y: [1, 0]
	    },
	    'y-reverse': {
	      x: [0, -1],
	      y: [1, 0]
	    }
	  },
	  scrollPosition: {
	    x: 'scrollLeft',
	    'x-reverse': 'scrollLeft',
	    y: 'scrollTop',
	    'y-reverse': 'scrollTop'
	  },
	  scrollLength: {
	    x: 'scrollWidth',
	    'x-reverse': 'scrollWidth',
	    y: 'scrollHeight',
	    'y-reverse': 'scrollHeight'
	  },
	  clientLength: {
	    x: 'clientWidth',
	    'x-reverse': 'clientWidth',
	    y: 'clientHeight',
	    'y-reverse': 'clientHeight'
	  }
	};
	
	function createTransition(property, options) {
	  var duration = options.duration,
	      easeFunction = options.easeFunction,
	      delay = options.delay;
	  return "".concat(property, " ").concat(duration, " ").concat(easeFunction, " ").concat(delay);
	} // We are using a 2x2 rotation matrix.
	
	
	function applyRotationMatrix(touch, axis) {
	  var rotationMatrix = axisProperties.rotationMatrix[axis];
	  return {
	    pageX: rotationMatrix.x[0] * touch.pageX + rotationMatrix.x[1] * touch.pageY,
	    pageY: rotationMatrix.y[0] * touch.pageX + rotationMatrix.y[1] * touch.pageY
	  };
	}
	
	function adaptMouse(event) {
	  event.touches = [{
	    pageX: event.pageX,
	    pageY: event.pageY
	  }];
	  return event;
	}
	
	function getDomTreeShapes(element, rootNode) {
	  var domTreeShapes = [];
	
	  while (element && element !== rootNode) {
	    // We reach a Swipeable View, no need to look higher in the dom tree.
	    if (element.hasAttribute('data-swipeable')) {
	      break;
	    }
	
	    var style = window.getComputedStyle(element);
	
	    if ( // Ignore the scroll children if the element is absolute positioned.
	    style.getPropertyValue('position') === 'absolute' || // Ignore the scroll children if the element has an overflowX hidden
	    style.getPropertyValue('overflow-x') === 'hidden') {
	      domTreeShapes = [];
	    } else if (element.clientWidth > 0 && element.scrollWidth > element.clientWidth || element.clientHeight > 0 && element.scrollHeight > element.clientHeight) {
	      // Ignore the nodes that have no width.
	      // Keep elements with a scroll
	      domTreeShapes.push({
	        element: element,
	        scrollWidth: element.scrollWidth,
	        scrollHeight: element.scrollHeight,
	        clientWidth: element.clientWidth,
	        clientHeight: element.clientHeight,
	        scrollLeft: element.scrollLeft,
	        scrollTop: element.scrollTop
	      });
	    }
	
	    element = element.parentNode;
	  }
	
	  return domTreeShapes;
	} // We can only have one node at the time claiming ownership for handling the swipe.
	// Otherwise, the UX would be confusing.
	// That's why we use a singleton here.
	
	
	var nodeWhoClaimedTheScroll = null;
	
	function findNativeHandler(params) {
	  var domTreeShapes = params.domTreeShapes,
	      pageX = params.pageX,
	      startX = params.startX,
	      axis = params.axis;
	  return domTreeShapes.some(function (shape) {
	    // Determine if we are going backward or forward.
	    var goingForward = pageX >= startX;
	
	    if (axis === 'x' || axis === 'y') {
	      goingForward = !goingForward;
	    }
	
	    var scrollPosition = shape[axisProperties.scrollPosition[axis]];
	    var areNotAtStart = scrollPosition > 0;
	    var areNotAtEnd = scrollPosition + shape[axisProperties.clientLength[axis]] < shape[axisProperties.scrollLength[axis]];
	
	    if (goingForward && areNotAtEnd || !goingForward && areNotAtStart) {
	      nodeWhoClaimedTheScroll = shape.element;
	      return true;
	    }
	
	    return false;
	  });
	}
	
	var SwipeableViews =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(SwipeableViews, _React$Component);
	
	  function SwipeableViews(props, context) {
	    var _this;
	
	    (0, _classCallCheck2.default)(this, SwipeableViews);
	    _this = (0, _possibleConstructorReturn2.default)(this, (SwipeableViews.__proto__ || Object.getPrototypeOf(SwipeableViews)).call(this, props, context));
	
	    _this.setRootNode = function (node) {
	      _this.rootNode = node;
	    };
	
	    _this.setContainerNode = function (node) {
	      _this.containerNode = node;
	    };
	
	    _this.setActiveSlide = function (node) {
	      _this.activeSlide = node;
	
	      _this.updateHeight();
	    };
	
	    _this.rootNode = null;
	    _this.containerNode = null;
	    _this.ignoreNextScrollEvents = false;
	    _this.viewLength = 0;
	    _this.startX = 0;
	    _this.lastX = 0;
	    _this.vx = 0;
	    _this.startY = 0;
	    _this.isSwiping = undefined;
	    _this.started = false;
	    _this.startIndex = 0;
	    _this.transitionListener = null;
	    _this.touchMoveListener = null;
	    _this.activeSlide = null;
	    _this.indexCurrent = null;
	
	    _this.handleSwipeStart = function (event) {
	      var axis = _this.props.axis;
	      var touch = applyRotationMatrix(event.touches[0], axis);
	      _this.viewLength = _this.rootNode.getBoundingClientRect()[axisProperties.length[axis]];
	      _this.startX = touch.pageX;
	      _this.lastX = touch.pageX;
	      _this.vx = 0;
	      _this.startY = touch.pageY;
	      _this.isSwiping = undefined;
	      _this.started = true;
	      var computedStyle = window.getComputedStyle(_this.containerNode);
	      var transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
	
	      if (transform && transform !== 'none') {
	        var transformValues = transform.split('(')[1].split(')')[0].split(',');
	        var rootStyle = window.getComputedStyle(_this.rootNode);
	        var tranformNormalized = applyRotationMatrix({
	          pageX: parseInt(transformValues[4], 10),
	          pageY: parseInt(transformValues[5], 10)
	        }, axis);
	        _this.startIndex = -tranformNormalized.pageX / (_this.viewLength - parseInt(rootStyle.paddingLeft, 10) - parseInt(rootStyle.paddingRight, 10)) || 0;
	      }
	    };
	
	    _this.handleSwipeMove = function (event) {
	      // The touch start event can be cancel.
	      // Makes sure we set a starting point.
	      if (!_this.started) {
	        _this.handleTouchStart(event);
	
	        return;
	      } // We are not supposed to hanlde this touch move.
	
	
	      if (nodeWhoClaimedTheScroll !== null && nodeWhoClaimedTheScroll !== _this.rootNode) {
	        return;
	      }
	
	      var _this$props = _this.props,
	          axis = _this$props.axis,
	          children = _this$props.children,
	          ignoreNativeScroll = _this$props.ignoreNativeScroll,
	          onSwitching = _this$props.onSwitching,
	          resistance = _this$props.resistance;
	      var touch = applyRotationMatrix(event.touches[0], axis); // We don't know yet.
	
	      if (_this.isSwiping === undefined) {
	        var dx = Math.abs(touch.pageX - _this.startX);
	        var dy = Math.abs(touch.pageY - _this.startY);
	        var isSwiping = dx > dy && dx > _reactSwipeableViewsCore.constant.UNCERTAINTY_THRESHOLD; // We let the parent handle the scroll.
	
	        if (!resistance && (axis === 'y' || axis === 'y-reverse') && (_this.indexCurrent === 0 && _this.startX < touch.pageX || _this.indexCurrent === _react.default.Children.count(_this.props.children) - 1 && _this.startX > touch.pageX)) {
	          _this.isSwiping = false;
	          return;
	        } // We are likely to be swiping, let's prevent the scroll event.
	
	
	        if (dx > dy) {
	          event.preventDefault();
	        }
	
	        if (isSwiping === true || dy > _reactSwipeableViewsCore.constant.UNCERTAINTY_THRESHOLD) {
	          _this.isSwiping = isSwiping;
	          _this.startX = touch.pageX; // Shift the starting point.
	
	          return; // Let's wait the next touch event to move something.
	        }
	      }
	
	      if (_this.isSwiping !== true) {
	        return;
	      } // We are swiping, let's prevent the scroll event.
	
	
	      event.preventDefault(); // Low Pass filter.
	
	      _this.vx = _this.vx * 0.5 + (touch.pageX - _this.lastX) * 0.5;
	      _this.lastX = touch.pageX;
	
	      var _computeIndex = (0, _reactSwipeableViewsCore.computeIndex)({
	        children: children,
	        resistance: resistance,
	        pageX: touch.pageX,
	        startIndex: _this.startIndex,
	        startX: _this.startX,
	        viewLength: _this.viewLength
	      }),
	          index = _computeIndex.index,
	          startX = _computeIndex.startX; // Add support for native scroll elements.
	
	
	      if (nodeWhoClaimedTheScroll === null && !ignoreNativeScroll) {
	        var domTreeShapes = getDomTreeShapes(event.target, _this.rootNode);
	        var hasFoundNativeHandler = findNativeHandler({
	          domTreeShapes: domTreeShapes,
	          startX: _this.startX,
	          pageX: touch.pageX,
	          axis: axis
	        }); // We abort the touch move handler.
	
	        if (hasFoundNativeHandler) {
	          return;
	        }
	      } // We are moving toward the edges.
	
	
	      if (startX) {
	        _this.startX = startX;
	      } else if (nodeWhoClaimedTheScroll === null) {
	        nodeWhoClaimedTheScroll = _this.rootNode;
	      }
	
	      _this.setIndexCurrent(index);
	
	      var callback = function callback() {
	        if (onSwitching) {
	          onSwitching(index, 'move');
	        }
	      };
	
	      if (_this.state.displaySameSlide || !_this.state.isDragging) {
	        _this.setState({
	          displaySameSlide: false,
	          isDragging: true
	        }, callback);
	      }
	
	      callback();
	    };
	
	    _this.handleSwipeEnd = function () {
	      nodeWhoClaimedTheScroll = null; // The touch start event can be cancel.
	      // Makes sure that a starting point is set.
	
	      if (!_this.started) {
	        return;
	      }
	
	      _this.started = false;
	
	      if (_this.isSwiping !== true) {
	        return;
	      }
	
	      var indexLatest = _this.state.indexLatest;
	      var indexCurrent = _this.indexCurrent;
	      var delta = indexLatest - indexCurrent;
	      var indexNew; // Quick movement
	
	      if (Math.abs(_this.vx) > _this.props.threshold) {
	        if (_this.vx > 0) {
	          indexNew = Math.floor(indexCurrent);
	        } else {
	          indexNew = Math.ceil(indexCurrent);
	        }
	      } else if (Math.abs(delta) > _this.props.hysteresis) {
	        // Some hysteresis with indexLatest.
	        indexNew = delta > 0 ? Math.floor(indexCurrent) : Math.ceil(indexCurrent);
	      } else {
	        indexNew = indexLatest;
	      }
	
	      var indexMax = _react.default.Children.count(_this.props.children) - 1;
	
	      if (indexNew < 0) {
	        indexNew = 0;
	      } else if (indexNew > indexMax) {
	        indexNew = indexMax;
	      }
	
	      _this.setIndexCurrent(indexNew);
	
	      _this.setState({
	        indexLatest: indexNew,
	        isDragging: false
	      }, function () {
	        if (_this.props.onSwitching) {
	          _this.props.onSwitching(indexNew, 'end');
	        }
	
	        if (_this.props.onChangeIndex && indexNew !== indexLatest) {
	          _this.props.onChangeIndex(indexNew, indexLatest, {
	            reason: 'swipe'
	          });
	        } // Manually calling handleTransitionEnd in that case as isn't otherwise.
	
	
	        if (indexCurrent === indexLatest) {
	          _this.handleTransitionEnd();
	        }
	      });
	    };
	
	    _this.handleTouchStart = function (event) {
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(event);
	      }
	
	      _this.handleSwipeStart(event);
	    };
	
	    _this.handleTouchEnd = function (event) {
	      if (_this.props.onTouchEnd) {
	        _this.props.onTouchEnd(event);
	      }
	
	      _this.handleSwipeEnd(event);
	    };
	
	    _this.handleMouseDown = function (event) {
	      if (_this.props.onMouseDown) {
	        _this.props.onMouseDown(event);
	      }
	
	      event.persist();
	
	      _this.handleSwipeStart(adaptMouse(event));
	    };
	
	    _this.handleMouseUp = function (event) {
	      if (_this.props.onMouseUp) {
	        _this.props.onMouseUp(event);
	      }
	
	      _this.handleSwipeEnd(adaptMouse(event));
	    };
	
	    _this.handleMouseLeave = function (event) {
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      } // Filter out events
	
	
	      if (_this.started) {
	        _this.handleSwipeEnd(adaptMouse(event));
	      }
	    };
	
	    _this.handleMouseMove = function (event) {
	      if (_this.props.onMouseMove) {
	        _this.props.onMouseMove(event);
	      } // Filter out events
	
	
	      if (_this.started) {
	        _this.handleSwipeMove(adaptMouse(event));
	      }
	    };
	
	    _this.handleScroll = function (event) {
	      if (_this.props.onScroll) {
	        _this.props.onScroll(event);
	      } // Ignore events bubbling up.
	
	
	      if (event.target !== _this.rootNode) {
	        return;
	      }
	
	      if (_this.ignoreNextScrollEvents) {
	        _this.ignoreNextScrollEvents = false;
	        return;
	      }
	
	      var indexLatest = _this.state.indexLatest;
	      var indexNew = Math.ceil(event.target.scrollLeft / event.target.clientWidth) + indexLatest;
	      _this.ignoreNextScrollEvents = true; // Reset the scroll position.
	
	      event.target.scrollLeft = 0;
	
	      if (_this.props.onChangeIndex && indexNew !== indexLatest) {
	        _this.props.onChangeIndex(indexNew, indexLatest, {
	          reason: 'focus'
	        });
	      }
	    };
	
	    _this.updateHeight = function () {
	      if (_this.activeSlide !== null) {
	        var child = _this.activeSlide.children[0];
	
	        if (child !== undefined && child.offsetHeight !== undefined && _this.state.heightLatest !== child.offsetHeight) {
	          _this.setState({
	            heightLatest: child.offsetHeight
	          });
	        }
	      }
	    };
	
	    if (false) {
	      (0, _reactSwipeableViewsCore.checkIndexBounds)(_this.props);
	    }
	
	    _this.state = {
	      indexLatest: _this.props.index,
	      // Set to true as soon as the component is swiping.
	      // It's the state counter part of this.isSwiping.
	      isDragging: false,
	      // Help with SSR logic and lazy loading logic.
	      isFirstRender: true,
	      heightLatest: 0,
	      // Let the render method that we are going to display the same slide than previously.
	      displaySameSlide: true
	    };
	
	    _this.setIndexCurrent(_this.props.index);
	
	    return _this;
	  }
	
	  (0, _createClass2.default)(SwipeableViews, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      var _this2 = this;
	
	      return {
	        swipeableViews: {
	          slideUpdateHeight: function slideUpdateHeight() {
	            _this2.updateHeight();
	          }
	        }
	      };
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      // Subscribe to transition end events.
	      this.transitionListener = addEventListenerEnhanced(this.containerNode, _properties.default.end, function (event) {
	        if (event.target !== _this3.containerNode) {
	          return;
	        }
	
	        _this3.handleTransitionEnd();
	      }); // Block the thread to handle that event.
	
	      this.touchMoveListener = addEventListenerEnhanced(this.rootNode, 'touchmove', function (event) {
	        // Handling touch events is disabled.
	        if (_this3.props.disabled) {
	          return;
	        }
	
	        _this3.handleSwipeMove(event);
	      }, {
	        passive: false
	      }); // eslint-disable-next-line react/no-did-mount-set-state
	
	      this.setState({
	        isFirstRender: false
	      });
	      injectStyle(); // Send all functions in an object if action param is set.
	
	      if (this.props.action) {
	        this.props.action({
	          updateHeight: this.updateHeight
	        });
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var index = nextProps.index;
	
	      if (typeof index === 'number' && index !== this.props.index) {
	        if (false) {
	          (0, _reactSwipeableViewsCore.checkIndexBounds)(nextProps);
	        }
	
	        this.setIndexCurrent(index);
	        this.setState({
	          // If true, we are going to change the children. We shoudn't animate it.
	          displaySameSlide: (0, _reactSwipeableViewsCore.getDisplaySameSlide)(this.props, nextProps),
	          indexLatest: index
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.transitionListener.remove();
	      this.touchMoveListener.remove();
	    }
	  }, {
	    key: "setIndexCurrent",
	    value: function setIndexCurrent(indexCurrent) {
	      if (!this.props.animateTransitions && this.indexCurrent !== indexCurrent) {
	        this.handleTransitionEnd();
	      }
	
	      this.indexCurrent = indexCurrent;
	
	      if (this.containerNode) {
	        var axis = this.props.axis;
	        var transform = axisProperties.transform[axis](indexCurrent * 100);
	        this.containerNode.style.WebkitTransform = transform;
	        this.containerNode.style.transform = transform;
	      }
	    }
	  }, {
	    key: "handleTransitionEnd",
	    value: function handleTransitionEnd() {
	      if (!this.props.onTransitionEnd) {
	        return;
	      } // Filters out when changing the children
	
	
	      if (this.state.displaySameSlide) {
	        return;
	      } // The rest callback is triggered when swiping. It's just noise.
	      // We filter it out.
	
	
	      if (!this.state.isDragging) {
	        this.props.onTransitionEnd();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          action = _props.action,
	          animateHeight = _props.animateHeight,
	          animateTransitions = _props.animateTransitions,
	          axis = _props.axis,
	          children = _props.children,
	          containerStyleProp = _props.containerStyle,
	          disabled = _props.disabled,
	          disableLazyLoading = _props.disableLazyLoading,
	          enableMouseEvents = _props.enableMouseEvents,
	          hysteresis = _props.hysteresis,
	          ignoreNativeScroll = _props.ignoreNativeScroll,
	          index = _props.index,
	          onChangeIndex = _props.onChangeIndex,
	          onSwitching = _props.onSwitching,
	          onTransitionEnd = _props.onTransitionEnd,
	          resistance = _props.resistance,
	          slideStyleProp = _props.slideStyle,
	          slideClassName = _props.slideClassName,
	          springConfig = _props.springConfig,
	          style = _props.style,
	          threshold = _props.threshold,
	          other = (0, _objectWithoutProperties2.default)(_props, ["action", "animateHeight", "animateTransitions", "axis", "children", "containerStyle", "disabled", "disableLazyLoading", "enableMouseEvents", "hysteresis", "ignoreNativeScroll", "index", "onChangeIndex", "onSwitching", "onTransitionEnd", "resistance", "slideStyle", "slideClassName", "springConfig", "style", "threshold"]);
	      var _state = this.state,
	          displaySameSlide = _state.displaySameSlide,
	          heightLatest = _state.heightLatest,
	          isDragging = _state.isDragging,
	          isFirstRender = _state.isFirstRender,
	          indexLatest = _state.indexLatest;
	      var touchEvents = !disabled ? {
	        onTouchStart: this.handleTouchStart,
	        onTouchEnd: this.handleTouchEnd
	      } : {};
	      var mouseEvents = !disabled && enableMouseEvents ? {
	        onMouseDown: this.handleMouseDown,
	        onMouseUp: this.handleMouseUp,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseMove: this.handleMouseMove
	      } : {}; // There is no point to animate if we are already providing a height.
	
	       false ? (0, _warning.default)(!animateHeight || !containerStyleProp || !containerStyleProp.height, "react-swipeable-view: You are setting animateHeight to true but you are\nalso providing a custom height.\nThe custom height has a higher priority than the animateHeight property.\nSo animateHeight is most likely having no effect at all.") : void 0;
	      var slideStyle = (0, _extends2.default)({}, styles.slide, slideStyleProp);
	      var transition;
	      var WebkitTransition;
	
	      if (isDragging || !animateTransitions || displaySameSlide) {
	        transition = 'all 0s ease 0s';
	        WebkitTransition = 'all 0s ease 0s';
	      } else {
	        transition = createTransition('transform', springConfig);
	        WebkitTransition = createTransition('-webkit-transform', springConfig);
	
	        if (heightLatest !== 0) {
	          var additionalTranstion = ", ".concat(createTransition('height', springConfig));
	          transition += additionalTranstion;
	          WebkitTransition += additionalTranstion;
	        }
	      }
	
	      var containerStyle = {
	        height: null,
	        WebkitFlexDirection: axisProperties.flexDirection[axis],
	        flexDirection: axisProperties.flexDirection[axis],
	        WebkitTransition: WebkitTransition,
	        transition: transition
	      }; // Apply the styles for SSR considerations
	
	      if (disableLazyLoading || !isFirstRender) {
	        var transform = axisProperties.transform[axis](this.indexCurrent * 100);
	        containerStyle.WebkitTransform = transform;
	        containerStyle.transform = transform;
	      }
	
	      if (animateHeight) {
	        containerStyle.height = heightLatest;
	      }
	
	      return _react.default.createElement("div", (0, _extends2.default)({
	        ref: this.setRootNode,
	        style: (0, _extends2.default)({}, axisProperties.root[axis], style)
	      }, other, touchEvents, mouseEvents, {
	        onScroll: this.handleScroll
	      }), _react.default.createElement("div", {
	        ref: this.setContainerNode,
	        style: (0, _extends2.default)({}, containerStyle, styles.container, containerStyleProp),
	        className: "react-swipeable-view-container"
	      }, _react.default.Children.map(children, function (child, indexChild) {
	        if (!disableLazyLoading && isFirstRender && indexChild !== indexLatest) {
	          return null;
	        }
	
	         false ? (0, _warning.default)(_react.default.isValidElement(child), "react-swipeable-view: one of the children provided is invalid: ".concat(child, ".\nWe are expecting a valid React Element")) : void 0;
	        var ref;
	        var hidden = true;
	
	        if (indexChild === indexLatest) {
	          hidden = false;
	
	          if (animateHeight) {
	            ref = _this4.setActiveSlide;
	            slideStyle.overflowY = 'hidden';
	          }
	        }
	
	        return _react.default.createElement("div", {
	          ref: ref,
	          style: slideStyle,
	          className: slideClassName,
	          "aria-hidden": hidden,
	          "data-swipeable": "true"
	        }, child);
	      })));
	    }
	  }]);
	  return SwipeableViews;
	}(_react.default.Component); // Added as an ads for people using the React dev tools in production.
	// So they know, the tool used to build the awesome UI they
	// are looking at/retro engineering.
	
	
	SwipeableViews.displayName = 'ReactSwipableView';
	SwipeableViews.propTypes =  false ? {
	  /**
	   * This is callback property. It's called by the component on mount.
	   * This is useful when you want to trigger an action programmatically.
	   * It currently only supports updateHeight() action.
	   *
	   * @param {object} actions This object contains all posible actions
	   * that can be triggered programmatically.
	   */
	  action: _propTypes.default.func,
	
	  /**
	   * If `true`, the height of the container will be animated to match the current slide height.
	   * Animating another style property has a negative impact regarding performance.
	   */
	  animateHeight: _propTypes.default.bool,
	
	  /**
	   * If `false`, changes to the index prop will not cause an animated transition.
	   */
	  animateTransitions: _propTypes.default.bool,
	
	  /**
	   * The axis on which the slides will slide.
	   */
	  axis: _propTypes.default.oneOf(['x', 'x-reverse', 'y', 'y-reverse']),
	
	  /**
	   * Use this property to provide your slides.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * This is the inlined style that will be applied
	   * to each slide container.
	   */
	  containerStyle: _propTypes.default.object,
	
	  /**
	   * If `true`, it will disable touch events.
	   * This is useful when you want to prohibit the user from changing slides.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * This is the config used to disable lazyloding,
	   * if `true` will render all the views in first rendering.
	   */
	  disableLazyLoading: _propTypes.default.bool,
	
	  /**
	   * If `true`, it will enable mouse events.
	   * This will allow the user to perform the relevant swipe actions with a mouse.
	   */
	  enableMouseEvents: _propTypes.default.bool,
	
	  /**
	   * Configure hysteresis between slides. This value determines how far
	   * should user swipe to switch slide.
	   */
	  hysteresis: _propTypes.default.number,
	
	  /**
	   * If `true`, it will ignore native scroll container.
	   * It can be used to filter out false positive that blocks the swipe.
	   */
	  ignoreNativeScroll: _propTypes.default.bool,
	
	  /**
	   * This is the index of the slide to show.
	   * This is useful when you want to change the default slide shown.
	   * Or when you have tabs linked to each slide.
	   */
	  index: _propTypes.default.number,
	
	  /**
	   * This is callback prop. It's call by the
	   * component when the shown slide change after a swipe made by the user.
	   * This is useful when you have tabs linked to each slide.
	   *
	   * @param {integer} index This is the current index of the slide.
	   * @param {integer} indexLatest This is the oldest index of the slide.
	   * @param {object} meta Meta data containing more information about the event.
	   */
	  onChangeIndex: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseLeave: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseMove: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseUp: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onScroll: _propTypes.default.func,
	
	  /**
	   * This is callback prop. It's called by the
	   * component when the slide switching.
	   * This is useful when you want to implement something corresponding
	   * to the current slide position.
	   *
	   * @param {integer} index This is the current index of the slide.
	   * @param {string} type Can be either `move` or `end`.
	   */
	  onSwitching: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onTouchEnd: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onTouchMove: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onTouchStart: _propTypes.default.func,
	
	  /**
	   * The callback that fires when the animation comes to a rest.
	   * This is useful to defer CPU intensive task.
	   */
	  onTransitionEnd: _propTypes.default.func,
	
	  /**
	   * If `true`, it will add bounds effect on the edges.
	   */
	  resistance: _propTypes.default.bool,
	
	  /**
	   * This is the className that will be applied
	   * on the slide component.
	   */
	  slideClassName: _propTypes.default.string,
	
	  /**
	   * This is the inlined style that will be applied
	   * on the slide component.
	   */
	  slideStyle: _propTypes.default.object,
	
	  /**
	   * This is the config used to create CSS transitions.
	   * This is useful to change the dynamic of the transition.
	   */
	  springConfig: _propTypes.default.shape({
	    duration: _propTypes.default.string,
	    easeFunction: _propTypes.default.string,
	    delay: _propTypes.default.string
	  }),
	
	  /**
	   * This is the inlined style that will be applied
	   * on the root component.
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * This is the threshold used for detecting a quick swipe.
	   * If the computed speed is above this value, the index change.
	   */
	  threshold: _propTypes.default.number
	} : {};
	SwipeableViews.defaultProps = {
	  animateHeight: false,
	  animateTransitions: true,
	  axis: 'x',
	  disabled: false,
	  disableLazyLoading: false,
	  enableMouseEvents: false,
	  hysteresis: 0.6,
	  ignoreNativeScroll: false,
	  index: 0,
	  threshold: 5,
	  springConfig: {
	    duration: '0.35s',
	    easeFunction: 'cubic-bezier(0.15, 0.3, 0.25, 1)',
	    delay: '0s'
	  },
	  resistance: false
	};
	SwipeableViews.childContextTypes = {
	  swipeableViews: _propTypes.default.shape({
	    slideUpdateHeight: _propTypes.default.func
	  })
	};
	var _default = SwipeableViews;
	exports.default = _default;

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(97);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _SwipeableViews = _interopRequireDefault(__webpack_require__(991));
	
	var _default = _SwipeableViews.default;
	exports.default = _default;

/***/ })
]);


// WEBPACK FOOTER //
// component---src-pages-index-jsx-4e6be2fa0d823c3dd7c5.js